
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hcYib", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $c872536f56b9ad13$export$ffb0004e005737fa; }, function (v) { return $c872536f56b9ad13$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $c872536f56b9ad13$export$34b9dba7ce09269b; }, function (v) { return $c872536f56b9ad13$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $c872536f56b9ad13$export$25062201e9e25d76; }, function (v) { return $c872536f56b9ad13$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c872536f56b9ad13$export$ffb0004e005737fa;
var $c872536f56b9ad13$export$34b9dba7ce09269b;
var $c872536f56b9ad13$export$25062201e9e25d76;
'use strict';

var $6uYXW = parcelRequire("6uYXW");
var $c872536f56b9ad13$var$k = Symbol.for("react.element"), $c872536f56b9ad13$var$l = Symbol.for("react.fragment"), $c872536f56b9ad13$var$m = Object.prototype.hasOwnProperty, $c872536f56b9ad13$var$n = $6uYXW.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $c872536f56b9ad13$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c872536f56b9ad13$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$c872536f56b9ad13$var$m.call(a, b) && !$c872536f56b9ad13$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $c872536f56b9ad13$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $c872536f56b9ad13$var$n.current
    };
}
$c872536f56b9ad13$export$ffb0004e005737fa = $c872536f56b9ad13$var$l;
$c872536f56b9ad13$export$34b9dba7ce09269b = $c872536f56b9ad13$var$q;
$c872536f56b9ad13$export$25062201e9e25d76 = $c872536f56b9ad13$var$q;

});
parcelRegister("6uYXW", function(module, exports) {
'use strict';

module.exports = (parcelRequire("g55RD"));

});
parcelRegister("g55RD", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $bb51a97a867b2b6c$export$dca3b0875bd9a954; }, function (v) { return $bb51a97a867b2b6c$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $bb51a97a867b2b6c$export$16fa2f45be04daa8; }, function (v) { return $bb51a97a867b2b6c$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bb51a97a867b2b6c$export$ffb0004e005737fa; }, function (v) { return $bb51a97a867b2b6c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $bb51a97a867b2b6c$export$e2c29f18771995cb; }, function (v) { return $bb51a97a867b2b6c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $bb51a97a867b2b6c$export$221d75b3f55bb0bd; }, function (v) { return $bb51a97a867b2b6c$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bb51a97a867b2b6c$export$5f8d39834fd61797; }, function (v) { return $bb51a97a867b2b6c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bb51a97a867b2b6c$export$74bf444e3cd11ea5; }, function (v) { return $bb51a97a867b2b6c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $bb51a97a867b2b6c$export$ae55be85d98224ed; }, function (v) { return $bb51a97a867b2b6c$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $bb51a97a867b2b6c$export$e530037191fcd5d7; }, function (v) { return $bb51a97a867b2b6c$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $bb51a97a867b2b6c$export$fd42f52fd3ae1109; }, function (v) { return $bb51a97a867b2b6c$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $bb51a97a867b2b6c$export$c8a8987d4410bf2d; }, function (v) { return $bb51a97a867b2b6c$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $bb51a97a867b2b6c$export$d38cd72104c1f0e9; }, function (v) { return $bb51a97a867b2b6c$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $bb51a97a867b2b6c$export$7d1e3a5e95ceca43; }, function (v) { return $bb51a97a867b2b6c$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $bb51a97a867b2b6c$export$257a8862b851cb5b; }, function (v) { return $bb51a97a867b2b6c$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $bb51a97a867b2b6c$export$a8257692ac88316c; }, function (v) { return $bb51a97a867b2b6c$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $bb51a97a867b2b6c$export$488013bae63b21da; }, function (v) { return $bb51a97a867b2b6c$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $bb51a97a867b2b6c$export$7c73462e0d25e514; }, function (v) { return $bb51a97a867b2b6c$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $bb51a97a867b2b6c$export$7568632d0d33d16d; }, function (v) { return $bb51a97a867b2b6c$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $bb51a97a867b2b6c$export$88948ce120ea2619; }, function (v) { return $bb51a97a867b2b6c$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $bb51a97a867b2b6c$export$35808ee640e87ca7; }, function (v) { return $bb51a97a867b2b6c$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $bb51a97a867b2b6c$export$fae74005e78b1a27; }, function (v) { return $bb51a97a867b2b6c$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $bb51a97a867b2b6c$export$dc8fbce3eb94dc1e; }, function (v) { return $bb51a97a867b2b6c$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $bb51a97a867b2b6c$export$6a7bc4e911dc01cf; }, function (v) { return $bb51a97a867b2b6c$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $bb51a97a867b2b6c$export$6d9c69b0de29b591; }, function (v) { return $bb51a97a867b2b6c$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $bb51a97a867b2b6c$export$f680877a34711e37; }, function (v) { return $bb51a97a867b2b6c$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $bb51a97a867b2b6c$export$d5a552a76deda3c2; }, function (v) { return $bb51a97a867b2b6c$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $bb51a97a867b2b6c$export$aaabe4eda9ed9969; }, function (v) { return $bb51a97a867b2b6c$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $bb51a97a867b2b6c$export$e5c5a5f917a5871c; }, function (v) { return $bb51a97a867b2b6c$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $bb51a97a867b2b6c$export$1538c33de8887b59; }, function (v) { return $bb51a97a867b2b6c$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $bb51a97a867b2b6c$export$13e3392192263954; }, function (v) { return $bb51a97a867b2b6c$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $bb51a97a867b2b6c$export$b8f5890fc79d6aca; }, function (v) { return $bb51a97a867b2b6c$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $bb51a97a867b2b6c$export$60241385465d0a34; }, function (v) { return $bb51a97a867b2b6c$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $bb51a97a867b2b6c$export$306c0aa65ff9ec16; }, function (v) { return $bb51a97a867b2b6c$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $bb51a97a867b2b6c$export$7b286972b8d8ccbf; }, function (v) { return $bb51a97a867b2b6c$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $bb51a97a867b2b6c$export$83d89fbfd8236492; }, function (v) { return $bb51a97a867b2b6c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bb51a97a867b2b6c$export$dca3b0875bd9a954;
var $bb51a97a867b2b6c$export$16fa2f45be04daa8;
var $bb51a97a867b2b6c$export$ffb0004e005737fa;
var $bb51a97a867b2b6c$export$e2c29f18771995cb;
var $bb51a97a867b2b6c$export$221d75b3f55bb0bd;
var $bb51a97a867b2b6c$export$5f8d39834fd61797;
var $bb51a97a867b2b6c$export$74bf444e3cd11ea5;
var $bb51a97a867b2b6c$export$ae55be85d98224ed;
var $bb51a97a867b2b6c$export$e530037191fcd5d7;
var $bb51a97a867b2b6c$export$fd42f52fd3ae1109;
var $bb51a97a867b2b6c$export$c8a8987d4410bf2d;
var $bb51a97a867b2b6c$export$d38cd72104c1f0e9;
var $bb51a97a867b2b6c$export$7d1e3a5e95ceca43;
var $bb51a97a867b2b6c$export$257a8862b851cb5b;
var $bb51a97a867b2b6c$export$a8257692ac88316c;
var $bb51a97a867b2b6c$export$488013bae63b21da;
var $bb51a97a867b2b6c$export$7c73462e0d25e514;
var $bb51a97a867b2b6c$export$7568632d0d33d16d;
var $bb51a97a867b2b6c$export$88948ce120ea2619;
var $bb51a97a867b2b6c$export$35808ee640e87ca7;
var $bb51a97a867b2b6c$export$fae74005e78b1a27;
var $bb51a97a867b2b6c$export$dc8fbce3eb94dc1e;
var $bb51a97a867b2b6c$export$6a7bc4e911dc01cf;
var $bb51a97a867b2b6c$export$6d9c69b0de29b591;
var $bb51a97a867b2b6c$export$f680877a34711e37;
var $bb51a97a867b2b6c$export$d5a552a76deda3c2;
var $bb51a97a867b2b6c$export$aaabe4eda9ed9969;
var $bb51a97a867b2b6c$export$e5c5a5f917a5871c;
var $bb51a97a867b2b6c$export$1538c33de8887b59;
var $bb51a97a867b2b6c$export$13e3392192263954;
var $bb51a97a867b2b6c$export$b8f5890fc79d6aca;
var $bb51a97a867b2b6c$export$60241385465d0a34;
var $bb51a97a867b2b6c$export$306c0aa65ff9ec16;
var $bb51a97a867b2b6c$export$7b286972b8d8ccbf;
var $bb51a97a867b2b6c$export$83d89fbfd8236492;
'use strict';
var $bb51a97a867b2b6c$var$l = Symbol.for("react.element"), $bb51a97a867b2b6c$var$n = Symbol.for("react.portal"), $bb51a97a867b2b6c$var$p = Symbol.for("react.fragment"), $bb51a97a867b2b6c$var$q = Symbol.for("react.strict_mode"), $bb51a97a867b2b6c$var$r = Symbol.for("react.profiler"), $bb51a97a867b2b6c$var$t = Symbol.for("react.provider"), $bb51a97a867b2b6c$var$u = Symbol.for("react.context"), $bb51a97a867b2b6c$var$v = Symbol.for("react.forward_ref"), $bb51a97a867b2b6c$var$w = Symbol.for("react.suspense"), $bb51a97a867b2b6c$var$x = Symbol.for("react.memo"), $bb51a97a867b2b6c$var$y = Symbol.for("react.lazy"), $bb51a97a867b2b6c$var$z = Symbol.iterator;
function $bb51a97a867b2b6c$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $bb51a97a867b2b6c$var$z && a[$bb51a97a867b2b6c$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $bb51a97a867b2b6c$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $bb51a97a867b2b6c$var$C = Object.assign, $bb51a97a867b2b6c$var$D = {};
function $bb51a97a867b2b6c$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $bb51a97a867b2b6c$var$D;
    this.updater = e || $bb51a97a867b2b6c$var$B;
}
$bb51a97a867b2b6c$var$E.prototype.isReactComponent = {};
$bb51a97a867b2b6c$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$bb51a97a867b2b6c$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $bb51a97a867b2b6c$var$F() {}
$bb51a97a867b2b6c$var$F.prototype = $bb51a97a867b2b6c$var$E.prototype;
function $bb51a97a867b2b6c$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $bb51a97a867b2b6c$var$D;
    this.updater = e || $bb51a97a867b2b6c$var$B;
}
var $bb51a97a867b2b6c$var$H = $bb51a97a867b2b6c$var$G.prototype = new $bb51a97a867b2b6c$var$F;
$bb51a97a867b2b6c$var$H.constructor = $bb51a97a867b2b6c$var$G;
$bb51a97a867b2b6c$var$C($bb51a97a867b2b6c$var$H, $bb51a97a867b2b6c$var$E.prototype);
$bb51a97a867b2b6c$var$H.isPureReactComponent = !0;
var $bb51a97a867b2b6c$var$I = Array.isArray, $bb51a97a867b2b6c$var$J = Object.prototype.hasOwnProperty, $bb51a97a867b2b6c$var$K = {
    current: null
}, $bb51a97a867b2b6c$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $bb51a97a867b2b6c$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$bb51a97a867b2b6c$var$J.call(b, d) && !$bb51a97a867b2b6c$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $bb51a97a867b2b6c$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $bb51a97a867b2b6c$var$K.current
    };
}
function $bb51a97a867b2b6c$var$N(a, b) {
    return {
        $$typeof: $bb51a97a867b2b6c$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $bb51a97a867b2b6c$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bb51a97a867b2b6c$var$l;
}
function $bb51a97a867b2b6c$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $bb51a97a867b2b6c$var$P = /\/+/g;
function $bb51a97a867b2b6c$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $bb51a97a867b2b6c$var$escape("" + a.key) : b.toString(36);
}
function $bb51a97a867b2b6c$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $bb51a97a867b2b6c$var$l:
                case $bb51a97a867b2b6c$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $bb51a97a867b2b6c$var$Q(h, 0) : d, $bb51a97a867b2b6c$var$I(c) ? (e = "", null != a && (e = a.replace($bb51a97a867b2b6c$var$P, "$&/") + "/"), $bb51a97a867b2b6c$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($bb51a97a867b2b6c$var$O(c) && (c = $bb51a97a867b2b6c$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($bb51a97a867b2b6c$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($bb51a97a867b2b6c$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $bb51a97a867b2b6c$var$Q(k, g);
        h += $bb51a97a867b2b6c$var$R(k, b, e, f, c);
    }
    else if (f = $bb51a97a867b2b6c$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $bb51a97a867b2b6c$var$Q(k, g++), h += $bb51a97a867b2b6c$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $bb51a97a867b2b6c$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $bb51a97a867b2b6c$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $bb51a97a867b2b6c$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $bb51a97a867b2b6c$var$U = {
    current: null
}, $bb51a97a867b2b6c$var$V = {
    transition: null
}, $bb51a97a867b2b6c$var$W = {
    ReactCurrentDispatcher: $bb51a97a867b2b6c$var$U,
    ReactCurrentBatchConfig: $bb51a97a867b2b6c$var$V,
    ReactCurrentOwner: $bb51a97a867b2b6c$var$K
};
$bb51a97a867b2b6c$export$dca3b0875bd9a954 = {
    map: $bb51a97a867b2b6c$var$S,
    forEach: function(a, b, e) {
        $bb51a97a867b2b6c$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $bb51a97a867b2b6c$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $bb51a97a867b2b6c$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$bb51a97a867b2b6c$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$bb51a97a867b2b6c$export$16fa2f45be04daa8 = $bb51a97a867b2b6c$var$E;
$bb51a97a867b2b6c$export$ffb0004e005737fa = $bb51a97a867b2b6c$var$p;
$bb51a97a867b2b6c$export$e2c29f18771995cb = $bb51a97a867b2b6c$var$r;
$bb51a97a867b2b6c$export$221d75b3f55bb0bd = $bb51a97a867b2b6c$var$G;
$bb51a97a867b2b6c$export$5f8d39834fd61797 = $bb51a97a867b2b6c$var$q;
$bb51a97a867b2b6c$export$74bf444e3cd11ea5 = $bb51a97a867b2b6c$var$w;
$bb51a97a867b2b6c$export$ae55be85d98224ed = $bb51a97a867b2b6c$var$W;
$bb51a97a867b2b6c$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $bb51a97a867b2b6c$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $bb51a97a867b2b6c$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$bb51a97a867b2b6c$var$J.call(b, f) && !$bb51a97a867b2b6c$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $bb51a97a867b2b6c$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$bb51a97a867b2b6c$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $bb51a97a867b2b6c$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $bb51a97a867b2b6c$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$bb51a97a867b2b6c$export$c8a8987d4410bf2d = $bb51a97a867b2b6c$var$M;
$bb51a97a867b2b6c$export$d38cd72104c1f0e9 = function(a) {
    var b = $bb51a97a867b2b6c$var$M.bind(null, a);
    b.type = a;
    return b;
};
$bb51a97a867b2b6c$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$bb51a97a867b2b6c$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $bb51a97a867b2b6c$var$v,
        render: a
    };
};
$bb51a97a867b2b6c$export$a8257692ac88316c = $bb51a97a867b2b6c$var$O;
$bb51a97a867b2b6c$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $bb51a97a867b2b6c$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $bb51a97a867b2b6c$var$T
    };
};
$bb51a97a867b2b6c$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $bb51a97a867b2b6c$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$bb51a97a867b2b6c$export$7568632d0d33d16d = function(a) {
    var b = $bb51a97a867b2b6c$var$V.transition;
    $bb51a97a867b2b6c$var$V.transition = {};
    try {
        a();
    } finally{
        $bb51a97a867b2b6c$var$V.transition = b;
    }
};
$bb51a97a867b2b6c$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$bb51a97a867b2b6c$export$35808ee640e87ca7 = function(a, b) {
    return $bb51a97a867b2b6c$var$U.current.useCallback(a, b);
};
$bb51a97a867b2b6c$export$fae74005e78b1a27 = function(a) {
    return $bb51a97a867b2b6c$var$U.current.useContext(a);
};
$bb51a97a867b2b6c$export$dc8fbce3eb94dc1e = function() {};
$bb51a97a867b2b6c$export$6a7bc4e911dc01cf = function(a) {
    return $bb51a97a867b2b6c$var$U.current.useDeferredValue(a);
};
$bb51a97a867b2b6c$export$6d9c69b0de29b591 = function(a, b) {
    return $bb51a97a867b2b6c$var$U.current.useEffect(a, b);
};
$bb51a97a867b2b6c$export$f680877a34711e37 = function() {
    return $bb51a97a867b2b6c$var$U.current.useId();
};
$bb51a97a867b2b6c$export$d5a552a76deda3c2 = function(a, b, e) {
    return $bb51a97a867b2b6c$var$U.current.useImperativeHandle(a, b, e);
};
$bb51a97a867b2b6c$export$aaabe4eda9ed9969 = function(a, b) {
    return $bb51a97a867b2b6c$var$U.current.useInsertionEffect(a, b);
};
$bb51a97a867b2b6c$export$e5c5a5f917a5871c = function(a, b) {
    return $bb51a97a867b2b6c$var$U.current.useLayoutEffect(a, b);
};
$bb51a97a867b2b6c$export$1538c33de8887b59 = function(a, b) {
    return $bb51a97a867b2b6c$var$U.current.useMemo(a, b);
};
$bb51a97a867b2b6c$export$13e3392192263954 = function(a, b, e) {
    return $bb51a97a867b2b6c$var$U.current.useReducer(a, b, e);
};
$bb51a97a867b2b6c$export$b8f5890fc79d6aca = function(a) {
    return $bb51a97a867b2b6c$var$U.current.useRef(a);
};
$bb51a97a867b2b6c$export$60241385465d0a34 = function(a) {
    return $bb51a97a867b2b6c$var$U.current.useState(a);
};
$bb51a97a867b2b6c$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $bb51a97a867b2b6c$var$U.current.useSyncExternalStore(a, b, e);
};
$bb51a97a867b2b6c$export$7b286972b8d8ccbf = function() {
    return $bb51a97a867b2b6c$var$U.current.useTransition();
};
$bb51a97a867b2b6c$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("iQsWA", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $db8388f9ae3d0ea5$export$ae55be85d98224ed; }, function (v) { return $db8388f9ae3d0ea5$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $db8388f9ae3d0ea5$export$d39a5bbd09211389; }, function (v) { return $db8388f9ae3d0ea5$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $db8388f9ae3d0ea5$export$882461b6382ed46c; }, function (v) { return $db8388f9ae3d0ea5$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $db8388f9ae3d0ea5$export$466bfc07425424d5; }, function (v) { return $db8388f9ae3d0ea5$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $db8388f9ae3d0ea5$export$cd75ccfd720a3cd4; }, function (v) { return $db8388f9ae3d0ea5$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $db8388f9ae3d0ea5$export$fa8d919ba61d84db; }, function (v) { return $db8388f9ae3d0ea5$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $db8388f9ae3d0ea5$export$757ceba2d55c277e; }, function (v) { return $db8388f9ae3d0ea5$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $db8388f9ae3d0ea5$export$b3890eb0ae9dca99; }, function (v) { return $db8388f9ae3d0ea5$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $db8388f9ae3d0ea5$export$502457920280e6be; }, function (v) { return $db8388f9ae3d0ea5$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $db8388f9ae3d0ea5$export$c78a37762a8d58e1; }, function (v) { return $db8388f9ae3d0ea5$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $db8388f9ae3d0ea5$export$dc54d992c10e8a18; }, function (v) { return $db8388f9ae3d0ea5$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $db8388f9ae3d0ea5$export$83d89fbfd8236492; }, function (v) { return $db8388f9ae3d0ea5$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $db8388f9ae3d0ea5$export$ae55be85d98224ed;
var $db8388f9ae3d0ea5$export$d39a5bbd09211389;
var $db8388f9ae3d0ea5$export$882461b6382ed46c;
var $db8388f9ae3d0ea5$export$466bfc07425424d5;
var $db8388f9ae3d0ea5$export$cd75ccfd720a3cd4;
var $db8388f9ae3d0ea5$export$fa8d919ba61d84db;
var $db8388f9ae3d0ea5$export$757ceba2d55c277e;
var $db8388f9ae3d0ea5$export$b3890eb0ae9dca99;
var $db8388f9ae3d0ea5$export$502457920280e6be;
var $db8388f9ae3d0ea5$export$c78a37762a8d58e1;
var $db8388f9ae3d0ea5$export$dc54d992c10e8a18;
var $db8388f9ae3d0ea5$export$83d89fbfd8236492;
'use strict';

var $6uYXW = parcelRequire("6uYXW");

var $7ZzgL = parcelRequire("7ZzgL");
function $db8388f9ae3d0ea5$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $db8388f9ae3d0ea5$var$da = new Set, $db8388f9ae3d0ea5$var$ea = {};
function $db8388f9ae3d0ea5$var$fa(a, b) {
    $db8388f9ae3d0ea5$var$ha(a, b);
    $db8388f9ae3d0ea5$var$ha(a + "Capture", b);
}
function $db8388f9ae3d0ea5$var$ha(a, b) {
    $db8388f9ae3d0ea5$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$db8388f9ae3d0ea5$var$da.add(b[a]);
}
var $db8388f9ae3d0ea5$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $db8388f9ae3d0ea5$var$ja = Object.prototype.hasOwnProperty, $db8388f9ae3d0ea5$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $db8388f9ae3d0ea5$var$la = {}, $db8388f9ae3d0ea5$var$ma = {};
function $db8388f9ae3d0ea5$var$oa(a) {
    if ($db8388f9ae3d0ea5$var$ja.call($db8388f9ae3d0ea5$var$ma, a)) return !0;
    if ($db8388f9ae3d0ea5$var$ja.call($db8388f9ae3d0ea5$var$la, a)) return !1;
    if ($db8388f9ae3d0ea5$var$ka.test(a)) return $db8388f9ae3d0ea5$var$ma[a] = !0;
    $db8388f9ae3d0ea5$var$la[a] = !0;
    return !1;
}
function $db8388f9ae3d0ea5$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $db8388f9ae3d0ea5$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $db8388f9ae3d0ea5$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $db8388f9ae3d0ea5$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $db8388f9ae3d0ea5$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $db8388f9ae3d0ea5$var$z[a] = new $db8388f9ae3d0ea5$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $db8388f9ae3d0ea5$var$z[b] = new $db8388f9ae3d0ea5$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $db8388f9ae3d0ea5$var$z[a] = new $db8388f9ae3d0ea5$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $db8388f9ae3d0ea5$var$z[a] = new $db8388f9ae3d0ea5$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $db8388f9ae3d0ea5$var$z[a] = new $db8388f9ae3d0ea5$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $db8388f9ae3d0ea5$var$z[a] = new $db8388f9ae3d0ea5$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $db8388f9ae3d0ea5$var$z[a] = new $db8388f9ae3d0ea5$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $db8388f9ae3d0ea5$var$z[a] = new $db8388f9ae3d0ea5$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $db8388f9ae3d0ea5$var$z[a] = new $db8388f9ae3d0ea5$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $db8388f9ae3d0ea5$var$ra = /[\-:]([a-z])/g;
function $db8388f9ae3d0ea5$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($db8388f9ae3d0ea5$var$ra, $db8388f9ae3d0ea5$var$sa);
    $db8388f9ae3d0ea5$var$z[b] = new $db8388f9ae3d0ea5$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($db8388f9ae3d0ea5$var$ra, $db8388f9ae3d0ea5$var$sa);
    $db8388f9ae3d0ea5$var$z[b] = new $db8388f9ae3d0ea5$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($db8388f9ae3d0ea5$var$ra, $db8388f9ae3d0ea5$var$sa);
    $db8388f9ae3d0ea5$var$z[b] = new $db8388f9ae3d0ea5$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $db8388f9ae3d0ea5$var$z[a] = new $db8388f9ae3d0ea5$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$db8388f9ae3d0ea5$var$z.xlinkHref = new $db8388f9ae3d0ea5$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $db8388f9ae3d0ea5$var$z[a] = new $db8388f9ae3d0ea5$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $db8388f9ae3d0ea5$var$ta(a, b, c, d) {
    var e = $db8388f9ae3d0ea5$var$z.hasOwnProperty(b) ? $db8388f9ae3d0ea5$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $db8388f9ae3d0ea5$var$qa(b, c, e, d) && (c = null), d || null === e ? $db8388f9ae3d0ea5$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $db8388f9ae3d0ea5$var$ua = $6uYXW.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $db8388f9ae3d0ea5$var$va = Symbol.for("react.element"), $db8388f9ae3d0ea5$var$wa = Symbol.for("react.portal"), $db8388f9ae3d0ea5$var$ya = Symbol.for("react.fragment"), $db8388f9ae3d0ea5$var$za = Symbol.for("react.strict_mode"), $db8388f9ae3d0ea5$var$Aa = Symbol.for("react.profiler"), $db8388f9ae3d0ea5$var$Ba = Symbol.for("react.provider"), $db8388f9ae3d0ea5$var$Ca = Symbol.for("react.context"), $db8388f9ae3d0ea5$var$Da = Symbol.for("react.forward_ref"), $db8388f9ae3d0ea5$var$Ea = Symbol.for("react.suspense"), $db8388f9ae3d0ea5$var$Fa = Symbol.for("react.suspense_list"), $db8388f9ae3d0ea5$var$Ga = Symbol.for("react.memo"), $db8388f9ae3d0ea5$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $db8388f9ae3d0ea5$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $db8388f9ae3d0ea5$var$Ja = Symbol.iterator;
function $db8388f9ae3d0ea5$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $db8388f9ae3d0ea5$var$Ja && a[$db8388f9ae3d0ea5$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $db8388f9ae3d0ea5$var$A = Object.assign, $db8388f9ae3d0ea5$var$La;
function $db8388f9ae3d0ea5$var$Ma(a) {
    if (void 0 === $db8388f9ae3d0ea5$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $db8388f9ae3d0ea5$var$La = b && b[1] || "";
    }
    return "\n" + $db8388f9ae3d0ea5$var$La + a;
}
var $db8388f9ae3d0ea5$var$Na = !1;
function $db8388f9ae3d0ea5$var$Oa(a, b) {
    if (!a || $db8388f9ae3d0ea5$var$Na) return "";
    $db8388f9ae3d0ea5$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $db8388f9ae3d0ea5$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $db8388f9ae3d0ea5$var$Ma(a) : "";
}
function $db8388f9ae3d0ea5$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $db8388f9ae3d0ea5$var$Ma(a.type);
        case 16:
            return $db8388f9ae3d0ea5$var$Ma("Lazy");
        case 13:
            return $db8388f9ae3d0ea5$var$Ma("Suspense");
        case 19:
            return $db8388f9ae3d0ea5$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $db8388f9ae3d0ea5$var$Oa(a.type, !1), a;
        case 11:
            return a = $db8388f9ae3d0ea5$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $db8388f9ae3d0ea5$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $db8388f9ae3d0ea5$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $db8388f9ae3d0ea5$var$ya:
            return "Fragment";
        case $db8388f9ae3d0ea5$var$wa:
            return "Portal";
        case $db8388f9ae3d0ea5$var$Aa:
            return "Profiler";
        case $db8388f9ae3d0ea5$var$za:
            return "StrictMode";
        case $db8388f9ae3d0ea5$var$Ea:
            return "Suspense";
        case $db8388f9ae3d0ea5$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $db8388f9ae3d0ea5$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $db8388f9ae3d0ea5$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $db8388f9ae3d0ea5$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $db8388f9ae3d0ea5$var$Ga:
            return b = a.displayName || null, null !== b ? b : $db8388f9ae3d0ea5$var$Qa(a.type) || "Memo";
        case $db8388f9ae3d0ea5$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $db8388f9ae3d0ea5$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $db8388f9ae3d0ea5$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $db8388f9ae3d0ea5$var$Qa(b);
        case 8:
            return b === $db8388f9ae3d0ea5$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $db8388f9ae3d0ea5$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $db8388f9ae3d0ea5$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $db8388f9ae3d0ea5$var$Ua(a) {
    var b = $db8388f9ae3d0ea5$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $db8388f9ae3d0ea5$var$Va(a) {
    a._valueTracker || (a._valueTracker = $db8388f9ae3d0ea5$var$Ua(a));
}
function $db8388f9ae3d0ea5$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $db8388f9ae3d0ea5$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $db8388f9ae3d0ea5$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $db8388f9ae3d0ea5$var$Ya(a, b) {
    var c = b.checked;
    return $db8388f9ae3d0ea5$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $db8388f9ae3d0ea5$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $db8388f9ae3d0ea5$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $db8388f9ae3d0ea5$var$ab(a, b) {
    b = b.checked;
    null != b && $db8388f9ae3d0ea5$var$ta(a, "checked", b, !1);
}
function $db8388f9ae3d0ea5$var$bb(a, b) {
    $db8388f9ae3d0ea5$var$ab(a, b);
    var c = $db8388f9ae3d0ea5$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $db8388f9ae3d0ea5$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $db8388f9ae3d0ea5$var$cb(a, b.type, $db8388f9ae3d0ea5$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $db8388f9ae3d0ea5$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $db8388f9ae3d0ea5$var$cb(a, b, c) {
    if ("number" !== b || $db8388f9ae3d0ea5$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $db8388f9ae3d0ea5$var$eb = Array.isArray;
function $db8388f9ae3d0ea5$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $db8388f9ae3d0ea5$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $db8388f9ae3d0ea5$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($db8388f9ae3d0ea5$var$p(91));
    return $db8388f9ae3d0ea5$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $db8388f9ae3d0ea5$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($db8388f9ae3d0ea5$var$p(92));
            if ($db8388f9ae3d0ea5$var$eb(c)) {
                if (1 < c.length) throw Error($db8388f9ae3d0ea5$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $db8388f9ae3d0ea5$var$Sa(c)
    };
}
function $db8388f9ae3d0ea5$var$ib(a, b) {
    var c = $db8388f9ae3d0ea5$var$Sa(b.value), d = $db8388f9ae3d0ea5$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $db8388f9ae3d0ea5$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $db8388f9ae3d0ea5$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $db8388f9ae3d0ea5$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $db8388f9ae3d0ea5$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $db8388f9ae3d0ea5$var$mb, $db8388f9ae3d0ea5$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $db8388f9ae3d0ea5$var$mb = $db8388f9ae3d0ea5$var$mb || document.createElement("div");
        $db8388f9ae3d0ea5$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $db8388f9ae3d0ea5$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $db8388f9ae3d0ea5$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $db8388f9ae3d0ea5$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $db8388f9ae3d0ea5$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($db8388f9ae3d0ea5$var$pb).forEach(function(a) {
    $db8388f9ae3d0ea5$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $db8388f9ae3d0ea5$var$pb[b] = $db8388f9ae3d0ea5$var$pb[a];
    });
});
function $db8388f9ae3d0ea5$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $db8388f9ae3d0ea5$var$pb.hasOwnProperty(a) && $db8388f9ae3d0ea5$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $db8388f9ae3d0ea5$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $db8388f9ae3d0ea5$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $db8388f9ae3d0ea5$var$tb = $db8388f9ae3d0ea5$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $db8388f9ae3d0ea5$var$ub(a, b) {
    if (b) {
        if ($db8388f9ae3d0ea5$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($db8388f9ae3d0ea5$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($db8388f9ae3d0ea5$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($db8388f9ae3d0ea5$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($db8388f9ae3d0ea5$var$p(62));
    }
}
function $db8388f9ae3d0ea5$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $db8388f9ae3d0ea5$var$wb = null;
function $db8388f9ae3d0ea5$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $db8388f9ae3d0ea5$var$yb = null, $db8388f9ae3d0ea5$var$zb = null, $db8388f9ae3d0ea5$var$Ab = null;
function $db8388f9ae3d0ea5$var$Bb(a) {
    if (a = $db8388f9ae3d0ea5$var$Cb(a)) {
        if ("function" !== typeof $db8388f9ae3d0ea5$var$yb) throw Error($db8388f9ae3d0ea5$var$p(280));
        var b = a.stateNode;
        b && (b = $db8388f9ae3d0ea5$var$Db(b), $db8388f9ae3d0ea5$var$yb(a.stateNode, a.type, b));
    }
}
function $db8388f9ae3d0ea5$var$Eb(a) {
    $db8388f9ae3d0ea5$var$zb ? $db8388f9ae3d0ea5$var$Ab ? $db8388f9ae3d0ea5$var$Ab.push(a) : $db8388f9ae3d0ea5$var$Ab = [
        a
    ] : $db8388f9ae3d0ea5$var$zb = a;
}
function $db8388f9ae3d0ea5$var$Fb() {
    if ($db8388f9ae3d0ea5$var$zb) {
        var a = $db8388f9ae3d0ea5$var$zb, b = $db8388f9ae3d0ea5$var$Ab;
        $db8388f9ae3d0ea5$var$Ab = $db8388f9ae3d0ea5$var$zb = null;
        $db8388f9ae3d0ea5$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$db8388f9ae3d0ea5$var$Bb(b[a]);
    }
}
function $db8388f9ae3d0ea5$var$Gb(a, b) {
    return a(b);
}
function $db8388f9ae3d0ea5$var$Hb() {}
var $db8388f9ae3d0ea5$var$Ib = !1;
function $db8388f9ae3d0ea5$var$Jb(a, b, c) {
    if ($db8388f9ae3d0ea5$var$Ib) return a(b, c);
    $db8388f9ae3d0ea5$var$Ib = !0;
    try {
        return $db8388f9ae3d0ea5$var$Gb(a, b, c);
    } finally{
        if ($db8388f9ae3d0ea5$var$Ib = !1, null !== $db8388f9ae3d0ea5$var$zb || null !== $db8388f9ae3d0ea5$var$Ab) $db8388f9ae3d0ea5$var$Hb(), $db8388f9ae3d0ea5$var$Fb();
    }
}
function $db8388f9ae3d0ea5$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $db8388f9ae3d0ea5$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($db8388f9ae3d0ea5$var$p(231, b, typeof c));
    return c;
}
var $db8388f9ae3d0ea5$var$Lb = !1;
if ($db8388f9ae3d0ea5$var$ia) try {
    var $db8388f9ae3d0ea5$var$Mb = {};
    Object.defineProperty($db8388f9ae3d0ea5$var$Mb, "passive", {
        get: function() {
            $db8388f9ae3d0ea5$var$Lb = !0;
        }
    });
    window.addEventListener("test", $db8388f9ae3d0ea5$var$Mb, $db8388f9ae3d0ea5$var$Mb);
    window.removeEventListener("test", $db8388f9ae3d0ea5$var$Mb, $db8388f9ae3d0ea5$var$Mb);
} catch (a) {
    $db8388f9ae3d0ea5$var$Lb = !1;
}
function $db8388f9ae3d0ea5$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $db8388f9ae3d0ea5$var$Ob = !1, $db8388f9ae3d0ea5$var$Pb = null, $db8388f9ae3d0ea5$var$Qb = !1, $db8388f9ae3d0ea5$var$Rb = null, $db8388f9ae3d0ea5$var$Sb = {
    onError: function(a) {
        $db8388f9ae3d0ea5$var$Ob = !0;
        $db8388f9ae3d0ea5$var$Pb = a;
    }
};
function $db8388f9ae3d0ea5$var$Tb(a, b, c, d, e, f, g, h, k) {
    $db8388f9ae3d0ea5$var$Ob = !1;
    $db8388f9ae3d0ea5$var$Pb = null;
    $db8388f9ae3d0ea5$var$Nb.apply($db8388f9ae3d0ea5$var$Sb, arguments);
}
function $db8388f9ae3d0ea5$var$Ub(a, b, c, d, e, f, g, h, k) {
    $db8388f9ae3d0ea5$var$Tb.apply(this, arguments);
    if ($db8388f9ae3d0ea5$var$Ob) {
        if ($db8388f9ae3d0ea5$var$Ob) {
            var l = $db8388f9ae3d0ea5$var$Pb;
            $db8388f9ae3d0ea5$var$Ob = !1;
            $db8388f9ae3d0ea5$var$Pb = null;
        } else throw Error($db8388f9ae3d0ea5$var$p(198));
        $db8388f9ae3d0ea5$var$Qb || ($db8388f9ae3d0ea5$var$Qb = !0, $db8388f9ae3d0ea5$var$Rb = l);
    }
}
function $db8388f9ae3d0ea5$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $db8388f9ae3d0ea5$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $db8388f9ae3d0ea5$var$Xb(a) {
    if ($db8388f9ae3d0ea5$var$Vb(a) !== a) throw Error($db8388f9ae3d0ea5$var$p(188));
}
function $db8388f9ae3d0ea5$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $db8388f9ae3d0ea5$var$Vb(a);
        if (null === b) throw Error($db8388f9ae3d0ea5$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $db8388f9ae3d0ea5$var$Xb(e), a;
                if (f === d) return $db8388f9ae3d0ea5$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($db8388f9ae3d0ea5$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($db8388f9ae3d0ea5$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($db8388f9ae3d0ea5$var$p(190));
    }
    if (3 !== c.tag) throw Error($db8388f9ae3d0ea5$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $db8388f9ae3d0ea5$var$Zb(a) {
    a = $db8388f9ae3d0ea5$var$Yb(a);
    return null !== a ? $db8388f9ae3d0ea5$var$$b(a) : null;
}
function $db8388f9ae3d0ea5$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $db8388f9ae3d0ea5$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $db8388f9ae3d0ea5$var$ac = $7ZzgL.unstable_scheduleCallback, $db8388f9ae3d0ea5$var$bc = $7ZzgL.unstable_cancelCallback, $db8388f9ae3d0ea5$var$cc = $7ZzgL.unstable_shouldYield, $db8388f9ae3d0ea5$var$dc = $7ZzgL.unstable_requestPaint, $db8388f9ae3d0ea5$var$B = $7ZzgL.unstable_now, $db8388f9ae3d0ea5$var$ec = $7ZzgL.unstable_getCurrentPriorityLevel, $db8388f9ae3d0ea5$var$fc = $7ZzgL.unstable_ImmediatePriority, $db8388f9ae3d0ea5$var$gc = $7ZzgL.unstable_UserBlockingPriority, $db8388f9ae3d0ea5$var$hc = $7ZzgL.unstable_NormalPriority, $db8388f9ae3d0ea5$var$ic = $7ZzgL.unstable_LowPriority, $db8388f9ae3d0ea5$var$jc = $7ZzgL.unstable_IdlePriority, $db8388f9ae3d0ea5$var$kc = null, $db8388f9ae3d0ea5$var$lc = null;
function $db8388f9ae3d0ea5$var$mc(a) {
    if ($db8388f9ae3d0ea5$var$lc && "function" === typeof $db8388f9ae3d0ea5$var$lc.onCommitFiberRoot) try {
        $db8388f9ae3d0ea5$var$lc.onCommitFiberRoot($db8388f9ae3d0ea5$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $db8388f9ae3d0ea5$var$oc = Math.clz32 ? Math.clz32 : $db8388f9ae3d0ea5$var$nc, $db8388f9ae3d0ea5$var$pc = Math.log, $db8388f9ae3d0ea5$var$qc = Math.LN2;
function $db8388f9ae3d0ea5$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($db8388f9ae3d0ea5$var$pc(a) / $db8388f9ae3d0ea5$var$qc | 0) | 0;
}
var $db8388f9ae3d0ea5$var$rc = 64, $db8388f9ae3d0ea5$var$sc = 4194304;
function $db8388f9ae3d0ea5$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $db8388f9ae3d0ea5$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $db8388f9ae3d0ea5$var$tc(h) : (f &= g, 0 !== f && (d = $db8388f9ae3d0ea5$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $db8388f9ae3d0ea5$var$tc(g) : 0 !== f && (d = $db8388f9ae3d0ea5$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $db8388f9ae3d0ea5$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $db8388f9ae3d0ea5$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $db8388f9ae3d0ea5$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $db8388f9ae3d0ea5$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $db8388f9ae3d0ea5$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $db8388f9ae3d0ea5$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $db8388f9ae3d0ea5$var$yc() {
    var a = $db8388f9ae3d0ea5$var$rc;
    $db8388f9ae3d0ea5$var$rc <<= 1;
    0 === ($db8388f9ae3d0ea5$var$rc & 4194240) && ($db8388f9ae3d0ea5$var$rc = 64);
    return a;
}
function $db8388f9ae3d0ea5$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $db8388f9ae3d0ea5$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $db8388f9ae3d0ea5$var$oc(b);
    a[b] = c;
}
function $db8388f9ae3d0ea5$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $db8388f9ae3d0ea5$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $db8388f9ae3d0ea5$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $db8388f9ae3d0ea5$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $db8388f9ae3d0ea5$var$C = 0;
function $db8388f9ae3d0ea5$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $db8388f9ae3d0ea5$var$Ec, $db8388f9ae3d0ea5$var$Fc, $db8388f9ae3d0ea5$var$Gc, $db8388f9ae3d0ea5$var$Hc, $db8388f9ae3d0ea5$var$Ic, $db8388f9ae3d0ea5$var$Jc = !1, $db8388f9ae3d0ea5$var$Kc = [], $db8388f9ae3d0ea5$var$Lc = null, $db8388f9ae3d0ea5$var$Mc = null, $db8388f9ae3d0ea5$var$Nc = null, $db8388f9ae3d0ea5$var$Oc = new Map, $db8388f9ae3d0ea5$var$Pc = new Map, $db8388f9ae3d0ea5$var$Qc = [], $db8388f9ae3d0ea5$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $db8388f9ae3d0ea5$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $db8388f9ae3d0ea5$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $db8388f9ae3d0ea5$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $db8388f9ae3d0ea5$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $db8388f9ae3d0ea5$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $db8388f9ae3d0ea5$var$Pc.delete(b.pointerId);
    }
}
function $db8388f9ae3d0ea5$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $db8388f9ae3d0ea5$var$Cb(b), null !== b && $db8388f9ae3d0ea5$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $db8388f9ae3d0ea5$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $db8388f9ae3d0ea5$var$Lc = $db8388f9ae3d0ea5$var$Tc($db8388f9ae3d0ea5$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $db8388f9ae3d0ea5$var$Mc = $db8388f9ae3d0ea5$var$Tc($db8388f9ae3d0ea5$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $db8388f9ae3d0ea5$var$Nc = $db8388f9ae3d0ea5$var$Tc($db8388f9ae3d0ea5$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $db8388f9ae3d0ea5$var$Oc.set(f, $db8388f9ae3d0ea5$var$Tc($db8388f9ae3d0ea5$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $db8388f9ae3d0ea5$var$Pc.set(f, $db8388f9ae3d0ea5$var$Tc($db8388f9ae3d0ea5$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $db8388f9ae3d0ea5$var$Vc(a) {
    var b = $db8388f9ae3d0ea5$var$Wc(a.target);
    if (null !== b) {
        var c = $db8388f9ae3d0ea5$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $db8388f9ae3d0ea5$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $db8388f9ae3d0ea5$var$Ic(a.priority, function() {
                        $db8388f9ae3d0ea5$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $db8388f9ae3d0ea5$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $db8388f9ae3d0ea5$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $db8388f9ae3d0ea5$var$wb = d;
            c.target.dispatchEvent(d);
            $db8388f9ae3d0ea5$var$wb = null;
        } else return b = $db8388f9ae3d0ea5$var$Cb(c), null !== b && $db8388f9ae3d0ea5$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $db8388f9ae3d0ea5$var$Zc(a, b, c) {
    $db8388f9ae3d0ea5$var$Xc(a) && c.delete(b);
}
function $db8388f9ae3d0ea5$var$$c() {
    $db8388f9ae3d0ea5$var$Jc = !1;
    null !== $db8388f9ae3d0ea5$var$Lc && $db8388f9ae3d0ea5$var$Xc($db8388f9ae3d0ea5$var$Lc) && ($db8388f9ae3d0ea5$var$Lc = null);
    null !== $db8388f9ae3d0ea5$var$Mc && $db8388f9ae3d0ea5$var$Xc($db8388f9ae3d0ea5$var$Mc) && ($db8388f9ae3d0ea5$var$Mc = null);
    null !== $db8388f9ae3d0ea5$var$Nc && $db8388f9ae3d0ea5$var$Xc($db8388f9ae3d0ea5$var$Nc) && ($db8388f9ae3d0ea5$var$Nc = null);
    $db8388f9ae3d0ea5$var$Oc.forEach($db8388f9ae3d0ea5$var$Zc);
    $db8388f9ae3d0ea5$var$Pc.forEach($db8388f9ae3d0ea5$var$Zc);
}
function $db8388f9ae3d0ea5$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $db8388f9ae3d0ea5$var$Jc || ($db8388f9ae3d0ea5$var$Jc = !0, $7ZzgL.unstable_scheduleCallback($7ZzgL.unstable_NormalPriority, $db8388f9ae3d0ea5$var$$c)));
}
function $db8388f9ae3d0ea5$var$bd(a) {
    function b(b) {
        return $db8388f9ae3d0ea5$var$ad(b, a);
    }
    if (0 < $db8388f9ae3d0ea5$var$Kc.length) {
        $db8388f9ae3d0ea5$var$ad($db8388f9ae3d0ea5$var$Kc[0], a);
        for(var c = 1; c < $db8388f9ae3d0ea5$var$Kc.length; c++){
            var d = $db8388f9ae3d0ea5$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $db8388f9ae3d0ea5$var$Lc && $db8388f9ae3d0ea5$var$ad($db8388f9ae3d0ea5$var$Lc, a);
    null !== $db8388f9ae3d0ea5$var$Mc && $db8388f9ae3d0ea5$var$ad($db8388f9ae3d0ea5$var$Mc, a);
    null !== $db8388f9ae3d0ea5$var$Nc && $db8388f9ae3d0ea5$var$ad($db8388f9ae3d0ea5$var$Nc, a);
    $db8388f9ae3d0ea5$var$Oc.forEach(b);
    $db8388f9ae3d0ea5$var$Pc.forEach(b);
    for(c = 0; c < $db8388f9ae3d0ea5$var$Qc.length; c++)d = $db8388f9ae3d0ea5$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $db8388f9ae3d0ea5$var$Qc.length && (c = $db8388f9ae3d0ea5$var$Qc[0], null === c.blockedOn);)$db8388f9ae3d0ea5$var$Vc(c), null === c.blockedOn && $db8388f9ae3d0ea5$var$Qc.shift();
}
var $db8388f9ae3d0ea5$var$cd = $db8388f9ae3d0ea5$var$ua.ReactCurrentBatchConfig, $db8388f9ae3d0ea5$var$dd = !0;
function $db8388f9ae3d0ea5$var$ed(a, b, c, d) {
    var e = $db8388f9ae3d0ea5$var$C, f = $db8388f9ae3d0ea5$var$cd.transition;
    $db8388f9ae3d0ea5$var$cd.transition = null;
    try {
        $db8388f9ae3d0ea5$var$C = 1, $db8388f9ae3d0ea5$var$fd(a, b, c, d);
    } finally{
        $db8388f9ae3d0ea5$var$C = e, $db8388f9ae3d0ea5$var$cd.transition = f;
    }
}
function $db8388f9ae3d0ea5$var$gd(a, b, c, d) {
    var e = $db8388f9ae3d0ea5$var$C, f = $db8388f9ae3d0ea5$var$cd.transition;
    $db8388f9ae3d0ea5$var$cd.transition = null;
    try {
        $db8388f9ae3d0ea5$var$C = 4, $db8388f9ae3d0ea5$var$fd(a, b, c, d);
    } finally{
        $db8388f9ae3d0ea5$var$C = e, $db8388f9ae3d0ea5$var$cd.transition = f;
    }
}
function $db8388f9ae3d0ea5$var$fd(a, b, c, d) {
    if ($db8388f9ae3d0ea5$var$dd) {
        var e = $db8388f9ae3d0ea5$var$Yc(a, b, c, d);
        if (null === e) $db8388f9ae3d0ea5$var$hd(a, b, d, $db8388f9ae3d0ea5$var$id, c), $db8388f9ae3d0ea5$var$Sc(a, d);
        else if ($db8388f9ae3d0ea5$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($db8388f9ae3d0ea5$var$Sc(a, d), b & 4 && -1 < $db8388f9ae3d0ea5$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $db8388f9ae3d0ea5$var$Cb(e);
                null !== f && $db8388f9ae3d0ea5$var$Ec(f);
                f = $db8388f9ae3d0ea5$var$Yc(a, b, c, d);
                null === f && $db8388f9ae3d0ea5$var$hd(a, b, d, $db8388f9ae3d0ea5$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $db8388f9ae3d0ea5$var$hd(a, b, d, null, c);
    }
}
var $db8388f9ae3d0ea5$var$id = null;
function $db8388f9ae3d0ea5$var$Yc(a, b, c, d) {
    $db8388f9ae3d0ea5$var$id = null;
    a = $db8388f9ae3d0ea5$var$xb(d);
    a = $db8388f9ae3d0ea5$var$Wc(a);
    if (null !== a) {
        if (b = $db8388f9ae3d0ea5$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $db8388f9ae3d0ea5$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $db8388f9ae3d0ea5$var$id = a;
    return null;
}
function $db8388f9ae3d0ea5$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($db8388f9ae3d0ea5$var$ec()){
                case $db8388f9ae3d0ea5$var$fc:
                    return 1;
                case $db8388f9ae3d0ea5$var$gc:
                    return 4;
                case $db8388f9ae3d0ea5$var$hc:
                case $db8388f9ae3d0ea5$var$ic:
                    return 16;
                case $db8388f9ae3d0ea5$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $db8388f9ae3d0ea5$var$kd = null, $db8388f9ae3d0ea5$var$ld = null, $db8388f9ae3d0ea5$var$md = null;
function $db8388f9ae3d0ea5$var$nd() {
    if ($db8388f9ae3d0ea5$var$md) return $db8388f9ae3d0ea5$var$md;
    var a, b = $db8388f9ae3d0ea5$var$ld, c = b.length, d, e = "value" in $db8388f9ae3d0ea5$var$kd ? $db8388f9ae3d0ea5$var$kd.value : $db8388f9ae3d0ea5$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $db8388f9ae3d0ea5$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $db8388f9ae3d0ea5$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $db8388f9ae3d0ea5$var$pd() {
    return !0;
}
function $db8388f9ae3d0ea5$var$qd() {
    return !1;
}
function $db8388f9ae3d0ea5$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $db8388f9ae3d0ea5$var$pd : $db8388f9ae3d0ea5$var$qd;
        this.isPropagationStopped = $db8388f9ae3d0ea5$var$qd;
        return this;
    }
    $db8388f9ae3d0ea5$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $db8388f9ae3d0ea5$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $db8388f9ae3d0ea5$var$pd);
        },
        persist: function() {},
        isPersistent: $db8388f9ae3d0ea5$var$pd
    });
    return b;
}
var $db8388f9ae3d0ea5$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $db8388f9ae3d0ea5$var$td = $db8388f9ae3d0ea5$var$rd($db8388f9ae3d0ea5$var$sd), $db8388f9ae3d0ea5$var$ud = $db8388f9ae3d0ea5$var$A({}, $db8388f9ae3d0ea5$var$sd, {
    view: 0,
    detail: 0
}), $db8388f9ae3d0ea5$var$vd = $db8388f9ae3d0ea5$var$rd($db8388f9ae3d0ea5$var$ud), $db8388f9ae3d0ea5$var$wd, $db8388f9ae3d0ea5$var$xd, $db8388f9ae3d0ea5$var$yd, $db8388f9ae3d0ea5$var$Ad = $db8388f9ae3d0ea5$var$A({}, $db8388f9ae3d0ea5$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $db8388f9ae3d0ea5$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $db8388f9ae3d0ea5$var$yd && ($db8388f9ae3d0ea5$var$yd && "mousemove" === a.type ? ($db8388f9ae3d0ea5$var$wd = a.screenX - $db8388f9ae3d0ea5$var$yd.screenX, $db8388f9ae3d0ea5$var$xd = a.screenY - $db8388f9ae3d0ea5$var$yd.screenY) : $db8388f9ae3d0ea5$var$xd = $db8388f9ae3d0ea5$var$wd = 0, $db8388f9ae3d0ea5$var$yd = a);
        return $db8388f9ae3d0ea5$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $db8388f9ae3d0ea5$var$xd;
    }
}), $db8388f9ae3d0ea5$var$Bd = $db8388f9ae3d0ea5$var$rd($db8388f9ae3d0ea5$var$Ad), $db8388f9ae3d0ea5$var$Cd = $db8388f9ae3d0ea5$var$A({}, $db8388f9ae3d0ea5$var$Ad, {
    dataTransfer: 0
}), $db8388f9ae3d0ea5$var$Dd = $db8388f9ae3d0ea5$var$rd($db8388f9ae3d0ea5$var$Cd), $db8388f9ae3d0ea5$var$Ed = $db8388f9ae3d0ea5$var$A({}, $db8388f9ae3d0ea5$var$ud, {
    relatedTarget: 0
}), $db8388f9ae3d0ea5$var$Fd = $db8388f9ae3d0ea5$var$rd($db8388f9ae3d0ea5$var$Ed), $db8388f9ae3d0ea5$var$Gd = $db8388f9ae3d0ea5$var$A({}, $db8388f9ae3d0ea5$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $db8388f9ae3d0ea5$var$Hd = $db8388f9ae3d0ea5$var$rd($db8388f9ae3d0ea5$var$Gd), $db8388f9ae3d0ea5$var$Id = $db8388f9ae3d0ea5$var$A({}, $db8388f9ae3d0ea5$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $db8388f9ae3d0ea5$var$Jd = $db8388f9ae3d0ea5$var$rd($db8388f9ae3d0ea5$var$Id), $db8388f9ae3d0ea5$var$Kd = $db8388f9ae3d0ea5$var$A({}, $db8388f9ae3d0ea5$var$sd, {
    data: 0
}), $db8388f9ae3d0ea5$var$Ld = $db8388f9ae3d0ea5$var$rd($db8388f9ae3d0ea5$var$Kd), $db8388f9ae3d0ea5$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $db8388f9ae3d0ea5$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $db8388f9ae3d0ea5$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $db8388f9ae3d0ea5$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $db8388f9ae3d0ea5$var$Od[a]) ? !!b[a] : !1;
}
function $db8388f9ae3d0ea5$var$zd() {
    return $db8388f9ae3d0ea5$var$Pd;
}
var $db8388f9ae3d0ea5$var$Qd = $db8388f9ae3d0ea5$var$A({}, $db8388f9ae3d0ea5$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $db8388f9ae3d0ea5$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $db8388f9ae3d0ea5$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $db8388f9ae3d0ea5$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $db8388f9ae3d0ea5$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $db8388f9ae3d0ea5$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $db8388f9ae3d0ea5$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $db8388f9ae3d0ea5$var$Rd = $db8388f9ae3d0ea5$var$rd($db8388f9ae3d0ea5$var$Qd), $db8388f9ae3d0ea5$var$Sd = $db8388f9ae3d0ea5$var$A({}, $db8388f9ae3d0ea5$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $db8388f9ae3d0ea5$var$Td = $db8388f9ae3d0ea5$var$rd($db8388f9ae3d0ea5$var$Sd), $db8388f9ae3d0ea5$var$Ud = $db8388f9ae3d0ea5$var$A({}, $db8388f9ae3d0ea5$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $db8388f9ae3d0ea5$var$zd
}), $db8388f9ae3d0ea5$var$Vd = $db8388f9ae3d0ea5$var$rd($db8388f9ae3d0ea5$var$Ud), $db8388f9ae3d0ea5$var$Wd = $db8388f9ae3d0ea5$var$A({}, $db8388f9ae3d0ea5$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $db8388f9ae3d0ea5$var$Xd = $db8388f9ae3d0ea5$var$rd($db8388f9ae3d0ea5$var$Wd), $db8388f9ae3d0ea5$var$Yd = $db8388f9ae3d0ea5$var$A({}, $db8388f9ae3d0ea5$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $db8388f9ae3d0ea5$var$Zd = $db8388f9ae3d0ea5$var$rd($db8388f9ae3d0ea5$var$Yd), $db8388f9ae3d0ea5$var$$d = [
    9,
    13,
    27,
    32
], $db8388f9ae3d0ea5$var$ae = $db8388f9ae3d0ea5$var$ia && "CompositionEvent" in window, $db8388f9ae3d0ea5$var$be = null;
$db8388f9ae3d0ea5$var$ia && "documentMode" in document && ($db8388f9ae3d0ea5$var$be = document.documentMode);
var $db8388f9ae3d0ea5$var$ce = $db8388f9ae3d0ea5$var$ia && "TextEvent" in window && !$db8388f9ae3d0ea5$var$be, $db8388f9ae3d0ea5$var$de = $db8388f9ae3d0ea5$var$ia && (!$db8388f9ae3d0ea5$var$ae || $db8388f9ae3d0ea5$var$be && 8 < $db8388f9ae3d0ea5$var$be && 11 >= $db8388f9ae3d0ea5$var$be), $db8388f9ae3d0ea5$var$ee = String.fromCharCode(32), $db8388f9ae3d0ea5$var$fe = !1;
function $db8388f9ae3d0ea5$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $db8388f9ae3d0ea5$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $db8388f9ae3d0ea5$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $db8388f9ae3d0ea5$var$ie = !1;
function $db8388f9ae3d0ea5$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $db8388f9ae3d0ea5$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $db8388f9ae3d0ea5$var$fe = !0;
            return $db8388f9ae3d0ea5$var$ee;
        case "textInput":
            return a = b.data, a === $db8388f9ae3d0ea5$var$ee && $db8388f9ae3d0ea5$var$fe ? null : a;
        default:
            return null;
    }
}
function $db8388f9ae3d0ea5$var$ke(a, b) {
    if ($db8388f9ae3d0ea5$var$ie) return "compositionend" === a || !$db8388f9ae3d0ea5$var$ae && $db8388f9ae3d0ea5$var$ge(a, b) ? (a = $db8388f9ae3d0ea5$var$nd(), $db8388f9ae3d0ea5$var$md = $db8388f9ae3d0ea5$var$ld = $db8388f9ae3d0ea5$var$kd = null, $db8388f9ae3d0ea5$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $db8388f9ae3d0ea5$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $db8388f9ae3d0ea5$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $db8388f9ae3d0ea5$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$db8388f9ae3d0ea5$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $db8388f9ae3d0ea5$var$ne(a, b, c, d) {
    $db8388f9ae3d0ea5$var$Eb(d);
    b = $db8388f9ae3d0ea5$var$oe(b, "onChange");
    0 < b.length && (c = new $db8388f9ae3d0ea5$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $db8388f9ae3d0ea5$var$pe = null, $db8388f9ae3d0ea5$var$qe = null;
function $db8388f9ae3d0ea5$var$re(a) {
    $db8388f9ae3d0ea5$var$se(a, 0);
}
function $db8388f9ae3d0ea5$var$te(a) {
    var b = $db8388f9ae3d0ea5$var$ue(a);
    if ($db8388f9ae3d0ea5$var$Wa(b)) return a;
}
function $db8388f9ae3d0ea5$var$ve(a, b) {
    if ("change" === a) return b;
}
var $db8388f9ae3d0ea5$var$we = !1;
if ($db8388f9ae3d0ea5$var$ia) {
    var $db8388f9ae3d0ea5$var$xe;
    if ($db8388f9ae3d0ea5$var$ia) {
        var $db8388f9ae3d0ea5$var$ye = "oninput" in document;
        if (!$db8388f9ae3d0ea5$var$ye) {
            var $db8388f9ae3d0ea5$var$ze = document.createElement("div");
            $db8388f9ae3d0ea5$var$ze.setAttribute("oninput", "return;");
            $db8388f9ae3d0ea5$var$ye = "function" === typeof $db8388f9ae3d0ea5$var$ze.oninput;
        }
        $db8388f9ae3d0ea5$var$xe = $db8388f9ae3d0ea5$var$ye;
    } else $db8388f9ae3d0ea5$var$xe = !1;
    $db8388f9ae3d0ea5$var$we = $db8388f9ae3d0ea5$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $db8388f9ae3d0ea5$var$Ae() {
    $db8388f9ae3d0ea5$var$pe && ($db8388f9ae3d0ea5$var$pe.detachEvent("onpropertychange", $db8388f9ae3d0ea5$var$Be), $db8388f9ae3d0ea5$var$qe = $db8388f9ae3d0ea5$var$pe = null);
}
function $db8388f9ae3d0ea5$var$Be(a) {
    if ("value" === a.propertyName && $db8388f9ae3d0ea5$var$te($db8388f9ae3d0ea5$var$qe)) {
        var b = [];
        $db8388f9ae3d0ea5$var$ne(b, $db8388f9ae3d0ea5$var$qe, a, $db8388f9ae3d0ea5$var$xb(a));
        $db8388f9ae3d0ea5$var$Jb($db8388f9ae3d0ea5$var$re, b);
    }
}
function $db8388f9ae3d0ea5$var$Ce(a, b, c) {
    "focusin" === a ? ($db8388f9ae3d0ea5$var$Ae(), $db8388f9ae3d0ea5$var$pe = b, $db8388f9ae3d0ea5$var$qe = c, $db8388f9ae3d0ea5$var$pe.attachEvent("onpropertychange", $db8388f9ae3d0ea5$var$Be)) : "focusout" === a && $db8388f9ae3d0ea5$var$Ae();
}
function $db8388f9ae3d0ea5$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $db8388f9ae3d0ea5$var$te($db8388f9ae3d0ea5$var$qe);
}
function $db8388f9ae3d0ea5$var$Ee(a, b) {
    if ("click" === a) return $db8388f9ae3d0ea5$var$te(b);
}
function $db8388f9ae3d0ea5$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $db8388f9ae3d0ea5$var$te(b);
}
function $db8388f9ae3d0ea5$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $db8388f9ae3d0ea5$var$He = "function" === typeof Object.is ? Object.is : $db8388f9ae3d0ea5$var$Ge;
function $db8388f9ae3d0ea5$var$Ie(a, b) {
    if ($db8388f9ae3d0ea5$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$db8388f9ae3d0ea5$var$ja.call(b, e) || !$db8388f9ae3d0ea5$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $db8388f9ae3d0ea5$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $db8388f9ae3d0ea5$var$Ke(a, b) {
    var c = $db8388f9ae3d0ea5$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $db8388f9ae3d0ea5$var$Je(c);
    }
}
function $db8388f9ae3d0ea5$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $db8388f9ae3d0ea5$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $db8388f9ae3d0ea5$var$Me() {
    for(var a = window, b = $db8388f9ae3d0ea5$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $db8388f9ae3d0ea5$var$Xa(a.document);
    }
    return b;
}
function $db8388f9ae3d0ea5$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $db8388f9ae3d0ea5$var$Oe(a) {
    var b = $db8388f9ae3d0ea5$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $db8388f9ae3d0ea5$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $db8388f9ae3d0ea5$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $db8388f9ae3d0ea5$var$Ke(c, f);
                var g = $db8388f9ae3d0ea5$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $db8388f9ae3d0ea5$var$Pe = $db8388f9ae3d0ea5$var$ia && "documentMode" in document && 11 >= document.documentMode, $db8388f9ae3d0ea5$var$Qe = null, $db8388f9ae3d0ea5$var$Re = null, $db8388f9ae3d0ea5$var$Se = null, $db8388f9ae3d0ea5$var$Te = !1;
function $db8388f9ae3d0ea5$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $db8388f9ae3d0ea5$var$Te || null == $db8388f9ae3d0ea5$var$Qe || $db8388f9ae3d0ea5$var$Qe !== $db8388f9ae3d0ea5$var$Xa(d) || (d = $db8388f9ae3d0ea5$var$Qe, "selectionStart" in d && $db8388f9ae3d0ea5$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $db8388f9ae3d0ea5$var$Se && $db8388f9ae3d0ea5$var$Ie($db8388f9ae3d0ea5$var$Se, d) || ($db8388f9ae3d0ea5$var$Se = d, d = $db8388f9ae3d0ea5$var$oe($db8388f9ae3d0ea5$var$Re, "onSelect"), 0 < d.length && (b = new $db8388f9ae3d0ea5$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $db8388f9ae3d0ea5$var$Qe)));
}
function $db8388f9ae3d0ea5$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $db8388f9ae3d0ea5$var$We = {
    animationend: $db8388f9ae3d0ea5$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $db8388f9ae3d0ea5$var$Ve("Animation", "AnimationIteration"),
    animationstart: $db8388f9ae3d0ea5$var$Ve("Animation", "AnimationStart"),
    transitionend: $db8388f9ae3d0ea5$var$Ve("Transition", "TransitionEnd")
}, $db8388f9ae3d0ea5$var$Xe = {}, $db8388f9ae3d0ea5$var$Ye = {};
$db8388f9ae3d0ea5$var$ia && ($db8388f9ae3d0ea5$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $db8388f9ae3d0ea5$var$We.animationend.animation, delete $db8388f9ae3d0ea5$var$We.animationiteration.animation, delete $db8388f9ae3d0ea5$var$We.animationstart.animation), "TransitionEvent" in window || delete $db8388f9ae3d0ea5$var$We.transitionend.transition);
function $db8388f9ae3d0ea5$var$Ze(a) {
    if ($db8388f9ae3d0ea5$var$Xe[a]) return $db8388f9ae3d0ea5$var$Xe[a];
    if (!$db8388f9ae3d0ea5$var$We[a]) return a;
    var b = $db8388f9ae3d0ea5$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $db8388f9ae3d0ea5$var$Ye) return $db8388f9ae3d0ea5$var$Xe[a] = b[c];
    return a;
}
var $db8388f9ae3d0ea5$var$$e = $db8388f9ae3d0ea5$var$Ze("animationend"), $db8388f9ae3d0ea5$var$af = $db8388f9ae3d0ea5$var$Ze("animationiteration"), $db8388f9ae3d0ea5$var$bf = $db8388f9ae3d0ea5$var$Ze("animationstart"), $db8388f9ae3d0ea5$var$cf = $db8388f9ae3d0ea5$var$Ze("transitionend"), $db8388f9ae3d0ea5$var$df = new Map, $db8388f9ae3d0ea5$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $db8388f9ae3d0ea5$var$ff(a, b) {
    $db8388f9ae3d0ea5$var$df.set(a, b);
    $db8388f9ae3d0ea5$var$fa(b, [
        a
    ]);
}
for(var $db8388f9ae3d0ea5$var$gf = 0; $db8388f9ae3d0ea5$var$gf < $db8388f9ae3d0ea5$var$ef.length; $db8388f9ae3d0ea5$var$gf++){
    var $db8388f9ae3d0ea5$var$hf = $db8388f9ae3d0ea5$var$ef[$db8388f9ae3d0ea5$var$gf], $db8388f9ae3d0ea5$var$jf = $db8388f9ae3d0ea5$var$hf.toLowerCase(), $db8388f9ae3d0ea5$var$kf = $db8388f9ae3d0ea5$var$hf[0].toUpperCase() + $db8388f9ae3d0ea5$var$hf.slice(1);
    $db8388f9ae3d0ea5$var$ff($db8388f9ae3d0ea5$var$jf, "on" + $db8388f9ae3d0ea5$var$kf);
}
$db8388f9ae3d0ea5$var$ff($db8388f9ae3d0ea5$var$$e, "onAnimationEnd");
$db8388f9ae3d0ea5$var$ff($db8388f9ae3d0ea5$var$af, "onAnimationIteration");
$db8388f9ae3d0ea5$var$ff($db8388f9ae3d0ea5$var$bf, "onAnimationStart");
$db8388f9ae3d0ea5$var$ff("dblclick", "onDoubleClick");
$db8388f9ae3d0ea5$var$ff("focusin", "onFocus");
$db8388f9ae3d0ea5$var$ff("focusout", "onBlur");
$db8388f9ae3d0ea5$var$ff($db8388f9ae3d0ea5$var$cf, "onTransitionEnd");
$db8388f9ae3d0ea5$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$db8388f9ae3d0ea5$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$db8388f9ae3d0ea5$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$db8388f9ae3d0ea5$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$db8388f9ae3d0ea5$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$db8388f9ae3d0ea5$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$db8388f9ae3d0ea5$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$db8388f9ae3d0ea5$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$db8388f9ae3d0ea5$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$db8388f9ae3d0ea5$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $db8388f9ae3d0ea5$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $db8388f9ae3d0ea5$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($db8388f9ae3d0ea5$var$lf));
function $db8388f9ae3d0ea5$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $db8388f9ae3d0ea5$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $db8388f9ae3d0ea5$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $db8388f9ae3d0ea5$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $db8388f9ae3d0ea5$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($db8388f9ae3d0ea5$var$Qb) throw a = $db8388f9ae3d0ea5$var$Rb, $db8388f9ae3d0ea5$var$Qb = !1, $db8388f9ae3d0ea5$var$Rb = null, a;
}
function $db8388f9ae3d0ea5$var$D(a, b) {
    var c = b[$db8388f9ae3d0ea5$var$of];
    void 0 === c && (c = b[$db8388f9ae3d0ea5$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($db8388f9ae3d0ea5$var$pf(b, a, 2, !1), c.add(d));
}
function $db8388f9ae3d0ea5$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $db8388f9ae3d0ea5$var$pf(c, a, d, b);
}
var $db8388f9ae3d0ea5$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $db8388f9ae3d0ea5$var$sf(a) {
    if (!a[$db8388f9ae3d0ea5$var$rf]) {
        a[$db8388f9ae3d0ea5$var$rf] = !0;
        $db8388f9ae3d0ea5$var$da.forEach(function(b) {
            "selectionchange" !== b && ($db8388f9ae3d0ea5$var$mf.has(b) || $db8388f9ae3d0ea5$var$qf(b, !1, a), $db8388f9ae3d0ea5$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$db8388f9ae3d0ea5$var$rf] || (b[$db8388f9ae3d0ea5$var$rf] = !0, $db8388f9ae3d0ea5$var$qf("selectionchange", !1, b));
    }
}
function $db8388f9ae3d0ea5$var$pf(a, b, c, d) {
    switch($db8388f9ae3d0ea5$var$jd(b)){
        case 1:
            var e = $db8388f9ae3d0ea5$var$ed;
            break;
        case 4:
            e = $db8388f9ae3d0ea5$var$gd;
            break;
        default:
            e = $db8388f9ae3d0ea5$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$db8388f9ae3d0ea5$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $db8388f9ae3d0ea5$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $db8388f9ae3d0ea5$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $db8388f9ae3d0ea5$var$Jb(function() {
        var d = f, e = $db8388f9ae3d0ea5$var$xb(c), g = [];
        a: {
            var h = $db8388f9ae3d0ea5$var$df.get(a);
            if (void 0 !== h) {
                var k = $db8388f9ae3d0ea5$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $db8388f9ae3d0ea5$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $db8388f9ae3d0ea5$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $db8388f9ae3d0ea5$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $db8388f9ae3d0ea5$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $db8388f9ae3d0ea5$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $db8388f9ae3d0ea5$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $db8388f9ae3d0ea5$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $db8388f9ae3d0ea5$var$Vd;
                        break;
                    case $db8388f9ae3d0ea5$var$$e:
                    case $db8388f9ae3d0ea5$var$af:
                    case $db8388f9ae3d0ea5$var$bf:
                        k = $db8388f9ae3d0ea5$var$Hd;
                        break;
                    case $db8388f9ae3d0ea5$var$cf:
                        k = $db8388f9ae3d0ea5$var$Xd;
                        break;
                    case "scroll":
                        k = $db8388f9ae3d0ea5$var$vd;
                        break;
                    case "wheel":
                        k = $db8388f9ae3d0ea5$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $db8388f9ae3d0ea5$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $db8388f9ae3d0ea5$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $db8388f9ae3d0ea5$var$Kb(w, x), null != F && t.push($db8388f9ae3d0ea5$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $db8388f9ae3d0ea5$var$wb && (n = c.relatedTarget || c.fromElement) && ($db8388f9ae3d0ea5$var$Wc(n) || n[$db8388f9ae3d0ea5$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $db8388f9ae3d0ea5$var$Wc(n) : null, null !== n && (J = $db8388f9ae3d0ea5$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $db8388f9ae3d0ea5$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $db8388f9ae3d0ea5$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $db8388f9ae3d0ea5$var$ue(k);
                        u = null == n ? h : $db8388f9ae3d0ea5$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $db8388f9ae3d0ea5$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $db8388f9ae3d0ea5$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $db8388f9ae3d0ea5$var$vf(F))u++;
                            for(; 0 < w - u;)t = $db8388f9ae3d0ea5$var$vf(t), w--;
                            for(; 0 < u - w;)x = $db8388f9ae3d0ea5$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $db8388f9ae3d0ea5$var$vf(t);
                                x = $db8388f9ae3d0ea5$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $db8388f9ae3d0ea5$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $db8388f9ae3d0ea5$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $db8388f9ae3d0ea5$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $db8388f9ae3d0ea5$var$ve;
                else if ($db8388f9ae3d0ea5$var$me(h)) {
                    if ($db8388f9ae3d0ea5$var$we) na = $db8388f9ae3d0ea5$var$Fe;
                    else {
                        na = $db8388f9ae3d0ea5$var$De;
                        var xa = $db8388f9ae3d0ea5$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $db8388f9ae3d0ea5$var$Ee);
                if (na && (na = na(a, d))) {
                    $db8388f9ae3d0ea5$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $db8388f9ae3d0ea5$var$cb(h, "number", h.value);
            }
            xa = d ? $db8388f9ae3d0ea5$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($db8388f9ae3d0ea5$var$me(xa) || "true" === xa.contentEditable) $db8388f9ae3d0ea5$var$Qe = xa, $db8388f9ae3d0ea5$var$Re = d, $db8388f9ae3d0ea5$var$Se = null;
                    break;
                case "focusout":
                    $db8388f9ae3d0ea5$var$Se = $db8388f9ae3d0ea5$var$Re = $db8388f9ae3d0ea5$var$Qe = null;
                    break;
                case "mousedown":
                    $db8388f9ae3d0ea5$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $db8388f9ae3d0ea5$var$Te = !1;
                    $db8388f9ae3d0ea5$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($db8388f9ae3d0ea5$var$Pe) break;
                case "keydown":
                case "keyup":
                    $db8388f9ae3d0ea5$var$Ue(g, c, e);
            }
            var $a;
            if ($db8388f9ae3d0ea5$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $db8388f9ae3d0ea5$var$ie ? $db8388f9ae3d0ea5$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($db8388f9ae3d0ea5$var$de && "ko" !== c.locale && ($db8388f9ae3d0ea5$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $db8388f9ae3d0ea5$var$ie && ($a = $db8388f9ae3d0ea5$var$nd()) : ($db8388f9ae3d0ea5$var$kd = e, $db8388f9ae3d0ea5$var$ld = "value" in $db8388f9ae3d0ea5$var$kd ? $db8388f9ae3d0ea5$var$kd.value : $db8388f9ae3d0ea5$var$kd.textContent, $db8388f9ae3d0ea5$var$ie = !0)), xa = $db8388f9ae3d0ea5$var$oe(d, ba), 0 < xa.length && (ba = new $db8388f9ae3d0ea5$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $db8388f9ae3d0ea5$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $db8388f9ae3d0ea5$var$ce ? $db8388f9ae3d0ea5$var$je(a, c) : $db8388f9ae3d0ea5$var$ke(a, c)) d = $db8388f9ae3d0ea5$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $db8388f9ae3d0ea5$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $db8388f9ae3d0ea5$var$se(g, b);
    });
}
function $db8388f9ae3d0ea5$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $db8388f9ae3d0ea5$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $db8388f9ae3d0ea5$var$Kb(a, c), null != f && d.unshift($db8388f9ae3d0ea5$var$tf(a, f, e)), f = $db8388f9ae3d0ea5$var$Kb(a, b), null != f && d.push($db8388f9ae3d0ea5$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $db8388f9ae3d0ea5$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $db8388f9ae3d0ea5$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $db8388f9ae3d0ea5$var$Kb(c, f), null != k && g.unshift($db8388f9ae3d0ea5$var$tf(c, k, h))) : e || (k = $db8388f9ae3d0ea5$var$Kb(c, f), null != k && g.push($db8388f9ae3d0ea5$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $db8388f9ae3d0ea5$var$xf = /\r\n?/g, $db8388f9ae3d0ea5$var$yf = /\u0000|\uFFFD/g;
function $db8388f9ae3d0ea5$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($db8388f9ae3d0ea5$var$xf, "\n").replace($db8388f9ae3d0ea5$var$yf, "");
}
function $db8388f9ae3d0ea5$var$Af(a, b, c) {
    b = $db8388f9ae3d0ea5$var$zf(b);
    if ($db8388f9ae3d0ea5$var$zf(a) !== b && c) throw Error($db8388f9ae3d0ea5$var$p(425));
}
function $db8388f9ae3d0ea5$var$Bf() {}
var $db8388f9ae3d0ea5$var$Cf = null, $db8388f9ae3d0ea5$var$Df = null;
function $db8388f9ae3d0ea5$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $db8388f9ae3d0ea5$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $db8388f9ae3d0ea5$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $db8388f9ae3d0ea5$var$Hf = "function" === typeof Promise ? Promise : void 0, $db8388f9ae3d0ea5$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $db8388f9ae3d0ea5$var$Hf ? function(a) {
    return $db8388f9ae3d0ea5$var$Hf.resolve(null).then(a).catch($db8388f9ae3d0ea5$var$If);
} : $db8388f9ae3d0ea5$var$Ff;
function $db8388f9ae3d0ea5$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $db8388f9ae3d0ea5$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $db8388f9ae3d0ea5$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $db8388f9ae3d0ea5$var$bd(b);
}
function $db8388f9ae3d0ea5$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $db8388f9ae3d0ea5$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $db8388f9ae3d0ea5$var$Nf = Math.random().toString(36).slice(2), $db8388f9ae3d0ea5$var$Of = "__reactFiber$" + $db8388f9ae3d0ea5$var$Nf, $db8388f9ae3d0ea5$var$Pf = "__reactProps$" + $db8388f9ae3d0ea5$var$Nf, $db8388f9ae3d0ea5$var$uf = "__reactContainer$" + $db8388f9ae3d0ea5$var$Nf, $db8388f9ae3d0ea5$var$of = "__reactEvents$" + $db8388f9ae3d0ea5$var$Nf, $db8388f9ae3d0ea5$var$Qf = "__reactListeners$" + $db8388f9ae3d0ea5$var$Nf, $db8388f9ae3d0ea5$var$Rf = "__reactHandles$" + $db8388f9ae3d0ea5$var$Nf;
function $db8388f9ae3d0ea5$var$Wc(a) {
    var b = a[$db8388f9ae3d0ea5$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$db8388f9ae3d0ea5$var$uf] || c[$db8388f9ae3d0ea5$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $db8388f9ae3d0ea5$var$Mf(a); null !== a;){
                if (c = a[$db8388f9ae3d0ea5$var$Of]) return c;
                a = $db8388f9ae3d0ea5$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $db8388f9ae3d0ea5$var$Cb(a) {
    a = a[$db8388f9ae3d0ea5$var$Of] || a[$db8388f9ae3d0ea5$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $db8388f9ae3d0ea5$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($db8388f9ae3d0ea5$var$p(33));
}
function $db8388f9ae3d0ea5$var$Db(a) {
    return a[$db8388f9ae3d0ea5$var$Pf] || null;
}
var $db8388f9ae3d0ea5$var$Sf = [], $db8388f9ae3d0ea5$var$Tf = -1;
function $db8388f9ae3d0ea5$var$Uf(a) {
    return {
        current: a
    };
}
function $db8388f9ae3d0ea5$var$E(a) {
    0 > $db8388f9ae3d0ea5$var$Tf || (a.current = $db8388f9ae3d0ea5$var$Sf[$db8388f9ae3d0ea5$var$Tf], $db8388f9ae3d0ea5$var$Sf[$db8388f9ae3d0ea5$var$Tf] = null, $db8388f9ae3d0ea5$var$Tf--);
}
function $db8388f9ae3d0ea5$var$G(a, b) {
    $db8388f9ae3d0ea5$var$Tf++;
    $db8388f9ae3d0ea5$var$Sf[$db8388f9ae3d0ea5$var$Tf] = a.current;
    a.current = b;
}
var $db8388f9ae3d0ea5$var$Vf = {}, $db8388f9ae3d0ea5$var$H = $db8388f9ae3d0ea5$var$Uf($db8388f9ae3d0ea5$var$Vf), $db8388f9ae3d0ea5$var$Wf = $db8388f9ae3d0ea5$var$Uf(!1), $db8388f9ae3d0ea5$var$Xf = $db8388f9ae3d0ea5$var$Vf;
function $db8388f9ae3d0ea5$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $db8388f9ae3d0ea5$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $db8388f9ae3d0ea5$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $db8388f9ae3d0ea5$var$$f() {
    $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$Wf);
    $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$H);
}
function $db8388f9ae3d0ea5$var$ag(a, b, c) {
    if ($db8388f9ae3d0ea5$var$H.current !== $db8388f9ae3d0ea5$var$Vf) throw Error($db8388f9ae3d0ea5$var$p(168));
    $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$H, b);
    $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$Wf, c);
}
function $db8388f9ae3d0ea5$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($db8388f9ae3d0ea5$var$p(108, $db8388f9ae3d0ea5$var$Ra(a) || "Unknown", e));
    return $db8388f9ae3d0ea5$var$A({}, c, d);
}
function $db8388f9ae3d0ea5$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $db8388f9ae3d0ea5$var$Vf;
    $db8388f9ae3d0ea5$var$Xf = $db8388f9ae3d0ea5$var$H.current;
    $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$H, a);
    $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$Wf, $db8388f9ae3d0ea5$var$Wf.current);
    return !0;
}
function $db8388f9ae3d0ea5$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($db8388f9ae3d0ea5$var$p(169));
    c ? (a = $db8388f9ae3d0ea5$var$bg(a, b, $db8388f9ae3d0ea5$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$Wf), $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$H), $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$H, a)) : $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$Wf);
    $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$Wf, c);
}
var $db8388f9ae3d0ea5$var$eg = null, $db8388f9ae3d0ea5$var$fg = !1, $db8388f9ae3d0ea5$var$gg = !1;
function $db8388f9ae3d0ea5$var$hg(a) {
    null === $db8388f9ae3d0ea5$var$eg ? $db8388f9ae3d0ea5$var$eg = [
        a
    ] : $db8388f9ae3d0ea5$var$eg.push(a);
}
function $db8388f9ae3d0ea5$var$ig(a) {
    $db8388f9ae3d0ea5$var$fg = !0;
    $db8388f9ae3d0ea5$var$hg(a);
}
function $db8388f9ae3d0ea5$var$jg() {
    if (!$db8388f9ae3d0ea5$var$gg && null !== $db8388f9ae3d0ea5$var$eg) {
        $db8388f9ae3d0ea5$var$gg = !0;
        var a = 0, b = $db8388f9ae3d0ea5$var$C;
        try {
            var c = $db8388f9ae3d0ea5$var$eg;
            for($db8388f9ae3d0ea5$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $db8388f9ae3d0ea5$var$eg = null;
            $db8388f9ae3d0ea5$var$fg = !1;
        } catch (e) {
            throw null !== $db8388f9ae3d0ea5$var$eg && ($db8388f9ae3d0ea5$var$eg = $db8388f9ae3d0ea5$var$eg.slice(a + 1)), $db8388f9ae3d0ea5$var$ac($db8388f9ae3d0ea5$var$fc, $db8388f9ae3d0ea5$var$jg), e;
        } finally{
            $db8388f9ae3d0ea5$var$C = b, $db8388f9ae3d0ea5$var$gg = !1;
        }
    }
    return null;
}
var $db8388f9ae3d0ea5$var$kg = [], $db8388f9ae3d0ea5$var$lg = 0, $db8388f9ae3d0ea5$var$mg = null, $db8388f9ae3d0ea5$var$ng = 0, $db8388f9ae3d0ea5$var$og = [], $db8388f9ae3d0ea5$var$pg = 0, $db8388f9ae3d0ea5$var$qg = null, $db8388f9ae3d0ea5$var$rg = 1, $db8388f9ae3d0ea5$var$sg = "";
function $db8388f9ae3d0ea5$var$tg(a, b) {
    $db8388f9ae3d0ea5$var$kg[$db8388f9ae3d0ea5$var$lg++] = $db8388f9ae3d0ea5$var$ng;
    $db8388f9ae3d0ea5$var$kg[$db8388f9ae3d0ea5$var$lg++] = $db8388f9ae3d0ea5$var$mg;
    $db8388f9ae3d0ea5$var$mg = a;
    $db8388f9ae3d0ea5$var$ng = b;
}
function $db8388f9ae3d0ea5$var$ug(a, b, c) {
    $db8388f9ae3d0ea5$var$og[$db8388f9ae3d0ea5$var$pg++] = $db8388f9ae3d0ea5$var$rg;
    $db8388f9ae3d0ea5$var$og[$db8388f9ae3d0ea5$var$pg++] = $db8388f9ae3d0ea5$var$sg;
    $db8388f9ae3d0ea5$var$og[$db8388f9ae3d0ea5$var$pg++] = $db8388f9ae3d0ea5$var$qg;
    $db8388f9ae3d0ea5$var$qg = a;
    var d = $db8388f9ae3d0ea5$var$rg;
    a = $db8388f9ae3d0ea5$var$sg;
    var e = 32 - $db8388f9ae3d0ea5$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $db8388f9ae3d0ea5$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $db8388f9ae3d0ea5$var$rg = 1 << 32 - $db8388f9ae3d0ea5$var$oc(b) + e | c << e | d;
        $db8388f9ae3d0ea5$var$sg = f + a;
    } else $db8388f9ae3d0ea5$var$rg = 1 << f | c << e | d, $db8388f9ae3d0ea5$var$sg = a;
}
function $db8388f9ae3d0ea5$var$vg(a) {
    null !== a.return && ($db8388f9ae3d0ea5$var$tg(a, 1), $db8388f9ae3d0ea5$var$ug(a, 1, 0));
}
function $db8388f9ae3d0ea5$var$wg(a) {
    for(; a === $db8388f9ae3d0ea5$var$mg;)$db8388f9ae3d0ea5$var$mg = $db8388f9ae3d0ea5$var$kg[--$db8388f9ae3d0ea5$var$lg], $db8388f9ae3d0ea5$var$kg[$db8388f9ae3d0ea5$var$lg] = null, $db8388f9ae3d0ea5$var$ng = $db8388f9ae3d0ea5$var$kg[--$db8388f9ae3d0ea5$var$lg], $db8388f9ae3d0ea5$var$kg[$db8388f9ae3d0ea5$var$lg] = null;
    for(; a === $db8388f9ae3d0ea5$var$qg;)$db8388f9ae3d0ea5$var$qg = $db8388f9ae3d0ea5$var$og[--$db8388f9ae3d0ea5$var$pg], $db8388f9ae3d0ea5$var$og[$db8388f9ae3d0ea5$var$pg] = null, $db8388f9ae3d0ea5$var$sg = $db8388f9ae3d0ea5$var$og[--$db8388f9ae3d0ea5$var$pg], $db8388f9ae3d0ea5$var$og[$db8388f9ae3d0ea5$var$pg] = null, $db8388f9ae3d0ea5$var$rg = $db8388f9ae3d0ea5$var$og[--$db8388f9ae3d0ea5$var$pg], $db8388f9ae3d0ea5$var$og[$db8388f9ae3d0ea5$var$pg] = null;
}
var $db8388f9ae3d0ea5$var$xg = null, $db8388f9ae3d0ea5$var$yg = null, $db8388f9ae3d0ea5$var$I = !1, $db8388f9ae3d0ea5$var$zg = null;
function $db8388f9ae3d0ea5$var$Ag(a, b) {
    var c = $db8388f9ae3d0ea5$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $db8388f9ae3d0ea5$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $db8388f9ae3d0ea5$var$xg = a, $db8388f9ae3d0ea5$var$yg = $db8388f9ae3d0ea5$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $db8388f9ae3d0ea5$var$xg = a, $db8388f9ae3d0ea5$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $db8388f9ae3d0ea5$var$qg ? {
                id: $db8388f9ae3d0ea5$var$rg,
                overflow: $db8388f9ae3d0ea5$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $db8388f9ae3d0ea5$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $db8388f9ae3d0ea5$var$xg = a, $db8388f9ae3d0ea5$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $db8388f9ae3d0ea5$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $db8388f9ae3d0ea5$var$Eg(a) {
    if ($db8388f9ae3d0ea5$var$I) {
        var b = $db8388f9ae3d0ea5$var$yg;
        if (b) {
            var c = b;
            if (!$db8388f9ae3d0ea5$var$Cg(a, b)) {
                if ($db8388f9ae3d0ea5$var$Dg(a)) throw Error($db8388f9ae3d0ea5$var$p(418));
                b = $db8388f9ae3d0ea5$var$Lf(c.nextSibling);
                var d = $db8388f9ae3d0ea5$var$xg;
                b && $db8388f9ae3d0ea5$var$Cg(a, b) ? $db8388f9ae3d0ea5$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $db8388f9ae3d0ea5$var$I = !1, $db8388f9ae3d0ea5$var$xg = a);
            }
        } else {
            if ($db8388f9ae3d0ea5$var$Dg(a)) throw Error($db8388f9ae3d0ea5$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $db8388f9ae3d0ea5$var$I = !1;
            $db8388f9ae3d0ea5$var$xg = a;
        }
    }
}
function $db8388f9ae3d0ea5$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $db8388f9ae3d0ea5$var$xg = a;
}
function $db8388f9ae3d0ea5$var$Gg(a) {
    if (a !== $db8388f9ae3d0ea5$var$xg) return !1;
    if (!$db8388f9ae3d0ea5$var$I) return $db8388f9ae3d0ea5$var$Fg(a), $db8388f9ae3d0ea5$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$db8388f9ae3d0ea5$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $db8388f9ae3d0ea5$var$yg)) {
        if ($db8388f9ae3d0ea5$var$Dg(a)) throw $db8388f9ae3d0ea5$var$Hg(), Error($db8388f9ae3d0ea5$var$p(418));
        for(; b;)$db8388f9ae3d0ea5$var$Ag(a, b), b = $db8388f9ae3d0ea5$var$Lf(b.nextSibling);
    }
    $db8388f9ae3d0ea5$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($db8388f9ae3d0ea5$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $db8388f9ae3d0ea5$var$yg = $db8388f9ae3d0ea5$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $db8388f9ae3d0ea5$var$yg = null;
        }
    } else $db8388f9ae3d0ea5$var$yg = $db8388f9ae3d0ea5$var$xg ? $db8388f9ae3d0ea5$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $db8388f9ae3d0ea5$var$Hg() {
    for(var a = $db8388f9ae3d0ea5$var$yg; a;)a = $db8388f9ae3d0ea5$var$Lf(a.nextSibling);
}
function $db8388f9ae3d0ea5$var$Ig() {
    $db8388f9ae3d0ea5$var$yg = $db8388f9ae3d0ea5$var$xg = null;
    $db8388f9ae3d0ea5$var$I = !1;
}
function $db8388f9ae3d0ea5$var$Jg(a) {
    null === $db8388f9ae3d0ea5$var$zg ? $db8388f9ae3d0ea5$var$zg = [
        a
    ] : $db8388f9ae3d0ea5$var$zg.push(a);
}
var $db8388f9ae3d0ea5$var$Kg = $db8388f9ae3d0ea5$var$ua.ReactCurrentBatchConfig;
function $db8388f9ae3d0ea5$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $db8388f9ae3d0ea5$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $db8388f9ae3d0ea5$var$Mg = $db8388f9ae3d0ea5$var$Uf(null), $db8388f9ae3d0ea5$var$Ng = null, $db8388f9ae3d0ea5$var$Og = null, $db8388f9ae3d0ea5$var$Pg = null;
function $db8388f9ae3d0ea5$var$Qg() {
    $db8388f9ae3d0ea5$var$Pg = $db8388f9ae3d0ea5$var$Og = $db8388f9ae3d0ea5$var$Ng = null;
}
function $db8388f9ae3d0ea5$var$Rg(a) {
    var b = $db8388f9ae3d0ea5$var$Mg.current;
    $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$Mg);
    a._currentValue = b;
}
function $db8388f9ae3d0ea5$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $db8388f9ae3d0ea5$var$Tg(a, b) {
    $db8388f9ae3d0ea5$var$Ng = a;
    $db8388f9ae3d0ea5$var$Pg = $db8388f9ae3d0ea5$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($db8388f9ae3d0ea5$var$Ug = !0), a.firstContext = null);
}
function $db8388f9ae3d0ea5$var$Vg(a) {
    var b = a._currentValue;
    if ($db8388f9ae3d0ea5$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $db8388f9ae3d0ea5$var$Og) {
            if (null === $db8388f9ae3d0ea5$var$Ng) throw Error($db8388f9ae3d0ea5$var$p(308));
            $db8388f9ae3d0ea5$var$Og = a;
            $db8388f9ae3d0ea5$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $db8388f9ae3d0ea5$var$Og = $db8388f9ae3d0ea5$var$Og.next = a;
    }
    return b;
}
var $db8388f9ae3d0ea5$var$Wg = null;
function $db8388f9ae3d0ea5$var$Xg(a) {
    null === $db8388f9ae3d0ea5$var$Wg ? $db8388f9ae3d0ea5$var$Wg = [
        a
    ] : $db8388f9ae3d0ea5$var$Wg.push(a);
}
function $db8388f9ae3d0ea5$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $db8388f9ae3d0ea5$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $db8388f9ae3d0ea5$var$Zg(a, d);
}
function $db8388f9ae3d0ea5$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $db8388f9ae3d0ea5$var$$g = !1;
function $db8388f9ae3d0ea5$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $db8388f9ae3d0ea5$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $db8388f9ae3d0ea5$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $db8388f9ae3d0ea5$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($db8388f9ae3d0ea5$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $db8388f9ae3d0ea5$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $db8388f9ae3d0ea5$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $db8388f9ae3d0ea5$var$Zg(a, c);
}
function $db8388f9ae3d0ea5$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $db8388f9ae3d0ea5$var$Cc(a, c);
    }
}
function $db8388f9ae3d0ea5$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $db8388f9ae3d0ea5$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $db8388f9ae3d0ea5$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $db8388f9ae3d0ea5$var$A({}, q, r);
                            break a;
                        case 2:
                            $db8388f9ae3d0ea5$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $db8388f9ae3d0ea5$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $db8388f9ae3d0ea5$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($db8388f9ae3d0ea5$var$p(191, e));
            e.call(d);
        }
    }
}
var $db8388f9ae3d0ea5$var$jh = (new $6uYXW.Component).refs;
function $db8388f9ae3d0ea5$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $db8388f9ae3d0ea5$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $db8388f9ae3d0ea5$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $db8388f9ae3d0ea5$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $db8388f9ae3d0ea5$var$L(), e = $db8388f9ae3d0ea5$var$lh(a), f = $db8388f9ae3d0ea5$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $db8388f9ae3d0ea5$var$dh(a, f, e);
        null !== b && ($db8388f9ae3d0ea5$var$mh(b, a, e, d), $db8388f9ae3d0ea5$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $db8388f9ae3d0ea5$var$L(), e = $db8388f9ae3d0ea5$var$lh(a), f = $db8388f9ae3d0ea5$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $db8388f9ae3d0ea5$var$dh(a, f, e);
        null !== b && ($db8388f9ae3d0ea5$var$mh(b, a, e, d), $db8388f9ae3d0ea5$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $db8388f9ae3d0ea5$var$L(), d = $db8388f9ae3d0ea5$var$lh(a), e = $db8388f9ae3d0ea5$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $db8388f9ae3d0ea5$var$dh(a, e, d);
        null !== b && ($db8388f9ae3d0ea5$var$mh(b, a, d, c), $db8388f9ae3d0ea5$var$eh(b, a, d));
    }
};
function $db8388f9ae3d0ea5$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$db8388f9ae3d0ea5$var$Ie(c, d) || !$db8388f9ae3d0ea5$var$Ie(e, f) : !0;
}
function $db8388f9ae3d0ea5$var$ph(a, b, c) {
    var d = !1, e = $db8388f9ae3d0ea5$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $db8388f9ae3d0ea5$var$Vg(f) : (e = $db8388f9ae3d0ea5$var$Zf(b) ? $db8388f9ae3d0ea5$var$Xf : $db8388f9ae3d0ea5$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $db8388f9ae3d0ea5$var$Yf(a, e) : $db8388f9ae3d0ea5$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $db8388f9ae3d0ea5$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $db8388f9ae3d0ea5$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $db8388f9ae3d0ea5$var$nh.enqueueReplaceState(b, b.state, null);
}
function $db8388f9ae3d0ea5$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $db8388f9ae3d0ea5$var$jh;
    $db8388f9ae3d0ea5$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $db8388f9ae3d0ea5$var$Vg(f) : (f = $db8388f9ae3d0ea5$var$Zf(b) ? $db8388f9ae3d0ea5$var$Xf : $db8388f9ae3d0ea5$var$H.current, e.context = $db8388f9ae3d0ea5$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($db8388f9ae3d0ea5$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $db8388f9ae3d0ea5$var$nh.enqueueReplaceState(e, e.state, null), $db8388f9ae3d0ea5$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $db8388f9ae3d0ea5$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($db8388f9ae3d0ea5$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($db8388f9ae3d0ea5$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $db8388f9ae3d0ea5$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($db8388f9ae3d0ea5$var$p(284));
        if (!c._owner) throw Error($db8388f9ae3d0ea5$var$p(290, a));
    }
    return a;
}
function $db8388f9ae3d0ea5$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($db8388f9ae3d0ea5$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $db8388f9ae3d0ea5$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $db8388f9ae3d0ea5$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $db8388f9ae3d0ea5$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $db8388f9ae3d0ea5$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $db8388f9ae3d0ea5$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $db8388f9ae3d0ea5$var$Ha && $db8388f9ae3d0ea5$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $db8388f9ae3d0ea5$var$sh(a, b, c), d.return = a, d;
        d = $db8388f9ae3d0ea5$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $db8388f9ae3d0ea5$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $db8388f9ae3d0ea5$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $db8388f9ae3d0ea5$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $db8388f9ae3d0ea5$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $db8388f9ae3d0ea5$var$va:
                    return c = $db8388f9ae3d0ea5$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $db8388f9ae3d0ea5$var$sh(a, null, b), c.return = a, c;
                case $db8388f9ae3d0ea5$var$wa:
                    return b = $db8388f9ae3d0ea5$var$zh(b, a.mode, c), b.return = a, b;
                case $db8388f9ae3d0ea5$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($db8388f9ae3d0ea5$var$eb(b) || $db8388f9ae3d0ea5$var$Ka(b)) return b = $db8388f9ae3d0ea5$var$Ah(b, a.mode, c, null), b.return = a, b;
            $db8388f9ae3d0ea5$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $db8388f9ae3d0ea5$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $db8388f9ae3d0ea5$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $db8388f9ae3d0ea5$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($db8388f9ae3d0ea5$var$eb(c) || $db8388f9ae3d0ea5$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $db8388f9ae3d0ea5$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $db8388f9ae3d0ea5$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $db8388f9ae3d0ea5$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $db8388f9ae3d0ea5$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($db8388f9ae3d0ea5$var$eb(d) || $db8388f9ae3d0ea5$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $db8388f9ae3d0ea5$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $db8388f9ae3d0ea5$var$I && $db8388f9ae3d0ea5$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $db8388f9ae3d0ea5$var$I && $db8388f9ae3d0ea5$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $db8388f9ae3d0ea5$var$I && $db8388f9ae3d0ea5$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $db8388f9ae3d0ea5$var$Ka(h);
        if ("function" !== typeof l) throw Error($db8388f9ae3d0ea5$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($db8388f9ae3d0ea5$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $db8388f9ae3d0ea5$var$I && $db8388f9ae3d0ea5$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $db8388f9ae3d0ea5$var$I && $db8388f9ae3d0ea5$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $db8388f9ae3d0ea5$var$I && $db8388f9ae3d0ea5$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $db8388f9ae3d0ea5$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $db8388f9ae3d0ea5$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $db8388f9ae3d0ea5$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $db8388f9ae3d0ea5$var$Ha && $db8388f9ae3d0ea5$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $db8388f9ae3d0ea5$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $db8388f9ae3d0ea5$var$ya ? (d = $db8388f9ae3d0ea5$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $db8388f9ae3d0ea5$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $db8388f9ae3d0ea5$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $db8388f9ae3d0ea5$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $db8388f9ae3d0ea5$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $db8388f9ae3d0ea5$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($db8388f9ae3d0ea5$var$eb(f)) return n(a, d, f, h);
            if ($db8388f9ae3d0ea5$var$Ka(f)) return t(a, d, f, h);
            $db8388f9ae3d0ea5$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $db8388f9ae3d0ea5$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $db8388f9ae3d0ea5$var$Bh = $db8388f9ae3d0ea5$var$vh(!0), $db8388f9ae3d0ea5$var$Ch = $db8388f9ae3d0ea5$var$vh(!1), $db8388f9ae3d0ea5$var$Dh = {}, $db8388f9ae3d0ea5$var$Eh = $db8388f9ae3d0ea5$var$Uf($db8388f9ae3d0ea5$var$Dh), $db8388f9ae3d0ea5$var$Fh = $db8388f9ae3d0ea5$var$Uf($db8388f9ae3d0ea5$var$Dh), $db8388f9ae3d0ea5$var$Gh = $db8388f9ae3d0ea5$var$Uf($db8388f9ae3d0ea5$var$Dh);
function $db8388f9ae3d0ea5$var$Hh(a) {
    if (a === $db8388f9ae3d0ea5$var$Dh) throw Error($db8388f9ae3d0ea5$var$p(174));
    return a;
}
function $db8388f9ae3d0ea5$var$Ih(a, b) {
    $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$Gh, b);
    $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$Fh, a);
    $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$Eh, $db8388f9ae3d0ea5$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $db8388f9ae3d0ea5$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $db8388f9ae3d0ea5$var$lb(b, a);
    }
    $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$Eh);
    $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$Eh, b);
}
function $db8388f9ae3d0ea5$var$Jh() {
    $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$Eh);
    $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$Fh);
    $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$Gh);
}
function $db8388f9ae3d0ea5$var$Kh(a) {
    $db8388f9ae3d0ea5$var$Hh($db8388f9ae3d0ea5$var$Gh.current);
    var b = $db8388f9ae3d0ea5$var$Hh($db8388f9ae3d0ea5$var$Eh.current);
    var c = $db8388f9ae3d0ea5$var$lb(b, a.type);
    b !== c && ($db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$Fh, a), $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$Eh, c));
}
function $db8388f9ae3d0ea5$var$Lh(a) {
    $db8388f9ae3d0ea5$var$Fh.current === a && ($db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$Eh), $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$Fh));
}
var $db8388f9ae3d0ea5$var$M = $db8388f9ae3d0ea5$var$Uf(0);
function $db8388f9ae3d0ea5$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $db8388f9ae3d0ea5$var$Nh = [];
function $db8388f9ae3d0ea5$var$Oh() {
    for(var a = 0; a < $db8388f9ae3d0ea5$var$Nh.length; a++)$db8388f9ae3d0ea5$var$Nh[a]._workInProgressVersionPrimary = null;
    $db8388f9ae3d0ea5$var$Nh.length = 0;
}
var $db8388f9ae3d0ea5$var$Ph = $db8388f9ae3d0ea5$var$ua.ReactCurrentDispatcher, $db8388f9ae3d0ea5$var$Qh = $db8388f9ae3d0ea5$var$ua.ReactCurrentBatchConfig, $db8388f9ae3d0ea5$var$Rh = 0, $db8388f9ae3d0ea5$var$N = null, $db8388f9ae3d0ea5$var$O = null, $db8388f9ae3d0ea5$var$P = null, $db8388f9ae3d0ea5$var$Sh = !1, $db8388f9ae3d0ea5$var$Th = !1, $db8388f9ae3d0ea5$var$Uh = 0, $db8388f9ae3d0ea5$var$Vh = 0;
function $db8388f9ae3d0ea5$var$Q() {
    throw Error($db8388f9ae3d0ea5$var$p(321));
}
function $db8388f9ae3d0ea5$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$db8388f9ae3d0ea5$var$He(a[c], b[c])) return !1;
    return !0;
}
function $db8388f9ae3d0ea5$var$Xh(a, b, c, d, e, f) {
    $db8388f9ae3d0ea5$var$Rh = f;
    $db8388f9ae3d0ea5$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $db8388f9ae3d0ea5$var$Ph.current = null === a || null === a.memoizedState ? $db8388f9ae3d0ea5$var$Yh : $db8388f9ae3d0ea5$var$Zh;
    a = c(d, e);
    if ($db8388f9ae3d0ea5$var$Th) {
        f = 0;
        do {
            $db8388f9ae3d0ea5$var$Th = !1;
            $db8388f9ae3d0ea5$var$Uh = 0;
            if (25 <= f) throw Error($db8388f9ae3d0ea5$var$p(301));
            f += 1;
            $db8388f9ae3d0ea5$var$P = $db8388f9ae3d0ea5$var$O = null;
            b.updateQueue = null;
            $db8388f9ae3d0ea5$var$Ph.current = $db8388f9ae3d0ea5$var$$h;
            a = c(d, e);
        }while ($db8388f9ae3d0ea5$var$Th);
    }
    $db8388f9ae3d0ea5$var$Ph.current = $db8388f9ae3d0ea5$var$ai;
    b = null !== $db8388f9ae3d0ea5$var$O && null !== $db8388f9ae3d0ea5$var$O.next;
    $db8388f9ae3d0ea5$var$Rh = 0;
    $db8388f9ae3d0ea5$var$P = $db8388f9ae3d0ea5$var$O = $db8388f9ae3d0ea5$var$N = null;
    $db8388f9ae3d0ea5$var$Sh = !1;
    if (b) throw Error($db8388f9ae3d0ea5$var$p(300));
    return a;
}
function $db8388f9ae3d0ea5$var$bi() {
    var a = 0 !== $db8388f9ae3d0ea5$var$Uh;
    $db8388f9ae3d0ea5$var$Uh = 0;
    return a;
}
function $db8388f9ae3d0ea5$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $db8388f9ae3d0ea5$var$P ? $db8388f9ae3d0ea5$var$N.memoizedState = $db8388f9ae3d0ea5$var$P = a : $db8388f9ae3d0ea5$var$P = $db8388f9ae3d0ea5$var$P.next = a;
    return $db8388f9ae3d0ea5$var$P;
}
function $db8388f9ae3d0ea5$var$di() {
    if (null === $db8388f9ae3d0ea5$var$O) {
        var a = $db8388f9ae3d0ea5$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $db8388f9ae3d0ea5$var$O.next;
    var b = null === $db8388f9ae3d0ea5$var$P ? $db8388f9ae3d0ea5$var$N.memoizedState : $db8388f9ae3d0ea5$var$P.next;
    if (null !== b) $db8388f9ae3d0ea5$var$P = b, $db8388f9ae3d0ea5$var$O = a;
    else {
        if (null === a) throw Error($db8388f9ae3d0ea5$var$p(310));
        $db8388f9ae3d0ea5$var$O = a;
        a = {
            memoizedState: $db8388f9ae3d0ea5$var$O.memoizedState,
            baseState: $db8388f9ae3d0ea5$var$O.baseState,
            baseQueue: $db8388f9ae3d0ea5$var$O.baseQueue,
            queue: $db8388f9ae3d0ea5$var$O.queue,
            next: null
        };
        null === $db8388f9ae3d0ea5$var$P ? $db8388f9ae3d0ea5$var$N.memoizedState = $db8388f9ae3d0ea5$var$P = a : $db8388f9ae3d0ea5$var$P = $db8388f9ae3d0ea5$var$P.next = a;
    }
    return $db8388f9ae3d0ea5$var$P;
}
function $db8388f9ae3d0ea5$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $db8388f9ae3d0ea5$var$fi(a) {
    var b = $db8388f9ae3d0ea5$var$di(), c = b.queue;
    if (null === c) throw Error($db8388f9ae3d0ea5$var$p(311));
    c.lastRenderedReducer = a;
    var d = $db8388f9ae3d0ea5$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($db8388f9ae3d0ea5$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $db8388f9ae3d0ea5$var$N.lanes |= m;
                $db8388f9ae3d0ea5$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $db8388f9ae3d0ea5$var$He(d, b.memoizedState) || ($db8388f9ae3d0ea5$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $db8388f9ae3d0ea5$var$N.lanes |= f, $db8388f9ae3d0ea5$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $db8388f9ae3d0ea5$var$gi(a) {
    var b = $db8388f9ae3d0ea5$var$di(), c = b.queue;
    if (null === c) throw Error($db8388f9ae3d0ea5$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $db8388f9ae3d0ea5$var$He(f, b.memoizedState) || ($db8388f9ae3d0ea5$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $db8388f9ae3d0ea5$var$hi() {}
function $db8388f9ae3d0ea5$var$ii(a, b) {
    var c = $db8388f9ae3d0ea5$var$N, d = $db8388f9ae3d0ea5$var$di(), e = b(), f = !$db8388f9ae3d0ea5$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $db8388f9ae3d0ea5$var$Ug = !0);
    d = d.queue;
    $db8388f9ae3d0ea5$var$ji($db8388f9ae3d0ea5$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $db8388f9ae3d0ea5$var$P && $db8388f9ae3d0ea5$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $db8388f9ae3d0ea5$var$li(9, $db8388f9ae3d0ea5$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $db8388f9ae3d0ea5$var$R) throw Error($db8388f9ae3d0ea5$var$p(349));
        0 !== ($db8388f9ae3d0ea5$var$Rh & 30) || $db8388f9ae3d0ea5$var$ni(c, b, e);
    }
    return e;
}
function $db8388f9ae3d0ea5$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $db8388f9ae3d0ea5$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $db8388f9ae3d0ea5$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $db8388f9ae3d0ea5$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $db8388f9ae3d0ea5$var$oi(b) && $db8388f9ae3d0ea5$var$pi(a);
}
function $db8388f9ae3d0ea5$var$ki(a, b, c) {
    return c(function() {
        $db8388f9ae3d0ea5$var$oi(b) && $db8388f9ae3d0ea5$var$pi(a);
    });
}
function $db8388f9ae3d0ea5$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$db8388f9ae3d0ea5$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $db8388f9ae3d0ea5$var$pi(a) {
    var b = $db8388f9ae3d0ea5$var$Zg(a, 1);
    null !== b && $db8388f9ae3d0ea5$var$mh(b, a, 1, -1);
}
function $db8388f9ae3d0ea5$var$qi(a) {
    var b = $db8388f9ae3d0ea5$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $db8388f9ae3d0ea5$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $db8388f9ae3d0ea5$var$ri.bind(null, $db8388f9ae3d0ea5$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $db8388f9ae3d0ea5$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $db8388f9ae3d0ea5$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $db8388f9ae3d0ea5$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $db8388f9ae3d0ea5$var$si() {
    return $db8388f9ae3d0ea5$var$di().memoizedState;
}
function $db8388f9ae3d0ea5$var$ti(a, b, c, d) {
    var e = $db8388f9ae3d0ea5$var$ci();
    $db8388f9ae3d0ea5$var$N.flags |= a;
    e.memoizedState = $db8388f9ae3d0ea5$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $db8388f9ae3d0ea5$var$ui(a, b, c, d) {
    var e = $db8388f9ae3d0ea5$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $db8388f9ae3d0ea5$var$O) {
        var g = $db8388f9ae3d0ea5$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $db8388f9ae3d0ea5$var$Wh(d, g.deps)) {
            e.memoizedState = $db8388f9ae3d0ea5$var$li(b, c, f, d);
            return;
        }
    }
    $db8388f9ae3d0ea5$var$N.flags |= a;
    e.memoizedState = $db8388f9ae3d0ea5$var$li(1 | b, c, f, d);
}
function $db8388f9ae3d0ea5$var$vi(a, b) {
    return $db8388f9ae3d0ea5$var$ti(8390656, 8, a, b);
}
function $db8388f9ae3d0ea5$var$ji(a, b) {
    return $db8388f9ae3d0ea5$var$ui(2048, 8, a, b);
}
function $db8388f9ae3d0ea5$var$wi(a, b) {
    return $db8388f9ae3d0ea5$var$ui(4, 2, a, b);
}
function $db8388f9ae3d0ea5$var$xi(a, b) {
    return $db8388f9ae3d0ea5$var$ui(4, 4, a, b);
}
function $db8388f9ae3d0ea5$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $db8388f9ae3d0ea5$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $db8388f9ae3d0ea5$var$ui(4, 4, $db8388f9ae3d0ea5$var$yi.bind(null, b, a), c);
}
function $db8388f9ae3d0ea5$var$Ai() {}
function $db8388f9ae3d0ea5$var$Bi(a, b) {
    var c = $db8388f9ae3d0ea5$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $db8388f9ae3d0ea5$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $db8388f9ae3d0ea5$var$Ci(a, b) {
    var c = $db8388f9ae3d0ea5$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $db8388f9ae3d0ea5$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $db8388f9ae3d0ea5$var$Di(a, b, c) {
    if (0 === ($db8388f9ae3d0ea5$var$Rh & 21)) return a.baseState && (a.baseState = !1, $db8388f9ae3d0ea5$var$Ug = !0), a.memoizedState = c;
    $db8388f9ae3d0ea5$var$He(c, b) || (c = $db8388f9ae3d0ea5$var$yc(), $db8388f9ae3d0ea5$var$N.lanes |= c, $db8388f9ae3d0ea5$var$hh |= c, a.baseState = !0);
    return b;
}
function $db8388f9ae3d0ea5$var$Ei(a, b) {
    var c = $db8388f9ae3d0ea5$var$C;
    $db8388f9ae3d0ea5$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $db8388f9ae3d0ea5$var$Qh.transition;
    $db8388f9ae3d0ea5$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $db8388f9ae3d0ea5$var$C = c, $db8388f9ae3d0ea5$var$Qh.transition = d;
    }
}
function $db8388f9ae3d0ea5$var$Fi() {
    return $db8388f9ae3d0ea5$var$di().memoizedState;
}
function $db8388f9ae3d0ea5$var$Gi(a, b, c) {
    var d = $db8388f9ae3d0ea5$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($db8388f9ae3d0ea5$var$Hi(a)) $db8388f9ae3d0ea5$var$Ii(b, c);
    else if (c = $db8388f9ae3d0ea5$var$Yg(a, b, c, d), null !== c) {
        var e = $db8388f9ae3d0ea5$var$L();
        $db8388f9ae3d0ea5$var$mh(c, a, d, e);
        $db8388f9ae3d0ea5$var$Ji(c, b, d);
    }
}
function $db8388f9ae3d0ea5$var$ri(a, b, c) {
    var d = $db8388f9ae3d0ea5$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($db8388f9ae3d0ea5$var$Hi(a)) $db8388f9ae3d0ea5$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($db8388f9ae3d0ea5$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $db8388f9ae3d0ea5$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $db8388f9ae3d0ea5$var$Yg(a, b, e, d);
        null !== c && (e = $db8388f9ae3d0ea5$var$L(), $db8388f9ae3d0ea5$var$mh(c, a, d, e), $db8388f9ae3d0ea5$var$Ji(c, b, d));
    }
}
function $db8388f9ae3d0ea5$var$Hi(a) {
    var b = a.alternate;
    return a === $db8388f9ae3d0ea5$var$N || null !== b && b === $db8388f9ae3d0ea5$var$N;
}
function $db8388f9ae3d0ea5$var$Ii(a, b) {
    $db8388f9ae3d0ea5$var$Th = $db8388f9ae3d0ea5$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $db8388f9ae3d0ea5$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $db8388f9ae3d0ea5$var$Cc(a, c);
    }
}
var $db8388f9ae3d0ea5$var$ai = {
    readContext: $db8388f9ae3d0ea5$var$Vg,
    useCallback: $db8388f9ae3d0ea5$var$Q,
    useContext: $db8388f9ae3d0ea5$var$Q,
    useEffect: $db8388f9ae3d0ea5$var$Q,
    useImperativeHandle: $db8388f9ae3d0ea5$var$Q,
    useInsertionEffect: $db8388f9ae3d0ea5$var$Q,
    useLayoutEffect: $db8388f9ae3d0ea5$var$Q,
    useMemo: $db8388f9ae3d0ea5$var$Q,
    useReducer: $db8388f9ae3d0ea5$var$Q,
    useRef: $db8388f9ae3d0ea5$var$Q,
    useState: $db8388f9ae3d0ea5$var$Q,
    useDebugValue: $db8388f9ae3d0ea5$var$Q,
    useDeferredValue: $db8388f9ae3d0ea5$var$Q,
    useTransition: $db8388f9ae3d0ea5$var$Q,
    useMutableSource: $db8388f9ae3d0ea5$var$Q,
    useSyncExternalStore: $db8388f9ae3d0ea5$var$Q,
    useId: $db8388f9ae3d0ea5$var$Q,
    unstable_isNewReconciler: !1
}, $db8388f9ae3d0ea5$var$Yh = {
    readContext: $db8388f9ae3d0ea5$var$Vg,
    useCallback: function(a, b) {
        $db8388f9ae3d0ea5$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $db8388f9ae3d0ea5$var$Vg,
    useEffect: $db8388f9ae3d0ea5$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $db8388f9ae3d0ea5$var$ti(4194308, 4, $db8388f9ae3d0ea5$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $db8388f9ae3d0ea5$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $db8388f9ae3d0ea5$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $db8388f9ae3d0ea5$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $db8388f9ae3d0ea5$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $db8388f9ae3d0ea5$var$Gi.bind(null, $db8388f9ae3d0ea5$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $db8388f9ae3d0ea5$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $db8388f9ae3d0ea5$var$qi,
    useDebugValue: $db8388f9ae3d0ea5$var$Ai,
    useDeferredValue: function(a) {
        return $db8388f9ae3d0ea5$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $db8388f9ae3d0ea5$var$qi(!1), b = a[0];
        a = $db8388f9ae3d0ea5$var$Ei.bind(null, a[1]);
        $db8388f9ae3d0ea5$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $db8388f9ae3d0ea5$var$N, e = $db8388f9ae3d0ea5$var$ci();
        if ($db8388f9ae3d0ea5$var$I) {
            if (void 0 === c) throw Error($db8388f9ae3d0ea5$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $db8388f9ae3d0ea5$var$R) throw Error($db8388f9ae3d0ea5$var$p(349));
            0 !== ($db8388f9ae3d0ea5$var$Rh & 30) || $db8388f9ae3d0ea5$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $db8388f9ae3d0ea5$var$vi($db8388f9ae3d0ea5$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $db8388f9ae3d0ea5$var$li(9, $db8388f9ae3d0ea5$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $db8388f9ae3d0ea5$var$ci(), b = $db8388f9ae3d0ea5$var$R.identifierPrefix;
        if ($db8388f9ae3d0ea5$var$I) {
            var c = $db8388f9ae3d0ea5$var$sg;
            var d = $db8388f9ae3d0ea5$var$rg;
            c = (d & ~(1 << 32 - $db8388f9ae3d0ea5$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $db8388f9ae3d0ea5$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $db8388f9ae3d0ea5$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $db8388f9ae3d0ea5$var$Zh = {
    readContext: $db8388f9ae3d0ea5$var$Vg,
    useCallback: $db8388f9ae3d0ea5$var$Bi,
    useContext: $db8388f9ae3d0ea5$var$Vg,
    useEffect: $db8388f9ae3d0ea5$var$ji,
    useImperativeHandle: $db8388f9ae3d0ea5$var$zi,
    useInsertionEffect: $db8388f9ae3d0ea5$var$wi,
    useLayoutEffect: $db8388f9ae3d0ea5$var$xi,
    useMemo: $db8388f9ae3d0ea5$var$Ci,
    useReducer: $db8388f9ae3d0ea5$var$fi,
    useRef: $db8388f9ae3d0ea5$var$si,
    useState: function() {
        return $db8388f9ae3d0ea5$var$fi($db8388f9ae3d0ea5$var$ei);
    },
    useDebugValue: $db8388f9ae3d0ea5$var$Ai,
    useDeferredValue: function(a) {
        var b = $db8388f9ae3d0ea5$var$di();
        return $db8388f9ae3d0ea5$var$Di(b, $db8388f9ae3d0ea5$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $db8388f9ae3d0ea5$var$fi($db8388f9ae3d0ea5$var$ei)[0], b = $db8388f9ae3d0ea5$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $db8388f9ae3d0ea5$var$hi,
    useSyncExternalStore: $db8388f9ae3d0ea5$var$ii,
    useId: $db8388f9ae3d0ea5$var$Fi,
    unstable_isNewReconciler: !1
}, $db8388f9ae3d0ea5$var$$h = {
    readContext: $db8388f9ae3d0ea5$var$Vg,
    useCallback: $db8388f9ae3d0ea5$var$Bi,
    useContext: $db8388f9ae3d0ea5$var$Vg,
    useEffect: $db8388f9ae3d0ea5$var$ji,
    useImperativeHandle: $db8388f9ae3d0ea5$var$zi,
    useInsertionEffect: $db8388f9ae3d0ea5$var$wi,
    useLayoutEffect: $db8388f9ae3d0ea5$var$xi,
    useMemo: $db8388f9ae3d0ea5$var$Ci,
    useReducer: $db8388f9ae3d0ea5$var$gi,
    useRef: $db8388f9ae3d0ea5$var$si,
    useState: function() {
        return $db8388f9ae3d0ea5$var$gi($db8388f9ae3d0ea5$var$ei);
    },
    useDebugValue: $db8388f9ae3d0ea5$var$Ai,
    useDeferredValue: function(a) {
        var b = $db8388f9ae3d0ea5$var$di();
        return null === $db8388f9ae3d0ea5$var$O ? b.memoizedState = a : $db8388f9ae3d0ea5$var$Di(b, $db8388f9ae3d0ea5$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $db8388f9ae3d0ea5$var$gi($db8388f9ae3d0ea5$var$ei)[0], b = $db8388f9ae3d0ea5$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $db8388f9ae3d0ea5$var$hi,
    useSyncExternalStore: $db8388f9ae3d0ea5$var$ii,
    useId: $db8388f9ae3d0ea5$var$Fi,
    unstable_isNewReconciler: !1
};
function $db8388f9ae3d0ea5$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $db8388f9ae3d0ea5$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $db8388f9ae3d0ea5$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $db8388f9ae3d0ea5$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $db8388f9ae3d0ea5$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $db8388f9ae3d0ea5$var$Oi(a, b, c) {
    c = $db8388f9ae3d0ea5$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $db8388f9ae3d0ea5$var$Pi || ($db8388f9ae3d0ea5$var$Pi = !0, $db8388f9ae3d0ea5$var$Qi = d);
        $db8388f9ae3d0ea5$var$Mi(a, b);
    };
    return c;
}
function $db8388f9ae3d0ea5$var$Ri(a, b, c) {
    c = $db8388f9ae3d0ea5$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $db8388f9ae3d0ea5$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $db8388f9ae3d0ea5$var$Mi(a, b);
        "function" !== typeof d && (null === $db8388f9ae3d0ea5$var$Si ? $db8388f9ae3d0ea5$var$Si = new Set([
            this
        ]) : $db8388f9ae3d0ea5$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $db8388f9ae3d0ea5$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $db8388f9ae3d0ea5$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $db8388f9ae3d0ea5$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $db8388f9ae3d0ea5$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $db8388f9ae3d0ea5$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $db8388f9ae3d0ea5$var$ch(-1, 1), b.tag = 2, $db8388f9ae3d0ea5$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $db8388f9ae3d0ea5$var$Xi = $db8388f9ae3d0ea5$var$ua.ReactCurrentOwner, $db8388f9ae3d0ea5$var$Ug = !1;
function $db8388f9ae3d0ea5$var$Yi(a, b, c, d) {
    b.child = null === a ? $db8388f9ae3d0ea5$var$Ch(b, null, c, d) : $db8388f9ae3d0ea5$var$Bh(b, a.child, c, d);
}
function $db8388f9ae3d0ea5$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $db8388f9ae3d0ea5$var$Tg(b, e);
    d = $db8388f9ae3d0ea5$var$Xh(a, b, c, d, f, e);
    c = $db8388f9ae3d0ea5$var$bi();
    if (null !== a && !$db8388f9ae3d0ea5$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $db8388f9ae3d0ea5$var$$i(a, b, e);
    $db8388f9ae3d0ea5$var$I && c && $db8388f9ae3d0ea5$var$vg(b);
    b.flags |= 1;
    $db8388f9ae3d0ea5$var$Yi(a, b, d, e);
    return b.child;
}
function $db8388f9ae3d0ea5$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$db8388f9ae3d0ea5$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $db8388f9ae3d0ea5$var$cj(a, b, f, d, e);
        a = $db8388f9ae3d0ea5$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $db8388f9ae3d0ea5$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $db8388f9ae3d0ea5$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $db8388f9ae3d0ea5$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $db8388f9ae3d0ea5$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($db8388f9ae3d0ea5$var$Ie(f, d) && a.ref === b.ref) {
            if ($db8388f9ae3d0ea5$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($db8388f9ae3d0ea5$var$Ug = !0);
            else return b.lanes = a.lanes, $db8388f9ae3d0ea5$var$$i(a, b, e);
        }
    }
    return $db8388f9ae3d0ea5$var$dj(a, b, c, d, e);
}
function $db8388f9ae3d0ea5$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$fj, $db8388f9ae3d0ea5$var$gj), $db8388f9ae3d0ea5$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$fj, $db8388f9ae3d0ea5$var$gj), $db8388f9ae3d0ea5$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$fj, $db8388f9ae3d0ea5$var$gj);
            $db8388f9ae3d0ea5$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$fj, $db8388f9ae3d0ea5$var$gj), $db8388f9ae3d0ea5$var$gj |= d;
    $db8388f9ae3d0ea5$var$Yi(a, b, e, c);
    return b.child;
}
function $db8388f9ae3d0ea5$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $db8388f9ae3d0ea5$var$dj(a, b, c, d, e) {
    var f = $db8388f9ae3d0ea5$var$Zf(c) ? $db8388f9ae3d0ea5$var$Xf : $db8388f9ae3d0ea5$var$H.current;
    f = $db8388f9ae3d0ea5$var$Yf(b, f);
    $db8388f9ae3d0ea5$var$Tg(b, e);
    c = $db8388f9ae3d0ea5$var$Xh(a, b, c, d, f, e);
    d = $db8388f9ae3d0ea5$var$bi();
    if (null !== a && !$db8388f9ae3d0ea5$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $db8388f9ae3d0ea5$var$$i(a, b, e);
    $db8388f9ae3d0ea5$var$I && d && $db8388f9ae3d0ea5$var$vg(b);
    b.flags |= 1;
    $db8388f9ae3d0ea5$var$Yi(a, b, c, e);
    return b.child;
}
function $db8388f9ae3d0ea5$var$ij(a, b, c, d, e) {
    if ($db8388f9ae3d0ea5$var$Zf(c)) {
        var f = !0;
        $db8388f9ae3d0ea5$var$cg(b);
    } else f = !1;
    $db8388f9ae3d0ea5$var$Tg(b, e);
    if (null === b.stateNode) $db8388f9ae3d0ea5$var$jj(a, b), $db8388f9ae3d0ea5$var$ph(b, c, d), $db8388f9ae3d0ea5$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $db8388f9ae3d0ea5$var$Vg(l) : (l = $db8388f9ae3d0ea5$var$Zf(c) ? $db8388f9ae3d0ea5$var$Xf : $db8388f9ae3d0ea5$var$H.current, l = $db8388f9ae3d0ea5$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $db8388f9ae3d0ea5$var$qh(b, g, d, l);
        $db8388f9ae3d0ea5$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $db8388f9ae3d0ea5$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $db8388f9ae3d0ea5$var$Wf.current || $db8388f9ae3d0ea5$var$$g ? ("function" === typeof m && ($db8388f9ae3d0ea5$var$kh(b, c, m, d), k = b.memoizedState), (h = $db8388f9ae3d0ea5$var$$g || $db8388f9ae3d0ea5$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $db8388f9ae3d0ea5$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $db8388f9ae3d0ea5$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $db8388f9ae3d0ea5$var$Vg(k) : (k = $db8388f9ae3d0ea5$var$Zf(c) ? $db8388f9ae3d0ea5$var$Xf : $db8388f9ae3d0ea5$var$H.current, k = $db8388f9ae3d0ea5$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $db8388f9ae3d0ea5$var$qh(b, g, d, k);
        $db8388f9ae3d0ea5$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $db8388f9ae3d0ea5$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $db8388f9ae3d0ea5$var$Wf.current || $db8388f9ae3d0ea5$var$$g ? ("function" === typeof y && ($db8388f9ae3d0ea5$var$kh(b, c, y, d), n = b.memoizedState), (l = $db8388f9ae3d0ea5$var$$g || $db8388f9ae3d0ea5$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $db8388f9ae3d0ea5$var$kj(a, b, c, d, f, e);
}
function $db8388f9ae3d0ea5$var$kj(a, b, c, d, e, f) {
    $db8388f9ae3d0ea5$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $db8388f9ae3d0ea5$var$dg(b, c, !1), $db8388f9ae3d0ea5$var$$i(a, b, f);
    d = b.stateNode;
    $db8388f9ae3d0ea5$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $db8388f9ae3d0ea5$var$Bh(b, a.child, null, f), b.child = $db8388f9ae3d0ea5$var$Bh(b, null, h, f)) : $db8388f9ae3d0ea5$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $db8388f9ae3d0ea5$var$dg(b, c, !0);
    return b.child;
}
function $db8388f9ae3d0ea5$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $db8388f9ae3d0ea5$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $db8388f9ae3d0ea5$var$ag(a, b.context, !1);
    $db8388f9ae3d0ea5$var$Ih(a, b.containerInfo);
}
function $db8388f9ae3d0ea5$var$mj(a, b, c, d, e) {
    $db8388f9ae3d0ea5$var$Ig();
    $db8388f9ae3d0ea5$var$Jg(e);
    b.flags |= 256;
    $db8388f9ae3d0ea5$var$Yi(a, b, c, d);
    return b.child;
}
var $db8388f9ae3d0ea5$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $db8388f9ae3d0ea5$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $db8388f9ae3d0ea5$var$pj(a, b, c) {
    var d = b.pendingProps, e = $db8388f9ae3d0ea5$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$M, e & 1);
    if (null === a) {
        $db8388f9ae3d0ea5$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $db8388f9ae3d0ea5$var$qj(g, d, 0, null), a = $db8388f9ae3d0ea5$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $db8388f9ae3d0ea5$var$oj(c), b.memoizedState = $db8388f9ae3d0ea5$var$nj, a) : $db8388f9ae3d0ea5$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $db8388f9ae3d0ea5$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $db8388f9ae3d0ea5$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $db8388f9ae3d0ea5$var$wh(h, f) : (f = $db8388f9ae3d0ea5$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $db8388f9ae3d0ea5$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $db8388f9ae3d0ea5$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $db8388f9ae3d0ea5$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $db8388f9ae3d0ea5$var$rj(a, b) {
    b = $db8388f9ae3d0ea5$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $db8388f9ae3d0ea5$var$tj(a, b, c, d) {
    null !== d && $db8388f9ae3d0ea5$var$Jg(d);
    $db8388f9ae3d0ea5$var$Bh(b, a.child, null, c);
    a = $db8388f9ae3d0ea5$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $db8388f9ae3d0ea5$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $db8388f9ae3d0ea5$var$Li(Error($db8388f9ae3d0ea5$var$p(422))), $db8388f9ae3d0ea5$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $db8388f9ae3d0ea5$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $db8388f9ae3d0ea5$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $db8388f9ae3d0ea5$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $db8388f9ae3d0ea5$var$oj(g);
        b.memoizedState = $db8388f9ae3d0ea5$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $db8388f9ae3d0ea5$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($db8388f9ae3d0ea5$var$p(419));
        d = $db8388f9ae3d0ea5$var$Li(f, d, void 0);
        return $db8388f9ae3d0ea5$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($db8388f9ae3d0ea5$var$Ug || h) {
        d = $db8388f9ae3d0ea5$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $db8388f9ae3d0ea5$var$Zg(a, e), $db8388f9ae3d0ea5$var$mh(d, a, e, -1));
        }
        $db8388f9ae3d0ea5$var$uj();
        d = $db8388f9ae3d0ea5$var$Li(Error($db8388f9ae3d0ea5$var$p(421)));
        return $db8388f9ae3d0ea5$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $db8388f9ae3d0ea5$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $db8388f9ae3d0ea5$var$yg = $db8388f9ae3d0ea5$var$Lf(e.nextSibling);
    $db8388f9ae3d0ea5$var$xg = b;
    $db8388f9ae3d0ea5$var$I = !0;
    $db8388f9ae3d0ea5$var$zg = null;
    null !== a && ($db8388f9ae3d0ea5$var$og[$db8388f9ae3d0ea5$var$pg++] = $db8388f9ae3d0ea5$var$rg, $db8388f9ae3d0ea5$var$og[$db8388f9ae3d0ea5$var$pg++] = $db8388f9ae3d0ea5$var$sg, $db8388f9ae3d0ea5$var$og[$db8388f9ae3d0ea5$var$pg++] = $db8388f9ae3d0ea5$var$qg, $db8388f9ae3d0ea5$var$rg = a.id, $db8388f9ae3d0ea5$var$sg = a.overflow, $db8388f9ae3d0ea5$var$qg = b);
    b = $db8388f9ae3d0ea5$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $db8388f9ae3d0ea5$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $db8388f9ae3d0ea5$var$Sg(a.return, b, c);
}
function $db8388f9ae3d0ea5$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $db8388f9ae3d0ea5$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $db8388f9ae3d0ea5$var$Yi(a, b, d.children, c);
    d = $db8388f9ae3d0ea5$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $db8388f9ae3d0ea5$var$wj(a, c, b);
            else if (19 === a.tag) $db8388f9ae3d0ea5$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $db8388f9ae3d0ea5$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $db8388f9ae3d0ea5$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $db8388f9ae3d0ea5$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $db8388f9ae3d0ea5$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $db8388f9ae3d0ea5$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $db8388f9ae3d0ea5$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $db8388f9ae3d0ea5$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $db8388f9ae3d0ea5$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($db8388f9ae3d0ea5$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $db8388f9ae3d0ea5$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $db8388f9ae3d0ea5$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $db8388f9ae3d0ea5$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $db8388f9ae3d0ea5$var$lj(b);
            $db8388f9ae3d0ea5$var$Ig();
            break;
        case 5:
            $db8388f9ae3d0ea5$var$Kh(b);
            break;
        case 1:
            $db8388f9ae3d0ea5$var$Zf(b.type) && $db8388f9ae3d0ea5$var$cg(b);
            break;
        case 4:
            $db8388f9ae3d0ea5$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$M, $db8388f9ae3d0ea5$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $db8388f9ae3d0ea5$var$pj(a, b, c);
                $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$M, $db8388f9ae3d0ea5$var$M.current & 1);
                a = $db8388f9ae3d0ea5$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$M, $db8388f9ae3d0ea5$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $db8388f9ae3d0ea5$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$M, $db8388f9ae3d0ea5$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $db8388f9ae3d0ea5$var$ej(a, b, c);
    }
    return $db8388f9ae3d0ea5$var$$i(a, b, c);
}
var $db8388f9ae3d0ea5$var$Aj, $db8388f9ae3d0ea5$var$Bj, $db8388f9ae3d0ea5$var$Cj, $db8388f9ae3d0ea5$var$Dj;
$db8388f9ae3d0ea5$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$db8388f9ae3d0ea5$var$Bj = function() {};
$db8388f9ae3d0ea5$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $db8388f9ae3d0ea5$var$Hh($db8388f9ae3d0ea5$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $db8388f9ae3d0ea5$var$Ya(a, e);
                d = $db8388f9ae3d0ea5$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $db8388f9ae3d0ea5$var$A({}, e, {
                    value: void 0
                });
                d = $db8388f9ae3d0ea5$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $db8388f9ae3d0ea5$var$gb(a, e);
                d = $db8388f9ae3d0ea5$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $db8388f9ae3d0ea5$var$Bf);
        }
        $db8388f9ae3d0ea5$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($db8388f9ae3d0ea5$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($db8388f9ae3d0ea5$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $db8388f9ae3d0ea5$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$db8388f9ae3d0ea5$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $db8388f9ae3d0ea5$var$Ej(a, b) {
    if (!$db8388f9ae3d0ea5$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $db8388f9ae3d0ea5$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $db8388f9ae3d0ea5$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $db8388f9ae3d0ea5$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $db8388f9ae3d0ea5$var$S(b), null;
        case 1:
            return $db8388f9ae3d0ea5$var$Zf(b.type) && $db8388f9ae3d0ea5$var$$f(), $db8388f9ae3d0ea5$var$S(b), null;
        case 3:
            d = b.stateNode;
            $db8388f9ae3d0ea5$var$Jh();
            $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$Wf);
            $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$H);
            $db8388f9ae3d0ea5$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $db8388f9ae3d0ea5$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $db8388f9ae3d0ea5$var$zg && ($db8388f9ae3d0ea5$var$Gj($db8388f9ae3d0ea5$var$zg), $db8388f9ae3d0ea5$var$zg = null));
            $db8388f9ae3d0ea5$var$Bj(a, b);
            $db8388f9ae3d0ea5$var$S(b);
            return null;
        case 5:
            $db8388f9ae3d0ea5$var$Lh(b);
            var e = $db8388f9ae3d0ea5$var$Hh($db8388f9ae3d0ea5$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $db8388f9ae3d0ea5$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($db8388f9ae3d0ea5$var$p(166));
                    $db8388f9ae3d0ea5$var$S(b);
                    return null;
                }
                a = $db8388f9ae3d0ea5$var$Hh($db8388f9ae3d0ea5$var$Eh.current);
                if ($db8388f9ae3d0ea5$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$db8388f9ae3d0ea5$var$Of] = b;
                    d[$db8388f9ae3d0ea5$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $db8388f9ae3d0ea5$var$D("cancel", d);
                            $db8388f9ae3d0ea5$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $db8388f9ae3d0ea5$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $db8388f9ae3d0ea5$var$lf.length; e++)$db8388f9ae3d0ea5$var$D($db8388f9ae3d0ea5$var$lf[e], d);
                            break;
                        case "source":
                            $db8388f9ae3d0ea5$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $db8388f9ae3d0ea5$var$D("error", d);
                            $db8388f9ae3d0ea5$var$D("load", d);
                            break;
                        case "details":
                            $db8388f9ae3d0ea5$var$D("toggle", d);
                            break;
                        case "input":
                            $db8388f9ae3d0ea5$var$Za(d, f);
                            $db8388f9ae3d0ea5$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $db8388f9ae3d0ea5$var$D("invalid", d);
                            break;
                        case "textarea":
                            $db8388f9ae3d0ea5$var$hb(d, f), $db8388f9ae3d0ea5$var$D("invalid", d);
                    }
                    $db8388f9ae3d0ea5$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $db8388f9ae3d0ea5$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $db8388f9ae3d0ea5$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $db8388f9ae3d0ea5$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $db8388f9ae3d0ea5$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $db8388f9ae3d0ea5$var$Va(d);
                            $db8388f9ae3d0ea5$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $db8388f9ae3d0ea5$var$Va(d);
                            $db8388f9ae3d0ea5$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $db8388f9ae3d0ea5$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $db8388f9ae3d0ea5$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$db8388f9ae3d0ea5$var$Of] = b;
                    a[$db8388f9ae3d0ea5$var$Pf] = d;
                    $db8388f9ae3d0ea5$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $db8388f9ae3d0ea5$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $db8388f9ae3d0ea5$var$D("cancel", a);
                                $db8388f9ae3d0ea5$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $db8388f9ae3d0ea5$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $db8388f9ae3d0ea5$var$lf.length; e++)$db8388f9ae3d0ea5$var$D($db8388f9ae3d0ea5$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $db8388f9ae3d0ea5$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $db8388f9ae3d0ea5$var$D("error", a);
                                $db8388f9ae3d0ea5$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $db8388f9ae3d0ea5$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $db8388f9ae3d0ea5$var$Za(a, d);
                                e = $db8388f9ae3d0ea5$var$Ya(a, d);
                                $db8388f9ae3d0ea5$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $db8388f9ae3d0ea5$var$A({}, d, {
                                    value: void 0
                                });
                                $db8388f9ae3d0ea5$var$D("invalid", a);
                                break;
                            case "textarea":
                                $db8388f9ae3d0ea5$var$hb(a, d);
                                e = $db8388f9ae3d0ea5$var$gb(a, d);
                                $db8388f9ae3d0ea5$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $db8388f9ae3d0ea5$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $db8388f9ae3d0ea5$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $db8388f9ae3d0ea5$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $db8388f9ae3d0ea5$var$ob(a, k) : "number" === typeof k && $db8388f9ae3d0ea5$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($db8388f9ae3d0ea5$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $db8388f9ae3d0ea5$var$D("scroll", a) : null != k && $db8388f9ae3d0ea5$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $db8388f9ae3d0ea5$var$Va(a);
                                $db8388f9ae3d0ea5$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $db8388f9ae3d0ea5$var$Va(a);
                                $db8388f9ae3d0ea5$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $db8388f9ae3d0ea5$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $db8388f9ae3d0ea5$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $db8388f9ae3d0ea5$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $db8388f9ae3d0ea5$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $db8388f9ae3d0ea5$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $db8388f9ae3d0ea5$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($db8388f9ae3d0ea5$var$p(166));
                c = $db8388f9ae3d0ea5$var$Hh($db8388f9ae3d0ea5$var$Gh.current);
                $db8388f9ae3d0ea5$var$Hh($db8388f9ae3d0ea5$var$Eh.current);
                if ($db8388f9ae3d0ea5$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$db8388f9ae3d0ea5$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $db8388f9ae3d0ea5$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $db8388f9ae3d0ea5$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $db8388f9ae3d0ea5$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$db8388f9ae3d0ea5$var$Of] = b, b.stateNode = d;
            }
            $db8388f9ae3d0ea5$var$S(b);
            return null;
        case 13:
            $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($db8388f9ae3d0ea5$var$I && null !== $db8388f9ae3d0ea5$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $db8388f9ae3d0ea5$var$Hg(), $db8388f9ae3d0ea5$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $db8388f9ae3d0ea5$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($db8388f9ae3d0ea5$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($db8388f9ae3d0ea5$var$p(317));
                        f[$db8388f9ae3d0ea5$var$Of] = b;
                    } else $db8388f9ae3d0ea5$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $db8388f9ae3d0ea5$var$S(b);
                    f = !1;
                } else null !== $db8388f9ae3d0ea5$var$zg && ($db8388f9ae3d0ea5$var$Gj($db8388f9ae3d0ea5$var$zg), $db8388f9ae3d0ea5$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($db8388f9ae3d0ea5$var$M.current & 1) ? 0 === $db8388f9ae3d0ea5$var$T && ($db8388f9ae3d0ea5$var$T = 3) : $db8388f9ae3d0ea5$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $db8388f9ae3d0ea5$var$S(b);
            return null;
        case 4:
            return $db8388f9ae3d0ea5$var$Jh(), $db8388f9ae3d0ea5$var$Bj(a, b), null === a && $db8388f9ae3d0ea5$var$sf(b.stateNode.containerInfo), $db8388f9ae3d0ea5$var$S(b), null;
        case 10:
            return $db8388f9ae3d0ea5$var$Rg(b.type._context), $db8388f9ae3d0ea5$var$S(b), null;
        case 17:
            return $db8388f9ae3d0ea5$var$Zf(b.type) && $db8388f9ae3d0ea5$var$$f(), $db8388f9ae3d0ea5$var$S(b), null;
        case 19:
            $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$M);
            f = b.memoizedState;
            if (null === f) return $db8388f9ae3d0ea5$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $db8388f9ae3d0ea5$var$Ej(f, !1);
                else {
                    if (0 !== $db8388f9ae3d0ea5$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $db8388f9ae3d0ea5$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $db8388f9ae3d0ea5$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$M, $db8388f9ae3d0ea5$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $db8388f9ae3d0ea5$var$B() > $db8388f9ae3d0ea5$var$Hj && (b.flags |= 128, d = !0, $db8388f9ae3d0ea5$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $db8388f9ae3d0ea5$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $db8388f9ae3d0ea5$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$db8388f9ae3d0ea5$var$I) return $db8388f9ae3d0ea5$var$S(b), null;
                    } else 2 * $db8388f9ae3d0ea5$var$B() - f.renderingStartTime > $db8388f9ae3d0ea5$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $db8388f9ae3d0ea5$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $db8388f9ae3d0ea5$var$B(), b.sibling = null, c = $db8388f9ae3d0ea5$var$M.current, $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$M, d ? c & 1 | 2 : c & 1), b;
            $db8388f9ae3d0ea5$var$S(b);
            return null;
        case 22:
        case 23:
            return $db8388f9ae3d0ea5$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($db8388f9ae3d0ea5$var$gj & 1073741824) && ($db8388f9ae3d0ea5$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $db8388f9ae3d0ea5$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($db8388f9ae3d0ea5$var$p(156, b.tag));
}
function $db8388f9ae3d0ea5$var$Jj(a, b) {
    $db8388f9ae3d0ea5$var$wg(b);
    switch(b.tag){
        case 1:
            return $db8388f9ae3d0ea5$var$Zf(b.type) && $db8388f9ae3d0ea5$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $db8388f9ae3d0ea5$var$Jh(), $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$Wf), $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$H), $db8388f9ae3d0ea5$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $db8388f9ae3d0ea5$var$Lh(b), null;
        case 13:
            $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($db8388f9ae3d0ea5$var$p(340));
                $db8388f9ae3d0ea5$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$M), null;
        case 4:
            return $db8388f9ae3d0ea5$var$Jh(), null;
        case 10:
            return $db8388f9ae3d0ea5$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $db8388f9ae3d0ea5$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $db8388f9ae3d0ea5$var$Kj = !1, $db8388f9ae3d0ea5$var$U = !1, $db8388f9ae3d0ea5$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $db8388f9ae3d0ea5$var$V = null;
function $db8388f9ae3d0ea5$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $db8388f9ae3d0ea5$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $db8388f9ae3d0ea5$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $db8388f9ae3d0ea5$var$W(a, b, d);
    }
}
var $db8388f9ae3d0ea5$var$Oj = !1;
function $db8388f9ae3d0ea5$var$Pj(a, b) {
    $db8388f9ae3d0ea5$var$Cf = $db8388f9ae3d0ea5$var$dd;
    a = $db8388f9ae3d0ea5$var$Me();
    if ($db8388f9ae3d0ea5$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $db8388f9ae3d0ea5$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $db8388f9ae3d0ea5$var$dd = !1;
    for($db8388f9ae3d0ea5$var$V = b; null !== $db8388f9ae3d0ea5$var$V;)if (b = $db8388f9ae3d0ea5$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $db8388f9ae3d0ea5$var$V = a;
    else for(; null !== $db8388f9ae3d0ea5$var$V;){
        b = $db8388f9ae3d0ea5$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $db8388f9ae3d0ea5$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($db8388f9ae3d0ea5$var$p(163));
            }
        } catch (F) {
            $db8388f9ae3d0ea5$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $db8388f9ae3d0ea5$var$V = a;
            break;
        }
        $db8388f9ae3d0ea5$var$V = b.return;
    }
    n = $db8388f9ae3d0ea5$var$Oj;
    $db8388f9ae3d0ea5$var$Oj = !1;
    return n;
}
function $db8388f9ae3d0ea5$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $db8388f9ae3d0ea5$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $db8388f9ae3d0ea5$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $db8388f9ae3d0ea5$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $db8388f9ae3d0ea5$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $db8388f9ae3d0ea5$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$db8388f9ae3d0ea5$var$Of], delete b[$db8388f9ae3d0ea5$var$Pf], delete b[$db8388f9ae3d0ea5$var$of], delete b[$db8388f9ae3d0ea5$var$Qf], delete b[$db8388f9ae3d0ea5$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $db8388f9ae3d0ea5$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $db8388f9ae3d0ea5$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $db8388f9ae3d0ea5$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $db8388f9ae3d0ea5$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $db8388f9ae3d0ea5$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($db8388f9ae3d0ea5$var$Wj(a, b, c), a = a.sibling; null !== a;)$db8388f9ae3d0ea5$var$Wj(a, b, c), a = a.sibling;
}
function $db8388f9ae3d0ea5$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($db8388f9ae3d0ea5$var$Xj(a, b, c), a = a.sibling; null !== a;)$db8388f9ae3d0ea5$var$Xj(a, b, c), a = a.sibling;
}
var $db8388f9ae3d0ea5$var$X = null, $db8388f9ae3d0ea5$var$Yj = !1;
function $db8388f9ae3d0ea5$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$db8388f9ae3d0ea5$var$ak(a, b, c), c = c.sibling;
}
function $db8388f9ae3d0ea5$var$ak(a, b, c) {
    if ($db8388f9ae3d0ea5$var$lc && "function" === typeof $db8388f9ae3d0ea5$var$lc.onCommitFiberUnmount) try {
        $db8388f9ae3d0ea5$var$lc.onCommitFiberUnmount($db8388f9ae3d0ea5$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $db8388f9ae3d0ea5$var$U || $db8388f9ae3d0ea5$var$Mj(c, b);
        case 6:
            var d = $db8388f9ae3d0ea5$var$X, e = $db8388f9ae3d0ea5$var$Yj;
            $db8388f9ae3d0ea5$var$X = null;
            $db8388f9ae3d0ea5$var$Zj(a, b, c);
            $db8388f9ae3d0ea5$var$X = d;
            $db8388f9ae3d0ea5$var$Yj = e;
            null !== $db8388f9ae3d0ea5$var$X && ($db8388f9ae3d0ea5$var$Yj ? (a = $db8388f9ae3d0ea5$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $db8388f9ae3d0ea5$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $db8388f9ae3d0ea5$var$X && ($db8388f9ae3d0ea5$var$Yj ? (a = $db8388f9ae3d0ea5$var$X, c = c.stateNode, 8 === a.nodeType ? $db8388f9ae3d0ea5$var$Kf(a.parentNode, c) : 1 === a.nodeType && $db8388f9ae3d0ea5$var$Kf(a, c), $db8388f9ae3d0ea5$var$bd(a)) : $db8388f9ae3d0ea5$var$Kf($db8388f9ae3d0ea5$var$X, c.stateNode));
            break;
        case 4:
            d = $db8388f9ae3d0ea5$var$X;
            e = $db8388f9ae3d0ea5$var$Yj;
            $db8388f9ae3d0ea5$var$X = c.stateNode.containerInfo;
            $db8388f9ae3d0ea5$var$Yj = !0;
            $db8388f9ae3d0ea5$var$Zj(a, b, c);
            $db8388f9ae3d0ea5$var$X = d;
            $db8388f9ae3d0ea5$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$db8388f9ae3d0ea5$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $db8388f9ae3d0ea5$var$Nj(c, b, g) : 0 !== (f & 4) && $db8388f9ae3d0ea5$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $db8388f9ae3d0ea5$var$Zj(a, b, c);
            break;
        case 1:
            if (!$db8388f9ae3d0ea5$var$U && ($db8388f9ae3d0ea5$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $db8388f9ae3d0ea5$var$W(c, b, h);
            }
            $db8388f9ae3d0ea5$var$Zj(a, b, c);
            break;
        case 21:
            $db8388f9ae3d0ea5$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($db8388f9ae3d0ea5$var$U = (d = $db8388f9ae3d0ea5$var$U) || null !== c.memoizedState, $db8388f9ae3d0ea5$var$Zj(a, b, c), $db8388f9ae3d0ea5$var$U = d) : $db8388f9ae3d0ea5$var$Zj(a, b, c);
            break;
        default:
            $db8388f9ae3d0ea5$var$Zj(a, b, c);
    }
}
function $db8388f9ae3d0ea5$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $db8388f9ae3d0ea5$var$Lj);
        b.forEach(function(b) {
            var d = $db8388f9ae3d0ea5$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $db8388f9ae3d0ea5$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $db8388f9ae3d0ea5$var$X = h.stateNode;
                        $db8388f9ae3d0ea5$var$Yj = !1;
                        break a;
                    case 3:
                        $db8388f9ae3d0ea5$var$X = h.stateNode.containerInfo;
                        $db8388f9ae3d0ea5$var$Yj = !0;
                        break a;
                    case 4:
                        $db8388f9ae3d0ea5$var$X = h.stateNode.containerInfo;
                        $db8388f9ae3d0ea5$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $db8388f9ae3d0ea5$var$X) throw Error($db8388f9ae3d0ea5$var$p(160));
            $db8388f9ae3d0ea5$var$ak(f, g, e);
            $db8388f9ae3d0ea5$var$X = null;
            $db8388f9ae3d0ea5$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $db8388f9ae3d0ea5$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$db8388f9ae3d0ea5$var$ek(b, a), b = b.sibling;
}
function $db8388f9ae3d0ea5$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $db8388f9ae3d0ea5$var$dk(b, a);
            $db8388f9ae3d0ea5$var$fk(a);
            if (d & 4) {
                try {
                    $db8388f9ae3d0ea5$var$Qj(3, a, a.return), $db8388f9ae3d0ea5$var$Rj(3, a);
                } catch (t) {
                    $db8388f9ae3d0ea5$var$W(a, a.return, t);
                }
                try {
                    $db8388f9ae3d0ea5$var$Qj(5, a, a.return);
                } catch (t) {
                    $db8388f9ae3d0ea5$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $db8388f9ae3d0ea5$var$dk(b, a);
            $db8388f9ae3d0ea5$var$fk(a);
            d & 512 && null !== c && $db8388f9ae3d0ea5$var$Mj(c, c.return);
            break;
        case 5:
            $db8388f9ae3d0ea5$var$dk(b, a);
            $db8388f9ae3d0ea5$var$fk(a);
            d & 512 && null !== c && $db8388f9ae3d0ea5$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $db8388f9ae3d0ea5$var$ob(e, "");
                } catch (t) {
                    $db8388f9ae3d0ea5$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $db8388f9ae3d0ea5$var$ab(e, f);
                    $db8388f9ae3d0ea5$var$vb(h, g);
                    var l = $db8388f9ae3d0ea5$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $db8388f9ae3d0ea5$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $db8388f9ae3d0ea5$var$nb(e, q) : "children" === m ? $db8388f9ae3d0ea5$var$ob(e, q) : $db8388f9ae3d0ea5$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $db8388f9ae3d0ea5$var$bb(e, f);
                            break;
                        case "textarea":
                            $db8388f9ae3d0ea5$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $db8388f9ae3d0ea5$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $db8388f9ae3d0ea5$var$fb(e, !!f.multiple, f.defaultValue, !0) : $db8388f9ae3d0ea5$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$db8388f9ae3d0ea5$var$Pf] = f;
                } catch (t) {
                    $db8388f9ae3d0ea5$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $db8388f9ae3d0ea5$var$dk(b, a);
            $db8388f9ae3d0ea5$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($db8388f9ae3d0ea5$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $db8388f9ae3d0ea5$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $db8388f9ae3d0ea5$var$dk(b, a);
            $db8388f9ae3d0ea5$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $db8388f9ae3d0ea5$var$bd(b.containerInfo);
            } catch (t) {
                $db8388f9ae3d0ea5$var$W(a, a.return, t);
            }
            break;
        case 4:
            $db8388f9ae3d0ea5$var$dk(b, a);
            $db8388f9ae3d0ea5$var$fk(a);
            break;
        case 13:
            $db8388f9ae3d0ea5$var$dk(b, a);
            $db8388f9ae3d0ea5$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($db8388f9ae3d0ea5$var$gk = $db8388f9ae3d0ea5$var$B()));
            d & 4 && $db8388f9ae3d0ea5$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($db8388f9ae3d0ea5$var$U = (l = $db8388f9ae3d0ea5$var$U) || m, $db8388f9ae3d0ea5$var$dk(b, a), $db8388f9ae3d0ea5$var$U = l) : $db8388f9ae3d0ea5$var$dk(b, a);
            $db8388f9ae3d0ea5$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($db8388f9ae3d0ea5$var$V = a, m = a.child; null !== m;){
                    for(q = $db8388f9ae3d0ea5$var$V = m; null !== $db8388f9ae3d0ea5$var$V;){
                        r = $db8388f9ae3d0ea5$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $db8388f9ae3d0ea5$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $db8388f9ae3d0ea5$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $db8388f9ae3d0ea5$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $db8388f9ae3d0ea5$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $db8388f9ae3d0ea5$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $db8388f9ae3d0ea5$var$V = y) : $db8388f9ae3d0ea5$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $db8388f9ae3d0ea5$var$rb("display", g));
                            } catch (t) {
                                $db8388f9ae3d0ea5$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $db8388f9ae3d0ea5$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $db8388f9ae3d0ea5$var$dk(b, a);
            $db8388f9ae3d0ea5$var$fk(a);
            d & 4 && $db8388f9ae3d0ea5$var$bk(a);
            break;
        case 21:
            break;
        default:
            $db8388f9ae3d0ea5$var$dk(b, a), $db8388f9ae3d0ea5$var$fk(a);
    }
}
function $db8388f9ae3d0ea5$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($db8388f9ae3d0ea5$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($db8388f9ae3d0ea5$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($db8388f9ae3d0ea5$var$ob(e, ""), d.flags &= -33);
                    var f = $db8388f9ae3d0ea5$var$Vj(a);
                    $db8388f9ae3d0ea5$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $db8388f9ae3d0ea5$var$Vj(a);
                    $db8388f9ae3d0ea5$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($db8388f9ae3d0ea5$var$p(161));
            }
        } catch (k) {
            $db8388f9ae3d0ea5$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $db8388f9ae3d0ea5$var$ik(a, b, c) {
    $db8388f9ae3d0ea5$var$V = a;
    $db8388f9ae3d0ea5$var$jk(a, b, c);
}
function $db8388f9ae3d0ea5$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $db8388f9ae3d0ea5$var$V;){
        var e = $db8388f9ae3d0ea5$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $db8388f9ae3d0ea5$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $db8388f9ae3d0ea5$var$U;
                h = $db8388f9ae3d0ea5$var$Kj;
                var l = $db8388f9ae3d0ea5$var$U;
                $db8388f9ae3d0ea5$var$Kj = g;
                if (($db8388f9ae3d0ea5$var$U = k) && !l) for($db8388f9ae3d0ea5$var$V = e; null !== $db8388f9ae3d0ea5$var$V;)g = $db8388f9ae3d0ea5$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $db8388f9ae3d0ea5$var$kk(e) : null !== k ? (k.return = g, $db8388f9ae3d0ea5$var$V = k) : $db8388f9ae3d0ea5$var$kk(e);
                for(; null !== f;)$db8388f9ae3d0ea5$var$V = f, $db8388f9ae3d0ea5$var$jk(f, b, c), f = f.sibling;
                $db8388f9ae3d0ea5$var$V = e;
                $db8388f9ae3d0ea5$var$Kj = h;
                $db8388f9ae3d0ea5$var$U = l;
            }
            $db8388f9ae3d0ea5$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $db8388f9ae3d0ea5$var$V = f) : $db8388f9ae3d0ea5$var$lk(a, b, c);
    }
}
function $db8388f9ae3d0ea5$var$lk(a) {
    for(; null !== $db8388f9ae3d0ea5$var$V;){
        var b = $db8388f9ae3d0ea5$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $db8388f9ae3d0ea5$var$U || $db8388f9ae3d0ea5$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$db8388f9ae3d0ea5$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $db8388f9ae3d0ea5$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $db8388f9ae3d0ea5$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $db8388f9ae3d0ea5$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $db8388f9ae3d0ea5$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($db8388f9ae3d0ea5$var$p(163));
                }
                $db8388f9ae3d0ea5$var$U || b.flags & 512 && $db8388f9ae3d0ea5$var$Sj(b);
            } catch (r) {
                $db8388f9ae3d0ea5$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $db8388f9ae3d0ea5$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $db8388f9ae3d0ea5$var$V = c;
            break;
        }
        $db8388f9ae3d0ea5$var$V = b.return;
    }
}
function $db8388f9ae3d0ea5$var$hk(a) {
    for(; null !== $db8388f9ae3d0ea5$var$V;){
        var b = $db8388f9ae3d0ea5$var$V;
        if (b === a) {
            $db8388f9ae3d0ea5$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $db8388f9ae3d0ea5$var$V = c;
            break;
        }
        $db8388f9ae3d0ea5$var$V = b.return;
    }
}
function $db8388f9ae3d0ea5$var$kk(a) {
    for(; null !== $db8388f9ae3d0ea5$var$V;){
        var b = $db8388f9ae3d0ea5$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $db8388f9ae3d0ea5$var$Rj(4, b);
                    } catch (k) {
                        $db8388f9ae3d0ea5$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $db8388f9ae3d0ea5$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $db8388f9ae3d0ea5$var$Sj(b);
                    } catch (k) {
                        $db8388f9ae3d0ea5$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $db8388f9ae3d0ea5$var$Sj(b);
                    } catch (k) {
                        $db8388f9ae3d0ea5$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $db8388f9ae3d0ea5$var$W(b, b.return, k);
        }
        if (b === a) {
            $db8388f9ae3d0ea5$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $db8388f9ae3d0ea5$var$V = h;
            break;
        }
        $db8388f9ae3d0ea5$var$V = b.return;
    }
}
var $db8388f9ae3d0ea5$var$mk = Math.ceil, $db8388f9ae3d0ea5$var$nk = $db8388f9ae3d0ea5$var$ua.ReactCurrentDispatcher, $db8388f9ae3d0ea5$var$ok = $db8388f9ae3d0ea5$var$ua.ReactCurrentOwner, $db8388f9ae3d0ea5$var$pk = $db8388f9ae3d0ea5$var$ua.ReactCurrentBatchConfig, $db8388f9ae3d0ea5$var$K = 0, $db8388f9ae3d0ea5$var$R = null, $db8388f9ae3d0ea5$var$Y = null, $db8388f9ae3d0ea5$var$Z = 0, $db8388f9ae3d0ea5$var$gj = 0, $db8388f9ae3d0ea5$var$fj = $db8388f9ae3d0ea5$var$Uf(0), $db8388f9ae3d0ea5$var$T = 0, $db8388f9ae3d0ea5$var$qk = null, $db8388f9ae3d0ea5$var$hh = 0, $db8388f9ae3d0ea5$var$rk = 0, $db8388f9ae3d0ea5$var$sk = 0, $db8388f9ae3d0ea5$var$tk = null, $db8388f9ae3d0ea5$var$uk = null, $db8388f9ae3d0ea5$var$gk = 0, $db8388f9ae3d0ea5$var$Hj = Infinity, $db8388f9ae3d0ea5$var$vk = null, $db8388f9ae3d0ea5$var$Pi = !1, $db8388f9ae3d0ea5$var$Qi = null, $db8388f9ae3d0ea5$var$Si = null, $db8388f9ae3d0ea5$var$wk = !1, $db8388f9ae3d0ea5$var$xk = null, $db8388f9ae3d0ea5$var$yk = 0, $db8388f9ae3d0ea5$var$zk = 0, $db8388f9ae3d0ea5$var$Ak = null, $db8388f9ae3d0ea5$var$Bk = -1, $db8388f9ae3d0ea5$var$Ck = 0;
function $db8388f9ae3d0ea5$var$L() {
    return 0 !== ($db8388f9ae3d0ea5$var$K & 6) ? $db8388f9ae3d0ea5$var$B() : -1 !== $db8388f9ae3d0ea5$var$Bk ? $db8388f9ae3d0ea5$var$Bk : $db8388f9ae3d0ea5$var$Bk = $db8388f9ae3d0ea5$var$B();
}
function $db8388f9ae3d0ea5$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($db8388f9ae3d0ea5$var$K & 2) && 0 !== $db8388f9ae3d0ea5$var$Z) return $db8388f9ae3d0ea5$var$Z & -$db8388f9ae3d0ea5$var$Z;
    if (null !== $db8388f9ae3d0ea5$var$Kg.transition) return 0 === $db8388f9ae3d0ea5$var$Ck && ($db8388f9ae3d0ea5$var$Ck = $db8388f9ae3d0ea5$var$yc()), $db8388f9ae3d0ea5$var$Ck;
    a = $db8388f9ae3d0ea5$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $db8388f9ae3d0ea5$var$jd(a.type);
    return a;
}
function $db8388f9ae3d0ea5$var$mh(a, b, c, d) {
    if (50 < $db8388f9ae3d0ea5$var$zk) throw $db8388f9ae3d0ea5$var$zk = 0, $db8388f9ae3d0ea5$var$Ak = null, Error($db8388f9ae3d0ea5$var$p(185));
    $db8388f9ae3d0ea5$var$Ac(a, c, d);
    if (0 === ($db8388f9ae3d0ea5$var$K & 2) || a !== $db8388f9ae3d0ea5$var$R) a === $db8388f9ae3d0ea5$var$R && (0 === ($db8388f9ae3d0ea5$var$K & 2) && ($db8388f9ae3d0ea5$var$rk |= c), 4 === $db8388f9ae3d0ea5$var$T && $db8388f9ae3d0ea5$var$Dk(a, $db8388f9ae3d0ea5$var$Z)), $db8388f9ae3d0ea5$var$Ek(a, d), 1 === c && 0 === $db8388f9ae3d0ea5$var$K && 0 === (b.mode & 1) && ($db8388f9ae3d0ea5$var$Hj = $db8388f9ae3d0ea5$var$B() + 500, $db8388f9ae3d0ea5$var$fg && $db8388f9ae3d0ea5$var$jg());
}
function $db8388f9ae3d0ea5$var$Ek(a, b) {
    var c = a.callbackNode;
    $db8388f9ae3d0ea5$var$wc(a, b);
    var d = $db8388f9ae3d0ea5$var$uc(a, a === $db8388f9ae3d0ea5$var$R ? $db8388f9ae3d0ea5$var$Z : 0);
    if (0 === d) null !== c && $db8388f9ae3d0ea5$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $db8388f9ae3d0ea5$var$bc(c);
        if (1 === b) 0 === a.tag ? $db8388f9ae3d0ea5$var$ig($db8388f9ae3d0ea5$var$Fk.bind(null, a)) : $db8388f9ae3d0ea5$var$hg($db8388f9ae3d0ea5$var$Fk.bind(null, a)), $db8388f9ae3d0ea5$var$Jf(function() {
            0 === ($db8388f9ae3d0ea5$var$K & 6) && $db8388f9ae3d0ea5$var$jg();
        }), c = null;
        else {
            switch($db8388f9ae3d0ea5$var$Dc(d)){
                case 1:
                    c = $db8388f9ae3d0ea5$var$fc;
                    break;
                case 4:
                    c = $db8388f9ae3d0ea5$var$gc;
                    break;
                case 16:
                    c = $db8388f9ae3d0ea5$var$hc;
                    break;
                case 536870912:
                    c = $db8388f9ae3d0ea5$var$jc;
                    break;
                default:
                    c = $db8388f9ae3d0ea5$var$hc;
            }
            c = $db8388f9ae3d0ea5$var$Gk(c, $db8388f9ae3d0ea5$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $db8388f9ae3d0ea5$var$Hk(a, b) {
    $db8388f9ae3d0ea5$var$Bk = -1;
    $db8388f9ae3d0ea5$var$Ck = 0;
    if (0 !== ($db8388f9ae3d0ea5$var$K & 6)) throw Error($db8388f9ae3d0ea5$var$p(327));
    var c = a.callbackNode;
    if ($db8388f9ae3d0ea5$var$Ik() && a.callbackNode !== c) return null;
    var d = $db8388f9ae3d0ea5$var$uc(a, a === $db8388f9ae3d0ea5$var$R ? $db8388f9ae3d0ea5$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $db8388f9ae3d0ea5$var$Jk(a, d);
    else {
        b = d;
        var e = $db8388f9ae3d0ea5$var$K;
        $db8388f9ae3d0ea5$var$K |= 2;
        var f = $db8388f9ae3d0ea5$var$Kk();
        if ($db8388f9ae3d0ea5$var$R !== a || $db8388f9ae3d0ea5$var$Z !== b) $db8388f9ae3d0ea5$var$vk = null, $db8388f9ae3d0ea5$var$Hj = $db8388f9ae3d0ea5$var$B() + 500, $db8388f9ae3d0ea5$var$Lk(a, b);
        for(;;)try {
            $db8388f9ae3d0ea5$var$Mk();
            break;
        } catch (h) {
            $db8388f9ae3d0ea5$var$Nk(a, h);
        }
        $db8388f9ae3d0ea5$var$Qg();
        $db8388f9ae3d0ea5$var$nk.current = f;
        $db8388f9ae3d0ea5$var$K = e;
        null !== $db8388f9ae3d0ea5$var$Y ? b = 0 : ($db8388f9ae3d0ea5$var$R = null, $db8388f9ae3d0ea5$var$Z = 0, b = $db8388f9ae3d0ea5$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $db8388f9ae3d0ea5$var$xc(a), 0 !== e && (d = e, b = $db8388f9ae3d0ea5$var$Ok(a, e)));
        if (1 === b) throw c = $db8388f9ae3d0ea5$var$qk, $db8388f9ae3d0ea5$var$Lk(a, 0), $db8388f9ae3d0ea5$var$Dk(a, d), $db8388f9ae3d0ea5$var$Ek(a, $db8388f9ae3d0ea5$var$B()), c;
        if (6 === b) $db8388f9ae3d0ea5$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$db8388f9ae3d0ea5$var$Pk(e) && (b = $db8388f9ae3d0ea5$var$Jk(a, d), 2 === b && (f = $db8388f9ae3d0ea5$var$xc(a), 0 !== f && (d = f, b = $db8388f9ae3d0ea5$var$Ok(a, f))), 1 === b)) throw c = $db8388f9ae3d0ea5$var$qk, $db8388f9ae3d0ea5$var$Lk(a, 0), $db8388f9ae3d0ea5$var$Dk(a, d), $db8388f9ae3d0ea5$var$Ek(a, $db8388f9ae3d0ea5$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($db8388f9ae3d0ea5$var$p(345));
                case 2:
                    $db8388f9ae3d0ea5$var$Qk(a, $db8388f9ae3d0ea5$var$uk, $db8388f9ae3d0ea5$var$vk);
                    break;
                case 3:
                    $db8388f9ae3d0ea5$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $db8388f9ae3d0ea5$var$gk + 500 - $db8388f9ae3d0ea5$var$B(), 10 < b)) {
                        if (0 !== $db8388f9ae3d0ea5$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $db8388f9ae3d0ea5$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $db8388f9ae3d0ea5$var$Ff($db8388f9ae3d0ea5$var$Qk.bind(null, a, $db8388f9ae3d0ea5$var$uk, $db8388f9ae3d0ea5$var$vk), b);
                        break;
                    }
                    $db8388f9ae3d0ea5$var$Qk(a, $db8388f9ae3d0ea5$var$uk, $db8388f9ae3d0ea5$var$vk);
                    break;
                case 4:
                    $db8388f9ae3d0ea5$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $db8388f9ae3d0ea5$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $db8388f9ae3d0ea5$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $db8388f9ae3d0ea5$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $db8388f9ae3d0ea5$var$Ff($db8388f9ae3d0ea5$var$Qk.bind(null, a, $db8388f9ae3d0ea5$var$uk, $db8388f9ae3d0ea5$var$vk), d);
                        break;
                    }
                    $db8388f9ae3d0ea5$var$Qk(a, $db8388f9ae3d0ea5$var$uk, $db8388f9ae3d0ea5$var$vk);
                    break;
                case 5:
                    $db8388f9ae3d0ea5$var$Qk(a, $db8388f9ae3d0ea5$var$uk, $db8388f9ae3d0ea5$var$vk);
                    break;
                default:
                    throw Error($db8388f9ae3d0ea5$var$p(329));
            }
        }
    }
    $db8388f9ae3d0ea5$var$Ek(a, $db8388f9ae3d0ea5$var$B());
    return a.callbackNode === c ? $db8388f9ae3d0ea5$var$Hk.bind(null, a) : null;
}
function $db8388f9ae3d0ea5$var$Ok(a, b) {
    var c = $db8388f9ae3d0ea5$var$tk;
    a.current.memoizedState.isDehydrated && ($db8388f9ae3d0ea5$var$Lk(a, b).flags |= 256);
    a = $db8388f9ae3d0ea5$var$Jk(a, b);
    2 !== a && (b = $db8388f9ae3d0ea5$var$uk, $db8388f9ae3d0ea5$var$uk = c, null !== b && $db8388f9ae3d0ea5$var$Gj(b));
    return a;
}
function $db8388f9ae3d0ea5$var$Gj(a) {
    null === $db8388f9ae3d0ea5$var$uk ? $db8388f9ae3d0ea5$var$uk = a : $db8388f9ae3d0ea5$var$uk.push.apply($db8388f9ae3d0ea5$var$uk, a);
}
function $db8388f9ae3d0ea5$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$db8388f9ae3d0ea5$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $db8388f9ae3d0ea5$var$Dk(a, b) {
    b &= ~$db8388f9ae3d0ea5$var$sk;
    b &= ~$db8388f9ae3d0ea5$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $db8388f9ae3d0ea5$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $db8388f9ae3d0ea5$var$Fk(a) {
    if (0 !== ($db8388f9ae3d0ea5$var$K & 6)) throw Error($db8388f9ae3d0ea5$var$p(327));
    $db8388f9ae3d0ea5$var$Ik();
    var b = $db8388f9ae3d0ea5$var$uc(a, 0);
    if (0 === (b & 1)) return $db8388f9ae3d0ea5$var$Ek(a, $db8388f9ae3d0ea5$var$B()), null;
    var c = $db8388f9ae3d0ea5$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $db8388f9ae3d0ea5$var$xc(a);
        0 !== d && (b = d, c = $db8388f9ae3d0ea5$var$Ok(a, d));
    }
    if (1 === c) throw c = $db8388f9ae3d0ea5$var$qk, $db8388f9ae3d0ea5$var$Lk(a, 0), $db8388f9ae3d0ea5$var$Dk(a, b), $db8388f9ae3d0ea5$var$Ek(a, $db8388f9ae3d0ea5$var$B()), c;
    if (6 === c) throw Error($db8388f9ae3d0ea5$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $db8388f9ae3d0ea5$var$Qk(a, $db8388f9ae3d0ea5$var$uk, $db8388f9ae3d0ea5$var$vk);
    $db8388f9ae3d0ea5$var$Ek(a, $db8388f9ae3d0ea5$var$B());
    return null;
}
function $db8388f9ae3d0ea5$var$Rk(a, b) {
    var c = $db8388f9ae3d0ea5$var$K;
    $db8388f9ae3d0ea5$var$K |= 1;
    try {
        return a(b);
    } finally{
        $db8388f9ae3d0ea5$var$K = c, 0 === $db8388f9ae3d0ea5$var$K && ($db8388f9ae3d0ea5$var$Hj = $db8388f9ae3d0ea5$var$B() + 500, $db8388f9ae3d0ea5$var$fg && $db8388f9ae3d0ea5$var$jg());
    }
}
function $db8388f9ae3d0ea5$var$Sk(a) {
    null !== $db8388f9ae3d0ea5$var$xk && 0 === $db8388f9ae3d0ea5$var$xk.tag && 0 === ($db8388f9ae3d0ea5$var$K & 6) && $db8388f9ae3d0ea5$var$Ik();
    var b = $db8388f9ae3d0ea5$var$K;
    $db8388f9ae3d0ea5$var$K |= 1;
    var c = $db8388f9ae3d0ea5$var$pk.transition, d = $db8388f9ae3d0ea5$var$C;
    try {
        if ($db8388f9ae3d0ea5$var$pk.transition = null, $db8388f9ae3d0ea5$var$C = 1, a) return a();
    } finally{
        $db8388f9ae3d0ea5$var$C = d, $db8388f9ae3d0ea5$var$pk.transition = c, $db8388f9ae3d0ea5$var$K = b, 0 === ($db8388f9ae3d0ea5$var$K & 6) && $db8388f9ae3d0ea5$var$jg();
    }
}
function $db8388f9ae3d0ea5$var$Ij() {
    $db8388f9ae3d0ea5$var$gj = $db8388f9ae3d0ea5$var$fj.current;
    $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$fj);
}
function $db8388f9ae3d0ea5$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $db8388f9ae3d0ea5$var$Gf(c));
    if (null !== $db8388f9ae3d0ea5$var$Y) for(c = $db8388f9ae3d0ea5$var$Y.return; null !== c;){
        var d = c;
        $db8388f9ae3d0ea5$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $db8388f9ae3d0ea5$var$$f();
                break;
            case 3:
                $db8388f9ae3d0ea5$var$Jh();
                $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$Wf);
                $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$H);
                $db8388f9ae3d0ea5$var$Oh();
                break;
            case 5:
                $db8388f9ae3d0ea5$var$Lh(d);
                break;
            case 4:
                $db8388f9ae3d0ea5$var$Jh();
                break;
            case 13:
                $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$M);
                break;
            case 19:
                $db8388f9ae3d0ea5$var$E($db8388f9ae3d0ea5$var$M);
                break;
            case 10:
                $db8388f9ae3d0ea5$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $db8388f9ae3d0ea5$var$Ij();
        }
        c = c.return;
    }
    $db8388f9ae3d0ea5$var$R = a;
    $db8388f9ae3d0ea5$var$Y = a = $db8388f9ae3d0ea5$var$wh(a.current, null);
    $db8388f9ae3d0ea5$var$Z = $db8388f9ae3d0ea5$var$gj = b;
    $db8388f9ae3d0ea5$var$T = 0;
    $db8388f9ae3d0ea5$var$qk = null;
    $db8388f9ae3d0ea5$var$sk = $db8388f9ae3d0ea5$var$rk = $db8388f9ae3d0ea5$var$hh = 0;
    $db8388f9ae3d0ea5$var$uk = $db8388f9ae3d0ea5$var$tk = null;
    if (null !== $db8388f9ae3d0ea5$var$Wg) {
        for(b = 0; b < $db8388f9ae3d0ea5$var$Wg.length; b++)if (c = $db8388f9ae3d0ea5$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $db8388f9ae3d0ea5$var$Wg = null;
    }
    return a;
}
function $db8388f9ae3d0ea5$var$Nk(a, b) {
    do {
        var c = $db8388f9ae3d0ea5$var$Y;
        try {
            $db8388f9ae3d0ea5$var$Qg();
            $db8388f9ae3d0ea5$var$Ph.current = $db8388f9ae3d0ea5$var$ai;
            if ($db8388f9ae3d0ea5$var$Sh) {
                for(var d = $db8388f9ae3d0ea5$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $db8388f9ae3d0ea5$var$Sh = !1;
            }
            $db8388f9ae3d0ea5$var$Rh = 0;
            $db8388f9ae3d0ea5$var$P = $db8388f9ae3d0ea5$var$O = $db8388f9ae3d0ea5$var$N = null;
            $db8388f9ae3d0ea5$var$Th = !1;
            $db8388f9ae3d0ea5$var$Uh = 0;
            $db8388f9ae3d0ea5$var$ok.current = null;
            if (null === c || null === c.return) {
                $db8388f9ae3d0ea5$var$T = 1;
                $db8388f9ae3d0ea5$var$qk = b;
                $db8388f9ae3d0ea5$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $db8388f9ae3d0ea5$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $db8388f9ae3d0ea5$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $db8388f9ae3d0ea5$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $db8388f9ae3d0ea5$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $db8388f9ae3d0ea5$var$Ti(f, l, b);
                            $db8388f9ae3d0ea5$var$uj();
                            break a;
                        }
                        k = Error($db8388f9ae3d0ea5$var$p(426));
                    }
                } else if ($db8388f9ae3d0ea5$var$I && h.mode & 1) {
                    var J = $db8388f9ae3d0ea5$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $db8388f9ae3d0ea5$var$Wi(J, g, h, f, b);
                        $db8388f9ae3d0ea5$var$Jg($db8388f9ae3d0ea5$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $db8388f9ae3d0ea5$var$Ki(k, h);
                4 !== $db8388f9ae3d0ea5$var$T && ($db8388f9ae3d0ea5$var$T = 2);
                null === $db8388f9ae3d0ea5$var$tk ? $db8388f9ae3d0ea5$var$tk = [
                    f
                ] : $db8388f9ae3d0ea5$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $db8388f9ae3d0ea5$var$Oi(f, k, b);
                            $db8388f9ae3d0ea5$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $db8388f9ae3d0ea5$var$Si || !$db8388f9ae3d0ea5$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $db8388f9ae3d0ea5$var$Ri(f, h, b);
                                $db8388f9ae3d0ea5$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $db8388f9ae3d0ea5$var$Tk(c);
        } catch (na) {
            b = na;
            $db8388f9ae3d0ea5$var$Y === c && null !== c && ($db8388f9ae3d0ea5$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $db8388f9ae3d0ea5$var$Kk() {
    var a = $db8388f9ae3d0ea5$var$nk.current;
    $db8388f9ae3d0ea5$var$nk.current = $db8388f9ae3d0ea5$var$ai;
    return null === a ? $db8388f9ae3d0ea5$var$ai : a;
}
function $db8388f9ae3d0ea5$var$uj() {
    if (0 === $db8388f9ae3d0ea5$var$T || 3 === $db8388f9ae3d0ea5$var$T || 2 === $db8388f9ae3d0ea5$var$T) $db8388f9ae3d0ea5$var$T = 4;
    null === $db8388f9ae3d0ea5$var$R || 0 === ($db8388f9ae3d0ea5$var$hh & 268435455) && 0 === ($db8388f9ae3d0ea5$var$rk & 268435455) || $db8388f9ae3d0ea5$var$Dk($db8388f9ae3d0ea5$var$R, $db8388f9ae3d0ea5$var$Z);
}
function $db8388f9ae3d0ea5$var$Jk(a, b) {
    var c = $db8388f9ae3d0ea5$var$K;
    $db8388f9ae3d0ea5$var$K |= 2;
    var d = $db8388f9ae3d0ea5$var$Kk();
    if ($db8388f9ae3d0ea5$var$R !== a || $db8388f9ae3d0ea5$var$Z !== b) $db8388f9ae3d0ea5$var$vk = null, $db8388f9ae3d0ea5$var$Lk(a, b);
    for(;;)try {
        $db8388f9ae3d0ea5$var$Uk();
        break;
    } catch (e) {
        $db8388f9ae3d0ea5$var$Nk(a, e);
    }
    $db8388f9ae3d0ea5$var$Qg();
    $db8388f9ae3d0ea5$var$K = c;
    $db8388f9ae3d0ea5$var$nk.current = d;
    if (null !== $db8388f9ae3d0ea5$var$Y) throw Error($db8388f9ae3d0ea5$var$p(261));
    $db8388f9ae3d0ea5$var$R = null;
    $db8388f9ae3d0ea5$var$Z = 0;
    return $db8388f9ae3d0ea5$var$T;
}
function $db8388f9ae3d0ea5$var$Uk() {
    for(; null !== $db8388f9ae3d0ea5$var$Y;)$db8388f9ae3d0ea5$var$Vk($db8388f9ae3d0ea5$var$Y);
}
function $db8388f9ae3d0ea5$var$Mk() {
    for(; null !== $db8388f9ae3d0ea5$var$Y && !$db8388f9ae3d0ea5$var$cc();)$db8388f9ae3d0ea5$var$Vk($db8388f9ae3d0ea5$var$Y);
}
function $db8388f9ae3d0ea5$var$Vk(a) {
    var b = $db8388f9ae3d0ea5$var$Wk(a.alternate, a, $db8388f9ae3d0ea5$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $db8388f9ae3d0ea5$var$Tk(a) : $db8388f9ae3d0ea5$var$Y = b;
    $db8388f9ae3d0ea5$var$ok.current = null;
}
function $db8388f9ae3d0ea5$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $db8388f9ae3d0ea5$var$Fj(c, b, $db8388f9ae3d0ea5$var$gj), null !== c) {
                $db8388f9ae3d0ea5$var$Y = c;
                return;
            }
        } else {
            c = $db8388f9ae3d0ea5$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $db8388f9ae3d0ea5$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $db8388f9ae3d0ea5$var$T = 6;
                $db8388f9ae3d0ea5$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $db8388f9ae3d0ea5$var$Y = b;
            return;
        }
        $db8388f9ae3d0ea5$var$Y = b = a;
    }while (null !== b);
    0 === $db8388f9ae3d0ea5$var$T && ($db8388f9ae3d0ea5$var$T = 5);
}
function $db8388f9ae3d0ea5$var$Qk(a, b, c) {
    var d = $db8388f9ae3d0ea5$var$C, e = $db8388f9ae3d0ea5$var$pk.transition;
    try {
        $db8388f9ae3d0ea5$var$pk.transition = null, $db8388f9ae3d0ea5$var$C = 1, $db8388f9ae3d0ea5$var$Xk(a, b, c, d);
    } finally{
        $db8388f9ae3d0ea5$var$pk.transition = e, $db8388f9ae3d0ea5$var$C = d;
    }
    return null;
}
function $db8388f9ae3d0ea5$var$Xk(a, b, c, d) {
    do $db8388f9ae3d0ea5$var$Ik();
    while (null !== $db8388f9ae3d0ea5$var$xk);
    if (0 !== ($db8388f9ae3d0ea5$var$K & 6)) throw Error($db8388f9ae3d0ea5$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($db8388f9ae3d0ea5$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $db8388f9ae3d0ea5$var$Bc(a, f);
    a === $db8388f9ae3d0ea5$var$R && ($db8388f9ae3d0ea5$var$Y = $db8388f9ae3d0ea5$var$R = null, $db8388f9ae3d0ea5$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $db8388f9ae3d0ea5$var$wk || ($db8388f9ae3d0ea5$var$wk = !0, $db8388f9ae3d0ea5$var$Gk($db8388f9ae3d0ea5$var$hc, function() {
        $db8388f9ae3d0ea5$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $db8388f9ae3d0ea5$var$pk.transition;
        $db8388f9ae3d0ea5$var$pk.transition = null;
        var g = $db8388f9ae3d0ea5$var$C;
        $db8388f9ae3d0ea5$var$C = 1;
        var h = $db8388f9ae3d0ea5$var$K;
        $db8388f9ae3d0ea5$var$K |= 4;
        $db8388f9ae3d0ea5$var$ok.current = null;
        $db8388f9ae3d0ea5$var$Pj(a, c);
        $db8388f9ae3d0ea5$var$ek(c, a);
        $db8388f9ae3d0ea5$var$Oe($db8388f9ae3d0ea5$var$Df);
        $db8388f9ae3d0ea5$var$dd = !!$db8388f9ae3d0ea5$var$Cf;
        $db8388f9ae3d0ea5$var$Df = $db8388f9ae3d0ea5$var$Cf = null;
        a.current = c;
        $db8388f9ae3d0ea5$var$ik(c, a, e);
        $db8388f9ae3d0ea5$var$dc();
        $db8388f9ae3d0ea5$var$K = h;
        $db8388f9ae3d0ea5$var$C = g;
        $db8388f9ae3d0ea5$var$pk.transition = f;
    } else a.current = c;
    $db8388f9ae3d0ea5$var$wk && ($db8388f9ae3d0ea5$var$wk = !1, $db8388f9ae3d0ea5$var$xk = a, $db8388f9ae3d0ea5$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($db8388f9ae3d0ea5$var$Si = null);
    $db8388f9ae3d0ea5$var$mc(c.stateNode, d);
    $db8388f9ae3d0ea5$var$Ek(a, $db8388f9ae3d0ea5$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($db8388f9ae3d0ea5$var$Pi) throw $db8388f9ae3d0ea5$var$Pi = !1, a = $db8388f9ae3d0ea5$var$Qi, $db8388f9ae3d0ea5$var$Qi = null, a;
    0 !== ($db8388f9ae3d0ea5$var$yk & 1) && 0 !== a.tag && $db8388f9ae3d0ea5$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $db8388f9ae3d0ea5$var$Ak ? $db8388f9ae3d0ea5$var$zk++ : ($db8388f9ae3d0ea5$var$zk = 0, $db8388f9ae3d0ea5$var$Ak = a) : $db8388f9ae3d0ea5$var$zk = 0;
    $db8388f9ae3d0ea5$var$jg();
    return null;
}
function $db8388f9ae3d0ea5$var$Ik() {
    if (null !== $db8388f9ae3d0ea5$var$xk) {
        var a = $db8388f9ae3d0ea5$var$Dc($db8388f9ae3d0ea5$var$yk), b = $db8388f9ae3d0ea5$var$pk.transition, c = $db8388f9ae3d0ea5$var$C;
        try {
            $db8388f9ae3d0ea5$var$pk.transition = null;
            $db8388f9ae3d0ea5$var$C = 16 > a ? 16 : a;
            if (null === $db8388f9ae3d0ea5$var$xk) var d = !1;
            else {
                a = $db8388f9ae3d0ea5$var$xk;
                $db8388f9ae3d0ea5$var$xk = null;
                $db8388f9ae3d0ea5$var$yk = 0;
                if (0 !== ($db8388f9ae3d0ea5$var$K & 6)) throw Error($db8388f9ae3d0ea5$var$p(331));
                var e = $db8388f9ae3d0ea5$var$K;
                $db8388f9ae3d0ea5$var$K |= 4;
                for($db8388f9ae3d0ea5$var$V = a.current; null !== $db8388f9ae3d0ea5$var$V;){
                    var f = $db8388f9ae3d0ea5$var$V, g = f.child;
                    if (0 !== ($db8388f9ae3d0ea5$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($db8388f9ae3d0ea5$var$V = l; null !== $db8388f9ae3d0ea5$var$V;){
                                    var m = $db8388f9ae3d0ea5$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $db8388f9ae3d0ea5$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $db8388f9ae3d0ea5$var$V = q;
                                    else for(; null !== $db8388f9ae3d0ea5$var$V;){
                                        m = $db8388f9ae3d0ea5$var$V;
                                        var r = m.sibling, y = m.return;
                                        $db8388f9ae3d0ea5$var$Tj(m);
                                        if (m === l) {
                                            $db8388f9ae3d0ea5$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $db8388f9ae3d0ea5$var$V = r;
                                            break;
                                        }
                                        $db8388f9ae3d0ea5$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $db8388f9ae3d0ea5$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $db8388f9ae3d0ea5$var$V = g;
                    else b: for(; null !== $db8388f9ae3d0ea5$var$V;){
                        f = $db8388f9ae3d0ea5$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $db8388f9ae3d0ea5$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $db8388f9ae3d0ea5$var$V = x;
                            break b;
                        }
                        $db8388f9ae3d0ea5$var$V = f.return;
                    }
                }
                var w = a.current;
                for($db8388f9ae3d0ea5$var$V = w; null !== $db8388f9ae3d0ea5$var$V;){
                    g = $db8388f9ae3d0ea5$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $db8388f9ae3d0ea5$var$V = u;
                    else b: for(g = w; null !== $db8388f9ae3d0ea5$var$V;){
                        h = $db8388f9ae3d0ea5$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $db8388f9ae3d0ea5$var$Rj(9, h);
                            }
                        } catch (na) {
                            $db8388f9ae3d0ea5$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $db8388f9ae3d0ea5$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $db8388f9ae3d0ea5$var$V = F;
                            break b;
                        }
                        $db8388f9ae3d0ea5$var$V = h.return;
                    }
                }
                $db8388f9ae3d0ea5$var$K = e;
                $db8388f9ae3d0ea5$var$jg();
                if ($db8388f9ae3d0ea5$var$lc && "function" === typeof $db8388f9ae3d0ea5$var$lc.onPostCommitFiberRoot) try {
                    $db8388f9ae3d0ea5$var$lc.onPostCommitFiberRoot($db8388f9ae3d0ea5$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $db8388f9ae3d0ea5$var$C = c, $db8388f9ae3d0ea5$var$pk.transition = b;
        }
    }
    return !1;
}
function $db8388f9ae3d0ea5$var$Yk(a, b, c) {
    b = $db8388f9ae3d0ea5$var$Ki(c, b);
    b = $db8388f9ae3d0ea5$var$Oi(a, b, 1);
    a = $db8388f9ae3d0ea5$var$dh(a, b, 1);
    b = $db8388f9ae3d0ea5$var$L();
    null !== a && ($db8388f9ae3d0ea5$var$Ac(a, 1, b), $db8388f9ae3d0ea5$var$Ek(a, b));
}
function $db8388f9ae3d0ea5$var$W(a, b, c) {
    if (3 === a.tag) $db8388f9ae3d0ea5$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $db8388f9ae3d0ea5$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $db8388f9ae3d0ea5$var$Si || !$db8388f9ae3d0ea5$var$Si.has(d))) {
                a = $db8388f9ae3d0ea5$var$Ki(c, a);
                a = $db8388f9ae3d0ea5$var$Ri(b, a, 1);
                b = $db8388f9ae3d0ea5$var$dh(b, a, 1);
                a = $db8388f9ae3d0ea5$var$L();
                null !== b && ($db8388f9ae3d0ea5$var$Ac(b, 1, a), $db8388f9ae3d0ea5$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $db8388f9ae3d0ea5$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $db8388f9ae3d0ea5$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $db8388f9ae3d0ea5$var$R === a && ($db8388f9ae3d0ea5$var$Z & c) === c && (4 === $db8388f9ae3d0ea5$var$T || 3 === $db8388f9ae3d0ea5$var$T && ($db8388f9ae3d0ea5$var$Z & 130023424) === $db8388f9ae3d0ea5$var$Z && 500 > $db8388f9ae3d0ea5$var$B() - $db8388f9ae3d0ea5$var$gk ? $db8388f9ae3d0ea5$var$Lk(a, 0) : $db8388f9ae3d0ea5$var$sk |= c);
    $db8388f9ae3d0ea5$var$Ek(a, b);
}
function $db8388f9ae3d0ea5$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $db8388f9ae3d0ea5$var$sc, $db8388f9ae3d0ea5$var$sc <<= 1, 0 === ($db8388f9ae3d0ea5$var$sc & 130023424) && ($db8388f9ae3d0ea5$var$sc = 4194304)));
    var c = $db8388f9ae3d0ea5$var$L();
    a = $db8388f9ae3d0ea5$var$Zg(a, b);
    null !== a && ($db8388f9ae3d0ea5$var$Ac(a, b, c), $db8388f9ae3d0ea5$var$Ek(a, c));
}
function $db8388f9ae3d0ea5$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $db8388f9ae3d0ea5$var$Zk(a, c);
}
function $db8388f9ae3d0ea5$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($db8388f9ae3d0ea5$var$p(314));
    }
    null !== d && d.delete(b);
    $db8388f9ae3d0ea5$var$Zk(a, c);
}
var $db8388f9ae3d0ea5$var$Wk;
$db8388f9ae3d0ea5$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $db8388f9ae3d0ea5$var$Wf.current) $db8388f9ae3d0ea5$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $db8388f9ae3d0ea5$var$Ug = !1, $db8388f9ae3d0ea5$var$zj(a, b, c);
            $db8388f9ae3d0ea5$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $db8388f9ae3d0ea5$var$Ug = !1, $db8388f9ae3d0ea5$var$I && 0 !== (b.flags & 1048576) && $db8388f9ae3d0ea5$var$ug(b, $db8388f9ae3d0ea5$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $db8388f9ae3d0ea5$var$jj(a, b);
            a = b.pendingProps;
            var e = $db8388f9ae3d0ea5$var$Yf(b, $db8388f9ae3d0ea5$var$H.current);
            $db8388f9ae3d0ea5$var$Tg(b, c);
            e = $db8388f9ae3d0ea5$var$Xh(null, b, d, a, e, c);
            var f = $db8388f9ae3d0ea5$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $db8388f9ae3d0ea5$var$Zf(d) ? (f = !0, $db8388f9ae3d0ea5$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $db8388f9ae3d0ea5$var$ah(b), e.updater = $db8388f9ae3d0ea5$var$nh, b.stateNode = e, e._reactInternals = b, $db8388f9ae3d0ea5$var$rh(b, d, a, c), b = $db8388f9ae3d0ea5$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $db8388f9ae3d0ea5$var$I && f && $db8388f9ae3d0ea5$var$vg(b), $db8388f9ae3d0ea5$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $db8388f9ae3d0ea5$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $db8388f9ae3d0ea5$var$$k(d);
                a = $db8388f9ae3d0ea5$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $db8388f9ae3d0ea5$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $db8388f9ae3d0ea5$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $db8388f9ae3d0ea5$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $db8388f9ae3d0ea5$var$aj(null, b, d, $db8388f9ae3d0ea5$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($db8388f9ae3d0ea5$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $db8388f9ae3d0ea5$var$Lg(d, e), $db8388f9ae3d0ea5$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $db8388f9ae3d0ea5$var$Lg(d, e), $db8388f9ae3d0ea5$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $db8388f9ae3d0ea5$var$lj(b);
                if (null === a) throw Error($db8388f9ae3d0ea5$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $db8388f9ae3d0ea5$var$bh(a, b);
                $db8388f9ae3d0ea5$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $db8388f9ae3d0ea5$var$Ki(Error($db8388f9ae3d0ea5$var$p(423)), b);
                        b = $db8388f9ae3d0ea5$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $db8388f9ae3d0ea5$var$Ki(Error($db8388f9ae3d0ea5$var$p(424)), b);
                        b = $db8388f9ae3d0ea5$var$mj(a, b, d, c, e);
                        break a;
                    } else for($db8388f9ae3d0ea5$var$yg = $db8388f9ae3d0ea5$var$Lf(b.stateNode.containerInfo.firstChild), $db8388f9ae3d0ea5$var$xg = b, $db8388f9ae3d0ea5$var$I = !0, $db8388f9ae3d0ea5$var$zg = null, c = $db8388f9ae3d0ea5$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $db8388f9ae3d0ea5$var$Ig();
                    if (d === e) {
                        b = $db8388f9ae3d0ea5$var$$i(a, b, c);
                        break a;
                    }
                    $db8388f9ae3d0ea5$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $db8388f9ae3d0ea5$var$Kh(b), null === a && $db8388f9ae3d0ea5$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $db8388f9ae3d0ea5$var$Ef(d, e) ? g = null : null !== f && $db8388f9ae3d0ea5$var$Ef(d, f) && (b.flags |= 32), $db8388f9ae3d0ea5$var$hj(a, b), $db8388f9ae3d0ea5$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $db8388f9ae3d0ea5$var$Eg(b), null;
        case 13:
            return $db8388f9ae3d0ea5$var$pj(a, b, c);
        case 4:
            return $db8388f9ae3d0ea5$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $db8388f9ae3d0ea5$var$Bh(b, null, d, c) : $db8388f9ae3d0ea5$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $db8388f9ae3d0ea5$var$Lg(d, e), $db8388f9ae3d0ea5$var$Zi(a, b, d, e, c);
        case 7:
            return $db8388f9ae3d0ea5$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $db8388f9ae3d0ea5$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $db8388f9ae3d0ea5$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $db8388f9ae3d0ea5$var$G($db8388f9ae3d0ea5$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($db8388f9ae3d0ea5$var$He(f.value, g)) {
                        if (f.children === e.children && !$db8388f9ae3d0ea5$var$Wf.current) {
                            b = $db8388f9ae3d0ea5$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $db8388f9ae3d0ea5$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $db8388f9ae3d0ea5$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($db8388f9ae3d0ea5$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $db8388f9ae3d0ea5$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $db8388f9ae3d0ea5$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $db8388f9ae3d0ea5$var$Tg(b, c), e = $db8388f9ae3d0ea5$var$Vg(e), d = d(e), b.flags |= 1, $db8388f9ae3d0ea5$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $db8388f9ae3d0ea5$var$Lg(d, b.pendingProps), e = $db8388f9ae3d0ea5$var$Lg(d.type, e), $db8388f9ae3d0ea5$var$aj(a, b, d, e, c);
        case 15:
            return $db8388f9ae3d0ea5$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $db8388f9ae3d0ea5$var$Lg(d, e), $db8388f9ae3d0ea5$var$jj(a, b), b.tag = 1, $db8388f9ae3d0ea5$var$Zf(d) ? (a = !0, $db8388f9ae3d0ea5$var$cg(b)) : a = !1, $db8388f9ae3d0ea5$var$Tg(b, c), $db8388f9ae3d0ea5$var$ph(b, d, e), $db8388f9ae3d0ea5$var$rh(b, d, e, c), $db8388f9ae3d0ea5$var$kj(null, b, d, !0, a, c);
        case 19:
            return $db8388f9ae3d0ea5$var$yj(a, b, c);
        case 22:
            return $db8388f9ae3d0ea5$var$ej(a, b, c);
    }
    throw Error($db8388f9ae3d0ea5$var$p(156, b.tag));
};
function $db8388f9ae3d0ea5$var$Gk(a, b) {
    return $db8388f9ae3d0ea5$var$ac(a, b);
}
function $db8388f9ae3d0ea5$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $db8388f9ae3d0ea5$var$Bg(a, b, c, d) {
    return new $db8388f9ae3d0ea5$var$al(a, b, c, d);
}
function $db8388f9ae3d0ea5$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $db8388f9ae3d0ea5$var$$k(a) {
    if ("function" === typeof a) return $db8388f9ae3d0ea5$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $db8388f9ae3d0ea5$var$Da) return 11;
        if (a === $db8388f9ae3d0ea5$var$Ga) return 14;
    }
    return 2;
}
function $db8388f9ae3d0ea5$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $db8388f9ae3d0ea5$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $db8388f9ae3d0ea5$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $db8388f9ae3d0ea5$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $db8388f9ae3d0ea5$var$ya:
            return $db8388f9ae3d0ea5$var$Ah(c.children, e, f, b);
        case $db8388f9ae3d0ea5$var$za:
            g = 8;
            e |= 8;
            break;
        case $db8388f9ae3d0ea5$var$Aa:
            return a = $db8388f9ae3d0ea5$var$Bg(12, c, b, e | 2), a.elementType = $db8388f9ae3d0ea5$var$Aa, a.lanes = f, a;
        case $db8388f9ae3d0ea5$var$Ea:
            return a = $db8388f9ae3d0ea5$var$Bg(13, c, b, e), a.elementType = $db8388f9ae3d0ea5$var$Ea, a.lanes = f, a;
        case $db8388f9ae3d0ea5$var$Fa:
            return a = $db8388f9ae3d0ea5$var$Bg(19, c, b, e), a.elementType = $db8388f9ae3d0ea5$var$Fa, a.lanes = f, a;
        case $db8388f9ae3d0ea5$var$Ia:
            return $db8388f9ae3d0ea5$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $db8388f9ae3d0ea5$var$Ba:
                    g = 10;
                    break a;
                case $db8388f9ae3d0ea5$var$Ca:
                    g = 9;
                    break a;
                case $db8388f9ae3d0ea5$var$Da:
                    g = 11;
                    break a;
                case $db8388f9ae3d0ea5$var$Ga:
                    g = 14;
                    break a;
                case $db8388f9ae3d0ea5$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($db8388f9ae3d0ea5$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $db8388f9ae3d0ea5$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $db8388f9ae3d0ea5$var$Ah(a, b, c, d) {
    a = $db8388f9ae3d0ea5$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $db8388f9ae3d0ea5$var$qj(a, b, c, d) {
    a = $db8388f9ae3d0ea5$var$Bg(22, a, d, b);
    a.elementType = $db8388f9ae3d0ea5$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $db8388f9ae3d0ea5$var$xh(a, b, c) {
    a = $db8388f9ae3d0ea5$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $db8388f9ae3d0ea5$var$zh(a, b, c) {
    b = $db8388f9ae3d0ea5$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $db8388f9ae3d0ea5$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $db8388f9ae3d0ea5$var$zc(0);
    this.expirationTimes = $db8388f9ae3d0ea5$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $db8388f9ae3d0ea5$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $db8388f9ae3d0ea5$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $db8388f9ae3d0ea5$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $db8388f9ae3d0ea5$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $db8388f9ae3d0ea5$var$ah(f);
    return a;
}
function $db8388f9ae3d0ea5$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $db8388f9ae3d0ea5$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $db8388f9ae3d0ea5$var$el(a) {
    if (!a) return $db8388f9ae3d0ea5$var$Vf;
    a = a._reactInternals;
    a: {
        if ($db8388f9ae3d0ea5$var$Vb(a) !== a || 1 !== a.tag) throw Error($db8388f9ae3d0ea5$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($db8388f9ae3d0ea5$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($db8388f9ae3d0ea5$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($db8388f9ae3d0ea5$var$Zf(c)) return $db8388f9ae3d0ea5$var$bg(a, c, b);
    }
    return b;
}
function $db8388f9ae3d0ea5$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $db8388f9ae3d0ea5$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $db8388f9ae3d0ea5$var$el(null);
    c = a.current;
    d = $db8388f9ae3d0ea5$var$L();
    e = $db8388f9ae3d0ea5$var$lh(c);
    f = $db8388f9ae3d0ea5$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $db8388f9ae3d0ea5$var$dh(c, f, e);
    a.current.lanes = e;
    $db8388f9ae3d0ea5$var$Ac(a, e, d);
    $db8388f9ae3d0ea5$var$Ek(a, d);
    return a;
}
function $db8388f9ae3d0ea5$var$gl(a, b, c, d) {
    var e = b.current, f = $db8388f9ae3d0ea5$var$L(), g = $db8388f9ae3d0ea5$var$lh(e);
    c = $db8388f9ae3d0ea5$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $db8388f9ae3d0ea5$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $db8388f9ae3d0ea5$var$dh(e, b, g);
    null !== a && ($db8388f9ae3d0ea5$var$mh(a, e, g, f), $db8388f9ae3d0ea5$var$eh(a, e, g));
    return g;
}
function $db8388f9ae3d0ea5$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $db8388f9ae3d0ea5$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $db8388f9ae3d0ea5$var$jl(a, b) {
    $db8388f9ae3d0ea5$var$il(a, b);
    (a = a.alternate) && $db8388f9ae3d0ea5$var$il(a, b);
}
function $db8388f9ae3d0ea5$var$kl() {
    return null;
}
var $db8388f9ae3d0ea5$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $db8388f9ae3d0ea5$var$ml(a) {
    this._internalRoot = a;
}
$db8388f9ae3d0ea5$var$nl.prototype.render = $db8388f9ae3d0ea5$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($db8388f9ae3d0ea5$var$p(409));
    $db8388f9ae3d0ea5$var$gl(a, b, null, null);
};
$db8388f9ae3d0ea5$var$nl.prototype.unmount = $db8388f9ae3d0ea5$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $db8388f9ae3d0ea5$var$Sk(function() {
            $db8388f9ae3d0ea5$var$gl(null, a, null, null);
        });
        b[$db8388f9ae3d0ea5$var$uf] = null;
    }
};
function $db8388f9ae3d0ea5$var$nl(a) {
    this._internalRoot = a;
}
$db8388f9ae3d0ea5$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $db8388f9ae3d0ea5$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $db8388f9ae3d0ea5$var$Qc.length && 0 !== b && b < $db8388f9ae3d0ea5$var$Qc[c].priority; c++);
        $db8388f9ae3d0ea5$var$Qc.splice(c, 0, a);
        0 === c && $db8388f9ae3d0ea5$var$Vc(a);
    }
};
function $db8388f9ae3d0ea5$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $db8388f9ae3d0ea5$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $db8388f9ae3d0ea5$var$ql() {}
function $db8388f9ae3d0ea5$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $db8388f9ae3d0ea5$var$hl(g);
                f.call(a);
            };
        }
        var g = $db8388f9ae3d0ea5$var$fl(b, d, a, 0, null, !1, !1, "", $db8388f9ae3d0ea5$var$ql);
        a._reactRootContainer = g;
        a[$db8388f9ae3d0ea5$var$uf] = g.current;
        $db8388f9ae3d0ea5$var$sf(8 === a.nodeType ? a.parentNode : a);
        $db8388f9ae3d0ea5$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $db8388f9ae3d0ea5$var$hl(k);
            h.call(a);
        };
    }
    var k = $db8388f9ae3d0ea5$var$cl(a, 0, !1, null, null, !1, !1, "", $db8388f9ae3d0ea5$var$ql);
    a._reactRootContainer = k;
    a[$db8388f9ae3d0ea5$var$uf] = k.current;
    $db8388f9ae3d0ea5$var$sf(8 === a.nodeType ? a.parentNode : a);
    $db8388f9ae3d0ea5$var$Sk(function() {
        $db8388f9ae3d0ea5$var$gl(b, k, c, d);
    });
    return k;
}
function $db8388f9ae3d0ea5$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $db8388f9ae3d0ea5$var$hl(g);
                h.call(a);
            };
        }
        $db8388f9ae3d0ea5$var$gl(b, g, a, e);
    } else g = $db8388f9ae3d0ea5$var$rl(c, b, a, e, d);
    return $db8388f9ae3d0ea5$var$hl(g);
}
$db8388f9ae3d0ea5$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $db8388f9ae3d0ea5$var$tc(b.pendingLanes);
                0 !== c && ($db8388f9ae3d0ea5$var$Cc(b, c | 1), $db8388f9ae3d0ea5$var$Ek(b, $db8388f9ae3d0ea5$var$B()), 0 === ($db8388f9ae3d0ea5$var$K & 6) && ($db8388f9ae3d0ea5$var$Hj = $db8388f9ae3d0ea5$var$B() + 500, $db8388f9ae3d0ea5$var$jg()));
            }
            break;
        case 13:
            $db8388f9ae3d0ea5$var$Sk(function() {
                var b = $db8388f9ae3d0ea5$var$Zg(a, 1);
                if (null !== b) {
                    var c = $db8388f9ae3d0ea5$var$L();
                    $db8388f9ae3d0ea5$var$mh(b, a, 1, c);
                }
            }), $db8388f9ae3d0ea5$var$jl(a, 1);
    }
};
$db8388f9ae3d0ea5$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $db8388f9ae3d0ea5$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $db8388f9ae3d0ea5$var$L();
            $db8388f9ae3d0ea5$var$mh(b, a, 134217728, c);
        }
        $db8388f9ae3d0ea5$var$jl(a, 134217728);
    }
};
$db8388f9ae3d0ea5$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $db8388f9ae3d0ea5$var$lh(a), c = $db8388f9ae3d0ea5$var$Zg(a, b);
        if (null !== c) {
            var d = $db8388f9ae3d0ea5$var$L();
            $db8388f9ae3d0ea5$var$mh(c, a, b, d);
        }
        $db8388f9ae3d0ea5$var$jl(a, b);
    }
};
$db8388f9ae3d0ea5$var$Hc = function() {
    return $db8388f9ae3d0ea5$var$C;
};
$db8388f9ae3d0ea5$var$Ic = function(a, b) {
    var c = $db8388f9ae3d0ea5$var$C;
    try {
        return $db8388f9ae3d0ea5$var$C = a, b();
    } finally{
        $db8388f9ae3d0ea5$var$C = c;
    }
};
$db8388f9ae3d0ea5$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $db8388f9ae3d0ea5$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $db8388f9ae3d0ea5$var$Db(d);
                        if (!e) throw Error($db8388f9ae3d0ea5$var$p(90));
                        $db8388f9ae3d0ea5$var$Wa(d);
                        $db8388f9ae3d0ea5$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $db8388f9ae3d0ea5$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $db8388f9ae3d0ea5$var$fb(a, !!c.multiple, b, !1);
    }
};
$db8388f9ae3d0ea5$var$Gb = $db8388f9ae3d0ea5$var$Rk;
$db8388f9ae3d0ea5$var$Hb = $db8388f9ae3d0ea5$var$Sk;
var $db8388f9ae3d0ea5$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $db8388f9ae3d0ea5$var$Cb,
        $db8388f9ae3d0ea5$var$ue,
        $db8388f9ae3d0ea5$var$Db,
        $db8388f9ae3d0ea5$var$Eb,
        $db8388f9ae3d0ea5$var$Fb,
        $db8388f9ae3d0ea5$var$Rk
    ]
}, $db8388f9ae3d0ea5$var$ul = {
    findFiberByHostInstance: $db8388f9ae3d0ea5$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $db8388f9ae3d0ea5$var$vl = {
    bundleType: $db8388f9ae3d0ea5$var$ul.bundleType,
    version: $db8388f9ae3d0ea5$var$ul.version,
    rendererPackageName: $db8388f9ae3d0ea5$var$ul.rendererPackageName,
    rendererConfig: $db8388f9ae3d0ea5$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $db8388f9ae3d0ea5$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $db8388f9ae3d0ea5$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $db8388f9ae3d0ea5$var$ul.findFiberByHostInstance || $db8388f9ae3d0ea5$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $db8388f9ae3d0ea5$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$db8388f9ae3d0ea5$var$wl.isDisabled && $db8388f9ae3d0ea5$var$wl.supportsFiber) try {
        $db8388f9ae3d0ea5$var$kc = $db8388f9ae3d0ea5$var$wl.inject($db8388f9ae3d0ea5$var$vl), $db8388f9ae3d0ea5$var$lc = $db8388f9ae3d0ea5$var$wl;
    } catch (a) {}
}
$db8388f9ae3d0ea5$export$ae55be85d98224ed = $db8388f9ae3d0ea5$var$tl;
$db8388f9ae3d0ea5$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$db8388f9ae3d0ea5$var$ol(b)) throw Error($db8388f9ae3d0ea5$var$p(200));
    return $db8388f9ae3d0ea5$var$dl(a, b, null, c);
};
$db8388f9ae3d0ea5$export$882461b6382ed46c = function(a, b) {
    if (!$db8388f9ae3d0ea5$var$ol(a)) throw Error($db8388f9ae3d0ea5$var$p(299));
    var c = !1, d = "", e = $db8388f9ae3d0ea5$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $db8388f9ae3d0ea5$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$db8388f9ae3d0ea5$var$uf] = b.current;
    $db8388f9ae3d0ea5$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $db8388f9ae3d0ea5$var$ml(b);
};
$db8388f9ae3d0ea5$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($db8388f9ae3d0ea5$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($db8388f9ae3d0ea5$var$p(268, a));
    }
    a = $db8388f9ae3d0ea5$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$db8388f9ae3d0ea5$export$cd75ccfd720a3cd4 = function(a) {
    return $db8388f9ae3d0ea5$var$Sk(a);
};
$db8388f9ae3d0ea5$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$db8388f9ae3d0ea5$var$pl(b)) throw Error($db8388f9ae3d0ea5$var$p(200));
    return $db8388f9ae3d0ea5$var$sl(null, a, b, !0, c);
};
$db8388f9ae3d0ea5$export$757ceba2d55c277e = function(a, b, c) {
    if (!$db8388f9ae3d0ea5$var$ol(a)) throw Error($db8388f9ae3d0ea5$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $db8388f9ae3d0ea5$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $db8388f9ae3d0ea5$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$db8388f9ae3d0ea5$var$uf] = b.current;
    $db8388f9ae3d0ea5$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $db8388f9ae3d0ea5$var$nl(b);
};
$db8388f9ae3d0ea5$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$db8388f9ae3d0ea5$var$pl(b)) throw Error($db8388f9ae3d0ea5$var$p(200));
    return $db8388f9ae3d0ea5$var$sl(null, a, b, !1, c);
};
$db8388f9ae3d0ea5$export$502457920280e6be = function(a) {
    if (!$db8388f9ae3d0ea5$var$pl(a)) throw Error($db8388f9ae3d0ea5$var$p(40));
    return a._reactRootContainer ? ($db8388f9ae3d0ea5$var$Sk(function() {
        $db8388f9ae3d0ea5$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$db8388f9ae3d0ea5$var$uf] = null;
        });
    }), !0) : !1;
};
$db8388f9ae3d0ea5$export$c78a37762a8d58e1 = $db8388f9ae3d0ea5$var$Rk;
$db8388f9ae3d0ea5$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$db8388f9ae3d0ea5$var$pl(c)) throw Error($db8388f9ae3d0ea5$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($db8388f9ae3d0ea5$var$p(38));
    return $db8388f9ae3d0ea5$var$sl(a, b, c, !1, d);
};
$db8388f9ae3d0ea5$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("7ZzgL", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dtkyr"));

});
parcelRegister("dtkyr", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9ceded7a0cc8b709$export$c4744153514ff05d; }, function (v) { return $9ceded7a0cc8b709$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9ceded7a0cc8b709$export$3e506c1ccc9cc1a7; }, function (v) { return $9ceded7a0cc8b709$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9ceded7a0cc8b709$export$e26fe2ed2fa76875; }, function (v) { return $9ceded7a0cc8b709$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9ceded7a0cc8b709$export$502329bbf4b505b1; }, function (v) { return $9ceded7a0cc8b709$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9ceded7a0cc8b709$export$6e3807111c4874c4; }, function (v) { return $9ceded7a0cc8b709$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9ceded7a0cc8b709$export$c27134553091fb3a; }, function (v) { return $9ceded7a0cc8b709$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9ceded7a0cc8b709$export$33ee1acdc04fd2a2; }, function (v) { return $9ceded7a0cc8b709$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9ceded7a0cc8b709$export$b00a404bbd5edef2; }, function (v) { return $9ceded7a0cc8b709$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9ceded7a0cc8b709$export$8352ce38b91d0c62; }, function (v) { return $9ceded7a0cc8b709$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9ceded7a0cc8b709$export$d66a1c1c77bd778b; }, function (v) { return $9ceded7a0cc8b709$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9ceded7a0cc8b709$export$d3dfb8e4810cb555; }, function (v) { return $9ceded7a0cc8b709$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9ceded7a0cc8b709$export$839f9183b0465a69; }, function (v) { return $9ceded7a0cc8b709$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9ceded7a0cc8b709$export$72fdf0e06517287b; }, function (v) { return $9ceded7a0cc8b709$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9ceded7a0cc8b709$export$4b844e58a3e414b4; }, function (v) { return $9ceded7a0cc8b709$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9ceded7a0cc8b709$export$816d2913ae6b83b1; }, function (v) { return $9ceded7a0cc8b709$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9ceded7a0cc8b709$export$61bcfe829111a1d0; }, function (v) { return $9ceded7a0cc8b709$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9ceded7a0cc8b709$export$7ee8c9beb337bc3f; }, function (v) { return $9ceded7a0cc8b709$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9ceded7a0cc8b709$export$b5836b71941fa3ed; }, function (v) { return $9ceded7a0cc8b709$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9ceded7a0cc8b709$export$cf845f2c119da08a; }, function (v) { return $9ceded7a0cc8b709$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9ceded7a0cc8b709$export$c4744153514ff05d;
var $9ceded7a0cc8b709$export$3e506c1ccc9cc1a7;
var $9ceded7a0cc8b709$export$e26fe2ed2fa76875;
var $9ceded7a0cc8b709$export$502329bbf4b505b1;
var $9ceded7a0cc8b709$export$6e3807111c4874c4;
var $9ceded7a0cc8b709$export$c27134553091fb3a;
var $9ceded7a0cc8b709$export$33ee1acdc04fd2a2;
var $9ceded7a0cc8b709$export$b00a404bbd5edef2;
var $9ceded7a0cc8b709$export$8352ce38b91d0c62;
var $9ceded7a0cc8b709$export$d66a1c1c77bd778b;
var $9ceded7a0cc8b709$export$d3dfb8e4810cb555;
var $9ceded7a0cc8b709$export$839f9183b0465a69;
var $9ceded7a0cc8b709$export$72fdf0e06517287b;
var $9ceded7a0cc8b709$export$4b844e58a3e414b4;
var $9ceded7a0cc8b709$export$816d2913ae6b83b1;
var $9ceded7a0cc8b709$export$61bcfe829111a1d0;
var $9ceded7a0cc8b709$export$7ee8c9beb337bc3f;
var $9ceded7a0cc8b709$export$b5836b71941fa3ed;
var $9ceded7a0cc8b709$export$cf845f2c119da08a;
'use strict';
function $9ceded7a0cc8b709$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9ceded7a0cc8b709$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9ceded7a0cc8b709$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9ceded7a0cc8b709$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9ceded7a0cc8b709$var$g(C, c)) n < e && 0 > $9ceded7a0cc8b709$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9ceded7a0cc8b709$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9ceded7a0cc8b709$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9ceded7a0cc8b709$var$l = performance;
    $9ceded7a0cc8b709$export$c4744153514ff05d = function() {
        return $9ceded7a0cc8b709$var$l.now();
    };
} else {
    var $9ceded7a0cc8b709$var$p = Date, $9ceded7a0cc8b709$var$q = $9ceded7a0cc8b709$var$p.now();
    $9ceded7a0cc8b709$export$c4744153514ff05d = function() {
        return $9ceded7a0cc8b709$var$p.now() - $9ceded7a0cc8b709$var$q;
    };
}
var $9ceded7a0cc8b709$var$r = [], $9ceded7a0cc8b709$var$t = [], $9ceded7a0cc8b709$var$u = 1, $9ceded7a0cc8b709$var$v = null, $9ceded7a0cc8b709$var$y = 3, $9ceded7a0cc8b709$var$z = !1, $9ceded7a0cc8b709$var$A = !1, $9ceded7a0cc8b709$var$B = !1, $9ceded7a0cc8b709$var$D = "function" === typeof setTimeout ? setTimeout : null, $9ceded7a0cc8b709$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9ceded7a0cc8b709$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9ceded7a0cc8b709$var$G(a) {
    for(var b = $9ceded7a0cc8b709$var$h($9ceded7a0cc8b709$var$t); null !== b;){
        if (null === b.callback) $9ceded7a0cc8b709$var$k($9ceded7a0cc8b709$var$t);
        else if (b.startTime <= a) $9ceded7a0cc8b709$var$k($9ceded7a0cc8b709$var$t), b.sortIndex = b.expirationTime, $9ceded7a0cc8b709$var$f($9ceded7a0cc8b709$var$r, b);
        else break;
        b = $9ceded7a0cc8b709$var$h($9ceded7a0cc8b709$var$t);
    }
}
function $9ceded7a0cc8b709$var$H(a) {
    $9ceded7a0cc8b709$var$B = !1;
    $9ceded7a0cc8b709$var$G(a);
    if (!$9ceded7a0cc8b709$var$A) {
        if (null !== $9ceded7a0cc8b709$var$h($9ceded7a0cc8b709$var$r)) $9ceded7a0cc8b709$var$A = !0, $9ceded7a0cc8b709$var$I($9ceded7a0cc8b709$var$J);
        else {
            var b = $9ceded7a0cc8b709$var$h($9ceded7a0cc8b709$var$t);
            null !== b && $9ceded7a0cc8b709$var$K($9ceded7a0cc8b709$var$H, b.startTime - a);
        }
    }
}
function $9ceded7a0cc8b709$var$J(a, b) {
    $9ceded7a0cc8b709$var$A = !1;
    $9ceded7a0cc8b709$var$B && ($9ceded7a0cc8b709$var$B = !1, $9ceded7a0cc8b709$var$E($9ceded7a0cc8b709$var$L), $9ceded7a0cc8b709$var$L = -1);
    $9ceded7a0cc8b709$var$z = !0;
    var c = $9ceded7a0cc8b709$var$y;
    try {
        $9ceded7a0cc8b709$var$G(b);
        for($9ceded7a0cc8b709$var$v = $9ceded7a0cc8b709$var$h($9ceded7a0cc8b709$var$r); null !== $9ceded7a0cc8b709$var$v && (!($9ceded7a0cc8b709$var$v.expirationTime > b) || a && !$9ceded7a0cc8b709$var$M());){
            var d = $9ceded7a0cc8b709$var$v.callback;
            if ("function" === typeof d) {
                $9ceded7a0cc8b709$var$v.callback = null;
                $9ceded7a0cc8b709$var$y = $9ceded7a0cc8b709$var$v.priorityLevel;
                var e = d($9ceded7a0cc8b709$var$v.expirationTime <= b);
                b = $9ceded7a0cc8b709$export$c4744153514ff05d();
                "function" === typeof e ? $9ceded7a0cc8b709$var$v.callback = e : $9ceded7a0cc8b709$var$v === $9ceded7a0cc8b709$var$h($9ceded7a0cc8b709$var$r) && $9ceded7a0cc8b709$var$k($9ceded7a0cc8b709$var$r);
                $9ceded7a0cc8b709$var$G(b);
            } else $9ceded7a0cc8b709$var$k($9ceded7a0cc8b709$var$r);
            $9ceded7a0cc8b709$var$v = $9ceded7a0cc8b709$var$h($9ceded7a0cc8b709$var$r);
        }
        if (null !== $9ceded7a0cc8b709$var$v) var w = !0;
        else {
            var m = $9ceded7a0cc8b709$var$h($9ceded7a0cc8b709$var$t);
            null !== m && $9ceded7a0cc8b709$var$K($9ceded7a0cc8b709$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9ceded7a0cc8b709$var$v = null, $9ceded7a0cc8b709$var$y = c, $9ceded7a0cc8b709$var$z = !1;
    }
}
var $9ceded7a0cc8b709$var$N = !1, $9ceded7a0cc8b709$var$O = null, $9ceded7a0cc8b709$var$L = -1, $9ceded7a0cc8b709$var$P = 5, $9ceded7a0cc8b709$var$Q = -1;
function $9ceded7a0cc8b709$var$M() {
    return $9ceded7a0cc8b709$export$c4744153514ff05d() - $9ceded7a0cc8b709$var$Q < $9ceded7a0cc8b709$var$P ? !1 : !0;
}
function $9ceded7a0cc8b709$var$R() {
    if (null !== $9ceded7a0cc8b709$var$O) {
        var a = $9ceded7a0cc8b709$export$c4744153514ff05d();
        $9ceded7a0cc8b709$var$Q = a;
        var b = !0;
        try {
            b = $9ceded7a0cc8b709$var$O(!0, a);
        } finally{
            b ? $9ceded7a0cc8b709$var$S() : ($9ceded7a0cc8b709$var$N = !1, $9ceded7a0cc8b709$var$O = null);
        }
    } else $9ceded7a0cc8b709$var$N = !1;
}
var $9ceded7a0cc8b709$var$S;
if ("function" === typeof $9ceded7a0cc8b709$var$F) $9ceded7a0cc8b709$var$S = function() {
    $9ceded7a0cc8b709$var$F($9ceded7a0cc8b709$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9ceded7a0cc8b709$var$T = new MessageChannel, $9ceded7a0cc8b709$var$U = $9ceded7a0cc8b709$var$T.port2;
    $9ceded7a0cc8b709$var$T.port1.onmessage = $9ceded7a0cc8b709$var$R;
    $9ceded7a0cc8b709$var$S = function() {
        $9ceded7a0cc8b709$var$U.postMessage(null);
    };
} else $9ceded7a0cc8b709$var$S = function() {
    $9ceded7a0cc8b709$var$D($9ceded7a0cc8b709$var$R, 0);
};
function $9ceded7a0cc8b709$var$I(a) {
    $9ceded7a0cc8b709$var$O = a;
    $9ceded7a0cc8b709$var$N || ($9ceded7a0cc8b709$var$N = !0, $9ceded7a0cc8b709$var$S());
}
function $9ceded7a0cc8b709$var$K(a, b) {
    $9ceded7a0cc8b709$var$L = $9ceded7a0cc8b709$var$D(function() {
        a($9ceded7a0cc8b709$export$c4744153514ff05d());
    }, b);
}
$9ceded7a0cc8b709$export$3e506c1ccc9cc1a7 = 5;
$9ceded7a0cc8b709$export$e26fe2ed2fa76875 = 1;
$9ceded7a0cc8b709$export$502329bbf4b505b1 = 4;
$9ceded7a0cc8b709$export$6e3807111c4874c4 = 3;
$9ceded7a0cc8b709$export$c27134553091fb3a = null;
$9ceded7a0cc8b709$export$33ee1acdc04fd2a2 = 2;
$9ceded7a0cc8b709$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9ceded7a0cc8b709$export$8352ce38b91d0c62 = function() {
    $9ceded7a0cc8b709$var$A || $9ceded7a0cc8b709$var$z || ($9ceded7a0cc8b709$var$A = !0, $9ceded7a0cc8b709$var$I($9ceded7a0cc8b709$var$J));
};
$9ceded7a0cc8b709$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9ceded7a0cc8b709$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9ceded7a0cc8b709$export$d3dfb8e4810cb555 = function() {
    return $9ceded7a0cc8b709$var$y;
};
$9ceded7a0cc8b709$export$839f9183b0465a69 = function() {
    return $9ceded7a0cc8b709$var$h($9ceded7a0cc8b709$var$r);
};
$9ceded7a0cc8b709$export$72fdf0e06517287b = function(a) {
    switch($9ceded7a0cc8b709$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9ceded7a0cc8b709$var$y;
    }
    var c = $9ceded7a0cc8b709$var$y;
    $9ceded7a0cc8b709$var$y = b;
    try {
        return a();
    } finally{
        $9ceded7a0cc8b709$var$y = c;
    }
};
$9ceded7a0cc8b709$export$4b844e58a3e414b4 = function() {};
$9ceded7a0cc8b709$export$816d2913ae6b83b1 = function() {};
$9ceded7a0cc8b709$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9ceded7a0cc8b709$var$y;
    $9ceded7a0cc8b709$var$y = a;
    try {
        return b();
    } finally{
        $9ceded7a0cc8b709$var$y = c;
    }
};
$9ceded7a0cc8b709$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9ceded7a0cc8b709$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9ceded7a0cc8b709$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9ceded7a0cc8b709$var$f($9ceded7a0cc8b709$var$t, a), null === $9ceded7a0cc8b709$var$h($9ceded7a0cc8b709$var$r) && a === $9ceded7a0cc8b709$var$h($9ceded7a0cc8b709$var$t) && ($9ceded7a0cc8b709$var$B ? ($9ceded7a0cc8b709$var$E($9ceded7a0cc8b709$var$L), $9ceded7a0cc8b709$var$L = -1) : $9ceded7a0cc8b709$var$B = !0, $9ceded7a0cc8b709$var$K($9ceded7a0cc8b709$var$H, c - d))) : (a.sortIndex = e, $9ceded7a0cc8b709$var$f($9ceded7a0cc8b709$var$r, a), $9ceded7a0cc8b709$var$A || $9ceded7a0cc8b709$var$z || ($9ceded7a0cc8b709$var$A = !0, $9ceded7a0cc8b709$var$I($9ceded7a0cc8b709$var$J)));
    return a;
};
$9ceded7a0cc8b709$export$b5836b71941fa3ed = $9ceded7a0cc8b709$var$M;
$9ceded7a0cc8b709$export$cf845f2c119da08a = function(a) {
    var b = $9ceded7a0cc8b709$var$y;
    return function() {
        var c = $9ceded7a0cc8b709$var$y;
        $9ceded7a0cc8b709$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9ceded7a0cc8b709$var$y = c;
        }
    };
};

});



parcelRegister("f5D4x", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $afc5a192b667a8e1$export$bf730a2d8bf68b42; }, function (v) { return $afc5a192b667a8e1$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $afc5a192b667a8e1$export$bf730a2d8bf68b42;
"use strict";

var $6uYXW = parcelRequire("6uYXW");
function $afc5a192b667a8e1$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $afc5a192b667a8e1$var$objectIs = "function" === typeof Object.is ? Object.is : $afc5a192b667a8e1$var$is, $afc5a192b667a8e1$var$useSyncExternalStore = $6uYXW.useSyncExternalStore, $afc5a192b667a8e1$var$useRef = $6uYXW.useRef, $afc5a192b667a8e1$var$useEffect = $6uYXW.useEffect, $afc5a192b667a8e1$var$useMemo = $6uYXW.useMemo, $afc5a192b667a8e1$var$useDebugValue = $6uYXW.useDebugValue;
$afc5a192b667a8e1$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $afc5a192b667a8e1$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $afc5a192b667a8e1$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($afc5a192b667a8e1$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $afc5a192b667a8e1$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $afc5a192b667a8e1$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $afc5a192b667a8e1$var$useDebugValue(value);
    return value;
};

});

parcelRegister("aZSdd", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $8019a7496ae3faee$export$bf730a2d8bf68b42; }, function (v) { return $8019a7496ae3faee$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8019a7496ae3faee$export$bf730a2d8bf68b42;
"use strict";

var $6uYXW = parcelRequire("6uYXW");

var $8JQzD = parcelRequire("8JQzD");
function $8019a7496ae3faee$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $8019a7496ae3faee$var$objectIs = "function" === typeof Object.is ? Object.is : $8019a7496ae3faee$var$is, $8019a7496ae3faee$var$useSyncExternalStore = $8JQzD.useSyncExternalStore, $8019a7496ae3faee$var$useRef = $6uYXW.useRef, $8019a7496ae3faee$var$useEffect = $6uYXW.useEffect, $8019a7496ae3faee$var$useMemo = $6uYXW.useMemo, $8019a7496ae3faee$var$useDebugValue = $6uYXW.useDebugValue;
$8019a7496ae3faee$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $8019a7496ae3faee$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $8019a7496ae3faee$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($8019a7496ae3faee$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $8019a7496ae3faee$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $8019a7496ae3faee$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $8019a7496ae3faee$var$useDebugValue(value);
    return value;
};

});
parcelRegister("8JQzD", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3suYI"));

});
parcelRegister("3suYI", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $284c0446ee4b48f3$export$306c0aa65ff9ec16; }, function (v) { return $284c0446ee4b48f3$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $284c0446ee4b48f3$export$306c0aa65ff9ec16;
"use strict";

var $6uYXW = parcelRequire("6uYXW");
function $284c0446ee4b48f3$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $284c0446ee4b48f3$var$objectIs = "function" === typeof Object.is ? Object.is : $284c0446ee4b48f3$var$is, $284c0446ee4b48f3$var$useState = $6uYXW.useState, $284c0446ee4b48f3$var$useEffect = $6uYXW.useEffect, $284c0446ee4b48f3$var$useLayoutEffect = $6uYXW.useLayoutEffect, $284c0446ee4b48f3$var$useDebugValue = $6uYXW.useDebugValue;
function $284c0446ee4b48f3$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $284c0446ee4b48f3$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $284c0446ee4b48f3$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $284c0446ee4b48f3$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $284c0446ee4b48f3$var$useEffect(function() {
        $284c0446ee4b48f3$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $284c0446ee4b48f3$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $284c0446ee4b48f3$var$useDebugValue(value);
    return value;
}
function $284c0446ee4b48f3$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$284c0446ee4b48f3$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $284c0446ee4b48f3$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $284c0446ee4b48f3$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $284c0446ee4b48f3$var$useSyncExternalStore$1 : $284c0446ee4b48f3$var$useSyncExternalStore$2;
$284c0446ee4b48f3$export$306c0aa65ff9ec16 = void 0 !== $6uYXW.useSyncExternalStore ? $6uYXW.useSyncExternalStore : $284c0446ee4b48f3$var$shim;

});



parcelRegister("eaGJn", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $2Wl5L = parcelRequire("2Wl5L");
function $a51325578fa3d364$var$emptyFunction() {}
function $a51325578fa3d364$var$emptyFunctionWithReset() {}
$a51325578fa3d364$var$emptyFunctionWithReset.resetWarningCache = $a51325578fa3d364$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $2Wl5L) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $a51325578fa3d364$var$emptyFunctionWithReset,
        resetWarningCache: $a51325578fa3d364$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("2Wl5L", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $22415bfad1d389c6$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $22415bfad1d389c6$var$ReactPropTypesSecret;

});


parcelRegister("dDyyD", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap');
/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */ var nonEnumShadows = !propertyIsEnumerable.call({
    'valueOf': 1
}, 'valueOf');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
    if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) return !value.length;
    var tag = getTag(value);
    if (tag == mapTag || tag == setTag) return !value.size;
    if (nonEnumShadows || isPrototype(value)) return !nativeKeys(value).length;
    for(var key in value){
        if (hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEmpty;

});

parcelRegister("6Ffwg", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRegister("j5aH7", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object), nativeMax = Math.max;
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
            else arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return identity;
    if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function baseOrderBy(collection, iteratees, orders) {
    var index = -1;
    iteratees = arrayMap(iteratees.length ? iteratees : [
        identity
    ], baseUnary(baseIteratee));
    var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
    });
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = array;
        return apply(func, this, otherArgs);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push('');
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, function(o) { return o.user; });
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 *
 * _.sortBy(users, 'user', function(o) {
 *   return Math.floor(o.age / 10);
 * });
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ var sortBy = baseRest(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = sortBy;

});

var $32c03629429003d8$exports = {};
'use strict';

$32c03629429003d8$exports = (parcelRequire("hcYib"));


var $b77ba2fb0905f4fb$export$882461b6382ed46c;
var $b77ba2fb0905f4fb$export$757ceba2d55c277e;
'use strict';
var $4e60b4008b7e4540$exports = {};
'use strict';
function $4e60b4008b7e4540$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($4e60b4008b7e4540$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$4e60b4008b7e4540$var$checkDCE();

$4e60b4008b7e4540$exports = (parcelRequire("iQsWA"));


var $b77ba2fb0905f4fb$var$i;
$b77ba2fb0905f4fb$export$882461b6382ed46c = $4e60b4008b7e4540$exports.createRoot;
$b77ba2fb0905f4fb$export$757ceba2d55c277e = $4e60b4008b7e4540$exports.hydrateRoot;



var $d6bb706f240c69b6$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $d6bb706f240c69b6$export$18a094aefa070634 = (obj, member, getter)=>{
    $d6bb706f240c69b6$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $d6bb706f240c69b6$export$addf369becd23283 = (obj, member, value1)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
};
var $d6bb706f240c69b6$export$42432efe6614d3b4 = (obj, member, value1, setter)=>{
    $d6bb706f240c69b6$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value1) : member.set(obj, value1);
    return value1;
};
var $d6bb706f240c69b6$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $d6bb706f240c69b6$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $d6bb706f240c69b6$export$18a094aefa070634(obj, member, getter);
        }
    });
var $d6bb706f240c69b6$export$fa92d15b718fce20 = (obj, member, method)=>{
    $d6bb706f240c69b6$var$__accessCheck(obj, member, "access private method");
    return method;
};



// src/utils.ts
var $91075ea0d0756915$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $91075ea0d0756915$export$8793edee2d425525() {
    return void 0;
}
function $91075ea0d0756915$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $91075ea0d0756915$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $91075ea0d0756915$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $91075ea0d0756915$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $91075ea0d0756915$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$91075ea0d0756915$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $91075ea0d0756915$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($91075ea0d0756915$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $91075ea0d0756915$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$91075ea0d0756915$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $91075ea0d0756915$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $91075ea0d0756915$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $91075ea0d0756915$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$91075ea0d0756915$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $91075ea0d0756915$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$91075ea0d0756915$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $91075ea0d0756915$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $91075ea0d0756915$export$7a8558113332b71e(a) && $91075ea0d0756915$export$7a8558113332b71e(b);
    if (array || $91075ea0d0756915$export$53b83ca8eaab0383(a) && $91075ea0d0756915$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if (!array && a[key] === void 0 && b[key] === void 0 && aItems.includes(key)) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $91075ea0d0756915$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $91075ea0d0756915$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $91075ea0d0756915$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $91075ea0d0756915$export$53b83ca8eaab0383(o) {
    if (!$91075ea0d0756915$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$91075ea0d0756915$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    return true;
}
function $91075ea0d0756915$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $91075ea0d0756915$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $91075ea0d0756915$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) return $91075ea0d0756915$export$77a71fc411098696(prevData, data);
    return data;
}
function $91075ea0d0756915$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $91075ea0d0756915$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $91075ea0d0756915$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $91075ea0d0756915$export$1aa5a89531b7670d = Symbol();







// src/notifyManager.ts
function $ca19c9b496b64b93$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = (cb)=>setTimeout(cb, 0);
    const setScheduler = (fn)=>{
        scheduleFn = fn;
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction,
        setScheduler: setScheduler
    };
}
var $ca19c9b496b64b93$export$520687f44db6e1ab = $ca19c9b496b64b93$export$316a8efd03cd1458();





// src/subscribable.ts
var $6164943b6c12fe94$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $b217e2cdf935894d$var$_focused, $b217e2cdf935894d$var$_cleanup, $b217e2cdf935894d$var$_setup;
var $b217e2cdf935894d$export$86f1af424b2ca4de = class extends (0, $6164943b6c12fe94$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $b217e2cdf935894d$var$_focused, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $b217e2cdf935894d$var$_cleanup, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $b217e2cdf935894d$var$_setup, void 0);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $b217e2cdf935894d$var$_setup, (onFocus)=>{
            if (!(0, $91075ea0d0756915$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $b217e2cdf935894d$var$_cleanup)) this.setEventListener((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $b217e2cdf935894d$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $b217e2cdf935894d$var$_cleanup)) == null || _a.call(this);
            (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $b217e2cdf935894d$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $b217e2cdf935894d$var$_setup, setup);
        (_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $b217e2cdf935894d$var$_cleanup)) == null || _a.call(this);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $b217e2cdf935894d$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $b217e2cdf935894d$var$_focused) !== focused;
        if (changed) {
            (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $b217e2cdf935894d$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $b217e2cdf935894d$var$_focused) === "boolean") return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $b217e2cdf935894d$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$b217e2cdf935894d$var$_focused = new WeakMap();
$b217e2cdf935894d$var$_cleanup = new WeakMap();
$b217e2cdf935894d$var$_setup = new WeakMap();
var $b217e2cdf935894d$export$6bf54661be5b02cf = new $b217e2cdf935894d$export$86f1af424b2ca4de();





var $620e7d45cdf9f89e$var$_online, $620e7d45cdf9f89e$var$_cleanup, $620e7d45cdf9f89e$var$_setup;
var $620e7d45cdf9f89e$export$58774fb55d5ff7fc = class extends (0, $6164943b6c12fe94$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $620e7d45cdf9f89e$var$_online, true);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $620e7d45cdf9f89e$var$_cleanup, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $620e7d45cdf9f89e$var$_setup, void 0);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $620e7d45cdf9f89e$var$_setup, (onOnline)=>{
            if (!(0, $91075ea0d0756915$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $620e7d45cdf9f89e$var$_cleanup)) this.setEventListener((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $620e7d45cdf9f89e$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $620e7d45cdf9f89e$var$_cleanup)) == null || _a.call(this);
            (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $620e7d45cdf9f89e$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $620e7d45cdf9f89e$var$_setup, setup);
        (_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $620e7d45cdf9f89e$var$_cleanup)) == null || _a.call(this);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $620e7d45cdf9f89e$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $620e7d45cdf9f89e$var$_online) !== online;
        if (changed) {
            (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $620e7d45cdf9f89e$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $620e7d45cdf9f89e$var$_online);
    }
};
$620e7d45cdf9f89e$var$_online = new WeakMap();
$620e7d45cdf9f89e$var$_cleanup = new WeakMap();
$620e7d45cdf9f89e$var$_setup = new WeakMap();
var $620e7d45cdf9f89e$export$b113e788b2dd3fdc = new $620e7d45cdf9f89e$export$58774fb55d5ff7fc();



function $67a3321a10d7da2e$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $67a3321a10d7da2e$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $620e7d45cdf9f89e$export$b113e788b2dd3fdc).isOnline() : true;
}
var $67a3321a10d7da2e$export$a8430ed4188f35a9 = class {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $67a3321a10d7da2e$export$986cc6445c1d323(value) {
    return value instanceof $67a3321a10d7da2e$export$a8430ed4188f35a9;
}
function $67a3321a10d7da2e$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved) {
            reject(new $67a3321a10d7da2e$export$a8430ed4188f35a9(cancelOptions));
            (_a = config.abort) == null || _a.call(config);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $b217e2cdf935894d$export$6bf54661be5b02cf).isFocused() || config.networkMode !== "always" && !(0, $620e7d45cdf9f89e$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onSuccess) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onError) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved) return;
            const retry = config.retry ?? ((0, $91075ea0d0756915$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $67a3321a10d7da2e$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $91075ea0d0756915$export$e772c8ff12451969)(delay).then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    if ($67a3321a10d7da2e$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}




var $dcea880be32b21b5$var$_gcTimeout;
var $dcea880be32b21b5$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $dcea880be32b21b5$var$_gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $91075ea0d0756915$export$e539f754e934e270)(this.gcTime)) (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $dcea880be32b21b5$var$_gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $91075ea0d0756915$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $dcea880be32b21b5$var$_gcTimeout)) {
            clearTimeout((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $dcea880be32b21b5$var$_gcTimeout));
            (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $dcea880be32b21b5$var$_gcTimeout, void 0);
        }
    }
};
$dcea880be32b21b5$var$_gcTimeout = new WeakMap();


var $ea6601bddc61dbe3$var$_initialState, $ea6601bddc61dbe3$var$_revertState, $ea6601bddc61dbe3$var$_cache, $ea6601bddc61dbe3$var$_retryer, $ea6601bddc61dbe3$var$_observers, $ea6601bddc61dbe3$var$_defaultOptions, $ea6601bddc61dbe3$var$_abortSignalConsumed, $ea6601bddc61dbe3$var$_dispatch, $ea6601bddc61dbe3$var$dispatch_fn;
var $ea6601bddc61dbe3$export$62297b13309008b2 = class extends (0, $dcea880be32b21b5$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $ea6601bddc61dbe3$var$_dispatch);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $ea6601bddc61dbe3$var$_initialState, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $ea6601bddc61dbe3$var$_revertState, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $ea6601bddc61dbe3$var$_cache, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $ea6601bddc61dbe3$var$_retryer, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $ea6601bddc61dbe3$var$_observers, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $ea6601bddc61dbe3$var$_defaultOptions, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $ea6601bddc61dbe3$var$_abortSignalConsumed, void 0);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $ea6601bddc61dbe3$var$_abortSignalConsumed, false);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $ea6601bddc61dbe3$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $ea6601bddc61dbe3$var$_observers, []);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $ea6601bddc61dbe3$var$_cache, config.cache);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $ea6601bddc61dbe3$var$_initialState, config.state || $ea6601bddc61dbe3$var$getDefaultState(this.options));
        this.state = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_observers).length && this.state.fetchStatus === "idle") (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $91075ea0d0756915$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $ea6601bddc61dbe3$var$_dispatch, $ea6601bddc61dbe3$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $ea6601bddc61dbe3$var$_dispatch, $ea6601bddc61dbe3$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_retryer)) == null ? void 0 : _a.promise;
        (_b = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, $91075ea0d0756915$export$8793edee2d425525)).catch((0, $91075ea0d0756915$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_initialState));
    }
    isActive() {
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_observers).some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        if (this.state.isInvalidated) return true;
        if (this.getObserversCount() > 0) return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_observers).some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0;
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !(0, $91075ea0d0756915$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_observers).find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_observers).find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_observers).includes(observer)) {
            (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if ((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_observers).includes(observer)) {
            (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $ea6601bddc61dbe3$var$_observers, (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_observers).filter((x)=>x !== observer));
            if (!(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_observers).length) {
                if ((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_retryer)) {
                    if ((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_abortSignalConsumed)) (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_observers).length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $ea6601bddc61dbe3$var$_dispatch, $ea6601bddc61dbe3$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _a, _b, _c;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_retryer)) {
                (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_retryer).continueRetry();
                return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_observers).find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const queryFnContext = {
            queryKey: this.queryKey,
            meta: this.meta
        };
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $ea6601bddc61dbe3$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        addSignalProperty(queryFnContext);
        const fetchFn = ()=>{
            if (!this.options.queryFn || this.options.queryFn === (0, $91075ea0d0756915$export$1aa5a89531b7670d)) return Promise.reject(new Error(`Missing queryFn: '${this.options.queryHash}'`));
            (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $ea6601bddc61dbe3$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(this.options.queryFn, queryFnContext, this);
            return this.options.queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_a = this.options.behavior) == null || _a.onFetch(context, this);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $ea6601bddc61dbe3$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_b = context.fetchOptions) == null ? void 0 : _b.meta)) (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $ea6601bddc61dbe3$var$_dispatch, $ea6601bddc61dbe3$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_c = context.fetchOptions) == null ? void 0 : _c.meta
        });
        const onError = (error)=>{
            var _a2, _b2, _c2, _d;
            if (!((0, $67a3321a10d7da2e$export$986cc6445c1d323)(error) && error.silent)) (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $ea6601bddc61dbe3$var$_dispatch, $ea6601bddc61dbe3$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            if (!(0, $67a3321a10d7da2e$export$986cc6445c1d323)(error)) {
                (_b2 = (_a2 = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_cache).config).onError) == null || _b2.call(_a2, error, this);
                (_d = (_c2 = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_cache).config).onSettled) == null || _d.call(_c2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) this.scheduleGc();
            this.isFetchingOptimistic = false;
        };
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $ea6601bddc61dbe3$var$_retryer, (0, $67a3321a10d7da2e$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _a2, _b2, _c2, _d;
                if (data === void 0) {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                this.setData(data);
                (_b2 = (_a2 = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_cache).config).onSuccess) == null || _b2.call(_a2, data, this);
                (_d = (_c2 = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_cache).config).onSettled) == null || _d.call(_c2, data, this.state.error, this);
                if (!this.isFetchingOptimistic) this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $ea6601bddc61dbe3$var$_dispatch, $ea6601bddc61dbe3$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $ea6601bddc61dbe3$var$_dispatch, $ea6601bddc61dbe3$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $ea6601bddc61dbe3$var$_dispatch, $ea6601bddc61dbe3$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        }));
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_retryer).promise;
    }
};
$ea6601bddc61dbe3$var$_initialState = new WeakMap();
$ea6601bddc61dbe3$var$_revertState = new WeakMap();
$ea6601bddc61dbe3$var$_cache = new WeakMap();
$ea6601bddc61dbe3$var$_retryer = new WeakMap();
$ea6601bddc61dbe3$var$_observers = new WeakMap();
$ea6601bddc61dbe3$var$_defaultOptions = new WeakMap();
$ea6601bddc61dbe3$var$_abortSignalConsumed = new WeakMap();
$ea6601bddc61dbe3$var$_dispatch = new WeakSet();
$ea6601bddc61dbe3$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$ea6601bddc61dbe3$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
            case "error":
                const error = action.error;
                if ((0, $67a3321a10d7da2e$export$986cc6445c1d323)(error) && error.revert && (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_revertState)) return {
                    ...(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_revertState),
                    fetchStatus: "idle"
                };
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $ca19c9b496b64b93$export$520687f44db6e1ab).batch(()=>{
        (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_observers).forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $ea6601bddc61dbe3$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $ea6601bddc61dbe3$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $67a3321a10d7da2e$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $ea6601bddc61dbe3$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $9184adb355ee8610$var$_queries;
var $9184adb355ee8610$export$5dde0cd941da8468 = class extends (0, $6164943b6c12fe94$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $9184adb355ee8610$var$_queries, void 0);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $9184adb355ee8610$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $91075ea0d0756915$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $ea6601bddc61dbe3$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $9184adb355ee8610$var$_queries).has(query.queryHash)) {
            (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $9184adb355ee8610$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $9184adb355ee8610$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $9184adb355ee8610$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $ca19c9b496b64b93$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $9184adb355ee8610$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $9184adb355ee8610$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $91075ea0d0756915$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $91075ea0d0756915$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $ca19c9b496b64b93$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $ca19c9b496b64b93$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $ca19c9b496b64b93$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$9184adb355ee8610$var$_queries = new WeakMap();








var $766e652c0fb9d81d$var$_observers, $766e652c0fb9d81d$var$_defaultOptions, $766e652c0fb9d81d$var$_mutationCache, $766e652c0fb9d81d$var$_retryer, $766e652c0fb9d81d$var$_dispatch, $766e652c0fb9d81d$var$dispatch_fn;
var $766e652c0fb9d81d$export$17b8b19c814bcf56 = class extends (0, $dcea880be32b21b5$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $766e652c0fb9d81d$var$_dispatch);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $766e652c0fb9d81d$var$_observers, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $766e652c0fb9d81d$var$_defaultOptions, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $766e652c0fb9d81d$var$_mutationCache, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $766e652c0fb9d81d$var$_retryer, void 0);
        this.mutationId = config.mutationId;
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $766e652c0fb9d81d$var$_defaultOptions, config.defaultOptions);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $766e652c0fb9d81d$var$_mutationCache, config.mutationCache);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $766e652c0fb9d81d$var$_observers, []);
        this.state = config.state || $766e652c0fb9d81d$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $766e652c0fb9d81d$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $766e652c0fb9d81d$var$_observers).includes(observer)) {
            (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $766e652c0fb9d81d$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $766e652c0fb9d81d$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $766e652c0fb9d81d$var$_observers, (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $766e652c0fb9d81d$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $766e652c0fb9d81d$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $766e652c0fb9d81d$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $766e652c0fb9d81d$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $766e652c0fb9d81d$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        const executeMutation = ()=>{
            (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $766e652c0fb9d81d$var$_retryer, (0, $67a3321a10d7da2e$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                    return this.options.mutationFn(variables);
                },
                onFail: (failureCount, error)=>{
                    (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $766e652c0fb9d81d$var$_dispatch, $766e652c0fb9d81d$var$dispatch_fn).call(this, {
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $766e652c0fb9d81d$var$_dispatch, $766e652c0fb9d81d$var$dispatch_fn).call(this, {
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $766e652c0fb9d81d$var$_dispatch, $766e652c0fb9d81d$var$dispatch_fn).call(this, {
                        type: "continue"
                    });
                },
                retry: this.options.retry ?? 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            }));
            return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $766e652c0fb9d81d$var$_retryer).promise;
        };
        const restored = this.state.status === "pending";
        try {
            if (!restored) {
                (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $766e652c0fb9d81d$var$_dispatch, $766e652c0fb9d81d$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables
                });
                await ((_b = (_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $766e652c0fb9d81d$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $766e652c0fb9d81d$var$_dispatch, $766e652c0fb9d81d$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables
                });
            }
            const data = await executeMutation();
            await ((_f = (_e = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $766e652c0fb9d81d$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $766e652c0fb9d81d$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $766e652c0fb9d81d$var$_dispatch, $766e652c0fb9d81d$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $766e652c0fb9d81d$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $766e652c0fb9d81d$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $766e652c0fb9d81d$var$_dispatch, $766e652c0fb9d81d$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        }
    }
};
$766e652c0fb9d81d$var$_observers = new WeakMap();
$766e652c0fb9d81d$var$_defaultOptions = new WeakMap();
$766e652c0fb9d81d$var$_mutationCache = new WeakMap();
$766e652c0fb9d81d$var$_retryer = new WeakMap();
$766e652c0fb9d81d$var$_dispatch = new WeakSet();
$766e652c0fb9d81d$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: !(0, $67a3321a10d7da2e$export$61b92f63f30245cf)(this.options.networkMode),
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $ca19c9b496b64b93$export$520687f44db6e1ab).batch(()=>{
        (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $766e652c0fb9d81d$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $766e652c0fb9d81d$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $766e652c0fb9d81d$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $d05f58aa7d3c70d5$var$_mutations, $d05f58aa7d3c70d5$var$_mutationId, $d05f58aa7d3c70d5$var$_resuming;
var $d05f58aa7d3c70d5$export$1fcfd9a244434844 = class extends (0, $6164943b6c12fe94$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $d05f58aa7d3c70d5$var$_mutations, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $d05f58aa7d3c70d5$var$_mutationId, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $d05f58aa7d3c70d5$var$_resuming, void 0);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $d05f58aa7d3c70d5$var$_mutations, []);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $d05f58aa7d3c70d5$var$_mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, $766e652c0fb9d81d$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++(0, $d6bb706f240c69b6$export$b1fe7cbb4502036b)(this, $d05f58aa7d3c70d5$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $d05f58aa7d3c70d5$var$_mutations).push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $d05f58aa7d3c70d5$var$_mutations, (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $d05f58aa7d3c70d5$var$_mutations).filter((x)=>x !== mutation));
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $ca19c9b496b64b93$export$520687f44db6e1ab).batch(()=>{
            (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $d05f58aa7d3c70d5$var$_mutations).forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $d05f58aa7d3c70d5$var$_mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $d05f58aa7d3c70d5$var$_mutations).find((mutation)=>(0, $91075ea0d0756915$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $d05f58aa7d3c70d5$var$_mutations).filter((mutation)=>(0, $91075ea0d0756915$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $ca19c9b496b64b93$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $d05f58aa7d3c70d5$var$_resuming, ((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $d05f58aa7d3c70d5$var$_resuming) ?? Promise.resolve()).then(()=>{
            const pausedMutations = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $d05f58aa7d3c70d5$var$_mutations).filter((x)=>x.state.isPaused);
            return (0, $ca19c9b496b64b93$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $91075ea0d0756915$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $d05f58aa7d3c70d5$var$_resuming, void 0);
        }));
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $d05f58aa7d3c70d5$var$_resuming);
    }
};
$d05f58aa7d3c70d5$var$_mutations = new WeakMap();
$d05f58aa7d3c70d5$var$_mutationId = new WeakMap();
$d05f58aa7d3c70d5$var$_resuming = new WeakMap();







function $fa1edde63b3db572$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const fetchFn = async ()=>{
                var _a, _b, _c, _d, _e;
                const options = context.options;
                const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
                const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
                const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
                const empty = {
                    pages: [],
                    pageParams: []
                };
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = context.options.queryFn && context.options.queryFn !== (0, $91075ea0d0756915$export$1aa5a89531b7670d) ? context.options.queryFn : ()=>{
                    return Promise.reject(new Error(`Missing queryFn: '${context.options.queryHash}'`));
                };
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $91075ea0d0756915$export$8c6246b73dd61f4a) : (0, $91075ea0d0756915$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                let result;
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $fa1edde63b3db572$var$getPreviousPageParam : $fa1edde63b3db572$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    result = await fetchPage(empty, oldPageParams[0] ?? options.initialPageParam);
                    const remainingPages = pages ?? oldPages.length;
                    for(let i = 1; i < remainingPages; i++){
                        const param = $fa1edde63b3db572$var$getNextPageParam(options, result);
                        result = await fetchPage(result, param);
                    }
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a, _b;
                return (_b = (_a = context.options).persister) == null ? void 0 : _b.call(_a, fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $fa1edde63b3db572$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams);
}
function $fa1edde63b3db572$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams);
}
function $fa1edde63b3db572$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $fa1edde63b3db572$var$getNextPageParam(options, data) != null;
}
function $fa1edde63b3db572$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $fa1edde63b3db572$var$getPreviousPageParam(options, data) != null;
}


var $18acf5281fa49b03$var$_queryCache, $18acf5281fa49b03$var$_mutationCache, $18acf5281fa49b03$var$_defaultOptions, $18acf5281fa49b03$var$_queryDefaults, $18acf5281fa49b03$var$_mutationDefaults, $18acf5281fa49b03$var$_mountCount, $18acf5281fa49b03$var$_unsubscribeFocus, $18acf5281fa49b03$var$_unsubscribeOnline;
var $18acf5281fa49b03$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $18acf5281fa49b03$var$_queryCache, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $18acf5281fa49b03$var$_mutationCache, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $18acf5281fa49b03$var$_defaultOptions, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $18acf5281fa49b03$var$_queryDefaults, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $18acf5281fa49b03$var$_mutationDefaults, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $18acf5281fa49b03$var$_mountCount, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $18acf5281fa49b03$var$_unsubscribeFocus, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $18acf5281fa49b03$var$_unsubscribeOnline, void 0);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $18acf5281fa49b03$var$_queryCache, config.queryCache || new (0, $9184adb355ee8610$export$5dde0cd941da8468)());
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $18acf5281fa49b03$var$_mutationCache, config.mutationCache || new (0, $d05f58aa7d3c70d5$export$1fcfd9a244434844)());
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $18acf5281fa49b03$var$_defaultOptions, config.defaultOptions || {});
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $18acf5281fa49b03$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $18acf5281fa49b03$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $18acf5281fa49b03$var$_mountCount, 0);
    }
    mount() {
        (0, $d6bb706f240c69b6$export$b1fe7cbb4502036b)(this, $18acf5281fa49b03$var$_mountCount)._++;
        if ((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_mountCount) !== 1) return;
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $18acf5281fa49b03$var$_unsubscribeFocus, (0, $b217e2cdf935894d$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache).onFocus();
            }
        }));
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $18acf5281fa49b03$var$_unsubscribeOnline, (0, $620e7d45cdf9f89e$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $d6bb706f240c69b6$export$b1fe7cbb4502036b)(this, $18acf5281fa49b03$var$_mountCount)._--;
        if ((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_mountCount) !== 0) return;
        (_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $18acf5281fa49b03$var$_unsubscribeFocus, void 0);
        (_b = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $18acf5281fa49b03$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const cachedData = this.getQueryData(options.queryKey);
        if (cachedData === void 0) return this.fetchQuery(options);
        else {
            const defaultedOptions = this.defaultQueryOptions(options);
            const query = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache).build(this, defaultedOptions);
            if (options.revalidateIfStale && query.isStaleByTime(defaultedOptions.staleTime)) this.prefetchQuery(defaultedOptions);
            return Promise.resolve(cachedData);
        }
    }
    getQueriesData(filters) {
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $91075ea0d0756915$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $ca19c9b496b64b93$export$520687f44db6e1ab).batch(()=>(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache);
        (0, $ca19c9b496b64b93$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache);
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $ca19c9b496b64b93$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters = {}, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $ca19c9b496b64b93$export$520687f44db6e1ab).batch(()=>(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $91075ea0d0756915$export$8793edee2d425525)).catch((0, $91075ea0d0756915$export$8793edee2d425525));
    }
    invalidateQueries(filters = {}, options = {}) {
        return (0, $ca19c9b496b64b93$export$520687f44db6e1ab).batch(()=>{
            (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: filters.refetchType ?? filters.type ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters = {}, options) {
        const fetchOptions = {
            ...options,
            cancelRefetch: (options == null ? void 0 : options.cancelRefetch) ?? true
        };
        const promises = (0, $ca19c9b496b64b93$export$520687f44db6e1ab).batch(()=>(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $91075ea0d0756915$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $91075ea0d0756915$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $91075ea0d0756915$export$8793edee2d425525)).catch((0, $91075ea0d0756915$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $fa1edde63b3db572$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $91075ea0d0756915$export$8793edee2d425525)).catch((0, $91075ea0d0756915$export$8793edee2d425525));
    }
    resumePausedMutations() {
        if ((0, $620e7d45cdf9f89e$export$b113e788b2dd3fdc).isOnline()) return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache);
    }
    getMutationCache() {
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $18acf5281fa49b03$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryDefaults).set((0, $91075ea0d0756915$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $91075ea0d0756915$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_mutationDefaults).set((0, $91075ea0d0756915$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_mutationDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $91075ea0d0756915$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $91075ea0d0756915$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.enabled !== true && defaultedOptions.queryFn === (0, $91075ea0d0756915$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_queryCache).clear();
        (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $18acf5281fa49b03$var$_mutationCache).clear();
    }
};
$18acf5281fa49b03$var$_queryCache = new WeakMap();
$18acf5281fa49b03$var$_mutationCache = new WeakMap();
$18acf5281fa49b03$var$_defaultOptions = new WeakMap();
$18acf5281fa49b03$var$_queryDefaults = new WeakMap();
$18acf5281fa49b03$var$_mutationDefaults = new WeakMap();
$18acf5281fa49b03$var$_mountCount = new WeakMap();
$18acf5281fa49b03$var$_unsubscribeFocus = new WeakMap();
$18acf5281fa49b03$var$_unsubscribeOnline = new WeakMap();


var $6uYXW = parcelRequire("6uYXW");

"use client";
var $8136cc1e66cf8798$export$da112d31b0149f31 = $6uYXW.createContext(void 0);
var $8136cc1e66cf8798$export$22e77b9572c4fded = (queryClient)=>{
    const client = $6uYXW.useContext($8136cc1e66cf8798$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $8136cc1e66cf8798$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $6uYXW.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $32c03629429003d8$exports.jsx)($8136cc1e66cf8798$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};


'use strict';
function $1c004eb3eb783df1$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $96bf4ecd87681c49$var$toString } = Object.prototype;
const { getPrototypeOf: $96bf4ecd87681c49$var$getPrototypeOf } = Object;
const { iterator: $96bf4ecd87681c49$var$iterator, toStringTag: $96bf4ecd87681c49$var$toStringTag } = Symbol;
const $96bf4ecd87681c49$var$kindOf = ((cache)=>(thing)=>{
        const str = $96bf4ecd87681c49$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $96bf4ecd87681c49$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$96bf4ecd87681c49$var$kindOf(thing) === type;
};
const $96bf4ecd87681c49$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $96bf4ecd87681c49$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $96bf4ecd87681c49$var$isUndefined = $96bf4ecd87681c49$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $96bf4ecd87681c49$var$isBuffer(val) {
    return val !== null && !$96bf4ecd87681c49$var$isUndefined(val) && val.constructor !== null && !$96bf4ecd87681c49$var$isUndefined(val.constructor) && $96bf4ecd87681c49$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $96bf4ecd87681c49$var$isArrayBuffer = $96bf4ecd87681c49$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $96bf4ecd87681c49$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $96bf4ecd87681c49$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $96bf4ecd87681c49$var$isString = $96bf4ecd87681c49$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $96bf4ecd87681c49$var$isFunction = $96bf4ecd87681c49$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $96bf4ecd87681c49$var$isNumber = $96bf4ecd87681c49$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $96bf4ecd87681c49$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $96bf4ecd87681c49$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $96bf4ecd87681c49$var$isPlainObject = (val)=>{
    if ($96bf4ecd87681c49$var$kindOf(val) !== 'object') return false;
    const prototype = $96bf4ecd87681c49$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($96bf4ecd87681c49$var$toStringTag in val) && !($96bf4ecd87681c49$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $96bf4ecd87681c49$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$96bf4ecd87681c49$var$isObject(val) || $96bf4ecd87681c49$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $96bf4ecd87681c49$var$isDate = $96bf4ecd87681c49$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $96bf4ecd87681c49$var$isFile = $96bf4ecd87681c49$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $96bf4ecd87681c49$var$isBlob = $96bf4ecd87681c49$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $96bf4ecd87681c49$var$isFileList = $96bf4ecd87681c49$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $96bf4ecd87681c49$var$isStream = (val)=>$96bf4ecd87681c49$var$isObject(val) && $96bf4ecd87681c49$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $96bf4ecd87681c49$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $96bf4ecd87681c49$var$isFunction(thing.append) && ((kind = $96bf4ecd87681c49$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $96bf4ecd87681c49$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $96bf4ecd87681c49$var$isURLSearchParams = $96bf4ecd87681c49$var$kindOfTest('URLSearchParams');
const [$96bf4ecd87681c49$var$isReadableStream, $96bf4ecd87681c49$var$isRequest, $96bf4ecd87681c49$var$isResponse, $96bf4ecd87681c49$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($96bf4ecd87681c49$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $96bf4ecd87681c49$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $96bf4ecd87681c49$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($96bf4ecd87681c49$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($96bf4ecd87681c49$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $96bf4ecd87681c49$var$findKey(obj, key) {
    if ($96bf4ecd87681c49$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $96bf4ecd87681c49$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $96bf4ecd87681c49$var$isContextDefined = (context)=>!$96bf4ecd87681c49$var$isUndefined(context) && context !== $96bf4ecd87681c49$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $96bf4ecd87681c49$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $96bf4ecd87681c49$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $96bf4ecd87681c49$var$findKey(result, key) || key;
        if ($96bf4ecd87681c49$var$isPlainObject(result[targetKey]) && $96bf4ecd87681c49$var$isPlainObject(val)) result[targetKey] = $96bf4ecd87681c49$var$merge(result[targetKey], val);
        else if ($96bf4ecd87681c49$var$isPlainObject(val)) result[targetKey] = $96bf4ecd87681c49$var$merge({}, val);
        else if ($96bf4ecd87681c49$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$96bf4ecd87681c49$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $96bf4ecd87681c49$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $96bf4ecd87681c49$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $96bf4ecd87681c49$var$forEach(b, (val, key)=>{
        if (thisArg && $96bf4ecd87681c49$var$isFunction(val)) a[key] = (0, $1c004eb3eb783df1$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $96bf4ecd87681c49$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $96bf4ecd87681c49$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $96bf4ecd87681c49$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $96bf4ecd87681c49$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $96bf4ecd87681c49$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $96bf4ecd87681c49$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($96bf4ecd87681c49$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$96bf4ecd87681c49$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $96bf4ecd87681c49$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $96bf4ecd87681c49$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $96bf4ecd87681c49$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$96bf4ecd87681c49$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $96bf4ecd87681c49$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $96bf4ecd87681c49$var$isHTMLForm = $96bf4ecd87681c49$var$kindOfTest('HTMLFormElement');
const $96bf4ecd87681c49$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $96bf4ecd87681c49$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $96bf4ecd87681c49$var$isRegExp = $96bf4ecd87681c49$var$kindOfTest('RegExp');
const $96bf4ecd87681c49$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $96bf4ecd87681c49$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $96bf4ecd87681c49$var$freezeMethods = (obj)=>{
    $96bf4ecd87681c49$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($96bf4ecd87681c49$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$96bf4ecd87681c49$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $96bf4ecd87681c49$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $96bf4ecd87681c49$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $96bf4ecd87681c49$var$noop = ()=>{};
const $96bf4ecd87681c49$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $96bf4ecd87681c49$var$isSpecCompliantForm(thing) {
    return !!(thing && $96bf4ecd87681c49$var$isFunction(thing.append) && thing[$96bf4ecd87681c49$var$toStringTag] === 'FormData' && thing[$96bf4ecd87681c49$var$iterator]);
}
const $96bf4ecd87681c49$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($96bf4ecd87681c49$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($96bf4ecd87681c49$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $96bf4ecd87681c49$var$isArray(source) ? [] : {};
                $96bf4ecd87681c49$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$96bf4ecd87681c49$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $96bf4ecd87681c49$var$isAsyncFn = $96bf4ecd87681c49$var$kindOfTest('AsyncFunction');
const $96bf4ecd87681c49$var$isThenable = (thing)=>thing && ($96bf4ecd87681c49$var$isObject(thing) || $96bf4ecd87681c49$var$isFunction(thing)) && $96bf4ecd87681c49$var$isFunction(thing.then) && $96bf4ecd87681c49$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $96bf4ecd87681c49$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $96bf4ecd87681c49$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $96bf4ecd87681c49$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $96bf4ecd87681c49$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $96bf4ecd87681c49$var$isFunction($96bf4ecd87681c49$var$_global.postMessage));
const $96bf4ecd87681c49$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($96bf4ecd87681c49$var$_global) : $96bf4ecd87681c49$var$_setImmediate;
// *********************
const $96bf4ecd87681c49$var$isIterable = (thing)=>thing != null && $96bf4ecd87681c49$var$isFunction(thing[$96bf4ecd87681c49$var$iterator]);
var $96bf4ecd87681c49$export$2e2bcd8739ae039 = {
    isArray: $96bf4ecd87681c49$var$isArray,
    isArrayBuffer: $96bf4ecd87681c49$var$isArrayBuffer,
    isBuffer: $96bf4ecd87681c49$var$isBuffer,
    isFormData: $96bf4ecd87681c49$var$isFormData,
    isArrayBufferView: $96bf4ecd87681c49$var$isArrayBufferView,
    isString: $96bf4ecd87681c49$var$isString,
    isNumber: $96bf4ecd87681c49$var$isNumber,
    isBoolean: $96bf4ecd87681c49$var$isBoolean,
    isObject: $96bf4ecd87681c49$var$isObject,
    isPlainObject: $96bf4ecd87681c49$var$isPlainObject,
    isEmptyObject: $96bf4ecd87681c49$var$isEmptyObject,
    isReadableStream: $96bf4ecd87681c49$var$isReadableStream,
    isRequest: $96bf4ecd87681c49$var$isRequest,
    isResponse: $96bf4ecd87681c49$var$isResponse,
    isHeaders: $96bf4ecd87681c49$var$isHeaders,
    isUndefined: $96bf4ecd87681c49$var$isUndefined,
    isDate: $96bf4ecd87681c49$var$isDate,
    isFile: $96bf4ecd87681c49$var$isFile,
    isBlob: $96bf4ecd87681c49$var$isBlob,
    isRegExp: $96bf4ecd87681c49$var$isRegExp,
    isFunction: $96bf4ecd87681c49$var$isFunction,
    isStream: $96bf4ecd87681c49$var$isStream,
    isURLSearchParams: $96bf4ecd87681c49$var$isURLSearchParams,
    isTypedArray: $96bf4ecd87681c49$var$isTypedArray,
    isFileList: $96bf4ecd87681c49$var$isFileList,
    forEach: $96bf4ecd87681c49$var$forEach,
    merge: $96bf4ecd87681c49$var$merge,
    extend: $96bf4ecd87681c49$var$extend,
    trim: $96bf4ecd87681c49$var$trim,
    stripBOM: $96bf4ecd87681c49$var$stripBOM,
    inherits: $96bf4ecd87681c49$var$inherits,
    toFlatObject: $96bf4ecd87681c49$var$toFlatObject,
    kindOf: $96bf4ecd87681c49$var$kindOf,
    kindOfTest: $96bf4ecd87681c49$var$kindOfTest,
    endsWith: $96bf4ecd87681c49$var$endsWith,
    toArray: $96bf4ecd87681c49$var$toArray,
    forEachEntry: $96bf4ecd87681c49$var$forEachEntry,
    matchAll: $96bf4ecd87681c49$var$matchAll,
    isHTMLForm: $96bf4ecd87681c49$var$isHTMLForm,
    hasOwnProperty: $96bf4ecd87681c49$var$hasOwnProperty,
    hasOwnProp: $96bf4ecd87681c49$var$hasOwnProperty,
    reduceDescriptors: $96bf4ecd87681c49$var$reduceDescriptors,
    freezeMethods: $96bf4ecd87681c49$var$freezeMethods,
    toObjectSet: $96bf4ecd87681c49$var$toObjectSet,
    toCamelCase: $96bf4ecd87681c49$var$toCamelCase,
    noop: $96bf4ecd87681c49$var$noop,
    toFiniteNumber: $96bf4ecd87681c49$var$toFiniteNumber,
    findKey: $96bf4ecd87681c49$var$findKey,
    global: $96bf4ecd87681c49$var$_global,
    isContextDefined: $96bf4ecd87681c49$var$isContextDefined,
    isSpecCompliantForm: $96bf4ecd87681c49$var$isSpecCompliantForm,
    toJSONObject: $96bf4ecd87681c49$var$toJSONObject,
    isAsyncFn: $96bf4ecd87681c49$var$isAsyncFn,
    isThenable: $96bf4ecd87681c49$var$isThenable,
    setImmediate: $96bf4ecd87681c49$var$_setImmediate,
    asap: $96bf4ecd87681c49$var$asap,
    isIterable: $96bf4ecd87681c49$var$isIterable
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $ad6c282166e6c43d$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).inherits($ad6c282166e6c43d$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $ad6c282166e6c43d$var$prototype = $ad6c282166e6c43d$var$AxiosError.prototype;
const $ad6c282166e6c43d$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $ad6c282166e6c43d$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($ad6c282166e6c43d$var$AxiosError, $ad6c282166e6c43d$var$descriptors);
Object.defineProperty($ad6c282166e6c43d$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$ad6c282166e6c43d$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($ad6c282166e6c43d$var$prototype);
    (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    const msg = error && error.message ? error.message : 'Error';
    // Prefer explicit code; otherwise copy the low-level error's code (e.g. ECONNREFUSED)
    const errCode = code == null && error ? error.code : code;
    $ad6c282166e6c43d$var$AxiosError.call(axiosError, msg, errCode, config, request, response);
    // Chain the original error on the standard field; non-enumerable to avoid JSON noise
    if (error && axiosError.cause == null) Object.defineProperty(axiosError, 'cause', {
        value: error,
        configurable: true
    });
    axiosError.name = error && error.name || 'Error';
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $ad6c282166e6c43d$export$2e2bcd8739ae039 = $ad6c282166e6c43d$var$AxiosError;


// eslint-disable-next-line strict
var $9507473dc3236b04$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $802fd0de90cfa455$export$a143d493d941bafc;
var $802fd0de90cfa455$export$e4cf37d7f6fb9e0a;
var $802fd0de90cfa455$export$f99ded8fe4b79145;
var $802fd0de90cfa455$export$599f31c3813fae4d;
'use strict';
var $bf94c29cc99c1571$export$a48f0734ac7c2329;
var $bf94c29cc99c1571$export$d622b2ad8d90c771;
var $bf94c29cc99c1571$export$6100ba28696e12de;
'use strict';
$bf94c29cc99c1571$export$a48f0734ac7c2329 = $bf94c29cc99c1571$var$byteLength;
$bf94c29cc99c1571$export$d622b2ad8d90c771 = $bf94c29cc99c1571$var$toByteArray;
$bf94c29cc99c1571$export$6100ba28696e12de = $bf94c29cc99c1571$var$fromByteArray;
var $bf94c29cc99c1571$var$lookup = [];
var $bf94c29cc99c1571$var$revLookup = [];
var $bf94c29cc99c1571$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $bf94c29cc99c1571$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $bf94c29cc99c1571$var$i = 0, $bf94c29cc99c1571$var$len = $bf94c29cc99c1571$var$code.length; $bf94c29cc99c1571$var$i < $bf94c29cc99c1571$var$len; ++$bf94c29cc99c1571$var$i){
    $bf94c29cc99c1571$var$lookup[$bf94c29cc99c1571$var$i] = $bf94c29cc99c1571$var$code[$bf94c29cc99c1571$var$i];
    $bf94c29cc99c1571$var$revLookup[$bf94c29cc99c1571$var$code.charCodeAt($bf94c29cc99c1571$var$i)] = $bf94c29cc99c1571$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$bf94c29cc99c1571$var$revLookup['-'.charCodeAt(0)] = 62;
$bf94c29cc99c1571$var$revLookup['_'.charCodeAt(0)] = 63;
function $bf94c29cc99c1571$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $bf94c29cc99c1571$var$byteLength(b64) {
    var lens = $bf94c29cc99c1571$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bf94c29cc99c1571$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bf94c29cc99c1571$var$toByteArray(b64) {
    var tmp;
    var lens = $bf94c29cc99c1571$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $bf94c29cc99c1571$var$Arr($bf94c29cc99c1571$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i)] << 18 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i)] << 2 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i)] << 10 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $bf94c29cc99c1571$var$tripletToBase64(num) {
    return $bf94c29cc99c1571$var$lookup[num >> 18 & 0x3F] + $bf94c29cc99c1571$var$lookup[num >> 12 & 0x3F] + $bf94c29cc99c1571$var$lookup[num >> 6 & 0x3F] + $bf94c29cc99c1571$var$lookup[num & 0x3F];
}
function $bf94c29cc99c1571$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($bf94c29cc99c1571$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $bf94c29cc99c1571$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($bf94c29cc99c1571$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($bf94c29cc99c1571$var$lookup[tmp >> 2] + $bf94c29cc99c1571$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($bf94c29cc99c1571$var$lookup[tmp >> 10] + $bf94c29cc99c1571$var$lookup[tmp >> 4 & 0x3F] + $bf94c29cc99c1571$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $32e74836fee794be$export$aafa59e2e03f2942;
var $32e74836fee794be$export$68d8715fc104d294;
$32e74836fee794be$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$32e74836fee794be$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $802fd0de90cfa455$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$802fd0de90cfa455$export$a143d493d941bafc = $802fd0de90cfa455$var$Buffer;
$802fd0de90cfa455$export$e4cf37d7f6fb9e0a = $802fd0de90cfa455$var$SlowBuffer;
$802fd0de90cfa455$export$f99ded8fe4b79145 = 50;
const $802fd0de90cfa455$var$K_MAX_LENGTH = 0x7fffffff;
$802fd0de90cfa455$export$599f31c3813fae4d = $802fd0de90cfa455$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $802fd0de90cfa455$var$Buffer.TYPED_ARRAY_SUPPORT = $802fd0de90cfa455$var$typedArraySupport();
if (!$802fd0de90cfa455$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $802fd0de90cfa455$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($802fd0de90cfa455$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$802fd0de90cfa455$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($802fd0de90cfa455$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$802fd0de90cfa455$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $802fd0de90cfa455$var$createBuffer(length) {
    if (length > $802fd0de90cfa455$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $802fd0de90cfa455$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $802fd0de90cfa455$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $802fd0de90cfa455$var$allocUnsafe(arg);
    }
    return $802fd0de90cfa455$var$from(arg, encodingOrOffset, length);
}
$802fd0de90cfa455$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $802fd0de90cfa455$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $802fd0de90cfa455$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $802fd0de90cfa455$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($802fd0de90cfa455$var$isInstance(value, ArrayBuffer) || value && $802fd0de90cfa455$var$isInstance(value.buffer, ArrayBuffer)) return $802fd0de90cfa455$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($802fd0de90cfa455$var$isInstance(value, SharedArrayBuffer) || value && $802fd0de90cfa455$var$isInstance(value.buffer, SharedArrayBuffer))) return $802fd0de90cfa455$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $802fd0de90cfa455$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $802fd0de90cfa455$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $802fd0de90cfa455$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $802fd0de90cfa455$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $802fd0de90cfa455$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($802fd0de90cfa455$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($802fd0de90cfa455$var$Buffer, Uint8Array);
function $802fd0de90cfa455$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $802fd0de90cfa455$var$alloc(size, fill, encoding) {
    $802fd0de90cfa455$var$assertSize(size);
    if (size <= 0) return $802fd0de90cfa455$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $802fd0de90cfa455$var$createBuffer(size).fill(fill, encoding) : $802fd0de90cfa455$var$createBuffer(size).fill(fill);
    return $802fd0de90cfa455$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $802fd0de90cfa455$var$Buffer.alloc = function(size, fill, encoding) {
    return $802fd0de90cfa455$var$alloc(size, fill, encoding);
};
function $802fd0de90cfa455$var$allocUnsafe(size) {
    $802fd0de90cfa455$var$assertSize(size);
    return $802fd0de90cfa455$var$createBuffer(size < 0 ? 0 : $802fd0de90cfa455$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $802fd0de90cfa455$var$Buffer.allocUnsafe = function(size) {
    return $802fd0de90cfa455$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $802fd0de90cfa455$var$Buffer.allocUnsafeSlow = function(size) {
    return $802fd0de90cfa455$var$allocUnsafe(size);
};
function $802fd0de90cfa455$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$802fd0de90cfa455$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $802fd0de90cfa455$var$byteLength(string, encoding) | 0;
    let buf = $802fd0de90cfa455$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $802fd0de90cfa455$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $802fd0de90cfa455$var$checked(array.length) | 0;
    const buf = $802fd0de90cfa455$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $802fd0de90cfa455$var$fromArrayView(arrayView) {
    if ($802fd0de90cfa455$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $802fd0de90cfa455$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $802fd0de90cfa455$var$fromArrayLike(arrayView);
}
function $802fd0de90cfa455$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $802fd0de90cfa455$var$Buffer.prototype);
    return buf;
}
function $802fd0de90cfa455$var$fromObject(obj) {
    if ($802fd0de90cfa455$var$Buffer.isBuffer(obj)) {
        const len = $802fd0de90cfa455$var$checked(obj.length) | 0;
        const buf = $802fd0de90cfa455$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $802fd0de90cfa455$var$numberIsNaN(obj.length)) return $802fd0de90cfa455$var$createBuffer(0);
        return $802fd0de90cfa455$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $802fd0de90cfa455$var$fromArrayLike(obj.data);
}
function $802fd0de90cfa455$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $802fd0de90cfa455$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $802fd0de90cfa455$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $802fd0de90cfa455$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $802fd0de90cfa455$var$Buffer.alloc(+length);
}
$802fd0de90cfa455$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $802fd0de90cfa455$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$802fd0de90cfa455$var$Buffer.compare = function compare(a, b) {
    if ($802fd0de90cfa455$var$isInstance(a, Uint8Array)) a = $802fd0de90cfa455$var$Buffer.from(a, a.offset, a.byteLength);
    if ($802fd0de90cfa455$var$isInstance(b, Uint8Array)) b = $802fd0de90cfa455$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$802fd0de90cfa455$var$Buffer.isBuffer(a) || !$802fd0de90cfa455$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$802fd0de90cfa455$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$802fd0de90cfa455$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $802fd0de90cfa455$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $802fd0de90cfa455$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($802fd0de90cfa455$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$802fd0de90cfa455$var$Buffer.isBuffer(buf)) buf = $802fd0de90cfa455$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$802fd0de90cfa455$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $802fd0de90cfa455$var$byteLength(string, encoding) {
    if ($802fd0de90cfa455$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $802fd0de90cfa455$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $802fd0de90cfa455$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $802fd0de90cfa455$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $802fd0de90cfa455$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$802fd0de90cfa455$var$Buffer.byteLength = $802fd0de90cfa455$var$byteLength;
function $802fd0de90cfa455$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $802fd0de90cfa455$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $802fd0de90cfa455$var$utf8Slice(this, start, end);
        case 'ascii':
            return $802fd0de90cfa455$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $802fd0de90cfa455$var$latin1Slice(this, start, end);
        case 'base64':
            return $802fd0de90cfa455$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $802fd0de90cfa455$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$802fd0de90cfa455$var$Buffer.prototype._isBuffer = true;
function $802fd0de90cfa455$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$802fd0de90cfa455$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$802fd0de90cfa455$var$swap(this, i, i + 1);
    return this;
};
$802fd0de90cfa455$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $802fd0de90cfa455$var$swap(this, i, i + 3);
        $802fd0de90cfa455$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$802fd0de90cfa455$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $802fd0de90cfa455$var$swap(this, i, i + 7);
        $802fd0de90cfa455$var$swap(this, i + 1, i + 6);
        $802fd0de90cfa455$var$swap(this, i + 2, i + 5);
        $802fd0de90cfa455$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$802fd0de90cfa455$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $802fd0de90cfa455$var$utf8Slice(this, 0, length);
    return $802fd0de90cfa455$var$slowToString.apply(this, arguments);
};
$802fd0de90cfa455$var$Buffer.prototype.toLocaleString = $802fd0de90cfa455$var$Buffer.prototype.toString;
$802fd0de90cfa455$var$Buffer.prototype.equals = function equals(b) {
    if (!$802fd0de90cfa455$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $802fd0de90cfa455$var$Buffer.compare(this, b) === 0;
};
$802fd0de90cfa455$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $802fd0de90cfa455$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($802fd0de90cfa455$var$customInspectSymbol) $802fd0de90cfa455$var$Buffer.prototype[$802fd0de90cfa455$var$customInspectSymbol] = $802fd0de90cfa455$var$Buffer.prototype.inspect;
$802fd0de90cfa455$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($802fd0de90cfa455$var$isInstance(target, Uint8Array)) target = $802fd0de90cfa455$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$802fd0de90cfa455$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $802fd0de90cfa455$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($802fd0de90cfa455$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $802fd0de90cfa455$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($802fd0de90cfa455$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $802fd0de90cfa455$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $802fd0de90cfa455$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $802fd0de90cfa455$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$802fd0de90cfa455$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$802fd0de90cfa455$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $802fd0de90cfa455$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$802fd0de90cfa455$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $802fd0de90cfa455$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $802fd0de90cfa455$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($802fd0de90cfa455$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $802fd0de90cfa455$var$utf8Write(buf, string, offset, length) {
    return $802fd0de90cfa455$var$blitBuffer($802fd0de90cfa455$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $802fd0de90cfa455$var$asciiWrite(buf, string, offset, length) {
    return $802fd0de90cfa455$var$blitBuffer($802fd0de90cfa455$var$asciiToBytes(string), buf, offset, length);
}
function $802fd0de90cfa455$var$base64Write(buf, string, offset, length) {
    return $802fd0de90cfa455$var$blitBuffer($802fd0de90cfa455$var$base64ToBytes(string), buf, offset, length);
}
function $802fd0de90cfa455$var$ucs2Write(buf, string, offset, length) {
    return $802fd0de90cfa455$var$blitBuffer($802fd0de90cfa455$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$802fd0de90cfa455$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $802fd0de90cfa455$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $802fd0de90cfa455$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $802fd0de90cfa455$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $802fd0de90cfa455$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $802fd0de90cfa455$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$802fd0de90cfa455$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $802fd0de90cfa455$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bf94c29cc99c1571$export$6100ba28696e12de(buf);
    else return $bf94c29cc99c1571$export$6100ba28696e12de(buf.slice(start, end));
}
function $802fd0de90cfa455$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $802fd0de90cfa455$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $802fd0de90cfa455$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $802fd0de90cfa455$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $802fd0de90cfa455$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $802fd0de90cfa455$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $802fd0de90cfa455$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $802fd0de90cfa455$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $802fd0de90cfa455$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $802fd0de90cfa455$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $802fd0de90cfa455$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$802fd0de90cfa455$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $802fd0de90cfa455$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $802fd0de90cfa455$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$802fd0de90cfa455$var$Buffer.prototype.readUintLE = $802fd0de90cfa455$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$802fd0de90cfa455$var$Buffer.prototype.readUintBE = $802fd0de90cfa455$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$802fd0de90cfa455$var$Buffer.prototype.readUint8 = $802fd0de90cfa455$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$802fd0de90cfa455$var$Buffer.prototype.readUint16LE = $802fd0de90cfa455$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$802fd0de90cfa455$var$Buffer.prototype.readUint16BE = $802fd0de90cfa455$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$802fd0de90cfa455$var$Buffer.prototype.readUint32LE = $802fd0de90cfa455$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$802fd0de90cfa455$var$Buffer.prototype.readUint32BE = $802fd0de90cfa455$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$802fd0de90cfa455$var$Buffer.prototype.readBigUInt64LE = $802fd0de90cfa455$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $802fd0de90cfa455$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $802fd0de90cfa455$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$802fd0de90cfa455$var$Buffer.prototype.readBigUInt64BE = $802fd0de90cfa455$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $802fd0de90cfa455$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $802fd0de90cfa455$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$802fd0de90cfa455$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$802fd0de90cfa455$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$802fd0de90cfa455$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$802fd0de90cfa455$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$802fd0de90cfa455$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$802fd0de90cfa455$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$802fd0de90cfa455$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$802fd0de90cfa455$var$Buffer.prototype.readBigInt64LE = $802fd0de90cfa455$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $802fd0de90cfa455$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $802fd0de90cfa455$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$802fd0de90cfa455$var$Buffer.prototype.readBigInt64BE = $802fd0de90cfa455$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $802fd0de90cfa455$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $802fd0de90cfa455$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$802fd0de90cfa455$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return $32e74836fee794be$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$802fd0de90cfa455$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return $32e74836fee794be$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$802fd0de90cfa455$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 8, this.length);
    return $32e74836fee794be$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$802fd0de90cfa455$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 8, this.length);
    return $32e74836fee794be$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $802fd0de90cfa455$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$802fd0de90cfa455$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$802fd0de90cfa455$var$Buffer.prototype.writeUintLE = $802fd0de90cfa455$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $802fd0de90cfa455$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUintBE = $802fd0de90cfa455$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $802fd0de90cfa455$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUint8 = $802fd0de90cfa455$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUint16LE = $802fd0de90cfa455$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUint16BE = $802fd0de90cfa455$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUint32LE = $802fd0de90cfa455$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUint32BE = $802fd0de90cfa455$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $802fd0de90cfa455$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $802fd0de90cfa455$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $802fd0de90cfa455$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $802fd0de90cfa455$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$802fd0de90cfa455$var$Buffer.prototype.writeBigUInt64LE = $802fd0de90cfa455$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $802fd0de90cfa455$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$802fd0de90cfa455$var$Buffer.prototype.writeBigUInt64BE = $802fd0de90cfa455$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $802fd0de90cfa455$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$802fd0de90cfa455$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $802fd0de90cfa455$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$802fd0de90cfa455$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $802fd0de90cfa455$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$802fd0de90cfa455$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$802fd0de90cfa455$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$802fd0de90cfa455$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$802fd0de90cfa455$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$802fd0de90cfa455$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$802fd0de90cfa455$var$Buffer.prototype.writeBigInt64LE = $802fd0de90cfa455$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $802fd0de90cfa455$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$802fd0de90cfa455$var$Buffer.prototype.writeBigInt64BE = $802fd0de90cfa455$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $802fd0de90cfa455$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $802fd0de90cfa455$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $802fd0de90cfa455$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $32e74836fee794be$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$802fd0de90cfa455$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $802fd0de90cfa455$var$writeFloat(this, value, offset, true, noAssert);
};
$802fd0de90cfa455$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $802fd0de90cfa455$var$writeFloat(this, value, offset, false, noAssert);
};
function $802fd0de90cfa455$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $32e74836fee794be$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$802fd0de90cfa455$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $802fd0de90cfa455$var$writeDouble(this, value, offset, true, noAssert);
};
$802fd0de90cfa455$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $802fd0de90cfa455$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$802fd0de90cfa455$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$802fd0de90cfa455$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$802fd0de90cfa455$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$802fd0de90cfa455$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $802fd0de90cfa455$var$Buffer.isBuffer(val) ? val : $802fd0de90cfa455$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $802fd0de90cfa455$var$errors = {};
function $802fd0de90cfa455$var$E(sym, getMessage, Base) {
    $802fd0de90cfa455$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$802fd0de90cfa455$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$802fd0de90cfa455$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$802fd0de90cfa455$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $802fd0de90cfa455$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $802fd0de90cfa455$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $802fd0de90cfa455$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $802fd0de90cfa455$var$checkBounds(buf, offset, byteLength) {
    $802fd0de90cfa455$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $802fd0de90cfa455$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $802fd0de90cfa455$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $802fd0de90cfa455$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $802fd0de90cfa455$var$checkBounds(buf, offset, byteLength);
}
function $802fd0de90cfa455$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $802fd0de90cfa455$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $802fd0de90cfa455$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $802fd0de90cfa455$var$validateNumber(value, type);
        throw new $802fd0de90cfa455$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $802fd0de90cfa455$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $802fd0de90cfa455$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $802fd0de90cfa455$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $802fd0de90cfa455$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($802fd0de90cfa455$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $802fd0de90cfa455$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $802fd0de90cfa455$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $802fd0de90cfa455$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $802fd0de90cfa455$var$base64ToBytes(str) {
    return $bf94c29cc99c1571$export$d622b2ad8d90c771($802fd0de90cfa455$var$base64clean(str));
}
function $802fd0de90cfa455$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $802fd0de90cfa455$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $802fd0de90cfa455$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $802fd0de90cfa455$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $802fd0de90cfa455$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $802fd0de90cfa455$var$BufferBigIntNotDefined : fn;
}
function $802fd0de90cfa455$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $0460442c5e4d0eef$require$Buffer = $802fd0de90cfa455$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $0460442c5e4d0eef$var$isVisitable(thing) {
    return (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $0460442c5e4d0eef$var$removeBrackets(key) {
    return (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $0460442c5e4d0eef$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $0460442c5e4d0eef$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $0460442c5e4d0eef$var$isFlatArray(arr) {
    return (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArray(arr) && !arr.some($0460442c5e4d0eef$var$isVisitable);
}
const $0460442c5e4d0eef$var$predicates = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).toFlatObject((0, $96bf4ecd87681c49$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $0460442c5e4d0eef$var$toFormData(obj, formData, options) {
    if (!(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $9507473dc3236b04$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $ad6c282166e6c43d$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $0460442c5e4d0eef$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArray(value) && $0460442c5e4d0eef$var$isFlatArray(value) || ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isFileList(value) || (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $0460442c5e4d0eef$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $0460442c5e4d0eef$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($0460442c5e4d0eef$var$isVisitable(value)) return true;
        formData.append($0460442c5e4d0eef$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($0460442c5e4d0eef$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $0460442c5e4d0eef$var$isVisitable
    });
    function build(value, path) {
        if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $0460442c5e4d0eef$export$2e2bcd8739ae039 = $0460442c5e4d0eef$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $271fa6b9caa4f02d$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $271fa6b9caa4f02d$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $0460442c5e4d0eef$export$2e2bcd8739ae039)(params, this, options);
}
const $271fa6b9caa4f02d$var$prototype = $271fa6b9caa4f02d$var$AxiosURLSearchParams.prototype;
$271fa6b9caa4f02d$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$271fa6b9caa4f02d$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $271fa6b9caa4f02d$var$encode);
    } : $271fa6b9caa4f02d$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $271fa6b9caa4f02d$export$2e2bcd8739ae039 = $271fa6b9caa4f02d$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $e1993edaebf31f88$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $e1993edaebf31f88$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $e1993edaebf31f88$var$encode;
    if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $271fa6b9caa4f02d$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $aa63a98a0047561b$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $aa63a98a0047561b$export$2e2bcd8739ae039 = $aa63a98a0047561b$var$InterceptorManager;





'use strict';
var $6db42038762d90d3$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $f1fd5bf5f6af2f1b$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $271fa6b9caa4f02d$export$2e2bcd8739ae039);


'use strict';
var $fc211d65e2bf23ba$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $c88db0704cf2a52f$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $7402973c36ad2888$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $f1fd5bf5f6af2f1b$export$2e2bcd8739ae039,
        FormData: $fc211d65e2bf23ba$export$2e2bcd8739ae039,
        Blob: $c88db0704cf2a52f$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $1b10703c05bc4563$exports = {};

$parcel$export($1b10703c05bc4563$exports, "hasBrowserEnv", function () { return $1b10703c05bc4563$export$c4996c4b7b93b0bf; });
$parcel$export($1b10703c05bc4563$exports, "navigator", function () { return $1b10703c05bc4563$export$ec7c8efa7f5790ae; });
$parcel$export($1b10703c05bc4563$exports, "hasStandardBrowserEnv", function () { return $1b10703c05bc4563$export$c0bcc9250309d66; });
$parcel$export($1b10703c05bc4563$exports, "hasStandardBrowserWebWorkerEnv", function () { return $1b10703c05bc4563$export$c81692cf5af97dac; });
$parcel$export($1b10703c05bc4563$exports, "origin", function () { return $1b10703c05bc4563$export$f710a83a91838a36; });
const $1b10703c05bc4563$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $1b10703c05bc4563$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $1b10703c05bc4563$export$c0bcc9250309d66 = $1b10703c05bc4563$export$c4996c4b7b93b0bf && (!$1b10703c05bc4563$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($1b10703c05bc4563$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $1b10703c05bc4563$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $1b10703c05bc4563$export$f710a83a91838a36 = $1b10703c05bc4563$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $482b67b2d3fa61b4$export$2e2bcd8739ae039 = {
    ...$1b10703c05bc4563$exports,
    ...(0, $7402973c36ad2888$export$2e2bcd8739ae039)
};


'use strict';
function $b60433b467e8f345$export$2e2bcd8739ae039(data, options) {
    return (0, $0460442c5e4d0eef$export$2e2bcd8739ae039)(data, new (0, $482b67b2d3fa61b4$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $482b67b2d3fa61b4$export$2e2bcd8739ae039).isNode && (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $a49fed3c533ba4d1$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $a49fed3c533ba4d1$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $a49fed3c533ba4d1$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $a49fed3c533ba4d1$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isFormData(formData) && (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($a49fed3c533ba4d1$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $a49fed3c533ba4d1$export$2e2bcd8739ae039 = $a49fed3c533ba4d1$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $a706ae374901563f$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $a706ae374901563f$var$defaults = {
    transitional: (0, $6db42038762d90d3$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $a49fed3c533ba4d1$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isBuffer(data) || (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isStream(data) || (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isFile(data) || (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isBlob(data) || (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $b60433b467e8f345$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $0460442c5e4d0eef$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $a706ae374901563f$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $a706ae374901563f$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isResponse(data) || (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).from(e, (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $482b67b2d3fa61b4$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $482b67b2d3fa61b4$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $a706ae374901563f$var$defaults.headers[method] = {};
});
var $a706ae374901563f$export$2e2bcd8739ae039 = $a706ae374901563f$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $ad4d605599f235a1$var$ignoreDuplicateOf = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $ad4d605599f235a1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $ad4d605599f235a1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $9bd474c9ee06b25a$var$$internals = Symbol('internals');
function $9bd474c9ee06b25a$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $9bd474c9ee06b25a$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArray(value) ? value.map($9bd474c9ee06b25a$var$normalizeValue) : String(value);
}
function $9bd474c9ee06b25a$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $9bd474c9ee06b25a$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $9bd474c9ee06b25a$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $9bd474c9ee06b25a$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $9bd474c9ee06b25a$var$buildAccessors(obj, header) {
    const accessorName = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $9bd474c9ee06b25a$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $9bd474c9ee06b25a$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $9bd474c9ee06b25a$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$9bd474c9ee06b25a$var$isValidHeaderName(header)) setHeaders((0, $ad4d605599f235a1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isObject(header) && (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $9bd474c9ee06b25a$var$normalizeHeader(header);
        if (header) {
            const key = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $9bd474c9ee06b25a$var$parseTokens(value);
                if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $9bd474c9ee06b25a$var$normalizeHeader(header);
        if (header) {
            const key = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $9bd474c9ee06b25a$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $9bd474c9ee06b25a$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $9bd474c9ee06b25a$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $9bd474c9ee06b25a$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $9bd474c9ee06b25a$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $9bd474c9ee06b25a$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $9bd474c9ee06b25a$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$9bd474c9ee06b25a$var$$internals] = this[$9bd474c9ee06b25a$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $9bd474c9ee06b25a$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $9bd474c9ee06b25a$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$9bd474c9ee06b25a$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).reduceDescriptors($9bd474c9ee06b25a$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).freezeMethods($9bd474c9ee06b25a$var$AxiosHeaders);
var $9bd474c9ee06b25a$export$2e2bcd8739ae039 = $9bd474c9ee06b25a$var$AxiosHeaders;


'use strict';
function $0fd5b188ce25bfb6$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $a706ae374901563f$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $9bd474c9ee06b25a$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $a91a5c4415fe8f73$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9c6f095464d44aba$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).inherits($9c6f095464d44aba$var$CanceledError, (0, $ad6c282166e6c43d$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $9c6f095464d44aba$export$2e2bcd8739ae039 = $9c6f095464d44aba$var$CanceledError;







'use strict';
function $ab9175fae9871e46$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $ad6c282166e6c43d$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $23f40965218f17e2$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $14084ddc7d7d1513$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $14084ddc7d7d1513$export$2e2bcd8739ae039 = $14084ddc7d7d1513$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $4f0288725be3e659$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $4f0288725be3e659$export$2e2bcd8739ae039 = $4f0288725be3e659$var$throttle;



const $e3588811115eff11$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $14084ddc7d7d1513$export$2e2bcd8739ae039)(50, 250);
    return (0, $4f0288725be3e659$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $e3588811115eff11$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $e3588811115eff11$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $945a49bbb414db81$export$2e2bcd8739ae039 = (0, $482b67b2d3fa61b4$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $482b67b2d3fa61b4$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $482b67b2d3fa61b4$export$2e2bcd8739ae039).origin), (0, $482b67b2d3fa61b4$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $482b67b2d3fa61b4$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $1e9c874f84e57f14$export$2e2bcd8739ae039 = (0, $482b67b2d3fa61b4$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $ba8900928e0faf28$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $f3394c016e7ae517$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $7571e290c6210b17$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $ba8900928e0faf28$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $f3394c016e7ae517$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $7d21bec2a36f0740$var$headersToObject = (thing)=>thing instanceof (0, $9bd474c9ee06b25a$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $7d21bec2a36f0740$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isPlainObject(target) && (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($7d21bec2a36f0740$var$headersToObject(a), $7d21bec2a36f0740$var$headersToObject(b), prop, true)
    };
    (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $0438be7e0fa7476f$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $7d21bec2a36f0740$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $9bd474c9ee06b25a$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $e1993edaebf31f88$export$2e2bcd8739ae039)((0, $7571e290c6210b17$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $482b67b2d3fa61b4$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $482b67b2d3fa61b4$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $482b67b2d3fa61b4$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $945a49bbb414db81$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $1e9c874f84e57f14$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $cb48d65dc7fd2148$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $cb48d65dc7fd2148$export$2e2bcd8739ae039 = $cb48d65dc7fd2148$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $0438be7e0fa7476f$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $9bd474c9ee06b25a$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $9bd474c9ee06b25a$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ab9175fae9871e46$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $ad6c282166e6c43d$export$2e2bcd8739ae039)('Request aborted', (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $ad6c282166e6c43d$export$2e2bcd8739ae039)(msg, (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $6db42038762d90d3$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $ad6c282166e6c43d$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).ETIMEDOUT : (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $e3588811115eff11$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $e3588811115eff11$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9c6f095464d44aba$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $23f40965218f17e2$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $482b67b2d3fa61b4$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $ad6c282166e6c43d$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $1d1fb9660061b9bf$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $ad6c282166e6c43d$export$2e2bcd8739ae039) ? err : new (0, $9c6f095464d44aba$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $ad6c282166e6c43d$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $1d1fb9660061b9bf$export$2e2bcd8739ae039 = $1d1fb9660061b9bf$var$composeSignals;


const $bd34a5fac98eaabf$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $bd34a5fac98eaabf$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $bd34a5fac98eaabf$var$readStream(iterable))yield* $bd34a5fac98eaabf$export$71b051935044bd5d(chunk, chunkSize);
};
const $bd34a5fac98eaabf$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $bd34a5fac98eaabf$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $bd34a5fac98eaabf$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $3d2c73a3b3f653c1$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $3d2c73a3b3f653c1$var$isFunction } = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039);
const $3d2c73a3b3f653c1$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).global);
const { ReadableStream: $3d2c73a3b3f653c1$var$ReadableStream, TextEncoder: $3d2c73a3b3f653c1$var$TextEncoder } = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).global;
const $3d2c73a3b3f653c1$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $3d2c73a3b3f653c1$var$factory = (env)=>{
    env = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $3d2c73a3b3f653c1$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $3d2c73a3b3f653c1$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $3d2c73a3b3f653c1$var$isFunction(Request);
    const isResponseSupported = $3d2c73a3b3f653c1$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $3d2c73a3b3f653c1$var$isFunction($3d2c73a3b3f653c1$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $3d2c73a3b3f653c1$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $3d2c73a3b3f653c1$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $3d2c73a3b3f653c1$var$test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, $482b67b2d3fa61b4$export$2e2bcd8739ae039).origin, {
            body: new $3d2c73a3b3f653c1$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $3d2c73a3b3f653c1$var$test(()=>(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $ad6c282166e6c43d$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $482b67b2d3fa61b4$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $0438be7e0fa7476f$export$2e2bcd8739ae039)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $1d1fb9660061b9bf$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: "half"
                });
                let contentTypeHeader;
                if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $e3588811115eff11$export$d9fadd12586c18d6)(requestContentLength, (0, $e3588811115eff11$export$c1b28109d46c3592)((0, $e3588811115eff11$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $bd34a5fac98eaabf$export$b0119225647bd83)(_request.body, $3d2c73a3b3f653c1$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $e3588811115eff11$export$d9fadd12586c18d6)(responseContentLength, (0, $e3588811115eff11$export$c1b28109d46c3592)((0, $e3588811115eff11$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                response = new Response((0, $bd34a5fac98eaabf$export$b0119225647bd83)(response.body, $3d2c73a3b3f653c1$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $ab9175fae9871e46$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $9bd474c9ee06b25a$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $ad6c282166e6c43d$export$2e2bcd8739ae039)('Network Error', (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
                cause: err.cause || err
            });
            throw (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
        }
    };
};
const $3d2c73a3b3f653c1$var$seedCache = new Map();
const $3d2c73a3b3f653c1$export$3105c6651375d4fa = (config)=>{
    let env = config ? config.env : {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $3d2c73a3b3f653c1$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $3d2c73a3b3f653c1$var$factory(env));
        map = target;
    }
    return target;
};
const $3d2c73a3b3f653c1$var$adapter = $3d2c73a3b3f653c1$export$3105c6651375d4fa();
var $3d2c73a3b3f653c1$export$2e2bcd8739ae039 = $3d2c73a3b3f653c1$var$adapter;



const $b0eda89ffc150414$var$knownAdapters = {
    http: (0, $9507473dc3236b04$export$2e2bcd8739ae039),
    xhr: (0, $cb48d65dc7fd2148$export$2e2bcd8739ae039),
    fetch: {
        get: $3d2c73a3b3f653c1$export$3105c6651375d4fa
    }
};
(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).forEach($b0eda89ffc150414$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $b0eda89ffc150414$var$renderReason = (reason)=>`- ${reason}`;
const $b0eda89ffc150414$var$isResolvedHandle = (adapter)=>(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $b0eda89ffc150414$export$2e2bcd8739ae039 = {
    getAdapter: (adapters, config)=>{
        adapters = (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$b0eda89ffc150414$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $b0eda89ffc150414$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $ad6c282166e6c43d$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter && ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($b0eda89ffc150414$var$renderReason).join('\n') : ' ' + $b0eda89ffc150414$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $ad6c282166e6c43d$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $b0eda89ffc150414$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $f59c4da7c686563f$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9c6f095464d44aba$export$2e2bcd8739ae039)(null, config);
}
function $f59c4da7c686563f$export$2e2bcd8739ae039(config) {
    $f59c4da7c686563f$var$throwIfCancellationRequested(config);
    config.headers = (0, $9bd474c9ee06b25a$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $0fd5b188ce25bfb6$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $b0eda89ffc150414$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $a706ae374901563f$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $f59c4da7c686563f$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $0fd5b188ce25bfb6$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $9bd474c9ee06b25a$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $a91a5c4415fe8f73$export$2e2bcd8739ae039)(reason)) {
            $f59c4da7c686563f$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $0fd5b188ce25bfb6$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $9bd474c9ee06b25a$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $c518999a8c95b317$export$a4ad2735b021c132 = "1.12.2";



'use strict';
const $97f00e46dc04fb38$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $97f00e46dc04fb38$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $97f00e46dc04fb38$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $97f00e46dc04fb38$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $c518999a8c95b317$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $ad6c282166e6c43d$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$97f00e46dc04fb38$var$deprecatedWarnings[opt]) {
            $97f00e46dc04fb38$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$97f00e46dc04fb38$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $97f00e46dc04fb38$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $ad6c282166e6c43d$export$2e2bcd8739ae039)('options must be an object', (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $ad6c282166e6c43d$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $ad6c282166e6c43d$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $ad6c282166e6c43d$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $97f00e46dc04fb38$export$2e2bcd8739ae039 = {
    assertOptions: $97f00e46dc04fb38$var$assertOptions,
    validators: $97f00e46dc04fb38$var$validators
};



'use strict';
const $9d015caea9a29454$var$validators = (0, $97f00e46dc04fb38$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $9d015caea9a29454$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $aa63a98a0047561b$export$2e2bcd8739ae039)(),
            response: new (0, $aa63a98a0047561b$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $7d21bec2a36f0740$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $97f00e46dc04fb38$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $9d015caea9a29454$var$validators.transitional($9d015caea9a29454$var$validators.boolean),
            forcedJSONParsing: $9d015caea9a29454$var$validators.transitional($9d015caea9a29454$var$validators.boolean),
            clarifyTimeoutError: $9d015caea9a29454$var$validators.transitional($9d015caea9a29454$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $97f00e46dc04fb38$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $9d015caea9a29454$var$validators.function,
                serialize: $9d015caea9a29454$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $97f00e46dc04fb38$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $9d015caea9a29454$var$validators.spelling('baseURL'),
            withXsrfToken: $9d015caea9a29454$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $9bd474c9ee06b25a$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $f59c4da7c686563f$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $f59c4da7c686563f$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $7d21bec2a36f0740$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $7571e290c6210b17$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $e1993edaebf31f88$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $9d015caea9a29454$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $7d21bec2a36f0740$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $96bf4ecd87681c49$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $7d21bec2a36f0740$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $9d015caea9a29454$var$Axios.prototype[method] = generateHTTPMethod();
    $9d015caea9a29454$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $9d015caea9a29454$export$2e2bcd8739ae039 = $9d015caea9a29454$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $9682e576288e4c91$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9c6f095464d44aba$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $9682e576288e4c91$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $9682e576288e4c91$export$2e2bcd8739ae039 = $9682e576288e4c91$var$CancelToken;






'use strict';
function $c40d60358c7afb0b$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $3ea330dd19ed61a9$export$2e2bcd8739ae039(payload) {
    return (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $7462125ec565a4a9$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($7462125ec565a4a9$var$HttpStatusCode).forEach(([key, value])=>{
    $7462125ec565a4a9$var$HttpStatusCode[value] = key;
});
var $7462125ec565a4a9$export$2e2bcd8739ae039 = $7462125ec565a4a9$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $3a7fe52a8cf7806b$var$createInstance(defaultConfig) {
    const context = new (0, $9d015caea9a29454$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $1c004eb3eb783df1$export$2e2bcd8739ae039)((0, $9d015caea9a29454$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).extend(instance, (0, $9d015caea9a29454$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $96bf4ecd87681c49$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $3a7fe52a8cf7806b$var$createInstance((0, $7d21bec2a36f0740$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $3a7fe52a8cf7806b$var$axios = $3a7fe52a8cf7806b$var$createInstance((0, $a706ae374901563f$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$3a7fe52a8cf7806b$var$axios.Axios = (0, $9d015caea9a29454$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$3a7fe52a8cf7806b$var$axios.CanceledError = (0, $9c6f095464d44aba$export$2e2bcd8739ae039);
$3a7fe52a8cf7806b$var$axios.CancelToken = (0, $9682e576288e4c91$export$2e2bcd8739ae039);
$3a7fe52a8cf7806b$var$axios.isCancel = (0, $a91a5c4415fe8f73$export$2e2bcd8739ae039);
$3a7fe52a8cf7806b$var$axios.VERSION = (0, $c518999a8c95b317$export$a4ad2735b021c132);
$3a7fe52a8cf7806b$var$axios.toFormData = (0, $0460442c5e4d0eef$export$2e2bcd8739ae039);
// Expose AxiosError class
$3a7fe52a8cf7806b$var$axios.AxiosError = (0, $ad6c282166e6c43d$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$3a7fe52a8cf7806b$var$axios.Cancel = $3a7fe52a8cf7806b$var$axios.CanceledError;
// Expose all/spread
$3a7fe52a8cf7806b$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$3a7fe52a8cf7806b$var$axios.spread = (0, $c40d60358c7afb0b$export$2e2bcd8739ae039);
// Expose isAxiosError
$3a7fe52a8cf7806b$var$axios.isAxiosError = (0, $3ea330dd19ed61a9$export$2e2bcd8739ae039);
// Expose mergeConfig
$3a7fe52a8cf7806b$var$axios.mergeConfig = (0, $7d21bec2a36f0740$export$2e2bcd8739ae039);
$3a7fe52a8cf7806b$var$axios.AxiosHeaders = (0, $9bd474c9ee06b25a$export$2e2bcd8739ae039);
$3a7fe52a8cf7806b$var$axios.formToJSON = (thing)=>(0, $a49fed3c533ba4d1$export$2e2bcd8739ae039)((0, $96bf4ecd87681c49$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$3a7fe52a8cf7806b$var$axios.getAdapter = (0, $b0eda89ffc150414$export$2e2bcd8739ae039).getAdapter;
$3a7fe52a8cf7806b$var$axios.HttpStatusCode = (0, $7462125ec565a4a9$export$2e2bcd8739ae039);
$3a7fe52a8cf7806b$var$axios.default = $3a7fe52a8cf7806b$var$axios;
var // this module should only have a default export
$3a7fe52a8cf7806b$export$2e2bcd8739ae039 = $3a7fe52a8cf7806b$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $d7df1784dcfb62bb$export$1c00760e9e5a4e95, AxiosError: $d7df1784dcfb62bb$export$c1fbed17c2f6a328, CanceledError: $d7df1784dcfb62bb$export$1ab0c6b20d94fa14, isCancel: $d7df1784dcfb62bb$export$3b22524397b493c6, CancelToken: $d7df1784dcfb62bb$export$fd08e3cb425f0d61, VERSION: $d7df1784dcfb62bb$export$a4ad2735b021c132, all: $d7df1784dcfb62bb$export$84bf76cd7afc7469, Cancel: $d7df1784dcfb62bb$export$848c9b7ead0df967, isAxiosError: $d7df1784dcfb62bb$export$fbafdbe06a5b5a9a, spread: $d7df1784dcfb62bb$export$3ae0fd4797ed47c8, toFormData: $d7df1784dcfb62bb$export$10ae0d317ea97f8b, AxiosHeaders: $d7df1784dcfb62bb$export$4e7d6ff0f3e6520, HttpStatusCode: $d7df1784dcfb62bb$export$a972f69c851492b3, formToJSON: $d7df1784dcfb62bb$export$86d7c59254d6a2c9, getAdapter: $d7df1784dcfb62bb$export$17ddc20a97d669e2, mergeConfig: $d7df1784dcfb62bb$export$7ec1ebcfa9d8bd6a } = (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039);


/**
 * React Router DOM v6.22.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6uYXW = parcelRequire("6uYXW");

/**
 * @remix-run/router v1.15.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $9a468b9555c2dd85$var$_extends() {
    $9a468b9555c2dd85$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9a468b9555c2dd85$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $9a468b9555c2dd85$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($9a468b9555c2dd85$export$e19cd5f9376f8cee || ($9a468b9555c2dd85$export$e19cd5f9376f8cee = {}));
const $9a468b9555c2dd85$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $9a468b9555c2dd85$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $9a468b9555c2dd85$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $9a468b9555c2dd85$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $9a468b9555c2dd85$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $9a468b9555c2dd85$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $9a468b9555c2dd85$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $9a468b9555c2dd85$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $9a468b9555c2dd85$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $9a468b9555c2dd85$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $9a468b9555c2dd85$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $9a468b9555c2dd85$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $9a468b9555c2dd85$export$fe53371bee54353d(to);
    }
    return $9a468b9555c2dd85$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $9a468b9555c2dd85$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $9a468b9555c2dd85$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $9a468b9555c2dd85$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $9a468b9555c2dd85$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $9a468b9555c2dd85$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $9a468b9555c2dd85$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $9a468b9555c2dd85$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $9a468b9555c2dd85$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $9a468b9555c2dd85$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $9a468b9555c2dd85$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $9a468b9555c2dd85$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $9a468b9555c2dd85$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $9a468b9555c2dd85$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $9a468b9555c2dd85$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $9a468b9555c2dd85$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $9a468b9555c2dd85$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $9a468b9555c2dd85$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $9a468b9555c2dd85$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($9a468b9555c2dd85$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $9a468b9555c2dd85$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $9a468b9555c2dd85$export$e19cd5f9376f8cee.Push;
        let location = $9a468b9555c2dd85$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $9a468b9555c2dd85$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $9a468b9555c2dd85$export$e19cd5f9376f8cee.Replace;
        let location = $9a468b9555c2dd85$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $9a468b9555c2dd85$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $9a468b9555c2dd85$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $9a468b9555c2dd85$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($9a468b9555c2dd85$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($9a468b9555c2dd85$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $9a468b9555c2dd85$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($9a468b9555c2dd85$var$ResultType || ($9a468b9555c2dd85$var$ResultType = {}));
const $9a468b9555c2dd85$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $9a468b9555c2dd85$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $9a468b9555c2dd85$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $9a468b9555c2dd85$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $9a468b9555c2dd85$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($9a468b9555c2dd85$var$isIndexRoute(route)) {
            let indexRoute = $9a468b9555c2dd85$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $9a468b9555c2dd85$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $9a468b9555c2dd85$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $9a468b9555c2dd85$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $9a468b9555c2dd85$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $9a468b9555c2dd85$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $9a468b9555c2dd85$var$flattenRoutes(routes);
    $9a468b9555c2dd85$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $9a468b9555c2dd85$var$decodePath(pathname);
        matches = $9a468b9555c2dd85$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $9a468b9555c2dd85$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $9a468b9555c2dd85$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $9a468b9555c2dd85$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $9a468b9555c2dd85$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $9a468b9555c2dd85$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $9a468b9555c2dd85$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $9a468b9555c2dd85$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $9a468b9555c2dd85$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $9a468b9555c2dd85$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $9a468b9555c2dd85$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $9a468b9555c2dd85$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $9a468b9555c2dd85$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $9a468b9555c2dd85$var$paramRe = /^:[\w-]+$/;
const $9a468b9555c2dd85$var$dynamicSegmentValue = 3;
const $9a468b9555c2dd85$var$indexRouteValue = 2;
const $9a468b9555c2dd85$var$emptySegmentValue = 1;
const $9a468b9555c2dd85$var$staticSegmentValue = 10;
const $9a468b9555c2dd85$var$splatPenalty = -2;
const $9a468b9555c2dd85$var$isSplat = (s)=>s === "*";
function $9a468b9555c2dd85$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($9a468b9555c2dd85$var$isSplat)) initialScore += $9a468b9555c2dd85$var$splatPenalty;
    if (index) initialScore += $9a468b9555c2dd85$var$indexRouteValue;
    return segments.filter((s)=>!$9a468b9555c2dd85$var$isSplat(s)).reduce((score, segment)=>score + ($9a468b9555c2dd85$var$paramRe.test(segment) ? $9a468b9555c2dd85$var$dynamicSegmentValue : segment === "" ? $9a468b9555c2dd85$var$emptySegmentValue : $9a468b9555c2dd85$var$staticSegmentValue), initialScore);
}
function $9a468b9555c2dd85$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $9a468b9555c2dd85$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $9a468b9555c2dd85$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $9a468b9555c2dd85$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $9a468b9555c2dd85$export$a5c6d149b50c1d86($9a468b9555c2dd85$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $9a468b9555c2dd85$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $9a468b9555c2dd85$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $9a468b9555c2dd85$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $9a468b9555c2dd85$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $9a468b9555c2dd85$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $9a468b9555c2dd85$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $9a468b9555c2dd85$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $9a468b9555c2dd85$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $9a468b9555c2dd85$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $9a468b9555c2dd85$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $9a468b9555c2dd85$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $9a468b9555c2dd85$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $9a468b9555c2dd85$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $9a468b9555c2dd85$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $9a468b9555c2dd85$var$normalizeSearch(search),
        hash: $9a468b9555c2dd85$var$normalizeHash(hash)
    };
}
function $9a468b9555c2dd85$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $9a468b9555c2dd85$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $9a468b9555c2dd85$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $9a468b9555c2dd85$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $9a468b9555c2dd85$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $9a468b9555c2dd85$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $9a468b9555c2dd85$export$8ccf933b0513f8d0(toArg);
    else {
        to = $9a468b9555c2dd85$var$_extends({}, toArg);
        $9a468b9555c2dd85$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $9a468b9555c2dd85$var$getInvalidPathError("?", "pathname", "search", to));
        $9a468b9555c2dd85$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $9a468b9555c2dd85$var$getInvalidPathError("#", "pathname", "hash", to));
        $9a468b9555c2dd85$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $9a468b9555c2dd85$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $9a468b9555c2dd85$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $9a468b9555c2dd85$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $9a468b9555c2dd85$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $9a468b9555c2dd85$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $9a468b9555c2dd85$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $9a468b9555c2dd85$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $9a468b9555c2dd85$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $9a468b9555c2dd85$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $9a468b9555c2dd85$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $9a468b9555c2dd85$export$42a99a7a4bc0e76a extends Error {
}
class $9a468b9555c2dd85$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $9a468b9555c2dd85$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $9a468b9555c2dd85$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $9a468b9555c2dd85$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $9a468b9555c2dd85$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $9a468b9555c2dd85$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $9a468b9555c2dd85$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $9a468b9555c2dd85$var$unwrapTrackedPromise(value) {
    if (!$9a468b9555c2dd85$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $9a468b9555c2dd85$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $9a468b9555c2dd85$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $9a468b9555c2dd85$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $9a468b9555c2dd85$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $9a468b9555c2dd85$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $9a468b9555c2dd85$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $9a468b9555c2dd85$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $9a468b9555c2dd85$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $9a468b9555c2dd85$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $9a468b9555c2dd85$var$validMutationMethods = new Set($9a468b9555c2dd85$var$validMutationMethodsArr);
const $9a468b9555c2dd85$var$validRequestMethodsArr = [
    "get",
    ...$9a468b9555c2dd85$var$validMutationMethodsArr
];
const $9a468b9555c2dd85$var$validRequestMethods = new Set($9a468b9555c2dd85$var$validRequestMethodsArr);
const $9a468b9555c2dd85$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $9a468b9555c2dd85$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $9a468b9555c2dd85$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $9a468b9555c2dd85$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $9a468b9555c2dd85$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $9a468b9555c2dd85$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $9a468b9555c2dd85$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $9a468b9555c2dd85$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $9a468b9555c2dd85$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $9a468b9555c2dd85$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $9a468b9555c2dd85$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $9a468b9555c2dd85$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $9a468b9555c2dd85$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $9a468b9555c2dd85$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $9a468b9555c2dd85$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $9a468b9555c2dd85$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $9a468b9555c2dd85$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $9a468b9555c2dd85$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $9a468b9555c2dd85$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $9a468b9555c2dd85$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $9a468b9555c2dd85$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$9a468b9555c2dd85$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($9a468b9555c2dd85$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $9a468b9555c2dd85$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $9a468b9555c2dd85$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $9a468b9555c2dd85$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $9a468b9555c2dd85$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $9a468b9555c2dd85$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $9a468b9555c2dd85$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $9a468b9555c2dd85$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $9a468b9555c2dd85$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $9a468b9555c2dd85$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($9a468b9555c2dd85$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $9a468b9555c2dd85$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $9a468b9555c2dd85$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $9a468b9555c2dd85$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $9a468b9555c2dd85$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $9a468b9555c2dd85$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $9a468b9555c2dd85$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $9a468b9555c2dd85$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $9a468b9555c2dd85$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $9a468b9555c2dd85$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $9a468b9555c2dd85$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $9a468b9555c2dd85$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $9a468b9555c2dd85$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $9a468b9555c2dd85$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $9a468b9555c2dd85$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $9a468b9555c2dd85$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $9a468b9555c2dd85$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $9a468b9555c2dd85$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$9a468b9555c2dd85$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $9a468b9555c2dd85$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $9a468b9555c2dd85$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $9a468b9555c2dd85$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $9a468b9555c2dd85$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $9a468b9555c2dd85$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $9a468b9555c2dd85$var$ResultType.error,
            error: $9a468b9555c2dd85$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $9a468b9555c2dd85$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($9a468b9555c2dd85$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($9a468b9555c2dd85$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $9a468b9555c2dd85$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $9a468b9555c2dd85$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($9a468b9555c2dd85$var$isDeferredResult(result)) throw $9a468b9555c2dd85$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $9a468b9555c2dd85$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $9a468b9555c2dd85$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $9a468b9555c2dd85$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $9a468b9555c2dd85$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since iot's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $9a468b9555c2dd85$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($9a468b9555c2dd85$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $9a468b9555c2dd85$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $9a468b9555c2dd85$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $9a468b9555c2dd85$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $9a468b9555c2dd85$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $9a468b9555c2dd85$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $9a468b9555c2dd85$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $9a468b9555c2dd85$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $9a468b9555c2dd85$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $9a468b9555c2dd85$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $9a468b9555c2dd85$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $9a468b9555c2dd85$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $9a468b9555c2dd85$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $9a468b9555c2dd85$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($9a468b9555c2dd85$var$isRedirectResult(actionResult) || $9a468b9555c2dd85$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $9a468b9555c2dd85$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($9a468b9555c2dd85$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $9a468b9555c2dd85$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $9a468b9555c2dd85$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($9a468b9555c2dd85$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($9a468b9555c2dd85$var$isDeferredResult(actionResult)) throw $9a468b9555c2dd85$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $9a468b9555c2dd85$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $9a468b9555c2dd85$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $9a468b9555c2dd85$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $9a468b9555c2dd85$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $9a468b9555c2dd85$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $9a468b9555c2dd85$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $9a468b9555c2dd85$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $9a468b9555c2dd85$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $9a468b9555c2dd85$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $9a468b9555c2dd85$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $9a468b9555c2dd85$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $9a468b9555c2dd85$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $9a468b9555c2dd85$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $9a468b9555c2dd85$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($9a468b9555c2dd85$var$isDeferredResult(result)) result = await $9a468b9555c2dd85$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $9a468b9555c2dd85$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($9a468b9555c2dd85$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $9a468b9555c2dd85$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($9a468b9555c2dd85$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $9a468b9555c2dd85$export$3e9cee6b33872309(!$9a468b9555c2dd85$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $9a468b9555c2dd85$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $9a468b9555c2dd85$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $9a468b9555c2dd85$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($9a468b9555c2dd85$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $9a468b9555c2dd85$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $9a468b9555c2dd85$export$e19cd5f9376f8cee.Replace : $9a468b9555c2dd85$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $9a468b9555c2dd85$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($9a468b9555c2dd85$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $9a468b9555c2dd85$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $9a468b9555c2dd85$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $9a468b9555c2dd85$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$9a468b9555c2dd85$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $9a468b9555c2dd85$var$callLoaderOrAction("loader", $9a468b9555c2dd85$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $9a468b9555c2dd85$var$ResultType.error,
                        error: $9a468b9555c2dd85$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $9a468b9555c2dd85$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $9a468b9555c2dd85$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $9a468b9555c2dd85$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $9a468b9555c2dd85$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $9a468b9555c2dd85$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $9a468b9555c2dd85$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $9a468b9555c2dd85$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $9a468b9555c2dd85$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $9a468b9555c2dd85$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $9a468b9555c2dd85$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $9a468b9555c2dd85$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $9a468b9555c2dd85$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $9a468b9555c2dd85$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$9a468b9555c2dd85$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $9a468b9555c2dd85$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $9a468b9555c2dd85$export$4d0306f8f6a4585b = Symbol("deferred");
function $9a468b9555c2dd85$export$3336b097a6fbc59a(routes, opts) {
    $9a468b9555c2dd85$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $9a468b9555c2dd85$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $9a468b9555c2dd85$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $9a468b9555c2dd85$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $9a468b9555c2dd85$var$createLocation("", $9a468b9555c2dd85$export$fe53371bee54353d(url), null, "default");
        let matches = $9a468b9555c2dd85$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$9a468b9555c2dd85$var$isValidMethod(method) && method !== "HEAD") {
            let error = $9a468b9555c2dd85$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $9a468b9555c2dd85$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $9a468b9555c2dd85$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $9a468b9555c2dd85$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($9a468b9555c2dd85$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $9a468b9555c2dd85$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $9a468b9555c2dd85$var$createLocation("", $9a468b9555c2dd85$export$fe53371bee54353d(url), null, "default");
        let matches = $9a468b9555c2dd85$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$9a468b9555c2dd85$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $9a468b9555c2dd85$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $9a468b9555c2dd85$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $9a468b9555c2dd85$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $9a468b9555c2dd85$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $9a468b9555c2dd85$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($9a468b9555c2dd85$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$9a468b9555c2dd85$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $9a468b9555c2dd85$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($9a468b9555c2dd85$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $9a468b9555c2dd85$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $9a468b9555c2dd85$var$isResponse(result) ? result : $9a468b9555c2dd85$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($9a468b9555c2dd85$var$isQueryRouteResponse(e)) {
                if (e.type === $9a468b9555c2dd85$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($9a468b9555c2dd85$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $9a468b9555c2dd85$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $9a468b9555c2dd85$var$ResultType.error,
                error: error
            };
        } else {
            result = await $9a468b9555c2dd85$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $9a468b9555c2dd85$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($9a468b9555c2dd85$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($9a468b9555c2dd85$var$isDeferredResult(result)) {
            let error = $9a468b9555c2dd85$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $9a468b9555c2dd85$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($9a468b9555c2dd85$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($9a468b9555c2dd85$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $9a468b9555c2dd85$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $9a468b9555c2dd85$var$_extends({}, context, {
                statusCode: $9a468b9555c2dd85$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $9a468b9555c2dd85$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $9a468b9555c2dd85$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $9a468b9555c2dd85$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $9a468b9555c2dd85$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $9a468b9555c2dd85$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$9a468b9555c2dd85$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $9a468b9555c2dd85$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $9a468b9555c2dd85$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $9a468b9555c2dd85$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $9a468b9555c2dd85$export$fec11da027c70692(routes, context, error) {
    let newContext = $9a468b9555c2dd85$var$_extends({}, context, {
        statusCode: $9a468b9555c2dd85$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $9a468b9555c2dd85$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $9a468b9555c2dd85$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $9a468b9555c2dd85$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $9a468b9555c2dd85$export$cae722b0cc860f13(to ? to : ".", $9a468b9555c2dd85$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $9a468b9555c2dd85$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$9a468b9555c2dd85$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $9a468b9555c2dd85$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $9a468b9555c2dd85$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $9a468b9555c2dd85$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$9a468b9555c2dd85$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$9a468b9555c2dd85$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $9a468b9555c2dd85$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $9a468b9555c2dd85$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $9a468b9555c2dd85$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$9a468b9555c2dd85$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$9a468b9555c2dd85$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $9a468b9555c2dd85$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $9a468b9555c2dd85$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $9a468b9555c2dd85$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $9a468b9555c2dd85$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $9a468b9555c2dd85$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($9a468b9555c2dd85$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $9a468b9555c2dd85$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $9a468b9555c2dd85$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $9a468b9555c2dd85$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $9a468b9555c2dd85$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $9a468b9555c2dd85$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $9a468b9555c2dd85$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($9a468b9555c2dd85$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $9a468b9555c2dd85$var$shouldRevalidateLoader(match, $9a468b9555c2dd85$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $9a468b9555c2dd85$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $9a468b9555c2dd85$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $9a468b9555c2dd85$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $9a468b9555c2dd85$var$shouldRevalidateLoader(fetcherMatch, $9a468b9555c2dd85$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $9a468b9555c2dd85$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $9a468b9555c2dd85$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $9a468b9555c2dd85$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $9a468b9555c2dd85$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $9a468b9555c2dd85$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $9a468b9555c2dd85$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$9a468b9555c2dd85$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $9a468b9555c2dd85$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $9a468b9555c2dd85$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $9a468b9555c2dd85$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $9a468b9555c2dd85$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $9a468b9555c2dd85$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $9a468b9555c2dd85$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $9a468b9555c2dd85$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $9a468b9555c2dd85$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $9a468b9555c2dd85$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($9a468b9555c2dd85$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($9a468b9555c2dd85$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $9a468b9555c2dd85$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$9a468b9555c2dd85$var$ABSOLUTE_URL_REGEX.test(location)) location = $9a468b9555c2dd85$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $9a468b9555c2dd85$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $9a468b9555c2dd85$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $9a468b9555c2dd85$var$ResultType.error ? $9a468b9555c2dd85$var$ResultType.error : $9a468b9555c2dd85$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $9a468b9555c2dd85$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $9a468b9555c2dd85$var$ResultType.error) return {
            type: resultType,
            error: new $9a468b9555c2dd85$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $9a468b9555c2dd85$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $9a468b9555c2dd85$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($9a468b9555c2dd85$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $9a468b9555c2dd85$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $9a468b9555c2dd85$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $9a468b9555c2dd85$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($9a468b9555c2dd85$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $9a468b9555c2dd85$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $9a468b9555c2dd85$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $9a468b9555c2dd85$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $9a468b9555c2dd85$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $9a468b9555c2dd85$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $9a468b9555c2dd85$export$3e9cee6b33872309(!$9a468b9555c2dd85$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($9a468b9555c2dd85$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $9a468b9555c2dd85$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $9a468b9555c2dd85$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($9a468b9555c2dd85$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $9a468b9555c2dd85$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $9a468b9555c2dd85$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $9a468b9555c2dd85$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($9a468b9555c2dd85$var$isErrorResult(result)) {
            let boundaryMatch = $9a468b9555c2dd85$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $9a468b9555c2dd85$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($9a468b9555c2dd85$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $9a468b9555c2dd85$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($9a468b9555c2dd85$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $9a468b9555c2dd85$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $9a468b9555c2dd85$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $9a468b9555c2dd85$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $9a468b9555c2dd85$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $9a468b9555c2dd85$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $9a468b9555c2dd85$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $9a468b9555c2dd85$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $9a468b9555c2dd85$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $9a468b9555c2dd85$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($9a468b9555c2dd85$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $9a468b9555c2dd85$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $9a468b9555c2dd85$export$8ccf933b0513f8d0(path) : path;
    return $9a468b9555c2dd85$export$fe53371bee54353d($9a468b9555c2dd85$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $9a468b9555c2dd85$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $9a468b9555c2dd85$var$isDeferredResult(result) {
    return result.type === $9a468b9555c2dd85$var$ResultType.deferred;
}
function $9a468b9555c2dd85$var$isErrorResult(result) {
    return result.type === $9a468b9555c2dd85$var$ResultType.error;
}
function $9a468b9555c2dd85$var$isRedirectResult(result) {
    return (result && result.type) === $9a468b9555c2dd85$var$ResultType.redirect;
}
function $9a468b9555c2dd85$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $9a468b9555c2dd85$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $9a468b9555c2dd85$var$isRedirectResponse(result) {
    if (!$9a468b9555c2dd85$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $9a468b9555c2dd85$var$isQueryRouteResponse(obj) {
    return obj && $9a468b9555c2dd85$var$isResponse(obj.response) && (obj.type === $9a468b9555c2dd85$var$ResultType.data || obj.type === $9a468b9555c2dd85$var$ResultType.error);
}
function $9a468b9555c2dd85$var$isValidMethod(method) {
    return $9a468b9555c2dd85$var$validRequestMethods.has(method.toLowerCase());
}
function $9a468b9555c2dd85$var$isMutationMethod(method) {
    return $9a468b9555c2dd85$var$validMutationMethods.has(method.toLowerCase());
}
async function $9a468b9555c2dd85$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$9a468b9555c2dd85$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($9a468b9555c2dd85$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $9a468b9555c2dd85$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $9a468b9555c2dd85$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $9a468b9555c2dd85$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $9a468b9555c2dd85$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $9a468b9555c2dd85$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $9a468b9555c2dd85$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $9a468b9555c2dd85$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $9a468b9555c2dd85$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $9a468b9555c2dd85$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $9a468b9555c2dd85$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $9a468b9555c2dd85$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $9a468b9555c2dd85$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $9a468b9555c2dd85$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $9a468b9555c2dd85$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $9a468b9555c2dd85$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $9a468b9555c2dd85$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $9a468b9555c2dd85$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $9a468b9555c2dd85$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($9a468b9555c2dd85$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $9a468b9555c2dd85$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($9a468b9555c2dd85$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $9a468b9555c2dd85$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6uYXW = parcelRequire("6uYXW");

function $88be82bcdaab0750$var$_extends() {
    $88be82bcdaab0750$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $88be82bcdaab0750$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $88be82bcdaab0750$export$3add0d5dce533e2e = /*#__PURE__*/ $6uYXW.createContext(null);
const $88be82bcdaab0750$export$145dfa71566a64dc = /*#__PURE__*/ $6uYXW.createContext(null);
const $88be82bcdaab0750$var$AwaitContext = /*#__PURE__*/ $6uYXW.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $88be82bcdaab0750$export$26749e8557646306 = /*#__PURE__*/ $6uYXW.createContext(null);
const $88be82bcdaab0750$export$c7914228fb69b0f5 = /*#__PURE__*/ $6uYXW.createContext(null);
const $88be82bcdaab0750$export$9072aa6dd1f93057 = /*#__PURE__*/ $6uYXW.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $88be82bcdaab0750$var$RouteErrorContext = /*#__PURE__*/ $6uYXW.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $88be82bcdaab0750$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$88be82bcdaab0750$export$9c954a9d03d32f4a() && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $6uYXW.useContext($88be82bcdaab0750$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $88be82bcdaab0750$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $9a468b9555c2dd85$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $88be82bcdaab0750$export$9c954a9d03d32f4a() {
    return $6uYXW.useContext($88be82bcdaab0750$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $88be82bcdaab0750$export$45d76561a5302f2b() {
    !$88be82bcdaab0750$export$9c954a9d03d32f4a() && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    return $6uYXW.useContext($88be82bcdaab0750$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $88be82bcdaab0750$export$1b3f31771c5d07c() {
    return $6uYXW.useContext($88be82bcdaab0750$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $88be82bcdaab0750$export$6c330e8992e8a295(pattern) {
    !$88be82bcdaab0750$export$9c954a9d03d32f4a() && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $88be82bcdaab0750$export$45d76561a5302f2b();
    return $6uYXW.useMemo(()=>(0, $9a468b9555c2dd85$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $88be82bcdaab0750$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $88be82bcdaab0750$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $6uYXW.useContext($88be82bcdaab0750$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $6uYXW.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $88be82bcdaab0750$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $6uYXW.useContext($88be82bcdaab0750$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $88be82bcdaab0750$var$useNavigateStable() : $88be82bcdaab0750$var$useNavigateUnstable();
}
function $88be82bcdaab0750$var$useNavigateUnstable() {
    !$88be82bcdaab0750$export$9c954a9d03d32f4a() && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    let dataRouterContext = $6uYXW.useContext($88be82bcdaab0750$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $6uYXW.useContext($88be82bcdaab0750$export$26749e8557646306);
    let { matches: matches } = $6uYXW.useContext($88be82bcdaab0750$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $88be82bcdaab0750$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $9a468b9555c2dd85$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $6uYXW.useRef(false);
    $88be82bcdaab0750$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $6uYXW.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $9a468b9555c2dd85$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $9a468b9555c2dd85$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $88be82bcdaab0750$var$OutletContext = /*#__PURE__*/ $6uYXW.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $88be82bcdaab0750$export$4138103a3ae699cc() {
    return $6uYXW.useContext($88be82bcdaab0750$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $88be82bcdaab0750$export$a3be3530d8e40d0b(context) {
    let outlet = $6uYXW.useContext($88be82bcdaab0750$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $88be82bcdaab0750$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $6uYXW.useContext($88be82bcdaab0750$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $88be82bcdaab0750$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $6uYXW.useContext($88be82bcdaab0750$export$26749e8557646306);
    let { matches: matches } = $6uYXW.useContext($88be82bcdaab0750$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $88be82bcdaab0750$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $9a468b9555c2dd85$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $6uYXW.useMemo(()=>(0, $9a468b9555c2dd85$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $88be82bcdaab0750$export$5d3fca4a98652595(routes, locationArg) {
    return $88be82bcdaab0750$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $88be82bcdaab0750$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$88be82bcdaab0750$export$9c954a9d03d32f4a() && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $6uYXW.useContext($88be82bcdaab0750$export$26749e8557646306);
    let { matches: parentMatches } = $6uYXW.useContext($88be82bcdaab0750$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $88be82bcdaab0750$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $9a468b9555c2dd85$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $9a468b9555c2dd85$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $88be82bcdaab0750$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $9a468b9555c2dd85$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $9a468b9555c2dd85$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $88be82bcdaab0750$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $9a468b9555c2dd85$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $88be82bcdaab0750$var$DefaultErrorComponent() {
    let error = $88be82bcdaab0750$export$ed527bf60f6e05f2();
    let message = (0, $9a468b9555c2dd85$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $6uYXW.createElement($6uYXW.Fragment, null, /*#__PURE__*/ $6uYXW.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $6uYXW.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $6uYXW.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $88be82bcdaab0750$var$defaultErrorElement = /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$var$DefaultErrorComponent, null);
class $88be82bcdaab0750$var$RenderErrorBoundary extends $6uYXW.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $88be82bcdaab0750$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $6uYXW.useContext($88be82bcdaab0750$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $88be82bcdaab0750$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $88be82bcdaab0750$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $88be82bcdaab0750$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $6uYXW.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $88be82bcdaab0750$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($88be82bcdaab0750$var$DataRouterHook || {});
var $88be82bcdaab0750$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($88be82bcdaab0750$var$DataRouterStateHook || {});
function $88be82bcdaab0750$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $88be82bcdaab0750$var$useDataRouterContext(hookName) {
    let ctx = $6uYXW.useContext($88be82bcdaab0750$export$3add0d5dce533e2e);
    !ctx && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    return ctx;
}
function $88be82bcdaab0750$var$useDataRouterState(hookName) {
    let state = $6uYXW.useContext($88be82bcdaab0750$export$145dfa71566a64dc);
    !state && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    return state;
}
function $88be82bcdaab0750$var$useRouteContext(hookName) {
    let route = $6uYXW.useContext($88be82bcdaab0750$export$9072aa6dd1f93057);
    !route && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $88be82bcdaab0750$var$useCurrentRouteId(hookName) {
    let route = $88be82bcdaab0750$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $88be82bcdaab0750$export$5fc8298006ad9e58() {
    return $88be82bcdaab0750$var$useCurrentRouteId($88be82bcdaab0750$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $88be82bcdaab0750$export$d0fd4b7106de2769() {
    let state = $88be82bcdaab0750$var$useDataRouterState($88be82bcdaab0750$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $88be82bcdaab0750$export$600dc272ed516c15() {
    let dataRouterContext = $88be82bcdaab0750$var$useDataRouterContext($88be82bcdaab0750$var$DataRouterHook.UseRevalidator);
    let state = $88be82bcdaab0750$var$useDataRouterState($88be82bcdaab0750$var$DataRouterStateHook.UseRevalidator);
    return $6uYXW.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $88be82bcdaab0750$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $88be82bcdaab0750$var$useDataRouterState($88be82bcdaab0750$var$DataRouterStateHook.UseMatches);
    return $6uYXW.useMemo(()=>matches.map((m)=>(0, $9a468b9555c2dd85$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $88be82bcdaab0750$export$1448a5050d252c4d() {
    let state = $88be82bcdaab0750$var$useDataRouterState($88be82bcdaab0750$var$DataRouterStateHook.UseLoaderData);
    let routeId = $88be82bcdaab0750$var$useCurrentRouteId($88be82bcdaab0750$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $88be82bcdaab0750$export$fd5d37484eab868d(routeId) {
    let state = $88be82bcdaab0750$var$useDataRouterState($88be82bcdaab0750$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $88be82bcdaab0750$export$fdc00f3f26066d5e() {
    let state = $88be82bcdaab0750$var$useDataRouterState($88be82bcdaab0750$var$DataRouterStateHook.UseActionData);
    let routeId = $88be82bcdaab0750$var$useCurrentRouteId($88be82bcdaab0750$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $88be82bcdaab0750$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $6uYXW.useContext($88be82bcdaab0750$var$RouteErrorContext);
    let state = $88be82bcdaab0750$var$useDataRouterState($88be82bcdaab0750$var$DataRouterStateHook.UseRouteError);
    let routeId = $88be82bcdaab0750$var$useCurrentRouteId($88be82bcdaab0750$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $88be82bcdaab0750$export$78a72ddb39bdd145() {
    let value = $6uYXW.useContext($88be82bcdaab0750$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $88be82bcdaab0750$export$17f53340677d5831() {
    let value = $6uYXW.useContext($88be82bcdaab0750$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $88be82bcdaab0750$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $88be82bcdaab0750$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $88be82bcdaab0750$var$useDataRouterContext($88be82bcdaab0750$var$DataRouterHook.UseBlocker);
    let state = $88be82bcdaab0750$var$useDataRouterState($88be82bcdaab0750$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $6uYXW.useState("");
    let blockerFunction = $6uYXW.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $88be82bcdaab0750$var$_extends({}, currentLocation, {
                pathname: (0, $9a468b9555c2dd85$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $88be82bcdaab0750$var$_extends({}, nextLocation, {
                pathname: (0, $9a468b9555c2dd85$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $6uYXW.useEffect(()=>{
        let key = String(++$88be82bcdaab0750$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $6uYXW.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $9a468b9555c2dd85$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $88be82bcdaab0750$var$useNavigateStable() {
    let { router: router } = $88be82bcdaab0750$var$useDataRouterContext($88be82bcdaab0750$var$DataRouterHook.UseNavigateStable);
    let id = $88be82bcdaab0750$var$useCurrentRouteId($88be82bcdaab0750$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $6uYXW.useRef(false);
    $88be82bcdaab0750$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $6uYXW.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $88be82bcdaab0750$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $88be82bcdaab0750$var$alreadyWarned = {};
function $88be82bcdaab0750$var$warningOnce(key, cond, message) {
    if (!cond && !$88be82bcdaab0750$var$alreadyWarned[key]) $88be82bcdaab0750$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $88be82bcdaab0750$var$START_TRANSITION = "startTransition";
const $88be82bcdaab0750$var$startTransitionImpl = $6uYXW[$88be82bcdaab0750$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $88be82bcdaab0750$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $6uYXW.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6uYXW.useCallback((newState)=>{
        if (v7_startTransition && $88be82bcdaab0750$var$startTransitionImpl) $88be82bcdaab0750$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $6uYXW.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $6uYXW.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $6uYXW.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $6uYXW.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6uYXW.createElement($6uYXW.Fragment, null, /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $88be82bcdaab0750$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $88be82bcdaab0750$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $88be82bcdaab0750$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $6uYXW.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9a468b9555c2dd85$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6uYXW.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6uYXW.useCallback((newState)=>{
        v7_startTransition && $88be82bcdaab0750$var$startTransitionImpl ? $88be82bcdaab0750$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6uYXW.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $88be82bcdaab0750$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$88be82bcdaab0750$export$9c954a9d03d32f4a() && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $6uYXW.useContext($88be82bcdaab0750$export$26749e8557646306);
    let { matches: matches } = $6uYXW.useContext($88be82bcdaab0750$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $88be82bcdaab0750$export$45d76561a5302f2b();
    let navigate = $88be82bcdaab0750$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $9a468b9555c2dd85$export$cae722b0cc860f13)(to, (0, $9a468b9555c2dd85$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $6uYXW.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $88be82bcdaab0750$export$910ae8079b2c2852(props) {
    return $88be82bcdaab0750$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $88be82bcdaab0750$export$e7b0ac011bb776c6(_props) {
    (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $88be82bcdaab0750$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $9a468b9555c2dd85$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$88be82bcdaab0750$export$9c954a9d03d32f4a() && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $6uYXW.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $88be82bcdaab0750$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $9a468b9555c2dd85$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $6uYXW.useMemo(()=>{
        let trailingPathname = (0, $9a468b9555c2dd85$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $88be82bcdaab0750$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $88be82bcdaab0750$export$5d3fca4a98652595($88be82bcdaab0750$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $88be82bcdaab0750$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$var$ResolveAwait, null, children));
}
var $88be82bcdaab0750$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($88be82bcdaab0750$var$AwaitRenderStatus || {});
const $88be82bcdaab0750$var$neverSettledPromise = new Promise(()=>{});
class $88be82bcdaab0750$var$AwaitErrorBoundary extends $6uYXW.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $88be82bcdaab0750$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $88be82bcdaab0750$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $88be82bcdaab0750$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $88be82bcdaab0750$var$AwaitRenderStatus.error : promise._data !== undefined ? $88be82bcdaab0750$var$AwaitRenderStatus.success : $88be82bcdaab0750$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $88be82bcdaab0750$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $88be82bcdaab0750$var$AwaitRenderStatus.error && promise._error instanceof (0, $9a468b9555c2dd85$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $88be82bcdaab0750$var$neverSettledPromise;
        if (status === $88be82bcdaab0750$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $88be82bcdaab0750$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $88be82bcdaab0750$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $6uYXW.createElement($88be82bcdaab0750$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $88be82bcdaab0750$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $88be82bcdaab0750$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $6uYXW.createElement($6uYXW.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $88be82bcdaab0750$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $6uYXW.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $6uYXW.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $6uYXW.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $88be82bcdaab0750$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $88be82bcdaab0750$export$e7b0ac011bb776c6) && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $88be82bcdaab0750$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $88be82bcdaab0750$export$daf73786167a7f72(matches) {
    return $88be82bcdaab0750$var$_renderMatches(matches);
}
function $88be82bcdaab0750$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $6uYXW.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $6uYXW.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $6uYXW.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $88be82bcdaab0750$export$f30f7e456d254e83(routes, opts) {
    return (0, $9a468b9555c2dd85$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $88be82bcdaab0750$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $9a468b9555c2dd85$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $88be82bcdaab0750$export$52b333d321859367
    }).initialize();
}



function $c6d33de9e7cf86ac$var$_extends() {
    $c6d33de9e7cf86ac$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c6d33de9e7cf86ac$var$_extends.apply(this, arguments);
}
function $c6d33de9e7cf86ac$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $c6d33de9e7cf86ac$var$defaultMethod = "get";
const $c6d33de9e7cf86ac$var$defaultEncType = "application/x-www-form-urlencoded";
function $c6d33de9e7cf86ac$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $c6d33de9e7cf86ac$var$isButtonElement(object) {
    return $c6d33de9e7cf86ac$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $c6d33de9e7cf86ac$var$isFormElement(object) {
    return $c6d33de9e7cf86ac$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $c6d33de9e7cf86ac$var$isInputElement(object) {
    return $c6d33de9e7cf86ac$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $c6d33de9e7cf86ac$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $c6d33de9e7cf86ac$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$c6d33de9e7cf86ac$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $c6d33de9e7cf86ac$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $c6d33de9e7cf86ac$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $c6d33de9e7cf86ac$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $c6d33de9e7cf86ac$var$_formDataSupportsSubmitter = null;
function $c6d33de9e7cf86ac$var$isFormDataSubmitterSupported() {
    if ($c6d33de9e7cf86ac$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $c6d33de9e7cf86ac$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $c6d33de9e7cf86ac$var$_formDataSupportsSubmitter = true;
    }
    return $c6d33de9e7cf86ac$var$_formDataSupportsSubmitter;
}
const $c6d33de9e7cf86ac$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $c6d33de9e7cf86ac$var$getFormEncType(encType) {
    if (encType != null && !$c6d33de9e7cf86ac$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $c6d33de9e7cf86ac$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($c6d33de9e7cf86ac$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $9a468b9555c2dd85$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $c6d33de9e7cf86ac$var$defaultMethod;
        encType = $c6d33de9e7cf86ac$var$getFormEncType(target.getAttribute("enctype")) || $c6d33de9e7cf86ac$var$defaultEncType;
        formData = new FormData(target);
    } else if ($c6d33de9e7cf86ac$var$isButtonElement(target) || $c6d33de9e7cf86ac$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $9a468b9555c2dd85$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $c6d33de9e7cf86ac$var$defaultMethod;
        encType = $c6d33de9e7cf86ac$var$getFormEncType(target.getAttribute("formenctype")) || $c6d33de9e7cf86ac$var$getFormEncType(form.getAttribute("enctype")) || $c6d33de9e7cf86ac$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$c6d33de9e7cf86ac$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($c6d33de9e7cf86ac$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $c6d33de9e7cf86ac$var$defaultMethod;
        action = null;
        encType = $c6d33de9e7cf86ac$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $c6d33de9e7cf86ac$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $c6d33de9e7cf86ac$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $c6d33de9e7cf86ac$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $c6d33de9e7cf86ac$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $c6d33de9e7cf86ac$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $c6d33de9e7cf86ac$export$1f3f55432a00e06d(routes, opts) {
    return (0, $9a468b9555c2dd85$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c6d33de9e7cf86ac$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $9a468b9555c2dd85$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c6d33de9e7cf86ac$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $88be82bcdaab0750$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c6d33de9e7cf86ac$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $9a468b9555c2dd85$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c6d33de9e7cf86ac$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $9a468b9555c2dd85$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c6d33de9e7cf86ac$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $88be82bcdaab0750$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c6d33de9e7cf86ac$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $c6d33de9e7cf86ac$var$_extends({}, state, {
        errors: $c6d33de9e7cf86ac$var$deserializeErrors(state.errors)
    });
    return state;
}
function $c6d33de9e7cf86ac$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $9a468b9555c2dd85$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $c6d33de9e7cf86ac$export$7ad602f0e94e62d1 = /*#__PURE__*/ $6uYXW.createContext({
    isTransitioning: false
});
const $c6d33de9e7cf86ac$export$148fd98d095596d4 = /*#__PURE__*/ $6uYXW.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $c6d33de9e7cf86ac$var$START_TRANSITION = "startTransition";
const $c6d33de9e7cf86ac$var$startTransitionImpl = $6uYXW[$c6d33de9e7cf86ac$var$START_TRANSITION];
const $c6d33de9e7cf86ac$var$FLUSH_SYNC = "flushSync";
const $c6d33de9e7cf86ac$var$flushSyncImpl = $4e60b4008b7e4540$exports[$c6d33de9e7cf86ac$var$FLUSH_SYNC];
const $c6d33de9e7cf86ac$var$USE_ID = "useId";
const $c6d33de9e7cf86ac$var$useIdImpl = $6uYXW[$c6d33de9e7cf86ac$var$USE_ID];
function $c6d33de9e7cf86ac$var$startTransitionSafe(cb) {
    if ($c6d33de9e7cf86ac$var$startTransitionImpl) $c6d33de9e7cf86ac$var$startTransitionImpl(cb);
    else cb();
}
function $c6d33de9e7cf86ac$var$flushSyncSafe(cb) {
    if ($c6d33de9e7cf86ac$var$flushSyncImpl) $c6d33de9e7cf86ac$var$flushSyncImpl(cb);
    else cb();
}
class $c6d33de9e7cf86ac$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $c6d33de9e7cf86ac$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $6uYXW.useState(router.state);
    let [pendingState, setPendingState] = $6uYXW.useState();
    let [vtContext, setVtContext] = $6uYXW.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $6uYXW.useState();
    let [transition, setTransition] = $6uYXW.useState();
    let [interruption, setInterruption] = $6uYXW.useState();
    let fetcherData = $6uYXW.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $6uYXW.useCallback((cb)=>{
        if (v7_startTransition) $c6d33de9e7cf86ac$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $6uYXW.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $c6d33de9e7cf86ac$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $c6d33de9e7cf86ac$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $c6d33de9e7cf86ac$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $c6d33de9e7cf86ac$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $c6d33de9e7cf86ac$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $6uYXW.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $6uYXW.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $c6d33de9e7cf86ac$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $6uYXW.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $6uYXW.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $6uYXW.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $6uYXW.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $6uYXW.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $6uYXW.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6uYXW.createElement($6uYXW.Fragment, null, /*#__PURE__*/ $6uYXW.createElement((0, $88be82bcdaab0750$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6uYXW.createElement((0, $88be82bcdaab0750$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $6uYXW.createElement($c6d33de9e7cf86ac$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $6uYXW.createElement($c6d33de9e7cf86ac$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $6uYXW.createElement((0, $88be82bcdaab0750$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $6uYXW.createElement($c6d33de9e7cf86ac$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $c6d33de9e7cf86ac$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $88be82bcdaab0750$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $c6d33de9e7cf86ac$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $6uYXW.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9a468b9555c2dd85$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6uYXW.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6uYXW.useCallback((newState)=>{
        v7_startTransition && $c6d33de9e7cf86ac$var$startTransitionImpl ? $c6d33de9e7cf86ac$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6uYXW.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6uYXW.createElement((0, $88be82bcdaab0750$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $c6d33de9e7cf86ac$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $6uYXW.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9a468b9555c2dd85$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6uYXW.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6uYXW.useCallback((newState)=>{
        v7_startTransition && $c6d33de9e7cf86ac$var$startTransitionImpl ? $c6d33de9e7cf86ac$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6uYXW.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6uYXW.createElement((0, $88be82bcdaab0750$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $c6d33de9e7cf86ac$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $6uYXW.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6uYXW.useCallback((newState)=>{
        v7_startTransition && $c6d33de9e7cf86ac$var$startTransitionImpl ? $c6d33de9e7cf86ac$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6uYXW.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6uYXW.createElement((0, $88be82bcdaab0750$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $c6d33de9e7cf86ac$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $c6d33de9e7cf86ac$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a = /*#__PURE__*/ $6uYXW.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $c6d33de9e7cf86ac$var$_objectWithoutPropertiesLoose(_ref7, $c6d33de9e7cf86ac$var$_excluded);
    let { basename: basename } = $6uYXW.useContext((0, $88be82bcdaab0750$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $c6d33de9e7cf86ac$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($c6d33de9e7cf86ac$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $9a468b9555c2dd85$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $88be82bcdaab0750$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $c6d33de9e7cf86ac$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $6uYXW.createElement("a", $c6d33de9e7cf86ac$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $c6d33de9e7cf86ac$export$b0d92dbee9b5b60d = /*#__PURE__*/ $6uYXW.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $c6d33de9e7cf86ac$var$_objectWithoutPropertiesLoose(_ref8, $c6d33de9e7cf86ac$var$_excluded2);
    let path = (0, $88be82bcdaab0750$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $88be82bcdaab0750$export$45d76561a5302f2b)();
    let routerState = $6uYXW.useContext((0, $88be82bcdaab0750$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $6uYXW.useContext((0, $88be82bcdaab0750$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $c6d33de9e7cf86ac$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $9a468b9555c2dd85$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $6uYXW.createElement($c6d33de9e7cf86ac$export$a6c7ac8248d6e38a, $c6d33de9e7cf86ac$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $c6d33de9e7cf86ac$export$a7fed597f4b8afd8 = /*#__PURE__*/ $6uYXW.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $c6d33de9e7cf86ac$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $c6d33de9e7cf86ac$var$_objectWithoutPropertiesLoose(_ref9, $c6d33de9e7cf86ac$var$_excluded3);
    let submit = $c6d33de9e7cf86ac$export$47c85c6e3a081d3();
    let formAction = $c6d33de9e7cf86ac$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $6uYXW.createElement("form", $c6d33de9e7cf86ac$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $c6d33de9e7cf86ac$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $c6d33de9e7cf86ac$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $c6d33de9e7cf86ac$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($c6d33de9e7cf86ac$var$DataRouterHook || ($c6d33de9e7cf86ac$var$DataRouterHook = {}));
var $c6d33de9e7cf86ac$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($c6d33de9e7cf86ac$var$DataRouterStateHook || ($c6d33de9e7cf86ac$var$DataRouterStateHook = {}));
// Internal hooks
function $c6d33de9e7cf86ac$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $c6d33de9e7cf86ac$var$useDataRouterContext(hookName) {
    let ctx = $6uYXW.useContext((0, $88be82bcdaab0750$export$3add0d5dce533e2e));
    !ctx && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    return ctx;
}
function $c6d33de9e7cf86ac$var$useDataRouterState(hookName) {
    let state = $6uYXW.useContext((0, $88be82bcdaab0750$export$145dfa71566a64dc));
    !state && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $c6d33de9e7cf86ac$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $88be82bcdaab0750$export$9770f232ac06a008)();
    let location = (0, $88be82bcdaab0750$export$45d76561a5302f2b)();
    let path = (0, $88be82bcdaab0750$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $6uYXW.useCallback((event)=>{
        if ($c6d33de9e7cf86ac$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $9a468b9555c2dd85$export$fe53371bee54353d)(location) === (0, $9a468b9555c2dd85$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $c6d33de9e7cf86ac$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $6uYXW.useRef($c6d33de9e7cf86ac$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $6uYXW.useRef(false);
    let location = (0, $88be82bcdaab0750$export$45d76561a5302f2b)();
    let searchParams = $6uYXW.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $c6d33de9e7cf86ac$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $88be82bcdaab0750$export$9770f232ac06a008)();
    let setSearchParams = $6uYXW.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $c6d33de9e7cf86ac$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $c6d33de9e7cf86ac$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $c6d33de9e7cf86ac$var$fetcherId = 0;
let $c6d33de9e7cf86ac$var$getUniqueFetcherId = ()=>"__" + String(++$c6d33de9e7cf86ac$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $c6d33de9e7cf86ac$export$47c85c6e3a081d3() {
    let { router: router } = $c6d33de9e7cf86ac$var$useDataRouterContext($c6d33de9e7cf86ac$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $6uYXW.useContext((0, $88be82bcdaab0750$export$26749e8557646306));
    let currentRouteId = (0, $88be82bcdaab0750$export$5fc8298006ad9e58)();
    return $6uYXW.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $c6d33de9e7cf86ac$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $c6d33de9e7cf86ac$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $c6d33de9e7cf86ac$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $c6d33de9e7cf86ac$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $6uYXW.useContext((0, $88be82bcdaab0750$export$26749e8557646306));
    let routeContext = $6uYXW.useContext((0, $88be82bcdaab0750$export$9072aa6dd1f93057));
    !routeContext && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $c6d33de9e7cf86ac$var$_extends({}, (0, $88be82bcdaab0750$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $88be82bcdaab0750$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $9a468b9555c2dd85$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $9a468b9555c2dd85$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $c6d33de9e7cf86ac$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $c6d33de9e7cf86ac$var$useDataRouterContext($c6d33de9e7cf86ac$var$DataRouterHook.UseFetcher);
    let state = $c6d33de9e7cf86ac$var$useDataRouterState($c6d33de9e7cf86ac$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $6uYXW.useContext($c6d33de9e7cf86ac$export$148fd98d095596d4);
    let route = $6uYXW.useContext((0, $88be82bcdaab0750$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    !route && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $c6d33de9e7cf86ac$var$useIdImpl ? $c6d33de9e7cf86ac$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $6uYXW.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($c6d33de9e7cf86ac$var$getUniqueFetcherId());
    // Registration/cleanup
    $6uYXW.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $6uYXW.useCallback((href, opts)=>{
        !routeId && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $c6d33de9e7cf86ac$export$47c85c6e3a081d3();
    let submit = $6uYXW.useCallback((target, opts)=>{
        submitImpl(target, $c6d33de9e7cf86ac$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $6uYXW.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $6uYXW.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $6uYXW.createElement($c6d33de9e7cf86ac$export$a7fed597f4b8afd8, $c6d33de9e7cf86ac$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $9a468b9555c2dd85$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $6uYXW.useMemo(()=>$c6d33de9e7cf86ac$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $c6d33de9e7cf86ac$export$fa996778a3a31087() {
    let state = $c6d33de9e7cf86ac$var$useDataRouterState($c6d33de9e7cf86ac$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $c6d33de9e7cf86ac$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $c6d33de9e7cf86ac$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $c6d33de9e7cf86ac$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $c6d33de9e7cf86ac$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $c6d33de9e7cf86ac$var$useDataRouterContext($c6d33de9e7cf86ac$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $c6d33de9e7cf86ac$var$useDataRouterState($c6d33de9e7cf86ac$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $6uYXW.useContext((0, $88be82bcdaab0750$export$26749e8557646306));
    let location = (0, $88be82bcdaab0750$export$45d76561a5302f2b)();
    let matches = (0, $88be82bcdaab0750$export$2378eb7f5ff86053)();
    let navigation = (0, $88be82bcdaab0750$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $6uYXW.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $c6d33de9e7cf86ac$var$usePageHide($6uYXW.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $c6d33de9e7cf86ac$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $c6d33de9e7cf86ac$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($c6d33de9e7cf86ac$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6uYXW.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $c6d33de9e7cf86ac$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $c6d33de9e7cf86ac$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6uYXW.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($c6d33de9e7cf86ac$var$_extends({}, location, {
                    pathname: (0, $9a468b9555c2dd85$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($c6d33de9e7cf86ac$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6uYXW.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c6d33de9e7cf86ac$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $6uYXW.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c6d33de9e7cf86ac$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $6uYXW.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $c6d33de9e7cf86ac$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $88be82bcdaab0750$export$b273b3273281a049)(when);
    $6uYXW.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $6uYXW.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $c6d33de9e7cf86ac$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $6uYXW.useContext($c6d33de9e7cf86ac$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $9a468b9555c2dd85$export$3e9cee6b33872309)(false);
    let { basename: basename } = $c6d33de9e7cf86ac$var$useDataRouterContext($c6d33de9e7cf86ac$var$DataRouterHook.useViewTransitionState);
    let path = (0, $88be82bcdaab0750$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $9a468b9555c2dd85$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $9a468b9555c2dd85$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $9a468b9555c2dd85$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $9a468b9555c2dd85$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $82ab136f92e5cec6$export$de79e2c695e052f3(element) {
    if ($82ab136f92e5cec6$var$$7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $82ab136f92e5cec6$var$$7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $82ab136f92e5cec6$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
let $82ab136f92e5cec6$var$$7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $82ab136f92e5cec6$var$$7215afc6de606d6b$var$supportsPreventScroll() {
    if ($82ab136f92e5cec6$var$$7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $82ab136f92e5cec6$var$$7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            let focusElem = document.createElement('div');
            focusElem.focus({
                get preventScroll () {
                    $82ab136f92e5cec6$var$$7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch  {
        // Ignore
        }
    }
    return $82ab136f92e5cec6$var$$7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $82ab136f92e5cec6$var$$7215afc6de606d6b$var$getScrollableElements(element) {
    let parent = element.parentNode;
    let scrollableElements = [];
    let rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $82ab136f92e5cec6$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element, scrollTop: scrollTop, scrollLeft: scrollLeft } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}

const $66912d9a390a7cbc$export$b204af158042fbac = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $66912d9a390a7cbc$export$f21a1ffae260145a = (el)=>{
    if (el && 'window' in el && el.window === el) return el;
    const doc = $66912d9a390a7cbc$export$b204af158042fbac(el);
    return doc.defaultView || window;
};
/**
 * Type guard that checks if a value is a Node. Verifies the presence and type of the nodeType property.
 */ function $66912d9a390a7cbc$var$$431fbd86ca7dc216$var$isNode(value) {
    return value !== null && typeof value === 'object' && 'nodeType' in value && typeof value.nodeType === 'number';
}
function $66912d9a390a7cbc$export$af51f0f06c0f328a(node) {
    return $66912d9a390a7cbc$var$$431fbd86ca7dc216$var$isNode(node) && node.nodeType === Node.DOCUMENT_FRAGMENT_NODE && 'host' in node;
}


/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $0e195daeb5600166$var$$7d2416ea0959daaa$var$supportsCheckVisibility = typeof Element !== 'undefined' && 'checkVisibility' in Element.prototype;
function $0e195daeb5600166$var$$7d2416ea0959daaa$var$isStyleVisible(element) {
    const windowObject = (0, $66912d9a390a7cbc$export$f21a1ffae260145a)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== 'none' && visibility !== 'hidden' && visibility !== 'collapse';
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== 'none' && computedVisibility !== 'hidden' && computedVisibility !== 'collapse';
    }
    return isVisible;
}
function $0e195daeb5600166$var$$7d2416ea0959daaa$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute('hidden') && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute('data-react-aria-prevent-focus') && (element.nodeName === 'DETAILS' && childElement && childElement.nodeName !== 'SUMMARY' ? element.hasAttribute('open') : true);
}
function $0e195daeb5600166$export$e989c0fffaa6b27a(element, childElement) {
    if ($0e195daeb5600166$var$$7d2416ea0959daaa$var$supportsCheckVisibility) return element.checkVisibility({
        visibilityProperty: true
    }) && !element.closest('[data-react-aria-prevent-focus]');
    return element.nodeName !== '#comment' && $0e195daeb5600166$var$$7d2416ea0959daaa$var$isStyleVisible(element) && $0e195daeb5600166$var$$7d2416ea0959daaa$var$isAttributeVisible(element, childElement) && (!element.parentElement || $0e195daeb5600166$export$e989c0fffaa6b27a(element.parentElement, element));
}


/*
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $5131cf1ab5844c65$var$$b4b717babfbb907b$var$focusableElements = [
    'input:not([disabled]):not([type=hidden])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable^="false"])',
    'permission'
];
const $5131cf1ab5844c65$var$$b4b717babfbb907b$var$FOCUSABLE_ELEMENT_SELECTOR = $5131cf1ab5844c65$var$$b4b717babfbb907b$var$focusableElements.join(':not([hidden]),') + ',[tabindex]:not([disabled]):not([hidden])';
$5131cf1ab5844c65$var$$b4b717babfbb907b$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $5131cf1ab5844c65$var$$b4b717babfbb907b$var$TABBABLE_ELEMENT_SELECTOR = $5131cf1ab5844c65$var$$b4b717babfbb907b$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $5131cf1ab5844c65$export$4c063cf1350e6fed(element) {
    return element.matches($5131cf1ab5844c65$var$$b4b717babfbb907b$var$FOCUSABLE_ELEMENT_SELECTOR) && (0, $0e195daeb5600166$export$e989c0fffaa6b27a)(element) && !$5131cf1ab5844c65$var$$b4b717babfbb907b$var$isInert(element);
}
function $5131cf1ab5844c65$export$bebd5a1431fec25d(element) {
    return element.matches($5131cf1ab5844c65$var$$b4b717babfbb907b$var$TABBABLE_ELEMENT_SELECTOR) && (0, $0e195daeb5600166$export$e989c0fffaa6b27a)(element) && !$5131cf1ab5844c65$var$$b4b717babfbb907b$var$isInert(element);
}
function $5131cf1ab5844c65$var$$b4b717babfbb907b$var$isInert(element) {
    let node = element;
    while(node != null){
        if (node instanceof node.ownerDocument.defaultView.HTMLElement && node.inert) return true;
        node = node.parentElement;
    }
    return false;
}


var $6uYXW = parcelRequire("6uYXW");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $f3c2cf6bc1ad45aa$export$e5c5a5f917a5871c = typeof document !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useLayoutEffect : ()=>{};



var $6uYXW = parcelRequire("6uYXW");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $4a41e7eee013a47e$var$$8ae05eaa5c114e9c$var$_React_useInsertionEffect;
// Use the earliest effect type possible. useInsertionEffect runs during the mutation phase,
// before all layout effects, but is available only in React 18 and later.
const $4a41e7eee013a47e$var$$8ae05eaa5c114e9c$var$useEarlyEffect = ($4a41e7eee013a47e$var$$8ae05eaa5c114e9c$var$_React_useInsertionEffect = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW)))['useInsertionEffect']) !== null && $4a41e7eee013a47e$var$$8ae05eaa5c114e9c$var$_React_useInsertionEffect !== void 0 ? $4a41e7eee013a47e$var$$8ae05eaa5c114e9c$var$_React_useInsertionEffect : (0, $f3c2cf6bc1ad45aa$export$e5c5a5f917a5871c);
function $4a41e7eee013a47e$export$7f54fc3180508a52(fn) {
    const ref = (0, $6uYXW.useRef)(null);
    $4a41e7eee013a47e$var$$8ae05eaa5c114e9c$var$useEarlyEffect(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, $6uYXW.useCallback)((...args)=>{
        const f = ref.current;
        return f === null || f === void 0 ? void 0 : f(...args);
    }, []);
}



var $6uYXW = parcelRequire("6uYXW");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $036d9b146821a238$export$525bc4921d56d4a(nativeEvent) {
    let event = nativeEvent;
    event.nativeEvent = nativeEvent;
    event.isDefaultPrevented = ()=>event.defaultPrevented;
    // cancelBubble is technically deprecated in the spec, but still supported in all browsers.
    event.isPropagationStopped = ()=>event.cancelBubble;
    event.persist = ()=>{};
    return event;
}
function $036d9b146821a238$export$c2b7abe5d61ec696(event, target) {
    Object.defineProperty(event, 'target', {
        value: target
    });
    Object.defineProperty(event, 'currentTarget', {
        value: target
    });
}
function $036d9b146821a238$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $6uYXW.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $f3c2cf6bc1ad45aa$export$e5c5a5f917a5871c)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $4a41e7eee013a47e$export$7f54fc3180508a52)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $6uYXW.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) {
                    // For backward compatibility, dispatch a (fake) React synthetic event.
                    let event = $036d9b146821a238$export$525bc4921d56d4a(e);
                    dispatchBlur(event);
                }
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener('focusout', onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent('blur', {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent('focusout', {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    'disabled'
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}
let $036d9b146821a238$export$fda7da73ab5d4c48 = false;
function $036d9b146821a238$export$cabe61c495ee3649(target) {
    // The browser will focus the nearest focusable ancestor of our target.
    while(target && !(0, $5131cf1ab5844c65$export$4c063cf1350e6fed)(target))target = target.parentElement;
    let window = (0, $66912d9a390a7cbc$export$f21a1ffae260145a)(target);
    let activeElement = window.document.activeElement;
    if (!activeElement || activeElement === target) return;
    $036d9b146821a238$export$fda7da73ab5d4c48 = true;
    let isRefocusing = false;
    let onBlur = (e)=>{
        if (e.target === activeElement || isRefocusing) e.stopImmediatePropagation();
    };
    let onFocusOut = (e)=>{
        if (e.target === activeElement || isRefocusing) {
            e.stopImmediatePropagation();
            // If there was no focusable ancestor, we don't expect a focus event.
            // Re-focus the original active element here.
            if (!target && !isRefocusing) {
                isRefocusing = true;
                (0, $82ab136f92e5cec6$export$de79e2c695e052f3)(activeElement);
                cleanup();
            }
        }
    };
    let onFocus = (e)=>{
        if (e.target === target || isRefocusing) e.stopImmediatePropagation();
    };
    let onFocusIn = (e)=>{
        if (e.target === target || isRefocusing) {
            e.stopImmediatePropagation();
            if (!isRefocusing) {
                isRefocusing = true;
                (0, $82ab136f92e5cec6$export$de79e2c695e052f3)(activeElement);
                cleanup();
            }
        }
    };
    window.addEventListener('blur', onBlur, true);
    window.addEventListener('focusout', onFocusOut, true);
    window.addEventListener('focusin', onFocusIn, true);
    window.addEventListener('focus', onFocus, true);
    let cleanup = ()=>{
        cancelAnimationFrame(raf);
        window.removeEventListener('blur', onBlur, true);
        window.removeEventListener('focusout', onFocusOut, true);
        window.removeEventListener('focusin', onFocusIn, true);
        window.removeEventListener('focus', onFocus, true);
        $036d9b146821a238$export$fda7da73ab5d4c48 = false;
        isRefocusing = false;
    };
    let raf = requestAnimationFrame(cleanup);
    return cleanup;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $88752230e686e186$var$$c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === 'undefined' || window.navigator == null) return false;
    let brands = (_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands;
    return Array.isArray(brands) && brands.some((brand)=>re.test(brand.brand)) || re.test(window.navigator.userAgent);
}
function $88752230e686e186$var$$c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator['userAgentData']) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $88752230e686e186$var$$c87311424ea30a05$var$cached(fn) {
    let res = null;
    return ()=>{
        if (res == null) res = fn();
        return res;
    };
}
const $88752230e686e186$export$9ac100e40613ea10 = $88752230e686e186$var$$c87311424ea30a05$var$cached(function() {
    return $88752230e686e186$var$$c87311424ea30a05$var$testPlatform(/^Mac/i);
});
const $88752230e686e186$export$186c6964ca17d99 = $88752230e686e186$var$$c87311424ea30a05$var$cached(function() {
    return $88752230e686e186$var$$c87311424ea30a05$var$testPlatform(/^iPhone/i);
});
const $88752230e686e186$export$7bef049ce92e4224 = $88752230e686e186$var$$c87311424ea30a05$var$cached(function() {
    return $88752230e686e186$var$$c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $88752230e686e186$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
const $88752230e686e186$export$fedb369cb70207f1 = $88752230e686e186$var$$c87311424ea30a05$var$cached(function() {
    return $88752230e686e186$export$186c6964ca17d99() || $88752230e686e186$export$7bef049ce92e4224();
});
const $88752230e686e186$export$e1865c3bedcd822b = $88752230e686e186$var$$c87311424ea30a05$var$cached(function() {
    return $88752230e686e186$export$9ac100e40613ea10() || $88752230e686e186$export$fedb369cb70207f1();
});
const $88752230e686e186$export$78551043582a6a98 = $88752230e686e186$var$$c87311424ea30a05$var$cached(function() {
    return $88752230e686e186$var$$c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$88752230e686e186$export$6446a186d09e379e();
});
const $88752230e686e186$export$6446a186d09e379e = $88752230e686e186$var$$c87311424ea30a05$var$cached(function() {
    return $88752230e686e186$var$$c87311424ea30a05$var$testUserAgent(/Chrome/i);
});
const $88752230e686e186$export$a11b0059900ceec8 = $88752230e686e186$var$$c87311424ea30a05$var$cached(function() {
    return $88752230e686e186$var$$c87311424ea30a05$var$testUserAgent(/Android/i);
});
const $88752230e686e186$export$b7d78993b74f766d = $88752230e686e186$var$$c87311424ea30a05$var$cached(function() {
    return $88752230e686e186$var$$c87311424ea30a05$var$testUserAgent(/Firefox/i);
});


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d62603cc3ad80604$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.pointerType === '' && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $88752230e686e186$export$a11b0059900ceec8)() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $d62603cc3ad80604$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $88752230e686e186$export$a11b0059900ceec8)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse';
}



var $6uYXW = parcelRequire("6uYXW");

var $6uYXW = parcelRequire("6uYXW");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $a6c79190c13afcd3$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $a6c79190c13afcd3$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createContext($a6c79190c13afcd3$var$$b5e257d569688ac6$var$defaultContext);
const $a6c79190c13afcd3$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createContext(false);
// This is only used in React < 18.
function $a6c79190c13afcd3$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $6uYXW.useContext)($a6c79190c13afcd3$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $a6c79190c13afcd3$var$$b5e257d569688ac6$var$useCounter(cur === $a6c79190c13afcd3$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $6uYXW.useState)(true);
    let value = (0, $6uYXW.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $a6c79190c13afcd3$var$$b5e257d569688ac6$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $6uYXW.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($a6c79190c13afcd3$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($a6c79190c13afcd3$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $a6c79190c13afcd3$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $a6c79190c13afcd3$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW)))['useId'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($a6c79190c13afcd3$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $a6c79190c13afcd3$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $a6c79190c13afcd3$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $a6c79190c13afcd3$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $6uYXW.useContext)($a6c79190c13afcd3$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $6uYXW.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $a6c79190c13afcd3$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $a6c79190c13afcd3$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $a6c79190c13afcd3$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $a6c79190c13afcd3$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $6uYXW.useContext)($a6c79190c13afcd3$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $a6c79190c13afcd3$var$$b5e257d569688ac6$var$defaultContext && $a6c79190c13afcd3$var$$b5e257d569688ac6$var$canUseDOM;
    let counter = $a6c79190c13afcd3$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $a6c79190c13afcd3$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useId();
    let [didSSR] = (0, $6uYXW.useState)($a6c79190c13afcd3$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$a6c79190c13afcd3$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $a6c79190c13afcd3$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW)))['useId'] === 'function' ? $a6c79190c13afcd3$var$$b5e257d569688ac6$var$useModernSSRSafeId : $a6c79190c13afcd3$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $a6c79190c13afcd3$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $a6c79190c13afcd3$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $a6c79190c13afcd3$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $a6c79190c13afcd3$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW)))['useSyncExternalStore']($a6c79190c13afcd3$var$$b5e257d569688ac6$var$subscribe, $a6c79190c13afcd3$var$$b5e257d569688ac6$var$getSnapshot, $a6c79190c13afcd3$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $6uYXW.useContext)($a6c79190c13afcd3$var$$b5e257d569688ac6$var$IsSSRContext);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $29291cbb1626300e$var$$507fabe10e71c6fb$var$currentModality = null;
let $29291cbb1626300e$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $29291cbb1626300e$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $29291cbb1626300e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $29291cbb1626300e$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $29291cbb1626300e$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $29291cbb1626300e$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $29291cbb1626300e$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $29291cbb1626300e$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $88752230e686e186$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === 'Control' || e.key === 'Shift' || e.key === 'Meta');
}
function $29291cbb1626300e$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $29291cbb1626300e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($29291cbb1626300e$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $29291cbb1626300e$var$$507fabe10e71c6fb$var$currentModality = 'keyboard';
        $29291cbb1626300e$var$$507fabe10e71c6fb$var$triggerChangeHandlers('keyboard', e);
    }
}
function $29291cbb1626300e$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $29291cbb1626300e$var$$507fabe10e71c6fb$var$currentModality = 'pointer';
    if (e.type === 'mousedown' || e.type === 'pointerdown') {
        $29291cbb1626300e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $29291cbb1626300e$var$$507fabe10e71c6fb$var$triggerChangeHandlers('pointer', e);
    }
}
function $29291cbb1626300e$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $d62603cc3ad80604$export$60278871457622de)(e)) {
        $29291cbb1626300e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $29291cbb1626300e$var$$507fabe10e71c6fb$var$currentModality = 'virtual';
    }
}
function $29291cbb1626300e$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document || (0, $036d9b146821a238$export$fda7da73ab5d4c48) || !e.isTrusted) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$29291cbb1626300e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$29291cbb1626300e$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $29291cbb1626300e$var$$507fabe10e71c6fb$var$currentModality = 'virtual';
        $29291cbb1626300e$var$$507fabe10e71c6fb$var$triggerChangeHandlers('virtual', e);
    }
    $29291cbb1626300e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $29291cbb1626300e$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $29291cbb1626300e$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    if (0, $036d9b146821a238$export$fda7da73ab5d4c48) return;
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $29291cbb1626300e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $29291cbb1626300e$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $29291cbb1626300e$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === 'undefined' || typeof document === 'undefined' || $29291cbb1626300e$export$d90243b58daecda7.get((0, $66912d9a390a7cbc$export$f21a1ffae260145a)(element))) return;
    const windowObject = (0, $66912d9a390a7cbc$export$f21a1ffae260145a)(element);
    const documentObject = (0, $66912d9a390a7cbc$export$b204af158042fbac)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $29291cbb1626300e$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener('keydown', $29291cbb1626300e$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener('keyup', $29291cbb1626300e$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener('click', $29291cbb1626300e$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener('focus', $29291cbb1626300e$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener('blur', $29291cbb1626300e$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.addEventListener('pointerdown', $29291cbb1626300e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('pointermove', $29291cbb1626300e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener('pointerup', $29291cbb1626300e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener('beforeunload', ()=>{
        $29291cbb1626300e$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $29291cbb1626300e$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $29291cbb1626300e$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $66912d9a390a7cbc$export$f21a1ffae260145a)(element);
    const documentObject = (0, $66912d9a390a7cbc$export$b204af158042fbac)(element);
    if (loadListener) documentObject.removeEventListener('DOMContentLoaded', loadListener);
    if (!$29291cbb1626300e$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $29291cbb1626300e$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener('keydown', $29291cbb1626300e$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('keyup', $29291cbb1626300e$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener('click', $29291cbb1626300e$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener('focus', $29291cbb1626300e$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener('blur', $29291cbb1626300e$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        documentObject.removeEventListener('pointerdown', $29291cbb1626300e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointermove', $29291cbb1626300e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener('pointerup', $29291cbb1626300e$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $29291cbb1626300e$export$d90243b58daecda7.delete(windowObject);
};
function $29291cbb1626300e$export$2f1888112f558a7d(element) {
    const documentObject = (0, $66912d9a390a7cbc$export$b204af158042fbac)(element);
    let loadListener;
    if (documentObject.readyState !== 'loading') $29291cbb1626300e$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $29291cbb1626300e$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener('DOMContentLoaded', loadListener);
    }
    return ()=>$29291cbb1626300e$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== 'undefined') $29291cbb1626300e$export$2f1888112f558a7d();
function $29291cbb1626300e$export$b9b3dfddab17db27() {
    return $29291cbb1626300e$var$$507fabe10e71c6fb$var$currentModality !== 'pointer';
}
function $29291cbb1626300e$export$630ff653c5ada6a9() {
    return $29291cbb1626300e$var$$507fabe10e71c6fb$var$currentModality;
}
function $29291cbb1626300e$export$8397ddfc504fdb9a(modality) {
    $29291cbb1626300e$var$$507fabe10e71c6fb$var$currentModality = modality;
    $29291cbb1626300e$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $29291cbb1626300e$export$98e20ec92f614cfe() {
    $29291cbb1626300e$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $6uYXW.useState)($29291cbb1626300e$var$$507fabe10e71c6fb$var$currentModality);
    (0, $6uYXW.useEffect)(()=>{
        let handler = ()=>{
            setModality($29291cbb1626300e$var$$507fabe10e71c6fb$var$currentModality);
        };
        $29291cbb1626300e$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $29291cbb1626300e$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $a6c79190c13afcd3$export$535bd6ca7f90a273)() ? null : modality;
}
const $29291cbb1626300e$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    'checkbox',
    'radio',
    'range',
    'color',
    'file',
    'image',
    'button',
    'submit',
    'reset'
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $29291cbb1626300e$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    let document1 = (0, $66912d9a390a7cbc$export$b204af158042fbac)(e === null || e === void 0 ? void 0 : e.target);
    const IHTMLInputElement = typeof window !== 'undefined' ? (0, $66912d9a390a7cbc$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== 'undefined' ? (0, $66912d9a390a7cbc$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== 'undefined' ? (0, $66912d9a390a7cbc$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== 'undefined' ? (0, $66912d9a390a7cbc$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    // For keyboard events that occur on a non-input element that will move focus into input element (aka ArrowLeft going from Datepicker button to the main input group)
    // we need to rely on the user passing isTextInput into here. This way we can skip toggling focus visiblity for said input element
    isTextInput = isTextInput || document1.activeElement instanceof IHTMLInputElement && !$29291cbb1626300e$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(document1.activeElement.type) || document1.activeElement instanceof IHTMLTextAreaElement || document1.activeElement instanceof IHTMLElement && document1.activeElement.isContentEditable;
    return !(isTextInput && modality === 'keyboard' && e instanceof IKeyboardEvent && !$29291cbb1626300e$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $29291cbb1626300e$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $6uYXW.useState)(autoFocus || $29291cbb1626300e$export$b9b3dfddab17db27());
    $29291cbb1626300e$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $29291cbb1626300e$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $29291cbb1626300e$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $6uYXW.useEffect)(()=>{
        let handler = (modality, e)=>{
            // We want to early return for any keyboard events that occur inside text inputs EXCEPT for Tab and Escape
            if (!$29291cbb1626300e$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($29291cbb1626300e$export$b9b3dfddab17db27());
        };
        $29291cbb1626300e$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $29291cbb1626300e$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}



var $6uYXW = parcelRequire("6uYXW");

/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $feb770e66c2c066b$var$$f4e2df6bd15f8569$var$_tableNestedRows = false;
let $feb770e66c2c066b$var$$f4e2df6bd15f8569$var$_shadowDOM = false;
function $feb770e66c2c066b$export$d9d8a0f82de49530() {
    $feb770e66c2c066b$var$$f4e2df6bd15f8569$var$_tableNestedRows = true;
}
function $feb770e66c2c066b$export$1b00cb14a96194e6() {
    return $feb770e66c2c066b$var$$f4e2df6bd15f8569$var$_tableNestedRows;
}
function $feb770e66c2c066b$export$12b151d9882e9985() {
    $feb770e66c2c066b$var$$f4e2df6bd15f8569$var$_shadowDOM = true;
}
function $feb770e66c2c066b$export$98658e8c59125e6a() {
    return $feb770e66c2c066b$var$$f4e2df6bd15f8569$var$_shadowDOM;
}


// Source: https://github.com/microsoft/tabster/blob/a89fc5d7e332d48f68d03b1ca6e344489d1c3898/src/Shadowdomize/DOMFunctions.ts#L16
function $b7a889d440882b15$export$4282f70798064fe0(node, otherNode) {
    if (!(0, $feb770e66c2c066b$export$98658e8c59125e6a)()) return otherNode && node ? node.contains(otherNode) : false;
    if (!node || !otherNode) return false;
    let currentNode = otherNode;
    while(currentNode !== null){
        if (currentNode === node) return true;
        if (currentNode.tagName === 'SLOT' && currentNode.assignedSlot) currentNode = currentNode.assignedSlot.parentNode;
        else if ((0, $66912d9a390a7cbc$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
        else currentNode = currentNode.parentNode;
    }
    return false;
}
const $b7a889d440882b15$export$cd4e5573fbe2b576 = (doc = document)=>{
    var _activeElement_shadowRoot;
    if (!(0, $feb770e66c2c066b$export$98658e8c59125e6a)()) return doc.activeElement;
    let activeElement = doc.activeElement;
    while(activeElement && 'shadowRoot' in activeElement && ((_activeElement_shadowRoot = activeElement.shadowRoot) === null || _activeElement_shadowRoot === void 0 ? void 0 : _activeElement_shadowRoot.activeElement))activeElement = activeElement.shadowRoot.activeElement;
    return activeElement;
};
function $b7a889d440882b15$export$e58f029f0fbfdb29(event) {
    if ((0, $feb770e66c2c066b$export$98658e8c59125e6a)() && event.target.shadowRoot) {
        if (event.composedPath) return event.composedPath()[0];
    }
    return event.target;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $148a9143f0f334e3$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $6uYXW.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $036d9b146821a238$export$715c682d09d639cc)(onBlur);
    const onFocus = (0, $6uYXW.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $66912d9a390a7cbc$export$b204af158042fbac)(e.target);
        const activeElement = ownerDocument ? (0, $b7a889d440882b15$export$cd4e5573fbe2b576)(ownerDocument) : (0, $b7a889d440882b15$export$cd4e5573fbe2b576)();
        if (e.target === e.currentTarget && activeElement === (0, $b7a889d440882b15$export$e58f029f0fbfdb29)(e.nativeEvent)) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}



var $6uYXW = parcelRequire("6uYXW");

var $6uYXW = parcelRequire("6uYXW");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $88b2371bced1bdb3$export$4eaf04e54aa8eed6() {
    let globalListeners = (0, $6uYXW.useRef)(new Map());
    let addGlobalListener = (0, $6uYXW.useCallback)((eventTarget, type, listener, options)=>{
        // Make sure we remove the listener after it is called with the `once` option.
        let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args)=>{
            globalListeners.current.delete(listener);
            listener(...args);
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, fn, options);
    }, []);
    let removeGlobalListener = (0, $6uYXW.useCallback)((eventTarget, type, listener, options)=>{
        var _globalListeners_current_get;
        let fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    let removeAllGlobalListeners = (0, $6uYXW.useCallback)(()=>{
        globalListeners.current.forEach((value, key)=>{
            removeGlobalListener(value.eventTarget, value.type, key, value.options);
        });
    }, [
        removeGlobalListener
    ]);
    (0, $6uYXW.useEffect)(()=>{
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $3eaa9455aacc5754$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $6uYXW.useRef)({
        isFocusWithin: false
    });
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $88b2371bced1bdb3$export$4eaf04e54aa8eed6)();
    let onBlur = (0, $6uYXW.useCallback)((e)=>{
        // Ignore events bubbling through portals.
        if (!e.currentTarget.contains(e.target)) return;
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            removeAllGlobalListeners();
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state,
        removeAllGlobalListeners
    ]);
    let onSyntheticFocus = (0, $036d9b146821a238$export$715c682d09d639cc)(onBlur);
    let onFocus = (0, $6uYXW.useCallback)((e)=>{
        // Ignore events bubbling through portals.
        if (!e.currentTarget.contains(e.target)) return;
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $66912d9a390a7cbc$export$b204af158042fbac)(e.target);
        const activeElement = (0, $b7a889d440882b15$export$cd4e5573fbe2b576)(ownerDocument);
        if (!state.current.isFocusWithin && activeElement === (0, $b7a889d440882b15$export$e58f029f0fbfdb29)(e.nativeEvent)) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
            // Browsers don't fire blur events when elements are removed from the DOM.
            // However, if a focus event occurs outside the element we're tracking, we
            // can manually fire onBlur.
            let currentTarget = e.currentTarget;
            addGlobalListener(ownerDocument, 'focus', (e)=>{
                if (state.current.isFocusWithin && !(0, $b7a889d440882b15$export$4282f70798064fe0)(currentTarget, e.target)) {
                    let nativeEvent = new ownerDocument.defaultView.FocusEvent('blur', {
                        relatedTarget: e.target
                    });
                    (0, $036d9b146821a238$export$c2b7abe5d61ec696)(nativeEvent, currentTarget);
                    let event = (0, $036d9b146821a238$export$525bc4921d56d4a)(nativeEvent);
                    onBlur(event);
                }
            }, {
                capture: true
            });
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus,
        addGlobalListener,
        onBlur
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These cannot be null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}



var $6uYXW = parcelRequire("6uYXW");
function $63b99e5b44fc4848$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false, isTextInput: isTextInput, within: within } = props;
    let state = (0, $6uYXW.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, $29291cbb1626300e$export$b9b3dfddab17db27)()
    });
    let [isFocused, setFocused] = (0, $6uYXW.useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (0, $6uYXW.useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (0, $6uYXW.useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (0, $6uYXW.useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, $29291cbb1626300e$export$ec71b4b83ac08ec3)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    let { focusProps: focusProps } = (0, $148a9143f0f334e3$export$f8168d8dd8fd66e6)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps } = (0, $3eaa9455aacc5754$export$420e68273165f4ec)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}




var $6uYXW = parcelRequire("6uYXW");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $2c47d83feaa2f132$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $2c47d83feaa2f132$var$$6179b936705e76d3$var$hoverCount = 0;
function $2c47d83feaa2f132$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $2c47d83feaa2f132$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $2c47d83feaa2f132$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $2c47d83feaa2f132$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === 'touch') $2c47d83feaa2f132$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $2c47d83feaa2f132$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === 'undefined') return;
    if ($2c47d83feaa2f132$var$$6179b936705e76d3$var$hoverCount === 0) {
        if (typeof PointerEvent !== 'undefined') document.addEventListener('pointerup', $2c47d83feaa2f132$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    }
    $2c47d83feaa2f132$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $2c47d83feaa2f132$var$$6179b936705e76d3$var$hoverCount--;
        if ($2c47d83feaa2f132$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== 'undefined') document.removeEventListener('pointerup', $2c47d83feaa2f132$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    };
}
function $2c47d83feaa2f132$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $6uYXW.useState)(false);
    let state = (0, $6uYXW.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: '',
        target: null
    }).current;
    (0, $6uYXW.useEffect)($2c47d83feaa2f132$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { addGlobalListener: addGlobalListener, removeAllGlobalListeners: removeAllGlobalListeners } = (0, $88b2371bced1bdb3$export$4eaf04e54aa8eed6)();
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $6uYXW.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === 'touch' || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            // When an element that is hovered over is removed, no pointerleave event is fired by the browser,
            // even though the originally hovered target may have shrunk in size so it is no longer hovered.
            // However, a pointerover event will be fired on the new target the mouse is over.
            // In Chrome this happens immediately. In Safari and Firefox, it happens upon moving the mouse one pixel.
            addGlobalListener((0, $66912d9a390a7cbc$export$b204af158042fbac)(event.target), 'pointerover', (e)=>{
                if (state.isHovered && state.target && !(0, $b7a889d440882b15$export$4282f70798064fe0)(state.target, e.target)) triggerHoverEnd(e, e.pointerType);
            }, {
                capture: true
            });
            if (onHoverStart) onHoverStart({
                type: 'hoverstart',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            let target = state.target;
            state.pointerType = '';
            state.target = null;
            if (pointerType === 'touch' || !state.isHovered || !target) return;
            state.isHovered = false;
            removeAllGlobalListeners();
            if (onHoverEnd) onHoverEnd({
                type: 'hoverend',
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== 'undefined') {
            hoverProps.onPointerEnter = (e)=>{
                if ($2c47d83feaa2f132$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === 'mouse') return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else var e, e1;
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state,
        addGlobalListener,
        removeAllGlobalListeners
    ]);
    (0, $6uYXW.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}



var $6uYXW = parcelRequire("6uYXW");

var $6uYXW = parcelRequire("6uYXW");
var $76d81e2a3e06b5b5$var$i = Object.defineProperty;
var $76d81e2a3e06b5b5$var$d = (t, e, n)=>e in t ? $76d81e2a3e06b5b5$var$i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n;
var $76d81e2a3e06b5b5$var$r = (t, e, n)=>($76d81e2a3e06b5b5$var$d(t, typeof e != "symbol" ? e + "" : e, n), n);
class $76d81e2a3e06b5b5$var$o {
    constructor(){
        $76d81e2a3e06b5b5$var$r(this, "current", this.detect());
        $76d81e2a3e06b5b5$var$r(this, "handoffState", "pending");
        $76d81e2a3e06b5b5$var$r(this, "currentId", 0);
    }
    set(e) {
        this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
    handoff() {
        this.handoffState === "pending" && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
        return this.handoffState === "complete";
    }
}
let $76d81e2a3e06b5b5$export$a7b6bc01c63cdfc3 = new $76d81e2a3e06b5b5$var$o;


function $d76c946db081c9ef$export$b204af158042fbac(n) {
    var u;
    return (0, $76d81e2a3e06b5b5$export$a7b6bc01c63cdfc3).isServer ? null : n == null ? document : (u = n == null ? void 0 : n.ownerDocument) != null ? u : document;
}
function $d76c946db081c9ef$export$9bfe85d84666e58(n) {
    var u, o;
    return (0, $76d81e2a3e06b5b5$export$a7b6bc01c63cdfc3).isServer ? null : n == null ? document : (o = (u = n == null ? void 0 : n.getRootNode) == null ? void 0 : u.call(n)) != null ? o : document;
}
function $d76c946db081c9ef$export$cd4e5573fbe2b576(n) {
    var u, o;
    return (o = (u = $d76c946db081c9ef$export$9bfe85d84666e58(n)) == null ? void 0 : u.activeElement) != null ? o : null;
}
function $d76c946db081c9ef$export$8a2eb51c14bb8899(n) {
    return $d76c946db081c9ef$export$cd4e5573fbe2b576(n) === n;
}



var $6uYXW = parcelRequire("6uYXW");
function $6254f9f306b433f5$export$a5ff0d6a738703ca(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}


function $5b6227043c6a88bc$export$12b26c28a05aa001() {
    let s = [], r = {
        addEventListener (e, t, n, i) {
            return e.addEventListener(t, n, i), r.add(()=>e.removeEventListener(t, n, i));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return r.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return r.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, $6254f9f306b433f5$export$a5ff0d6a738703ca)(()=>{
                t.current && e[0]();
            }), r.add(()=>{
                t.current = !1;
            });
        },
        style (e, t, n) {
            let i = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: n
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: i
                });
            });
        },
        group (e) {
            let t = $5b6227043c6a88bc$export$12b26c28a05aa001();
            return e(t), this.add(()=>t.dispose());
        },
        add (e) {
            return s.includes(e) || s.push(e), ()=>{
                let t = s.indexOf(e);
                if (t >= 0) for (let n of s.splice(t, 1))n();
            };
        },
        dispose () {
            for (let e of s.splice(0))e();
        }
    };
    return r;
}


function $550b4821e7e353bd$export$fd183955ff4b45d9() {
    let [e] = (0, $6uYXW.useState)((0, $5b6227043c6a88bc$export$12b26c28a05aa001));
    return (0, $6uYXW.useEffect)(()=>()=>e.dispose(), [
        e
    ]), e;
}



var $6uYXW = parcelRequire("6uYXW");

var $6uYXW = parcelRequire("6uYXW");

var $6uYXW = parcelRequire("6uYXW");

let $f90baf459dcf3957$export$ce5ed857c741fd71 = (e, t)=>{
    (0, $76d81e2a3e06b5b5$export$a7b6bc01c63cdfc3).isServer ? (0, $6uYXW.useEffect)(e, t) : (0, $6uYXW.useLayoutEffect)(e, t);
};


function $45cf98b6ba6e8cbc$export$86c4283a11f23f95(e) {
    let r = (0, $6uYXW.useRef)(e);
    return (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        r.current = e;
    }, [
        e
    ]), r;
}


let $555339916ec7fe05$export$90fc3a17d93f704c = function(t) {
    let e = (0, $45cf98b6ba6e8cbc$export$86c4283a11f23f95)(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).useCallback((...r)=>e.current(...r), [
        e
    ]);
};


function $2a0752a989a3abf0$var$E(e) {
    let t = e.width / 2, n = e.height / 2;
    return {
        top: e.clientY - n,
        right: e.clientX + t,
        bottom: e.clientY + n,
        left: e.clientX - t
    };
}
function $2a0752a989a3abf0$var$P(e, t) {
    return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function $2a0752a989a3abf0$export$73224eeef4bbe873({ disabled: e = !1 } = {}) {
    let t = (0, $6uYXW.useRef)(null), [n, l] = (0, $6uYXW.useState)(!1), r = (0, $550b4821e7e353bd$export$fd183955ff4b45d9)(), o = (0, $555339916ec7fe05$export$90fc3a17d93f704c)(()=>{
        t.current = null, l(!1), r.dispose();
    }), f = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((s)=>{
        if (r.dispose(), t.current === null) {
            t.current = s.currentTarget, l(!0);
            {
                let i = (0, $d76c946db081c9ef$export$b204af158042fbac)(s.currentTarget);
                r.addEventListener(i, "pointerup", o, !1), r.addEventListener(i, "pointermove", (c)=>{
                    if (t.current) {
                        let p = $2a0752a989a3abf0$var$E(c);
                        l($2a0752a989a3abf0$var$P(p, t.current.getBoundingClientRect()));
                    }
                }, !1), r.addEventListener(i, "pointercancel", o, !1);
            }
        }
    });
    return {
        pressed: n,
        pressProps: e ? {} : {
            onPointerDown: f,
            onPointerUp: o,
            onClick: o
        }
    };
}




var $6uYXW = parcelRequire("6uYXW");

var $6uYXW = parcelRequire("6uYXW");
function $8df6c730accaca48$export$53652b2b272efe9c(t, u) {
    return (0, $6uYXW.useMemo)(()=>{
        var n;
        if (t.type) return t.type;
        let r = (n = t.as) != null ? n : "button";
        if (typeof r == "string" && r.toLowerCase() === "button" || (u == null ? void 0 : u.tagName) === "BUTTON" && !u.hasAttribute("type")) return "button";
    }, [
        t.type,
        t.as,
        u
    ]);
}



var $6uYXW = parcelRequire("6uYXW");
function $fbe56f88477e21c7$export$9d4c57ee4c6ffdd8(e) {
    return (0, $6uYXW.useMemo)(()=>e, Object.values(e));
}



var $6uYXW = parcelRequire("6uYXW");

let $c8ac0a774b50c957$var$u = Symbol();
function $c8ac0a774b50c957$export$7029785b750eb74(t, n = !0) {
    return Object.assign(t, {
        [$c8ac0a774b50c957$var$u]: n
    });
}
function $c8ac0a774b50c957$export$f6a25a78204acc7e(...t) {
    let n = (0, $6uYXW.useRef)(t);
    (0, $6uYXW.useEffect)(()=>{
        n.current = t;
    }, [
        t
    ]);
    let c = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((e)=>{
        for (let o of n.current)o != null && (typeof o == "function" ? o(e) : o.current = e);
    });
    return t.every((e)=>e == null || (e == null ? void 0 : e[$c8ac0a774b50c957$var$u])) ? void 0 : c;
}



var $6uYXW = parcelRequire("6uYXW");



var $6uYXW = parcelRequire("6uYXW");
function $7cc2b64b274aa20e$export$2879604e6aec4ab(u = 0) {
    let [r, a] = (0, $6uYXW.useState)(u), g = (0, $6uYXW.useCallback)((e)=>a(e), []), s = (0, $6uYXW.useCallback)((e)=>a((l)=>l | e), []), m = (0, $6uYXW.useCallback)((e)=>(r & e) === e, [
        r
    ]), n = (0, $6uYXW.useCallback)((e)=>a((l)=>l & ~e), []), F = (0, $6uYXW.useCallback)((e)=>a((l)=>l ^ e), []);
    return {
        flags: r,
        setFlag: g,
        addFlag: s,
        hasFlag: m,
        removeFlag: n,
        toggleFlag: F
    };
}



var $ccac44f91c8229c7$var$T, $ccac44f91c8229c7$var$S;
var $ccac44f91c8229c7$var$A = ((i)=>(i[i.None = 0] = "None", i[i.Closed = 1] = "Closed", i[i.Enter = 2] = "Enter", i[i.Leave = 4] = "Leave", i))($ccac44f91c8229c7$var$A || {});
function $ccac44f91c8229c7$export$c291d481c40a2fc3(e) {
    let r = {};
    for(let t in e)e[t] === !0 && (r[`data-${t}`] = "");
    return r;
}
function $ccac44f91c8229c7$export$7b286972b8d8ccbf(e, r, t, n) {
    let [i, a] = (0, $6uYXW.useState)(t), { hasFlag: s, addFlag: o, removeFlag: l } = (0, $7cc2b64b274aa20e$export$2879604e6aec4ab)(e && i ? 3 : 0), u = (0, $6uYXW.useRef)(!1), f = (0, $6uYXW.useRef)(!1), E = (0, $550b4821e7e353bd$export$fd183955ff4b45d9)();
    return (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        var d;
        if (e) {
            if (t && a(!0), !r) {
                t && o(3);
                return;
            }
            return (d = n == null ? void 0 : n.start) == null || d.call(n, t), $ccac44f91c8229c7$var$C(r, {
                inFlight: u,
                prepare () {
                    f.current ? f.current = !1 : f.current = u.current, u.current = !0, !f.current && (t ? (o(3), l(4)) : (o(4), l(2)));
                },
                run () {
                    f.current ? t ? (l(3), o(4)) : (l(4), o(3)) : t ? l(1) : o(1);
                },
                done () {
                    var p;
                    f.current && $ccac44f91c8229c7$var$D(r) || (u.current = !1, l(7), t || a(!1), (p = n == null ? void 0 : n.end) == null || p.call(n, t));
                }
            });
        }
    }, [
        e,
        t,
        r,
        E
    ]), e ? [
        i,
        {
            closed: s(1),
            enter: s(2),
            leave: s(4),
            transition: s(2) || s(4)
        }
    ] : [
        t,
        {
            closed: void 0,
            enter: void 0,
            leave: void 0,
            transition: void 0
        }
    ];
}
function $ccac44f91c8229c7$var$C(e, { prepare: r, run: t, done: n, inFlight: i }) {
    let a = (0, $5b6227043c6a88bc$export$12b26c28a05aa001)();
    return $ccac44f91c8229c7$var$j(e, {
        prepare: r,
        inFlight: i
    }), a.nextFrame(()=>{
        t(), a.requestAnimationFrame(()=>{
            a.add($ccac44f91c8229c7$var$M(e, n));
        });
    }), a.dispose;
}
function $ccac44f91c8229c7$var$M(e, r) {
    var a, s;
    let t = (0, $5b6227043c6a88bc$export$12b26c28a05aa001)();
    if (!e) return t.dispose;
    let n = !1;
    t.add(()=>{
        n = !0;
    });
    let i = (s = (a = e.getAnimations) == null ? void 0 : a.call(e).filter((o)=>o instanceof CSSTransition)) != null ? s : [];
    return i.length === 0 ? (r(), t.dispose) : (Promise.allSettled(i.map((o)=>o.finished)).then(()=>{
        n || r();
    }), t.dispose);
}
function $ccac44f91c8229c7$var$j(e, { inFlight: r, prepare: t }) {
    if (r != null && r.current) {
        t();
        return;
    }
    let n = e.style.transition;
    e.style.transition = "none", t(), e.offsetHeight, e.style.transition = n;
}
function $ccac44f91c8229c7$var$D(e) {
    var t, n;
    return ((n = (t = e.getAnimations) == null ? void 0 : t.call(e)) != null ? n : []).some((i)=>i instanceof CSSTransition && i.playState !== "finished");
}



var $6uYXW = parcelRequire("6uYXW");
"use client";
let $34590dda7a415b35$var$e = (0, $6uYXW.createContext)(()=>{});
function $34590dda7a415b35$export$4e99330e6f37bca2() {
    return (0, $6uYXW.useContext)($34590dda7a415b35$var$e);
}
function $34590dda7a415b35$export$dd2a80b78bebbe1d({ value: t, children: o }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($34590dda7a415b35$var$e.Provider, {
        value: t
    }, o);
}



var $6uYXW = parcelRequire("6uYXW");
let $efd9a985d91b0391$var$n = (0, $6uYXW.createContext)(null);
$efd9a985d91b0391$var$n.displayName = "OpenClosedContext";
var $efd9a985d91b0391$export$7254cc27399e90bd = ((e)=>(e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))($efd9a985d91b0391$export$7254cc27399e90bd || {});
function $efd9a985d91b0391$export$fc6fdf0ecf360e() {
    return (0, $6uYXW.useContext)($efd9a985d91b0391$var$n);
}
function $efd9a985d91b0391$export$2a0ed818b175f558({ value: o, children: t }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($efd9a985d91b0391$var$n.Provider, {
        value: o
    }, t);
}
function $efd9a985d91b0391$export$6748feed729c7cf3({ children: o }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($efd9a985d91b0391$var$n.Provider, {
        value: null
    }, o);
}


function $36c2319598bace40$export$8ee0fc9ee280b4ee(e) {
    return typeof e != "object" || e === null ? !1 : "nodeType" in e;
}
function $36c2319598bace40$export$45a5e7f76e0caa8d(e) {
    return $36c2319598bace40$export$8ee0fc9ee280b4ee(e) && "tagName" in e;
}
function $36c2319598bace40$export$1b3bfaa9684536aa(e) {
    return $36c2319598bace40$export$45a5e7f76e0caa8d(e) && "accessKey" in e;
}
function $36c2319598bace40$export$79c619c6018bbb44(e) {
    return $36c2319598bace40$export$45a5e7f76e0caa8d(e) && "tabIndex" in e;
}
function $36c2319598bace40$export$62c830b63044c679(e) {
    return $36c2319598bace40$export$45a5e7f76e0caa8d(e) && "style" in e;
}
function $36c2319598bace40$export$8b613183536fc004(e) {
    return $36c2319598bace40$export$1b3bfaa9684536aa(e) && e.nodeName === "IFRAME";
}
function $36c2319598bace40$export$88a6ceeed5737ba3(e) {
    return $36c2319598bace40$export$1b3bfaa9684536aa(e) && e.nodeName === "INPUT";
}
function $36c2319598bace40$export$b7395b0e7f36a30b(e) {
    return $36c2319598bace40$export$1b3bfaa9684536aa(e) && e.nodeName === "TEXTAREA";
}
function $36c2319598bace40$export$42dc0115f0e5e4fc(e) {
    return $36c2319598bace40$export$1b3bfaa9684536aa(e) && e.nodeName === "LABEL";
}
function $36c2319598bace40$export$224ee1e631187c8e(e) {
    return $36c2319598bace40$export$1b3bfaa9684536aa(e) && e.nodeName === "FIELDSET";
}
function $36c2319598bace40$export$b5145d164c8e27ab(e) {
    return $36c2319598bace40$export$1b3bfaa9684536aa(e) && e.nodeName === "LEGEND";
}
function $36c2319598bace40$export$3dee5e4542c672d9(e) {
    return $36c2319598bace40$export$45a5e7f76e0caa8d(e) ? e.matches('a[href],audio[controls],button,details,embed,iframe,img[usemap],input:not([type="hidden"]),label,select,textarea,video[controls]') : !1;
}


function $d37bc8a0371b3098$export$db61f031a278447c(l) {
    let e = l.parentElement, t = null;
    for(; e && !$36c2319598bace40$export$224ee1e631187c8e(e);)$36c2319598bace40$export$b5145d164c8e27ab(e) && (t = e), e = e.parentElement;
    let i = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return i && $d37bc8a0371b3098$var$r(t) ? !1 : i;
}
function $d37bc8a0371b3098$var$r(l) {
    if (!l) return !1;
    let e = l.previousElementSibling;
    for(; e !== null;){
        if ($36c2319598bace40$export$b5145d164c8e27ab(e)) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}



function $151185d7717c1097$export$4659b591c19bdf3d(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, $151185d7717c1097$export$4659b591c19bdf3d), t;
}




var $6uYXW = parcelRequire("6uYXW");
function $393ff8b6ca113c61$export$ce4ab0c55987d1ff(...r) {
    return Array.from(new Set(r.flatMap((n)=>typeof n == "string" ? n.split(" ") : []))).filter(Boolean).join(" ");
}



var $513e46b2b02099d5$export$ba0ea3f20e7bf777 = ((a)=>(a[a.None = 0] = "None", a[a.RenderStrategy = 1] = "RenderStrategy", a[a.Static = 2] = "Static", a))($513e46b2b02099d5$export$ba0ea3f20e7bf777 || {}), $513e46b2b02099d5$export$80c0a745e59f7989 = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))($513e46b2b02099d5$export$80c0a745e59f7989 || {});
function $513e46b2b02099d5$export$e25bb1e5b53cbdff() {
    let n = $513e46b2b02099d5$var$$();
    return (0, $6uYXW.useCallback)((r)=>$513e46b2b02099d5$var$U({
            mergeRefs: n,
            ...r
        }), [
        n
    ]);
}
function $513e46b2b02099d5$var$U({ ourProps: n, theirProps: r, slot: e, defaultTag: a, features: s, visible: t = !0, name: l, mergeRefs: i }) {
    i = i != null ? i : $513e46b2b02099d5$var$I;
    let o = $513e46b2b02099d5$var$P(r, n);
    if (t) return $513e46b2b02099d5$var$F(o, e, a, l, i);
    let y = s != null ? s : 0;
    if (y & 2) {
        let { static: f = !1, ...u } = o;
        if (f) return $513e46b2b02099d5$var$F(u, e, a, l, i);
    }
    if (y & 1) {
        let { unmount: f = !0, ...u } = o;
        return (0, $151185d7717c1097$export$4659b591c19bdf3d)(f ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return $513e46b2b02099d5$var$F({
                    ...u,
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }, e, a, l, i);
            }
        });
    }
    return $513e46b2b02099d5$var$F(o, e, a, l, i);
}
function $513e46b2b02099d5$var$F(n, r = {}, e, a, s) {
    let { as: t = e, children: l, refName: i = "ref", ...o } = $513e46b2b02099d5$var$h(n, [
        "unmount",
        "static"
    ]), y = n.ref !== void 0 ? {
        [i]: n.ref
    } : {}, f = typeof l == "function" ? l(r) : l;
    "className" in o && o.className && typeof o.className == "function" && (o.className = o.className(r)), o["aria-labelledby"] && o["aria-labelledby"] === o.id && (o["aria-labelledby"] = void 0);
    let u = {};
    if (r) {
        let d = !1, p = [];
        for (let [c, T] of Object.entries(r))typeof T == "boolean" && (d = !0), T === !0 && p.push(c.replace(/([A-Z])/g, (g)=>`-${g.toLowerCase()}`));
        if (d) {
            u["data-headlessui-state"] = p.join(" ");
            for (let c of p)u[`data-${c}`] = "";
        }
    }
    if ($513e46b2b02099d5$export$9522e17588c12572(t) && (Object.keys($513e46b2b02099d5$export$8e16b83750b44988(o)).length > 0 || Object.keys($513e46b2b02099d5$export$8e16b83750b44988(u)).length > 0)) {
        if (!(0, $6uYXW.isValidElement)(f) || Array.isArray(f) && f.length > 1 || $513e46b2b02099d5$export$b4a42ffad0473d5d(f)) {
            if (Object.keys($513e46b2b02099d5$export$8e16b83750b44988(o)).length > 0) throw new Error([
                'Passing props on "Fragment"!',
                "",
                `The current component <${a} /> is rendering a "Fragment".`,
                "However we need to passthrough the following props:",
                Object.keys($513e46b2b02099d5$export$8e16b83750b44988(o)).concat(Object.keys($513e46b2b02099d5$export$8e16b83750b44988(u))).map((d)=>`  - ${d}`).join(`
`),
                "",
                "You can apply a few solutions:",
                [
                    'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                    "Render a single element as the child so that we can forward the props onto that element."
                ].map((d)=>`  - ${d}`).join(`
`)
            ].join(`
`));
        } else {
            let d = f.props, p = d == null ? void 0 : d.className, c = typeof p == "function" ? (...R)=>(0, $393ff8b6ca113c61$export$ce4ab0c55987d1ff)(p(...R), o.className) : (0, $393ff8b6ca113c61$export$ce4ab0c55987d1ff)(p, o.className), T = c ? {
                className: c
            } : {}, g = $513e46b2b02099d5$var$P(f.props, $513e46b2b02099d5$export$8e16b83750b44988($513e46b2b02099d5$var$h(o, [
                "ref"
            ])));
            for(let R in u)R in g && delete u[R];
            return (0, $6uYXW.cloneElement)(f, Object.assign({}, g, u, y, {
                ref: s($513e46b2b02099d5$var$H(f), y.ref)
            }, T));
        }
    }
    return (0, $6uYXW.createElement)(t, Object.assign({}, $513e46b2b02099d5$var$h(o, [
        "ref"
    ]), !$513e46b2b02099d5$export$9522e17588c12572(t) && y, !$513e46b2b02099d5$export$9522e17588c12572(t) && u), f);
}
function $513e46b2b02099d5$var$$() {
    let n = (0, $6uYXW.useRef)([]), r = (0, $6uYXW.useCallback)((e)=>{
        for (let a of n.current)a != null && (typeof a == "function" ? a(e) : a.current = e);
    }, []);
    return (...e)=>{
        if (!e.every((a)=>a == null)) return n.current = e, r;
    };
}
function $513e46b2b02099d5$var$I(...n) {
    return n.every((r)=>r == null) ? void 0 : (r)=>{
        for (let e of n)e != null && (typeof e == "function" ? e(r) : e.current = r);
    };
}
function $513e46b2b02099d5$var$P(...n) {
    var a;
    if (n.length === 0) return {};
    if (n.length === 1) return n[0];
    let r = {}, e = {};
    for (let s of n)for(let t in s)t.startsWith("on") && typeof s[t] == "function" ? ((a = e[t]) != null || (e[t] = []), e[t].push(s[t])) : r[t] = s[t];
    if (r.disabled || r["aria-disabled"]) for(let s in e)/^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(s) && (e[s] = [
        (t)=>{
            var l;
            return (l = t == null ? void 0 : t.preventDefault) == null ? void 0 : l.call(t);
        }
    ]);
    for(let s in e)Object.assign(r, {
        [s] (t, ...l) {
            let i = e[s];
            for (let o of i){
                if ((t instanceof Event || (t == null ? void 0 : t.nativeEvent) instanceof Event) && t.defaultPrevented) return;
                o(t, ...l);
            }
        }
    });
    return r;
}
function $513e46b2b02099d5$export$9d1611c77c2fe928(...n) {
    var a;
    if (n.length === 0) return {};
    if (n.length === 1) return n[0];
    let r = {}, e = {};
    for (let s of n)for(let t in s)t.startsWith("on") && typeof s[t] == "function" ? ((a = e[t]) != null || (e[t] = []), e[t].push(s[t])) : r[t] = s[t];
    for(let s in e)Object.assign(r, {
        [s] (...t) {
            let l = e[s];
            for (let i of l)i == null || i(...t);
        }
    });
    return r;
}
function $513e46b2b02099d5$export$e43f39796049410c(n) {
    var r;
    return Object.assign((0, $6uYXW.forwardRef)(n), {
        displayName: (r = n.displayName) != null ? r : n.name
    });
}
function $513e46b2b02099d5$export$8e16b83750b44988(n) {
    let r = Object.assign({}, n);
    for(let e in r)r[e] === void 0 && delete r[e];
    return r;
}
function $513e46b2b02099d5$var$h(n, r = []) {
    let e = Object.assign({}, n);
    for (let a of r)a in e && delete e[a];
    return e;
}
function $513e46b2b02099d5$var$H(n) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).version.split(".")[0] >= "19" ? n.props.ref : n.ref;
}
function $513e46b2b02099d5$export$9522e17588c12572(n) {
    return n === (0, $6uYXW.Fragment) || n === Symbol.for("react.fragment");
}
function $513e46b2b02099d5$export$b4a42ffad0473d5d(n) {
    return $513e46b2b02099d5$export$9522e17588c12572(n.type);
}



var $6uYXW = parcelRequire("6uYXW");
var $b0fe98e613cc67f0$var$t;
let $b0fe98e613cc67f0$export$7568632d0d33d16d = ($b0fe98e613cc67f0$var$t = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).startTransition) != null ? $b0fe98e613cc67f0$var$t : function(i) {
    i();
};


var $961a4e4f4fb2e176$export$4b0075e5ea5e1f26 = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))($961a4e4f4fb2e176$export$4b0075e5ea5e1f26 || {});


"use client";
var $a736ddedb241f228$var$me = ((l)=>(l[l.Open = 0] = "Open", l[l.Closed = 1] = "Closed", l))($a736ddedb241f228$var$me || {}), $a736ddedb241f228$var$fe = ((n)=>(n[n.ToggleDisclosure = 0] = "ToggleDisclosure", n[n.CloseDisclosure = 1] = "CloseDisclosure", n[n.SetButtonId = 2] = "SetButtonId", n[n.SetPanelId = 3] = "SetPanelId", n[n.SetButtonElement = 4] = "SetButtonElement", n[n.SetPanelElement = 5] = "SetPanelElement", n))($a736ddedb241f228$var$fe || {});
let $a736ddedb241f228$var$De = {
    [0]: (e)=>({
            ...e,
            disclosureState: (0, $151185d7717c1097$export$4659b591c19bdf3d)(e.disclosureState, {
                [0]: 1,
                [1]: 0
            })
        }),
    [1]: (e)=>e.disclosureState === 1 ? e : {
            ...e,
            disclosureState: 1
        },
    [2] (e, t) {
        return e.buttonId === t.buttonId ? e : {
            ...e,
            buttonId: t.buttonId
        };
    },
    [3] (e, t) {
        return e.panelId === t.panelId ? e : {
            ...e,
            panelId: t.panelId
        };
    },
    [4] (e, t) {
        return e.buttonElement === t.element ? e : {
            ...e,
            buttonElement: t.element
        };
    },
    [5] (e, t) {
        return e.panelElement === t.element ? e : {
            ...e,
            panelElement: t.element
        };
    }
}, $a736ddedb241f228$var$_ = (0, $6uYXW.createContext)(null);
$a736ddedb241f228$var$_.displayName = "DisclosureContext";
function $a736ddedb241f228$var$M(e) {
    let t = (0, $6uYXW.useContext)($a736ddedb241f228$var$_);
    if (t === null) {
        let l = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(l, $a736ddedb241f228$var$M), l;
    }
    return t;
}
let $a736ddedb241f228$var$F = (0, $6uYXW.createContext)(null);
$a736ddedb241f228$var$F.displayName = "DisclosureAPIContext";
function $a736ddedb241f228$var$V(e) {
    let t = (0, $6uYXW.useContext)($a736ddedb241f228$var$F);
    if (t === null) {
        let l = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(l, $a736ddedb241f228$var$V), l;
    }
    return t;
}
let $a736ddedb241f228$var$H = (0, $6uYXW.createContext)(null);
$a736ddedb241f228$var$H.displayName = "DisclosurePanelContext";
function $a736ddedb241f228$var$ye() {
    return (0, $6uYXW.useContext)($a736ddedb241f228$var$H);
}
function $a736ddedb241f228$var$Pe(e, t) {
    return (0, $151185d7717c1097$export$4659b591c19bdf3d)(t.type, $a736ddedb241f228$var$De, e, t);
}
let $a736ddedb241f228$var$Ee = (0, $6uYXW.Fragment);
function $a736ddedb241f228$var$Se(e, t) {
    let { defaultOpen: l = !1, ...p } = e, a = (0, $6uYXW.useRef)(null), c = (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)(t, (0, $c8ac0a774b50c957$export$7029785b750eb74)((u)=>{
        a.current = u;
    }, e.as === void 0 || (0, $513e46b2b02099d5$export$9522e17588c12572)(e.as))), n = (0, $6uYXW.useReducer)($a736ddedb241f228$var$Pe, {
        disclosureState: l ? 0 : 1,
        buttonElement: null,
        panelElement: null,
        buttonId: null,
        panelId: null
    }), [{ disclosureState: o, buttonId: r }, f] = n, s = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((u)=>{
        f({
            type: 1
        });
        let m = (0, $d76c946db081c9ef$export$b204af158042fbac)(a.current);
        if (!m || !r) return;
        let d = (()=>u ? $36c2319598bace40$export$79c619c6018bbb44(u) ? u : "current" in u && $36c2319598bace40$export$79c619c6018bbb44(u.current) ? u.current : m.getElementById(r) : m.getElementById(r))();
        d == null || d.focus();
    }), E = (0, $6uYXW.useMemo)(()=>({
            close: s
        }), [
        s
    ]), T = (0, $fbe56f88477e21c7$export$9d4c57ee4c6ffdd8)({
        open: o === 0,
        close: s
    }), D = {
        ref: c
    }, S = (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($a736ddedb241f228$var$_.Provider, {
        value: n
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($a736ddedb241f228$var$F.Provider, {
        value: E
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $34590dda7a415b35$export$dd2a80b78bebbe1d), {
        value: s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $efd9a985d91b0391$export$2a0ed818b175f558), {
        value: (0, $151185d7717c1097$export$4659b591c19bdf3d)(o, {
            [0]: (0, $efd9a985d91b0391$export$7254cc27399e90bd).Open,
            [1]: (0, $efd9a985d91b0391$export$7254cc27399e90bd).Closed
        })
    }, S({
        ourProps: D,
        theirProps: p,
        slot: T,
        defaultTag: $a736ddedb241f228$var$Ee,
        name: "Disclosure"
    })))));
}
let $a736ddedb241f228$var$ge = "button";
function $a736ddedb241f228$var$Ae(e, t) {
    let l = (0, $6uYXW.useId)(), { id: p = `headlessui-disclosure-button-${l}`, disabled: a = !1, autoFocus: c = !1, ...n } = e, [o, r] = $a736ddedb241f228$var$M("Disclosure.Button"), f = $a736ddedb241f228$var$ye(), s = f === null ? !1 : f === o.panelId, E = (0, $6uYXW.useRef)(null), T = (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)(E, t, (0, $555339916ec7fe05$export$90fc3a17d93f704c)((i)=>{
        if (!s) return r({
            type: 4,
            element: i
        });
    }));
    (0, $6uYXW.useEffect)(()=>{
        if (!s) return r({
            type: 2,
            buttonId: p
        }), ()=>{
            r({
                type: 2,
                buttonId: null
            });
        };
    }, [
        p,
        r,
        s
    ]);
    let D = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((i)=>{
        var g;
        if (s) {
            if (o.disclosureState === 1) return;
            switch(i.key){
                case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Space:
                case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Enter:
                    i.preventDefault(), i.stopPropagation(), r({
                        type: 0
                    }), (g = o.buttonElement) == null || g.focus();
                    break;
            }
        } else switch(i.key){
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Space:
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Enter:
                i.preventDefault(), i.stopPropagation(), r({
                    type: 0
                });
                break;
        }
    }), S = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((i)=>{
        switch(i.key){
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Space:
                i.preventDefault();
                break;
        }
    }), u = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((i)=>{
        var g;
        (0, $d37bc8a0371b3098$export$db61f031a278447c)(i.currentTarget) || a || (s ? (r({
            type: 0
        }), (g = o.buttonElement) == null || g.focus()) : r({
            type: 0
        }));
    }), { isFocusVisible: m, focusProps: d } = (0, $63b99e5b44fc4848$export$4e328f61c538687f)({
        autoFocus: c
    }), { isHovered: C, hoverProps: h } = (0, $2c47d83feaa2f132$export$ae780daf29e6d456)({
        isDisabled: a
    }), { pressed: $, pressProps: U } = (0, $2a0752a989a3abf0$export$73224eeef4bbe873)({
        disabled: a
    }), J = (0, $fbe56f88477e21c7$export$9d4c57ee4c6ffdd8)({
        open: o.disclosureState === 0,
        hover: C,
        active: $,
        disabled: a,
        focus: m,
        autofocus: c
    }), G = (0, $8df6c730accaca48$export$53652b2b272efe9c)(e, o.buttonElement), X = s ? (0, $513e46b2b02099d5$export$9d1611c77c2fe928)({
        ref: T,
        type: G,
        disabled: a || void 0,
        autoFocus: c,
        onKeyDown: D,
        onClick: u
    }, d, h, U) : (0, $513e46b2b02099d5$export$9d1611c77c2fe928)({
        ref: T,
        id: p,
        type: G,
        "aria-expanded": o.disclosureState === 0,
        "aria-controls": o.panelElement ? o.panelId : void 0,
        disabled: a || void 0,
        autoFocus: c,
        onKeyDown: D,
        onKeyUp: S,
        onClick: u
    }, d, h, U);
    return (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)()({
        ourProps: X,
        theirProps: n,
        slot: J,
        defaultTag: $a736ddedb241f228$var$ge,
        name: "Disclosure.Button"
    });
}
let $a736ddedb241f228$var$be = "div", $a736ddedb241f228$var$Ce = (0, $513e46b2b02099d5$export$ba0ea3f20e7bf777).RenderStrategy | (0, $513e46b2b02099d5$export$ba0ea3f20e7bf777).Static;
function $a736ddedb241f228$var$Re(e, t) {
    let l = (0, $6uYXW.useId)(), { id: p = `headlessui-disclosure-panel-${l}`, transition: a = !1, ...c } = e, [n, o] = $a736ddedb241f228$var$M("Disclosure.Panel"), { close: r } = $a736ddedb241f228$var$V("Disclosure.Panel"), [f, s] = (0, $6uYXW.useState)(null), E = (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)(t, (0, $555339916ec7fe05$export$90fc3a17d93f704c)((C)=>{
        (0, $b0fe98e613cc67f0$export$7568632d0d33d16d)(()=>o({
                type: 5,
                element: C
            }));
    }), s);
    (0, $6uYXW.useEffect)(()=>(o({
            type: 3,
            panelId: p
        }), ()=>{
            o({
                type: 3,
                panelId: null
            });
        }), [
        p,
        o
    ]);
    let T = (0, $efd9a985d91b0391$export$fc6fdf0ecf360e)(), [D, S] = (0, $ccac44f91c8229c7$export$7b286972b8d8ccbf)(a, f, T !== null ? (T & (0, $efd9a985d91b0391$export$7254cc27399e90bd).Open) === (0, $efd9a985d91b0391$export$7254cc27399e90bd).Open : n.disclosureState === 0), u = (0, $fbe56f88477e21c7$export$9d4c57ee4c6ffdd8)({
        open: n.disclosureState === 0,
        close: r
    }), m = {
        ref: E,
        id: p,
        ...(0, $ccac44f91c8229c7$export$c291d481c40a2fc3)(S)
    }, d = (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $efd9a985d91b0391$export$6748feed729c7cf3), null, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($a736ddedb241f228$var$H.Provider, {
        value: n.panelId
    }, d({
        ourProps: m,
        theirProps: c,
        slot: u,
        defaultTag: $a736ddedb241f228$var$be,
        features: $a736ddedb241f228$var$Ce,
        visible: D,
        name: "Disclosure.Panel"
    })));
}
let $a736ddedb241f228$var$Ie = (0, $513e46b2b02099d5$export$e43f39796049410c)($a736ddedb241f228$var$Se), $a736ddedb241f228$export$4edbb1575344e6fc = (0, $513e46b2b02099d5$export$e43f39796049410c)($a736ddedb241f228$var$Ae), $a736ddedb241f228$export$feabaa331e1d464c = (0, $513e46b2b02099d5$export$e43f39796049410c)($a736ddedb241f228$var$Re), $a736ddedb241f228$export$74a362b31437ec83 = Object.assign($a736ddedb241f228$var$Ie, {
    Button: $a736ddedb241f228$export$4edbb1575344e6fc,
    Panel: $a736ddedb241f228$export$feabaa331e1d464c
});




var $6uYXW = parcelRequire("6uYXW");




var $6uYXW = parcelRequire("6uYXW");


function $ac376574bfb928bb$var$h(i) {
    if (i === null) return {
        width: 0,
        height: 0
    };
    let { width: t, height: e } = i.getBoundingClientRect();
    return {
        width: t,
        height: e
    };
}
function $ac376574bfb928bb$export$2b86bedf890eab8(i, t, e = !1) {
    let [r, f] = (0, $6uYXW.useState)(()=>$ac376574bfb928bb$var$h(t));
    return (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        if (!t || !i) return;
        let n = (0, $5b6227043c6a88bc$export$12b26c28a05aa001)();
        return n.requestAnimationFrame(function s() {
            n.requestAnimationFrame(s), f((u)=>{
                let o = $ac376574bfb928bb$var$h(t);
                return o.width === u.width && o.height === u.height ? u : o;
            });
        }), ()=>{
            n.dispose();
        };
    }, [
        t,
        i
    ]), e ? {
        width: `${r.width}px`,
        height: `${r.height}px`
    } : r;
}




var $6uYXW = parcelRequire("6uYXW");
var $b525ec018fa637e5$export$92850d9476e00eee = ((f)=>(f[f.Left = 0] = "Left", f[f.Right = 2] = "Right", f))($b525ec018fa637e5$export$92850d9476e00eee || {});




function $15a351b74ba7cdc8$export$87bd167e79a089ba(t) {
    let r = (0, $6uYXW.useRef)(null), u = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((e)=>{
        r.current = e.pointerType, !(0, $d37bc8a0371b3098$export$db61f031a278447c)(e.currentTarget) && e.pointerType === "mouse" && e.button === (0, $b525ec018fa637e5$export$92850d9476e00eee).Left && (e.preventDefault(), t(e));
    }), i = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((e)=>{
        r.current !== "mouse" && ((0, $d37bc8a0371b3098$export$db61f031a278447c)(e.currentTarget) || t(e));
    });
    return {
        onPointerDown: u,
        onClick: i
    };
}



var $6uYXW = parcelRequire("6uYXW");



var $6uYXW = parcelRequire("6uYXW");
class $2857275ab2af966c$export$674cd7dcb504ac5c extends Map {
    constructor(t){
        super();
        this.factory = t;
    }
    get(t) {
        let e = super.get(t);
        return e === void 0 && (e = this.factory(t), this.set(t, e)), e;
    }
}




var $bf0f3973007a2834$var$h = Object.defineProperty;
var $bf0f3973007a2834$var$v = (t, e, r)=>e in t ? $bf0f3973007a2834$var$h(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r;
var $bf0f3973007a2834$var$S = (t, e, r)=>($bf0f3973007a2834$var$v(t, typeof e != "symbol" ? e + "" : e, r), r), $bf0f3973007a2834$var$b = (t, e, r)=>{
    if (!e.has(t)) throw TypeError("Cannot " + r);
};
var $bf0f3973007a2834$var$i = (t, e, r)=>($bf0f3973007a2834$var$b(t, e, "read from private field"), r ? r.call(t) : e.get(t)), $bf0f3973007a2834$var$c = (t, e, r)=>{
    if (e.has(t)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(t) : e.set(t, r);
}, $bf0f3973007a2834$var$u = (t, e, r, s)=>($bf0f3973007a2834$var$b(t, e, "write to private field"), s ? s.call(t, r) : e.set(t, r), r);
var $bf0f3973007a2834$var$n, $bf0f3973007a2834$var$a, $bf0f3973007a2834$var$o;
class $bf0f3973007a2834$export$f391db14ff2d9279 {
    constructor(e){
        $bf0f3973007a2834$var$c(this, $bf0f3973007a2834$var$n, {});
        $bf0f3973007a2834$var$c(this, $bf0f3973007a2834$var$a, new (0, $2857275ab2af966c$export$674cd7dcb504ac5c)(()=>new Set));
        $bf0f3973007a2834$var$c(this, $bf0f3973007a2834$var$o, new Set);
        $bf0f3973007a2834$var$S(this, "disposables", (0, $5b6227043c6a88bc$export$12b26c28a05aa001)());
        $bf0f3973007a2834$var$u(this, $bf0f3973007a2834$var$n, e), (0, $76d81e2a3e06b5b5$export$a7b6bc01c63cdfc3).isServer && this.disposables.microTask(()=>{
            this.dispose();
        });
    }
    dispose() {
        this.disposables.dispose();
    }
    get state() {
        return $bf0f3973007a2834$var$i(this, $bf0f3973007a2834$var$n);
    }
    subscribe(e, r) {
        if ((0, $76d81e2a3e06b5b5$export$a7b6bc01c63cdfc3).isServer) return ()=>{};
        let s = {
            selector: e,
            callback: r,
            current: e($bf0f3973007a2834$var$i(this, $bf0f3973007a2834$var$n))
        };
        return $bf0f3973007a2834$var$i(this, $bf0f3973007a2834$var$o).add(s), this.disposables.add(()=>{
            $bf0f3973007a2834$var$i(this, $bf0f3973007a2834$var$o).delete(s);
        });
    }
    on(e, r) {
        return (0, $76d81e2a3e06b5b5$export$a7b6bc01c63cdfc3).isServer ? ()=>{} : ($bf0f3973007a2834$var$i(this, $bf0f3973007a2834$var$a).get(e).add(r), this.disposables.add(()=>{
            $bf0f3973007a2834$var$i(this, $bf0f3973007a2834$var$a).get(e).delete(r);
        }));
    }
    send(e) {
        let r = this.reduce($bf0f3973007a2834$var$i(this, $bf0f3973007a2834$var$n), e);
        if (r !== $bf0f3973007a2834$var$i(this, $bf0f3973007a2834$var$n)) {
            $bf0f3973007a2834$var$u(this, $bf0f3973007a2834$var$n, r);
            for (let s of $bf0f3973007a2834$var$i(this, $bf0f3973007a2834$var$o)){
                let l = s.selector($bf0f3973007a2834$var$i(this, $bf0f3973007a2834$var$n));
                $bf0f3973007a2834$export$d36bdfa510afb180(s.current, l) || (s.current = l, s.callback(l));
            }
            for (let s of $bf0f3973007a2834$var$i(this, $bf0f3973007a2834$var$a).get(e.type))s($bf0f3973007a2834$var$i(this, $bf0f3973007a2834$var$n), e);
        }
    }
}
$bf0f3973007a2834$var$n = new WeakMap, $bf0f3973007a2834$var$a = new WeakMap, $bf0f3973007a2834$var$o = new WeakMap;
function $bf0f3973007a2834$export$d36bdfa510afb180(t, e) {
    return Object.is(t, e) ? !0 : typeof t != "object" || t === null || typeof e != "object" || e === null ? !1 : Array.isArray(t) && Array.isArray(e) ? t.length !== e.length ? !1 : $bf0f3973007a2834$var$f(t[Symbol.iterator](), e[Symbol.iterator]()) : t instanceof Map && e instanceof Map || t instanceof Set && e instanceof Set ? t.size !== e.size ? !1 : $bf0f3973007a2834$var$f(t.entries(), e.entries()) : $bf0f3973007a2834$var$p(t) && $bf0f3973007a2834$var$p(e) ? $bf0f3973007a2834$var$f(Object.entries(t)[Symbol.iterator](), Object.entries(e)[Symbol.iterator]()) : !1;
}
function $bf0f3973007a2834$var$f(t, e) {
    do {
        let r = t.next(), s = e.next();
        if (r.done && s.done) return !0;
        if (r.done || s.done || !Object.is(r.value, s.value)) return !1;
    }while (!0);
}
function $bf0f3973007a2834$var$p(t) {
    if (Object.prototype.toString.call(t) !== "[object Object]") return !1;
    let e = Object.getPrototypeOf(t);
    return e === null || Object.getPrototypeOf(e) === null;
}
function $bf0f3973007a2834$export$712ea50be43a7858(t) {
    let [e, r] = t(), s = (0, $5b6227043c6a88bc$export$12b26c28a05aa001)();
    return (...l)=>{
        e(...l), s.dispose(), s.microTask(r);
    };
}




var $742c0ddaeb293345$var$a = Object.defineProperty;
var $742c0ddaeb293345$var$r = (e, c, t)=>c in e ? $742c0ddaeb293345$var$a(e, c, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[c] = t;
var $742c0ddaeb293345$var$p = (e, c, t)=>($742c0ddaeb293345$var$r(e, typeof c != "symbol" ? c + "" : c, t), t);
var $742c0ddaeb293345$export$1385d81a6c6bbcd4 = ((t)=>(t[t.Push = 0] = "Push", t[t.Pop = 1] = "Pop", t))($742c0ddaeb293345$export$1385d81a6c6bbcd4 || {});
let $742c0ddaeb293345$var$y = {
    [0] (e, c) {
        let t = c.id, s = e.stack, i = e.stack.indexOf(t);
        if (i !== -1) {
            let n = e.stack.slice();
            return n.splice(i, 1), n.push(t), s = n, {
                ...e,
                stack: s
            };
        }
        return {
            ...e,
            stack: [
                ...e.stack,
                t
            ]
        };
    },
    [1] (e, c) {
        let t = c.id, s = e.stack.indexOf(t);
        if (s === -1) return e;
        let i = e.stack.slice();
        return i.splice(s, 1), {
            ...e,
            stack: i
        };
    }
};
class $742c0ddaeb293345$var$o extends (0, $bf0f3973007a2834$export$f391db14ff2d9279) {
    constructor(){
        super(...arguments);
        $742c0ddaeb293345$var$p(this, "actions", {
            push: (t)=>this.send({
                    type: 0,
                    id: t
                }),
            pop: (t)=>this.send({
                    type: 1,
                    id: t
                })
        });
        $742c0ddaeb293345$var$p(this, "selectors", {
            isTop: (t, s)=>t.stack[t.stack.length - 1] === s,
            inStack: (t, s)=>t.stack.includes(s)
        });
    }
    static new() {
        return new $742c0ddaeb293345$var$o({
            stack: []
        });
    }
    reduce(t, s) {
        return (0, $151185d7717c1097$export$4659b591c19bdf3d)(s.type, $742c0ddaeb293345$var$y, t, s);
    }
}
const $742c0ddaeb293345$export$151359021f43c28a = new (0, $2857275ab2af966c$export$674cd7dcb504ac5c)(()=>$742c0ddaeb293345$var$o.new());


var $2590c45a9dbb5def$exports = {};
'use strict';

$2590c45a9dbb5def$exports = (parcelRequire("f5D4x"));




function $185fb310b820deb4$export$89d3cfa2bf31e31a(e, n, r = (0, $bf0f3973007a2834$export$d36bdfa510afb180)) {
    return (0, $2590c45a9dbb5def$exports.useSyncExternalStoreWithSelector)((0, $555339916ec7fe05$export$90fc3a17d93f704c)((i)=>e.subscribe($185fb310b820deb4$var$s, i)), (0, $555339916ec7fe05$export$90fc3a17d93f704c)(()=>e.state), (0, $555339916ec7fe05$export$90fc3a17d93f704c)(()=>e.state), (0, $555339916ec7fe05$export$90fc3a17d93f704c)(n), r);
}
function $185fb310b820deb4$var$s(e) {
    return e;
}



function $62a149d4d147ea69$export$5f5dd115998e0b80(o, s) {
    let t = (0, $6uYXW.useId)(), r = (0, $742c0ddaeb293345$export$151359021f43c28a).get(s), [i, c] = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(r, (0, $6uYXW.useCallback)((e)=>[
            r.selectors.isTop(e, t),
            r.selectors.inStack(e, t)
        ], [
        r,
        t
    ]));
    return (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        if (o) return r.actions.push(t), ()=>r.actions.pop(t);
    }, [
        r,
        o,
        t
    ]), o ? c ? i : !0 : !1;
}



let $09ac2e93626b6281$var$f = new Map, $09ac2e93626b6281$var$u = new Map;
function $09ac2e93626b6281$var$h(t) {
    var e;
    let r = (e = $09ac2e93626b6281$var$u.get(t)) != null ? e : 0;
    return $09ac2e93626b6281$var$u.set(t, r + 1), r !== 0 ? ()=>$09ac2e93626b6281$var$m(t) : ($09ac2e93626b6281$var$f.set(t, {
        "aria-hidden": t.getAttribute("aria-hidden"),
        inert: t.inert
    }), t.setAttribute("aria-hidden", "true"), t.inert = !0, ()=>$09ac2e93626b6281$var$m(t));
}
function $09ac2e93626b6281$var$m(t) {
    var i;
    let r = (i = $09ac2e93626b6281$var$u.get(t)) != null ? i : 1;
    if (r === 1 ? $09ac2e93626b6281$var$u.delete(t) : $09ac2e93626b6281$var$u.set(t, r - 1), r !== 1) return;
    let e = $09ac2e93626b6281$var$f.get(t);
    e && (e["aria-hidden"] === null ? t.removeAttribute("aria-hidden") : t.setAttribute("aria-hidden", e["aria-hidden"]), t.inert = e.inert, $09ac2e93626b6281$var$f.delete(t));
}
function $09ac2e93626b6281$export$af489fa7e5283cc3(t, { allowed: r, disallowed: e } = {}) {
    let i = (0, $62a149d4d147ea69$export$5f5dd115998e0b80)(t, "inert-others");
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        var d, c;
        if (!i) return;
        let a = (0, $5b6227043c6a88bc$export$12b26c28a05aa001)();
        for (let n of (d = e == null ? void 0 : e()) != null ? d : [])n && a.add($09ac2e93626b6281$var$h(n));
        let s = (c = r == null ? void 0 : r()) != null ? c : [];
        for (let n of s){
            if (!n) continue;
            let l = (0, $d76c946db081c9ef$export$b204af158042fbac)(n);
            if (!l) continue;
            let o = n.parentElement;
            for(; o && o !== l.body;){
                for (let p of o.children)s.some((E)=>p.contains(E)) || a.add($09ac2e93626b6281$var$h(p));
                o = o.parentElement;
            }
        }
        return a.dispose;
    }, [
        i,
        r,
        e
    ]);
}




var $6uYXW = parcelRequire("6uYXW");



function $0635c499e325c995$export$b41b9097915aa006(s, n, o) {
    let i = (0, $45cf98b6ba6e8cbc$export$86c4283a11f23f95)((t)=>{
        let e = t.getBoundingClientRect();
        e.x === 0 && e.y === 0 && e.width === 0 && e.height === 0 && o();
    });
    (0, $6uYXW.useEffect)(()=>{
        if (!s) return;
        let t = n === null ? null : $36c2319598bace40$export$1b3bfaa9684536aa(n) ? n : n.current;
        if (!t) return;
        let e = (0, $5b6227043c6a88bc$export$12b26c28a05aa001)();
        if (typeof ResizeObserver != "undefined") {
            let r = new ResizeObserver(()=>i.current(t));
            r.observe(t), e.add(()=>r.disconnect());
        }
        if (typeof IntersectionObserver != "undefined") {
            let r = new IntersectionObserver(()=>i.current(t));
            r.observe(t), e.add(()=>r.disconnect());
        }
        return ()=>e.dispose();
    }, [
        n,
        i,
        s
    ]);
}



var $6uYXW = parcelRequire("6uYXW");





let $fbf026b0a7ade674$export$acea64b1933eb668 = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "details>summary",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(","), $fbf026b0a7ade674$var$S = [
    "[data-autofocus]"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var $fbf026b0a7ade674$export$807a7eae502106e7 = ((o)=>(o[o.First = 1] = "First", o[o.Previous = 2] = "Previous", o[o.Next = 4] = "Next", o[o.Last = 8] = "Last", o[o.WrapAround = 16] = "WrapAround", o[o.NoScroll = 32] = "NoScroll", o[o.AutoFocus = 64] = "AutoFocus", o))($fbf026b0a7ade674$export$807a7eae502106e7 || {}), $fbf026b0a7ade674$export$abf286375dfa6dbd = ((n)=>(n[n.Error = 0] = "Error", n[n.Overflow = 1] = "Overflow", n[n.Success = 2] = "Success", n[n.Underflow = 3] = "Underflow", n))($fbf026b0a7ade674$export$abf286375dfa6dbd || {}), $fbf026b0a7ade674$var$O = ((t)=>(t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))($fbf026b0a7ade674$var$O || {});
function $fbf026b0a7ade674$export$433aaa1f216cf32d(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($fbf026b0a7ade674$export$acea64b1933eb668)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
function $fbf026b0a7ade674$export$89622d0e8d475962(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($fbf026b0a7ade674$var$S)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var $fbf026b0a7ade674$export$27112a34f2f8402d = ((t)=>(t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))($fbf026b0a7ade674$export$27112a34f2f8402d || {});
function $fbf026b0a7ade674$export$ff1ec1c740b3c8d5(e, r = 0) {
    var t;
    return e === ((t = (0, $d76c946db081c9ef$export$b204af158042fbac)(e)) == null ? void 0 : t.body) ? !1 : (0, $151185d7717c1097$export$4659b591c19bdf3d)(r, {
        [0] () {
            return e.matches($fbf026b0a7ade674$export$acea64b1933eb668);
        },
        [1] () {
            let l = e;
            for(; l !== null;){
                if (l.matches($fbf026b0a7ade674$export$acea64b1933eb668)) return !0;
                l = l.parentElement;
            }
            return !1;
        }
    });
}
function $fbf026b0a7ade674$export$46388676ec35ab85(e) {
    (0, $5b6227043c6a88bc$export$12b26c28a05aa001)().nextFrame(()=>{
        let r = (0, $d76c946db081c9ef$export$cd4e5573fbe2b576)(e);
        r && $36c2319598bace40$export$79c619c6018bbb44(r) && !$fbf026b0a7ade674$export$ff1ec1c740b3c8d5(r, 0) && $fbf026b0a7ade674$export$5fed9cc43865dc7e(e);
    });
}
var $fbf026b0a7ade674$var$g = ((t)=>(t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))($fbf026b0a7ade674$var$g || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e)=>{
    e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e)=>{
    e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function $fbf026b0a7ade674$export$5fed9cc43865dc7e(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let $fbf026b0a7ade674$var$_ = [
    "textarea",
    "input"
].join(",");
function $fbf026b0a7ade674$var$P(e) {
    var r, t;
    return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, $fbf026b0a7ade674$var$_)) != null ? t : !1;
}
function $fbf026b0a7ade674$export$20305e96f91bf103(e, r = (t)=>t) {
    return e.slice().sort((t, l)=>{
        let n = r(t), a = r(l);
        if (n === null || a === null) return 0;
        let u = n.compareDocumentPosition(a);
        return u & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : u & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function $fbf026b0a7ade674$export$7fb6c844b485e870(e, r, t = e === null ? document.body : (0, $d76c946db081c9ef$export$9bfe85d84666e58)(e)) {
    return $fbf026b0a7ade674$export$82e1f4f412218a1d($fbf026b0a7ade674$export$433aaa1f216cf32d(t), r, {
        relativeTo: e
    });
}
function $fbf026b0a7ade674$export$82e1f4f412218a1d(e, r, { sorted: t = !0, relativeTo: l = null, skipElements: n = [] } = {}) {
    let a = Array.isArray(e) ? e.length > 0 ? (0, $d76c946db081c9ef$export$9bfe85d84666e58)(e[0]) : document : (0, $d76c946db081c9ef$export$9bfe85d84666e58)(e), u = Array.isArray(e) ? t ? $fbf026b0a7ade674$export$20305e96f91bf103(e) : e : r & 64 ? $fbf026b0a7ade674$export$89622d0e8d475962(e) : $fbf026b0a7ade674$export$433aaa1f216cf32d(e);
    n.length > 0 && u.length > 1 && (u = u.filter((i)=>!n.some((d)=>d != null && "current" in d ? (d == null ? void 0 : d.current) === i : d === i))), l = l != null ? l : a == null ? void 0 : a.activeElement;
    let o = (()=>{
        if (r & 5) return 1;
        if (r & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), M = (()=>{
        if (r & 1) return 0;
        if (r & 2) return Math.max(0, u.indexOf(l)) - 1;
        if (r & 4) return Math.max(0, u.indexOf(l)) + 1;
        if (r & 8) return u.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), N = r & 32 ? {
        preventScroll: !0
    } : {}, m = 0, c = u.length, s;
    do {
        if (m >= c || m + c <= 0) return 0;
        let i = M + m;
        if (r & 16) i = (i + c) % c;
        else {
            if (i < 0) return 3;
            if (i >= c) return 1;
        }
        s = u[i], s == null || s.focus(N), m += o;
    }while (s !== (0, $d76c946db081c9ef$export$cd4e5573fbe2b576)(s));
    return r & 6 && $fbf026b0a7ade674$var$P(s) && s.select(), 2;
}


function $a0810353f512e7f9$export$fedb369cb70207f1() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function $a0810353f512e7f9$export$a11b0059900ceec8() {
    return /Android/gi.test(window.navigator.userAgent);
}
function $a0810353f512e7f9$export$d0a8044dce8ff2fc() {
    return $a0810353f512e7f9$export$fedb369cb70207f1() || $a0810353f512e7f9$export$a11b0059900ceec8();
}



var $6uYXW = parcelRequire("6uYXW");

function $af9d1b29ed65b12e$export$55d2b5df396a097b(t, e, o, n) {
    let u = (0, $45cf98b6ba6e8cbc$export$86c4283a11f23f95)(o);
    (0, $6uYXW.useEffect)(()=>{
        if (!t) return;
        function r(m) {
            u.current(m);
        }
        return document.addEventListener(e, r, n), ()=>document.removeEventListener(e, r, n);
    }, [
        t,
        e,
        n
    ]);
}




var $6uYXW = parcelRequire("6uYXW");

function $207995f11d05acef$export$ee579bb285b8d4aa(t, e, o, n) {
    let i = (0, $45cf98b6ba6e8cbc$export$86c4283a11f23f95)(o);
    (0, $6uYXW.useEffect)(()=>{
        if (!t) return;
        function r(d) {
            i.current(d);
        }
        return window.addEventListener(e, r, n), ()=>window.removeEventListener(e, r, n);
    }, [
        t,
        e,
        n
    ]);
}


const $26e1e3973f586229$var$C = 30;
function $26e1e3973f586229$export$71b2224f1ce5e08e(o, f, h) {
    let m = (0, $45cf98b6ba6e8cbc$export$86c4283a11f23f95)(h), s = (0, $6uYXW.useCallback)(function(e, c) {
        if (e.defaultPrevented) return;
        let r = c(e);
        if (r === null || !r.getRootNode().contains(r) || !r.isConnected) return;
        let M = function u(n) {
            return typeof n == "function" ? u(n()) : Array.isArray(n) || n instanceof Set ? n : [
                n
            ];
        }(f);
        for (let u of M)if (u !== null && (u.contains(r) || e.composed && e.composedPath().includes(u))) return;
        return !(0, $fbf026b0a7ade674$export$ff1ec1c740b3c8d5)(r, (0, $fbf026b0a7ade674$export$27112a34f2f8402d).Loose) && r.tabIndex !== -1 && e.preventDefault(), m.current(e, r);
    }, [
        m,
        f
    ]), i = (0, $6uYXW.useRef)(null);
    (0, $af9d1b29ed65b12e$export$55d2b5df396a097b)(o, "pointerdown", (t)=>{
        var e, c;
        (0, $a0810353f512e7f9$export$d0a8044dce8ff2fc)() || (i.current = ((c = (e = t.composedPath) == null ? void 0 : e.call(t)) == null ? void 0 : c[0]) || t.target);
    }, !0), (0, $af9d1b29ed65b12e$export$55d2b5df396a097b)(o, "pointerup", (t)=>{
        if ((0, $a0810353f512e7f9$export$d0a8044dce8ff2fc)() || !i.current) return;
        let e = i.current;
        return i.current = null, s(t, ()=>e);
    }, !0);
    let l = (0, $6uYXW.useRef)({
        x: 0,
        y: 0
    });
    (0, $af9d1b29ed65b12e$export$55d2b5df396a097b)(o, "touchstart", (t)=>{
        l.current.x = t.touches[0].clientX, l.current.y = t.touches[0].clientY;
    }, !0), (0, $af9d1b29ed65b12e$export$55d2b5df396a097b)(o, "touchend", (t)=>{
        let e = {
            x: t.changedTouches[0].clientX,
            y: t.changedTouches[0].clientY
        };
        if (!(Math.abs(e.x - l.current.x) >= $26e1e3973f586229$var$C || Math.abs(e.y - l.current.y) >= $26e1e3973f586229$var$C)) return s(t, ()=>$36c2319598bace40$export$79c619c6018bbb44(t.target) ? t.target : null);
    }, !0), (0, $207995f11d05acef$export$ee579bb285b8d4aa)(o, "blur", (t)=>s(t, ()=>$36c2319598bace40$export$8b613183536fc004(window.document.activeElement) ? window.document.activeElement : null), !0);
}



var $6uYXW = parcelRequire("6uYXW");

function $8994b146d9de4c13$export$dd9fbcea3de0ae36(...e) {
    return (0, $6uYXW.useMemo)(()=>(0, $d76c946db081c9ef$export$b204af158042fbac)(...e), [
        ...e
    ]);
}
function $8994b146d9de4c13$export$f6e818c9976ebbf2(...e) {
    return (0, $6uYXW.useMemo)(()=>(0, $d76c946db081c9ef$export$9bfe85d84666e58)(...e), [
        ...e
    ]);
}



var $6uYXW = parcelRequire("6uYXW");


var $61338770e1b4369c$var$H = ((e)=>(e[e.Ignore = 0] = "Ignore", e[e.Select = 1] = "Select", e[e.Close = 2] = "Close", e))($61338770e1b4369c$var$H || {});
const $61338770e1b4369c$export$e19cd5f9376f8cee = {
    Ignore: {
        kind: 0
    },
    Select: (r)=>({
            kind: 1,
            target: r
        }),
    Close: {
        kind: 2
    }
}, $61338770e1b4369c$var$M = 200, $61338770e1b4369c$var$f = 5;
function $61338770e1b4369c$export$a46c853b8b55573a(r, { trigger: n, action: T, close: e, select: p }) {
    let l = (0, $6uYXW.useRef)(null), i = (0, $6uYXW.useRef)(null), u = (0, $6uYXW.useRef)(null);
    (0, $af9d1b29ed65b12e$export$55d2b5df396a097b)(r && n !== null, "pointerdown", (t)=>{
        $36c2319598bace40$export$8ee0fc9ee280b4ee(t == null ? void 0 : t.target) && n != null && n.contains(t.target) && (i.current = t.x, u.current = t.y, l.current = t.timeStamp);
    }), (0, $af9d1b29ed65b12e$export$55d2b5df396a097b)(r && n !== null, "pointerup", (t)=>{
        var s, m;
        let c = l.current;
        if (c === null || (l.current = null, !$36c2319598bace40$export$79c619c6018bbb44(t.target)) || Math.abs(t.x - ((s = i.current) != null ? s : t.x)) < $61338770e1b4369c$var$f && Math.abs(t.y - ((m = u.current) != null ? m : t.y)) < $61338770e1b4369c$var$f) return;
        let a = T(t);
        switch(a.kind){
            case 0:
                return;
            case 1:
                t.timeStamp - c > $61338770e1b4369c$var$M && (p(a.target), e());
                break;
            case 2:
                e();
                break;
        }
    }, {
        capture: !0
    });
}




var $6uYXW = parcelRequire("6uYXW");
function $9bd6ba82966948c8$export$6ccbb43953eebf8(t) {
    return (0, $6uYXW.useSyncExternalStore)(t.subscribe, t.getSnapshot, t.getSnapshot);
}




function $a54f0019dca48e9f$export$f51a9068ac82ea43(o, r) {
    let t = o(), n = new Set;
    return {
        getSnapshot () {
            return t;
        },
        subscribe (e) {
            return n.add(e), ()=>n.delete(e);
        },
        dispatch (e, ...s) {
            let i = r[e].call(t, ...s);
            i && (t = i, n.forEach((c)=>c()));
        }
    };
}


function $b1c0a0adaa7639b5$export$110627fb35ef9205() {
    let r;
    return {
        before ({ doc: e }) {
            var l;
            let o = e.documentElement, t = (l = e.defaultView) != null ? l : window;
            r = Math.max(0, t.innerWidth - o.clientWidth);
        },
        after ({ doc: e, d: o }) {
            let t = e.documentElement, l = Math.max(0, t.clientWidth - t.offsetWidth), n = Math.max(0, r - l);
            o.style(t, "paddingRight", `${n}px`);
        }
    };
}





function $c76b9ffc4bf149c6$export$e3a523dfabf27286() {
    return (0, $a0810353f512e7f9$export$fedb369cb70207f1)() ? {
        before ({ doc: o, d: r, meta: m }) {
            function a(s) {
                for (let l of m().containers)for (let c of l())if (c.contains(s)) return !0;
                return !1;
            }
            r.microTask(()=>{
                var c;
                if (window.getComputedStyle(o.documentElement).scrollBehavior !== "auto") {
                    let t = (0, $5b6227043c6a88bc$export$12b26c28a05aa001)();
                    t.style(o.documentElement, "scrollBehavior", "auto"), r.add(()=>r.microTask(()=>t.dispose()));
                }
                let s = (c = window.scrollY) != null ? c : window.pageYOffset, l = null;
                r.addEventListener(o, "click", (t)=>{
                    if ($36c2319598bace40$export$79c619c6018bbb44(t.target)) try {
                        let e = t.target.closest("a");
                        if (!e) return;
                        let { hash: n } = new URL(e.href), f = o.querySelector(n);
                        $36c2319598bace40$export$79c619c6018bbb44(f) && !a(f) && (l = f);
                    } catch  {}
                }, !0), r.group((t)=>{
                    r.addEventListener(o, "touchstart", (e)=>{
                        if (t.dispose(), $36c2319598bace40$export$79c619c6018bbb44(e.target) && $36c2319598bace40$export$62c830b63044c679(e.target)) {
                            if (a(e.target)) {
                                let n = e.target;
                                for(; n.parentElement && a(n.parentElement);)n = n.parentElement;
                                t.style(n, "overscrollBehavior", "contain");
                            } else t.style(e.target, "touchAction", "none");
                        }
                    });
                }), r.addEventListener(o, "touchmove", (t)=>{
                    if ($36c2319598bace40$export$79c619c6018bbb44(t.target)) {
                        if ($36c2319598bace40$export$88a6ceeed5737ba3(t.target)) return;
                        if (a(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && e.dataset.headlessuiPortal !== "" && !(e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth);)e = e.parentElement;
                            e.dataset.headlessuiPortal === "" && t.preventDefault();
                        } else t.preventDefault();
                    }
                }, {
                    passive: !1
                }), r.add(()=>{
                    var e;
                    let t = (e = window.scrollY) != null ? e : window.pageYOffset;
                    s !== t && window.scrollTo(0, s), l && l.isConnected && (l.scrollIntoView({
                        block: "nearest"
                    }), l = null);
                });
            });
        }
    } : {};
}


function $a4abfe58155915c9$export$d8b6ff28805e84e9() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        }
    };
}


function $3e4196989f8f13e7$var$r(e) {
    let o = {};
    for (let t of e)Object.assign(o, t(o));
    return o;
}
let $3e4196989f8f13e7$export$a4161f418919b5aa = (0, $a54f0019dca48e9f$export$f51a9068ac82ea43)(()=>new Map, {
    PUSH (e, o) {
        var n;
        let t = (n = this.get(e)) != null ? n : {
            doc: e,
            count: 0,
            d: (0, $5b6227043c6a88bc$export$12b26c28a05aa001)(),
            meta: new Set,
            computedMeta: {}
        };
        return t.count++, t.meta.add(o), t.computedMeta = $3e4196989f8f13e7$var$r(t.meta), this.set(e, t), this;
    },
    POP (e, o) {
        let t = this.get(e);
        return t && (t.count--, t.meta.delete(o), t.computedMeta = $3e4196989f8f13e7$var$r(t.meta)), this;
    },
    SCROLL_PREVENT (e) {
        let o = {
            doc: e.doc,
            d: e.d,
            meta () {
                return e.computedMeta;
            }
        }, t = [
            (0, $c76b9ffc4bf149c6$export$e3a523dfabf27286)(),
            (0, $b1c0a0adaa7639b5$export$110627fb35ef9205)(),
            (0, $a4abfe58155915c9$export$d8b6ff28805e84e9)()
        ];
        t.forEach(({ before: n })=>n == null ? void 0 : n(o)), t.forEach(({ after: n })=>n == null ? void 0 : n(o));
    },
    SCROLL_ALLOW ({ d: e }) {
        e.dispose();
    },
    TEARDOWN ({ doc: e }) {
        this.delete(e);
    }
});
$3e4196989f8f13e7$export$a4161f418919b5aa.subscribe(()=>{
    let e = $3e4196989f8f13e7$export$a4161f418919b5aa.getSnapshot(), o = new Map;
    for (let [t] of e)o.set(t, t.documentElement.style.overflow);
    for (let t of e.values()){
        let n = o.get(t.doc) === "hidden", a = t.count !== 0;
        (a && !n || !a && n) && $3e4196989f8f13e7$export$a4161f418919b5aa.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && $3e4196989f8f13e7$export$a4161f418919b5aa.dispatch("TEARDOWN", t);
    }
});


function $f8eca989f1d6a5b2$export$bb0ae4a42bcd9e0(r, e, n = ()=>({
        containers: []
    })) {
    let f = (0, $9bd6ba82966948c8$export$6ccbb43953eebf8)((0, $3e4196989f8f13e7$export$a4161f418919b5aa)), o = e ? f.get(e) : void 0, i = o ? o.count > 0 : !1;
    return (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        if (!(!e || !r)) return (0, $3e4196989f8f13e7$export$a4161f418919b5aa).dispatch("PUSH", e, n), ()=>(0, $3e4196989f8f13e7$export$a4161f418919b5aa).dispatch("POP", e, n);
    }, [
        r,
        e
    ]), i;
}



function $df0eaf79c869102e$export$e47ba1b900da5d3b(e, c, n = ()=>[
        document.body
    ]) {
    let r = (0, $62a149d4d147ea69$export$5f5dd115998e0b80)(e, "scroll-lock");
    (0, $f8eca989f1d6a5b2$export$bb0ae4a42bcd9e0)(r, c, (t)=>{
        var o;
        return {
            containers: [
                ...(o = t.containers) != null ? o : [],
                n
            ]
        };
    });
}





var $6uYXW = parcelRequire("6uYXW");

let $814348a16548847f$var$a = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function $814348a16548847f$var$o(e) {
    var l, n;
    let i = (l = e.innerText) != null ? l : "", t = e.cloneNode(!0);
    if (!$36c2319598bace40$export$1b3bfaa9684536aa(t)) return i;
    let u = !1;
    for (let f of t.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))f.remove(), u = !0;
    let r = u ? (n = t.innerText) != null ? n : "" : i;
    return $814348a16548847f$var$a.test(r) && (r = r.replace($814348a16548847f$var$a, "")), r;
}
function $814348a16548847f$export$6ca03cb7b75bfa13(e) {
    let i = e.getAttribute("aria-label");
    if (typeof i == "string") return i.trim();
    let t = e.getAttribute("aria-labelledby");
    if (t) {
        let u = t.split(" ").map((r)=>{
            let l = document.getElementById(r);
            if (l) {
                let n = l.getAttribute("aria-label");
                return typeof n == "string" ? n.trim() : $814348a16548847f$var$o(l).trim();
            }
            return null;
        }).filter(Boolean);
        if (u.length > 0) return u.join(", ");
    }
    return $814348a16548847f$var$o(e).trim();
}



function $97d669c64d97dbf0$export$f6862afd851a1cf4(c) {
    let t = (0, $6uYXW.useRef)(""), r = (0, $6uYXW.useRef)("");
    return (0, $555339916ec7fe05$export$90fc3a17d93f704c)(()=>{
        let e = c.current;
        if (!e) return "";
        let u = e.innerText;
        if (t.current === u) return r.current;
        let n = (0, $814348a16548847f$export$6ca03cb7b75bfa13)(e).trim().toLowerCase();
        return t.current = u, r.current = n, n;
    });
}



var $6uYXW = parcelRequire("6uYXW");
function $2277b68d6ee21509$var$t(e) {
    return [
        e.screenX,
        e.screenY
    ];
}
function $2277b68d6ee21509$export$24ebee078bde85c3() {
    let e = (0, $6uYXW.useRef)([
        -1,
        -1
    ]);
    return {
        wasMoved (r) {
            let n = $2277b68d6ee21509$var$t(r);
            return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
        },
        update (r) {
            e.current = $2277b68d6ee21509$var$t(r);
        }
    };
}




var $6uYXW = parcelRequire("6uYXW");


function $398e4c5e66e6a1a3$export$b0abce39eb34b36(c, { container: e, accept: t, walk: r }) {
    let o = (0, $6uYXW.useRef)(t), l = (0, $6uYXW.useRef)(r);
    (0, $6uYXW.useEffect)(()=>{
        o.current = t, l.current = r;
    }, [
        t,
        r
    ]), (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        if (!e || !c) return;
        let n = (0, $d76c946db081c9ef$export$b204af158042fbac)(e);
        if (!n) return;
        let f = o.current, p = l.current, i = Object.assign((m)=>f(m), {
            acceptNode: f
        }), u = n.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, i, !1);
        for(; u.nextNode();)p(u.currentNode);
    }, [
        e,
        c,
        o,
        l
    ]);
}


/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $79146317861d6bce$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $79146317861d6bce$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $79146317861d6bce$export$803cd8101b6c182b = /*#__PURE__*/ $79146317861d6bce$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $79146317861d6bce$export$27b07d8a310ed8b5[0], side + "-" + $79146317861d6bce$export$27b07d8a310ed8b5[1]), []);
const $79146317861d6bce$export$96ec731ed4dcb222 = Math.min;
const $79146317861d6bce$export$8960430cfd85939f = Math.max;
const $79146317861d6bce$export$2077e0241d6afd3c = Math.round;
const $79146317861d6bce$export$a3fe094919f356fd = Math.floor;
const $79146317861d6bce$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $79146317861d6bce$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $79146317861d6bce$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $79146317861d6bce$export$7d15b64cf5a3a4c4(start, value, end) {
    return $79146317861d6bce$export$8960430cfd85939f(start, $79146317861d6bce$export$96ec731ed4dcb222(value, end));
}
function $79146317861d6bce$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $79146317861d6bce$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $79146317861d6bce$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $79146317861d6bce$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $79146317861d6bce$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
const $79146317861d6bce$var$yAxisSides = /*#__PURE__*/ new Set([
    'top',
    'bottom'
]);
function $79146317861d6bce$export$f28e8f882010718a(placement) {
    return $79146317861d6bce$var$yAxisSides.has($79146317861d6bce$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $79146317861d6bce$export$2b57e0052a6d6d4c(placement) {
    return $79146317861d6bce$export$8a000a963141ac32($79146317861d6bce$export$f28e8f882010718a(placement));
}
function $79146317861d6bce$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $79146317861d6bce$export$f0989780f32bfcda(placement);
    const alignmentAxis = $79146317861d6bce$export$2b57e0052a6d6d4c(placement);
    const length = $79146317861d6bce$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $79146317861d6bce$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $79146317861d6bce$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $79146317861d6bce$export$496432a3699e50b1(placement) {
    const oppositePlacement = $79146317861d6bce$export$9c5e28bad23365fa(placement);
    return [
        $79146317861d6bce$export$2b182c584985588b(placement),
        oppositePlacement,
        $79146317861d6bce$export$2b182c584985588b(oppositePlacement)
    ];
}
function $79146317861d6bce$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$79146317861d6bce$var$oppositeAlignmentMap[alignment]);
}
const $79146317861d6bce$var$lrPlacement = [
    'left',
    'right'
];
const $79146317861d6bce$var$rlPlacement = [
    'right',
    'left'
];
const $79146317861d6bce$var$tbPlacement = [
    'top',
    'bottom'
];
const $79146317861d6bce$var$btPlacement = [
    'bottom',
    'top'
];
function $79146317861d6bce$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $79146317861d6bce$var$rlPlacement : $79146317861d6bce$var$lrPlacement;
            return isStart ? $79146317861d6bce$var$lrPlacement : $79146317861d6bce$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $79146317861d6bce$var$tbPlacement : $79146317861d6bce$var$btPlacement;
        default:
            return [];
    }
}
function $79146317861d6bce$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $79146317861d6bce$export$f0989780f32bfcda(placement);
    let list = $79146317861d6bce$var$getSideList($79146317861d6bce$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($79146317861d6bce$export$2b182c584985588b));
    }
    return list;
}
function $79146317861d6bce$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$79146317861d6bce$var$oppositeSideMap[side]);
}
function $79146317861d6bce$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $79146317861d6bce$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $79146317861d6bce$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $79146317861d6bce$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $910de09cd4e818fd$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $79146317861d6bce$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $79146317861d6bce$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $79146317861d6bce$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $79146317861d6bce$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $79146317861d6bce$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $910de09cd4e818fd$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $910de09cd4e818fd$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $910de09cd4e818fd$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $910de09cd4e818fd$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $79146317861d6bce$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $79146317861d6bce$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $79146317861d6bce$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $79146317861d6bce$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $910de09cd4e818fd$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $79146317861d6bce$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $79146317861d6bce$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $79146317861d6bce$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $79146317861d6bce$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $79146317861d6bce$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $79146317861d6bce$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $79146317861d6bce$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $79146317861d6bce$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $910de09cd4e818fd$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $79146317861d6bce$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $79146317861d6bce$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $79146317861d6bce$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $79146317861d6bce$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $79146317861d6bce$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $910de09cd4e818fd$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $79146317861d6bce$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $79146317861d6bce$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $79146317861d6bce$export$803cd8101b6c182b) ? $910de09cd4e818fd$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $910de09cd4e818fd$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $79146317861d6bce$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $79146317861d6bce$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $79146317861d6bce$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $79146317861d6bce$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $910de09cd4e818fd$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $79146317861d6bce$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $79146317861d6bce$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $79146317861d6bce$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $79146317861d6bce$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $79146317861d6bce$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $79146317861d6bce$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $79146317861d6bce$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $910de09cd4e818fd$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $79146317861d6bce$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $79146317861d6bce$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $79146317861d6bce$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $79146317861d6bce$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $910de09cd4e818fd$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $910de09cd4e818fd$var$isAnySideFullyClipped(overflow) {
    return (0, $79146317861d6bce$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $910de09cd4e818fd$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $79146317861d6bce$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $910de09cd4e818fd$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $910de09cd4e818fd$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $910de09cd4e818fd$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $910de09cd4e818fd$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $910de09cd4e818fd$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $910de09cd4e818fd$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $910de09cd4e818fd$var$getBoundingRect(rects) {
    const minX = (0, $79146317861d6bce$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $79146317861d6bce$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $79146317861d6bce$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $79146317861d6bce$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $910de09cd4e818fd$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $79146317861d6bce$export$ee05aea0aeecbad4)($910de09cd4e818fd$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $910de09cd4e818fd$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $79146317861d6bce$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $910de09cd4e818fd$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $79146317861d6bce$export$ee05aea0aeecbad4)($910de09cd4e818fd$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $79146317861d6bce$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $79146317861d6bce$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $79146317861d6bce$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $79146317861d6bce$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $79146317861d6bce$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $79146317861d6bce$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $910de09cd4e818fd$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $910de09cd4e818fd$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $79146317861d6bce$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $79146317861d6bce$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $79146317861d6bce$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $910de09cd4e818fd$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $79146317861d6bce$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $910de09cd4e818fd$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $910de09cd4e818fd$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $910de09cd4e818fd$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $79146317861d6bce$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $910de09cd4e818fd$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $79146317861d6bce$export$f28e8f882010718a)((0, $79146317861d6bce$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $79146317861d6bce$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $79146317861d6bce$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $79146317861d6bce$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $910de09cd4e818fd$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $79146317861d6bce$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $79146317861d6bce$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $79146317861d6bce$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $79146317861d6bce$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $910de09cd4e818fd$var$originSides.has((0, $79146317861d6bce$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $910de09cd4e818fd$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $79146317861d6bce$export$fef61f332f2c0afc)(options, state);
            const overflow = await $910de09cd4e818fd$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $79146317861d6bce$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $79146317861d6bce$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $79146317861d6bce$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $79146317861d6bce$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $79146317861d6bce$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $79146317861d6bce$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $79146317861d6bce$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $79146317861d6bce$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $79146317861d6bce$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $79146317861d6bce$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $79146317861d6bce$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $9bc7004828788a5e$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $9bc7004828788a5e$export$651544f548703224(node) {
    if ($9bc7004828788a5e$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $9bc7004828788a5e$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $9bc7004828788a5e$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($9bc7004828788a5e$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $9bc7004828788a5e$export$8ee0fc9ee280b4ee(value) {
    if (!$9bc7004828788a5e$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $9bc7004828788a5e$export$38b2d434cce3ea22(value).Node;
}
function $9bc7004828788a5e$export$45a5e7f76e0caa8d(value) {
    if (!$9bc7004828788a5e$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $9bc7004828788a5e$export$38b2d434cce3ea22(value).Element;
}
function $9bc7004828788a5e$export$1b3bfaa9684536aa(value) {
    if (!$9bc7004828788a5e$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $9bc7004828788a5e$export$38b2d434cce3ea22(value).HTMLElement;
}
function $9bc7004828788a5e$export$af51f0f06c0f328a(value) {
    if (!$9bc7004828788a5e$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $9bc7004828788a5e$export$38b2d434cce3ea22(value).ShadowRoot;
}
const $9bc7004828788a5e$var$invalidOverflowDisplayValues = /*#__PURE__*/ new Set([
    'inline',
    'contents'
]);
function $9bc7004828788a5e$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $9bc7004828788a5e$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !$9bc7004828788a5e$var$invalidOverflowDisplayValues.has(display);
}
const $9bc7004828788a5e$var$tableElements = /*#__PURE__*/ new Set([
    'table',
    'td',
    'th'
]);
function $9bc7004828788a5e$export$71535ffaa902797f(element) {
    return $9bc7004828788a5e$var$tableElements.has($9bc7004828788a5e$export$651544f548703224(element));
}
const $9bc7004828788a5e$var$topLayerSelectors = [
    ':popover-open',
    ':modal'
];
function $9bc7004828788a5e$export$89e651af02346cd4(element) {
    return $9bc7004828788a5e$var$topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (_e) {
            return false;
        }
    });
}
const $9bc7004828788a5e$var$transformProperties = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective'
];
const $9bc7004828788a5e$var$willChangeValues = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective',
    'filter'
];
const $9bc7004828788a5e$var$containValues = [
    'paint',
    'layout',
    'strict',
    'content'
];
function $9bc7004828788a5e$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $9bc7004828788a5e$export$78551043582a6a98();
    const css = $9bc7004828788a5e$export$45a5e7f76e0caa8d(elementOrCss) ? $9bc7004828788a5e$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $9bc7004828788a5e$var$transformProperties.some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || $9bc7004828788a5e$var$willChangeValues.some((value)=>(css.willChange || '').includes(value)) || $9bc7004828788a5e$var$containValues.some((value)=>(css.contain || '').includes(value));
}
function $9bc7004828788a5e$export$940d8225183e1404(element) {
    let currentNode = $9bc7004828788a5e$export$4e12058fc4d51d56(element);
    while($9bc7004828788a5e$export$1b3bfaa9684536aa(currentNode) && !$9bc7004828788a5e$export$d1162fb0b6d4cd51(currentNode)){
        if ($9bc7004828788a5e$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($9bc7004828788a5e$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $9bc7004828788a5e$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $9bc7004828788a5e$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
const $9bc7004828788a5e$var$lastTraversableNodeNames = /*#__PURE__*/ new Set([
    'html',
    'body',
    '#document'
]);
function $9bc7004828788a5e$export$d1162fb0b6d4cd51(node) {
    return $9bc7004828788a5e$var$lastTraversableNodeNames.has($9bc7004828788a5e$export$651544f548703224(node));
}
function $9bc7004828788a5e$export$3735103072e4a80(element) {
    return $9bc7004828788a5e$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $9bc7004828788a5e$export$dc8fc79fa2800137(element) {
    if ($9bc7004828788a5e$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $9bc7004828788a5e$export$4e12058fc4d51d56(node) {
    if ($9bc7004828788a5e$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $9bc7004828788a5e$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $9bc7004828788a5e$export$e495491855dc5418(node);
    return $9bc7004828788a5e$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $9bc7004828788a5e$export$7cd01a57c8ca906c(node) {
    const parentNode = $9bc7004828788a5e$export$4e12058fc4d51d56(node);
    if ($9bc7004828788a5e$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($9bc7004828788a5e$export$1b3bfaa9684536aa(parentNode) && $9bc7004828788a5e$export$989e911fa9af580a(parentNode)) return parentNode;
    return $9bc7004828788a5e$export$7cd01a57c8ca906c(parentNode);
}
function $9bc7004828788a5e$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $9bc7004828788a5e$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $9bc7004828788a5e$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $9bc7004828788a5e$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $9bc7004828788a5e$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $9bc7004828788a5e$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $9bc7004828788a5e$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $9bc7004828788a5e$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $aa34d2df375b4645$var$getCssDimensions(element) {
    const css = (0, $9bc7004828788a5e$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $79146317861d6bce$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $79146317861d6bce$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $aa34d2df375b4645$var$unwrapElement(element) {
    return !(0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $aa34d2df375b4645$var$getScale(element) {
    const domElement = $aa34d2df375b4645$var$unwrapElement(element);
    if (!(0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(domElement)) return (0, $79146317861d6bce$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $aa34d2df375b4645$var$getCssDimensions(domElement);
    let x = ($ ? (0, $79146317861d6bce$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $79146317861d6bce$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $aa34d2df375b4645$var$noOffsets = /*#__PURE__*/ (0, $79146317861d6bce$export$a397704b5e280835)(0);
function $aa34d2df375b4645$var$getVisualOffsets(element) {
    const win = (0, $9bc7004828788a5e$export$38b2d434cce3ea22)(element);
    if (!(0, $9bc7004828788a5e$export$78551043582a6a98)() || !win.visualViewport) return $aa34d2df375b4645$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $aa34d2df375b4645$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $9bc7004828788a5e$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $aa34d2df375b4645$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $aa34d2df375b4645$var$unwrapElement(element);
    let scale = (0, $79146317861d6bce$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(offsetParent)) scale = $aa34d2df375b4645$var$getScale(offsetParent);
        } else scale = $aa34d2df375b4645$var$getScale(element);
    }
    const visualOffsets = $aa34d2df375b4645$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $aa34d2df375b4645$var$getVisualOffsets(domElement) : (0, $79146317861d6bce$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $9bc7004828788a5e$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $9bc7004828788a5e$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $9bc7004828788a5e$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $aa34d2df375b4645$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $9bc7004828788a5e$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $9bc7004828788a5e$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $9bc7004828788a5e$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $79146317861d6bce$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $aa34d2df375b4645$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $9bc7004828788a5e$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $aa34d2df375b4645$var$getBoundingClientRect((0, $9bc7004828788a5e$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $aa34d2df375b4645$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $aa34d2df375b4645$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $aa34d2df375b4645$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $9bc7004828788a5e$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $9bc7004828788a5e$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $79146317861d6bce$export$a397704b5e280835)(1);
    const offsets = (0, $79146317861d6bce$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $9bc7004828788a5e$export$651544f548703224)(offsetParent) !== 'body' || (0, $9bc7004828788a5e$export$989e911fa9af580a)(documentElement)) scroll = (0, $9bc7004828788a5e$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $aa34d2df375b4645$var$getBoundingClientRect(offsetParent);
            scale = $aa34d2df375b4645$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $aa34d2df375b4645$var$getHTMLOffset(documentElement, scroll) : (0, $79146317861d6bce$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $aa34d2df375b4645$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $aa34d2df375b4645$var$getDocumentRect(element) {
    const html = (0, $9bc7004828788a5e$export$e495491855dc5418)(element);
    const scroll = (0, $9bc7004828788a5e$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $79146317861d6bce$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $79146317861d6bce$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $aa34d2df375b4645$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $9bc7004828788a5e$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $79146317861d6bce$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $aa34d2df375b4645$var$SCROLLBAR_MAX = 25;
function $aa34d2df375b4645$var$getViewportRect(element, strategy) {
    const win = (0, $9bc7004828788a5e$export$38b2d434cce3ea22)(element);
    const html = (0, $9bc7004828788a5e$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $9bc7004828788a5e$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $aa34d2df375b4645$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $aa34d2df375b4645$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $aa34d2df375b4645$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
const $aa34d2df375b4645$var$absoluteOrFixed = /*#__PURE__*/ new Set([
    'absolute',
    'fixed'
]);
// Returns the inner client rect, subtracting scrollbars if present.
function $aa34d2df375b4645$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $aa34d2df375b4645$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(element) ? $aa34d2df375b4645$var$getScale(element) : (0, $79146317861d6bce$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $aa34d2df375b4645$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $aa34d2df375b4645$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $aa34d2df375b4645$var$getDocumentRect((0, $9bc7004828788a5e$export$e495491855dc5418)(element));
    else if ((0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $aa34d2df375b4645$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $aa34d2df375b4645$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $79146317861d6bce$export$ee05aea0aeecbad4)(rect);
}
function $aa34d2df375b4645$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $9bc7004828788a5e$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(parentNode) || (0, $9bc7004828788a5e$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $9bc7004828788a5e$export$3735103072e4a80)(parentNode).position === 'fixed' || $aa34d2df375b4645$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $aa34d2df375b4645$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $9bc7004828788a5e$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(el) && (0, $9bc7004828788a5e$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $9bc7004828788a5e$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $9bc7004828788a5e$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(currentNode) && !(0, $9bc7004828788a5e$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $9bc7004828788a5e$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $9bc7004828788a5e$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && $aa34d2df375b4645$var$absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || (0, $9bc7004828788a5e$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $aa34d2df375b4645$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $9bc7004828788a5e$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $aa34d2df375b4645$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $9bc7004828788a5e$export$89e651af02346cd4)(element) ? [] : $aa34d2df375b4645$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $aa34d2df375b4645$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $79146317861d6bce$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $79146317861d6bce$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $79146317861d6bce$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $79146317861d6bce$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $aa34d2df375b4645$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $aa34d2df375b4645$var$getDimensions(element) {
    const { width: width, height: height } = $aa34d2df375b4645$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $aa34d2df375b4645$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $9bc7004828788a5e$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $aa34d2df375b4645$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $79146317861d6bce$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $aa34d2df375b4645$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $9bc7004828788a5e$export$651544f548703224)(offsetParent) !== 'body' || (0, $9bc7004828788a5e$export$989e911fa9af580a)(documentElement)) scroll = (0, $9bc7004828788a5e$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $aa34d2df375b4645$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $aa34d2df375b4645$var$getHTMLOffset(documentElement, scroll) : (0, $79146317861d6bce$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $aa34d2df375b4645$var$isStaticPositioned(element) {
    return (0, $9bc7004828788a5e$export$3735103072e4a80)(element).position === 'static';
}
function $aa34d2df375b4645$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(element) || (0, $9bc7004828788a5e$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $9bc7004828788a5e$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $aa34d2df375b4645$var$getOffsetParent(element, polyfill) {
    const win = (0, $9bc7004828788a5e$export$38b2d434cce3ea22)(element);
    if ((0, $9bc7004828788a5e$export$89e651af02346cd4)(element)) return win;
    if (!(0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $9bc7004828788a5e$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $9bc7004828788a5e$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$aa34d2df375b4645$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $9bc7004828788a5e$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $aa34d2df375b4645$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $9bc7004828788a5e$export$71535ffaa902797f)(offsetParent) && $aa34d2df375b4645$var$isStaticPositioned(offsetParent))offsetParent = $aa34d2df375b4645$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $9bc7004828788a5e$export$d1162fb0b6d4cd51)(offsetParent) && $aa34d2df375b4645$var$isStaticPositioned(offsetParent) && !(0, $9bc7004828788a5e$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $9bc7004828788a5e$export$940d8225183e1404)(element) || win;
}
const $aa34d2df375b4645$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $aa34d2df375b4645$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $aa34d2df375b4645$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $aa34d2df375b4645$var$isRTL(element) {
    return (0, $9bc7004828788a5e$export$3735103072e4a80)(element).direction === 'rtl';
}
const $aa34d2df375b4645$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $aa34d2df375b4645$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $9bc7004828788a5e$export$e495491855dc5418,
    getClippingRect: $aa34d2df375b4645$var$getClippingRect,
    getOffsetParent: $aa34d2df375b4645$var$getOffsetParent,
    getElementRects: $aa34d2df375b4645$var$getElementRects,
    getClientRects: $aa34d2df375b4645$var$getClientRects,
    getDimensions: $aa34d2df375b4645$var$getDimensions,
    getScale: $aa34d2df375b4645$var$getScale,
    isElement: $9bc7004828788a5e$export$45a5e7f76e0caa8d,
    isRTL: $aa34d2df375b4645$var$isRTL
};
function $aa34d2df375b4645$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $aa34d2df375b4645$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $9bc7004828788a5e$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $79146317861d6bce$export$a3fe094919f356fd)(top);
        const insetRight = (0, $79146317861d6bce$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $79146317861d6bce$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $79146317861d6bce$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $79146317861d6bce$export$8960430cfd85939f)(0, (0, $79146317861d6bce$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$aa34d2df375b4645$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $aa34d2df375b4645$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $aa34d2df375b4645$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $9bc7004828788a5e$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $9bc7004828788a5e$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $aa34d2df375b4645$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $aa34d2df375b4645$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $aa34d2df375b4645$var$getBoundingClientRect(reference);
        if (prevRefRect && !$aa34d2df375b4645$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $aa34d2df375b4645$export$37b6bde19b108ecc = (0, $910de09cd4e818fd$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $aa34d2df375b4645$export$cc800923e997bb8 = (0, $910de09cd4e818fd$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $aa34d2df375b4645$export$91fb6ecbd551914 = (0, $910de09cd4e818fd$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $aa34d2df375b4645$export$fba63a578e423eb = (0, $910de09cd4e818fd$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $aa34d2df375b4645$export$8a83211c878a3f1f = (0, $910de09cd4e818fd$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $aa34d2df375b4645$export$346677f925de839c = (0, $910de09cd4e818fd$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $aa34d2df375b4645$export$fe8985bb6374093c = (0, $910de09cd4e818fd$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $aa34d2df375b4645$export$f2120bbfa5450bd2 = (0, $910de09cd4e818fd$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $aa34d2df375b4645$export$18c8ad048e32c7d5 = (0, $910de09cd4e818fd$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $aa34d2df375b4645$export$7bf07e38f3dc4b69 = (0, $910de09cd4e818fd$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $aa34d2df375b4645$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $aa34d2df375b4645$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $910de09cd4e818fd$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $6uYXW = parcelRequire("6uYXW");

var $9276ab85670b57fb$var$isClient = typeof document !== 'undefined';
var $9276ab85670b57fb$var$noop = function noop() {};
var $9276ab85670b57fb$var$index = $9276ab85670b57fb$var$isClient ? (0, $6uYXW.useLayoutEffect) : $9276ab85670b57fb$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $9276ab85670b57fb$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$9276ab85670b57fb$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$9276ab85670b57fb$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $9276ab85670b57fb$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $9276ab85670b57fb$var$roundByDPR(element, value) {
    const dpr = $9276ab85670b57fb$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $9276ab85670b57fb$var$useLatestRef(value) {
    const ref = $6uYXW.useRef(value);
    $9276ab85670b57fb$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $9276ab85670b57fb$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $6uYXW.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $6uYXW.useState(middleware);
    if (!$9276ab85670b57fb$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $6uYXW.useState(null);
    const [_floating, _setFloating] = $6uYXW.useState(null);
    const setReference = $6uYXW.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $6uYXW.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $6uYXW.useRef(null);
    const floatingRef = $6uYXW.useRef(null);
    const dataRef = $6uYXW.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $9276ab85670b57fb$var$useLatestRef(whileElementsMounted);
    const platformRef = $9276ab85670b57fb$var$useLatestRef(platform);
    const openRef = $9276ab85670b57fb$var$useLatestRef(open);
    const update = $6uYXW.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $aa34d2df375b4645$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$9276ab85670b57fb$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $4e60b4008b7e4540$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $9276ab85670b57fb$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $6uYXW.useRef(false);
    $9276ab85670b57fb$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $9276ab85670b57fb$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $6uYXW.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $6uYXW.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $6uYXW.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $9276ab85670b57fb$var$roundByDPR(elements.floating, data.x);
        const y = $9276ab85670b57fb$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$9276ab85670b57fb$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $6uYXW.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9276ab85670b57fb$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $aa34d2df375b4645$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $aa34d2df375b4645$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9276ab85670b57fb$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $aa34d2df375b4645$export$cc800923e997bb8)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9276ab85670b57fb$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $aa34d2df375b4645$export$fba63a578e423eb)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9276ab85670b57fb$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $aa34d2df375b4645$export$7bf07e38f3dc4b69)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9276ab85670b57fb$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $aa34d2df375b4645$export$8a83211c878a3f1f)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9276ab85670b57fb$export$346677f925de839c = (options, deps)=>({
        ...(0, $aa34d2df375b4645$export$346677f925de839c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9276ab85670b57fb$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $aa34d2df375b4645$export$91fb6ecbd551914)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9276ab85670b57fb$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $aa34d2df375b4645$export$fe8985bb6374093c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9276ab85670b57fb$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $aa34d2df375b4645$export$18c8ad048e32c7d5)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9276ab85670b57fb$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$9276ab85670b57fb$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });


var $6uYXW = parcelRequire("6uYXW");

function $055af5d835501cff$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $055af5d835501cff$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $9bc7004828788a5e$export$af51f0f06c0f328a)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function $055af5d835501cff$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $055af5d835501cff$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $055af5d835501cff$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($055af5d835501cff$export$a11b0059900ceec8() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $055af5d835501cff$export$29bf1b5f2c56cf63(event) {
    if ($055af5d835501cff$export$c8f880a2d81914c4()) return false;
    return !$055af5d835501cff$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $055af5d835501cff$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $055af5d835501cff$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $055af5d835501cff$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($055af5d835501cff$export$867a782338812cb4()) || re.test($055af5d835501cff$export$7935961ef7719cb0());
}
function $055af5d835501cff$export$9ac100e40613ea10() {
    return $055af5d835501cff$export$867a782338812cb4().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $055af5d835501cff$export$c8f880a2d81914c4() {
    return $055af5d835501cff$export$7935961ef7719cb0().includes('jsdom/');
}
function $055af5d835501cff$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
function $055af5d835501cff$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
function $055af5d835501cff$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $055af5d835501cff$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $055af5d835501cff$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $055af5d835501cff$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $055af5d835501cff$export$78b3d091ff376bc = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $055af5d835501cff$export$42ad131c32f0fb8d(element) {
    return (0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(element) && element.matches($055af5d835501cff$export$78b3d091ff376bc);
}
function $055af5d835501cff$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $055af5d835501cff$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $055af5d835501cff$export$42ad131c32f0fb8d(element);
}




/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $5d46657807318796$var$candidateSelectors = [
    'input:not([inert])',
    'select:not([inert])',
    'textarea:not([inert])',
    'a[href]:not([inert])',
    'button:not([inert])',
    '[tabindex]:not(slot):not([inert])',
    'audio[controls]:not([inert])',
    'video[controls]:not([inert])',
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    'details>summary:first-of-type:not([inert])',
    'details:not([inert])'
];
var $5d46657807318796$var$candidateSelector = /* #__PURE__ */ $5d46657807318796$var$candidateSelectors.join(',');
var $5d46657807318796$var$NoElement = typeof Element === 'undefined';
var $5d46657807318796$var$matches = $5d46657807318796$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $5d46657807318796$var$getRootNode = !$5d46657807318796$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $5d46657807318796$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $5d46657807318796$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $5d46657807318796$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($5d46657807318796$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($5d46657807318796$var$candidateSelector));
    if (includeContainer && $5d46657807318796$var$matches.call(el, $5d46657807318796$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $5d46657807318796$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($5d46657807318796$var$isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $5d46657807318796$var$matches.call(element, $5d46657807318796$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$5d46657807318796$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $5d46657807318796$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $5d46657807318796$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $5d46657807318796$var$isContentEditable(node)) && !$5d46657807318796$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $5d46657807318796$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $5d46657807318796$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$5d46657807318796$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $5d46657807318796$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $5d46657807318796$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $5d46657807318796$var$isHiddenInput = function isHiddenInput(node) {
    return $5d46657807318796$var$isInput(node) && node.type === 'hidden';
};
var $5d46657807318796$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $5d46657807318796$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $5d46657807318796$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $5d46657807318796$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $5d46657807318796$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $5d46657807318796$var$isRadio = function isRadio(node) {
    return $5d46657807318796$var$isInput(node) && node.type === 'radio';
};
var $5d46657807318796$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $5d46657807318796$var$isRadio(node) && !$5d46657807318796$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $5d46657807318796$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $5d46657807318796$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $5d46657807318796$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $5d46657807318796$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $5d46657807318796$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') return true;
    var isDirectSummary = $5d46657807318796$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($5d46657807318796$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $5d46657807318796$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $5d46657807318796$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($5d46657807318796$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $5d46657807318796$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $5d46657807318796$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $5d46657807318796$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $5d46657807318796$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $5d46657807318796$var$isInert(node) || $5d46657807318796$var$isHiddenInput(node) || $5d46657807318796$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $5d46657807318796$var$isDetailsWithSummary(node) || $5d46657807318796$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $5d46657807318796$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($5d46657807318796$var$isNonTabbableRadio(node) || $5d46657807318796$export$a4672efddb4181b8(node) < 0 || !$5d46657807318796$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $5d46657807318796$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $5d46657807318796$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $5d46657807318796$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($5d46657807318796$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $5d46657807318796$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $5d46657807318796$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $5d46657807318796$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $5d46657807318796$var$isValidShadowRootTabbable
    });
    else candidates = $5d46657807318796$var$getCandidates(container, options.includeContainer, $5d46657807318796$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $5d46657807318796$var$sortByOrder(candidates);
};
var $5d46657807318796$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $5d46657807318796$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $5d46657807318796$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $5d46657807318796$var$getCandidates(container, options.includeContainer, $5d46657807318796$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $5d46657807318796$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($5d46657807318796$var$matches.call(node, $5d46657807318796$var$candidateSelector) === false) return false;
    return $5d46657807318796$var$isNodeMatchingSelectorTabbable(options, node);
};
var $5d46657807318796$var$focusableCandidateSelector = /* #__PURE__ */ $5d46657807318796$var$candidateSelectors.concat('iframe').join(',');
var $5d46657807318796$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($5d46657807318796$var$matches.call(node, $5d46657807318796$var$focusableCandidateSelector) === false) return false;
    return $5d46657807318796$var$isNodeMatchingSelectorFocusable(options, node);
};




/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $3ace4598bf8a59b0$export$74665b213cb5c4cf(refs) {
    return $6uYXW.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $3ace4598bf8a59b0$var$SafeReact = {
    ...$6uYXW
};
const $3ace4598bf8a59b0$var$useInsertionEffect = $3ace4598bf8a59b0$var$SafeReact.useInsertionEffect;
const $3ace4598bf8a59b0$var$useSafeInsertionEffect = $3ace4598bf8a59b0$var$useInsertionEffect || ((fn)=>fn());
function $3ace4598bf8a59b0$var$useEffectEvent(callback) {
    const ref = $6uYXW.useRef(()=>{});
    $3ace4598bf8a59b0$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $6uYXW.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
const $3ace4598bf8a59b0$var$ARROW_UP = 'ArrowUp';
const $3ace4598bf8a59b0$var$ARROW_DOWN = 'ArrowDown';
const $3ace4598bf8a59b0$var$ARROW_LEFT = 'ArrowLeft';
const $3ace4598bf8a59b0$var$ARROW_RIGHT = 'ArrowRight';
function $3ace4598bf8a59b0$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $3ace4598bf8a59b0$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $3ace4598bf8a59b0$var$getMinIndex(listRef, disabledIndices) {
    return $3ace4598bf8a59b0$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $3ace4598bf8a59b0$var$getMaxIndex(listRef, disabledIndices) {
    return $3ace4598bf8a59b0$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $3ace4598bf8a59b0$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && $3ace4598bf8a59b0$var$isDisabled(list, index, disabledIndices));
    return index;
}
function $3ace4598bf8a59b0$var$getGridNavigatedIndex(elementsRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, rtl: rtl, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $3ace4598bf8a59b0$var$ARROW_UP) {
        stop && (0, $055af5d835501cff$export$7ae4cd3a66c1e050)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $3ace4598bf8a59b0$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($3ace4598bf8a59b0$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $3ace4598bf8a59b0$var$ARROW_DOWN) {
        stop && (0, $055af5d835501cff$export$7ae4cd3a66c1e050)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $3ace4598bf8a59b0$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $3ace4598bf8a59b0$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($3ace4598bf8a59b0$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, $79146317861d6bce$export$a3fe094919f356fd)(prevIndex / cols);
        if (event.key === (rtl ? $3ace4598bf8a59b0$var$ARROW_LEFT : $3ace4598bf8a59b0$var$ARROW_RIGHT)) {
            stop && (0, $055af5d835501cff$export$7ae4cd3a66c1e050)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $3ace4598bf8a59b0$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $3ace4598bf8a59b0$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $3ace4598bf8a59b0$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $3ace4598bf8a59b0$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($3ace4598bf8a59b0$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? $3ace4598bf8a59b0$var$ARROW_RIGHT : $3ace4598bf8a59b0$var$ARROW_LEFT)) {
            stop && (0, $055af5d835501cff$export$7ae4cd3a66c1e050)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $3ace4598bf8a59b0$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $3ace4598bf8a59b0$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $3ace4598bf8a59b0$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $3ace4598bf8a59b0$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($3ace4598bf8a59b0$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $79146317861d6bce$export$a3fe094919f356fd)(maxIndex / cols) === prevRow;
        if ($3ace4598bf8a59b0$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? $3ace4598bf8a59b0$var$ARROW_RIGHT : $3ace4598bf8a59b0$var$ARROW_LEFT) ? maxIndex : $3ace4598bf8a59b0$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $3ace4598bf8a59b0$var$buildCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $3ace4598bf8a59b0$var$getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $3ace4598bf8a59b0$var$getCellIndices(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $3ace4598bf8a59b0$var$isDisabled(list, index, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index);
    const element = list[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
var $3ace4598bf8a59b0$var$index = typeof document !== 'undefined' ? (0, $6uYXW.useLayoutEffect) : (0, $6uYXW.useEffect);
function $3ace4598bf8a59b0$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $3ace4598bf8a59b0$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $3ace4598bf8a59b0$var$FloatingListContext = /*#__PURE__*/ $6uYXW.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $3ace4598bf8a59b0$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [map, setMap] = $6uYXW.useState(()=>new Map());
    const register = $6uYXW.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $6uYXW.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $3ace4598bf8a59b0$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($3ace4598bf8a59b0$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$3ace4598bf8a59b0$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ $6uYXW.createElement($3ace4598bf8a59b0$var$FloatingListContext.Provider, {
        value: $6uYXW.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $3ace4598bf8a59b0$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $6uYXW.useContext($3ace4598bf8a59b0$var$FloatingListContext);
    const [index$1, setIndex] = $6uYXW.useState(null);
    const componentRef = $6uYXW.useRef(null);
    const ref = $6uYXW.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $3ace4598bf8a59b0$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $3ace4598bf8a59b0$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $6uYXW.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
function $3ace4598bf8a59b0$var$renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ $6uYXW.cloneElement(render, computedProps);
    return /*#__PURE__*/ $6uYXW.createElement("div", computedProps);
}
const $3ace4598bf8a59b0$var$CompositeContext = /*#__PURE__*/ $6uYXW.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $3ace4598bf8a59b0$var$horizontalKeys = [
    $3ace4598bf8a59b0$var$ARROW_LEFT,
    $3ace4598bf8a59b0$var$ARROW_RIGHT
];
const $3ace4598bf8a59b0$var$verticalKeys = [
    $3ace4598bf8a59b0$var$ARROW_UP,
    $3ace4598bf8a59b0$var$ARROW_DOWN
];
const $3ace4598bf8a59b0$var$allKeys = [
    ...$3ace4598bf8a59b0$var$horizontalKeys,
    ...$3ace4598bf8a59b0$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $3ace4598bf8a59b0$export$43586241d9db0c6d = /*#__PURE__*/ $6uYXW.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = 'both', loop: loop = true, rtl: rtl = false, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $6uYXW.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = $3ace4598bf8a59b0$var$useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $6uYXW.useRef([]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const contextValue = $6uYXW.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$3ace4598bf8a59b0$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = $3ace4598bf8a59b0$var$getMinIndex(elementsRef, disabledIndices);
        const maxIndex = $3ace4598bf8a59b0$var$getMaxIndex(elementsRef, disabledIndices);
        const horizontalEndKey = rtl ? $3ace4598bf8a59b0$var$ARROW_LEFT : $3ace4598bf8a59b0$var$ARROW_RIGHT;
        const horizontalStartKey = rtl ? $3ace4598bf8a59b0$var$ARROW_RIGHT : $3ace4598bf8a59b0$var$ARROW_LEFT;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $3ace4598bf8a59b0$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$3ace4598bf8a59b0$var$isDisabled(elementsRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$3ace4598bf8a59b0$var$isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[$3ace4598bf8a59b0$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $3ace4598bf8a59b0$var$getCellIndices([
                    ...disabledIndices || elementsRef.current.map((_, index)=>$3ace4598bf8a59b0$var$isDisabled(elementsRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $3ace4598bf8a59b0$var$getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $3ace4598bf8a59b0$var$ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                $3ace4598bf8a59b0$var$ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                $3ace4598bf8a59b0$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                $3ace4598bf8a59b0$var$ARROW_UP
            ],
            both: [
                horizontalStartKey,
                $3ace4598bf8a59b0$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $3ace4598bf8a59b0$var$allKeys : ({
            horizontal: $3ace4598bf8a59b0$var$horizontalKeys,
            vertical: $3ace4598bf8a59b0$var$verticalKeys,
            both: $3ace4598bf8a59b0$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = $3ace4598bf8a59b0$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !$3ace4598bf8a59b0$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ $6uYXW.createElement($3ace4598bf8a59b0$var$CompositeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $6uYXW.createElement($3ace4598bf8a59b0$export$ffe15b0e64951704, {
        elementsRef: elementsRef
    }, $3ace4598bf8a59b0$var$renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $3ace4598bf8a59b0$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $6uYXW.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $6uYXW.useContext($3ace4598bf8a59b0$var$CompositeContext);
    const { ref: ref, index: index } = $3ace4598bf8a59b0$export$dcdc7ff5149f7d1a();
    const mergedRef = $3ace4598bf8a59b0$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $3ace4598bf8a59b0$var$renderJsx(render, computedProps);
});
function $3ace4598bf8a59b0$var$_extends() {
    $3ace4598bf8a59b0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3ace4598bf8a59b0$var$_extends.apply(this, arguments);
}
let $3ace4598bf8a59b0$var$serverHandoffComplete = false;
let $3ace4598bf8a59b0$var$count = 0;
const $3ace4598bf8a59b0$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $3ace4598bf8a59b0$var$count++;
function $3ace4598bf8a59b0$var$useFloatingId() {
    const [id, setId] = $6uYXW.useState(()=>$3ace4598bf8a59b0$var$serverHandoffComplete ? $3ace4598bf8a59b0$var$genId() : undefined);
    $3ace4598bf8a59b0$var$index(()=>{
        if (id == null) setId($3ace4598bf8a59b0$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $6uYXW.useEffect(()=>{
        $3ace4598bf8a59b0$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $3ace4598bf8a59b0$var$useReactId = $3ace4598bf8a59b0$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $3ace4598bf8a59b0$export$f680877a34711e37 = $3ace4598bf8a59b0$var$useReactId || $3ace4598bf8a59b0$var$useFloatingId;
let $3ace4598bf8a59b0$var$devMessageSet;
function $3ace4598bf8a59b0$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = $3ace4598bf8a59b0$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $3ace4598bf8a59b0$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $3ace4598bf8a59b0$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = $3ace4598bf8a59b0$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $3ace4598bf8a59b0$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $3ace4598bf8a59b0$export$33511391554732bc = /*#__PURE__*/ $6uYXW.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $3ace4598bf8a59b0$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $6uYXW.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    $3ace4598bf8a59b0$var$index(()=>{
        if (!floating) return;
        const isRTL = (0, $9bc7004828788a5e$export$3735103072e4a80)(floating).direction === 'rtl';
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split('-');
    const isVerticalSide = side === 'top' || side === 'bottom';
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
    let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
    const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    const rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    return /*#__PURE__*/ $6uYXW.createElement("svg", $3ace4598bf8a59b0$var$_extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(' '),
            ...restStyle
        }
    }), computedStrokeWidth > 0 && /*#__PURE__*/ $6uYXW.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: computedStrokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ $6uYXW.createElement("path", {
        stroke: computedStrokeWidth && !d ? rest.fill : 'none',
        d: dValue
    }), /*#__PURE__*/ $6uYXW.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $6uYXW.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
    })));
});
function $3ace4598bf8a59b0$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $3ace4598bf8a59b0$var$FloatingNodeContext = /*#__PURE__*/ $6uYXW.createContext(null);
const $3ace4598bf8a59b0$var$FloatingTreeContext = /*#__PURE__*/ $6uYXW.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $3ace4598bf8a59b0$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $6uYXW.useContext($3ace4598bf8a59b0$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $3ace4598bf8a59b0$export$db0c2a7c7a2a4f69 = ()=>$6uYXW.useContext($3ace4598bf8a59b0$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $3ace4598bf8a59b0$export$9b136e0e758a42f4(customParentId) {
    const id = $3ace4598bf8a59b0$export$f680877a34711e37();
    const tree = $3ace4598bf8a59b0$export$db0c2a7c7a2a4f69();
    const reactParentId = $3ace4598bf8a59b0$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $3ace4598bf8a59b0$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $3ace4598bf8a59b0$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $3ace4598bf8a59b0$export$165209eae06d3488();
    return /*#__PURE__*/ $6uYXW.createElement($3ace4598bf8a59b0$var$FloatingNodeContext.Provider, {
        value: $6uYXW.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $3ace4598bf8a59b0$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $6uYXW.useRef([]);
    const addNode = $6uYXW.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $6uYXW.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $6uYXW.useState(()=>$3ace4598bf8a59b0$var$createPubSub())[0];
    return /*#__PURE__*/ $6uYXW.createElement($3ace4598bf8a59b0$var$FloatingTreeContext.Provider, {
        value: $6uYXW.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function $3ace4598bf8a59b0$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $3ace4598bf8a59b0$var$useLatestRef(value) {
    const ref = (0, $6uYXW.useRef)(value);
    $3ace4598bf8a59b0$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $3ace4598bf8a59b0$var$safePolygonIdentifier = /*#__PURE__*/ $3ace4598bf8a59b0$var$createAttribute('safe-polygon');
function $3ace4598bf8a59b0$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $055af5d835501cff$export$81cf264172d31e51)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $3ace4598bf8a59b0$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $3ace4598bf8a59b0$export$db0c2a7c7a2a4f69();
    const parentId = $3ace4598bf8a59b0$export$165209eae06d3488();
    const handleCloseRef = $3ace4598bf8a59b0$var$useLatestRef(handleClose);
    const delayRef = $3ace4598bf8a59b0$var$useLatestRef(delay);
    const openRef = $3ace4598bf8a59b0$var$useLatestRef(open);
    const pointerTypeRef = $6uYXW.useRef();
    const timeoutRef = $6uYXW.useRef(-1);
    const handlerRef = $6uYXW.useRef();
    const restTimeoutRef = $6uYXW.useRef(-1);
    const blockMouseMoveRef = $6uYXW.useRef(true);
    const performedPointerEventsMutationRef = $6uYXW.useRef(false);
    const unbindMouseMoveRef = $6uYXW.useRef(()=>{});
    const restTimeoutPendingRef = $6uYXW.useRef(false);
    const isHoverOpen = $6uYXW.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $6uYXW.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $6uYXW.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        const html = (0, $055af5d835501cff$export$f65ca476c09acec0)(elements.floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $6uYXW.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        const closeDelay = $3ace4598bf8a59b0$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $3ace4598bf8a59b0$var$useEffectEvent(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = $3ace4598bf8a59b0$var$useEffectEvent(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $055af5d835501cff$export$f65ca476c09acec0)(elements.floating).body;
            body.style.pointerEvents = '';
            body.removeAttribute($3ace4598bf8a59b0$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    const isClickLikeOpenEvent = $3ace4598bf8a59b0$var$useEffectEvent(()=>{
        return dataRef.current.openEvent ? [
            'click',
            'mousedown'
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $6uYXW.useEffect(()=>{
        if (!enabled) return;
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $055af5d835501cff$export$81cf264172d31e51)(pointerTypeRef.current) || restMs > 0 && !$3ace4598bf8a59b0$var$getDelay(delayRef.current, 'open')) return;
            const openDelay = $3ace4598bf8a59b0$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, 'hover');
            }, openDelay);
            else if (!open) onOpenChange(true, event, 'hover');
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = (0, $055af5d835501cff$export$f65ca476c09acec0)(elements.floating);
            clearTimeout(restTimeoutRef.current);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, 'safe-polygon');
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === 'touch' ? !(0, $055af5d835501cff$export$2344b14b097df817)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            })(event);
        }
        if ((0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(elements.domReference)) {
            var _elements$floating;
            const ref = elements.domReference;
            open && ref.addEventListener('mouseleave', onScrollMouseLeave);
            (_elements$floating = elements.floating) == null || _elements$floating.addEventListener('mouseleave', onScrollMouseLeave);
            move && ref.addEventListener('mousemove', onMouseEnter, {
                once: true
            });
            ref.addEventListener('mouseenter', onMouseEnter);
            ref.addEventListener('mouseleave', onMouseLeave);
            return ()=>{
                var _elements$floating2;
                open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
                (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener('mouseleave', onScrollMouseLeave);
                move && ref.removeEventListener('mousemove', onMouseEnter);
                ref.removeEventListener('mouseenter', onMouseEnter);
                ref.removeEventListener('mouseleave', onMouseLeave);
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $3ace4598bf8a59b0$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $055af5d835501cff$export$f65ca476c09acec0)(elements.floating).body;
                body.setAttribute($3ace4598bf8a59b0$var$safePolygonIdentifier, '');
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                body.style.pointerEvents = 'none';
                ref.style.pointerEvents = 'auto';
                floatingEl.style.pointerEvents = 'auto';
                return ()=>{
                    body.style.pointerEvents = '';
                    ref.style.pointerEvents = '';
                    floatingEl.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    $3ace4598bf8a59b0$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $6uYXW.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $6uYXW.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, 'hover');
                }
                if (mouseOnly && !(0, $055af5d835501cff$export$81cf264172d31e51)(pointerTypeRef.current)) return;
                if (open || restMs === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                clearTimeout(restTimeoutRef.current);
                if (pointerTypeRef.current === 'touch') handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMs
    ]);
    const floating = $6uYXW.useMemo(()=>({
            onMouseEnter () {
                clearTimeout(timeoutRef.current);
            },
            onMouseLeave (event) {
                if (!isClickLikeOpenEvent()) closeWithDelay(event.nativeEvent, false);
            }
        }), [
        closeWithDelay,
        isClickLikeOpenEvent
    ]);
    return $6uYXW.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
const $3ace4598bf8a59b0$var$NOOP = ()=>{};
const $3ace4598bf8a59b0$var$FloatingDelayGroupContext = /*#__PURE__*/ $6uYXW.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $3ace4598bf8a59b0$var$NOOP,
    setState: $3ace4598bf8a59b0$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $3ace4598bf8a59b0$export$e2411914b150383d = ()=>$6uYXW.useContext($3ace4598bf8a59b0$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $3ace4598bf8a59b0$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $6uYXW.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $6uYXW.useRef(null);
    const setCurrentId = $6uYXW.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $3ace4598bf8a59b0$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ $6uYXW.createElement($3ace4598bf8a59b0$var$FloatingDelayGroupContext.Provider, {
        value: $6uYXW.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ])
    }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $3ace4598bf8a59b0$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $3ace4598bf8a59b0$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    $3ace4598bf8a59b0$var$index(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $3ace4598bf8a59b0$var$getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $3ace4598bf8a59b0$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $3ace4598bf8a59b0$var$index(()=>{
        if (!enabled) return;
        if (setCurrentId === $3ace4598bf8a59b0$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
let $3ace4598bf8a59b0$var$rafId = 0;
function $3ace4598bf8a59b0$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($3ace4598bf8a59b0$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $3ace4598bf8a59b0$var$rafId = requestAnimationFrame(exec);
}
function $3ace4598bf8a59b0$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $3ace4598bf8a59b0$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $3ace4598bf8a59b0$var$getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $3ace4598bf8a59b0$var$getChildren(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let $3ace4598bf8a59b0$var$counterMap = /*#__PURE__*/ new WeakMap();
let $3ace4598bf8a59b0$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $3ace4598bf8a59b0$var$markerMap = {};
let $3ace4598bf8a59b0$var$lockCount$1 = 0;
const $3ace4598bf8a59b0$var$supportsInert = ()=>typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
const $3ace4598bf8a59b0$var$unwrapHost = (node)=>node && (node.host || $3ace4598bf8a59b0$var$unwrapHost(node.parentNode));
const $3ace4598bf8a59b0$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $3ace4598bf8a59b0$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $3ace4598bf8a59b0$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = 'data-floating-ui-inert';
    const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    const avoidElements = $3ace4598bf8a59b0$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$3ace4598bf8a59b0$var$markerMap[markerName]) $3ace4598bf8a59b0$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $3ace4598bf8a59b0$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $9bc7004828788a5e$export$651544f548703224)(node) === 'script') return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== 'false';
                const counterValue = ($3ace4598bf8a59b0$var$counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $3ace4598bf8a59b0$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $3ace4598bf8a59b0$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, 'true');
            }
        });
    }
    $3ace4598bf8a59b0$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterValue = ($3ace4598bf8a59b0$var$counterMap.get(element) || 0) - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            $3ace4598bf8a59b0$var$counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$3ace4598bf8a59b0$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $3ace4598bf8a59b0$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $3ace4598bf8a59b0$var$lockCount$1--;
        if (!$3ace4598bf8a59b0$var$lockCount$1) {
            $3ace4598bf8a59b0$var$counterMap = new WeakMap();
            $3ace4598bf8a59b0$var$counterMap = new WeakMap();
            $3ace4598bf8a59b0$var$uncontrolledElementsSet = new WeakSet();
            $3ace4598bf8a59b0$var$markerMap = {};
        }
    };
}
function $3ace4598bf8a59b0$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = (0, $055af5d835501cff$export$f65ca476c09acec0)(avoidElements[0]).body;
    return $3ace4598bf8a59b0$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live]'))), body, ariaHidden, inert);
}
const $3ace4598bf8a59b0$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function $3ace4598bf8a59b0$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $5d46657807318796$export$17100aea90429aa7)(container, $3ace4598bf8a59b0$var$getTabbableOptions());
    if (direction === 'prev') allTabbable.reverse();
    const activeIndex = allTabbable.indexOf((0, $055af5d835501cff$export$da980962bd2147a4)((0, $055af5d835501cff$export$f65ca476c09acec0)(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $3ace4598bf8a59b0$var$getNextTabbable() {
    return $3ace4598bf8a59b0$var$getTabbableIn(document.body, 'next');
}
function $3ace4598bf8a59b0$var$getPreviousTabbable() {
    return $3ace4598bf8a59b0$var$getTabbableIn(document.body, 'prev');
}
function $3ace4598bf8a59b0$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, $055af5d835501cff$export$2344b14b097df817)(containerElement, relatedTarget);
}
function $3ace4598bf8a59b0$var$disableFocusInside(container) {
    const tabbableElements = (0, $5d46657807318796$export$17100aea90429aa7)(container, $3ace4598bf8a59b0$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $3ace4598bf8a59b0$var$enableFocusInside(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $3ace4598bf8a59b0$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
let $3ace4598bf8a59b0$var$timeoutId;
function $3ace4598bf8a59b0$var$setActiveElementOnTab(event) {
    if (event.key === 'Tab') {
        event.target;
        clearTimeout($3ace4598bf8a59b0$var$timeoutId);
    }
}
const $3ace4598bf8a59b0$var$FocusGuard = /*#__PURE__*/ $6uYXW.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $6uYXW.useState();
    $3ace4598bf8a59b0$var$index(()=>{
        if ((0, $055af5d835501cff$export$95df08bae54cb4df)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
        document.addEventListener('keydown', $3ace4598bf8a59b0$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener('keydown', $3ace4598bf8a59b0$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        'aria-hidden': role ? undefined : true,
        [$3ace4598bf8a59b0$var$createAttribute('focus-guard')]: '',
        style: $3ace4598bf8a59b0$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ $6uYXW.createElement("span", $3ace4598bf8a59b0$var$_extends({}, props, restProps));
});
const $3ace4598bf8a59b0$var$PortalContext = /*#__PURE__*/ $6uYXW.createContext(null);
const $3ace4598bf8a59b0$var$attr = /*#__PURE__*/ $3ace4598bf8a59b0$var$createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $3ace4598bf8a59b0$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $3ace4598bf8a59b0$export$f680877a34711e37();
    const portalContext = $3ace4598bf8a59b0$var$usePortalContext();
    const [portalNode, setPortalNode] = $6uYXW.useState(null);
    const portalNodeRef = $6uYXW.useRef(null);
    $3ace4598bf8a59b0$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    $3ace4598bf8a59b0$var$index(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($3ace4598bf8a59b0$var$attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    $3ace4598bf8a59b0$var$index(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($3ace4598bf8a59b0$var$attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $3ace4598bf8a59b0$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $3ace4598bf8a59b0$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $6uYXW.useState(null);
    const beforeOutsideRef = $6uYXW.useRef(null);
    const afterOutsideRef = $6uYXW.useRef(null);
    const beforeInsideRef = $6uYXW.useRef(null);
    const afterInsideRef = $6uYXW.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $6uYXW.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $3ace4598bf8a59b0$var$isOutsideEvent(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? $3ace4598bf8a59b0$var$enableFocusInside : $3ace4598bf8a59b0$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $6uYXW.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        $3ace4598bf8a59b0$var$enableFocusInside(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ $6uYXW.createElement($3ace4598bf8a59b0$var$PortalContext.Provider, {
        value: $6uYXW.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $6uYXW.createElement($3ace4598bf8a59b0$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($3ace4598bf8a59b0$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $3ace4598bf8a59b0$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $6uYXW.createElement("span", {
        "aria-owns": portalNode.id,
        style: $3ace4598bf8a59b0$var$HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ $4e60b4008b7e4540$exports.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ $6uYXW.createElement($3ace4598bf8a59b0$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($3ace4598bf8a59b0$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $3ace4598bf8a59b0$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
            }
        }
    }));
}
const $3ace4598bf8a59b0$var$usePortalContext = ()=>$6uYXW.useContext($3ace4598bf8a59b0$var$PortalContext);
const $3ace4598bf8a59b0$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
function $3ace4598bf8a59b0$var$getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($3ace4598bf8a59b0$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $3ace4598bf8a59b0$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
const $3ace4598bf8a59b0$var$LIST_LIMIT = 20;
let $3ace4598bf8a59b0$var$previouslyFocusedElements = [];
function $3ace4598bf8a59b0$var$addPreviouslyFocusedElement(element) {
    $3ace4598bf8a59b0$var$previouslyFocusedElements = $3ace4598bf8a59b0$var$previouslyFocusedElements.filter((el)=>el.isConnected);
    let tabbableEl = element;
    if (!tabbableEl || (0, $9bc7004828788a5e$export$651544f548703224)(tabbableEl) === 'body') return;
    if (!(0, $5d46657807318796$export$bebd5a1431fec25d)(tabbableEl, $3ace4598bf8a59b0$var$getTabbableOptions())) {
        const tabbableChild = (0, $5d46657807318796$export$17100aea90429aa7)(tabbableEl, $3ace4598bf8a59b0$var$getTabbableOptions())[0];
        if (tabbableChild) tabbableEl = tabbableChild;
    }
    $3ace4598bf8a59b0$var$previouslyFocusedElements.push(tabbableEl);
    if ($3ace4598bf8a59b0$var$previouslyFocusedElements.length > $3ace4598bf8a59b0$var$LIST_LIMIT) $3ace4598bf8a59b0$var$previouslyFocusedElements = $3ace4598bf8a59b0$var$previouslyFocusedElements.slice(-$3ace4598bf8a59b0$var$LIST_LIMIT);
}
function $3ace4598bf8a59b0$var$getPreviouslyFocusedElement() {
    return $3ace4598bf8a59b0$var$previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
const $3ace4598bf8a59b0$var$VisuallyHiddenDismiss = /*#__PURE__*/ $6uYXW.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $6uYXW.createElement("button", $3ace4598bf8a59b0$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $3ace4598bf8a59b0$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $3ace4598bf8a59b0$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        'content'
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true } = props;
    const { open: open, refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, events: events, dataRef: dataRef, floatingId: floatingId, elements: { domReference: domReference, floating: floating } } = context;
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $055af5d835501cff$export$259ba5ae38188551)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const guards = $3ace4598bf8a59b0$var$supportsInert() ? _guards : true;
    const orderRef = $3ace4598bf8a59b0$var$useLatestRef(order);
    const initialFocusRef = $3ace4598bf8a59b0$var$useLatestRef(initialFocus);
    const returnFocusRef = $3ace4598bf8a59b0$var$useLatestRef(returnFocus);
    const tree = $3ace4598bf8a59b0$export$db0c2a7c7a2a4f69();
    const portalContext = $3ace4598bf8a59b0$var$usePortalContext();
    const startDismissButtonRef = $6uYXW.useRef(null);
    const endDismissButtonRef = $6uYXW.useRef(null);
    const preventReturnFocusRef = $6uYXW.useRef(false);
    const isPointerDownRef = $6uYXW.useRef(false);
    const tabbableIndexRef = $6uYXW.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = $3ace4598bf8a59b0$var$getFloatingFocusElement(floating);
    const getTabbableContent = $3ace4598bf8a59b0$var$useEffectEvent(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $5d46657807318796$export$17100aea90429aa7)(container, $3ace4598bf8a59b0$var$getTabbableOptions()) : [];
    });
    const getTabbableElements = $3ace4598bf8a59b0$var$useEffectEvent((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floatingFocusElement && type === 'floating') return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $6uYXW.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $055af5d835501cff$export$2344b14b097df817)(floatingFocusElement, (0, $055af5d835501cff$export$da980962bd2147a4)((0, $055af5d835501cff$export$f65ca476c09acec0)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $055af5d835501cff$export$7ae4cd3a66c1e050)(event);
                const els = getTabbableElements();
                const target = (0, $055af5d835501cff$export$c22522a4dfa48e9c)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, $055af5d835501cff$export$7ae4cd3a66c1e050)(event);
                    if (event.shiftKey) $3ace4598bf8a59b0$var$enqueueFocus(els[els.length - 1]);
                    else $3ace4598bf8a59b0$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
                    (0, $055af5d835501cff$export$7ae4cd3a66c1e050)(event);
                    $3ace4598bf8a59b0$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $055af5d835501cff$export$f65ca476c09acec0)(floatingFocusElement);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $6uYXW.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $055af5d835501cff$export$c22522a4dfa48e9c)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener('focusin', handleFocusIn);
        return ()=>{
            floating.removeEventListener('focusin', handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $6uYXW.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !((0, $055af5d835501cff$export$2344b14b097df817)(domReference, relatedTarget) || (0, $055af5d835501cff$export$2344b14b097df817)(floating, relatedTarget) || (0, $055af5d835501cff$export$2344b14b097df817)(relatedTarget, floating) || (0, $055af5d835501cff$export$2344b14b097df817)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($3ace4598bf8a59b0$var$createAttribute('focus-guard')) || tree && ($3ace4598bf8a59b0$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $055af5d835501cff$export$2344b14b097df817)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $055af5d835501cff$export$2344b14b097df817)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $3ace4598bf8a59b0$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && movedToUnrelatedNode && (0, $055af5d835501cff$export$da980962bd2147a4)((0, $055af5d835501cff$export$f65ca476c09acec0)(floatingFocusElement)) === (0, $055af5d835501cff$export$f65ca476c09acec0)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(nodeToFocus)) nodeToFocus.focus();
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $3ace4598bf8a59b0$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, 'focus-out');
                }
            });
        }
        if (floating && (0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            floating.addEventListener('focusout', handleFocusOutside);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                floating.removeEventListener('focusout', handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox
    ]);
    $6uYXW.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $3ace4598bf8a59b0$var$createAttribute('portal') + "]")) || []);
        if (floating) {
            const insideElements = [
                floating,
                ...portalNodes,
                startDismissButtonRef.current,
                endDismissButtonRef.current,
                orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
            ].filter((x)=>x != null);
            const cleanup = modal || isUntrappedTypeableCombobox ? $3ace4598bf8a59b0$var$markOthers(insideElements, guards, !guards) : $3ace4598bf8a59b0$var$markOthers(insideElements);
            return ()=>{
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards
    ]);
    $3ace4598bf8a59b0$var$index(()=>{
        if (disabled || !(0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(floatingFocusElement)) return;
        const doc = (0, $055af5d835501cff$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $055af5d835501cff$export$da980962bd2147a4)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $055af5d835501cff$export$2344b14b097df817)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $3ace4598bf8a59b0$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $3ace4598bf8a59b0$var$index(()=>{
        if (disabled || !floatingFocusElement) return;
        let preventReturnFocusScroll = false;
        const doc = (0, $055af5d835501cff$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $055af5d835501cff$export$da980962bd2147a4)(doc);
        const contextData = dataRef.current;
        let openEvent = contextData.openEvent;
        $3ace4598bf8a59b0$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { open: open, reason: reason, event: event, nested: nested } = _ref;
            if (open) openEvent = event;
            if (reason === 'escape-key' && refs.domReference.current) $3ace4598bf8a59b0$var$addPreviouslyFocusedElement(refs.domReference.current);
            if (reason === 'hover' && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, $055af5d835501cff$export$60278871457622de)(event) || (0, $055af5d835501cff$export$29bf1b5f2c56cf63)(event));
        }
        events.on('openchange', onOpenChange);
        const fallbackEl = doc.createElement('span');
        fallbackEl.setAttribute('tabindex', '-1');
        fallbackEl.setAttribute('aria-hidden', 'true');
        Object.assign(fallbackEl.style, $3ace4598bf8a59b0$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement('afterend', fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === 'boolean') return $3ace4598bf8a59b0$var$getPreviouslyFocusedElement() || fallbackEl;
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off('openchange', onOpenChange);
            const activeEl = (0, $055af5d835501cff$export$da980962bd2147a4)(doc);
            const isFocusInsideFloatingTree = (0, $055af5d835501cff$export$2344b14b097df817)(floating, activeEl) || tree && $3ace4598bf8a59b0$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context5;
                return (0, $055af5d835501cff$export$2344b14b097df817)((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            });
            const shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                'click',
                'mousedown'
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) $3ace4598bf8a59b0$var$addPreviouslyFocusedElement(refs.domReference.current);
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) returnElement.focus({
                    preventScroll: preventReturnFocusScroll
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId,
        isInsidePortal,
        domReference
    ]);
    $6uYXW.useEffect(()=>{
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(()=>{
            preventReturnFocusRef.current = false;
        });
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $3ace4598bf8a59b0$var$index(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            refs: refs
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    $3ace4598bf8a59b0$var$index(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        if (typeof MutationObserver !== 'function') return;
        if (ignoreInitialFocus) return;
        const handleMutation = ()=>{
            const tabIndex = floatingFocusElement.getAttribute('tabindex');
            const tabbableContent = getTabbableContent();
            const activeEl = (0, $055af5d835501cff$export$da980962bd2147a4)((0, $055af5d835501cff$export$f65ca476c09acec0)(floating));
            const tabbableIndex = tabbableContent.indexOf(activeEl);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
            if (orderRef.current.includes('floating') || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
                if (tabIndex !== '0') floatingFocusElement.setAttribute('tabindex', '0');
            } else if (tabIndex !== '-1') floatingFocusElement.setAttribute('tabindex', '-1');
        };
        handleMutation();
        const observer = new MutationObserver(handleMutation);
        observer.observe(floatingFocusElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ $6uYXW.createElement($3ace4598bf8a59b0$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent)
        }, typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss');
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ $6uYXW.createElement($6uYXW.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $6uYXW.createElement($3ace4598bf8a59b0$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $3ace4598bf8a59b0$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($3ace4598bf8a59b0$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $3ace4598bf8a59b0$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton('start'), children, renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/ $6uYXW.createElement($3ace4598bf8a59b0$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $3ace4598bf8a59b0$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if ($3ace4598bf8a59b0$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $3ace4598bf8a59b0$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
let $3ace4598bf8a59b0$var$lockCount = 0;
function $3ace4598bf8a59b0$var$enableScrollLock() {
    const isIOS = /iP(hone|ad|od)|iOS/.test((0, $055af5d835501cff$export$867a782338812cb4)());
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: 'fixed',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0'
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: '',
            [paddingProp]: ''
        });
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: '',
                top: '',
                left: '',
                right: ''
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $3ace4598bf8a59b0$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $3ace4598bf8a59b0$export$a35954495955337b = /*#__PURE__*/ $6uYXW.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    $3ace4598bf8a59b0$var$index(()=>{
        if (!lockScroll) return;
        $3ace4598bf8a59b0$var$lockCount++;
        if ($3ace4598bf8a59b0$var$lockCount === 1) $3ace4598bf8a59b0$var$cleanup = $3ace4598bf8a59b0$var$enableScrollLock();
        return ()=>{
            $3ace4598bf8a59b0$var$lockCount--;
            if ($3ace4598bf8a59b0$var$lockCount === 0) $3ace4598bf8a59b0$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ $6uYXW.createElement("div", $3ace4598bf8a59b0$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $3ace4598bf8a59b0$var$isButtonTarget(event) {
    return (0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === 'BUTTON';
}
function $3ace4598bf8a59b0$var$isSpaceIgnored(element) {
    return (0, $055af5d835501cff$export$42ad131c32f0fb8d)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $3ace4598bf8a59b0$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true, stickIfOpen: stickIfOpen = true } = props;
    const pointerTypeRef = $6uYXW.useRef();
    const didKeyDownRef = $6uYXW.useRef(false);
    const reference = $6uYXW.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === 'click') return;
                if ((0, $055af5d835501cff$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $055af5d835501cff$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else onOpenChange(true, event.nativeEvent, 'click');
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $3ace4598bf8a59b0$var$isButtonTarget(event)) return;
                if (event.key === ' ' && !$3ace4598bf8a59b0$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (event.key === 'Enter') {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $3ace4598bf8a59b0$var$isButtonTarget(event) || $3ace4598bf8a59b0$var$isSpaceIgnored(domReference)) return;
                if (event.key === ' ' && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return $6uYXW.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $3ace4598bf8a59b0$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === 'x' || data.axis === 'both';
            const isYAxis = data.axis === 'y' || data.axis === 'both';
            const canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $3ace4598bf8a59b0$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $3ace4598bf8a59b0$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = 'both', x: x = null, y: y = null } = props;
    const initialRef = $6uYXW.useRef(false);
    const cleanupListenerRef = $6uYXW.useRef(null);
    const [pointerType, setPointerType] = $6uYXW.useState();
    const [reactive, setReactive] = $6uYXW.useState([]);
    const setReference = $3ace4598bf8a59b0$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$3ace4598bf8a59b0$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($3ace4598bf8a59b0$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $3ace4598bf8a59b0$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $055af5d835501cff$export$81cf264172d31e51)(pointerType) ? floating : open;
    const addListener = $6uYXW.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $9bc7004828788a5e$export$38b2d434cce3ea22)(floating);
        function handleMouseMove(event) {
            const target = (0, $055af5d835501cff$export$c22522a4dfa48e9c)(event);
            if (!(0, $055af5d835501cff$export$2344b14b097df817)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $3ace4598bf8a59b0$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $6uYXW.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $6uYXW.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $6uYXW.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $3ace4598bf8a59b0$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $6uYXW.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $6uYXW.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $3ace4598bf8a59b0$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $3ace4598bf8a59b0$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const $3ace4598bf8a59b0$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $3ace4598bf8a59b0$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $3ace4598bf8a59b0$export$db0c2a7c7a2a4f69();
    const outsidePressFn = $3ace4598bf8a59b0$var$useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $6uYXW.useRef(false);
    const endedOrStartedInsideRef = $6uYXW.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $3ace4598bf8a59b0$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $3ace4598bf8a59b0$var$normalizeProp(capture);
    const isComposingRef = $6uYXW.useRef(false);
    const closeOnEscapeKeyDown = $3ace4598bf8a59b0$var$useEffectEvent((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? $3ace4598bf8a59b0$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $055af5d835501cff$export$94781ce41a161222)(event) ? event.nativeEvent : event, 'escape-key');
    });
    const closeOnEscapeKeyDownCapture = $3ace4598bf8a59b0$var$useEffectEvent((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $055af5d835501cff$export$c22522a4dfa48e9c)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, $055af5d835501cff$export$c22522a4dfa48e9c)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    const closeOnPressOutside = $3ace4598bf8a59b0$var$useEffectEvent((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        const target = (0, $055af5d835501cff$export$c22522a4dfa48e9c)(event);
        const inertSelector = "[" + $3ace4598bf8a59b0$var$createAttribute('inert') + "]";
        const markers = (0, $055af5d835501cff$export$f65ca476c09acec0)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(target) ? target : null;
        while(targetRootAncestor && !(0, $9bc7004828788a5e$export$d1162fb0b6d4cd51)(targetRootAncestor)){
            const nextParent = (0, $9bc7004828788a5e$export$4e12058fc4d51d56)(targetRootAncestor);
            if ((0, $9bc7004828788a5e$export$d1162fb0b6d4cd51)(nextParent) || !(0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(target) && !(0, $055af5d835501cff$export$7b296c28e0fa3aed)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $055af5d835501cff$export$2344b14b097df817)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $055af5d835501cff$export$2344b14b097df817)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            let xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                const isRTL = (0, $9bc7004828788a5e$export$3735103072e4a80)(target).direction === 'rtl';
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && $3ace4598bf8a59b0$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $055af5d835501cff$export$43c3154d5bf2c6c2)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $055af5d835501cff$export$43c3154d5bf2c6c2)(event, elements.floating) || (0, $055af5d835501cff$export$43c3154d5bf2c6c2)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? $3ace4598bf8a59b0$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    const closeOnPressOutsideCapture = $3ace4598bf8a59b0$var$useEffectEvent((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $055af5d835501cff$export$c22522a4dfa48e9c)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $055af5d835501cff$export$c22522a4dfa48e9c)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $6uYXW.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $9bc7004828788a5e$export$78551043582a6a98)() ? 5 : 0);
        }
        const doc = (0, $055af5d835501cff$export$f65ca476c09acec0)(elements.floating);
        if (escapeKey) {
            doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener('compositionstart', handleCompositionStart);
            doc.addEventListener('compositionend', handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(elements.domReference)) ancestors = (0, $9bc7004828788a5e$export$3b57c1601291186b)(elements.domReference);
            if ((0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(elements.floating)) ancestors = ancestors.concat((0, $9bc7004828788a5e$export$3b57c1601291186b)(elements.floating));
            if (!(0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $9bc7004828788a5e$export$3b57c1601291186b)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll, {
                passive: true
            });
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener('compositionstart', handleCompositionStart);
                doc.removeEventListener('compositionend', handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $6uYXW.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $6uYXW.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            [$3ace4598bf8a59b0$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                if (referencePress) onOpenChange(false, event.nativeEvent, 'reference-press');
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $6uYXW.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [$3ace4598bf8a59b0$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                insideReactTreeRef.current = true;
            }
        }), [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return $6uYXW.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $3ace4598bf8a59b0$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $3ace4598bf8a59b0$export$f680877a34711e37();
    const dataRef = $6uYXW.useRef({});
    const [events] = $6uYXW.useState(()=>$3ace4598bf8a59b0$var$createPubSub());
    const nested = $3ace4598bf8a59b0$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $6uYXW.useState(elementsProp.reference);
    const onOpenChange = $3ace4598bf8a59b0$var$useEffectEvent((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $6uYXW.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $6uYXW.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $6uYXW.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $3ace4598bf8a59b0$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $3ace4598bf8a59b0$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $6uYXW.useState(null);
    const [positionReference, _setPositionReference] = $6uYXW.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $6uYXW.useRef(null);
    const tree = $3ace4598bf8a59b0$export$db0c2a7c7a2a4f69();
    $3ace4598bf8a59b0$var$index(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $9276ab85670b57fb$export$4e02a5c1d08bac65)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $6uYXW.useCallback((node)=>{
        const computedPositionReference = (0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $6uYXW.useCallback((node)=>{
        if ((0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $6uYXW.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $6uYXW.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $6uYXW.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    $3ace4598bf8a59b0$var$index(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $6uYXW.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $3ace4598bf8a59b0$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $6uYXW.useRef(false);
    const timeoutRef = $6uYXW.useRef();
    const keyboardModalityRef = $6uYXW.useRef(true);
    $6uYXW.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $9bc7004828788a5e$export$38b2d434cce3ea22)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(elements.domReference) && elements.domReference === (0, $055af5d835501cff$export$da980962bd2147a4)((0, $055af5d835501cff$export$f65ca476c09acec0)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        win.addEventListener('blur', onBlur);
        win.addEventListener('keydown', onKeyDown, true);
        return ()=>{
            win.removeEventListener('blur', onBlur);
            win.removeEventListener('keydown', onKeyDown, true);
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $6uYXW.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $6uYXW.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const reference = $6uYXW.useMemo(()=>({
            onPointerDown (event) {
                if ((0, $055af5d835501cff$export$29bf1b5f2c56cf63)(event.nativeEvent)) return;
                keyboardModalityRef.current = false;
            },
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $055af5d835501cff$export$c22522a4dfa48e9c)(event.nativeEvent);
                if (visibleOnly && (0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(target)) try {
                    // Mac Safari unreliably matches `:focus-visible` on the reference
                    // if focus was outside the page initially - use the fallback
                    // instead.
                    if ((0, $055af5d835501cff$export$95df08bae54cb4df)() && (0, $055af5d835501cff$export$9ac100e40613ea10)()) throw Error();
                    if (!target.matches(':focus-visible')) return;
                } catch (e) {
                    // Old browsers will throw an error when using `:focus-visible`.
                    if (!keyboardModalityRef.current && !(0, $055af5d835501cff$export$42ad131c32f0fb8d)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, 'focus');
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(relatedTarget) && relatedTarget.hasAttribute($3ace4598bf8a59b0$var$createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $055af5d835501cff$export$da980962bd2147a4)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $055af5d835501cff$export$2344b14b097df817)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $055af5d835501cff$export$2344b14b097df817)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, 'focus');
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $6uYXW.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $3ace4598bf8a59b0$var$ACTIVE_KEY = 'active';
const $3ace4598bf8a59b0$var$SELECTED_KEY = 'selected';
function $3ace4598bf8a59b0$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === 'item';
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$3ace4598bf8a59b0$var$ACTIVE_KEY]: _, [$3ace4598bf8a59b0$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1,
            [$3ace4598bf8a59b0$var$FOCUSABLE_ATTRIBUTE]: ''
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $3ace4598bf8a59b0$var$ACTIVE_KEY,
                    $3ace4598bf8a59b0$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $3ace4598bf8a59b0$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $6uYXW.useCallback((userProps)=>$3ace4598bf8a59b0$var$mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $6uYXW.useCallback((userProps)=>$3ace4598bf8a59b0$var$mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $6uYXW.useCallback((userProps)=>$3ace4598bf8a59b0$var$mergeProps(userProps, propsList, 'item'), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $6uYXW.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
let $3ace4598bf8a59b0$var$isPreventScrollSupported = false;
function $3ace4598bf8a59b0$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $3ace4598bf8a59b0$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $3ace4598bf8a59b0$var$ARROW_UP || key === $3ace4598bf8a59b0$var$ARROW_DOWN;
    const horizontal = key === $3ace4598bf8a59b0$var$ARROW_LEFT || key === $3ace4598bf8a59b0$var$ARROW_RIGHT;
    return $3ace4598bf8a59b0$var$doSwitch(orientation, vertical, horizontal);
}
function $3ace4598bf8a59b0$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $3ace4598bf8a59b0$var$ARROW_DOWN;
    const horizontal = rtl ? key === $3ace4598bf8a59b0$var$ARROW_LEFT : key === $3ace4598bf8a59b0$var$ARROW_RIGHT;
    return $3ace4598bf8a59b0$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $3ace4598bf8a59b0$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $3ace4598bf8a59b0$var$ARROW_LEFT : key === $3ace4598bf8a59b0$var$ARROW_RIGHT;
    const horizontal = key === $3ace4598bf8a59b0$var$ARROW_DOWN;
    return $3ace4598bf8a59b0$var$doSwitch(orientation, vertical, horizontal);
}
function $3ace4598bf8a59b0$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $3ace4598bf8a59b0$var$ARROW_RIGHT : key === $3ace4598bf8a59b0$var$ARROW_LEFT;
    const horizontal = key === $3ace4598bf8a59b0$var$ARROW_UP;
    return $3ace4598bf8a59b0$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $3ace4598bf8a59b0$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = $3ace4598bf8a59b0$var$getFloatingFocusElement(elements.floating);
    const floatingFocusElementRef = $3ace4598bf8a59b0$var$useLatestRef(floatingFocusElement);
    const parentId = $3ace4598bf8a59b0$export$165209eae06d3488();
    const tree = $3ace4598bf8a59b0$export$db0c2a7c7a2a4f69();
    const onNavigate = $3ace4598bf8a59b0$var$useEffectEvent(unstable_onNavigate);
    const typeableComboboxReference = (0, $055af5d835501cff$export$259ba5ae38188551)(elements.domReference);
    const focusItemOnOpenRef = $6uYXW.useRef(focusItemOnOpen);
    const indexRef = $6uYXW.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $6uYXW.useRef(null);
    const isPointerModalityRef = $6uYXW.useRef(true);
    const previousOnNavigateRef = $6uYXW.useRef(onNavigate);
    const previousMountedRef = $6uYXW.useRef(!!elements.floating);
    const previousOpenRef = $6uYXW.useRef(open);
    const forceSyncFocus = $6uYXW.useRef(false);
    const forceScrollIntoViewRef = $6uYXW.useRef(false);
    const disabledIndicesRef = $3ace4598bf8a59b0$var$useLatestRef(disabledIndices);
    const latestOpenRef = $3ace4598bf8a59b0$var$useLatestRef(open);
    const scrollItemIntoViewRef = $3ace4598bf8a59b0$var$useLatestRef(scrollItemIntoView);
    const selectedIndexRef = $3ace4598bf8a59b0$var$useLatestRef(selectedIndex);
    const [activeId, setActiveId] = $6uYXW.useState();
    const [virtualId, setVirtualId] = $6uYXW.useState();
    const focusItem = $3ace4598bf8a59b0$var$useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        function runFocus(item) {
            if (virtual) {
                setActiveId(item.id);
                tree == null || tree.events.emit('virtualfocus', item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $3ace4598bf8a59b0$var$enqueueFocus(item, {
                preventScroll: true,
                // Mac Safari does not move the virtual cursor unless the focus call
                // is sync. However, for the very first focus call, we need to wait
                // for the position to be ready in order to prevent unwanted
                // scrolling. This means the virtual cursor will not move to the first
                // item when first opening the floating element, but will on
                // subsequent calls. `preventScroll` is supported in modern Safari,
                // so we can use that instead.
                // iOS Safari must be async or the first item will not be focused.
                sync: (0, $055af5d835501cff$export$9ac100e40613ea10)() && (0, $055af5d835501cff$export$95df08bae54cb4df)() ? $3ace4598bf8a59b0$var$isPreventScrollSupported || forceSyncFocus.current : false
            });
        }
        const initialItem = listRef.current[indexRef.current];
        if (initialItem) runFocus(initialItem);
        requestAnimationFrame(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    $3ace4598bf8a59b0$var$index(()=>{
        document.createElement('div').focus({
            get preventScroll () {
                $3ace4598bf8a59b0$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $3ace4598bf8a59b0$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $3ace4598bf8a59b0$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndexRef.current != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    let runs = 0;
                    const waitForListPopulated = ()=>{
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || $3ace4598bf8a59b0$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $3ace4598bf8a59b0$var$getMinIndex(listRef, disabledIndicesRef.current) : $3ace4598bf8a59b0$var$getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!$3ace4598bf8a59b0$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $3ace4598bf8a59b0$var$index(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $055af5d835501cff$export$da980962bd2147a4)((0, $055af5d835501cff$export$f65ca476c09acec0)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $055af5d835501cff$export$2344b14b097df817)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    $3ace4598bf8a59b0$var$index(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return ()=>{
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    $3ace4598bf8a59b0$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!elements.floating;
    });
    $3ace4598bf8a59b0$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    $3ace4598bf8a59b0$var$index(()=>{
        previousOpenRef.current = open;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $6uYXW.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === 'touch') return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    onNavigate(null);
                    if (!virtual) $3ace4598bf8a59b0$var$enqueueFocus(floatingFocusElementRef.current, {
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        open,
        floatingFocusElementRef,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const commonOnKeyDown = $3ace4598bf8a59b0$var$useEffectEvent((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocus.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $3ace4598bf8a59b0$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
            (0, $055af5d835501cff$export$7ae4cd3a66c1e050)(event);
            onOpenChange(false, event.nativeEvent, 'list-navigation');
            if ((0, $9bc7004828788a5e$export$1b3bfaa9684536aa)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit('virtualfocus', elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = $3ace4598bf8a59b0$var$getMinIndex(listRef, disabledIndices);
        const maxIndex = $3ace4598bf8a59b0$var$getMaxIndex(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === 'Home') {
                (0, $055af5d835501cff$export$7ae4cd3a66c1e050)(event);
                indexRef.current = minIndex;
                onNavigate(indexRef.current);
            }
            if (event.key === 'End') {
                (0, $055af5d835501cff$export$7ae4cd3a66c1e050)(event);
                indexRef.current = maxIndex;
                onNavigate(indexRef.current);
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $3ace4598bf8a59b0$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$3ace4598bf8a59b0$var$isDisabled(listRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$3ace4598bf8a59b0$var$isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[$3ace4598bf8a59b0$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $3ace4598bf8a59b0$var$getCellIndices([
                    ...disabledIndices || listRef.current.map((_, index)=>$3ace4598bf8a59b0$var$isDisabled(listRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $3ace4598bf8a59b0$var$getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $3ace4598bf8a59b0$var$ARROW_DOWN ? 'bl' : event.key === (rtl ? $3ace4598bf8a59b0$var$ARROW_LEFT : $3ace4598bf8a59b0$var$ARROW_RIGHT) ? 'tr' : 'tl'),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate(indexRef.current);
            }
            if (orientation === 'both') return;
        }
        if ($3ace4598bf8a59b0$var$isMainOrientationKey(event.key, orientation)) {
            (0, $055af5d835501cff$export$7ae4cd3a66c1e050)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $055af5d835501cff$export$da980962bd2147a4)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $3ace4598bf8a59b0$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate(indexRef.current);
                return;
            }
            if ($3ace4598bf8a59b0$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $3ace4598bf8a59b0$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, $3ace4598bf8a59b0$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $3ace4598bf8a59b0$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, $3ace4598bf8a59b0$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ($3ace4598bf8a59b0$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
            else onNavigate(indexRef.current);
        }
    });
    const ariaActiveDescendantProp = $6uYXW.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $6uYXW.useMemo(()=>{
        return {
            'aria-orientation': orientation === 'both' ? undefined : orientation,
            ...!(0, $055af5d835501cff$export$259ba5ae38188551)(elements.domReference) && ariaActiveDescendantProp,
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        elements.domReference,
        orientation
    ]);
    const reference = $6uYXW.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $055af5d835501cff$export$60278871457622de)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $055af5d835501cff$export$29bf1b5f2c56cf63)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith('Arrow');
                const isHomeOrEndKey = [
                    'Home',
                    'End'
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $3ace4598bf8a59b0$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $3ace4598bf8a59b0$var$isCrossOrientationCloseKey(event.key, orientation, rtl);
                const isMainKey = $3ace4598bf8a59b0$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? $3ace4598bf8a59b0$var$getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent('keydown', {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $055af5d835501cff$export$7ae4cd3a66c1e050)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $055af5d835501cff$export$7ae4cd3a66c1e050)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                if (nested) {
                    if (isCrossOpenKey) {
                        (0, $055af5d835501cff$export$7ae4cd3a66c1e050)(event);
                        if (open) {
                            indexRef.current = $3ace4598bf8a59b0$var$getMinIndex(listRef, disabledIndicesRef.current);
                            onNavigate(indexRef.current);
                        } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $055af5d835501cff$export$7ae4cd3a66c1e050)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                    else commonOnKeyDown(event);
                    if (open) onNavigate(indexRef.current);
                }
            },
            onFocus () {
                if (open && !virtual) onNavigate(null);
            },
            onPointerDown: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $6uYXW.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $3ace4598bf8a59b0$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $3ace4598bf8a59b0$export$f66572793fa256a1(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, floatingId: floatingId } = context;
    const { enabled: enabled = true, role: role = 'dialog' } = props;
    const ariaRole = (_componentRoleToAriaR = $3ace4598bf8a59b0$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const referenceId = $3ace4598bf8a59b0$export$f680877a34711e37();
    const parentId = $3ace4598bf8a59b0$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $6uYXW.useMemo(()=>{
        if (ariaRole === 'tooltip' || role === 'label') return {
            ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        };
        return {
            'aria-expanded': open ? 'true' : 'false',
            'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
            'aria-controls': open ? floatingId : undefined,
            ...ariaRole === 'listbox' && {
                role: 'combobox'
            },
            ...ariaRole === 'menu' && {
                id: referenceId
            },
            ...ariaRole === 'menu' && isNested && {
                role: 'menuitem'
            },
            ...role === 'select' && {
                'aria-autocomplete': 'none'
            },
            ...role === 'combobox' && {
                'aria-autocomplete': 'list'
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $6uYXW.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === 'tooltip' || role === 'label') return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === 'menu' && {
                'aria-labelledby': referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $6uYXW.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: 'option',
            ...active && {
                id: floatingId + "-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case 'select':
                return {
                    ...commonProps,
                    'aria-selected': active && selected
                };
            case 'combobox':
                return {
                    ...commonProps,
                    ...active && {
                        'aria-selected': true
                    }
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $6uYXW.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $3ace4598bf8a59b0$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function $3ace4598bf8a59b0$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function $3ace4598bf8a59b0$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $6uYXW.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $6uYXW.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $3ace4598bf8a59b0$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $6uYXW.useState('unmounted');
    const isMounted = $3ace4598bf8a59b0$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === 'close') setStatus('unmounted');
    $3ace4598bf8a59b0$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                setStatus('open');
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $3ace4598bf8a59b0$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const fnArgs = $6uYXW.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $6uYXW.useState(()=>({
            ...$3ace4598bf8a59b0$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$3ace4598bf8a59b0$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $3ace4598bf8a59b0$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $3ace4598bf8a59b0$var$useLatestRef(unstable_initial);
    const openRef = $3ace4598bf8a59b0$var$useLatestRef(unstable_open);
    const closeRef = $3ace4598bf8a59b0$var$useLatestRef(unstable_close);
    const commonRef = $3ace4598bf8a59b0$var$useLatestRef(unstable_common);
    $3ace4598bf8a59b0$var$index(()=>{
        const initialStyles = $3ace4598bf8a59b0$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $3ace4598bf8a59b0$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $3ace4598bf8a59b0$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $3ace4598bf8a59b0$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === 'open') setStyles({
            transitionProperty: Object.keys(openStyles).map($3ace4598bf8a59b0$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($3ace4598bf8a59b0$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $3ace4598bf8a59b0$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $6uYXW.useRef();
    const stringRef = $6uYXW.useRef('');
    const prevIndexRef = $6uYXW.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $6uYXW.useRef(null);
    const onMatch = $3ace4598bf8a59b0$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $3ace4598bf8a59b0$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $3ace4598bf8a59b0$var$useLatestRef(findMatch);
    const ignoreKeysRef = $3ace4598bf8a59b0$var$useLatestRef(ignoreKeys);
    $3ace4598bf8a59b0$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    $3ace4598bf8a59b0$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = $3ace4598bf8a59b0$var$useEffectEvent((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = $3ace4598bf8a59b0$var$useEffectEvent((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === ' ') (0, $055af5d835501cff$export$7ae4cd3a66c1e050)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, $055af5d835501cff$export$7ae4cd3a66c1e050)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(()=>{
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            setTypingChange(false);
        }
    });
    const reference = $6uYXW.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $6uYXW.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === ' ') setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $6uYXW.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $3ace4598bf8a59b0$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $3ace4598bf8a59b0$export$4ae363f1d88fb658 = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $79146317861d6bce$export$fef61f332f2c0afc)(props, state);
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $9276ab85670b57fb$export$cc800923e997bb8)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await (0, $aa34d2df375b4645$export$37b6bde19b108ecc)($3ace4598bf8a59b0$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await (0, $aa34d2df375b4645$export$37b6bde19b108ecc)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = (0, $79146317861d6bce$export$8960430cfd85939f)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $79146317861d6bce$export$2077e0241d6afd3c);
            const maxHeight = rounder((0, $79146317861d6bce$export$8960430cfd85939f)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $79146317861d6bce$export$8960430cfd85939f)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $79146317861d6bce$export$96ec731ed4dcb222)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $4e60b4008b7e4540$exports.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await (0, $aa34d2df375b4645$export$37b6bde19b108ecc)($3ace4598bf8a59b0$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function $3ace4598bf8a59b0$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = $3ace4598bf8a59b0$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $6uYXW.useRef(false);
    const prevScrollTopRef = $6uYXW.useRef(null);
    const initialOverflowRef = $6uYXW.useRef(null);
    $6uYXW.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $4e60b4008b7e4540$exports.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $055af5d835501cff$export$7935961ef7719cb0)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $6uYXW.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $4e60b4008b7e4540$exports.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $6uYXW.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $3ace4598bf8a59b0$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $3ace4598bf8a59b0$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $3ace4598bf8a59b0$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = (0, $055af5d835501cff$export$c22522a4dfa48e9c)(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = (0, $055af5d835501cff$export$2344b14b097df817)(elements.floating, target);
            const isOverReferenceEl = (0, $055af5d835501cff$export$2344b14b097df817)(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $3ace4598bf8a59b0$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $9bc7004828788a5e$export$45a5e7f76e0caa8d)(event.relatedTarget) && (0, $055af5d835501cff$export$2344b14b097df817)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $3ace4598bf8a59b0$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($3ace4598bf8a59b0$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$3ace4598bf8a59b0$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}



var $6uYXW = parcelRequire("6uYXW");




let $b78d9d7c3cf3d636$var$y = (0, $6uYXW.createContext)({
    styles: void 0,
    setReference: ()=>{},
    setFloating: ()=>{},
    getReferenceProps: ()=>({}),
    getFloatingProps: ()=>({}),
    slot: {}
});
$b78d9d7c3cf3d636$var$y.displayName = "FloatingContext";
let $b78d9d7c3cf3d636$var$$ = (0, $6uYXW.createContext)(null);
$b78d9d7c3cf3d636$var$$.displayName = "PlacementContext";
function $b78d9d7c3cf3d636$export$ee5342e485f0bdb0(e) {
    return (0, $6uYXW.useMemo)(()=>e ? typeof e == "string" ? {
            to: e
        } : e : null, [
        e
    ]);
}
function $b78d9d7c3cf3d636$export$916a28f343467e85() {
    return (0, $6uYXW.useContext)($b78d9d7c3cf3d636$var$y).setReference;
}
function $b78d9d7c3cf3d636$export$c7931d5027a8ead4() {
    return (0, $6uYXW.useContext)($b78d9d7c3cf3d636$var$y).getReferenceProps;
}
function $b78d9d7c3cf3d636$export$106e71f938eae412() {
    let { getFloatingProps: e, slot: t } = (0, $6uYXW.useContext)($b78d9d7c3cf3d636$var$y);
    return (0, $6uYXW.useCallback)((...n)=>Object.assign({}, e(...n), {
            "data-anchor": t.anchor
        }), [
        e,
        t
    ]);
}
function $b78d9d7c3cf3d636$export$aff4be9ef2a28e43(e = null) {
    e === !1 && (e = null), typeof e == "string" && (e = {
        to: e
    });
    let t = (0, $6uYXW.useContext)($b78d9d7c3cf3d636$var$$), n = (0, $6uYXW.useMemo)(()=>e, [
        JSON.stringify(e, (l, o)=>{
            var u;
            return (u = o == null ? void 0 : o.outerHTML) != null ? u : o;
        })
    ]);
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        t == null || t(n != null ? n : null);
    }, [
        t,
        n
    ]);
    let r = (0, $6uYXW.useContext)($b78d9d7c3cf3d636$var$y);
    return (0, $6uYXW.useMemo)(()=>[
            r.setFloating,
            e ? r.styles : {}
        ], [
        r.setFloating,
        e,
        r.styles
    ]);
}
let $b78d9d7c3cf3d636$var$D = 4;
function $b78d9d7c3cf3d636$export$e473aa84737d3250({ children: e, enabled: t = !0 }) {
    let [n, r] = (0, $6uYXW.useState)(null), [l, o] = (0, $6uYXW.useState)(0), u = (0, $6uYXW.useRef)(null), [f, s] = (0, $6uYXW.useState)(null);
    $b78d9d7c3cf3d636$var$ce(f);
    let i = t && n !== null && f !== null, { to: F = "bottom", gap: E = 0, offset: A = 0, padding: c = 0, inner: h } = $b78d9d7c3cf3d636$var$ge(n, f), [a, p = "center"] = F.split(" ");
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        i && o(0);
    }, [
        i
    ]);
    let { refs: b, floatingStyles: S, context: g } = (0, $3ace4598bf8a59b0$export$4e02a5c1d08bac65)({
        open: i,
        placement: a === "selection" ? p === "center" ? "bottom" : `bottom-${p}` : p === "center" ? `${a}` : `${a}-${p}`,
        strategy: "absolute",
        transform: !1,
        middleware: [
            (0, $9276ab85670b57fb$export$cc800923e997bb8)({
                mainAxis: a === "selection" ? 0 : E,
                crossAxis: A
            }),
            (0, $9276ab85670b57fb$export$fba63a578e423eb)({
                padding: c
            }),
            a !== "selection" && (0, $9276ab85670b57fb$export$8a83211c878a3f1f)({
                padding: c
            }),
            a === "selection" && h ? (0, $3ace4598bf8a59b0$export$4ae363f1d88fb658)({
                ...h,
                padding: c,
                overflowRef: u,
                offset: l,
                minItemsVisible: $b78d9d7c3cf3d636$var$D,
                referenceOverflowThreshold: c,
                onFallbackChange (P) {
                    var L, N;
                    if (!P) return;
                    let d = g.elements.floating;
                    if (!d) return;
                    let M = parseFloat(getComputedStyle(d).scrollPaddingBottom) || 0, I = Math.min($b78d9d7c3cf3d636$var$D, d.childElementCount), W = 0, B = 0;
                    for (let m of (N = (L = g.elements.floating) == null ? void 0 : L.childNodes) != null ? N : [])if ($36c2319598bace40$export$1b3bfaa9684536aa(m)) {
                        let x = m.offsetTop, k = x + m.clientHeight + M, H = d.scrollTop, U = H + d.clientHeight;
                        if (x >= H && k <= U) I--;
                        else {
                            B = Math.max(0, Math.min(k, U) - Math.max(x, H)), W = m.clientHeight;
                            break;
                        }
                    }
                    I >= 1 && o((m)=>{
                        let x = W * I - B + M;
                        return m >= x ? m : x;
                    });
                }
            }) : null,
            (0, $9276ab85670b57fb$export$346677f925de839c)({
                padding: c,
                apply ({ availableWidth: P, availableHeight: d, elements: M }) {
                    Object.assign(M.floating.style, {
                        overflow: "auto",
                        maxWidth: `${P}px`,
                        maxHeight: `min(var(--anchor-max-height, 100vh), ${d}px)`
                    });
                }
            })
        ].filter(Boolean),
        whileElementsMounted: (0, $aa34d2df375b4645$export$deee3a793edee05f)
    }), [w = a, V = p] = g.placement.split("-");
    a === "selection" && (w = "selection");
    let G = (0, $6uYXW.useMemo)(()=>({
            anchor: [
                w,
                V
            ].filter(Boolean).join(" ")
        }), [
        w,
        V
    ]), K = (0, $3ace4598bf8a59b0$export$3d74b0dda7cc82ff)(g, {
        overflowRef: u,
        onChange: o
    }), { getReferenceProps: Q, getFloatingProps: X } = (0, $3ace4598bf8a59b0$export$a519f7794e446ddd)([
        K
    ]), Y = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((P)=>{
        s(P), b.setFloating(P);
    });
    return $6uYXW.createElement($b78d9d7c3cf3d636$var$$.Provider, {
        value: r
    }, $6uYXW.createElement($b78d9d7c3cf3d636$var$y.Provider, {
        value: {
            setFloating: Y,
            setReference: b.setReference,
            styles: S,
            getReferenceProps: Q,
            getFloatingProps: X,
            slot: G
        }
    }, e));
}
function $b78d9d7c3cf3d636$var$ce(e) {
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        if (!e) return;
        let t = new MutationObserver(()=>{
            let n = window.getComputedStyle(e).maxHeight, r = parseFloat(n);
            if (isNaN(r)) return;
            let l = parseInt(n);
            isNaN(l) || r !== l && (e.style.maxHeight = `${Math.ceil(r)}px`);
        });
        return t.observe(e, {
            attributes: !0,
            attributeFilter: [
                "style"
            ]
        }), ()=>{
            t.disconnect();
        };
    }, [
        e
    ]);
}
function $b78d9d7c3cf3d636$var$ge(e, t) {
    var o, u, f;
    let n = $b78d9d7c3cf3d636$var$O((o = e == null ? void 0 : e.gap) != null ? o : "var(--anchor-gap, 0)", t), r = $b78d9d7c3cf3d636$var$O((u = e == null ? void 0 : e.offset) != null ? u : "var(--anchor-offset, 0)", t), l = $b78d9d7c3cf3d636$var$O((f = e == null ? void 0 : e.padding) != null ? f : "var(--anchor-padding, 0)", t);
    return {
        ...e,
        gap: n,
        offset: r,
        padding: l
    };
}
function $b78d9d7c3cf3d636$var$O(e, t, n) {
    let r = (0, $550b4821e7e353bd$export$fd183955ff4b45d9)(), l = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((s, i)=>{
        if (s == null) return [
            n,
            null
        ];
        if (typeof s == "number") return [
            s,
            null
        ];
        if (typeof s == "string") {
            if (!i) return [
                n,
                null
            ];
            let F = $b78d9d7c3cf3d636$var$J(s, i);
            return [
                F,
                (E)=>{
                    let A = $b78d9d7c3cf3d636$var$q(s);
                    {
                        let c = A.map((h)=>window.getComputedStyle(i).getPropertyValue(h));
                        r.requestAnimationFrame(function h() {
                            r.nextFrame(h);
                            let a = !1;
                            for (let [b, S] of A.entries()){
                                let g = window.getComputedStyle(i).getPropertyValue(S);
                                if (c[b] !== g) {
                                    c[b] = g, a = !0;
                                    break;
                                }
                            }
                            if (!a) return;
                            let p = $b78d9d7c3cf3d636$var$J(s, i);
                            F !== p && (E(p), F = p);
                        });
                    }
                    return r.dispose;
                }
            ];
        }
        return [
            n,
            null
        ];
    }), o = (0, $6uYXW.useMemo)(()=>l(e, t)[0], [
        e,
        t
    ]), [u = o, f] = (0, $6uYXW.useState)();
    return (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        let [s, i] = l(e, t);
        if (f(s), !!i) return i(f);
    }, [
        e,
        t
    ]), u;
}
function $b78d9d7c3cf3d636$var$q(e) {
    let t = /var\((.*)\)/.exec(e);
    if (t) {
        let n = t[1].indexOf(",");
        if (n === -1) return [
            t[1]
        ];
        let r = t[1].slice(0, n).trim(), l = t[1].slice(n + 1).trim();
        return l ? [
            r,
            ...$b78d9d7c3cf3d636$var$q(l)
        ] : [
            r
        ];
    }
    return [];
}
function $b78d9d7c3cf3d636$var$J(e, t) {
    let n = document.createElement("div");
    t.appendChild(n), n.style.setProperty("margin-top", "0px", "important"), n.style.setProperty("margin-top", e, "important");
    let r = parseFloat(window.getComputedStyle(n).marginTop) || 0;
    return t.removeChild(n), r;
}





function $fd8c7f19da8b319f$var$u(l) {
    throw new Error("Unexpected object: " + l);
}
var $fd8c7f19da8b319f$export$807a7eae502106e7 = ((i)=>(i[i.First = 0] = "First", i[i.Previous = 1] = "Previous", i[i.Next = 2] = "Next", i[i.Last = 3] = "Last", i[i.Specific = 4] = "Specific", i[i.Nothing = 5] = "Nothing", i))($fd8c7f19da8b319f$export$807a7eae502106e7 || {});
function $fd8c7f19da8b319f$export$c6b4626b54936d5e(l, n) {
    let t = n.resolveItems();
    if (t.length <= 0) return null;
    let r = n.resolveActiveIndex(), s = r != null ? r : -1;
    switch(l.focus){
        case 0:
            for(let e = 0; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 1:
            s === -1 && (s = t.length);
            for(let e = s - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 2:
            for(let e = s + 1; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 3:
            for(let e = t.length - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 4:
            for(let e = 0; e < t.length; ++e)if (n.resolveId(t[e], e, t) === l.id) return e;
            return r;
        case 5:
            return null;
        default:
            $fd8c7f19da8b319f$var$u(l);
    }
}









var $6uYXW = parcelRequire("6uYXW");


var $6uYXW = parcelRequire("6uYXW");




var $6uYXW = parcelRequire("6uYXW");
let $303765c5ac0e0bd6$var$e = (0, $6uYXW.createContext)(void 0);
function $303765c5ac0e0bd6$export$c763bb7a184a0f11() {
    return (0, $6uYXW.useContext)($303765c5ac0e0bd6$var$e);
}
function $303765c5ac0e0bd6$export$a4d3bd77f4efe5ad({ value: t, children: o }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($303765c5ac0e0bd6$var$e.Provider, {
        value: t
    }, o);
}



"use client";
let $1eae8f067ba552e0$var$a = (0, $6uYXW.createContext)(null);
$1eae8f067ba552e0$var$a.displayName = "DescriptionContext";
function $1eae8f067ba552e0$var$f() {
    let r = (0, $6uYXW.useContext)($1eae8f067ba552e0$var$a);
    if (r === null) {
        let e = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(e, $1eae8f067ba552e0$var$f), e;
    }
    return r;
}
function $1eae8f067ba552e0$export$899851af1363628() {
    var r, e;
    return (e = (r = (0, $6uYXW.useContext)($1eae8f067ba552e0$var$a)) == null ? void 0 : r.value) != null ? e : void 0;
}
function $1eae8f067ba552e0$export$babde88292020af7() {
    let [r, e] = (0, $6uYXW.useState)([]);
    return [
        r.length > 0 ? r.join(" ") : void 0,
        (0, $6uYXW.useMemo)(()=>function(t) {
                let i = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((n)=>(e((o)=>[
                            ...o,
                            n
                        ]), ()=>e((o)=>{
                            let s = o.slice(), p = s.indexOf(n);
                            return p !== -1 && s.splice(p, 1), s;
                        }))), l = (0, $6uYXW.useMemo)(()=>({
                        register: i,
                        slot: t.slot,
                        name: t.name,
                        props: t.props,
                        value: t.value
                    }), [
                    i,
                    t.slot,
                    t.name,
                    t.props,
                    t.value
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($1eae8f067ba552e0$var$a.Provider, {
                    value: l
                }, t.children);
            }, [
            e
        ])
    ];
}
let $1eae8f067ba552e0$var$I = "p";
function $1eae8f067ba552e0$var$C(r, e) {
    let c = (0, $6uYXW.useId)(), t = (0, $303765c5ac0e0bd6$export$c763bb7a184a0f11)(), { id: i = `headlessui-description-${c}`, ...l } = r, n = $1eae8f067ba552e0$var$f(), o = (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)(e);
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>n.register(i), [
        i,
        n.register
    ]);
    let s = (0, $fbe56f88477e21c7$export$9d4c57ee4c6ffdd8)({
        ...n.slot,
        disabled: t || !1
    }), p = {
        ref: o,
        ...n.props,
        id: i
    };
    return (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)()({
        ourProps: p,
        theirProps: l,
        slot: s,
        defaultTag: $1eae8f067ba552e0$var$I,
        name: n.name || "Description"
    });
}
let $1eae8f067ba552e0$var$_ = (0, $513e46b2b02099d5$export$e43f39796049410c)($1eae8f067ba552e0$var$C), $1eae8f067ba552e0$export$393edc798c47379d = Object.assign($1eae8f067ba552e0$var$_, {});




var $6uYXW = parcelRequire("6uYXW");


var $6uYXW = parcelRequire("6uYXW");





var $6uYXW = parcelRequire("6uYXW");
let $c50bcf43c5423b2f$var$e = (0, $6uYXW.createContext)(void 0);
function $c50bcf43c5423b2f$export$6ba3910d268310db() {
    return (0, $6uYXW.useContext)($c50bcf43c5423b2f$var$e);
}
function $c50bcf43c5423b2f$export$6be90bcb437e928f({ id: t, children: r }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($c50bcf43c5423b2f$var$e.Provider, {
        value: t
    }, r);
}




"use client";
let $480d43553d3d88f4$var$L = (0, $6uYXW.createContext)(null);
$480d43553d3d88f4$var$L.displayName = "LabelContext";
function $480d43553d3d88f4$export$feddbbf47baabdb9() {
    let n = (0, $6uYXW.useContext)($480d43553d3d88f4$var$L);
    if (n === null) {
        let l = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(l, $480d43553d3d88f4$export$feddbbf47baabdb9), l;
    }
    return n;
}
function $480d43553d3d88f4$export$1f86aee6764cddb2(n) {
    var a, e, o;
    let l = (e = (a = (0, $6uYXW.useContext)($480d43553d3d88f4$var$L)) == null ? void 0 : a.value) != null ? e : void 0;
    return ((o = n == null ? void 0 : n.length) != null ? o : 0) > 0 ? [
        l,
        ...n
    ].filter(Boolean).join(" ") : l;
}
function $480d43553d3d88f4$export$d6875122194c7b44({ inherit: n = !1 } = {}) {
    let l = $480d43553d3d88f4$export$1f86aee6764cddb2(), [a, e] = (0, $6uYXW.useState)([]), o = n ? [
        l,
        ...a
    ].filter(Boolean) : a;
    return [
        o.length > 0 ? o.join(" ") : void 0,
        (0, $6uYXW.useMemo)(()=>function(t) {
                let p = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((i)=>(e((u)=>[
                            ...u,
                            i
                        ]), ()=>e((u)=>{
                            let d = u.slice(), f = d.indexOf(i);
                            return f !== -1 && d.splice(f, 1), d;
                        }))), b = (0, $6uYXW.useMemo)(()=>({
                        register: p,
                        slot: t.slot,
                        name: t.name,
                        props: t.props,
                        value: t.value
                    }), [
                    p,
                    t.slot,
                    t.name,
                    t.props,
                    t.value
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($480d43553d3d88f4$var$L.Provider, {
                    value: b
                }, t.children);
            }, [
            e
        ])
    ];
}
let $480d43553d3d88f4$var$G = "label";
function $480d43553d3d88f4$var$U(n, l) {
    var y;
    let a = (0, $6uYXW.useId)(), e = $480d43553d3d88f4$export$feddbbf47baabdb9(), o = (0, $c50bcf43c5423b2f$export$6ba3910d268310db)(), T = (0, $303765c5ac0e0bd6$export$c763bb7a184a0f11)(), { id: t = `headlessui-label-${a}`, htmlFor: p = o != null ? o : (y = e.props) == null ? void 0 : y.htmlFor, passive: b = !1, ...i } = n, u = (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)(l);
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>e.register(t), [
        t,
        e.register
    ]);
    let d = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((s)=>{
        let g = s.currentTarget;
        if (!(s.target !== s.currentTarget && $36c2319598bace40$export$3dee5e4542c672d9(s.target)) && ($36c2319598bace40$export$42dc0115f0e5e4fc(g) && s.preventDefault(), e.props && "onClick" in e.props && typeof e.props.onClick == "function" && e.props.onClick(s), $36c2319598bace40$export$42dc0115f0e5e4fc(g))) {
            let r = document.getElementById(g.htmlFor);
            if (r) {
                let E = r.getAttribute("disabled");
                if (E === "true" || E === "") return;
                let x = r.getAttribute("aria-disabled");
                if (x === "true" || x === "") return;
                ($36c2319598bace40$export$88a6ceeed5737ba3(r) && (r.type === "file" || r.type === "radio" || r.type === "checkbox") || r.role === "radio" || r.role === "checkbox" || r.role === "switch") && r.click(), r.focus({
                    preventScroll: !0
                });
            }
        }
    }), f = (0, $fbe56f88477e21c7$export$9d4c57ee4c6ffdd8)({
        ...e.slot,
        disabled: T || !1
    }), c = {
        ref: u,
        ...e.props,
        id: t,
        htmlFor: p,
        onClick: d
    };
    return b && ("onClick" in c && (delete c.htmlFor, delete c.onClick), "onClick" in i && delete i.onClick), (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)()({
        ourProps: c,
        theirProps: i,
        slot: f,
        defaultTag: p ? $480d43553d3d88f4$var$G : "div",
        name: e.name || "Label"
    });
}
let $480d43553d3d88f4$var$j = (0, $513e46b2b02099d5$export$e43f39796049410c)($480d43553d3d88f4$var$U), $480d43553d3d88f4$export$b04be29aa201d4f5 = Object.assign($480d43553d3d88f4$var$j, {});



var $6uYXW = parcelRequire("6uYXW");




var $6uYXW = parcelRequire("6uYXW");


function $73cba5e331f72191$export$cd059ee7fd0e9f3d(t) {
    let r = (0, $555339916ec7fe05$export$90fc3a17d93f704c)(t), e = (0, $6uYXW.useRef)(!1);
    (0, $6uYXW.useEffect)(()=>(e.current = !1, ()=>{
            e.current = !0, (0, $6254f9f306b433f5$export$a5ff0d6a738703ca)(()=>{
                e.current && r();
            });
        }), [
        r
    ]);
}





var $6uYXW = parcelRequire("6uYXW");
let $972b2d9fa18d04b6$var$e = (0, $6uYXW.createContext)(!1);
function $972b2d9fa18d04b6$export$6ecd3efa4eebe261() {
    return (0, $6uYXW.useContext)($972b2d9fa18d04b6$var$e);
}
function $972b2d9fa18d04b6$export$8f2af6644e3a3c93(o) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($972b2d9fa18d04b6$var$e.Provider, {
        value: o.force
    }, o.children);
}




"use client";
function $50dad12a3f22a3c2$var$W(e) {
    let o = (0, $972b2d9fa18d04b6$export$6ecd3efa4eebe261)(), l = (0, $6uYXW.useContext)($50dad12a3f22a3c2$var$c), [r, p] = (0, $6uYXW.useState)(()=>{
        var s;
        if (!o && l !== null) return (s = l.current) != null ? s : null;
        if ((0, $76d81e2a3e06b5b5$export$a7b6bc01c63cdfc3).isServer) return null;
        let t = e == null ? void 0 : e.getElementById("headlessui-portal-root");
        if (t) return t;
        if (e === null) return null;
        let n = e.createElement("div");
        return n.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(n);
    });
    return (0, $6uYXW.useEffect)(()=>{
        r !== null && (e != null && e.body.contains(r) || e == null || e.body.appendChild(r));
    }, [
        r,
        e
    ]), (0, $6uYXW.useEffect)(()=>{
        o || l !== null && p(l.current);
    }, [
        l,
        p,
        o
    ]), r;
}
let $50dad12a3f22a3c2$var$_ = (0, $6uYXW.Fragment), $50dad12a3f22a3c2$var$j = (0, $513e46b2b02099d5$export$e43f39796049410c)(function(o, l) {
    let { ownerDocument: r = null, ...p } = o, t = (0, $6uYXW.useRef)(null), n = (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)((0, $c8ac0a774b50c957$export$7029785b750eb74)((a)=>{
        t.current = a;
    }), l), s = (0, $8994b146d9de4c13$export$dd9fbcea3de0ae36)(t.current), C = r != null ? r : s, u = $50dad12a3f22a3c2$var$W(C), y = (0, $6uYXW.useContext)($50dad12a3f22a3c2$var$m), g = (0, $550b4821e7e353bd$export$fd183955ff4b45d9)(), v = (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)();
    return (0, $73cba5e331f72191$export$cd059ee7fd0e9f3d)(()=>{
        var a;
        u && u.childNodes.length <= 0 && ((a = u.parentElement) == null || a.removeChild(u));
    }), u ? (0, $4e60b4008b7e4540$exports.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement("div", {
        "data-headlessui-portal": "",
        ref: (a)=>{
            g.dispose(), y && a && g.add(y.register(a));
        }
    }, v({
        ourProps: {
            ref: n
        },
        theirProps: p,
        slot: {},
        defaultTag: $50dad12a3f22a3c2$var$_,
        name: "Portal"
    })), u) : null;
});
function $50dad12a3f22a3c2$var$S(e, o) {
    let l = (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)(o), { enabled: r = !0, ownerDocument: p, ...t } = e, n = (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)();
    return r ? (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($50dad12a3f22a3c2$var$j, {
        ...t,
        ownerDocument: p,
        ref: l
    }) : n({
        ourProps: {
            ref: l
        },
        theirProps: t,
        slot: {},
        defaultTag: $50dad12a3f22a3c2$var$_,
        name: "Portal"
    });
}
let $50dad12a3f22a3c2$var$I = (0, $6uYXW.Fragment), $50dad12a3f22a3c2$var$c = (0, $6uYXW.createContext)(null);
function $50dad12a3f22a3c2$var$D(e, o) {
    let { target: l, ...r } = e, t = {
        ref: (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)(o)
    }, n = (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($50dad12a3f22a3c2$var$c.Provider, {
        value: l
    }, n({
        ourProps: t,
        theirProps: r,
        defaultTag: $50dad12a3f22a3c2$var$I,
        name: "Popover.Group"
    }));
}
let $50dad12a3f22a3c2$var$m = (0, $6uYXW.createContext)(null);
function $50dad12a3f22a3c2$export$26b8c35244a70b37() {
    let e = (0, $6uYXW.useContext)($50dad12a3f22a3c2$var$m), o = (0, $6uYXW.useRef)([]), l = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((t)=>(o.current.push(t), e && e.register(t), ()=>r(t))), r = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((t)=>{
        let n = o.current.indexOf(t);
        n !== -1 && o.current.splice(n, 1), e && e.unregister(t);
    }), p = (0, $6uYXW.useMemo)(()=>({
            register: l,
            unregister: r,
            portals: o
        }), [
        l,
        r,
        o
    ]);
    return [
        o,
        (0, $6uYXW.useMemo)(()=>function({ children: n }) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($50dad12a3f22a3c2$var$m.Provider, {
                    value: p
                }, n);
            }, [
            p
        ])
    ];
}
let $50dad12a3f22a3c2$var$J = (0, $513e46b2b02099d5$export$e43f39796049410c)($50dad12a3f22a3c2$var$S), $50dad12a3f22a3c2$export$84c667e5e4409848 = (0, $513e46b2b02099d5$export$e43f39796049410c)($50dad12a3f22a3c2$var$D), $50dad12a3f22a3c2$export$602eac185826482c = Object.assign($50dad12a3f22a3c2$var$J, {
    Group: $50dad12a3f22a3c2$export$84c667e5e4409848
});






const $4efd704abd02a8a5$export$6e185a5347a09ebe = {
    Idle: {
        kind: "Idle"
    },
    Tracked: (e)=>({
            kind: "Tracked",
            position: e
        }),
    Moved: {
        kind: "Moved"
    }
};
function $4efd704abd02a8a5$export$988ea8227f238095(e) {
    let t = e.getBoundingClientRect();
    return `${t.x},${t.y}`;
}
function $4efd704abd02a8a5$export$3449027609988d06(e, t, i) {
    let n = (0, $5b6227043c6a88bc$export$12b26c28a05aa001)();
    if (t.kind === "Tracked") {
        let o = function() {
            d !== $4efd704abd02a8a5$export$988ea8227f238095(e) && (n.dispose(), i());
        };
        var f = o;
        let { position: d } = t, s = new ResizeObserver(o);
        s.observe(e), n.add(()=>s.disconnect()), n.addEventListener(window, "scroll", o, {
            passive: !0
        }), n.addEventListener(window, "resize", o);
    }
    return ()=>n.dispose();
}




var $6a44bfeea3d74f80$var$y = Object.defineProperty;
var $6a44bfeea3d74f80$var$M = (e, i, t)=>i in e ? $6a44bfeea3d74f80$var$y(e, i, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[i] = t;
var $6a44bfeea3d74f80$var$S = (e, i, t)=>($6a44bfeea3d74f80$var$M(e, typeof i != "symbol" ? i + "" : i, t), t);
var $6a44bfeea3d74f80$export$b9c7f256f19297fb = ((t)=>(t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))($6a44bfeea3d74f80$export$b9c7f256f19297fb || {}), $6a44bfeea3d74f80$export$604fb2d029447fbb = ((t)=>(t[t.Pointer = 0] = "Pointer", t[t.Other = 1] = "Other", t))($6a44bfeea3d74f80$export$604fb2d029447fbb || {}), $6a44bfeea3d74f80$export$1385d81a6c6bbcd4 = ((o)=>(o[o.OpenMenu = 0] = "OpenMenu", o[o.CloseMenu = 1] = "CloseMenu", o[o.GoToItem = 2] = "GoToItem", o[o.Search = 3] = "Search", o[o.ClearSearch = 4] = "ClearSearch", o[o.RegisterItems = 5] = "RegisterItems", o[o.UnregisterItems = 6] = "UnregisterItems", o[o.SetButtonElement = 7] = "SetButtonElement", o[o.SetItemsElement = 8] = "SetItemsElement", o[o.SortItems = 9] = "SortItems", o[o.MarkButtonAsMoved = 10] = "MarkButtonAsMoved", o))($6a44bfeea3d74f80$export$1385d81a6c6bbcd4 || {});
function $6a44bfeea3d74f80$var$x(e, i = (t)=>t) {
    let t = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, n = (0, $fbf026b0a7ade674$export$20305e96f91bf103)(i(e.items.slice()), (s)=>s.dataRef.current.domRef.current), r = t ? n.indexOf(t) : null;
    return r === -1 && (r = null), {
        items: n,
        activeItemIndex: r
    };
}
let $6a44bfeea3d74f80$var$k = {
    [1] (e) {
        if (e.menuState === 1) return e;
        let i = e.buttonElement ? (0, $4efd704abd02a8a5$export$6e185a5347a09ebe).Tracked((0, $4efd704abd02a8a5$export$988ea8227f238095)(e.buttonElement)) : e.buttonPositionState;
        return {
            ...e,
            activeItemIndex: null,
            pendingFocus: {
                focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Nothing
            },
            menuState: 1,
            buttonPositionState: i
        };
    },
    [0] (e, i) {
        return e.menuState === 0 ? e : {
            ...e,
            __demoMode: !1,
            pendingFocus: i.focus,
            menuState: 0,
            buttonPositionState: (0, $4efd704abd02a8a5$export$6e185a5347a09ebe).Idle
        };
    },
    [2]: (e, i)=>{
        var s, l, a, I, f;
        if (e.menuState === 1) return e;
        let t = {
            ...e,
            searchQuery: "",
            activationTrigger: (s = i.trigger) != null ? s : 1,
            __demoMode: !1
        };
        if (i.focus === (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Nothing) return {
            ...t,
            activeItemIndex: null
        };
        if (i.focus === (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Specific) return {
            ...t,
            activeItemIndex: e.items.findIndex((d)=>d.id === i.id)
        };
        if (i.focus === (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Previous) {
            let d = e.activeItemIndex;
            if (d !== null) {
                let o = e.items[d].dataRef.current.domRef, c = (0, $fd8c7f19da8b319f$export$c6b4626b54936d5e)(i, {
                    resolveItems: ()=>e.items,
                    resolveActiveIndex: ()=>e.activeItemIndex,
                    resolveId: (u)=>u.id,
                    resolveDisabled: (u)=>u.dataRef.current.disabled
                });
                if (c !== null) {
                    let u = e.items[c].dataRef.current.domRef;
                    if (((l = o.current) == null ? void 0 : l.previousElementSibling) === u.current || ((a = u.current) == null ? void 0 : a.previousElementSibling) === null) return {
                        ...t,
                        activeItemIndex: c
                    };
                }
            }
        } else if (i.focus === (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Next) {
            let d = e.activeItemIndex;
            if (d !== null) {
                let o = e.items[d].dataRef.current.domRef, c = (0, $fd8c7f19da8b319f$export$c6b4626b54936d5e)(i, {
                    resolveItems: ()=>e.items,
                    resolveActiveIndex: ()=>e.activeItemIndex,
                    resolveId: (u)=>u.id,
                    resolveDisabled: (u)=>u.dataRef.current.disabled
                });
                if (c !== null) {
                    let u = e.items[c].dataRef.current.domRef;
                    if (((I = o.current) == null ? void 0 : I.nextElementSibling) === u.current || ((f = u.current) == null ? void 0 : f.nextElementSibling) === null) return {
                        ...t,
                        activeItemIndex: c
                    };
                }
            }
        }
        let n = $6a44bfeea3d74f80$var$x(e), r = (0, $fd8c7f19da8b319f$export$c6b4626b54936d5e)(i, {
            resolveItems: ()=>n.items,
            resolveActiveIndex: ()=>n.activeItemIndex,
            resolveId: (d)=>d.id,
            resolveDisabled: (d)=>d.dataRef.current.disabled
        });
        return {
            ...t,
            ...n,
            activeItemIndex: r
        };
    },
    [3]: (e, i)=>{
        let n = e.searchQuery !== "" ? 0 : 1, r = e.searchQuery + i.value.toLowerCase(), l = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + n).concat(e.items.slice(0, e.activeItemIndex + n)) : e.items).find((I)=>{
            var f;
            return ((f = I.dataRef.current.textValue) == null ? void 0 : f.startsWith(r)) && !I.dataRef.current.disabled;
        }), a = l ? e.items.indexOf(l) : -1;
        return a === -1 || a === e.activeItemIndex ? {
            ...e,
            searchQuery: r
        } : {
            ...e,
            searchQuery: r,
            activeItemIndex: a,
            activationTrigger: 1
        };
    },
    [4] (e) {
        return e.searchQuery === "" ? e : {
            ...e,
            searchQuery: "",
            searchActiveItemIndex: null
        };
    },
    [5]: (e, i)=>{
        let t = e.items.concat(i.items.map((r)=>r)), n = e.activeItemIndex;
        return e.pendingFocus.focus !== (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Nothing && (n = (0, $fd8c7f19da8b319f$export$c6b4626b54936d5e)(e.pendingFocus, {
            resolveItems: ()=>t,
            resolveActiveIndex: ()=>e.activeItemIndex,
            resolveId: (r)=>r.id,
            resolveDisabled: (r)=>r.dataRef.current.disabled
        })), {
            ...e,
            items: t,
            activeItemIndex: n,
            pendingFocus: {
                focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Nothing
            },
            pendingShouldSort: !0
        };
    },
    [6]: (e, i)=>{
        let t = e.items, n = [], r = new Set(i.items);
        for (let [s, l] of t.entries())if (r.has(l.id) && (n.push(s), r.delete(l.id), r.size === 0)) break;
        if (n.length > 0) {
            t = t.slice();
            for (let s of n.reverse())t.splice(s, 1);
        }
        return {
            ...e,
            items: t,
            activationTrigger: 1
        };
    },
    [7]: (e, i)=>e.buttonElement === i.element ? e : {
            ...e,
            buttonElement: i.element
        },
    [8]: (e, i)=>e.itemsElement === i.element ? e : {
            ...e,
            itemsElement: i.element
        },
    [9]: (e)=>e.pendingShouldSort ? {
            ...e,
            ...$6a44bfeea3d74f80$var$x(e),
            pendingShouldSort: !1
        } : e,
    [10] (e) {
        return e.buttonPositionState.kind !== "Tracked" ? e : {
            ...e,
            buttonPositionState: (0, $4efd704abd02a8a5$export$6e185a5347a09ebe).Moved
        };
    }
};
class $6a44bfeea3d74f80$export$648f6cb766064520 extends (0, $bf0f3973007a2834$export$f391db14ff2d9279) {
    constructor(t){
        super(t);
        $6a44bfeea3d74f80$var$S(this, "actions", {
            registerItem: (0, $bf0f3973007a2834$export$712ea50be43a7858)(()=>{
                let t = [], n = new Set;
                return [
                    (r, s)=>{
                        n.has(s) || (n.add(s), t.push({
                            id: r,
                            dataRef: s
                        }));
                    },
                    ()=>(n.clear(), this.send({
                            type: 5,
                            items: t.splice(0)
                        }))
                ];
            }),
            unregisterItem: (0, $bf0f3973007a2834$export$712ea50be43a7858)(()=>{
                let t = [];
                return [
                    (n)=>t.push(n),
                    ()=>this.send({
                            type: 6,
                            items: t.splice(0)
                        })
                ];
            })
        });
        $6a44bfeea3d74f80$var$S(this, "selectors", {
            activeDescendantId (t) {
                var s;
                let n = t.activeItemIndex, r = t.items;
                return n === null || (s = r[n]) == null ? void 0 : s.id;
            },
            isActive (t, n) {
                var l;
                let r = t.activeItemIndex, s = t.items;
                return r !== null ? ((l = s[r]) == null ? void 0 : l.id) === n : !1;
            },
            shouldScrollIntoView (t, n) {
                return t.__demoMode || t.menuState !== 0 || t.activationTrigger === 0 ? !1 : this.isActive(t, n);
            },
            didButtonMove (t) {
                return t.buttonPositionState.kind === "Moved";
            }
        });
        this.on(5, ()=>{
            this.disposables.requestAnimationFrame(()=>{
                this.send({
                    type: 9
                });
            });
        });
        {
            let n = this.state.id, r = (0, $742c0ddaeb293345$export$151359021f43c28a).get(null);
            this.disposables.add(r.on((0, $742c0ddaeb293345$export$1385d81a6c6bbcd4).Push, (s)=>{
                !r.selectors.isTop(s, n) && this.state.menuState === 0 && this.send({
                    type: 1
                });
            })), this.on(0, ()=>r.actions.push(n)), this.on(1, ()=>r.actions.pop(n));
        }
        this.disposables.group((n)=>{
            this.on(1, (r)=>{
                r.buttonElement && (n.dispose(), n.add((0, $4efd704abd02a8a5$export$3449027609988d06)(r.buttonElement, r.buttonPositionState, ()=>{
                    this.send({
                        type: 10
                    });
                })));
            });
        });
    }
    static new({ id: t, __demoMode: n = !1 }) {
        return new $6a44bfeea3d74f80$export$648f6cb766064520({
            id: t,
            __demoMode: n,
            menuState: n ? 0 : 1,
            buttonElement: null,
            itemsElement: null,
            items: [],
            searchQuery: "",
            activeItemIndex: null,
            activationTrigger: 1,
            pendingShouldSort: !1,
            pendingFocus: {
                focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Nothing
            },
            buttonPositionState: (0, $4efd704abd02a8a5$export$6e185a5347a09ebe).Idle
        });
    }
    reduce(t, n) {
        return (0, $151185d7717c1097$export$4659b591c19bdf3d)(n.type, $6a44bfeea3d74f80$var$k, t, n);
    }
}



var $6uYXW = parcelRequire("6uYXW");


const $a0333a0cfde50abe$export$c7e742effb1c51e2 = (0, $6uYXW.createContext)(null);
function $a0333a0cfde50abe$export$3be2a17d43f51472(t) {
    let n = (0, $6uYXW.useContext)($a0333a0cfde50abe$export$c7e742effb1c51e2);
    if (n === null) {
        let e = new Error(`<${t} /> is missing a parent <Menu /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(e, $a0333a0cfde50abe$export$f9f36e6f046f8066), e;
    }
    return n;
}
function $a0333a0cfde50abe$export$f9f36e6f046f8066({ id: t, __demoMode: n = !1 }) {
    let e = (0, $6uYXW.useMemo)(()=>(0, $6a44bfeea3d74f80$export$648f6cb766064520).new({
            id: t,
            __demoMode: n
        }), []);
    return (0, $73cba5e331f72191$export$cd059ee7fd0e9f3d)(()=>e.dispose()), e;
}


"use client";
let $0f0f7d0b8832cc2f$var$Ze = (0, $6uYXW.Fragment);
function $0f0f7d0b8832cc2f$var$et(m, y) {
    let l = (0, $6uYXW.useId)(), { __demoMode: a = !1, ...p } = m, s = (0, $a0333a0cfde50abe$export$f9f36e6f046f8066)({
        id: l,
        __demoMode: a
    }), [n, M, f] = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(s, (d)=>[
            d.menuState,
            d.itemsElement,
            d.buttonElement
        ]), _ = (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)(y), o = (0, $742c0ddaeb293345$export$151359021f43c28a).get(null), F = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(o, (0, $6uYXW.useCallback)((d)=>o.selectors.isTop(d, l), [
        o,
        l
    ]));
    (0, $26e1e3973f586229$export$71b2224f1ce5e08e)(F, [
        f,
        M
    ], (d, T)=>{
        var P;
        s.send({
            type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).CloseMenu
        }), (0, $fbf026b0a7ade674$export$ff1ec1c740b3c8d5)(T, (0, $fbf026b0a7ade674$export$27112a34f2f8402d).Loose) || (d.preventDefault(), (P = s.state.buttonElement) == null || P.focus());
    });
    let I = (0, $555339916ec7fe05$export$90fc3a17d93f704c)(()=>{
        s.send({
            type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).CloseMenu
        });
    }), b = (0, $fbe56f88477e21c7$export$9d4c57ee4c6ffdd8)({
        open: n === (0, $6a44bfeea3d74f80$export$b9c7f256f19297fb).Open,
        close: I
    }), i = {
        ref: _
    }, g = (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $b78d9d7c3cf3d636$export$e473aa84737d3250), null, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $a0333a0cfde50abe$export$c7e742effb1c51e2).Provider, {
        value: s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $efd9a985d91b0391$export$2a0ed818b175f558), {
        value: (0, $151185d7717c1097$export$4659b591c19bdf3d)(n, {
            [(0, $6a44bfeea3d74f80$export$b9c7f256f19297fb).Open]: (0, $efd9a985d91b0391$export$7254cc27399e90bd).Open,
            [(0, $6a44bfeea3d74f80$export$b9c7f256f19297fb).Closed]: (0, $efd9a985d91b0391$export$7254cc27399e90bd).Closed
        })
    }, g({
        ourProps: i,
        theirProps: p,
        slot: b,
        defaultTag: $0f0f7d0b8832cc2f$var$Ze,
        name: "Menu"
    }))));
}
let $0f0f7d0b8832cc2f$var$tt = "button";
function $0f0f7d0b8832cc2f$var$ot(m, y) {
    let l = (0, $a0333a0cfde50abe$export$3be2a17d43f51472)("Menu.Button"), a = (0, $6uYXW.useId)(), { id: p = `headlessui-menu-button-${a}`, disabled: s = !1, autoFocus: n = !1, ...M } = m, f = (0, $6uYXW.useRef)(null), _ = (0, $b78d9d7c3cf3d636$export$c7931d5027a8ead4)(), o = (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)(y, f, (0, $b78d9d7c3cf3d636$export$916a28f343467e85)(), (0, $555339916ec7fe05$export$90fc3a17d93f704c)((t)=>l.send({
            type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).SetButtonElement,
            element: t
        }))), F = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((t)=>{
        switch(t.key){
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Space:
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Enter:
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).ArrowDown:
                t.preventDefault(), t.stopPropagation(), l.send({
                    type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).OpenMenu,
                    focus: {
                        focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).First
                    }
                });
                break;
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).ArrowUp:
                t.preventDefault(), t.stopPropagation(), l.send({
                    type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).OpenMenu,
                    focus: {
                        focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Last
                    }
                });
                break;
        }
    }), I = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((t)=>{
        switch(t.key){
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Space:
                t.preventDefault();
                break;
        }
    }), [b, i, g] = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(l, (t)=>[
            t.menuState,
            t.buttonElement,
            t.itemsElement
        ]), d = b === (0, $6a44bfeea3d74f80$export$b9c7f256f19297fb).Open;
    (0, $61338770e1b4369c$export$a46c853b8b55573a)(d, {
        trigger: i,
        action: (0, $6uYXW.useCallback)((t)=>{
            if (i != null && i.contains(t.target)) return (0, $61338770e1b4369c$export$e19cd5f9376f8cee).Ignore;
            let S = t.target.closest('[role="menuitem"]:not([data-disabled])');
            return $36c2319598bace40$export$1b3bfaa9684536aa(S) ? (0, $61338770e1b4369c$export$e19cd5f9376f8cee).Select(S) : g != null && g.contains(t.target) ? (0, $61338770e1b4369c$export$e19cd5f9376f8cee).Ignore : (0, $61338770e1b4369c$export$e19cd5f9376f8cee).Close;
        }, [
            i,
            g
        ]),
        close: (0, $6uYXW.useCallback)(()=>l.send({
                type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).CloseMenu
            }), []),
        select: (0, $6uYXW.useCallback)((t)=>t.click(), [])
    });
    let T = (0, $15a351b74ba7cdc8$export$87bd167e79a089ba)((t)=>{
        var S;
        s || (b === (0, $6a44bfeea3d74f80$export$b9c7f256f19297fb).Open ? ((0, $4e60b4008b7e4540$exports.flushSync)(()=>l.send({
                type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).CloseMenu
            })), (S = f.current) == null || S.focus({
            preventScroll: !0
        })) : (t.preventDefault(), l.send({
            type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).OpenMenu,
            focus: {
                focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Nothing
            },
            trigger: (0, $6a44bfeea3d74f80$export$604fb2d029447fbb).Pointer
        })));
    }), { isFocusVisible: P, focusProps: L } = (0, $63b99e5b44fc4848$export$4e328f61c538687f)({
        autoFocus: n
    }), { isHovered: O, hoverProps: v } = (0, $2c47d83feaa2f132$export$ae780daf29e6d456)({
        isDisabled: s
    }), { pressed: D, pressProps: U } = (0, $2a0752a989a3abf0$export$73224eeef4bbe873)({
        disabled: s
    }), H = (0, $fbe56f88477e21c7$export$9d4c57ee4c6ffdd8)({
        open: b === (0, $6a44bfeea3d74f80$export$b9c7f256f19297fb).Open,
        active: D || b === (0, $6a44bfeea3d74f80$export$b9c7f256f19297fb).Open,
        disabled: s,
        hover: O,
        focus: P,
        autofocus: n
    }), G = (0, $513e46b2b02099d5$export$9d1611c77c2fe928)(_(), {
        ref: o,
        id: p,
        type: (0, $8df6c730accaca48$export$53652b2b272efe9c)(m, f.current),
        "aria-haspopup": "menu",
        "aria-controls": g == null ? void 0 : g.id,
        "aria-expanded": b === (0, $6a44bfeea3d74f80$export$b9c7f256f19297fb).Open,
        disabled: s || void 0,
        autoFocus: n,
        onKeyDown: F,
        onKeyUp: I
    }, T, L, v, U);
    return (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)()({
        ourProps: G,
        theirProps: M,
        slot: H,
        defaultTag: $0f0f7d0b8832cc2f$var$tt,
        name: "Menu.Button"
    });
}
let $0f0f7d0b8832cc2f$var$nt = "div", $0f0f7d0b8832cc2f$var$rt = (0, $513e46b2b02099d5$export$ba0ea3f20e7bf777).RenderStrategy | (0, $513e46b2b02099d5$export$ba0ea3f20e7bf777).Static;
function $0f0f7d0b8832cc2f$var$at(m, y) {
    let l = (0, $6uYXW.useId)(), { id: a = `headlessui-menu-items-${l}`, anchor: p, portal: s = !1, modal: n = !0, transition: M = !1, ...f } = m, _ = (0, $b78d9d7c3cf3d636$export$ee5342e485f0bdb0)(p), o = (0, $a0333a0cfde50abe$export$3be2a17d43f51472)("Menu.Items"), [F, I] = (0, $b78d9d7c3cf3d636$export$aff4be9ef2a28e43)(_), b = (0, $b78d9d7c3cf3d636$export$106e71f938eae412)(), [i, g] = (0, $6uYXW.useState)(null), d = (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)(y, _ ? F : null, (0, $555339916ec7fe05$export$90fc3a17d93f704c)((e)=>o.send({
            type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).SetItemsElement,
            element: e
        })), g), [T, P] = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(o, (e)=>[
            e.menuState,
            e.buttonElement
        ]), L = (0, $8994b146d9de4c13$export$dd9fbcea3de0ae36)(P), O = (0, $8994b146d9de4c13$export$dd9fbcea3de0ae36)(i);
    _ && (s = !0);
    let v = (0, $efd9a985d91b0391$export$fc6fdf0ecf360e)(), [D, U] = (0, $ccac44f91c8229c7$export$7b286972b8d8ccbf)(M, i, v !== null ? (v & (0, $efd9a985d91b0391$export$7254cc27399e90bd).Open) === (0, $efd9a985d91b0391$export$7254cc27399e90bd).Open : T === (0, $6a44bfeea3d74f80$export$b9c7f256f19297fb).Open);
    (0, $0635c499e325c995$export$b41b9097915aa006)(D, P, ()=>{
        o.send({
            type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).CloseMenu
        });
    });
    let H = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(o, (e)=>e.__demoMode), G = H ? !1 : n && T === (0, $6a44bfeea3d74f80$export$b9c7f256f19297fb).Open;
    (0, $df0eaf79c869102e$export$e47ba1b900da5d3b)(G, O);
    let w = H ? !1 : n && T === (0, $6a44bfeea3d74f80$export$b9c7f256f19297fb).Open;
    (0, $09ac2e93626b6281$export$af489fa7e5283cc3)(w, {
        allowed: (0, $6uYXW.useCallback)(()=>[
                P,
                i
            ], [
            P,
            i
        ])
    });
    let S = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(o, o.selectors.didButtonMove) ? !1 : D;
    (0, $6uYXW.useEffect)(()=>{
        let e = i;
        e && T === (0, $6a44bfeea3d74f80$export$b9c7f256f19297fb).Open && ((0, $d76c946db081c9ef$export$8a2eb51c14bb8899)(e) || e.focus({
            preventScroll: !0
        }));
    }, [
        T,
        i
    ]), (0, $398e4c5e66e6a1a3$export$b0abce39eb34b36)(T === (0, $6a44bfeea3d74f80$export$b9c7f256f19297fb).Open, {
        container: i,
        accept (e) {
            return e.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : e.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (e) {
            e.setAttribute("role", "none");
        }
    });
    let z = (0, $550b4821e7e353bd$export$fd183955ff4b45d9)(), le = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((e)=>{
        var N, Y, Z;
        switch(z.dispose(), e.key){
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Space:
                if (o.state.searchQuery !== "") return e.preventDefault(), e.stopPropagation(), o.send({
                    type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).Search,
                    value: e.key
                });
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Enter:
                if (e.preventDefault(), e.stopPropagation(), o.state.activeItemIndex !== null) {
                    let { dataRef: de } = o.state.items[o.state.activeItemIndex];
                    (Y = (N = de.current) == null ? void 0 : N.domRef.current) == null || Y.click();
                }
                o.send({
                    type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).CloseMenu
                }), (0, $fbf026b0a7ade674$export$46388676ec35ab85)(o.state.buttonElement);
                break;
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).ArrowDown:
                return e.preventDefault(), e.stopPropagation(), o.send({
                    type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).GoToItem,
                    focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Next
                });
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).ArrowUp:
                return e.preventDefault(), e.stopPropagation(), o.send({
                    type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).GoToItem,
                    focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Previous
                });
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Home:
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).PageUp:
                return e.preventDefault(), e.stopPropagation(), o.send({
                    type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).GoToItem,
                    focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).First
                });
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).End:
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).PageDown:
                return e.preventDefault(), e.stopPropagation(), o.send({
                    type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).GoToItem,
                    focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Last
                });
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Escape:
                e.preventDefault(), e.stopPropagation(), (0, $4e60b4008b7e4540$exports.flushSync)(()=>o.send({
                        type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).CloseMenu
                    })), (Z = o.state.buttonElement) == null || Z.focus({
                    preventScroll: !0
                });
                break;
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Tab:
                e.preventDefault(), e.stopPropagation(), (0, $4e60b4008b7e4540$exports.flushSync)(()=>o.send({
                        type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).CloseMenu
                    })), (0, $fbf026b0a7ade674$export$7fb6c844b485e870)(o.state.buttonElement, e.shiftKey ? (0, $fbf026b0a7ade674$export$807a7eae502106e7).Previous : (0, $fbf026b0a7ade674$export$807a7eae502106e7).Next);
                break;
            default:
                e.key.length === 1 && (o.send({
                    type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).Search,
                    value: e.key
                }), z.setTimeout(()=>o.send({
                        type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).ClearSearch
                    }), 350));
                break;
        }
    }), pe = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((e)=>{
        switch(e.key){
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Space:
                e.preventDefault();
                break;
        }
    }), ie = (0, $fbe56f88477e21c7$export$9d4c57ee4c6ffdd8)({
        open: T === (0, $6a44bfeea3d74f80$export$b9c7f256f19297fb).Open
    }), ue = (0, $513e46b2b02099d5$export$9d1611c77c2fe928)(_ ? b() : {}, {
        "aria-activedescendant": (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(o, o.selectors.activeDescendantId),
        "aria-labelledby": (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(o, (e)=>{
            var N;
            return (N = e.buttonElement) == null ? void 0 : N.id;
        }),
        id: a,
        onKeyDown: le,
        onKeyUp: pe,
        role: "menu",
        tabIndex: T === (0, $6a44bfeea3d74f80$export$b9c7f256f19297fb).Open ? 0 : void 0,
        ref: d,
        style: {
            ...f.style,
            ...I,
            "--button-width": (0, $ac376574bfb928bb$export$2b86bedf890eab8)(D, P, !0).width
        },
        ...(0, $ccac44f91c8229c7$export$c291d481c40a2fc3)(U)
    }), me = (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $50dad12a3f22a3c2$export$602eac185826482c), {
        enabled: s ? m.static || D : !1,
        ownerDocument: L
    }, me({
        ourProps: ue,
        theirProps: f,
        slot: ie,
        defaultTag: $0f0f7d0b8832cc2f$var$nt,
        features: $0f0f7d0b8832cc2f$var$rt,
        visible: S,
        name: "Menu.Items"
    }));
}
let $0f0f7d0b8832cc2f$var$st = (0, $6uYXW.Fragment);
function $0f0f7d0b8832cc2f$var$lt(m, y) {
    let l = (0, $6uYXW.useId)(), { id: a = `headlessui-menu-item-${l}`, disabled: p = !1, ...s } = m, n = (0, $a0333a0cfde50abe$export$3be2a17d43f51472)("Menu.Item"), M = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(n, (t)=>n.selectors.isActive(t, a)), f = (0, $6uYXW.useRef)(null), _ = (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)(y, f), o = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(n, (t)=>n.selectors.shouldScrollIntoView(t, a));
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        if (o) return (0, $5b6227043c6a88bc$export$12b26c28a05aa001)().requestAnimationFrame(()=>{
            var t, S;
            (S = (t = f.current) == null ? void 0 : t.scrollIntoView) == null || S.call(t, {
                block: "nearest"
            });
        });
    }, [
        o,
        f
    ]);
    let F = (0, $97d669c64d97dbf0$export$f6862afd851a1cf4)(f), I = (0, $6uYXW.useRef)({
        disabled: p,
        domRef: f,
        get textValue () {
            return F();
        }
    });
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        I.current.disabled = p;
    }, [
        I,
        p
    ]), (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>(n.actions.registerItem(a, I), ()=>n.actions.unregisterItem(a)), [
        I,
        a
    ]);
    let b = (0, $555339916ec7fe05$export$90fc3a17d93f704c)(()=>{
        n.send({
            type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).CloseMenu
        });
    }), i = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((t)=>{
        if (p) return t.preventDefault();
        n.send({
            type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).CloseMenu
        }), (0, $fbf026b0a7ade674$export$46388676ec35ab85)(n.state.buttonElement);
    }), g = (0, $555339916ec7fe05$export$90fc3a17d93f704c)(()=>{
        if (p) return n.send({
            type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).GoToItem,
            focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Nothing
        });
        n.send({
            type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).GoToItem,
            focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Specific,
            id: a
        });
    }), d = (0, $2277b68d6ee21509$export$24ebee078bde85c3)(), T = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((t)=>d.update(t)), P = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((t)=>{
        d.wasMoved(t) && (p || M || n.send({
            type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).GoToItem,
            focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Specific,
            id: a,
            trigger: (0, $6a44bfeea3d74f80$export$604fb2d029447fbb).Pointer
        }));
    }), L = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((t)=>{
        d.wasMoved(t) && (p || M && n.state.activationTrigger === (0, $6a44bfeea3d74f80$export$604fb2d029447fbb).Pointer && n.send({
            type: (0, $6a44bfeea3d74f80$export$1385d81a6c6bbcd4).GoToItem,
            focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Nothing
        }));
    }), [O, v] = (0, $480d43553d3d88f4$export$d6875122194c7b44)(), [D, U] = (0, $1eae8f067ba552e0$export$babde88292020af7)(), H = (0, $fbe56f88477e21c7$export$9d4c57ee4c6ffdd8)({
        active: M,
        focus: M,
        disabled: p,
        close: b
    }), G = {
        id: a,
        ref: _,
        role: "menuitem",
        tabIndex: p === !0 ? void 0 : -1,
        "aria-disabled": p === !0 ? !0 : void 0,
        "aria-labelledby": O,
        "aria-describedby": D,
        disabled: void 0,
        onClick: i,
        onFocus: g,
        onPointerEnter: T,
        onMouseEnter: T,
        onPointerMove: P,
        onMouseMove: P,
        onPointerLeave: L,
        onMouseLeave: L
    }, w = (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(v, null, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(U, null, w({
        ourProps: G,
        theirProps: s,
        slot: H,
        defaultTag: $0f0f7d0b8832cc2f$var$st,
        name: "Menu.Item"
    })));
}
let $0f0f7d0b8832cc2f$var$pt = "div";
function $0f0f7d0b8832cc2f$var$it(m, y) {
    let [l, a] = (0, $480d43553d3d88f4$export$d6875122194c7b44)(), p = m, s = {
        ref: y,
        "aria-labelledby": l,
        role: "group"
    }, n = (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(a, null, n({
        ourProps: s,
        theirProps: p,
        slot: {},
        defaultTag: $0f0f7d0b8832cc2f$var$pt,
        name: "Menu.Section"
    }));
}
let $0f0f7d0b8832cc2f$var$ut = "header";
function $0f0f7d0b8832cc2f$var$mt(m, y) {
    let l = (0, $6uYXW.useId)(), { id: a = `headlessui-menu-heading-${l}`, ...p } = m, s = (0, $480d43553d3d88f4$export$feddbbf47baabdb9)();
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>s.register(a), [
        a,
        s.register
    ]);
    let n = {
        id: a,
        ref: y,
        role: "presentation",
        ...s.props
    };
    return (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)()({
        ourProps: n,
        theirProps: p,
        slot: {},
        defaultTag: $0f0f7d0b8832cc2f$var$ut,
        name: "Menu.Heading"
    });
}
let $0f0f7d0b8832cc2f$var$dt = "div";
function $0f0f7d0b8832cc2f$var$Tt(m, y) {
    let l = m, a = {
        ref: y,
        role: "separator"
    };
    return (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)()({
        ourProps: a,
        theirProps: l,
        slot: {},
        defaultTag: $0f0f7d0b8832cc2f$var$dt,
        name: "Menu.Separator"
    });
}
let $0f0f7d0b8832cc2f$var$ct = (0, $513e46b2b02099d5$export$e43f39796049410c)($0f0f7d0b8832cc2f$var$et), $0f0f7d0b8832cc2f$export$266a769812832828 = (0, $513e46b2b02099d5$export$e43f39796049410c)($0f0f7d0b8832cc2f$var$ot), $0f0f7d0b8832cc2f$export$15a41fea157b048a = (0, $513e46b2b02099d5$export$e43f39796049410c)($0f0f7d0b8832cc2f$var$at), $0f0f7d0b8832cc2f$export$2ce376c2cc3355c8 = (0, $513e46b2b02099d5$export$e43f39796049410c)($0f0f7d0b8832cc2f$var$lt), $0f0f7d0b8832cc2f$export$4b1545b4f2016d26 = (0, $513e46b2b02099d5$export$e43f39796049410c)($0f0f7d0b8832cc2f$var$it), $0f0f7d0b8832cc2f$export$ef9631cf12896f8 = (0, $513e46b2b02099d5$export$e43f39796049410c)($0f0f7d0b8832cc2f$var$mt), $0f0f7d0b8832cc2f$export$1cec7dcdd713e220 = (0, $513e46b2b02099d5$export$e43f39796049410c)($0f0f7d0b8832cc2f$var$Tt), $0f0f7d0b8832cc2f$export$d9b273488cd8ce6f = Object.assign($0f0f7d0b8832cc2f$var$ct, {
    Button: $0f0f7d0b8832cc2f$export$266a769812832828,
    Items: $0f0f7d0b8832cc2f$export$15a41fea157b048a,
    Item: $0f0f7d0b8832cc2f$export$2ce376c2cc3355c8,
    Section: $0f0f7d0b8832cc2f$export$4b1545b4f2016d26,
    Heading: $0f0f7d0b8832cc2f$export$ef9631cf12896f8,
    Separator: $0f0f7d0b8832cc2f$export$1cec7dcdd713e220
});


var $6uYXW = parcelRequire("6uYXW");



var $6uYXW = parcelRequire("6uYXW");

function $a4563ad763a0edfc$export$80c2a3957bcb42ea() {
    let e = (0, $6uYXW.useRef)(!1);
    return (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>(e.current = !0, ()=>{
            e.current = !1;
        }), []), e;
}





var $6uYXW = parcelRequire("6uYXW");

function $25a2c7dd5a8e440a$var$s() {
    let r = typeof document == "undefined";
    return "useSyncExternalStore" in $6uYXW ? ((o)=>o.useSyncExternalStore)($6uYXW)(()=>()=>{}, ()=>!1, ()=>!r) : !1;
}
function $25a2c7dd5a8e440a$export$44ab2b9f2d09b0fa() {
    let r = $25a2c7dd5a8e440a$var$s(), [e, n] = $6uYXW.useState((0, $76d81e2a3e06b5b5$export$a7b6bc01c63cdfc3).isHandoffComplete);
    return e && (0, $76d81e2a3e06b5b5$export$a7b6bc01c63cdfc3).isHandoffComplete === !1 && n(!1), $6uYXW.useEffect(()=>{
        e !== !0 && n(!0);
    }, [
        e
    ]), $6uYXW.useEffect(()=>(0, $76d81e2a3e06b5b5$export$a7b6bc01c63cdfc3).handoff(), []), r ? !1 : e;
}








"use client";
function $c4d6508f3241bffd$var$ue(e) {
    var t;
    return !!(e.enter || e.enterFrom || e.enterTo || e.leave || e.leaveFrom || e.leaveTo) || !(0, $513e46b2b02099d5$export$9522e17588c12572)((t = e.as) != null ? t : $c4d6508f3241bffd$var$de) || (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Children.count(e.children) === 1;
}
let $c4d6508f3241bffd$var$V = (0, $6uYXW.createContext)(null);
$c4d6508f3241bffd$var$V.displayName = "TransitionContext";
var $c4d6508f3241bffd$var$De = ((n)=>(n.Visible = "visible", n.Hidden = "hidden", n))($c4d6508f3241bffd$var$De || {});
function $c4d6508f3241bffd$var$He() {
    let e = (0, $6uYXW.useContext)($c4d6508f3241bffd$var$V);
    if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return e;
}
function $c4d6508f3241bffd$var$Ae() {
    let e = (0, $6uYXW.useContext)($c4d6508f3241bffd$var$w);
    if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return e;
}
let $c4d6508f3241bffd$var$w = (0, $6uYXW.createContext)(null);
$c4d6508f3241bffd$var$w.displayName = "NestingContext";
function $c4d6508f3241bffd$var$M(e) {
    return "children" in e ? $c4d6508f3241bffd$var$M(e.children) : e.current.filter(({ el: t })=>t.current !== null).filter(({ state: t })=>t === "visible").length > 0;
}
function $c4d6508f3241bffd$var$Te(e, t) {
    let n = (0, $45cf98b6ba6e8cbc$export$86c4283a11f23f95)(e), l = (0, $6uYXW.useRef)([]), S = (0, $a4563ad763a0edfc$export$80c2a3957bcb42ea)(), R = (0, $550b4821e7e353bd$export$fd183955ff4b45d9)(), d = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((o, i = (0, $513e46b2b02099d5$export$80c0a745e59f7989).Hidden)=>{
        let a = l.current.findIndex(({ el: s })=>s === o);
        a !== -1 && ((0, $151185d7717c1097$export$4659b591c19bdf3d)(i, {
            [(0, $513e46b2b02099d5$export$80c0a745e59f7989).Unmount] () {
                l.current.splice(a, 1);
            },
            [(0, $513e46b2b02099d5$export$80c0a745e59f7989).Hidden] () {
                l.current[a].state = "hidden";
            }
        }), R.microTask(()=>{
            var s;
            !$c4d6508f3241bffd$var$M(l) && S.current && ((s = n.current) == null || s.call(n));
        }));
    }), y = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((o)=>{
        let i = l.current.find(({ el: a })=>a === o);
        return i ? i.state !== "visible" && (i.state = "visible") : l.current.push({
            el: o,
            state: "visible"
        }), ()=>d(o, (0, $513e46b2b02099d5$export$80c0a745e59f7989).Unmount);
    }), C = (0, $6uYXW.useRef)([]), p = (0, $6uYXW.useRef)(Promise.resolve()), h = (0, $6uYXW.useRef)({
        enter: [],
        leave: []
    }), g = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((o, i, a)=>{
        C.current.splice(0), t && (t.chains.current[i] = t.chains.current[i].filter(([s])=>s !== o)), t == null || t.chains.current[i].push([
            o,
            new Promise((s)=>{
                C.current.push(s);
            })
        ]), t == null || t.chains.current[i].push([
            o,
            new Promise((s)=>{
                Promise.all(h.current[i].map(([r, f])=>f)).then(()=>s());
            })
        ]), i === "enter" ? p.current = p.current.then(()=>t == null ? void 0 : t.wait.current).then(()=>a(i)) : a(i);
    }), v = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((o, i, a)=>{
        Promise.all(h.current[i].splice(0).map(([s, r])=>r)).then(()=>{
            var s;
            (s = C.current.shift()) == null || s();
        }).then(()=>a(i));
    });
    return (0, $6uYXW.useMemo)(()=>({
            children: l,
            register: y,
            unregister: d,
            onStart: g,
            onStop: v,
            wait: p,
            chains: h
        }), [
        y,
        d,
        l,
        g,
        v,
        h,
        p
    ]);
}
let $c4d6508f3241bffd$var$de = (0, $6uYXW.Fragment), $c4d6508f3241bffd$var$fe = (0, $513e46b2b02099d5$export$ba0ea3f20e7bf777).RenderStrategy;
function $c4d6508f3241bffd$var$Fe(e, t) {
    var ee, te;
    let { transition: n = !0, beforeEnter: l, afterEnter: S, beforeLeave: R, afterLeave: d, enter: y, enterFrom: C, enterTo: p, entered: h, leave: g, leaveFrom: v, leaveTo: o, ...i } = e, [a, s] = (0, $6uYXW.useState)(null), r = (0, $6uYXW.useRef)(null), f = $c4d6508f3241bffd$var$ue(e), U = (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)(...f ? [
        r,
        t,
        s
    ] : t === null ? [] : [
        t
    ]), H = (ee = i.unmount) == null || ee ? (0, $513e46b2b02099d5$export$80c0a745e59f7989).Unmount : (0, $513e46b2b02099d5$export$80c0a745e59f7989).Hidden, { show: u, appear: z, initial: K } = $c4d6508f3241bffd$var$He(), [m, j] = (0, $6uYXW.useState)(u ? "visible" : "hidden"), Q = $c4d6508f3241bffd$var$Ae(), { register: A, unregister: F } = Q;
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>A(r), [
        A,
        r
    ]), (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        if (H === (0, $513e46b2b02099d5$export$80c0a745e59f7989).Hidden && r.current) {
            if (u && m !== "visible") {
                j("visible");
                return;
            }
            return (0, $151185d7717c1097$export$4659b591c19bdf3d)(m, {
                ["hidden"]: ()=>F(r),
                ["visible"]: ()=>A(r)
            });
        }
    }, [
        m,
        r,
        A,
        F,
        u,
        H
    ]);
    let G = (0, $25a2c7dd5a8e440a$export$44ab2b9f2d09b0fa)();
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        if (f && G && m === "visible" && r.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [
        r,
        m,
        G,
        f
    ]);
    let ce = K && !z, Y = z && u && K, B = (0, $6uYXW.useRef)(!1), I = $c4d6508f3241bffd$var$Te(()=>{
        B.current || (j("hidden"), F(r));
    }, Q), Z = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((W)=>{
        B.current = !0;
        let L = W ? "enter" : "leave";
        I.onStart(r, L, (_)=>{
            _ === "enter" ? l == null || l() : _ === "leave" && (R == null || R());
        });
    }), $ = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((W)=>{
        let L = W ? "enter" : "leave";
        B.current = !1, I.onStop(r, L, (_)=>{
            _ === "enter" ? S == null || S() : _ === "leave" && (d == null || d());
        }), L === "leave" && !$c4d6508f3241bffd$var$M(I) && (j("hidden"), F(r));
    });
    (0, $6uYXW.useEffect)(()=>{
        f && n || (Z(u), $(u));
    }, [
        u,
        f,
        n
    ]);
    let pe = (()=>!(!n || !f || !G || ce))(), [, T] = (0, $ccac44f91c8229c7$export$7b286972b8d8ccbf)(pe, a, u, {
        start: Z,
        end: $
    }), Ce = (0, $513e46b2b02099d5$export$8e16b83750b44988)({
        ref: U,
        className: ((te = (0, $393ff8b6ca113c61$export$ce4ab0c55987d1ff)(i.className, Y && y, Y && C, T.enter && y, T.enter && T.closed && C, T.enter && !T.closed && p, T.leave && g, T.leave && !T.closed && v, T.leave && T.closed && o, !T.transition && u && h)) == null ? void 0 : te.trim()) || void 0,
        ...(0, $ccac44f91c8229c7$export$c291d481c40a2fc3)(T)
    }), N = 0;
    m === "visible" && (N |= (0, $efd9a985d91b0391$export$7254cc27399e90bd).Open), m === "hidden" && (N |= (0, $efd9a985d91b0391$export$7254cc27399e90bd).Closed), u && m === "hidden" && (N |= (0, $efd9a985d91b0391$export$7254cc27399e90bd).Opening), !u && m === "visible" && (N |= (0, $efd9a985d91b0391$export$7254cc27399e90bd).Closing);
    let he = (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($c4d6508f3241bffd$var$w.Provider, {
        value: I
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $efd9a985d91b0391$export$2a0ed818b175f558), {
        value: N
    }, he({
        ourProps: Ce,
        theirProps: i,
        defaultTag: $c4d6508f3241bffd$var$de,
        features: $c4d6508f3241bffd$var$fe,
        visible: m === "visible",
        name: "Transition.Child"
    })));
}
function $c4d6508f3241bffd$var$Ie(e, t) {
    let { show: n, appear: l = !1, unmount: S = !0, ...R } = e, d = (0, $6uYXW.useRef)(null), y = $c4d6508f3241bffd$var$ue(e), C = (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)(...y ? [
        d,
        t
    ] : t === null ? [] : [
        t
    ]);
    (0, $25a2c7dd5a8e440a$export$44ab2b9f2d09b0fa)();
    let p = (0, $efd9a985d91b0391$export$fc6fdf0ecf360e)();
    if (n === void 0 && p !== null && (n = (p & (0, $efd9a985d91b0391$export$7254cc27399e90bd).Open) === (0, $efd9a985d91b0391$export$7254cc27399e90bd).Open), n === void 0) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [h, g] = (0, $6uYXW.useState)(n ? "visible" : "hidden"), v = $c4d6508f3241bffd$var$Te(()=>{
        n || g("hidden");
    }), [o, i] = (0, $6uYXW.useState)(!0), a = (0, $6uYXW.useRef)([
        n
    ]);
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        o !== !1 && a.current[a.current.length - 1] !== n && (a.current.push(n), i(!1));
    }, [
        a,
        n
    ]);
    let s = (0, $6uYXW.useMemo)(()=>({
            show: n,
            appear: l,
            initial: o
        }), [
        n,
        l,
        o
    ]);
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        n ? g("visible") : !$c4d6508f3241bffd$var$M(v) && d.current !== null && g("hidden");
    }, [
        n,
        v
    ]);
    let r = {
        unmount: S
    }, f = (0, $555339916ec7fe05$export$90fc3a17d93f704c)(()=>{
        var u;
        o && i(!1), (u = e.beforeEnter) == null || u.call(e);
    }), U = (0, $555339916ec7fe05$export$90fc3a17d93f704c)(()=>{
        var u;
        o && i(!1), (u = e.beforeLeave) == null || u.call(e);
    }), H = (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($c4d6508f3241bffd$var$w.Provider, {
        value: v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($c4d6508f3241bffd$var$V.Provider, {
        value: s
    }, H({
        ourProps: {
            ...r,
            as: (0, $6uYXW.Fragment),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($c4d6508f3241bffd$var$me, {
                ref: C,
                ...r,
                ...R,
                beforeEnter: f,
                beforeLeave: U
            })
        },
        theirProps: {},
        defaultTag: (0, $6uYXW.Fragment),
        features: $c4d6508f3241bffd$var$fe,
        visible: h === "visible",
        name: "Transition"
    })));
}
function $c4d6508f3241bffd$var$Le(e, t) {
    let n = (0, $6uYXW.useContext)($c4d6508f3241bffd$var$V) !== null, l = (0, $efd9a985d91b0391$export$fc6fdf0ecf360e)() !== null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Fragment, null, !n && l ? (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($c4d6508f3241bffd$var$X, {
        ref: t,
        ...e
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($c4d6508f3241bffd$var$me, {
        ref: t,
        ...e
    }));
}
let $c4d6508f3241bffd$var$X = (0, $513e46b2b02099d5$export$e43f39796049410c)($c4d6508f3241bffd$var$Ie), $c4d6508f3241bffd$var$me = (0, $513e46b2b02099d5$export$e43f39796049410c)($c4d6508f3241bffd$var$Fe), $c4d6508f3241bffd$export$b8acc0f6b9e8ca5d = (0, $513e46b2b02099d5$export$e43f39796049410c)($c4d6508f3241bffd$var$Le), $c4d6508f3241bffd$export$be58926105124dd4 = Object.assign($c4d6508f3241bffd$var$X, {
    Child: $c4d6508f3241bffd$export$b8acc0f6b9e8ca5d,
    Root: $c4d6508f3241bffd$var$X
});



var $6uYXW = parcelRequire("6uYXW");
function $8bb878504f29e766$var$Bars3Icon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $6uYXW.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $6uYXW.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $6uYXW.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    }));
}
const $8bb878504f29e766$var$ForwardRef = /*#__PURE__*/ $6uYXW.forwardRef($8bb878504f29e766$var$Bars3Icon);
var $8bb878504f29e766$export$2e2bcd8739ae039 = $8bb878504f29e766$var$ForwardRef;


var $6uYXW = parcelRequire("6uYXW");
function $d1d6c6decb486f9a$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $6uYXW.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $6uYXW.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $6uYXW.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 18 18 6M6 6l12 12"
    }));
}
const $d1d6c6decb486f9a$var$ForwardRef = /*#__PURE__*/ $6uYXW.forwardRef($d1d6c6decb486f9a$var$XMarkIcon);
var $d1d6c6decb486f9a$export$2e2bcd8739ae039 = $d1d6c6decb486f9a$var$ForwardRef;



var $6uYXW = parcelRequire("6uYXW");


parcelRequire("6uYXW");
const $95b38580b50577cd$var$SvgTandemLogoHorizontal = (props)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        id: "tandem-logo-horizontal_svg__Layer_1",
        viewBox: "0 0 720 167.76",
        ...props,
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("style", {
                    children: ".tandem-logo-horizontal_svg__cls-1{fill:#112131}.tandem-logo-horizontal_svg__cls-2{fill:#3bbcda}"
                })
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("path", {
                d: "M226.14 98.38V58.72c0-2.24-.81-3.36-2.64-3.36-5.7 0-13.32.2-21.56.91-1.12.1-1.63-.1-1.42-.81l1.52-6.31c.1-.71.31-1.22 1.32-1.12 6.61.21 9.66.21 26.34.21h10.27c16.37 0 19.73 0 26.34-.21 1.02-.1 1.22.21 1.02 1.12l-1.12 6.51c-.1.51-.41.71-1.53.61-8.24-.71-15.15-.91-20.54-.91-1.83 0-2.65 1.12-2.65 3.36v39.66c0 8.24.51 15.26.71 21.05h-16.68c.31-5.8.61-12.82.61-21.05ZM347.28 119.43h-15.87l-6.82-15.15c-1.22-2.85-2.03-2.95-4.78-2.95h-19.93c-3.05 0-4.17 0-5.19 2.95l-5.29 15.15h-9.76c2.34-5.09 4.78-10.07 6.92-15.15l16.88-38.85c2.95-6.81 4.78-12.41 5.19-16.17.1-.92 7.22-2.14 7.53-1.42l24.2 56.65c2.24 5.09 4.37 9.87 6.92 14.95Zm-27.36-26.34-10.17-24.51-10.17 24.51c-.61 1.42.71 1.73 2.03 1.73h16.27c1.32 0 2.65-.3 2.03-1.73ZM438 119.43h-3.76c-1.02 0-1.73-.1-2.44-.92l-48.1-47.19v16.27c0 10.58.1 19.22.61 31.83h-9.05c.51-12.61.61-21.25.61-31.83v-7.32c0-14.34-.21-22.58-1.12-30.71-.1-.92.1-1.32.91-1.32h3.66c1.02 0 1.73.1 2.44.91l48.2 47.29V80.07c0-10.58-.1-19.22-.61-31.83h9.05c-.51 12.61-.61 21.25-.61 31.83v7.32c0 14.34.2 22.58 1.12 30.71.1.92-.11 1.32-.92 1.32ZM471.46 119.43c.3-5.8.61-12.82.61-21.05V69.29c0-8.24-.3-15.25-.61-21.05 9.97.3 22.98-.21 27.97-.21 23.8 0 37.93 14.75 37.93 34.17s-13.43 37.42-38.04 37.42c-4.78 0-17.9-.51-27.87-.2Zm51.05-30c0-20.44-10.17-35.39-29.69-35.39-3.25 0-5.8 1.02-5.8 4.78v48.51c0 4.27 4.88 6.31 11.69 6.31 17.8 0 23.8-8.14 23.8-24.2ZM591.16 119.12c-6.71 0-17.39 0-27.35.3.3-5.8.61-12.82.61-21.05V69.28c0-8.24-.3-15.25-.61-21.05 9.97.3 20.54.3 26.74.3 4.27 0 12 0 20.14-.51 1.02-.1 1.22.21 1.02 1.12l-1.42 6c-.1.51-.41.61-1.53.51-9.46-.81-16.17-1.32-23.9-1.32-3.46 0-5.09 1.12-5.18 3.86-.21 4.37-.3 8.24-.3 12.31v6.51c0 2.65 1.32 3.15 3.35 3.15h1.83c8.04 0 13.12-.1 18.81-.81.81-.1 1.22.4.81 1.32l-2.03 5.49c-.3 1.12-.91 1.12-2.24 1.02-3.86-.3-10.88-.71-16.27-.71h-.92c-2.04 0-3.35.51-3.35 3.15v7.53c0 4.07 0 7.83.3 12.21.2 2.74 1.73 3.86 5.18 3.86 8.24 0 16.58-.81 26.04-1.63 1.12-.1 1.63 0 1.53.51l-1.22 6.41c-.2.92-.2 1.22-1.02 1.12-8.13-.51-13.22-.51-19.02-.51M718.6 119.43h-15.77c-.4-9.97-.81-19.93-1.42-29.9l-.81-12.31-15.15 30.1c-2.03 3.87-3.25 8.04-3.66 9.36-.51 1.32-2.85 1.53-5.09 1.53s-2.85-.3-3.46-1.53L650.76 75.8l-.51 13.73c-.41 9.97-.71 19.93-1.02 29.9h-8.85c.91-9.97 1.83-19.93 2.44-29.9l2.44-40.88c.1-2.03 3.97-2.23 5.29 0l30.1 53.8 27.66-53.8c1.12-2.23 5.39-2.03 5.49-.1l2.65 40.98c.51 9.97 1.22 19.93 2.14 29.9Z",
                className: "tandem-logo-horizontal_svg__cls-1"
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("rect", {
                width: 120.03,
                height: 120.03,
                x: 24.08,
                y: 23.71,
                className: "tandem-logo-horizontal_svg__cls-1",
                rx: 5.68,
                ry: 5.68,
                transform: "rotate(45 84.091 83.722)"
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("path", {
                d: "M102.92 17.67 84.1 36.49 65.28 17.67l-14.2 14.2L69.9 50.69 59.24 61.35a5.44 5.44 0 0 0-.34 7.33l8.37 10.07c.72.87 2.04.93 2.84.13L84.1 64.89l14.2-14.2 18.82-18.82zM150.14 64.9l-14.2-14.2-18.82 18.82-10.06-10.07a5.44 5.44 0 0 0-7.33-.34l-10.07 8.37c-.87.72-.93 2.04-.13 2.84l46.42 46.42 14.2-14.2-18.82-18.82 18.82-18.82ZM78.79 97.24 32.25 50.7l-14.2 14.2 18.82 18.82-18.82 18.82 14.2 14.2 18.82-18.82 10.18 10.18a5.44 5.44 0 0 0 7.33.34l10.07-8.37c.87-.72.93-2.04.13-2.84ZM117.12 135.57 98.3 116.75l10.06-10.06a5.44 5.44 0 0 0 .34-7.33l-8.37-10.07c-.72-.87-2.04-.93-2.84-.13l-46.42 46.42 14.2 14.2 18.82-18.82 18.82 18.82 14.2-14.2Z",
                className: "tandem-logo-horizontal_svg__cls-2"
            })
        ]
    });
var $95b38580b50577cd$export$2e2bcd8739ae039 = $95b38580b50577cd$var$SvgTandemLogoHorizontal;



var $491b3e7eff402de2$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $491b3e7eff402de2$var$INFINITY = 1 / 0;
/** `Object#toString` result references. */ var $491b3e7eff402de2$var$symbolTag = '[object Symbol]';
/** Detect free variable `global` from Node.js. */ var $491b3e7eff402de2$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $491b3e7eff402de2$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $491b3e7eff402de2$var$root = $491b3e7eff402de2$var$freeGlobal || $491b3e7eff402de2$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $491b3e7eff402de2$var$objectProto = Object.prototype;
/** Used to generate unique IDs. */ var $491b3e7eff402de2$var$idCounter = 0;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $491b3e7eff402de2$var$objectToString = $491b3e7eff402de2$var$objectProto.toString;
/** Built-in value references. */ var $491b3e7eff402de2$var$Symbol = $491b3e7eff402de2$var$root.Symbol;
/** Used to convert symbols to primitives and strings. */ var $491b3e7eff402de2$var$symbolProto = $491b3e7eff402de2$var$Symbol ? $491b3e7eff402de2$var$Symbol.prototype : undefined, $491b3e7eff402de2$var$symbolToString = $491b3e7eff402de2$var$symbolProto ? $491b3e7eff402de2$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $491b3e7eff402de2$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($491b3e7eff402de2$var$isSymbol(value)) return $491b3e7eff402de2$var$symbolToString ? $491b3e7eff402de2$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$491b3e7eff402de2$var$INFINITY ? '-0' : result;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $491b3e7eff402de2$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $491b3e7eff402de2$var$isSymbol(value) {
    return typeof value == 'symbol' || $491b3e7eff402de2$var$isObjectLike(value) && $491b3e7eff402de2$var$objectToString.call(value) == $491b3e7eff402de2$var$symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $491b3e7eff402de2$var$toString(value) {
    return value == null ? '' : $491b3e7eff402de2$var$baseToString(value);
}
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $491b3e7eff402de2$var$uniqueId(prefix) {
    var id = ++$491b3e7eff402de2$var$idCounter;
    return $491b3e7eff402de2$var$toString(prefix) + id;
}
$491b3e7eff402de2$exports = $491b3e7eff402de2$var$uniqueId;


var $bb817058aecadce6$exports = {};
'use strict';
var $ec413cd653ea5dbe$exports = {};
'use strict';
var $ec413cd653ea5dbe$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== 'object' || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var $ec413cd653ea5dbe$var$createStore = function createStore(createState) {
    return createState ? $ec413cd653ea5dbe$var$createStoreImpl(createState) : $ec413cd653ea5dbe$var$createStoreImpl;
};
var $ec413cd653ea5dbe$var$vanilla = function(createState) {
    return $ec413cd653ea5dbe$var$createStore(createState);
};
$ec413cd653ea5dbe$exports.createStore = $ec413cd653ea5dbe$var$createStore;
$ec413cd653ea5dbe$exports.default = $ec413cd653ea5dbe$var$vanilla;
$ec413cd653ea5dbe$exports = $ec413cd653ea5dbe$var$vanilla;
$ec413cd653ea5dbe$exports.createStore = $ec413cd653ea5dbe$var$createStore;
$ec413cd653ea5dbe$exports.default = $ec413cd653ea5dbe$exports;



var $6uYXW = parcelRequire("6uYXW");
var $0ac3176be14f59c2$exports = {};
'use strict';

$0ac3176be14f59c2$exports = (parcelRequire("aZSdd"));


var $bb817058aecadce6$var$useDebugValue = $6uYXW.useDebugValue;
var $bb817058aecadce6$var$useSyncExternalStoreWithSelector = $0ac3176be14f59c2$exports.useSyncExternalStoreWithSelector;
var $bb817058aecadce6$var$didWarnAboutEqualityFn = false;
var $bb817058aecadce6$var$identity = function identity(arg) {
    return arg;
};
function $bb817058aecadce6$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = $bb817058aecadce6$var$identity;
    var slice = $bb817058aecadce6$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $bb817058aecadce6$var$useDebugValue(slice);
    return slice;
}
var $bb817058aecadce6$var$createImpl = function createImpl(createState) {
    var api = typeof createState === 'function' ? $ec413cd653ea5dbe$exports.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $bb817058aecadce6$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $bb817058aecadce6$var$create = function create(createState) {
    return createState ? $bb817058aecadce6$var$createImpl(createState) : $bb817058aecadce6$var$createImpl;
};
var $bb817058aecadce6$var$react = function(createState) {
    return $bb817058aecadce6$var$create(createState);
};
$bb817058aecadce6$exports.create = $bb817058aecadce6$var$create;
$bb817058aecadce6$exports.default = $bb817058aecadce6$var$react;
$bb817058aecadce6$exports.useStore = $bb817058aecadce6$var$useStore;
Object.keys($ec413cd653ea5dbe$exports).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call($bb817058aecadce6$exports, k)) Object.defineProperty($bb817058aecadce6$exports, k, {
        enumerable: true,
        get: function() {
            return $ec413cd653ea5dbe$exports[k];
        }
    });
});
$bb817058aecadce6$exports = $bb817058aecadce6$var$react;
$bb817058aecadce6$exports.create = $bb817058aecadce6$var$create;
$bb817058aecadce6$exports.useStore = $bb817058aecadce6$var$useStore;
$bb817058aecadce6$exports.createStore = $ec413cd653ea5dbe$exports.createStore;
$bb817058aecadce6$exports.default = $bb817058aecadce6$exports;


const $8460a3ee79a43e41$export$aa94277a9804d2bd = (0, $bb817058aecadce6$exports.create)((set, get)=>({
        notifications: [],
        showSuccess: (message)=>{
            const { notifications: notifications } = get();
            const notifId = (0, (/*@__PURE__*/$parcel$interopDefault($491b3e7eff402de2$exports)))('notif-');
            notifications.push({
                id: notifId,
                message: message,
                isShown: true,
                type: 'success'
            });
            set({
                notifications: [
                    ...notifications
                ]
            });
            setTimeout(()=>{
                const { notifications: notifications } = get();
                const ind = notifications.findIndex(({ id: id })=>id === notifId);
                if (ind >= 0) notifications[ind].isShown = false;
                set({
                    notifications: [
                        ...notifications
                    ]
                });
            }, 3000);
            setTimeout(()=>{
                const { notifications: notifications } = get();
                const ind = notifications.findIndex(({ id: id })=>id === notifId);
                if (ind >= 0) notifications.splice(ind, 1);
                set({
                    notifications: [
                        ...notifications
                    ]
                });
            }, 3500);
        },
        showError: (message)=>{
            const { notifications: notifications } = get();
            const notifId = (0, (/*@__PURE__*/$parcel$interopDefault($491b3e7eff402de2$exports)))('notif-');
            notifications.push({
                id: notifId,
                message: message,
                isShown: true,
                type: 'error'
            });
            set({
                notifications: [
                    ...notifications
                ]
            });
            setTimeout(()=>{
                const { notifications: notifications } = get();
                const ind = notifications.findIndex(({ id: id })=>id === notifId);
                if (ind >= 0) notifications[ind].isShown = false;
                set({
                    notifications: [
                        ...notifications
                    ]
                });
            }, 5000);
            setTimeout(()=>{
                const { notifications: notifications } = get();
                const ind = notifications.findIndex(({ id: id })=>id === notifId);
                if (ind >= 0) notifications.splice(ind, 1);
                set({
                    notifications: [
                        ...notifications
                    ]
                });
            }, 5500);
        },
        clearAll: ()=>{
            set({
                notifications: []
            });
        }
    }));





var $6uYXW = parcelRequire("6uYXW");
function $3fe1004080f52094$var$CheckCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $6uYXW.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $6uYXW.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $6uYXW.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $3fe1004080f52094$var$ForwardRef = /*#__PURE__*/ $6uYXW.forwardRef($3fe1004080f52094$var$CheckCircleIcon);
var $3fe1004080f52094$export$2e2bcd8739ae039 = $3fe1004080f52094$var$ForwardRef;


var $6uYXW = parcelRequire("6uYXW");
function $9daba32d9a6b5b9a$var$ExclamationCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $6uYXW.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $6uYXW.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $6uYXW.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
    }));
}
const $9daba32d9a6b5b9a$var$ForwardRef = /*#__PURE__*/ $6uYXW.forwardRef($9daba32d9a6b5b9a$var$ExclamationCircleIcon);
var $9daba32d9a6b5b9a$export$2e2bcd8739ae039 = $9daba32d9a6b5b9a$var$ForwardRef;


var $d7456dac8e72de90$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($d7456dac8e72de90$exports) {
        classNames.default = classNames;
        $d7456dac8e72de90$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


var $ea834b5e286ecd0d$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ea834b5e286ecd0d$var$ReactIs, $ea834b5e286ecd0d$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$ea834b5e286ecd0d$exports = (parcelRequire("eaGJn"))();



var $6uYXW = parcelRequire("6uYXW");
const $7260414d8677517a$var$Notification = ({ isShown: isShown = true, type: type, message: message })=>{
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c4d6508f3241bffd$export$be58926105124dd4), {
        show: isShown,
        as: (0, $6uYXW.Fragment),
        enter: "transform ease-out duration-300 transition",
        enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
        enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
        leave: "transition ease-in duration-100",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
            role: "alert",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d7456dac8e72de90$exports)))('alert', {
                'alert-success': type === 'success',
                'alert-error': type === 'error'
            }),
            children: [
                type === 'success' && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $3fe1004080f52094$export$2e2bcd8739ae039), {
                    className: "w-6 h-6",
                    "aria-hidden": "true"
                }),
                type === 'error' && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $9daba32d9a6b5b9a$export$2e2bcd8739ae039), {
                    className: "w-6 h-6",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                    children: message
                })
            ]
        })
    });
};
$7260414d8677517a$var$Notification.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).string,
    message: (0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).string,
    isShown: (0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).bool
};
var $7260414d8677517a$export$2e2bcd8739ae039 = $7260414d8677517a$var$Notification;


const $4ae29c767235f602$var$NotificationsContainer = ()=>{
    const notifications = (0, $8460a3ee79a43e41$export$aa94277a9804d2bd)((state)=>state.notifications);
    if (notifications.length === 0) return null;
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
        className: "z-50 w-96 toast toast-top toast-end",
        children: notifications.map((notification)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $7260414d8677517a$export$2e2bcd8739ae039), {
                ...notification
            }, notification.id))
    });
};
var $4ae29c767235f602$export$2e2bcd8739ae039 = $4ae29c767235f602$var$NotificationsContainer;



var $f52005c5eeccb4c4$exports = {};
/*! js-cookie v3.0.5 | MIT */ (function(global, factory) {
    $f52005c5eeccb4c4$exports = factory();
})($f52005c5eeccb4c4$exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});



const $411dbc53a58dde5c$export$84b02e82de41af9a = 'scclientsessid';
const $411dbc53a58dde5c$export$d9aa07b2354f0f02 = 'scclientuserid';
const $411dbc53a58dde5c$export$cc885caaa8b7ab4e = (0, $bb817058aecadce6$exports.create)((set, get)=>({
        user: undefined,
        session: {
            id: (0, (/*@__PURE__*/$parcel$interopDefault($f52005c5eeccb4c4$exports))).get($411dbc53a58dde5c$export$84b02e82de41af9a),
            userId: (0, (/*@__PURE__*/$parcel$interopDefault($f52005c5eeccb4c4$exports))).get($411dbc53a58dde5c$export$d9aa07b2354f0f02)
        },
        isSignedIn: ()=>!!get().session?.id && !!get().session?.userId && !!get().user?.id,
        signIn: async (credentials)=>{
            const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).post('/clients/login?include=user', credentials);
            set({
                session: data,
                user: data.user
            });
            const createdAt = new Date(data.created);
            const expiresAt = new Date(createdAt.getTime() + data.ttl * 1000);
            (0, (/*@__PURE__*/$parcel$interopDefault($f52005c5eeccb4c4$exports))).set($411dbc53a58dde5c$export$84b02e82de41af9a, data.id, {
                expires: expiresAt
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($f52005c5eeccb4c4$exports))).set($411dbc53a58dde5c$export$d9aa07b2354f0f02, data.userId, {
                expires: expiresAt
            });
            (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).defaults.headers.common['Authorization'] = data.id;
        },
        // Exchange a single-use access token (from an emailed link) for a session.
        // Mirrors signIn's cookie/header setup; the response carries no user, so the
        // user object is loaded lazily via verifyUser when needed.
        tokenLogin: async (accessToken)=>{
            const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).post('/clients/token-login', {
                accessToken: accessToken
            });
            set({
                session: data
            });
            const createdAt = new Date(data.created);
            const expiresAt = new Date(createdAt.getTime() + data.ttl * 1000);
            (0, (/*@__PURE__*/$parcel$interopDefault($f52005c5eeccb4c4$exports))).set($411dbc53a58dde5c$export$84b02e82de41af9a, data.id, {
                expires: expiresAt
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($f52005c5eeccb4c4$exports))).set($411dbc53a58dde5c$export$d9aa07b2354f0f02, data.userId, {
                expires: expiresAt
            });
            (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).defaults.headers.common['Authorization'] = data.id;
        },
        verifyUser: async ()=>{
            const token = (0, (/*@__PURE__*/$parcel$interopDefault($f52005c5eeccb4c4$exports))).get($411dbc53a58dde5c$export$84b02e82de41af9a);
            const userId = (0, (/*@__PURE__*/$parcel$interopDefault($f52005c5eeccb4c4$exports))).get($411dbc53a58dde5c$export$d9aa07b2354f0f02);
            const user = get().user;
            if (token && userId && !user) try {
                (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).defaults.headers.common['Authorization'] = token;
                const { data: userData } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get(`/clients/${userId}`);
                set({
                    user: {
                        ...userData
                    }
                });
            } catch (err) {
                // fall through, old token, etc.
                set({
                    user: undefined
                });
                delete (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).defaults.headers.common['Authorization'];
            }
        },
        updateUser: (updatedUser)=>{
            set({
                user: updatedUser
            });
        },
        signInWithoutCreds: async (username, security_answers)=>{
            const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).post(`/clients/security-answers`, {
                username: username,
                security_answers: security_answers
            });
            set({
                session: {
                    ...data,
                    id: data.access_token,
                    userId: data.client_id
                }
            });
            const createdAt = new Date(data.created);
            const expiresAt = new Date(createdAt.getTime() + data.ttl * 1000);
            (0, (/*@__PURE__*/$parcel$interopDefault($f52005c5eeccb4c4$exports))).set($411dbc53a58dde5c$export$84b02e82de41af9a, data.access_token, {
                expires: expiresAt
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($f52005c5eeccb4c4$exports))).set($411dbc53a58dde5c$export$d9aa07b2354f0f02, data.client_id, {
                expires: expiresAt
            });
            (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).defaults.headers.common['Authorization'] = data.id;
        },
        signOut: ()=>{
            delete (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).defaults.headers.common['Authorization'];
            (0, (/*@__PURE__*/$parcel$interopDefault($f52005c5eeccb4c4$exports))).remove($411dbc53a58dde5c$export$84b02e82de41af9a);
            (0, (/*@__PURE__*/$parcel$interopDefault($f52005c5eeccb4c4$exports))).remove($411dbc53a58dde5c$export$d9aa07b2354f0f02);
            set({
                session: undefined,
                user: undefined
            });
        }
    }));


function $ce7ce7b7f0e3cbea$var$classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}
const $ce7ce7b7f0e3cbea$var$Layout = ()=>{
    const { isSignedIn: isSignedIn } = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e)();
    return(// Full-height flex column so the footer stays at the viewport bottom even
    // when the page content is shorter than the screen.
    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "flex flex-col min-h-screen",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $a736ddedb241f228$export$74a362b31437ec83), {
                as: "nav",
                children: ({ open: open })=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $32c03629429003d8$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                className: "px-4 mx-auto max-w-7xl sm:px-6 lg:px-8",
                                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "flex justify-between h-16",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                            className: "flex",
                                            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                                className: "flex items-center flex-shrink-0",
                                                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                                    className: "text-4xl logo btn btn-ghost",
                                                    to: "/",
                                                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $95b38580b50577cd$export$2e2bcd8739ae039), {
                                                        className: "w-auto h-10"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                            className: "hidden sm:ml-6 sm:flex sm:items-center",
                                            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $0f0f7d0b8832cc2f$export$d9b273488cd8ce6f), {
                                                as: "div",
                                                className: "relative ml-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                                        className: "mr-4",
                                                        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $0f0f7d0b8832cc2f$export$266a769812832828), {
                                                            className: "relative flex p-2 text-sm bg-white rounded-md btn btn-ghost focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                                                                    className: "absolute -inset-1.5"
                                                                }),
                                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                                                                    className: "sr-only",
                                                                    children: "Open user menu"
                                                                }),
                                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $8bb878504f29e766$export$2e2bcd8739ae039), {
                                                                    className: "block w-6 h-6",
                                                                    "aria-hidden": "true"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c4d6508f3241bffd$export$be58926105124dd4), {
                                                        as: (0, $6uYXW.Fragment),
                                                        enter: "transition ease-out duration-200",
                                                        enterFrom: "transform opacity-0 scale-95",
                                                        enterTo: "transform opacity-100 scale-100",
                                                        leave: "transition ease-in duration-75",
                                                        leaveFrom: "transform opacity-100 scale-100",
                                                        leaveTo: "transform opacity-0 scale-95",
                                                        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $0f0f7d0b8832cc2f$export$15a41fea157b048a), {
                                                            className: "absolute right-0 z-10 w-48 py-1 mt-2 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
                                                            children: isSignedIn() ? /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $32c03629429003d8$exports.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $0f0f7d0b8832cc2f$export$2ce376c2cc3355c8), {
                                                                        children: ({ active: active })=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                                                                to: "/home",
                                                                                className: $ce7ce7b7f0e3cbea$var$classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700'),
                                                                                children: "Home"
                                                                            })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $0f0f7d0b8832cc2f$export$2ce376c2cc3355c8), {
                                                                        children: ({ active: active })=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                                                                to: "/profile",
                                                                                className: $ce7ce7b7f0e3cbea$var$classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700'),
                                                                                children: "Your Profile"
                                                                            })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $0f0f7d0b8832cc2f$export$2ce376c2cc3355c8), {
                                                                        children: ({ active: active })=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                                                                to: "/personalFinances",
                                                                                className: $ce7ce7b7f0e3cbea$var$classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700'),
                                                                                children: "Personal Finances"
                                                                            })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $0f0f7d0b8832cc2f$export$2ce376c2cc3355c8), {
                                                                        children: ({ active: active })=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                                                                to: "/assessments",
                                                                                className: $ce7ce7b7f0e3cbea$var$classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700'),
                                                                                children: "Questionnaires"
                                                                            })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $0f0f7d0b8832cc2f$export$1cec7dcdd713e220), {}),
                                                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $0f0f7d0b8832cc2f$export$2ce376c2cc3355c8), {
                                                                        children: ({ active: active })=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                                                                to: "/logout",
                                                                                className: $ce7ce7b7f0e3cbea$var$classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700'),
                                                                                children: "Sign out"
                                                                            })
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $0f0f7d0b8832cc2f$export$2ce376c2cc3355c8), {
                                                                children: ({ active: active })=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                                                        to: "/login",
                                                                        className: $ce7ce7b7f0e3cbea$var$classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700'),
                                                                        children: "Sign in"
                                                                    })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                            className: "flex items-center -mr-2 sm:hidden",
                                            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $a736ddedb241f228$export$4edbb1575344e6fc), {
                                                className: "relative inline-flex items-center justify-center p-2 text-gray-400 rounded-md hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                                                        className: "absolute -inset-0.5"
                                                    }),
                                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Open main menu"
                                                    }),
                                                    open ? /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $d1d6c6decb486f9a$export$2e2bcd8739ae039), {
                                                        className: "block w-6 h-6",
                                                        "aria-hidden": "true"
                                                    }) : /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $8bb878504f29e766$export$2e2bcd8739ae039), {
                                                        className: "block w-6 h-6",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $a736ddedb241f228$export$feabaa331e1d464c), {
                                className: "sm:hidden",
                                children: ({ close: close })=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                        className: "pt-4 pb-3 border-t border-gray-200",
                                        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                            className: "mt-3 space-y-1",
                                            children: isSignedIn() ? /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $32c03629429003d8$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                                        to: "/profile",
                                                        className: "block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800",
                                                        onClick: close,
                                                        children: "Your Profile"
                                                    }),
                                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                                        to: "/logout",
                                                        className: "block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800",
                                                        children: "Sign out"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                                to: "/login",
                                                className: "block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800",
                                                onClick: close,
                                                children: "Sign in"
                                            })
                                        })
                                    })
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "flex-1 outlet",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $88be82bcdaab0750$export$910ae8079b2c2852), {})
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("footer", {
                className: "p-4 footer footer-center",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("aside", {
                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("p", {
                        children: [
                            "\xa9 ",
                            new Date().getFullYear(),
                            " Tandem, Build",
                            ' ',
                            "77"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $4ae29c767235f602$export$2e2bcd8739ae039), {})
        ]
    }));
};
var $ce7ce7b7f0e3cbea$export$2e2bcd8739ae039 = $ce7ce7b7f0e3cbea$var$Layout;




var $dDyyD = parcelRequire("dDyyD");


var $6uYXW = parcelRequire("6uYXW");


const $5c7f6f99ffebc2a8$var$RequireAuth = ({ children: children })=>{
    const { session: session, user: user, verifyUser: verifyUser } = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e)();
    const location = (0, $88be82bcdaab0750$export$45d76561a5302f2b)();
    (0, $6uYXW.useEffect)(()=>{
        if (!user && session) verifyUser();
    }, [
        user,
        session
    ]);
    if (!user && (0, (/*@__PURE__*/$parcel$interopDefault($dDyyD)))(session) || user && (0, (/*@__PURE__*/$parcel$interopDefault($dDyyD)))(session) || !user && (!session.userId || !session.id)) // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $88be82bcdaab0750$export$444b3ab0cb9aec40), {
        to: "/login",
        state: {
            from: location
        },
        replace: true
    });
    else if (!user && !(0, (/*@__PURE__*/$parcel$interopDefault($dDyyD)))(session)) // show loader while verifying and loading user data
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
        className: "fixed top-0 left-0 z-50 w-full h-full bg-white opacity-75",
        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
            className: "mt-[50vh] flex items-center justify-center",
            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "inline-block h-6 w-6 animate-spin rounded-full border-[3px] border-current border-t-transparent text-primary-600",
                role: "status",
                "aria-label": "loading",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                    className: "sr-only",
                    children: "Loading..."
                })
            })
        })
    });
    return children;
};
$5c7f6f99ffebc2a8$var$RequireAuth.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).element
};
var $5c7f6f99ffebc2a8$export$2e2bcd8739ae039 = $5c7f6f99ffebc2a8$var$RequireAuth;









var $070a12c6f2c59ce6$var$_client, $070a12c6f2c59ce6$var$_currentQuery, $070a12c6f2c59ce6$var$_currentQueryInitialState, $070a12c6f2c59ce6$var$_currentResult, $070a12c6f2c59ce6$var$_currentResultState, $070a12c6f2c59ce6$var$_currentResultOptions, $070a12c6f2c59ce6$var$_selectError, $070a12c6f2c59ce6$var$_selectFn, $070a12c6f2c59ce6$var$_selectResult, $070a12c6f2c59ce6$var$_lastQueryWithDefinedData, $070a12c6f2c59ce6$var$_staleTimeoutId, $070a12c6f2c59ce6$var$_refetchIntervalId, $070a12c6f2c59ce6$var$_currentRefetchInterval, $070a12c6f2c59ce6$var$_trackedProps, $070a12c6f2c59ce6$var$_executeFetch, $070a12c6f2c59ce6$var$executeFetch_fn, $070a12c6f2c59ce6$var$_updateStaleTimeout, $070a12c6f2c59ce6$var$updateStaleTimeout_fn, $070a12c6f2c59ce6$var$_computeRefetchInterval, $070a12c6f2c59ce6$var$computeRefetchInterval_fn, $070a12c6f2c59ce6$var$_updateRefetchInterval, $070a12c6f2c59ce6$var$updateRefetchInterval_fn, $070a12c6f2c59ce6$var$_updateTimers, $070a12c6f2c59ce6$var$updateTimers_fn, $070a12c6f2c59ce6$var$_clearStaleTimeout, $070a12c6f2c59ce6$var$clearStaleTimeout_fn, $070a12c6f2c59ce6$var$_clearRefetchInterval, $070a12c6f2c59ce6$var$clearRefetchInterval_fn, $070a12c6f2c59ce6$var$_updateQuery, $070a12c6f2c59ce6$var$updateQuery_fn, $070a12c6f2c59ce6$var$_notify, $070a12c6f2c59ce6$var$notify_fn;
var $070a12c6f2c59ce6$export$a06cf8c0066f0d4c = class extends (0, $6164943b6c12fe94$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_executeFetch);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_updateStaleTimeout);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_computeRefetchInterval);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_updateRefetchInterval);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_updateTimers);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_clearStaleTimeout);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_clearRefetchInterval);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_updateQuery);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_notify);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_client, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_currentQuery, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_currentQueryInitialState, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_currentResult, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_currentResultState, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_currentResultOptions, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_selectError, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_selectFn, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_selectResult, void 0);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_lastQueryWithDefinedData, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_staleTimeoutId, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_refetchIntervalId, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_currentRefetchInterval, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $070a12c6f2c59ce6$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_client, client);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_selectError, null);
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery).addObserver(this);
            if ($070a12c6f2c59ce6$var$shouldFetchOnMount((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery), this.options)) (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_executeFetch, $070a12c6f2c59ce6$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_updateTimers, $070a12c6f2c59ce6$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $070a12c6f2c59ce6$var$shouldFetchOn((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $070a12c6f2c59ce6$var$shouldFetchOn((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_clearStaleTimeout, $070a12c6f2c59ce6$var$clearStaleTimeout_fn).call(this);
        (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_clearRefetchInterval, $070a12c6f2c59ce6$var$clearRefetchInterval_fn).call(this);
        (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery).removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery);
        this.options = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
        (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_updateQuery, $070a12c6f2c59ce6$var$updateQuery_fn).call(this);
        (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $91075ea0d0756915$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $070a12c6f2c59ce6$var$shouldFetchOptionally((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_executeFetch, $070a12c6f2c59ce6$var$executeFetch_fn).call(this);
        this.updateResult(notifyOptions);
        if (mounted && ((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_updateStaleTimeout, $070a12c6f2c59ce6$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_computeRefetchInterval, $070a12c6f2c59ce6$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentRefetchInterval))) (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_updateRefetchInterval, $070a12c6f2c59ce6$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_client).getQueryCache().build((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_client), options);
        const result = this.createResult(query, options);
        if ($070a12c6f2c59ce6$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_currentResult, result);
            (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_currentResultOptions, this.options);
            (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_currentResultState, (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentResult);
    }
    trackResult(result, onPropTracked) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackProp(key);
                    onPropTracked == null || onPropTracked(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    trackProp(key) {
        (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_client).defaultQueryOptions(options);
        const query = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_client).getQueryCache().build((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_client), defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_executeFetch, $070a12c6f2c59ce6$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentResult);
        const prevResultState = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentResultState);
        const prevResultOptions = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQueryInitialState);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $070a12c6f2c59ce6$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $070a12c6f2c59ce6$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $ea6601bddc61dbe3$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        if (options.select && newState.data !== void 0) {
            if (prevResult && newState.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_selectFn)) data = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_selectResult);
            else try {
                (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_selectFn, options.select);
                data = options.select(newState.data);
                data = (0, $91075ea0d0756915$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_selectResult, data);
                (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_selectError, null);
            } catch (selectError) {
                (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_selectError, selectError);
            }
        } else data = newState.data;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_lastQueryWithDefinedData)) : options.placeholderData;
                if (options.select && placeholderData !== void 0) try {
                    placeholderData = options.select(placeholderData);
                    (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_selectError, null);
                } catch (selectError) {
                    (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_selectError, selectError);
                }
            }
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $91075ea0d0756915$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if ((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_selectError)) {
            error = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_selectError);
            data = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $070a12c6f2c59ce6$var$isStale(query, options),
            refetch: this.refetch
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentResult);
        const nextResult = this.createResult((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery), this.options);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_currentResultState, (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery).state);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_currentResultOptions, this.options);
        if ((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentResultState).data !== void 0) (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_lastQueryWithDefinedData, (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery));
        if ((0, $91075ea0d0756915$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_currentResult, nextResult);
        const defaultNotifyOptions = {};
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_notify, $070a12c6f2c59ce6$var$notify_fn).call(this, {
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_updateTimers, $070a12c6f2c59ce6$var$updateTimers_fn).call(this);
    }
};
$070a12c6f2c59ce6$var$_client = new WeakMap();
$070a12c6f2c59ce6$var$_currentQuery = new WeakMap();
$070a12c6f2c59ce6$var$_currentQueryInitialState = new WeakMap();
$070a12c6f2c59ce6$var$_currentResult = new WeakMap();
$070a12c6f2c59ce6$var$_currentResultState = new WeakMap();
$070a12c6f2c59ce6$var$_currentResultOptions = new WeakMap();
$070a12c6f2c59ce6$var$_selectError = new WeakMap();
$070a12c6f2c59ce6$var$_selectFn = new WeakMap();
$070a12c6f2c59ce6$var$_selectResult = new WeakMap();
$070a12c6f2c59ce6$var$_lastQueryWithDefinedData = new WeakMap();
$070a12c6f2c59ce6$var$_staleTimeoutId = new WeakMap();
$070a12c6f2c59ce6$var$_refetchIntervalId = new WeakMap();
$070a12c6f2c59ce6$var$_currentRefetchInterval = new WeakMap();
$070a12c6f2c59ce6$var$_trackedProps = new WeakMap();
$070a12c6f2c59ce6$var$_executeFetch = new WeakSet();
$070a12c6f2c59ce6$var$executeFetch_fn = function(fetchOptions) {
    (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_updateQuery, $070a12c6f2c59ce6$var$updateQuery_fn).call(this);
    let promise = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $91075ea0d0756915$export$8793edee2d425525));
    return promise;
};
$070a12c6f2c59ce6$var$_updateStaleTimeout = new WeakSet();
$070a12c6f2c59ce6$var$updateStaleTimeout_fn = function() {
    (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_clearStaleTimeout, $070a12c6f2c59ce6$var$clearStaleTimeout_fn).call(this);
    if ((0, $91075ea0d0756915$export$6acf61af03e62db) || (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentResult).isStale || !(0, $91075ea0d0756915$export$e539f754e934e270)(this.options.staleTime)) return;
    const time = (0, $91075ea0d0756915$export$811b83d62bcf47f0)((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentResult).dataUpdatedAt, this.options.staleTime);
    const timeout = time + 1;
    (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_staleTimeoutId, setTimeout(()=>{
        if (!(0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$070a12c6f2c59ce6$var$_computeRefetchInterval = new WeakSet();
$070a12c6f2c59ce6$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$070a12c6f2c59ce6$var$_updateRefetchInterval = new WeakSet();
$070a12c6f2c59ce6$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_clearRefetchInterval, $070a12c6f2c59ce6$var$clearRefetchInterval_fn).call(this);
    (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_currentRefetchInterval, nextInterval);
    if ((0, $91075ea0d0756915$export$6acf61af03e62db) || this.options.enabled === false || !(0, $91075ea0d0756915$export$e539f754e934e270)((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentRefetchInterval)) || (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentRefetchInterval) === 0) return;
    (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_refetchIntervalId, setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $b217e2cdf935894d$export$6bf54661be5b02cf).isFocused()) (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_executeFetch, $070a12c6f2c59ce6$var$executeFetch_fn).call(this);
    }, (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentRefetchInterval)));
};
$070a12c6f2c59ce6$var$_updateTimers = new WeakSet();
$070a12c6f2c59ce6$var$updateTimers_fn = function() {
    (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_updateStaleTimeout, $070a12c6f2c59ce6$var$updateStaleTimeout_fn).call(this);
    (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_updateRefetchInterval, $070a12c6f2c59ce6$var$updateRefetchInterval_fn).call(this, (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $070a12c6f2c59ce6$var$_computeRefetchInterval, $070a12c6f2c59ce6$var$computeRefetchInterval_fn).call(this));
};
$070a12c6f2c59ce6$var$_clearStaleTimeout = new WeakSet();
$070a12c6f2c59ce6$var$clearStaleTimeout_fn = function() {
    if ((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_staleTimeoutId)) {
        clearTimeout((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_staleTimeoutId));
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_staleTimeoutId, void 0);
    }
};
$070a12c6f2c59ce6$var$_clearRefetchInterval = new WeakSet();
$070a12c6f2c59ce6$var$clearRefetchInterval_fn = function() {
    if ((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_refetchIntervalId)) {
        clearInterval((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_refetchIntervalId));
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_refetchIntervalId, void 0);
    }
};
$070a12c6f2c59ce6$var$_updateQuery = new WeakSet();
$070a12c6f2c59ce6$var$updateQuery_fn = function() {
    const query = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_client).getQueryCache().build((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_client), this.options);
    if (query === (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery)) return;
    const prevQuery = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery);
    (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_currentQuery, query);
    (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $070a12c6f2c59ce6$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$070a12c6f2c59ce6$var$_notify = new WeakSet();
$070a12c6f2c59ce6$var$notify_fn = function(notifyOptions) {
    (0, $ca19c9b496b64b93$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentResult));
        });
        (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_client).getQueryCache().notify({
            query: (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $070a12c6f2c59ce6$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $070a12c6f2c59ce6$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $070a12c6f2c59ce6$var$shouldFetchOnMount(query, options) {
    return $070a12c6f2c59ce6$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $070a12c6f2c59ce6$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $070a12c6f2c59ce6$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $070a12c6f2c59ce6$var$isStale(query, options);
    }
    return false;
}
function $070a12c6f2c59ce6$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $070a12c6f2c59ce6$var$isStale(query, options);
}
function $070a12c6f2c59ce6$var$isStale(query, options) {
    return options.enabled !== false && query.isStaleByTime(options.staleTime);
}
function $070a12c6f2c59ce6$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $91075ea0d0756915$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $6uYXW = parcelRequire("6uYXW");


var $6uYXW = parcelRequire("6uYXW");

"use client";
function $cd83007a9ea55b55$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $cd83007a9ea55b55$var$QueryErrorResetBoundaryContext = $6uYXW.createContext($cd83007a9ea55b55$var$createValue());
var $cd83007a9ea55b55$export$50dfac555130cafd = ()=>$6uYXW.useContext($cd83007a9ea55b55$var$QueryErrorResetBoundaryContext);
var $cd83007a9ea55b55$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $6uYXW.useState(()=>$cd83007a9ea55b55$var$createValue());
    return /* @__PURE__ */ (0, $32c03629429003d8$exports.jsx)($cd83007a9ea55b55$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};




var $6uYXW = parcelRequire("6uYXW");
"use client";
var $53d8d8ba8e3b6265$var$IsRestoringContext = $6uYXW.createContext(false);
var $53d8d8ba8e3b6265$export$4da0178d6b5f553 = ()=>$6uYXW.useContext($53d8d8ba8e3b6265$var$IsRestoringContext);
var $53d8d8ba8e3b6265$export$593807d4e94f9621 = $53d8d8ba8e3b6265$var$IsRestoringContext.Provider;



var $6uYXW = parcelRequire("6uYXW");
// src/utils.ts
function $d5bdeafed6b3345e$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}
function $d5bdeafed6b3345e$export$8793edee2d425525() {}


"use client";
var $bc3422952273e750$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $bc3422952273e750$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $6uYXW.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $bc3422952273e750$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (0, $d5bdeafed6b3345e$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]);
};


// src/suspense.ts
var $26fdfbea3575e147$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $26fdfbea3575e147$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1e3;
    }
};
var $26fdfbea3575e147$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $26fdfbea3575e147$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var $26fdfbea3575e147$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $347c8102c1d992e9$export$fff0865807e996c5(options, Observer, queryClient) {
    const client = (0, $8136cc1e66cf8798$export$22e77b9572c4fded)(queryClient);
    const isRestoring = (0, $53d8d8ba8e3b6265$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $cd83007a9ea55b55$export$50dfac555130cafd)();
    const defaultedOptions = client.defaultQueryOptions(options);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $26fdfbea3575e147$export$2c40a591ad2dafb1)(defaultedOptions);
    (0, $bc3422952273e750$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $bc3422952273e750$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $6uYXW.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    $6uYXW.useSyncExternalStore($6uYXW.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>void 0 : observer.subscribe((0, $ca19c9b496b64b93$export$520687f44db6e1ab).batchCalls(onStoreChange));
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $6uYXW.useEffect(()=>{
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $26fdfbea3575e147$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $26fdfbea3575e147$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $bc3422952273e750$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash)
    })) throw result.error;
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $b505c391aa3d7eba$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $347c8102c1d992e9$export$fff0865807e996c5)(options, (0, $070a12c6f2c59ce6$export$a06cf8c0066f0d4c), queryClient);
}




const $da3a3fc2c3487546$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $da3a3fc2c3487546$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $da3a3fc2c3487546$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $53cd9215d6a52cb5$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $98cb436cf7d72acc$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $98cb436cf7d72acc$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $98cb436cf7d72acc$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $98cb436cf7d72acc$export$cbf60ecb96cbb82f = {
    date: (0, $53cd9215d6a52cb5$export$38e44e97ce4dbb7d)({
        formats: $98cb436cf7d72acc$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $53cd9215d6a52cb5$export$38e44e97ce4dbb7d)({
        formats: $98cb436cf7d72acc$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $53cd9215d6a52cb5$export$38e44e97ce4dbb7d)({
        formats: $98cb436cf7d72acc$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $9e5862328993d442$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $9e5862328993d442$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$9e5862328993d442$var$formatRelativeLocale[token];


/* eslint-disable no-unused-vars */ /**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $ad2c407c986026f9$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $bed8b7ce43c87334$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $bed8b7ce43c87334$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $bed8b7ce43c87334$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $bed8b7ce43c87334$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $bed8b7ce43c87334$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $bed8b7ce43c87334$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $bed8b7ce43c87334$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $bed8b7ce43c87334$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $bed8b7ce43c87334$var$ordinalNumber,
    era: (0, $ad2c407c986026f9$export$63596d6ee8878b25)({
        values: $bed8b7ce43c87334$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $ad2c407c986026f9$export$63596d6ee8878b25)({
        values: $bed8b7ce43c87334$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $ad2c407c986026f9$export$63596d6ee8878b25)({
        values: $bed8b7ce43c87334$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $ad2c407c986026f9$export$63596d6ee8878b25)({
        values: $bed8b7ce43c87334$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $ad2c407c986026f9$export$63596d6ee8878b25)({
        values: $bed8b7ce43c87334$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $bed8b7ce43c87334$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $9c4d1568dc4aacac$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $9c4d1568dc4aacac$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $9c4d1568dc4aacac$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $9c4d1568dc4aacac$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $9c4d1568dc4aacac$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $735cfabe4b224726$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $4473904048b26e62$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $4473904048b26e62$var$parseOrdinalNumberPattern = /\d+/i;
const $4473904048b26e62$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $4473904048b26e62$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $4473904048b26e62$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $4473904048b26e62$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $4473904048b26e62$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $4473904048b26e62$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $4473904048b26e62$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $4473904048b26e62$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $4473904048b26e62$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $4473904048b26e62$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $4473904048b26e62$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $735cfabe4b224726$export$fdaf2fd6d7edde95)({
        matchPattern: $4473904048b26e62$var$matchOrdinalNumberPattern,
        parsePattern: $4473904048b26e62$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $9c4d1568dc4aacac$export$1430a0f35710914d)({
        matchPatterns: $4473904048b26e62$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4473904048b26e62$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $9c4d1568dc4aacac$export$1430a0f35710914d)({
        matchPatterns: $4473904048b26e62$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4473904048b26e62$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $9c4d1568dc4aacac$export$1430a0f35710914d)({
        matchPatterns: $4473904048b26e62$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4473904048b26e62$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $9c4d1568dc4aacac$export$1430a0f35710914d)({
        matchPatterns: $4473904048b26e62$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4473904048b26e62$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $9c4d1568dc4aacac$export$1430a0f35710914d)({
        matchPatterns: $4473904048b26e62$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $4473904048b26e62$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $742ada657cc1d5be$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $da3a3fc2c3487546$export$2c14ff85d6318973),
    formatLong: (0, $98cb436cf7d72acc$export$cbf60ecb96cbb82f),
    formatRelative: (0, $9e5862328993d442$export$8fbbfd65594f46a0),
    localize: (0, $bed8b7ce43c87334$export$b3bd0bc58e36cd63),
    match: (0, $4473904048b26e62$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$742ada657cc1d5be$export$2e2bcd8739ae039 = $742ada657cc1d5be$export$137380d9ce54f7f;


let $0dc874e9bc9ff3dd$var$defaultOptions = {};
function $0dc874e9bc9ff3dd$export$430a3269e24b912e() {
    return $0dc874e9bc9ff3dd$var$defaultOptions;
}
function $0dc874e9bc9ff3dd$export$95365be1b0704abc(newOptions) {
    $0dc874e9bc9ff3dd$var$defaultOptions = newOptions;
}


/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $2920700654fb9eb4$export$dfd9b671c89acc8e = 7;
const $2920700654fb9eb4$export$3913210603d8e9ae = 365.2425;
const $2920700654fb9eb4$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $2920700654fb9eb4$export$4dec998e48f9c246 = -$2920700654fb9eb4$export$81caae6e1cc7a622;
const $2920700654fb9eb4$export$4fad13613e88edc8 = 604800000;
const $2920700654fb9eb4$export$b76b1809a2898f9a = 86400000;
const $2920700654fb9eb4$export$91246f0b9bd9beff = 60000;
const $2920700654fb9eb4$export$7f72910d6dfd237a = 3600000;
const $2920700654fb9eb4$export$397c2d5776aa9055 = 1000;
const $2920700654fb9eb4$export$3633035e63cee86a = 525600;
const $2920700654fb9eb4$export$ab7da2ccd1075c38 = 43200;
const $2920700654fb9eb4$export$2423174df8cd3cd2 = 1440;
const $2920700654fb9eb4$export$f2f5ae5a8e2d8f9f = 60;
const $2920700654fb9eb4$export$3c58128db900d44e = 3;
const $2920700654fb9eb4$export$80d7e435f744f319 = 12;
const $2920700654fb9eb4$export$4db7641526e3241f = 4;
const $2920700654fb9eb4$export$698aec755e92c695 = 3600;
const $2920700654fb9eb4$export$a77c1a7ebebe2a5a = 60;
const $2920700654fb9eb4$export$815a9362476d2fe3 = $2920700654fb9eb4$export$698aec755e92c695 * 24;
const $2920700654fb9eb4$export$34804a017b31e2fe = $2920700654fb9eb4$export$815a9362476d2fe3 * 7;
const $2920700654fb9eb4$export$7271e9e3478110d1 = $2920700654fb9eb4$export$815a9362476d2fe3 * $2920700654fb9eb4$export$3913210603d8e9ae;
const $2920700654fb9eb4$export$8e6600bbdee7dabb = $2920700654fb9eb4$export$7271e9e3478110d1 / 12;
const $2920700654fb9eb4$export$be1dccf2de902d31 = $2920700654fb9eb4$export$8e6600bbdee7dabb * 3;


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $e4a95432db4c1b05$export$e67a095c620b86fe(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}
var // Fallback for modularized imports:
$e4a95432db4c1b05$export$2e2bcd8739ae039 = $e4a95432db4c1b05$export$e67a095c620b86fe;


function $434e7621b67f2282$export$63fa379ae8a9ba2(date) {
    const _date = (0, $e4a95432db4c1b05$export$e67a095c620b86fe)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$434e7621b67f2282$export$2e2bcd8739ae039 = $434e7621b67f2282$export$63fa379ae8a9ba2;



function $916bff7d7cf18135$export$113002b5eff6e430(date) {
    const _date = (0, $e4a95432db4c1b05$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}


function $b8410fe420a6b00e$export$4a02e9c37dab4871(dateLeft, dateRight) {
    const startOfDayLeft = (0, $434e7621b67f2282$export$63fa379ae8a9ba2)(dateLeft);
    const startOfDayRight = (0, $434e7621b67f2282$export$63fa379ae8a9ba2)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $916bff7d7cf18135$export$113002b5eff6e430)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $916bff7d7cf18135$export$113002b5eff6e430)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / (0, $2920700654fb9eb4$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$b8410fe420a6b00e$export$2e2bcd8739ae039 = $b8410fe420a6b00e$export$4a02e9c37dab4871;



/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $b21c54c07449461d$export$ead8a1812b171991(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}
var // Fallback for modularized imports:
$b21c54c07449461d$export$2e2bcd8739ae039 = $b21c54c07449461d$export$ead8a1812b171991;


function $3ba3b28a58665ded$export$f91e89d3d0406102(date) {
    const cleanDate = (0, $e4a95432db4c1b05$export$e67a095c620b86fe)(date);
    const _date = (0, $b21c54c07449461d$export$ead8a1812b171991)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$3ba3b28a58665ded$export$2e2bcd8739ae039 = $3ba3b28a58665ded$export$f91e89d3d0406102;



function $c92b40e67568d853$export$d3b42cd8452deec(date) {
    const _date = (0, $e4a95432db4c1b05$export$e67a095c620b86fe)(date);
    const diff = (0, $b8410fe420a6b00e$export$4a02e9c37dab4871)(_date, (0, $3ba3b28a58665ded$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$c92b40e67568d853$export$2e2bcd8739ae039 = $c92b40e67568d853$export$d3b42cd8452deec;





function $bf7c74a25b96b8fc$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $0dc874e9bc9ff3dd$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $e4a95432db4c1b05$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$bf7c74a25b96b8fc$export$2e2bcd8739ae039 = $bf7c74a25b96b8fc$export$42c81a444fbfb5d4;


function $c5e99dcf8b2462e1$export$6173213f95a4431e(date) {
    return (0, $bf7c74a25b96b8fc$export$42c81a444fbfb5d4)(date, {
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$c5e99dcf8b2462e1$export$2e2bcd8739ae039 = $c5e99dcf8b2462e1$export$6173213f95a4431e;





function $8e0143ee32ebc028$export$3dbc52535f6f8fcc(date) {
    const _date = (0, $e4a95432db4c1b05$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $b21c54c07449461d$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $c5e99dcf8b2462e1$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $b21c54c07449461d$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $c5e99dcf8b2462e1$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$8e0143ee32ebc028$export$2e2bcd8739ae039 = $8e0143ee32ebc028$export$3dbc52535f6f8fcc;




function $3e6147e6ec42e595$export$236bdfa374eb69a9(date) {
    const year = (0, $8e0143ee32ebc028$export$3dbc52535f6f8fcc)(date);
    const fourthOfJanuary = (0, $b21c54c07449461d$export$ead8a1812b171991)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $c5e99dcf8b2462e1$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$3e6147e6ec42e595$export$2e2bcd8739ae039 = $3e6147e6ec42e595$export$236bdfa374eb69a9;



function $f353e9ffc41e2d49$export$7cabdc5698b63e2f(date) {
    const _date = (0, $e4a95432db4c1b05$export$e67a095c620b86fe)(date);
    const diff = +(0, $c5e99dcf8b2462e1$export$6173213f95a4431e)(_date) - +(0, $3e6147e6ec42e595$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $2920700654fb9eb4$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$f353e9ffc41e2d49$export$2e2bcd8739ae039 = $f353e9ffc41e2d49$export$7cabdc5698b63e2f;










function $7d02db6ecf3e836a$export$12d572480ceb6e58(date, options) {
    const _date = (0, $e4a95432db4c1b05$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $0dc874e9bc9ff3dd$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $b21c54c07449461d$export$ead8a1812b171991)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $bf7c74a25b96b8fc$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $b21c54c07449461d$export$ead8a1812b171991)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $bf7c74a25b96b8fc$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$7d02db6ecf3e836a$export$2e2bcd8739ae039 = $7d02db6ecf3e836a$export$12d572480ceb6e58;




function $f507237b3e6e4495$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $0dc874e9bc9ff3dd$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $7d02db6ecf3e836a$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $b21c54c07449461d$export$ead8a1812b171991)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $bf7c74a25b96b8fc$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$f507237b3e6e4495$export$2e2bcd8739ae039 = $f507237b3e6e4495$export$bb7b45bb8e74da0f;



function $f714cfa44a2834a3$export$efe19b760242b2fc(date, options) {
    const _date = (0, $e4a95432db4c1b05$export$e67a095c620b86fe)(date);
    const diff = +(0, $bf7c74a25b96b8fc$export$42c81a444fbfb5d4)(_date, options) - +(0, $f507237b3e6e4495$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $2920700654fb9eb4$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$f714cfa44a2834a3$export$2e2bcd8739ae039 = $f714cfa44a2834a3$export$efe19b760242b2fc;



function $9cd33f9a225c04ac$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $eb85a83557c09d9e$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $33b9051271232016$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $33b9051271232016$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $eb85a83557c09d9e$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $7d02db6ecf3e836a$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $8e0143ee32ebc028$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $eb85a83557c09d9e$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $f714cfa44a2834a3$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $f353e9ffc41e2d49$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $eb85a83557c09d9e$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $c92b40e67568d853$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $33b9051271232016$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $33b9051271232016$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $33b9051271232016$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $33b9051271232016$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $33b9051271232016$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $33b9051271232016$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $eb85a83557c09d9e$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $eb85a83557c09d9e$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $eb85a83557c09d9e$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $eb85a83557c09d9e$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $eb85a83557c09d9e$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $33b9051271232016$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $33b9051271232016$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $33b9051271232016$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $33b9051271232016$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $33b9051271232016$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $33b9051271232016$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $33b9051271232016$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $33b9051271232016$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $33b9051271232016$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $33b9051271232016$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(timestamp, token.length);
    }
};
function $33b9051271232016$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(minutes, 2);
}
function $33b9051271232016$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $33b9051271232016$var$formatTimezone(offset, delimiter);
}
function $33b9051271232016$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $9cd33f9a225c04ac$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $b1fef7f1212db8bc$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $b1fef7f1212db8bc$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $b1fef7f1212db8bc$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $b1fef7f1212db8bc$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $b1fef7f1212db8bc$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $b1fef7f1212db8bc$var$timeLongFormatter(timePattern, formatLong));
};
const $b1fef7f1212db8bc$export$70cc8fd02856fd58 = {
    p: $b1fef7f1212db8bc$var$timeLongFormatter,
    P: $b1fef7f1212db8bc$var$dateTimeLongFormatter
};


const $dff392b3ae006c38$var$dayOfYearTokenRE = /^D+$/;
const $dff392b3ae006c38$var$weekYearTokenRE = /^Y+$/;
const $dff392b3ae006c38$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $dff392b3ae006c38$export$c6cc36aa33304772(token) {
    return $dff392b3ae006c38$var$dayOfYearTokenRE.test(token);
}
function $dff392b3ae006c38$export$c6b49d6dceb604a1(token) {
    return $dff392b3ae006c38$var$weekYearTokenRE.test(token);
}
function $dff392b3ae006c38$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $dff392b3ae006c38$var$message(token, format, input);
    console.warn(_message);
    if ($dff392b3ae006c38$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $dff392b3ae006c38$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $fa73273ef78dd963$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$fa73273ef78dd963$export$2e2bcd8739ae039 = $fa73273ef78dd963$export$871608497c498473;



function $da710ce66c9d5046$export$1ea939691cdc45b8(date) {
    if (!(0, $fa73273ef78dd963$export$871608497c498473)(date) && typeof date !== "number") return false;
    const _date = (0, $e4a95432db4c1b05$export$e67a095c620b86fe)(date);
    return !isNaN(Number(_date));
}
var // Fallback for modularized imports:
$da710ce66c9d5046$export$2e2bcd8739ae039 = $da710ce66c9d5046$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $ebd4f34ba903fc95$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $ebd4f34ba903fc95$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $ebd4f34ba903fc95$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $ebd4f34ba903fc95$var$doubleQuoteRegExp = /''/g;
const $ebd4f34ba903fc95$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $ebd4f34ba903fc95$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $0dc874e9bc9ff3dd$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $742ada657cc1d5be$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $e4a95432db4c1b05$export$e67a095c620b86fe)(date);
    if (!(0, $da710ce66c9d5046$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($ebd4f34ba903fc95$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $b1fef7f1212db8bc$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($ebd4f34ba903fc95$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $ebd4f34ba903fc95$var$cleanEscapedString(substring)
        };
        if ((0, $33b9051271232016$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($ebd4f34ba903fc95$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $dff392b3ae006c38$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $dff392b3ae006c38$export$c6cc36aa33304772)(token)) (0, $dff392b3ae006c38$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $33b9051271232016$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $ebd4f34ba903fc95$var$cleanEscapedString(input) {
    const matched = input.match($ebd4f34ba903fc95$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($ebd4f34ba903fc95$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$ebd4f34ba903fc95$export$2e2bcd8739ae039 = $ebd4f34ba903fc95$export$d9468344d3651243;



var $6Ffwg = parcelRequire("6Ffwg");

var $dDyyD = parcelRequire("dDyyD");
var $789a31cf917603ba$exports = {};
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $789a31cf917603ba$var$numberTag = '[object Number]';
/** Used for built-in method references. */ var $789a31cf917603ba$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $789a31cf917603ba$var$objectToString = $789a31cf917603ba$var$objectProto.toString;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $789a31cf917603ba$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
 * as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $789a31cf917603ba$var$isNumber(value) {
    return typeof value == 'number' || $789a31cf917603ba$var$isObjectLike(value) && $789a31cf917603ba$var$objectToString.call(value) == $789a31cf917603ba$var$numberTag;
}
$789a31cf917603ba$exports = $789a31cf917603ba$var$isNumber;


var $50b4f02e555bb557$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $50b4f02e555bb557$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $50b4f02e555bb557$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $50b4f02e555bb557$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $50b4f02e555bb557$var$baseIndexOf(array, value, fromIndex) {
    if (value !== value) return $50b4f02e555bb557$var$baseFindIndex(array, $50b4f02e555bb557$var$baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $50b4f02e555bb557$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $50b4f02e555bb557$var$baseIsNaN(value) {
    return value !== value;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $50b4f02e555bb557$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/** Used for built-in method references. */ var $50b4f02e555bb557$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $50b4f02e555bb557$var$splice = $50b4f02e555bb557$var$arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $50b4f02e555bb557$var$nativeMax = Math.max;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $50b4f02e555bb557$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $50b4f02e555bb557$var$baseIndexOfWith : $50b4f02e555bb557$var$baseIndexOf, index = -1, length = values.length, seen = array;
    if (array === values) values = $50b4f02e555bb557$var$copyArray(values);
    if (iteratee) seen = $50b4f02e555bb557$var$arrayMap(array, $50b4f02e555bb557$var$baseUnary(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $50b4f02e555bb557$var$splice.call(seen, fromIndex, 1);
            $50b4f02e555bb557$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $50b4f02e555bb557$var$baseRest(func, start) {
    start = $50b4f02e555bb557$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $50b4f02e555bb557$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = array;
        return $50b4f02e555bb557$var$apply(func, this, otherArgs);
    };
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $50b4f02e555bb557$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $50b4f02e555bb557$var$pull = $50b4f02e555bb557$var$baseRest($50b4f02e555bb557$var$pullAll);
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $50b4f02e555bb557$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $50b4f02e555bb557$var$basePullAll(array, values) : array;
}
$50b4f02e555bb557$exports = $50b4f02e555bb557$var$pull;


var $bac8a8742414b780$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var $bac8a8742414b780$var$LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var $bac8a8742414b780$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var $bac8a8742414b780$var$INFINITY = 1 / 0;
/** `Object#toString` result references. */ var $bac8a8742414b780$var$funcTag = '[object Function]', $bac8a8742414b780$var$genTag = '[object GeneratorFunction]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $bac8a8742414b780$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $bac8a8742414b780$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $bac8a8742414b780$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $bac8a8742414b780$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $bac8a8742414b780$var$root = $bac8a8742414b780$var$freeGlobal || $bac8a8742414b780$var$freeSelf || Function('return this')();
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $bac8a8742414b780$var$arrayIncludes(array, value) {
    var length = array ? array.length : 0;
    return !!length && $bac8a8742414b780$var$baseIndexOf(array, value, 0) > -1;
}
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $bac8a8742414b780$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bac8a8742414b780$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bac8a8742414b780$var$baseIndexOf(array, value, fromIndex) {
    if (value !== value) return $bac8a8742414b780$var$baseFindIndex(array, $bac8a8742414b780$var$baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $bac8a8742414b780$var$baseIsNaN(value) {
    return value !== value;
}
/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bac8a8742414b780$var$cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $bac8a8742414b780$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $bac8a8742414b780$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $bac8a8742414b780$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var $bac8a8742414b780$var$arrayProto = Array.prototype, $bac8a8742414b780$var$funcProto = Function.prototype, $bac8a8742414b780$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $bac8a8742414b780$var$coreJsData = $bac8a8742414b780$var$root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var $bac8a8742414b780$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($bac8a8742414b780$var$coreJsData && $bac8a8742414b780$var$coreJsData.keys && $bac8a8742414b780$var$coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var $bac8a8742414b780$var$funcToString = $bac8a8742414b780$var$funcProto.toString;
/** Used to check objects for own properties. */ var $bac8a8742414b780$var$hasOwnProperty = $bac8a8742414b780$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bac8a8742414b780$var$objectToString = $bac8a8742414b780$var$objectProto.toString;
/** Used to detect if a method is native. */ var $bac8a8742414b780$var$reIsNative = RegExp('^' + $bac8a8742414b780$var$funcToString.call($bac8a8742414b780$var$hasOwnProperty).replace($bac8a8742414b780$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var $bac8a8742414b780$var$splice = $bac8a8742414b780$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $bac8a8742414b780$var$Map = $bac8a8742414b780$var$getNative($bac8a8742414b780$var$root, 'Map'), $bac8a8742414b780$var$Set = $bac8a8742414b780$var$getNative($bac8a8742414b780$var$root, 'Set'), $bac8a8742414b780$var$nativeCreate = $bac8a8742414b780$var$getNative(Object, 'create');
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bac8a8742414b780$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $bac8a8742414b780$var$hashClear() {
    this.__data__ = $bac8a8742414b780$var$nativeCreate ? $bac8a8742414b780$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $bac8a8742414b780$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $bac8a8742414b780$var$hashGet(key) {
    var data = this.__data__;
    if ($bac8a8742414b780$var$nativeCreate) {
        var result = data[key];
        return result === $bac8a8742414b780$var$HASH_UNDEFINED ? undefined : result;
    }
    return $bac8a8742414b780$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bac8a8742414b780$var$hashHas(key) {
    var data = this.__data__;
    return $bac8a8742414b780$var$nativeCreate ? data[key] !== undefined : $bac8a8742414b780$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $bac8a8742414b780$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $bac8a8742414b780$var$nativeCreate && value === undefined ? $bac8a8742414b780$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$bac8a8742414b780$var$Hash.prototype.clear = $bac8a8742414b780$var$hashClear;
$bac8a8742414b780$var$Hash.prototype['delete'] = $bac8a8742414b780$var$hashDelete;
$bac8a8742414b780$var$Hash.prototype.get = $bac8a8742414b780$var$hashGet;
$bac8a8742414b780$var$Hash.prototype.has = $bac8a8742414b780$var$hashHas;
$bac8a8742414b780$var$Hash.prototype.set = $bac8a8742414b780$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bac8a8742414b780$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $bac8a8742414b780$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $bac8a8742414b780$var$listCacheDelete(key) {
    var data = this.__data__, index = $bac8a8742414b780$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $bac8a8742414b780$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $bac8a8742414b780$var$listCacheGet(key) {
    var data = this.__data__, index = $bac8a8742414b780$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bac8a8742414b780$var$listCacheHas(key) {
    return $bac8a8742414b780$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $bac8a8742414b780$var$listCacheSet(key, value) {
    var data = this.__data__, index = $bac8a8742414b780$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$bac8a8742414b780$var$ListCache.prototype.clear = $bac8a8742414b780$var$listCacheClear;
$bac8a8742414b780$var$ListCache.prototype['delete'] = $bac8a8742414b780$var$listCacheDelete;
$bac8a8742414b780$var$ListCache.prototype.get = $bac8a8742414b780$var$listCacheGet;
$bac8a8742414b780$var$ListCache.prototype.has = $bac8a8742414b780$var$listCacheHas;
$bac8a8742414b780$var$ListCache.prototype.set = $bac8a8742414b780$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bac8a8742414b780$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $bac8a8742414b780$var$mapCacheClear() {
    this.__data__ = {
        'hash': new $bac8a8742414b780$var$Hash,
        'map': new ($bac8a8742414b780$var$Map || $bac8a8742414b780$var$ListCache),
        'string': new $bac8a8742414b780$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $bac8a8742414b780$var$mapCacheDelete(key) {
    return $bac8a8742414b780$var$getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $bac8a8742414b780$var$mapCacheGet(key) {
    return $bac8a8742414b780$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bac8a8742414b780$var$mapCacheHas(key) {
    return $bac8a8742414b780$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $bac8a8742414b780$var$mapCacheSet(key, value) {
    $bac8a8742414b780$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$bac8a8742414b780$var$MapCache.prototype.clear = $bac8a8742414b780$var$mapCacheClear;
$bac8a8742414b780$var$MapCache.prototype['delete'] = $bac8a8742414b780$var$mapCacheDelete;
$bac8a8742414b780$var$MapCache.prototype.get = $bac8a8742414b780$var$mapCacheGet;
$bac8a8742414b780$var$MapCache.prototype.has = $bac8a8742414b780$var$mapCacheHas;
$bac8a8742414b780$var$MapCache.prototype.set = $bac8a8742414b780$var$mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $bac8a8742414b780$var$SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new $bac8a8742414b780$var$MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $bac8a8742414b780$var$setCacheAdd(value) {
    this.__data__.set(value, $bac8a8742414b780$var$HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $bac8a8742414b780$var$setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
$bac8a8742414b780$var$SetCache.prototype.add = $bac8a8742414b780$var$SetCache.prototype.push = $bac8a8742414b780$var$setCacheAdd;
$bac8a8742414b780$var$SetCache.prototype.has = $bac8a8742414b780$var$setCacheHas;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bac8a8742414b780$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($bac8a8742414b780$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $bac8a8742414b780$var$baseIsNative(value) {
    if (!$bac8a8742414b780$var$isObject(value) || $bac8a8742414b780$var$isMasked(value)) return false;
    var pattern = $bac8a8742414b780$var$isFunction(value) || $bac8a8742414b780$var$isHostObject(value) ? $bac8a8742414b780$var$reIsNative : $bac8a8742414b780$var$reIsHostCtor;
    return pattern.test($bac8a8742414b780$var$toSource(value));
}
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bac8a8742414b780$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $bac8a8742414b780$var$arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $bac8a8742414b780$var$arrayIncludesWith;
    } else if (length >= $bac8a8742414b780$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $bac8a8742414b780$var$createSet(array);
        if (set) return $bac8a8742414b780$var$setToArray(set);
        isCommon = false;
        includes = $bac8a8742414b780$var$cacheHas;
        seen = new $bac8a8742414b780$var$SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $bac8a8742414b780$var$createSet = !($bac8a8742414b780$var$Set && 1 / $bac8a8742414b780$var$setToArray(new $bac8a8742414b780$var$Set([
    ,
    -0
]))[1] == $bac8a8742414b780$var$INFINITY) ? $bac8a8742414b780$var$noop : function(values) {
    return new $bac8a8742414b780$var$Set(values);
};
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $bac8a8742414b780$var$getMapData(map, key) {
    var data = map.__data__;
    return $bac8a8742414b780$var$isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $bac8a8742414b780$var$getNative(object, key) {
    var value = $bac8a8742414b780$var$getValue(object, key);
    return $bac8a8742414b780$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $bac8a8742414b780$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $bac8a8742414b780$var$isMasked(func) {
    return !!$bac8a8742414b780$var$maskSrcKey && $bac8a8742414b780$var$maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $bac8a8742414b780$var$toSource(func) {
    if (func != null) {
        try {
            return $bac8a8742414b780$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each
 * element is kept.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $bac8a8742414b780$var$uniq(array) {
    return array && array.length ? $bac8a8742414b780$var$baseUniq(array) : [];
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $bac8a8742414b780$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $bac8a8742414b780$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $bac8a8742414b780$var$isObject(value) ? $bac8a8742414b780$var$objectToString.call(value) : '';
    return tag == $bac8a8742414b780$var$funcTag || tag == $bac8a8742414b780$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $bac8a8742414b780$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $bac8a8742414b780$var$noop() {
// No operation performed.
}
$bac8a8742414b780$exports = $bac8a8742414b780$var$uniq;



var $6uYXW = parcelRequire("6uYXW");



var $6uYXW = parcelRequire("6uYXW");
function $3182b6c787011cbf$var$XCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $6uYXW.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $6uYXW.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $6uYXW.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $3182b6c787011cbf$var$ForwardRef = /*#__PURE__*/ $6uYXW.forwardRef($3182b6c787011cbf$var$XCircleIcon);
var $3182b6c787011cbf$export$2e2bcd8739ae039 = $3182b6c787011cbf$var$ForwardRef;



const $4bb5f6c4bf3ec124$var$Alert = ({ message: message })=>{
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        role: "alert",
        className: "alert alert-error",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $3182b6c787011cbf$export$2e2bcd8739ae039), {
                className: "block h-6 w-6"
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                children: message
            })
        ]
    });
};
$4bb5f6c4bf3ec124$var$Alert.propTypes = {
    message: (0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).string.isRequired
};
var $4bb5f6c4bf3ec124$export$2e2bcd8739ae039 = $4bb5f6c4bf3ec124$var$Alert;






var $6uYXW = parcelRequire("6uYXW");
function $5f18043a302e5169$var$ArrowTopRightOnSquareIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $6uYXW.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $6uYXW.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $6uYXW.createElement("path", {
        fillRule: "evenodd",
        d: "M4.25 5.5a.75.75 0 0 0-.75.75v8.5c0 .414.336.75.75.75h8.5a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 1 1.5 0v4A2.25 2.25 0 0 1 12.75 17h-8.5A2.25 2.25 0 0 1 2 14.75v-8.5A2.25 2.25 0 0 1 4.25 4h5a.75.75 0 0 1 0 1.5h-5Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $6uYXW.createElement("path", {
        fillRule: "evenodd",
        d: "M6.194 12.753a.75.75 0 0 0 1.06.053L16.5 4.44v2.81a.75.75 0 0 0 1.5 0v-4.5a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h2.553l-9.056 8.194a.75.75 0 0 0-.053 1.06Z",
        clipRule: "evenodd"
    }));
}
const $5f18043a302e5169$var$ForwardRef = /*#__PURE__*/ $6uYXW.forwardRef($5f18043a302e5169$var$ArrowTopRightOnSquareIcon);
var $5f18043a302e5169$export$2e2bcd8739ae039 = $5f18043a302e5169$var$ForwardRef;




var $1eb246cd2cb85ac6$exports = {};
/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $1eb246cd2cb85ac6$var$stringTag = '[object String]';
/** Used for built-in method references. */ var $1eb246cd2cb85ac6$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1eb246cd2cb85ac6$var$objectToString = $1eb246cd2cb85ac6$var$objectProto.toString;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $1eb246cd2cb85ac6$var$isArray = Array.isArray;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1eb246cd2cb85ac6$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $1eb246cd2cb85ac6$var$isString(value) {
    return typeof value == 'string' || !$1eb246cd2cb85ac6$var$isArray(value) && $1eb246cd2cb85ac6$var$isObjectLike(value) && $1eb246cd2cb85ac6$var$objectToString.call(value) == $1eb246cd2cb85ac6$var$stringTag;
}
$1eb246cd2cb85ac6$exports = $1eb246cd2cb85ac6$var$isString;




const $6f6cd60d0c567d4d$var$QuestionInput = ({ question: question, id: id, onChange: onChange, chosenAnswer: chosenAnswer = '' })=>{
    const { user: user, session: session } = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e)();
    const { question_type: question_type, care_quest_answers: care_quest_answers, required_ind: required_ind } = question;
    if (question_type === 'Numeric') return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
        type: "number",
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d7456dac8e72de90$exports)))('input', 'input-bordered'),
        onChange: onChange,
        required: required_ind,
        value: chosenAnswer,
        inputMode: "decimal"
    });
    else if (question_type === 'Date') return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
        type: "date",
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d7456dac8e72de90$exports)))('input', 'input-bordered'),
        onChange: onChange,
        required: required_ind,
        value: chosenAnswer
    });
    else if (question_type === 'Yes/No' || question_type === 'Multiple Choice Single Select') return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("select", {
        onChange: onChange,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d7456dac8e72de90$exports)))('select', 'select-bordered'),
        required: required_ind,
        value: chosenAnswer || '',
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                disabled: true,
                value: "",
                children: "Pick one"
            }),
            care_quest_answers.map((answer)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                    value: answer.id,
                    children: answer.answer_text
                }, `${answer.care_quest_questionId}-${answer.id}`))
        ]
    });
    else if (question_type === 'Freetext response') return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("textarea", {
        required: required_ind,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d7456dac8e72de90$exports)))('textarea', 'textarea-bordered'),
        onChange: onChange,
        value: chosenAnswer
    });
    else if (question_type === 'Multiple Choice Multiple Select') return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
        className: "grid grid-cols-3 gap-4",
        children: care_quest_answers.map((answer)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "form-control",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("label", {
                    className: "cursor-pointer label",
                    children: [
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                            name: `q-${question.id}`,
                            type: "checkbox",
                            className: "checkbox",
                            value: answer.id,
                            onChange: onChange,
                            checked: chosenAnswer?.includes(answer.id)
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                            className: "label-text",
                            children: answer.answer_text
                        })
                    ]
                })
            }, `${answer.care_quest_questionId}-${answer.id}`))
    });
    else if (question_type === 'document_upload') {
        const attachments = [];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($1eb246cd2cb85ac6$exports)))(chosenAnswer) && chosenAnswer.length > 0) {
            const attachmentLinks = chosenAnswer.split(',');
            for(let i = 0; i < attachmentLinks.length; i++){
                const [attachmentId, type, fileName] = attachmentLinks[i].split(';');
                if (type?.includes('image')) attachments.push({
                    id: attachmentId,
                    fileName: fileName,
                    previewUrl: `${(0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).defaults.baseURL}/coords/${user.id}/care-quest-response-download/${attachmentId}?access_token=${session.id}`
                });
                else attachments.push({
                    fileName: fileName,
                    id: attachmentId
                });
            }
        }
        return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                        type: "file",
                        className: "w-full file-input file-input-bordered",
                        onChange: onChange,
                        multiple: true
                    })
                }),
                attachments.map((attachment)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                        className: "mt-4",
                        children: [
                            attachment.previewUrl && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                className: "mb-2",
                                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("img", {
                                    src: attachment.previewUrl,
                                    className: "border border-gray-400 rounded-lg image-full"
                                })
                            }),
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("a", {
                                target: "_blank",
                                href: `${(0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).defaults.baseURL}/coords/${user.id}/care-quest-response-download/${attachment.id}?access_token=${session.id}`,
                                rel: "noreferrer",
                                download: true,
                                className: "link link-primary",
                                children: [
                                    "Download ",
                                    attachment.fileName,
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $5f18043a302e5169$export$2e2bcd8739ae039), {
                                        className: "inline-block w-4 h-4 ml-1"
                                    })
                                ]
                            })
                        ]
                    }, `${attachment.id}`))
            ]
        });
    }
    return null;
};
$6f6cd60d0c567d4d$var$QuestionInput.propTypes = {
    question: (0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).object,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).func,
    chosenAnswer: (0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).any
};
var $6f6cd60d0c567d4d$export$2e2bcd8739ae039 = $6f6cd60d0c567d4d$var$QuestionInput;


const $3e7e14d5e330c4e2$var$Assessment = ()=>{
    const queryClient = (0, $8136cc1e66cf8798$export$22e77b9572c4fded)();
    let { formId: formId } = (0, $88be82bcdaab0750$export$99eaa27ddbbb95ef)();
    const [defaultAnswers, setDefaultAnswers] = (0, $6uYXW.useState)({});
    const [answers, setAnswers] = (0, $6uYXW.useState)({});
    const [isSaving, setIsSaving] = (0, $6uYXW.useState)(false);
    const [canTotal, setCanTotal] = (0, $6uYXW.useState)(false);
    const { user: user } = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e)();
    const { showError: showError, showSuccess: showSuccess } = (0, $8460a3ee79a43e41$export$aa94277a9804d2bd)();
    const navigate = (0, $88be82bcdaab0750$export$9770f232ac06a008)();
    const location = (0, $88be82bcdaab0750$export$45d76561a5302f2b)();
    // Pages that link here can pass `state.from` to control where a successful
    // save returns to (e.g. "/cca"); otherwise fall back to /home.
    const returnTo = location.state?.from ?? '/home';
    const { isFetching: isFetching, isFetched: isFetched, data: data, isError: isError } = (0, $b505c391aa3d7eba$export$dd0a697e1782aedd)({
        queryKey: [
            'care_quest_questions',
            formId
        ],
        queryFn: async ()=>{
            const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get('/care_quest_questions', {
                params: {
                    filter: JSON.stringify({
                        where: {
                            care_quest_groupId: formId
                        },
                        include: 'care_quest_answers',
                        order: 'question_order'
                    })
                }
            });
            return data;
        },
        enabled: !!formId
    });
    const { isFetched: isRespFetched, data: respData, isRefetching: isRefetching } = (0, $b505c391aa3d7eba$export$dd0a697e1782aedd)({
        queryKey: [
            'care_quest_response_group',
            formId,
            user.id
        ],
        queryFn: async ()=>{
            const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get(`/clients/${user.id}/care_quest_response_groups`, {
                params: {
                    filter: JSON.stringify({
                        where: {
                            care_quest_groupId: formId
                        },
                        include: [
                            {
                                relation: 'care_quest_responses',
                                scope: {
                                    include: [
                                        'care_quest_answer'
                                    ]
                                }
                            },
                            'care_quest_group'
                        ],
                        order: 'response_dttm DESC',
                        limit: 1
                    })
                }
            });
            return Array.isArray(data) && data.length > 0 ? data[0] : null;
        },
        enabled: !!formId && !!user.id && isFetched,
        retry: 0
    });
    (0, $6uYXW.useEffect)(()=>{
        setAnswers({});
        setDefaultAnswers({});
        setCanTotal(false);
    }, [
        formId
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (isFetched) {
            let isTotalable = false;
            const defaultAnswers = {};
            data.forEach((question, index)=>{
                if (question.question_type === 'Multiple Choice Single Select') {
                    defaultAnswers[`${question.id}`] = question.default_answer;
                    isTotalable = false;
                } else if (question.question_type === 'Multiple Choice Multiple Select') {
                    defaultAnswers[`${question.id}`] = [];
                    isTotalable = false;
                } else if (question.question_type === 'Yes/No') {
                    defaultAnswers[`${question.id}`] = question.default_answer;
                    isTotalable = false;
                } else if (question.question_type === 'Freetext response') {
                    defaultAnswers[`${question.id}`] = '';
                    isTotalable = isTotalable && index === data.length - 1 ? true : false;
                } else if (question.question_type === 'Numeric') {
                    defaultAnswers[`${question.id}`] = question.default_answer;
                    isTotalable = true;
                } else if (question.question_type === 'Wellness Scale') defaultAnswers[`${question.id}`] = 0;
                else if (question.question_type.indexOf('slider') === 0) {
                    // set a default
                    defaultAnswers[`${question.id}`] = 0;
                    // convert from string or calculate default answer
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($789a31cf917603ba$exports)))(question.default_answer)) defaultAnswers[`${question.id}`] = parseInt(question.default_answer, 10);
                    else try {
                        const [, range] = question.question_type.split(':');
                        const [min, max] = range.split('-');
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($789a31cf917603ba$exports)))(min) && (0, (/*@__PURE__*/$parcel$interopDefault($789a31cf917603ba$exports)))(max)) defaultAnswers[`${question.id}`] = Math.round((parseInt(max, 10) - parseInt(min, 10)) / 2);
                    } catch (err) {
                    // a default is set already
                    }
                    isTotalable = false;
                } else // TODO: other options as needed...
                // console.log('UNKNOWN', question)
                isTotalable = false;
            });
            setCanTotal(isTotalable);
            setDefaultAnswers(defaultAnswers);
        }
    }, [
        isFetched,
        data
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (!isRefetching && isRespFetched && respData) {
            const existingAnswers = (0, (/*@__PURE__*/$parcel$interopDefault($6Ffwg)))(defaultAnswers);
            respData.care_quest_responses.forEach((resp)=>{
                if (Array.isArray(existingAnswers[`${resp.care_quest_questionId}`])) existingAnswers[`${resp.care_quest_questionId}`].push(resp.care_quest_answerId);
                else if (resp.care_quest_answerId && (0, (/*@__PURE__*/$parcel$interopDefault($dDyyD)))(resp.care_quest_answer_text)) existingAnswers[`${resp.care_quest_questionId}`] = resp.care_quest_answerId;
                else existingAnswers[`${resp.care_quest_questionId}`] = resp.care_quest_answer_text;
            });
            setAnswers(existingAnswers);
        } else if (isRespFetched && (0, (/*@__PURE__*/$parcel$interopDefault($dDyyD)))(respData)) setAnswers(defaultAnswers);
    }, [
        isRespFetched,
        respData,
        defaultAnswers,
        isRefetching
    ]);
    (0, $6uYXW.useEffect)(()=>{
        // total values
        if (isFetched && canTotal) {
            let total = 0;
            data.forEach((question, index)=>{
                if (index < data.length - 1) total += Number(answers[question.id]);
                else if (index === data.length - 1 && total != answers[`${question.id}`]) setAnswers({
                    ...answers,
                    [`${question.id}`]: total
                });
            });
        }
    }, [
        data,
        answers,
        canTotal
    ]);
    const handleAnswerValueChange = (questionId, answer)=>{
        if (answer.type === 'checkbox') {
            const chosenAnswer = [
                ...answers[`${questionId}`]
            ];
            const newAnswer = parseInt(answer.value);
            if (answer.checked) chosenAnswer.push(newAnswer);
            else (0, (/*@__PURE__*/$parcel$interopDefault($50b4f02e555bb557$exports)))(chosenAnswer, newAnswer);
            setAnswers({
                ...answers,
                [`${questionId}`]: (0, (/*@__PURE__*/$parcel$interopDefault($bac8a8742414b780$exports)))(chosenAnswer)
            });
        } else if (answer.type === 'file') setAnswers({
            ...answers,
            [`${questionId}`]: answer.files
        });
        else if (answer.type === 'select-one') setAnswers({
            ...answers,
            [`${questionId}`]: parseInt(answer.value)
        });
        else setAnswers({
            ...answers,
            [`${questionId}`]: answer.value
        });
    };
    const handleSaveResponse = async ()=>{
        const finalAnswers = [];
        const entities = data.reduce((prev, curr)=>{
            prev[curr.id] = curr;
            return prev;
        }, {});
        const response_dttm = new Date();
        Object.keys(answers).forEach((questionId)=>{
            // if (hideQuestion(entities[questionId])) {
            // 	return;
            // }
            let isMultiChoice = false;
            const finalAnswer = {
                care_quest_questionId: parseInt(questionId),
                care_quest_groupId: formId,
                response_dttm: response_dttm
            };
            // extract answer id from choice questions
            if ([
                'Multiple Choice Single Select',
                'Yes/No'
            ].includes(entities[questionId].question_type)) {
                const chosenAnswer = entities[questionId].care_quest_answers.find((answer)=>answer.id == answers[questionId]);
                if (entities[questionId].required_ind && !chosenAnswer) ;
                else finalAnswer.care_quest_answerId = chosenAnswer.id;
            } else if ([
                'Multiple Choice Multiple Select'
            ].includes(entities[questionId].question_type)) {
                isMultiChoice = true;
                answers[questionId].forEach((response)=>{
                    const chosenAnswer = entities[questionId].care_quest_answers.find((answer)=>answer.id === response);
                    if (entities[questionId].required_ind && !chosenAnswer) ;
                    else {
                        const answer = {
                            ...finalAnswer,
                            care_quest_answerId: chosenAnswer.id
                        };
                        finalAnswers.push(answer);
                    }
                });
            } else if ('document_upload' === entities[questionId].question_type) {
                const formData = new FormData();
                formData.append('data', JSON.stringify(finalAnswer));
                for(let i = 0; i < answers[questionId].length; i++)formData.append('files', answers[questionId][i]);
                finalAnswer.formData = formData;
            } else finalAnswer.care_quest_answer_text = answers[questionId];
            if (!isMultiChoice) finalAnswers.push(finalAnswer);
        });
        // console.log(finalAnswers);
        if (finalAnswers.length > 0) {
            setIsSaving(true);
            try {
                const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).post(`/clients/${user.id}/care_quest_response_groups`, {
                    care_quest_groupId: formId,
                    response_dttm: response_dttm,
                    completed_by_type: 'client',
                    completed_by_id: user.id
                });
                const results = await Promise.allSettled(finalAnswers.map(async (finalAnswer)=>{
                    if (finalAnswer.formData) {
                        const { formData: formData } = finalAnswer;
                        const fData = JSON.parse(formData.get('data'));
                        formData.set('data', JSON.stringify({
                            ...fData,
                            clientId: user.id,
                            care_quest_response_groupId: data.id
                        }));
                        const response = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).post('/care_quest_responses/upload-response-with-file', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });
                        return {
                            uploads: formData.getAll('files').length,
                            ...response.data
                        };
                    } else {
                        const response = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).post('/care_quest_responses', {
                            ...finalAnswer,
                            clientId: user.id,
                            care_quest_response_groupId: data.id
                        });
                        return response.data;
                    }
                }));
                queryClient.invalidateQueries({
                    queryKey: [
                        'care_quest_response_group',
                        formId,
                        user.id
                    ]
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        'incompleteRequests',
                        user.id
                    ]
                });
                let message = 'Application module saved';
                const totalUploaded = results.filter((r)=>r.value?.uploads).reduce((sum, r)=>sum + r.value.uploads, 0);
                if (totalUploaded > 0) message += `, ${totalUploaded} file(s) uploaded`;
                showSuccess(message);
                navigate(returnTo);
            } catch (e) {
                showError('There was a problem saving the application module');
            } finally{
                setIsSaving(false);
            }
        }
    };
    const handleSubmit = (event)=>{
        event.preventDefault();
    };
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "application page-wide",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h1", {
                children: "Application"
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h3", {
                children: respData && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $32c03629429003d8$exports.Fragment), {
                    children: [
                        respData?.care_quest_group?.name,
                        ' ',
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("em", {
                            className: "text-base font-normal text-gray-500",
                            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("small", {
                                children: [
                                    "Last updated on",
                                    ' ',
                                    (0, $ebd4f34ba903fc95$export$d9468344d3651243)(new Date(respData.response_dttm), 'PP p')
                                ]
                            })
                        })
                    ]
                })
            }),
            isError && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $4bb5f6c4bf3ec124$export$2e2bcd8739ae039), {
                message: "Unable to load application!"
            }),
            isFetching && 'Loading...',
            isFetched && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                        className: "grid items-end gap-4 xl:grid-cols-2 2xl:grid-cols-3",
                        children: data.map((question)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($d7456dac8e72de90$exports)))('form-control', {
                                    'xl:col-span-2 2xl:col-span-3': question.question_type === 'Freetext response' || question.question_type === 'Multiple Choice Multiple Select' || question.question_type === 'document_upload'
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                        className: "text-sm label",
                                        htmlFor: `q-${question.care_quest_groupId}.${question.id}`,
                                        children: question.question_text
                                    }),
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $6f6cd60d0c567d4d$export$2e2bcd8739ae039), {
                                        id: `q-${question.care_quest_groupId}.${question.id}`,
                                        question: question,
                                        onChange: ({ target: target })=>handleAnswerValueChange(question.id, target),
                                        chosenAnswer: answers[`${question.id}`]
                                    })
                                ]
                            }, `${question.care_quest_groupId}-${question.id}-${question.question_order}`))
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                        className: "mt-4 text-right",
                        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("button", {
                            className: "btn btn-primary",
                            onClick: handleSaveResponse,
                            disabled: isSaving,
                            children: [
                                isSaving && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                                    className: "loading loading-spinner"
                                }),
                                "Save"
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $3e7e14d5e330c4e2$export$2e2bcd8739ae039 = $3e7e14d5e330c4e2$var$Assessment;







const $8e0ea8865cb8f5ee$var$CompletedAssessments = ()=>{
    const { user: user } = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e)();
    const completedAssessmentsQuery = (0, $b505c391aa3d7eba$export$dd0a697e1782aedd)({
        queryKey: [
            'completedAssessments',
            user.id
        ],
        queryFn: async ()=>{
            const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get(`/clients/${user.id}/completed-assessments`);
            return data;
        }
    });
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "application page-wide",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h1", {
                children: "Questionnaires"
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                className: "mb-4",
                children: "Below is a list of completed Questionnaires. You can open each to review or update."
            }),
            completedAssessmentsQuery.isLoading && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                    className: "loading loading-dots loading-lg text-primary"
                })
            }),
            !completedAssessmentsQuery.isLoading && completedAssessmentsQuery.data.length === 0 && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                children: "No completed questionnaires found."
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "grid gap-4 sm:grid-cols-3",
                children: !completedAssessmentsQuery.isLoading && completedAssessmentsQuery.data.map((assessment)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                        className: "bg-white shadow card",
                        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "card-body",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h3", {
                                    className: "card-title",
                                    children: assessment.name
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("p", {
                                    className: "card-text",
                                    children: [
                                        "Completed on:",
                                        ' ',
                                        new Date(assessment.response_dttm).toLocaleDateString()
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                    to: `/assessments/${assessment.id}`,
                                    className: "btn btn-primary",
                                    children: "View / Update"
                                })
                            ]
                        })
                    }, assessment.id))
            })
        ]
    });
};
var $8e0ea8865cb8f5ee$export$2e2bcd8739ae039 = $8e0ea8865cb8f5ee$var$CompletedAssessments;


var $1faa9d57eb35cbd7$export$2e2bcd8739ae039 = (0, $3e7e14d5e330c4e2$export$2e2bcd8739ae039);








var $6uYXW = parcelRequire("6uYXW");
function $48750dcddf37498f$var$ExclamationTriangleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $6uYXW.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $6uYXW.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $6uYXW.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
    }));
}
const $48750dcddf37498f$var$ForwardRef = /*#__PURE__*/ $6uYXW.forwardRef($48750dcddf37498f$var$ExclamationTriangleIcon);
var $48750dcddf37498f$export$2e2bcd8739ae039 = $48750dcddf37498f$var$ForwardRef;



// Shown when the services lookup fails. `onRetry` is wired to the query's
// refetch. The button is explicitly type="button" because this renders inside a
// <Form>/<form>, where an untyped button would submit it.
const $d71cbaef15ea582f$var$ServicesError = ({ onRetry: onRetry })=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "mt-4 alert alert-error",
        role: "alert",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $48750dcddf37498f$export$2e2bcd8739ae039), {
                className: "block w-6 h-6"
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                children: "We couldn't load services right now. Please try again."
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                type: "button",
                className: "btn btn-sm",
                onClick: onRetry,
                children: "Retry"
            })
        ]
    });
$d71cbaef15ea582f$var$ServicesError.propTypes = {
    onRetry: (0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).func.isRequired
};
var $d71cbaef15ea582f$export$2e2bcd8739ae039 = $d71cbaef15ea582f$var$ServicesError;



const $22bff9b089455983$export$8508f2023dac619 = (0, $bb817058aecadce6$exports.create)((set, get)=>({
        zipCode: null,
        setZipCode: (zip)=>set({
                zipCode: zip
            }),
        program: null,
        setProgram: (program)=>set({
                program: program
            }),
        idempotencyKey: null,
        setIdempotencyKey: (idempotencyKey)=>set({
                idempotencyKey: idempotencyKey
            }),
        clearApplication: ()=>set({
                zipCode: null,
                program: null,
                idempotencyKey: null
            }),
        // The chosen program is the sole source for the request: its name is the
        // service description and its id is the external reference. The idempotency
        // key lets the server dedupe a resubmitted request.
        getApplication: ()=>{
            const { program: program, idempotencyKey: idempotencyKey } = get();
            return {
                taxonomy_detail: program?.name,
                external_id: program?.id,
                idempotency_key: idempotencyKey
            };
        }
    }));







var $6uYXW = parcelRequire("6uYXW");
const $56f28e4051d8651c$var$sameText = (a, b)=>(a ?? '').trim() === (b ?? '').trim();
// A location's name is often just the organization's name repeated; when that
// happens show it once. The title leads with the organization name, unless the
// caller is already listing one organization's services and wants the service
// name up front instead.
const $56f28e4051d8651c$var$cardHeading = (program, location, programNameAsTitle)=>{
    const locationName = $56f28e4051d8651c$var$sameText(location.name, location.organization_name) ? undefined : location.name;
    const [title, ...subtitle] = programNameAsTitle ? [
        program.name,
        location.organization_name,
        locationName
    ] : [
        location.organization_name,
        locationName,
        program.name
    ];
    return {
        title: title,
        subtitle: subtitle.filter(Boolean)
    };
};
const $56f28e4051d8651c$var$ServiceCard = ({ program: program, programNameAsTitle: programNameAsTitle = false })=>{
    // let allowsElectronicApplications = false;
    const isTandemOrgService = !!program?.ccAttributes?.coord_agency_id;
    const isNonHubPartner = !!program?.ccAttributes?.non_hub_partner;
    const acceptsElectronicReferralsTag = program?.tags.find(({ category: category })=>category === 'accepts_e_ref');
    const acceptsElectronicReferrals = !!acceptsElectronicReferralsTag;
    const acceptsElectronicReferralsCurrently = acceptsElectronicReferralsTag?.properties.find(({ name: name })=>name === 'accepts_e_ref_currently')?.value === '1';
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
        className: "my-4 bg-white shadow-xl card",
        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
            className: "card-body",
            children: [
                program.locations.map((location)=>{
                    const { title: title, subtitle: subtitle } = $56f28e4051d8651c$var$cardHeading(program, location, programNameAsTitle);
                    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                className: "text-xl text-primary",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                className: "text-sm",
                                children: subtitle.map((line, index)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $6uYXW.Fragment), {
                                        children: [
                                            index > 0 && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("br", {}),
                                            line
                                        ]
                                    }, `${index}-${line}`))
                            })
                        ]
                    }, location.id);
                }),
                program.physical_address.map((address)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                        children: [
                            address.address_1,
                            " | ",
                            address.city,
                            ", ",
                            address.state_province,
                            ",",
                            ' ',
                            address.postal_code
                        ]
                    }, `${address.id}`)),
                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                    className: "text-primary",
                    children: program.program
                }),
                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                    children: program.description
                }),
                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("strong", {
                            children: "Serves:"
                        }),
                        " ",
                        program.service_area
                    ]
                }),
                program.ccAttributes?.allow_self_ref_ind === 0 && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                    className: "mt-4 alert alert-warning",
                    role: "alert",
                    children: [
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $48750dcddf37498f$export$2e2bcd8739ae039), {
                            className: "block w-6 h-6"
                        }),
                        "Not available for self-service applications."
                    ]
                }),
                (acceptsElectronicReferrals || isTandemOrgService || isNonHubPartner) && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                    className: "mt-4 btn btn-primary btn-sm btn-block",
                    name: "program",
                    value: program.id,
                    type: "submit",
                    disabled: isNonHubPartner ? program.ccAttributes?.availability != 1 : !acceptsElectronicReferralsCurrently,
                    children: "Apply Electronically"
                })
            ]
        })
    });
};
$56f28e4051d8651c$var$ServiceCard.propTypes = {
    program: (0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).object.isRequired,
    // Leads the card with the service name rather than the organization name.
    programNameAsTitle: (0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).bool
};
var $56f28e4051d8651c$export$2e2bcd8739ae039 = $56f28e4051d8651c$var$ServiceCard;


async function $25522fd699d42b1c$export$f4c5de44377d2946({ request: request }) {
    const url = new URL(request.url);
    const zipCode = url.searchParams.get('zipCode');
    const county = url.searchParams.get('county');
    const taxonomyCode = url.searchParams.get('taxonomy[taxonomy_code]');
    const taxonomyName = url.searchParams.get('taxonomy[taxonomy_name_reference]');
    (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e).getState().verifyUser();
    // taxonomyCode/taxonomyName stay local to this page; only zipCode and the
    // eventually-chosen program are carried across pages now.
    (0, $22bff9b089455983$export$8508f2023dac619).getState().setZipCode(zipCode);
    return {
        zipCode: zipCode,
        taxonomyCode: taxonomyCode,
        taxonomyName: taxonomyName,
        county: county
    };
}
const $25522fd699d42b1c$var$AvailableOrganizations = ()=>{
    const { zipCode: zipCode, taxonomyCode: taxonomyCode, taxonomyName: taxonomyName, county: county } = (0, $88be82bcdaab0750$export$1448a5050d252c4d)();
    const navigate = (0, $88be82bcdaab0750$export$9770f232ac06a008)();
    const { setProgram: setProgram } = (0, $22bff9b089455983$export$8508f2023dac619)();
    const { data: programs, isLoading: isLoading, isError: isError, refetch: refetch } = (0, $b505c391aa3d7eba$export$dd0a697e1782aedd)({
        queryKey: [
            'organizations',
            zipCode,
            taxonomyCode,
            county
        ],
        queryFn: async ()=>{
            const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get('/clients/getServicesByTaxonomyAndPostalCode', {
                params: {
                    zipCode: zipCode,
                    taxonomyCode: taxonomyCode,
                    county: county
                }
            });
            return data;
        }
    });
    const handleSubmit = ({ nativeEvent: nativeEvent })=>{
        const programId = nativeEvent.submitter.value;
        const program = programs.find((p)=>p.id == programId);
        setProgram(program);
    };
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "page available-organizations",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "sm:mx-auto sm:w-full sm:max-w-2xl",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("h2", {
                    children: [
                        "Organizations ",
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("small", {
                            children: zipCode
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "sm:mx-auto sm:w-full sm:max-w-2xl",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $c6d33de9e7cf86ac$export$a7fed597f4b8afd8), {
                    method: "get",
                    action: "/checkProfile",
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h3", {
                            children: taxonomyName
                        }),
                        isLoading && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                            className: "text-center",
                            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                                className: "loading loading-dots loading-lg text-primary"
                            })
                        }),
                        isError && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $d71cbaef15ea582f$export$2e2bcd8739ae039), {
                            onRetry: refetch
                        }),
                        !isLoading && !isError && programs.length === 0 && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                                    children: "No organizations found. Please try another search."
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-primary btn-sm btn-block",
                                    onClick: ()=>navigate(-1),
                                    children: "Go Back"
                                })
                            ]
                        }),
                        !isLoading && !isError && programs.map((program)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $56f28e4051d8651c$export$2e2bcd8739ae039), {
                                program: program
                            }, program.id)),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                            type: "hidden",
                            name: "zipCode",
                            value: zipCode
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                            type: "hidden",
                            name: "taxonomy[taxonomy_code]",
                            value: taxonomyCode
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                            type: "hidden",
                            name: "taxonomy[taxonomy_name_reference]",
                            value: taxonomyName
                        })
                    ]
                })
            })
        ]
    });
};
var $25522fd699d42b1c$export$2e2bcd8739ae039 = $25522fd699d42b1c$var$AvailableOrganizations;


var $f98453a3b051f25f$export$2e2bcd8739ae039 = (0, $25522fd699d42b1c$export$2e2bcd8739ae039);






var $dDyyD = parcelRequire("dDyyD");

var $6uYXW = parcelRequire("6uYXW");

async function $07ee53d1fd944508$export$31eb53bd5b582a97({ request: request /*params */  }) {
    const formData = await request.formData();
    const data = Object.fromEntries(formData);
    const password = data.password1;
    try {
        await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).post('/clients/reset_user_password', {
            password: password,
            accessToken: data.accessToken
        });
    } catch (error) {
        return {
            error: error
        };
    }
    return {
        submitted: true
    };
}
const $07ee53d1fd944508$var$ChangePassword = ()=>{
    const actionData = (0, $88be82bcdaab0750$export$fdc00f3f26066d5e)();
    const paramsString = window.location.hash.split('?')[1] || '';
    const searchParams = new URLSearchParams(paramsString);
    const [password1, setPassword1] = (0, $6uYXW.useState)('');
    const [password2, setPassword2] = (0, $6uYXW.useState)('');
    const [passwordsMatch, setPasswordsMatch] = (0, $6uYXW.useState)(true);
    (0, $6uYXW.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($dDyyD)))(password2)) {
            setPasswordsMatch(true);
            return;
        }
        setPasswordsMatch(password1 === password2);
    }, [
        password1,
        password2
    ]);
    const handleValidate = (e)=>{
        if (password1 !== password2) e.preventDefault();
    };
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "justify-center py-12 page",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "sm:mx-auto sm:w-full sm:max-w-sm",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h2", {
                    children: "Change Password"
                })
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "mt-10 sm:mx-auto sm:w-full sm:max-w-sm",
                children: actionData?.submitted ? /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $32c03629429003d8$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("p", {
                        className: "pb-4",
                        children: [
                            "Password change successful. You can now",
                            ' ',
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                to: "/login",
                                className: "link link-primary",
                                children: "Login"
                            }),
                            ' ',
                            "with your new password."
                        ]
                    })
                }) : /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $c6d33de9e7cf86ac$export$a7fed597f4b8afd8), {
                    className: "space-y-6",
                    method: "post",
                    onSubmit: handleValidate,
                    children: [
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                            children: "Enter your username or mobile number. If there is a valid mobile number associated with your account, you will receive a link to reset your password."
                        }),
                        actionData?.error && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                            className: "py-4 text-red-600",
                            children: "An error occurred while attempting to change your password. Please try again."
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "form-control",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                    htmlFor: "password1",
                                    className: "label label-text",
                                    children: "Password"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                    id: "password1",
                                    name: "password1",
                                    type: "password",
                                    autoComplete: "new-password",
                                    required: true,
                                    className: "w-full input input-sm input-bordered",
                                    value: password1,
                                    onChange: (e)=>setPassword1(e.target.value),
                                    minLength: 8
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("label", {
                            className: "form-control",
                            htmlFor: "password2",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                    className: "label",
                                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                                        className: "label-text",
                                        children: "Confirm Password"
                                    })
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                    id: "password2",
                                    name: "password2",
                                    type: "password",
                                    autoComplete: "new-password",
                                    required: true,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d7456dac8e72de90$exports)))('w-full', 'input', 'input-sm', 'input-bordered', {
                                        'input-error': !passwordsMatch
                                    }),
                                    value: password2,
                                    onChange: (e)=>setPassword2(e.target.value)
                                }),
                                !passwordsMatch && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                    className: "label",
                                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                                        className: "label-text text-error",
                                        children: "Passwords do not match"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                    type: "hidden",
                                    name: "accessToken",
                                    value: searchParams.get('token')
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                                    className: "text-white btn btn-primary btn-sm btn-block",
                                    name: "form",
                                    value: "resetPassword",
                                    children: "Change Password"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $07ee53d1fd944508$export$2e2bcd8739ae039 = $07ee53d1fd944508$var$ChangePassword;


var $5502b534e446bf5a$export$2e2bcd8739ae039 = (0, $07ee53d1fd944508$export$2e2bcd8739ae039);





async function $3e074ae14a790c44$export$f4c5de44377d2946() {
    const { isSignedIn: isSignedIn } = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e).getState();
    if (isSignedIn()) return (0, $9a468b9555c2dd85$export$89e12c5b50f7529d)('/submitRequest');
    else return (0, $9a468b9555c2dd85$export$89e12c5b50f7529d)('/login');
}
const $3e074ae14a790c44$var$CheckProfile = ()=>{
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
        className: "page check-profile",
        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
            className: "sm:mx-auto sm:w-full sm:max-w-2xl",
            children: "Placeholder"
        })
    });
};
var $3e074ae14a790c44$export$2e2bcd8739ae039 = $3e074ae14a790c44$var$CheckProfile;


var $e8cd06ed188feb94$export$2e2bcd8739ae039 = (0, $3e074ae14a790c44$export$2e2bcd8739ae039);










var $6uYXW = parcelRequire("6uYXW");

var $dDyyD = parcelRequire("dDyyD");

const $65b8bc3753f9832b$var$ChallengeQuestions = ({ user: user, onSave: onSave = ()=>{} })=>{
    const { showSuccess: showSuccess, showError: showError } = (0, $8460a3ee79a43e41$export$aa94277a9804d2bd)();
    const [question1, setQuestion1] = (0, $6uYXW.useState)(-1);
    const [question2, setQuestion2] = (0, $6uYXW.useState)(-1);
    const [question3, setQuestion3] = (0, $6uYXW.useState)(-1);
    const [answer1, setAnswer1] = (0, $6uYXW.useState)('');
    const [answer2, setAnswer2] = (0, $6uYXW.useState)('');
    const [answer3, setAnswer3] = (0, $6uYXW.useState)('');
    const query = (0, $b505c391aa3d7eba$export$dd0a697e1782aedd)({
        queryKey: [
            'questions'
        ],
        queryFn: async ()=>{
            const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get('/clients/security-questions');
            return data;
        }
    });
    const handleSaveQuestionAndResponses = async (event)=>{
        event.preventDefault();
        const security_questions = [
            {
                question_id: question1,
                answer: answer1
            },
            {
                question_id: question2,
                answer: answer2
            },
            {
                question_id: question3,
                answer: answer3
            }
        ];
        try {
            await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).post(`/clients/${user.id}/security-questions-save`, {
                security_questions: security_questions
            });
            showSuccess('Challenge questions updated');
            // clear fields
            setQuestion1(-1);
            setQuestion2(-1);
            setQuestion3(-1);
            setAnswer1('');
            setAnswer2('');
            setAnswer3('');
            onSave();
        } catch (err) {
            showError('Unable to save your choices');
        }
    };
    const questionSet1 = query.data?.filter(({ id: id })=>id != question2 && id != question3);
    const questionSet2 = query.data?.filter(({ id: id })=>id != question1 && id != question3);
    const questionSet3 = query.data?.filter(({ id: id })=>id != question1 && id != question2);
    if (!query.data) return null;
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("form", {
        className: "bg-white shadow-sm card ring-1 ring-gray-900/5 md:col-span-2",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "card-body",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                    className: "grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6",
                    children: [
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "form-control sm:col-span-4",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                    htmlFor: "question1",
                                    className: "label label-text",
                                    children: "Question 1"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("select", {
                                    id: "question1",
                                    name: "question1",
                                    required: true,
                                    className: "select select-bordered select-sm",
                                    onChange: ({ target: target })=>setQuestion1(target.value),
                                    value: question1,
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                            value: -1,
                                            children: "Choose..."
                                        }),
                                        questionSet1.map(({ id: id, question: question })=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                value: id,
                                                children: question
                                            }, `${id}`))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "form-control sm:col-span-6",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                    htmlFor: "answer1",
                                    className: "label label-text",
                                    children: "Answer 1"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                    id: "answer1",
                                    name: "answer1",
                                    type: "text",
                                    required: true,
                                    className: "input input-sm input-bordered",
                                    onChange: ({ target: target })=>setAnswer1(target.value),
                                    value: answer1
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "form-control sm:col-span-4",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                    htmlFor: "question2",
                                    className: "label label-text",
                                    children: "Question 2"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("select", {
                                    id: "question2",
                                    name: "question2",
                                    required: true,
                                    className: "select select-bordered select-sm",
                                    onChange: ({ target: target })=>setQuestion2(target.value),
                                    value: question2,
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                            value: -1,
                                            children: "Choose..."
                                        }),
                                        questionSet2.map(({ id: id, question: question })=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                value: id,
                                                children: question
                                            }, `${id}`))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "form-control sm:col-span-6",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                    htmlFor: "answer2",
                                    className: "label label-text",
                                    children: "Answer 2"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                    id: "answer2",
                                    name: "answer2",
                                    type: "text",
                                    required: true,
                                    className: "input input-sm input-bordered",
                                    onChange: ({ target: target })=>setAnswer2(target.value),
                                    value: answer2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "form-control sm:col-span-4",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                    htmlFor: "question3",
                                    className: "label label-text",
                                    children: "Question 3"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("select", {
                                    id: "question3",
                                    name: "question3",
                                    required: true,
                                    className: "select select-bordered select-sm",
                                    onChange: ({ target: target })=>setQuestion3(target.value),
                                    value: question3,
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                            value: -1,
                                            children: "Choose..."
                                        }),
                                        questionSet3.map(({ id: id, question: question })=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                value: id,
                                                children: question
                                            }, `${id}`))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "form-control sm:col-span-6",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                    htmlFor: "answer3",
                                    className: "label label-text",
                                    children: "Answer 3"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                    id: "answer3",
                                    name: "answer3",
                                    type: "text",
                                    required: true,
                                    className: "input input-sm input-bordered",
                                    onChange: ({ target: target })=>setAnswer3(target.value),
                                    value: answer3
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "justify-end px-8 py-4 border-t card-actions border-gray-900/10",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                    className: "text-white btn btn-primary btn-sm",
                    name: "form",
                    value: "challQuestions",
                    disabled: query.isPending || query.isError || question1 == -1 || question2 == -1 || question3 == -1 || (0, (/*@__PURE__*/$parcel$interopDefault($dDyyD)))(answer1) || (0, (/*@__PURE__*/$parcel$interopDefault($dDyyD)))(answer2) || (0, (/*@__PURE__*/$parcel$interopDefault($dDyyD)))(answer3),
                    onClick: handleSaveQuestionAndResponses,
                    children: "Save"
                })
            })
        ]
    });
};
$65b8bc3753f9832b$var$ChallengeQuestions.propTypes = {
    user: (0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).object.isRequired,
    onSave: (0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).func
};
var $65b8bc3753f9832b$export$2e2bcd8739ae039 = $65b8bc3753f9832b$var$ChallengeQuestions;


const $b01bc80274f0921f$var$CompleteRegistration = ()=>{
    const { user: user } = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e)();
    const navigate = (0, $88be82bcdaab0750$export$9770f232ac06a008)();
    const handleSave = ()=>{
        navigate('/home');
    };
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "justify-center py-12 page",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                className: "text-center sm:mx-auto sm:w-full sm:max-w-md",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h2", {
                        children: "Complete Registration"
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                        className: "mt-1 text-sm leading-6 text-gray-600",
                        children: "Complete your registration by setting your challenge questions to allow for account recovery in case you forget your password."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "mt-10 sm:mx-auto sm:w-full sm:max-w-md",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $65b8bc3753f9832b$export$2e2bcd8739ae039), {
                    user: user,
                    onSave: handleSave
                })
            })
        ]
    });
};
var $b01bc80274f0921f$export$2e2bcd8739ae039 = $b01bc80274f0921f$var$CompleteRegistration;




const $2c0a2054119283d0$var$ErrorPage = ()=>{
    const error = (0, $88be82bcdaab0750$export$ed527bf60f6e05f2)();
    // eslint-disable-next-line no-console
    console.error(error);
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        id: "error-page",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h1", {
                children: "Oops!"
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                children: "Sorry, an unexpected error has occurred."
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("i", {
                    children: error.statusText || error.message
                })
            })
        ]
    });
};
var $2c0a2054119283d0$export$2e2bcd8739ae039 = $2c0a2054119283d0$var$ErrorPage;








var $6uYXW = parcelRequire("6uYXW");
const $ee2b5825bb99ab9f$var$ChallengeQuestions = ({ questions: questions = [] })=>{
    const [question1, setQuestion1] = (0, $6uYXW.useState)(-1);
    const [question2, setQuestion2] = (0, $6uYXW.useState)(-1);
    const [question3, setQuestion3] = (0, $6uYXW.useState)(-1);
    const questionSet1 = questions.filter(({ id: id })=>id != question2 && id != question3);
    const questionSet2 = questions.filter(({ id: id })=>id != question1 && id != question3);
    const questionSet3 = questions.filter(({ id: id })=>id != question1 && id != question2);
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $32c03629429003d8$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                className: "form-control",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                        htmlFor: "question1",
                        className: "label label-text",
                        children: "Question 1"
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("select", {
                        id: "question1",
                        name: "question1",
                        required: true,
                        className: "select select-bordered select-sm",
                        onChange: ({ target: target })=>setQuestion1(target.value),
                        value: question1,
                        children: [
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                value: -1,
                                children: "Choose..."
                            }),
                            questionSet1.map(({ id: id, question: question })=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                    value: id,
                                    children: question
                                }, `${id}`))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                className: "form-control",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                        htmlFor: "answer1",
                        className: "label label-text",
                        children: "Answer 1"
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                        id: "answer1",
                        name: "answer1",
                        type: "text",
                        required: true,
                        className: "input input-sm input-bordered"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                className: "form-control",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                        htmlFor: "question2",
                        className: "label label-text",
                        children: "Question 2"
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("select", {
                        id: "question2",
                        name: "question2",
                        required: true,
                        className: "select select-bordered select-sm",
                        onChange: ({ target: target })=>setQuestion2(target.value),
                        value: question2,
                        children: [
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                value: -1,
                                children: "Choose..."
                            }),
                            questionSet2.map(({ id: id, question: question })=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                    value: id,
                                    children: question
                                }, `${id}`))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                className: "form-control",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                        htmlFor: "answer2",
                        className: "label label-text",
                        children: "Answer 2"
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                        id: "answer2",
                        name: "answer2",
                        type: "text",
                        required: true,
                        className: "input input-sm input-bordered"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                className: "form-control",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                        htmlFor: "question3",
                        className: "label label-text",
                        children: "Question 3"
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("select", {
                        id: "question3",
                        name: "question3",
                        required: true,
                        className: "select select-bordered select-sm",
                        onChange: ({ target: target })=>setQuestion3(target.value),
                        value: question3,
                        children: [
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                value: -1,
                                children: "Choose..."
                            }),
                            questionSet3.map(({ id: id, question: question })=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                    value: id,
                                    children: question
                                }, `${id}`))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                className: "form-control",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                        htmlFor: "answer3",
                        className: "label label-text",
                        children: "Answer 3"
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                        id: "answer3",
                        name: "answer3",
                        type: "text",
                        required: true,
                        className: "input input-sm input-bordered"
                    })
                ]
            })
        ]
    });
};
$ee2b5825bb99ab9f$var$ChallengeQuestions.propTypes = {
    questions: (0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).object)
};
var $ee2b5825bb99ab9f$export$2e2bcd8739ae039 = $ee2b5825bb99ab9f$var$ChallengeQuestions;



async function $b811950337b3734f$export$f4c5de44377d2946() {
    const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get('/clients/security-questions');
    return data;
}
async function $b811950337b3734f$export$31eb53bd5b582a97({ request: request /*params */  }) {
    const { signInWithoutCreds: signInWithoutCreds } = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e).getState();
    const formData = await request.formData();
    const data = Object.fromEntries(formData);
    const errors = {};
    if (data.form === 'challQuestions') {
        const security_answers = [
            {
                question_id: parseInt(data.question1, 10),
                answer: data.answer1
            },
            {
                question_id: parseInt(data.question2, 10),
                answer: data.answer2
            },
            {
                question_id: parseInt(data.question3, 10),
                answer: data.answer3
            }
        ];
        try {
            await signInWithoutCreds(data.username, security_answers);
            return (0, $9a468b9555c2dd85$export$89e12c5b50f7529d)('/home');
        } catch (err) {
            errors.challQuestions = {
                message: 'Unable to save your choices'
            };
        }
    }
    return errors;
}
const $b811950337b3734f$var$ForgotPassword = ()=>{
    const { subTask: subTask } = (0, $88be82bcdaab0750$export$99eaa27ddbbb95ef)();
    const questions = (0, $88be82bcdaab0750$export$1448a5050d252c4d)();
    const showChallQuestLogin = subTask === 'questions';
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
        className: "justify-center py-12 page",
        children: showChallQuestLogin ? /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $32c03629429003d8$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                    className: "sm:mx-auto sm:w-full sm:max-w-sm",
                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h2", {
                        children: "Answer Challenge Questions"
                    })
                }),
                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                    className: "mt-10 sm:mx-auto sm:w-full sm:max-w-sm",
                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $c6d33de9e7cf86ac$export$a7fed597f4b8afd8), {
                        className: "space-y-6",
                        method: "post",
                        children: [
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                className: "form-control",
                                children: [
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                        htmlFor: "username",
                                        className: "label label-text",
                                        children: "Username"
                                    }),
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                        id: "username",
                                        name: "username",
                                        type: "text",
                                        autoComplete: "username",
                                        required: true,
                                        className: "w-full input input-sm input-bordered"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $ee2b5825bb99ab9f$export$2e2bcd8739ae039), {
                                questions: questions
                            }),
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                                    className: "text-white btn btn-primary btn-sm btn-block",
                                    name: "form",
                                    value: "challQuestions",
                                    children: "Sign In"
                                })
                            })
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $32c03629429003d8$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                    className: "sm:mx-auto sm:w-full sm:max-w-sm",
                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h2", {
                        children: "Forgot password"
                    })
                }),
                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                    className: "mt-10 sm:mx-auto sm:w-full sm:max-w-sm",
                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("p", {
                        children: [
                            "You can",
                            ' ',
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                to: "/forgotPassword/reset",
                                className: "link link-primary",
                                children: "reset your password"
                            }),
                            ' ',
                            "if you added a valid mobile number when you registered. Alternatively, you can",
                            ' ',
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                to: "/forgotPassword/questions",
                                className: "link link-primary",
                                children: "login with your username and challenge questions"
                            }),
                            ' ',
                            "you answered when you registered."
                        ]
                    })
                })
            ]
        })
    });
};
var $b811950337b3734f$export$2e2bcd8739ae039 = $b811950337b3734f$var$ForgotPassword;


var $48f8dfe8d4e2503d$export$2e2bcd8739ae039 = (0, $b811950337b3734f$export$2e2bcd8739ae039);






const $bd068e8c9e1d16ad$var$status = {
    incomplete: 'Incomplete (Not Released)',
    waitlist: 'Wait List',
    new: 'New',
    open: 'Open',
    onhold: 'On Hold',
    completed: 'Service Provided',
    closed: 'Service Not Provided',
    cancelled: 'Cancelled',
    fulfillment: 'Open: In-fulfillment',
    'closed-no-contact': 'Service Not Provided: Unable to Contact Client',
    'closed-duplicate': 'Service Not Provided: Duplicate Service Request',
    'closed-service-not-available': 'Service Not Provided: Service not currently available',
    'closed-registration': 'Service Not Provided: Registration full/past deadline',
    'closed-ineligible': 'Service Not Provided: Client ineligible',
    'closed-service-inaccessible': 'Service Not Provided: Service inaccessible',
    'closed-opted-out': 'Service Not Provided: Client opted out',
    'closed-other': 'Service Not Provided: Other',
    'closed-verbal': 'Verbal Referral Made'
};
var $bd068e8c9e1d16ad$export$2e2bcd8739ae039 = {
    status: $bd068e8c9e1d16ad$var$status,
    closedStatuses: [
        'completed',
        'cancelled',
        ...Object.keys($bd068e8c9e1d16ad$var$status).filter((s)=>s.startsWith('closed'))
    ],
    openStatuses: [
        'open',
        'fulfillment'
    ],
    shortStatus: {
        completed: 'Complete',
        closed: 'Close',
        cancelled: 'Cancel'
    },
    durationUnits: {
        once: 'Once',
        days: 'Daily',
        weeks: 'Weekly',
        months: 'Monthly',
        yearly: 'Yearly'
    },
    marital_status: {
        single: 'Single',
        married: 'Married',
        divorced: 'Divorced',
        widowed: 'Widowed'
    },
    disability: {
        no: 'No',
        yes: 'Yes',
        decline: 'Decline to answer'
    },
    veteran: {
        no: 'No',
        yes: 'Yes',
        decline: 'Decline to answer'
    },
    ethnicity: {
        no: 'Not Hispanic or Latino',
        yes: 'Hispanic or Latino',
        decline: 'Decline to answer'
    },
    race: {
        amer_indian: 'American Indian or Alaska Native',
        asian: 'Asian',
        black: 'Black or African American',
        native_hawaiian_islander: 'Native Hawaiian or Other Pacific Islander',
        white: 'White',
        other: 'Other race',
        decline: 'Decline to answer'
    },
    fulfillmentStatus: {
        FULFILLED: 'Fulfilled',
        NOT_REIMBURSEABLE: 'Fulfilled - Not Reimbursable',
        NOT_ELIGIBLE: 'Not Eligible'
    },
    agencyType: {
        CLINICAL: 'clinical',
        EXECUTING: 'executing',
        HEALTHPLAN: 'healthplan'
    }
};



const $880b1e72ccbac58f$var$Home = ()=>{
    const { user: user } = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e)();
    const incompleteQuery = (0, $b505c391aa3d7eba$export$dd0a697e1782aedd)({
        queryKey: [
            'incompleteRequests',
            user?.id
        ],
        queryFn: async ()=>{
            const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get(`/clients/${user?.id}/incomplete-requests`);
            return data;
        }
    });
    const openQuery = (0, $b505c391aa3d7eba$export$dd0a697e1782aedd)({
        queryKey: [
            'openRequests',
            user?.id
        ],
        queryFn: async ()=>{
            const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get(`/clients/${user?.id}/open-requests`);
            return data;
        }
    });
    const closedQuery = (0, $b505c391aa3d7eba$export$dd0a697e1782aedd)({
        queryKey: [
            'closedRequests',
            user?.id
        ],
        queryFn: async ()=>{
            const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get(`/clients/${user?.id}/closed-requests`);
            return data;
        }
    });
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "home page-wide",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                className: "flex flex-row items-center justify-between mb-4",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h1", {
                        className: "mb-0",
                        children: "Home"
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                        to: "/",
                        className: "btn btn-primary",
                        children: "New Service Request"
                    })
                ]
            }),
            incompleteQuery?.data?.length > 0 && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $32c03629429003d8$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h2", {
                        children: "Incomplete Service Requests (more info needed)"
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("table", {
                        className: "table w-full mb-4",
                        children: [
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("th", {
                                            children: "Date"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("th", {
                                            children: "Service"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("th", {
                                            children: "Agency"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("th", {
                                            children: "Missing Questionnaires"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("tbody", {
                                children: incompleteQuery?.data?.map((request)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("td", {
                                                children: new Date(request.request_dttm).toLocaleDateString()
                                            }),
                                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("td", {
                                                children: request.taxonomy_detail
                                            }),
                                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("td", {
                                                children: request.external_211_service.data.locations[0].name
                                            }),
                                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("td", {
                                                children: request.missingAssessments.map(({ name: name, care_quest_group_id: care_quest_group_id })=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                                        className: "inline-block px-2 link link-primary",
                                                        to: `/assessments/${care_quest_group_id}`,
                                                        children: name
                                                    }, `${name}-${care_quest_group_id}`))
                                            })
                                        ]
                                    }, request.id))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h2", {
                children: "In-progress Service Requests"
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("table", {
                className: "table w-full mb-4",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("th", {
                                    children: "Date"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("th", {
                                    children: "Service"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("th", {
                                    children: "Agency"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("th", {
                                    children: "Status"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("tbody", {
                        children: [
                            openQuery?.isLoading && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("td", {
                                    colSpan: 4,
                                    children: "Loading..."
                                })
                            }),
                            openQuery?.isError && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("td", {
                                    colSpan: 4,
                                    children: "Error loading open service requests"
                                })
                            }),
                            !openQuery?.isLoading && !openQuery?.isError && openQuery?.data?.length === 0 && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("td", {
                                    colSpan: 4,
                                    children: "No open service requests"
                                })
                            }),
                            !openQuery?.isLoading && !openQuery?.isError && openQuery?.data?.map((request)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("td", {
                                            children: new Date(request.request_dttm).toLocaleDateString()
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("td", {
                                            children: request.taxonomy_detail
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("td", {
                                            children: request.external_211_service.data.locations[0].name
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("td", {
                                            children: (0, $bd068e8c9e1d16ad$export$2e2bcd8739ae039).status[request.request_status]
                                        })
                                    ]
                                }, request.id))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("p", {
                children: [
                    "Completed Service Requests: ",
                    closedQuery?.data?.length
                ]
            })
        ]
    });
};
var $880b1e72ccbac58f$export$2e2bcd8739ae039 = $880b1e72ccbac58f$var$Home;


var $5db40108ec48fd36$export$2e2bcd8739ae039 = (0, $880b1e72ccbac58f$export$2e2bcd8739ae039);








async function $fbe49b383ff2a675$export$31eb53bd5b582a97({ request: request /*params */  }) {
    const { signIn: signIn } = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e).getState();
    const formData = await request.formData();
    const data = Object.fromEntries(formData);
    try {
        await signIn(data);
        if ((0, $22bff9b089455983$export$8508f2023dac619).getState().program?.id) return (0, $9a468b9555c2dd85$export$89e12c5b50f7529d)('/submitRequest');
        else {
            const { user: user } = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e).getState();
            const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get(`/clients/${user.id}/security-questions-exists`);
            if (!data?.questions_exist) return (0, $9a468b9555c2dd85$export$89e12c5b50f7529d)('/completeRegistration');
        }
        return (0, $9a468b9555c2dd85$export$89e12c5b50f7529d)('/home');
    } catch (err) {
        return err?.response?.data?.error;
    }
}
const $fbe49b383ff2a675$var$Login = ()=>{
    const loginError = (0, $88be82bcdaab0750$export$fdc00f3f26066d5e)();
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "justify-center py-12 page",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "text-center sm:mx-auto sm:w-full sm:max-w-sm",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h2", {
                    children: "Sign in to your account"
                })
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                className: "mt-10 sm:mx-auto sm:w-full sm:max-w-sm",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $c6d33de9e7cf86ac$export$a7fed597f4b8afd8), {
                        className: "space-y-6",
                        method: "post",
                        children: [
                            loginError?.code === 'LOGIN_FAILED' && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $4bb5f6c4bf3ec124$export$2e2bcd8739ae039), {
                                message: "Invalid username or password, please try again."
                            }),
                            loginError?.code === 'USERNAME_EMAIL_REQUIRED' && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $4bb5f6c4bf3ec124$export$2e2bcd8739ae039), {
                                message: "Username is required."
                            }),
                            loginError?.code === 'UNKNOWN' && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $4bb5f6c4bf3ec124$export$2e2bcd8739ae039), {
                                message: "Unable to log in at this time. Please try again later."
                            }),
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                className: "form-control",
                                children: [
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                        htmlFor: "username",
                                        className: "label label-text",
                                        children: "Username"
                                    }),
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                        id: "username",
                                        name: "username",
                                        type: "text",
                                        autoComplete: "username",
                                        required: true,
                                        className: "w-full input input-sm input-bordered"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                className: "form-control",
                                children: [
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                                htmlFor: "password",
                                                className: "label label-text",
                                                children: "Password"
                                            }),
                                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                                    to: "/forgotPassword",
                                                    className: "link link-primary label-text",
                                                    children: "Forgot password?"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                        id: "password",
                                        name: "password",
                                        type: "password",
                                        autoComplete: "current-password",
                                        required: true,
                                        className: "w-full input input-sm input-bordered"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                                    className: "text-white btn btn-primary btn-sm btn-block",
                                    children: "Sign In"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("p", {
                        className: "mt-10 text-sm text-center text-gray-600",
                        children: [
                            "No account?",
                            ' ',
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                to: "/register",
                                className: "link link-primary",
                                children: "Register Now"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("p", {
                        className: "mt-8 text-xs text-center text-gray-400",
                        children: [
                            "\xa9 ",
                            new Date().getFullYear(),
                            " Tandem, Build",
                            ' ',
                            "77"
                        ]
                    })
                ]
            })
        ]
    });
};
var $fbe49b383ff2a675$export$2e2bcd8739ae039 = $fbe49b383ff2a675$var$Login;



var $6uYXW = parcelRequire("6uYXW");


const $bdd7c25d548c08c8$var$Logout = ()=>{
    const { signOut: signOut } = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e)();
    const navigate = (0, $88be82bcdaab0750$export$9770f232ac06a008)();
    (0, $6uYXW.useEffect)(()=>{
        signOut();
        navigate('/', {
            replace: true
        });
    }, []);
    return null;
};
var $bdd7c25d548c08c8$export$2e2bcd8739ae039 = $bdd7c25d548c08c8$var$Logout;









// Every service is linked to the org through its locations, so the org name
// comes back with the data rather than needing a separate lookup.
const $e632337bccd116e5$var$organizationName = (programs)=>programs?.[0]?.locations?.[0]?.organization_name;
const $e632337bccd116e5$var$OrganizationServices = ()=>{
    const { orgId: orgId } = (0, $88be82bcdaab0750$export$99eaa27ddbbb95ef)();
    const navigate = (0, $88be82bcdaab0750$export$9770f232ac06a008)();
    const { setProgram: setProgram } = (0, $22bff9b089455983$export$8508f2023dac619)();
    const { data: programs, isLoading: isLoading, isError: isError, refetch: refetch } = (0, $b505c391aa3d7eba$export$dd0a697e1782aedd)({
        queryKey: [
            'organizationServices',
            orgId
        ],
        queryFn: async ()=>{
            const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get('/clients/services-by-org', {
                params: {
                    orgId: orgId
                }
            });
            return data;
        }
    });
    // ServiceCard's Apply button is a submit button carrying the program id as its
    // value. Stash the chosen program, then let the Form navigate to /checkProfile.
    const handleSubmit = ({ nativeEvent: nativeEvent })=>{
        const programId = nativeEvent.submitter.value;
        setProgram(programs.find((p)=>p.id == programId));
    };
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "page organization-services",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                className: "sm:mx-auto sm:w-full sm:max-w-2xl",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h2", {
                        children: $e632337bccd116e5$var$organizationName(programs)
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h5", {
                        children: "Organization Services"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "sm:mx-auto sm:w-full sm:max-w-2xl",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $c6d33de9e7cf86ac$export$a7fed597f4b8afd8), {
                    method: "get",
                    action: "/checkProfile",
                    onSubmit: handleSubmit,
                    children: [
                        isLoading && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                            className: "text-center",
                            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                                className: "loading loading-dots loading-lg text-primary"
                            })
                        }),
                        isError && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $d71cbaef15ea582f$export$2e2bcd8739ae039), {
                            onRetry: refetch
                        }),
                        !isLoading && !isError && programs.length === 0 && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                                    children: "No services found for this organization."
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-primary btn-sm btn-block",
                                    onClick: ()=>navigate(-1),
                                    children: "Go Back"
                                })
                            ]
                        }),
                        !isLoading && !isError && programs.map((program)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $56f28e4051d8651c$export$2e2bcd8739ae039), {
                                program: program,
                                programNameAsTitle: true
                            }, program.id))
                    ]
                })
            })
        ]
    });
};
var $e632337bccd116e5$export$2e2bcd8739ae039 = $e632337bccd116e5$var$OrganizationServices;


var $5dced1388b58754f$export$2e2bcd8739ae039 = (0, $e632337bccd116e5$export$2e2bcd8739ae039);




var $6uYXW = parcelRequire("6uYXW");





var $52bdc8f8e8ec5565$var$_client, $52bdc8f8e8ec5565$var$_currentResult, $52bdc8f8e8ec5565$var$_currentMutation, $52bdc8f8e8ec5565$var$_mutateOptions, $52bdc8f8e8ec5565$var$_updateResult, $52bdc8f8e8ec5565$var$updateResult_fn, $52bdc8f8e8ec5565$var$_notify, $52bdc8f8e8ec5565$var$notify_fn;
var $52bdc8f8e8ec5565$export$d3c1860ee66f291a = class extends (0, $6164943b6c12fe94$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $52bdc8f8e8ec5565$var$_updateResult);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $52bdc8f8e8ec5565$var$_notify);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $52bdc8f8e8ec5565$var$_client, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $52bdc8f8e8ec5565$var$_currentResult, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $52bdc8f8e8ec5565$var$_currentMutation, void 0);
        (0, $d6bb706f240c69b6$export$addf369becd23283)(this, $52bdc8f8e8ec5565$var$_mutateOptions, void 0);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $52bdc8f8e8ec5565$var$_client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $52bdc8f8e8ec5565$var$_updateResult, $52bdc8f8e8ec5565$var$updateResult_fn).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _a;
        const prevOptions = this.options;
        this.options = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_client).defaultMutationOptions(options);
        if (!(0, $91075ea0d0756915$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_currentMutation),
            observer: this
        });
        if ((prevOptions == null ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, $91075ea0d0756915$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $91075ea0d0756915$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (((_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_currentMutation)) == null ? void 0 : _a.state.status) === "pending") (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_currentMutation).setOptions(this.options);
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) (_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_currentMutation)) == null || _a.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $52bdc8f8e8ec5565$var$_updateResult, $52bdc8f8e8ec5565$var$updateResult_fn).call(this);
        (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $52bdc8f8e8ec5565$var$_notify, $52bdc8f8e8ec5565$var$notify_fn).call(this, action);
    }
    getCurrentResult() {
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_currentResult);
    }
    reset() {
        var _a;
        (_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $52bdc8f8e8ec5565$var$_currentMutation, void 0);
        (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $52bdc8f8e8ec5565$var$_updateResult, $52bdc8f8e8ec5565$var$updateResult_fn).call(this);
        (0, $d6bb706f240c69b6$export$fa92d15b718fce20)(this, $52bdc8f8e8ec5565$var$_notify, $52bdc8f8e8ec5565$var$notify_fn).call(this);
    }
    mutate(variables, options) {
        var _a;
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $52bdc8f8e8ec5565$var$_mutateOptions, options);
        (_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $52bdc8f8e8ec5565$var$_currentMutation, (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_client).getMutationCache().build((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_client), this.options));
        (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_currentMutation).addObserver(this);
        return (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_currentMutation).execute(variables);
    }
};
$52bdc8f8e8ec5565$var$_client = new WeakMap();
$52bdc8f8e8ec5565$var$_currentResult = new WeakMap();
$52bdc8f8e8ec5565$var$_currentMutation = new WeakMap();
$52bdc8f8e8ec5565$var$_mutateOptions = new WeakMap();
$52bdc8f8e8ec5565$var$_updateResult = new WeakSet();
$52bdc8f8e8ec5565$var$updateResult_fn = function() {
    var _a;
    const state = ((_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_currentMutation)) == null ? void 0 : _a.state) ?? (0, $766e652c0fb9d81d$export$a1659b54bac3252a)();
    (0, $d6bb706f240c69b6$export$42432efe6614d3b4)(this, $52bdc8f8e8ec5565$var$_currentResult, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
};
$52bdc8f8e8ec5565$var$_notify = new WeakSet();
$52bdc8f8e8ec5565$var$notify_fn = function(action) {
    (0, $ca19c9b496b64b93$export$520687f44db6e1ab).batch(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_mutateOptions) && this.hasListeners()) {
            const variables = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_currentResult).variables;
            const context = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_currentResult).context;
            if ((action == null ? void 0 : action.type) === "success") {
                (_b = (_a = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_mutateOptions)).onSuccess) == null || _b.call(_a, action.data, variables, context);
                (_d = (_c = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_mutateOptions)).onSettled) == null || _d.call(_c, action.data, null, variables, context);
            } else if ((action == null ? void 0 : action.type) === "error") {
                (_f = (_e = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_mutateOptions)).onError) == null || _f.call(_e, action.error, variables, context);
                (_h = (_g = (0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_mutateOptions)).onSettled) == null || _h.call(_g, void 0, action.error, variables, context);
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $d6bb706f240c69b6$export$18a094aefa070634)(this, $52bdc8f8e8ec5565$var$_currentResult));
        });
    });
};




"use client";
function $09aa25a5777508fa$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $8136cc1e66cf8798$export$22e77b9572c4fded)(queryClient);
    const [observer] = $6uYXW.useState(()=>new (0, $52bdc8f8e8ec5565$export$d3c1860ee66f291a)(client, options));
    $6uYXW.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $6uYXW.useSyncExternalStore($6uYXW.useCallback((onStoreChange)=>observer.subscribe((0, $ca19c9b496b64b93$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $6uYXW.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $d5bdeafed6b3345e$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $d5bdeafed6b3345e$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}



var $b73b0d42318075d9$exports = {};
(function(globalScope) {
    'use strict';
    /*!
   *  decimal.js v10.4.3
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js
   *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The maximum exponent magnitude.
    // The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
    var EXP_LIMIT = 9e15, // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    MAX_DIGITS = 1e9, // Base conversion alphabet.
    NUMERALS = '0123456789abcdef', // The natural logarithm of 10 (1025 digits).
    LN10 = '2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058', // Pi (1025 digits).
    PI = '3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789', // The initial configuration properties of the Decimal constructor.
    DEFAULTS = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed at run-time using the `Decimal.config` method.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used when rounding to `precision`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP         0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
        // FLOOR      3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN  6 The IEEE 754 remainder function.
        // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
        //
        // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
        // division (9) are commonly used for the modulus operation. The other rounding modes can also
        // be used, but they may not give useful results.
        modulo: 1,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The minimum exponent value, beneath which underflow to zero occurs.
        // JavaScript numbers: -324  (5e-324)
        minE: -EXP_LIMIT,
        // The maximum exponent value, above which overflow to Infinity occurs.
        // JavaScript numbers: 308  (1.7976931348623157e+308)
        maxE: EXP_LIMIT,
        // Whether to use cryptographically-secure random number generation, if available.
        crypto: false // true/false
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    Decimal, inexact, noConflict, quadrant, external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', precisionLimitExceeded = decimalError + 'Precision limit exceeded', cryptoUnavailable = decimalError + 'crypto unavailable', tag = '[object Decimal]', mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, // Decimal.prototype object
    P = {
        toStringTag: tag
    };
    // Decimal prototype methods
    /*
   *  absoluteValue             abs
   *  ceil
   *  clampedTo                 clamp
   *  comparedTo                cmp
   *  cosine                    cos
   *  cubeRoot                  cbrt
   *  decimalPlaces             dp
   *  dividedBy                 div
   *  dividedToIntegerBy        divToInt
   *  equals                    eq
   *  floor
   *  greaterThan               gt
   *  greaterThanOrEqualTo      gte
   *  hyperbolicCosine          cosh
   *  hyperbolicSine            sinh
   *  hyperbolicTangent         tanh
   *  inverseCosine             acos
   *  inverseHyperbolicCosine   acosh
   *  inverseHyperbolicSine     asinh
   *  inverseHyperbolicTangent  atanh
   *  inverseSine               asin
   *  inverseTangent            atan
   *  isFinite
   *  isInteger                 isInt
   *  isNaN
   *  isNegative                isNeg
   *  isPositive                isPos
   *  isZero
   *  lessThan                  lt
   *  lessThanOrEqualTo         lte
   *  logarithm                 log
   *  [maximum]                 [max]
   *  [minimum]                 [min]
   *  minus                     sub
   *  modulo                    mod
   *  naturalExponential        exp
   *  naturalLogarithm          ln
   *  negated                   neg
   *  plus                      add
   *  precision                 sd
   *  round
   *  sine                      sin
   *  squareRoot                sqrt
   *  tangent                   tan
   *  times                     mul
   *  toBinary
   *  toDecimalPlaces           toDP
   *  toExponential
   *  toFixed
   *  toFraction
   *  toHexadecimal             toHex
   *  toNearest
   *  toNumber
   *  toOctal
   *  toPower                   pow
   *  toPrecision
   *  toSignificantDigits       toSD
   *  toString
   *  truncated                 trunc
   *  valueOf                   toJSON
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s < 0) x.s = 1;
        return finalise(x);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of positive Infinity.
   *
   */ P.ceil = function() {
        return finalise(new this.constructor(this), this.e + 1, 2);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal clamped to the range
   * delineated by `min` and `max`.
   *
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */ P.clampedTo = P.clamp = function(min, max) {
        var k, x = this, Ctor = x.constructor;
        min = new Ctor(min);
        max = new Ctor(max);
        if (!min.s || !max.s) return new Ctor(NaN);
        if (min.gt(max)) throw Error(invalidArgument + max);
        k = x.cmp(min);
        return k < 0 ? min : x.cmp(max) > 0 ? max : new Ctor(x);
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value,
   *   NaN  if the value of either Decimal is NaN.
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this, xd = x.d, yd = (y = new x.constructor(y)).d, xs = x.s, ys = y.s;
        // Either NaN or ±Infinity?
        if (!xd || !yd) return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
        // Either zero?
        if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;
        // Signs differ?
        if (xs !== ys) return xs;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;
        xdL = xd.length;
        ydL = yd.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
    };
    /*
   * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * cos(0)         = 1
   * cos(-0)        = 1
   * cos(Infinity)  = NaN
   * cos(-Infinity) = NaN
   * cos(NaN)       = NaN
   *
   */ P.cosine = P.cos = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.d) return new Ctor(NaN);
        // cos(0) = cos(-0) = 1
        if (!x.d[0]) return new Ctor(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = cosine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
    };
    /*
   *
   * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   *  cbrt(0)  =  0
   *  cbrt(-0) = -0
   *  cbrt(1)  =  1
   *  cbrt(-1) = -1
   *  cbrt(N)  =  N
   *  cbrt(-I) = -I
   *  cbrt(I)  =  I
   *
   * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
   *
   */ P.cubeRoot = P.cbrt = function() {
        var e, m, n, r, rep, s, sd, t, t3, t3plusx, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        external = false;
        // Initial estimate.
        s = x.s * mathpow(x.s * x, 1 / 3);
        // Math.cbrt underflow/overflow?
        // Pass x to Math.pow as integer, then adjust the exponent of the result.
        if (!s || Math.abs(s) == 1 / 0) {
            n = digitsToString(x.d);
            e = x.e;
            // Adjust n exponent so it is a multiple of 3 away from x exponent.
            if (s = (e - n.length + 1) % 3) n += s == 1 || s == -2 ? '0' : '00';
            s = mathpow(n, 1 / 3);
            // Rarely, e may be one less than the result exponent value.
            e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
            r.s = x.s;
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Halley's method.
        // TODO? Compare Newton's method.
        for(;;){
            t = r;
            t3 = t.times(t).times(t);
            t3plusx = t3.plus(x);
            r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
                // , i.e. approaching a rounding boundary, continue the iteration.
                if (n == '9999' || !rep && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var w, d = this.d, n = NaN;
        if (d) {
            w = d.length - 1;
            n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last word.
            w = d[w];
            if (w) for(; w % 10 == 0; w /= 10)n--;
            if (n < 0) n = 0;
        }
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedToIntegerBy = P.divToInt = function(y) {
        var x = this, Ctor = x.constructor;
        return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return this.cmp(y) === 0;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of negative Infinity.
   *
   */ P.floor = function() {
        return finalise(new this.constructor(this), this.e + 1, 3);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        var k = this.cmp(y);
        return k == 1 || k === 0;
    };
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [1, Infinity]
   *
   * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
   *
   * cosh(0)         = 1
   * cosh(-0)        = 1
   * cosh(Infinity)  = Infinity
   * cosh(-Infinity) = Infinity
   * cosh(NaN)       = NaN
   *
   *  x        time taken (ms)   result
   * 1000      9                 9.8503555700852349694e+433
   * 10000     25                4.4034091128314607936e+4342
   * 100000    171               1.4033316802130615897e+43429
   * 1000000   3817              1.5166076984010437725e+434294
   * 10000000  abandoned after 2 minute wait
   *
   * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
   *
   */ P.hyperbolicCosine = P.cosh = function() {
        var k, n, pr, rm, len, x = this, Ctor = x.constructor, one = new Ctor(1);
        if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
        if (x.isZero()) return one;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
        // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))
        // Estimate the optimum number of times to use the argument reduction.
        // TODO? Estimation reused from cosine() and may not be optimal here.
        if (len < 32) {
            k = Math.ceil(len / 3);
            n = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            n = '2.3283064365386962890625e-10';
        }
        x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);
        // Reverse argument reduction
        var cosh2_x, i = k, d8 = new Ctor(8);
        for(; i--;){
            cosh2_x = x.times(x);
            x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
        }
        return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
   *
   * sinh(0)         = 0
   * sinh(-0)        = -0
   * sinh(Infinity)  = Infinity
   * sinh(-Infinity) = -Infinity
   * sinh(NaN)       = NaN
   *
   * x        time taken (ms)
   * 10       2 ms
   * 100      5 ms
   * 1000     14 ms
   * 10000    82 ms
   * 100000   886 ms            1.4033316802130615897e+43429
   * 200000   2613 ms
   * 300000   5407 ms
   * 400000   8824 ms
   * 500000   13026 ms          8.7080643612718084129e+217146
   * 1000000  48543 ms
   *
   * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
   *
   */ P.hyperbolicSine = P.sinh = function() {
        var k, pr, rm, len, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        if (len < 3) x = taylorSeries(Ctor, 2, x, x, true);
        else {
            // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
            // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
            // 3 multiplications and 1 addition
            // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
            // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
            // 4 multiplications and 2 additions
            // Estimate the optimum number of times to use the argument reduction.
            k = 1.4 * Math.sqrt(len);
            k = k > 16 ? 16 : k | 0;
            x = x.times(1 / tinyPow(5, k));
            x = taylorSeries(Ctor, 2, x, x, true);
            // Reverse argument reduction
            var sinh2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
            for(; k--;){
                sinh2_x = x.times(x);
                x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
            }
        }
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * tanh(x) = sinh(x) / cosh(x)
   *
   * tanh(0)         = 0
   * tanh(-0)        = -0
   * tanh(Infinity)  = 1
   * tanh(-Infinity) = -1
   * tanh(NaN)       = NaN
   *
   */ P.hyperbolicTangent = P.tanh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(x.s);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 7;
        Ctor.rounding = 1;
        return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
    };
    /*
   * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
   * this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [0, pi]
   *
   * acos(x) = pi/2 - asin(x)
   *
   * acos(0)       = pi/2
   * acos(-0)      = pi/2
   * acos(1)       = 0
   * acos(-1)      = pi
   * acos(1/2)     = pi/3
   * acos(-1/2)    = 2*pi/3
   * acos(|x| > 1) = NaN
   * acos(NaN)     = NaN
   *
   */ P.inverseCosine = P.acos = function() {
        var halfPi, x = this, Ctor = x.constructor, k = x.abs().cmp(1), pr = Ctor.precision, rm = Ctor.rounding;
        if (k !== -1) return k === 0 ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0) : new Ctor(NaN);
        if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);
        // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.asin();
        halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return halfPi.minus(x);
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
   * value of this Decimal.
   *
   * Domain: [1, Infinity]
   * Range: [0, Infinity]
   *
   * acosh(x) = ln(x + sqrt(x^2 - 1))
   *
   * acosh(x < 1)     = NaN
   * acosh(NaN)       = NaN
   * acosh(Infinity)  = Infinity
   * acosh(-Infinity) = NaN
   * acosh(0)         = NaN
   * acosh(-0)        = NaN
   * acosh(1)         = 0
   * acosh(-1)        = NaN
   *
   */ P.inverseHyperbolicCosine = P.acosh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
        if (!x.isFinite()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).minus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * asinh(x) = ln(x + sqrt(x^2 + 1))
   *
   * asinh(NaN)       = NaN
   * asinh(Infinity)  = Infinity
   * asinh(-Infinity) = -Infinity
   * asinh(0)         = 0
   * asinh(-0)        = -0
   *
   */ P.inverseHyperbolicSine = P.asinh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).plus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
   * value of this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [-Infinity, Infinity]
   *
   * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
   *
   * atanh(|x| > 1)   = NaN
   * atanh(NaN)       = NaN
   * atanh(Infinity)  = NaN
   * atanh(-Infinity) = NaN
   * atanh(0)         = 0
   * atanh(-0)        = -0
   * atanh(1)         = Infinity
   * atanh(-1)        = -Infinity
   *
   */ P.inverseHyperbolicTangent = P.atanh = function() {
        var pr, rm, wpr, xsd, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        xsd = x.sd();
        if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);
        Ctor.precision = wpr = xsd - x.e;
        x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);
        Ctor.precision = pr + 4;
        Ctor.rounding = 1;
        x = x.ln();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(0.5);
    };
    /*
   * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
   *
   * asin(0)       = 0
   * asin(-0)      = -0
   * asin(1/2)     = pi/6
   * asin(-1/2)    = -pi/6
   * asin(1)       = pi/2
   * asin(-1)      = -pi/2
   * asin(|x| > 1) = NaN
   * asin(NaN)     = NaN
   *
   * TODO? Compare performance of Taylor series.
   *
   */ P.inverseSine = P.asin = function() {
        var halfPi, k, pr, rm, x = this, Ctor = x.constructor;
        if (x.isZero()) return new Ctor(x);
        k = x.abs().cmp(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (k !== -1) {
            // |x| is 1
            if (k === 0) {
                halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
                halfPi.s = x.s;
                return halfPi;
            }
            // |x| > 1 or x is NaN
            return new Ctor(NaN);
        }
        // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(2);
    };
    /*
   * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
   *
   * atan(0)         = 0
   * atan(-0)        = -0
   * atan(1)         = pi/4
   * atan(-1)        = -pi/4
   * atan(Infinity)  = pi/2
   * atan(-Infinity) = -pi/2
   * atan(NaN)       = NaN
   *
   */ P.inverseTangent = P.atan = function() {
        var i, j, k, n, px, t, r, wpr, x2, x = this, Ctor = x.constructor, pr = Ctor.precision, rm = Ctor.rounding;
        if (!x.isFinite()) {
            if (!x.s) return new Ctor(NaN);
            if (pr + 4 <= PI_PRECISION) {
                r = getPi(Ctor, pr + 4, rm).times(0.5);
                r.s = x.s;
                return r;
            }
        } else if (x.isZero()) return new Ctor(x);
        else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
            r = getPi(Ctor, pr + 4, rm).times(0.25);
            r.s = x.s;
            return r;
        }
        Ctor.precision = wpr = pr + 10;
        Ctor.rounding = 1;
        // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);
        // Argument reduction
        // Ensure |x| < 0.42
        // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))
        k = Math.min(28, wpr / LOG_BASE + 2 | 0);
        for(i = k; i; --i)x = x.div(x.times(x).plus(1).sqrt().plus(1));
        external = false;
        j = Math.ceil(wpr / LOG_BASE);
        n = 1;
        x2 = x.times(x);
        r = new Ctor(x);
        px = x;
        // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
        for(; i !== -1;){
            px = px.times(x2);
            t = r.minus(px.div(n += 2));
            px = px.times(x2);
            r = t.plus(px.div(n += 2));
            if (r.d[j] !== void 0) for(i = j; r.d[i] === t.d[i] && i--;);
        }
        if (k) r = r.times(2 << k - 1);
        external = true;
        return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return true if the value of this Decimal is a finite number, otherwise return false.
   *
   */ P.isFinite = function() {
        return !!this.d;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isInt = function() {
        return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is NaN, otherwise return false.
   *
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isNeg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.isPos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0 or -0, otherwise return false.
   *
   */ P.isZero = function() {
        return !!this.d && this.d[0] === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * If no base is specified, return log[10](arg).
   *
   * log[base](arg) = ln(arg) / ln(base)
   *
   * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
   * otherwise:
   *
   * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
   * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
   * between the result and the correctly rounded result will be one ulp (unit in the last place).
   *
   * log[-b](a)       = NaN
   * log[0](a)        = NaN
   * log[1](a)        = NaN
   * log[NaN](a)      = NaN
   * log[Infinity](a) = NaN
   * log[b](0)        = -Infinity
   * log[b](-0)       = -Infinity
   * log[b](-a)       = NaN
   * log[b](1)        = 0
   * log[b](Infinity) = Infinity
   * log[b](NaN)      = NaN
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var isBase10, d, denominator, k, inf, num, sd, r, arg = this, Ctor = arg.constructor, pr = Ctor.precision, rm = Ctor.rounding, guard = 5;
        // Default base is 10.
        if (base == null) {
            base = new Ctor(10);
            isBase10 = true;
        } else {
            base = new Ctor(base);
            d = base.d;
            // Return NaN if base is negative, or non-finite, or is 0 or 1.
            if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);
            isBase10 = base.eq(10);
        }
        d = arg.d;
        // Is arg negative, non-finite, 0 or 1?
        if (arg.s < 0 || !d || !d[0] || arg.eq(1)) return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
        // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
        // integer power of 10.
        if (isBase10) {
            if (d.length > 1) inf = true;
            else {
                for(k = d[0]; k % 10 === 0;)k /= 10;
                inf = k !== 1;
            }
        }
        external = false;
        sd = pr + guard;
        num = naturalLogarithm(arg, sd);
        denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
        // The result will have 5 rounding digits.
        r = divide(num, denominator, sd, 1);
        // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
        // calculate 10 further digits.
        //
        // If the result is known to have an infinite decimal expansion, repeat this until it is clear
        // that the result is above or below the boundary. Otherwise, if after calculating the 10
        // further digits, the last 14 are nines, round up and assume the result is exact.
        // Also assume the result is exact if the last 14 are zero.
        //
        // Example of a result that will be incorrectly rounded:
        // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
        // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
        // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
        // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
        // place is still 2.6.
        if (checkRoundingDigits(r.d, k = pr, rm)) do {
            sd += 10;
            num = naturalLogarithm(arg, sd);
            denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
            r = divide(num, denominator, sd, 1);
            if (!inf) {
                // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
                if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
                break;
            }
        }while (checkRoundingDigits(r.d, k += 10, rm));
        external = true;
        return finalise(r, pr, rm);
    };
    /*
   * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.max = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'lt');
  };
   */ /*
   * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.min = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'gt');
  };
   */ /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.minus = P.sub = function(y) {
        var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (x.d) y.s = -y.s;
            else y = new Ctor(y.d || x.s !== y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.plus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return y negated if x is zero and y is non-zero.
            if (yd[0]) y.s = -y.s;
            else if (xd[0]) y = new Ctor(x);
            else return new Ctor(rm === 3 ? -0 : 0);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        e = mathfloor(y.e / LOG_BASE);
        xe = mathfloor(x.e / LOG_BASE);
        xd = xd.slice();
        k = xe - e;
        // If base 1e7 exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of
            // zeros needing to be prepended, but this can be avoided while still ensuring correct
            // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to `xd` if shorter.
        // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * The result depends on the modulo mode.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
        if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);
        // Return x if y is ±Infinity or x is ±0.
        if (!y.d || x.d && !x.d[0]) return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
        // Prevent rounding of intermediate calculations.
        external = false;
        if (Ctor.modulo == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // result = x - q * y    where  0 <= result < abs(y)
            q = divide(x, y.abs(), 0, 3, 1);
            q.s *= y.s;
        } else q = divide(x, y, 0, Ctor.modulo, 1);
        q = q.times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.naturalExponential = P.exp = function() {
        return naturalExponential(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return naturalLogarithm(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s;
        return finalise(x);
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.plus = P.add = function(y) {
        var carry, d, e, i, k, len, pr, rm, xd, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.minus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!yd[0]) y = new Ctor(x);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        k = mathfloor(x.e / LOG_BASE);
        e = mathfloor(y.e / LOG_BASE);
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var k, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        if (x.d) {
            k = getPrecision(x.d);
            if (z && x.e + 1 > k) k = x.e + 1;
        } else k = NaN;
        return k;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.round = function() {
        var x = this, Ctor = x.constructor;
        return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
    };
    /*
   * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * sin(x) = x - x^3/3! + x^5/5! - ...
   *
   * sin(0)         = 0
   * sin(-0)        = -0
   * sin(Infinity)  = NaN
   * sin(-Infinity) = NaN
   * sin(NaN)       = NaN
   *
   */ P.sine = P.sin = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = sine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   *  sqrt(-n) =  N
   *  sqrt(N)  =  N
   *  sqrt(-I) =  N
   *  sqrt(I)  =  I
   *  sqrt(0)  =  0
   *  sqrt(-0) = -0
   *
   */ P.squareRoot = P.sqrt = function() {
        var m, n, sd, r, rep, t, x = this, d = x.d, e = x.e, s = x.s, Ctor = x.constructor;
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !d || !d[0]) return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (n == '9999' || !rep && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * tan(0)         = 0
   * tan(-0)        = -0
   * tan(Infinity)  = NaN
   * tan(-Infinity) = NaN
   * tan(NaN)       = NaN
   *
   */ P.tangent = P.tan = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 10;
        Ctor.rounding = 1;
        x = x.sin();
        x.s = 1;
        x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        y.s *= x.s;
        // If either is NaN, ±Infinity or ±0...
        if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd ? NaN : !xd || !yd ? y.s / 0 : y.s * 0);
        e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = getBase10Exponent(r, e);
        return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
    };
    /*
   * Return a string representing the value of this Decimal in base 2, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toBinary = function(sd, rm) {
        return toStringBinary(this, 2, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.toDP = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return finalise(x, dp + x.e + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), dp + 1, rm);
            str = finiteToString(x, true, dp + 1);
        }
        return x.isNeg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            y = finalise(new Ctor(x), dp + x.e + 1, rm);
            str = finiteToString(y, false, dp + y.e + 1);
        }
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isNeg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return an array representing the value of this Decimal as a simple fraction with an integer
   * numerator and an integer denominator.
   *
   * The denominator will be a positive non-zero value less than or equal to the specified maximum
   * denominator. If a maximum denominator is not specified, the denominator will be the lowest
   * value necessary to represent the number exactly.
   *
   * [maxD] {number|string|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
   *
   */ P.toFraction = function(maxD) {
        var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r, x = this, xd = x.d, Ctor = x.constructor;
        if (!xd) return new Ctor(x);
        n1 = d0 = new Ctor(1);
        d1 = n0 = new Ctor(0);
        d = new Ctor(d1);
        e = d.e = getPrecision(xd) - x.e - 1;
        k = e % LOG_BASE;
        d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);
        if (maxD == null) // d is 10**e, the minimum max-denominator needed.
        maxD = e > 0 ? d : n1;
        else {
            n = new Ctor(maxD);
            if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
            maxD = n.gt(d) ? e > 0 ? d : n1 : n;
        }
        external = false;
        n = new Ctor(digitsToString(xd));
        pr = Ctor.precision;
        Ctor.precision = e = xd.length * LOG_BASE * 2;
        for(;;){
            q = divide(n, d, 0, 1, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.cmp(maxD) == 1) break;
            d0 = d1;
            d1 = d2;
            d2 = n1;
            n1 = n0.plus(q.times(d2));
            n0 = d2;
            d2 = d;
            d = n.minus(q.times(d2));
            n = d2;
        }
        d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        // Determine which fraction is closer to x, n0/d0 or n1/d1?
        r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        Ctor.precision = pr;
        external = true;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal in base 16, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toHexadecimal = P.toHex = function(sd, rm) {
        return toStringBinary(this, 16, sd, rm);
    };
    /*
   * Returns a new Decimal whose value is the nearest multiple of `y` in the direction of rounding
   * mode `rm`, or `Decimal.rounding` if `rm` is omitted, to the value of this Decimal.
   *
   * The return value will always have the same sign as this Decimal, unless either this Decimal
   * or `y` is NaN, in which case the return value will be also be NaN.
   *
   * The return value is not affected by the value of `precision`.
   *
   * y {number|string|Decimal} The magnitude to round to a multiple of.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toNearest() rounding mode not an integer: {rm}'
   * 'toNearest() rounding mode out of range: {rm}'
   *
   */ P.toNearest = function(y, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (y == null) {
            // If x is not finite, return x.
            if (!x.d) return x;
            y = new Ctor(1);
            rm = Ctor.rounding;
        } else {
            y = new Ctor(y);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            // If x is not finite, return x if y is not NaN, else NaN.
            if (!x.d) return y.s ? x : y;
            // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
            if (!y.d) {
                if (y.s) y.s = x.s;
                return y;
            }
        }
        // If y is not zero, calculate the nearest multiple of y to x.
        if (y.d[0]) {
            external = false;
            x = divide(x, y, 0, rm, 1).times(y);
            external = true;
            finalise(x);
        // If y is zero, return zero with the sign of x.
        } else {
            y.s = x.s;
            x = y;
        }
        return x;
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   * Zero keeps its sign.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a string representing the value of this Decimal in base 8, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toOctal = function(sd, rm) {
        return toStringBinary(this, 8, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
   * to `precision` significant digits using rounding mode `rounding`.
   *
   * ECMAScript compliant.
   *
   *   pow(x, NaN)                           = NaN
   *   pow(x, ±0)                            = 1

   *   pow(NaN, non-zero)                    = NaN
   *   pow(abs(x) > 1, +Infinity)            = +Infinity
   *   pow(abs(x) > 1, -Infinity)            = +0
   *   pow(abs(x) == 1, ±Infinity)           = NaN
   *   pow(abs(x) < 1, +Infinity)            = +0
   *   pow(abs(x) < 1, -Infinity)            = +Infinity
   *   pow(+Infinity, y > 0)                 = +Infinity
   *   pow(+Infinity, y < 0)                 = +0
   *   pow(-Infinity, odd integer > 0)       = -Infinity
   *   pow(-Infinity, even integer > 0)      = +Infinity
   *   pow(-Infinity, odd integer < 0)       = -0
   *   pow(-Infinity, even integer < 0)      = +0
   *   pow(+0, y > 0)                        = +0
   *   pow(+0, y < 0)                        = +Infinity
   *   pow(-0, odd integer > 0)              = -0
   *   pow(-0, even integer > 0)             = +0
   *   pow(-0, odd integer < 0)              = -Infinity
   *   pow(-0, even integer < 0)             = +Infinity
   *   pow(finite x < 0, finite non-integer) = NaN
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
   * probability of an incorrectly rounded result
   * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
   * i.e. 1 in 250,000,000,000,000
   *
   * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, rm, s, x = this, Ctor = x.constructor, yn = +(y = new Ctor(y));
        // Either ±Infinity, NaN or ±0?
        if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor(mathpow(+x, yn));
        x = new Ctor(x);
        if (x.eq(1)) return x;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (y.eq(1)) return finalise(x, pr, rm);
        // y exponent
        e = mathfloor(y.e / LOG_BASE);
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = intPow(Ctor, x, k, pr);
            return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
        }
        s = x.s;
        // if x is negative
        if (s < 0) {
            // if y is not an integer
            if (e < y.d.length - 1) return new Ctor(NaN);
            // Result is positive if x is negative and the last digit of integer y is even.
            if ((y.d[e] & 1) == 0) s = 1;
            // if x.eq(-1)
            if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
                x.s = s;
                return x;
            }
        }
        // Estimate result exponent.
        // x^y = 10^e,  where e = y * log10(x)
        // log10(x) = log10(x_significand) + x_exponent
        // log10(x_significand) = ln(x_significand) / ln(10)
        k = mathpow(+x, yn);
        e = k == 0 || !isFinite(k) ? mathfloor(yn * (Math.log('0.' + digitsToString(x.d)) / Math.LN10 + x.e + 1)) : new Ctor(k + '').e;
        // Exponent estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.
        // Overflow/underflow?
        if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);
        external = false;
        Ctor.rounding = x.s = 1;
        // Estimate the extra guard digits needed to ensure five correct rounding digits from
        // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
        // new Decimal(2.32456).pow('2087987436534566.46411')
        // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
        k = Math.min(12, (e + '').length);
        // r = x^y = exp(y*ln(x))
        r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);
        // r may be Infinity, e.g. (0.9999999999999999).pow(-1e+40)
        if (r.d) {
            // Truncate to the required precision plus five rounding digits.
            r = finalise(r, pr + 5, 1);
            // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
            // the result.
            if (checkRoundingDigits(r.d, pr, rm)) {
                e = pr + 10;
                // Truncate to the increased precision plus five rounding digits.
                r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);
                // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
                if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
            }
        }
        r.s = s;
        external = true;
        Ctor.rounding = rm;
        return finalise(r, pr, rm);
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var str, x = this, Ctor = x.constructor;
        if (sd === void 0) str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), sd, rm);
            str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
        }
        return x.isNeg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toSD() digits out of range: {sd}'
   * 'toSD() digits not an integer: {sd}'
   * 'toSD() rounding mode not an integer: {rm}'
   * 'toSD() rounding mode out of range: {rm}'
   *
   */ P.toSignificantDigits = P.toSD = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return finalise(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
   *
   */ P.truncated = P.trunc = function() {
        return finalise(new this.constructor(this), this.e + 1, 1);
    };
    /*
   * Return a string representing the value of this Decimal.
   * Unlike `toString`, negative zero will include the minus sign.
   *
   */ P.valueOf = P.toJSON = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() ? '-' + str : str;
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
   *                           finiteToString, naturalExponential, naturalLogarithm
   *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
   *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
   *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
   *  convertBase              toStringBinary, parseOther
   *  cos                      P.cos
   *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
   *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
   *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
   *                           taylorSeries, atan2, parseOther
   *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
   *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
   *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
   *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
   *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
   *                           P.truncated, divide, getLn10, getPi, naturalExponential,
   *                           naturalLogarithm, ceil, floor, round, trunc
   *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
   *                           toStringBinary
   *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
   *  getLn10                  P.logarithm, naturalLogarithm
   *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
   *  getPrecision             P.precision, P.toFraction
   *  getZeroString            digitsToString, finiteToString
   *  intPow                   P.toPower, parseOther
   *  isOdd                    toLessThanHalfPi
   *  maxOrMin                 max, min
   *  naturalExponential       P.naturalExponential, P.toPower
   *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
   *                           P.toPower, naturalExponential
   *  nonFiniteToString        finiteToString, toStringBinary
   *  parseDecimal             Decimal
   *  parseOther               Decimal
   *  sin                      P.sin
   *  taylorSeries             P.cosh, P.sinh, cos, sin
   *  toLessThanHalfPi         P.cos, P.sin
   *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
   *  truncate                 intPow
   *
   *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
   *                           naturalLogarithm, config, parseOther, random, Decimal
   */ function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    /*
   * Check 5 rounding digits if `repeating` is null, 4 otherwise.
   * `repeating == null` if caller is `log` or `pow`,
   * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
   */ function checkRoundingDigits(d, i, rm, repeating) {
        var di, k, r, rd;
        // Get the length of the first word of the array d.
        for(k = d[0]; k >= 10; k /= 10)--i;
        // Is the rounding digit in the first word of d?
        if (--i < 0) {
            i += LOG_BASE;
            di = 0;
        } else {
            di = Math.ceil((i + 1) / LOG_BASE);
            i %= LOG_BASE;
        }
        // i is the index (0 - 6) of the rounding digit.
        // E.g. if within the word 3487563 the first rounding digit is 5,
        // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
        k = mathpow(10, LOG_BASE - i);
        rd = d[di] % k | 0;
        if (repeating == null) {
            if (i < 3) {
                if (i == 0) rd = rd / 100 | 0;
                else if (i == 1) rd = rd / 10 | 0;
                r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 50000 || rd == 0;
            } else r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 || (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
        } else if (i < 4) {
            if (i == 0) rd = rd / 1000 | 0;
            else if (i == 1) rd = rd / 100 | 0;
            else if (i == 2) rd = rd / 10 | 0;
            r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
        } else r = ((repeating || rm < 4) && rd + 1 == k || !repeating && rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 1000 | 0) == mathpow(10, i - 3) - 1;
        return r;
    }
    // Convert string of `baseIn` to an array of numbers of `baseOut`.
    // Eg. convertBase('255', 10, 16) returns [15, 15].
    // Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
    function convertBase(str, baseIn, baseOut) {
        var j, arr = [
            0
        ], arrL, i = 0, strL = str.length;
        for(; i < strL;){
            for(arrL = arr.length; arrL--;)arr[arrL] *= baseIn;
            arr[0] += NUMERALS.indexOf(str.charAt(i++));
            for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                if (arr[j + 1] === void 0) arr[j + 1] = 0;
                arr[j + 1] += arr[j] / baseOut | 0;
                arr[j] %= baseOut;
            }
        }
        return arr.reverse();
    }
    /*
   * cos(x) = 1 - x^2/2! + x^4/4! - ...
   * |x| < pi/2
   *
   */ function cosine(Ctor, x) {
        var k, len, y;
        if (x.isZero()) return x;
        // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
        // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1
        // Estimate the optimum number of times to use the argument reduction.
        len = x.d.length;
        if (len < 32) {
            k = Math.ceil(len / 3);
            y = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            y = '2.3283064365386962890625e-10';
        }
        Ctor.precision += k;
        x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));
        // Reverse argument reduction
        for(var i = k; i--;){
            var cos2x = x.times(x);
            x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
        }
        Ctor.precision -= k;
        return x;
    }
    /*
   * Perform division in the specified base.
   */ var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k, base) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % base | 0;
                carry = temp / base | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, rm, dp, base) {
            var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either NaN, Infinity or 0?
            if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN : // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
            xd && xd[0] == 0 || !yd ? sign * 0 : sign / 0);
            if (base) {
                logBase = 1;
                e = x.e - y.e;
            } else {
                base = BASE;
                logBase = LOG_BASE;
                e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
            }
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            // The digit array of a Decimal from toStringBinary may have trailing zeros.
            for(i = 0; yd[i] == (xd[i] || 0); i++);
            if (yd[i] > (xd[i] || 0)) e--;
            if (pr == null) {
                sd = pr = Ctor.precision;
                rm = Ctor.rounding;
            } else if (dp) sd = pr + (x.e - y.e) + 1;
            else sd = pr;
            if (sd < 0) {
                qd.push(1);
                more = true;
            } else {
                // Convert precision in number of base 10 digits to base 1e7 digits.
                sd = sd / logBase + 2 | 0;
                i = 0;
                // divisor < 1e7
                if (yL == 1) {
                    k = 0;
                    yd = yd[0];
                    sd++;
                    // k is the carry.
                    for(; (i < xL || k) && sd--; i++){
                        t = k * base + (xd[i] || 0);
                        qd[i] = t / yd | 0;
                        k = t % yd | 0;
                    }
                    more = k || i < xL;
                // divisor >= 1e7
                } else {
                    // Normalise xd and yd so highest order digit of yd is >= base/2
                    k = base / (yd[0] + 1) | 0;
                    if (k > 1) {
                        yd = multiplyInteger(yd, k, base);
                        xd = multiplyInteger(xd, k, base);
                        yL = yd.length;
                        xL = xd.length;
                    }
                    xi = yL;
                    rem = xd.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL;)rem[remL++] = 0;
                    yz = yd.slice();
                    yz.unshift(0);
                    yd0 = yd[0];
                    if (yd[1] >= base / 2) ++yd0;
                    do {
                        k = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yd, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, k.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // k will be how many times the divisor goes into the current remainder.
                            k = rem0 / yd0 | 0;
                            //  Algorithm:
                            //  1. product = divisor * trial digit (k)
                            //  2. if product > remainder: product -= divisor, k--
                            //  3. remainder -= product
                            //  4. if product was < remainder at 2:
                            //    5. compare new remainder and divisor
                            //    6. If remainder > divisor: remainder -= divisor, k++
                            if (k > 1) {
                                if (k >= base) k = base - 1;
                                // product = divisor * trial digit.
                                prod = multiplyInteger(yd, k, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                cmp = compare(prod, rem, prodL, remL);
                                // product > remainder.
                                if (cmp == 1) {
                                    k--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yd, prodL, base);
                                }
                            } else {
                                // cmp is -1.
                                // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                                // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                                if (k == 0) cmp = k = 1;
                                prod = yd.slice();
                            }
                            prodL = prod.length;
                            if (prodL < remL) prod.unshift(0);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            // If product was < previous remainder.
                            if (cmp == -1) {
                                remL = rem.length;
                                // Compare divisor and new remainder.
                                cmp = compare(yd, rem, yL, remL);
                                // If divisor < new remainder, subtract divisor from remainder.
                                if (cmp < 1) {
                                    k++;
                                    // Subtract divisor from remainder.
                                    subtract(rem, yL < remL ? yz : yd, remL, base);
                                }
                            }
                            remL = rem.length;
                        } else if (cmp === 0) {
                            k++;
                            rem = [
                                0
                            ];
                        } // if cmp === 1, k will be 0
                        // Add the next digit, k, to the result array.
                        qd[i++] = k;
                        // Update the remainder.
                        if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                        else {
                            rem = [
                                xd[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] !== void 0) && sd--);
                    more = rem[0] !== void 0;
                }
                // Leading zero?
                if (!qd[0]) qd.shift();
            }
            // logBase is 1 when divide is being used for base conversion.
            if (logBase == 1) {
                q.e = e;
                inexact = more;
            } else {
                // To calculate q.e, first get the number of digits of qd[0].
                for(i = 1, k = qd[0]; k >= 10; k /= 10)i++;
                q.e = i + e * logBase - 1;
                finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
            }
            return q;
        };
    }();
    /*
   * Round `x` to `sd` significant digits using rounding mode `rm`.
   * Check for over/under-flow.
   */ function finalise(x, sd, rm, isTruncated) {
        var digits, i, j, k, rd, roundUp, w, xd, xdi, Ctor = x.constructor;
        // Don't round if sd is null or undefined.
        out: if (sd != null) {
            xd = x.d;
            // Infinity/NaN.
            if (!xd) return x;
            // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
            // w: the word of xd containing rd, a base 1e7 number.
            // xdi: the index of w within xd.
            // digits: the number of digits of w.
            // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
            // they had leading zeros)
            // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
            // Get the length of the first word of the digits array xd.
            for(digits = 1, k = xd[0]; k >= 10; k /= 10)digits++;
            i = sd - digits;
            // Is the rounding digit in the first word of xd?
            if (i < 0) {
                i += LOG_BASE;
                j = sd;
                w = xd[xdi = 0];
                // Get the rounding digit at index j of w.
                rd = w / mathpow(10, digits - j - 1) % 10 | 0;
            } else {
                xdi = Math.ceil((i + 1) / LOG_BASE);
                k = xd.length;
                if (xdi >= k) {
                    if (isTruncated) {
                        // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
                        for(; k++ <= xdi;)xd.push(0);
                        w = rd = 0;
                        digits = 1;
                        i %= LOG_BASE;
                        j = i - LOG_BASE + 1;
                    } else break out;
                } else {
                    w = k = xd[xdi];
                    // Get the number of digits of w.
                    for(digits = 1; k >= 10; k /= 10)digits++;
                    // Get the index of rd within w.
                    i %= LOG_BASE;
                    // Get the index of rd within w, adjusted for leading zeros.
                    // The number of leading zeros of w is given by LOG_BASE - digits.
                    j = i - LOG_BASE + digits;
                    // Get the rounding digit at index j of w.
                    rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
                }
            }
            // Are there any non-zero digits after the rounding digit?
            isTruncated = isTruncated || sd < 0 || xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));
            // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
            // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
            // will give 714.
            roundUp = rm < 4 ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
            if (sd < 1 || !xd[0]) {
                xd.length = 0;
                if (roundUp) {
                    // Convert sd to decimal places.
                    sd -= x.e + 1;
                    // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                    xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                    x.e = -sd || 0;
                } else // Zero.
                xd[0] = x.e = 0;
                return x;
            }
            // Remove excess digits.
            if (i == 0) {
                xd.length = xdi;
                k = 1;
                xdi--;
            } else {
                xd.length = xdi + 1;
                k = mathpow(10, LOG_BASE - i);
                // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                // j > 0 means i > number of leading zeros of w.
                xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
            }
            if (roundUp) {
                for(;;)// Is the digit to be rounded up in the first word of xd?
                if (xdi == 0) {
                    // i will be the length of xd[0] before k is added.
                    for(i = 1, j = xd[0]; j >= 10; j /= 10)i++;
                    j = xd[0] += k;
                    for(k = 1; j >= 10; j /= 10)k++;
                    // if i != k the length has increased.
                    if (i != k) {
                        x.e++;
                        if (xd[0] == BASE) xd[0] = 1;
                    }
                    break;
                } else {
                    xd[xdi] += k;
                    if (xd[xdi] != BASE) break;
                    xd[xdi--] = 0;
                    k = 1;
                }
            }
            // Remove trailing zeros.
            for(i = xd.length; xd[--i] === 0;)xd.pop();
        }
        if (external) {
            // Overflow?
            if (x.e > Ctor.maxE) {
                // Infinity.
                x.d = null;
                x.e = NaN;
            // Underflow?
            } else if (x.e < Ctor.minE) {
                // Zero.
                x.e = 0;
                x.d = [
                    0
                ];
            // Ctor.underflow = true;
            } // else Ctor.underflow = false;
        }
        return x;
    }
    function finiteToString(x, isExp, sd) {
        if (!x.isFinite()) return nonFiniteToString(x);
        var k, e = x.e, str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (x.e < 0 ? 'e' : 'e+') + x.e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return str;
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(digits, e) {
        var w = digits[0];
        // Add the number of digits of the first word of the digits array.
        for(e *= LOG_BASE; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > LN10_PRECISION) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(precisionLimitExceeded);
        }
        return finalise(new Ctor(LN10), sd, 1, true);
    }
    function getPi(Ctor, sd, rm) {
        if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
        return finalise(new Ctor(PI), sd, rm, true);
    }
    function getPrecision(digits) {
        var w = digits.length - 1, len = w * LOG_BASE + 1;
        w = digits[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)len--;
            // Add the number of digits of the first word.
            for(w = digits[0]; w >= 10; w /= 10)len++;
        }
        return len;
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
   * integer of type number.
   *
   * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
   *
   */ function intPow(Ctor, x, n, pr) {
        var isTruncated, r = new Ctor(1), // Max n of 9007199254740991 takes 53 loop iterations.
        // Maximum digits array length; leaves [28, 34] guard digits.
        k = Math.ceil(pr / LOG_BASE + 4);
        external = false;
        for(;;){
            if (n % 2) {
                r = r.times(x);
                if (truncate(r.d, k)) isTruncated = true;
            }
            n = mathfloor(n / 2);
            if (n === 0) {
                // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
                n = r.d.length - 1;
                if (isTruncated && r.d[n] === 0) ++r.d[n];
                break;
            }
            x = x.times(x);
            truncate(x.d, k);
        }
        external = true;
        return r;
    }
    function isOdd(n) {
        return n.d[n.d.length - 1] & 1;
    }
    /*
   * Handle `max` and `min`. `ltgt` is 'lt' or 'gt'.
   */ function maxOrMin(Ctor, args, ltgt) {
        var y, x = new Ctor(args[0]), i = 0;
        for(; ++i < args.length;){
            y = new Ctor(args[i]);
            if (!y.s) {
                x = y;
                break;
            } else if (x[ltgt](y)) x = y;
        }
        return x;
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
   * digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
   * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(Infinity)  = Infinity
   *  exp(-Infinity) = 0
   *  exp(NaN)       = NaN
   *  exp(±0)        = 1
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   *  The result will always be correctly rounded.
   *
   */ function naturalExponential(x, sd) {
        var denominator, guard, j, pow, sum, t, wpr, rep = 0, i = 0, k = 0, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // 0/NaN/Infinity?
        if (!x.d || !x.d[0] || x.e > 17) return new Ctor(x.d ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0 : x.s ? x.s < 0 ? 0 : x : 0 / 0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        // while abs(x) >= 0.1
        while(x.e > -2){
            // x = x / 2^5
            x = x.times(t);
            k += 5;
        }
        // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
        // necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(1);
        Ctor.precision = wpr;
        for(;;){
            pow = finalise(pow.times(x), wpr, 1);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                j = k;
                while(j--)sum = finalise(sum.times(sum), wpr, 1);
                // Check to see if the first 4 rounding digits are [49]999.
                // If so, repeat the summation with a higher precision, otherwise
                // e.g. with precision: 18, rounding: 1
                // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (rep < 3 && checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += 10;
                        denominator = pow = t = new Ctor(1);
                        i = 0;
                        rep++;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
        }
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
   * digits.
   *
   *  ln(-n)        = NaN
   *  ln(0)         = -Infinity
   *  ln(-0)        = -Infinity
   *  ln(1)         = 0
   *  ln(Infinity)  = Infinity
   *  ln(-Infinity) = NaN
   *  ln(NaN)       = NaN
   *
   *  ln(n) (n != 1) is non-terminating.
   *
   */ function naturalLogarithm(y, sd) {
        var c, c0, denominator, e, numerator, rep, sum, t, wpr, x1, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // Is x negative or Infinity, NaN, 0 or 1?
        if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        Ctor.precision = wpr += guard;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        if (Math.abs(e = x.e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = x.e;
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = naturalLogarithm(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? finalise(x, pr, rm, external = true) : x;
        }
        // x1 is x reduced to a value near 1.
        x1 = x;
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
        x2 = finalise(x.times(x), wpr, 1);
        denominator = 3;
        for(;;){
            numerator = finalise(numerator.times(x2), wpr, 1);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
                // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr, 1);
                // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
                // been repeated previously) and the first 4 rounding digits 9999?
                // If so, restart the summation with a higher precision, otherwise
                // e.g. with precision: 12, rounding: 1
                // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += guard;
                        t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
                        x2 = finalise(x.times(x), wpr, 1);
                        denominator = rep = 1;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
            denominator += 2;
        }
    }
    // ±Infinity, NaN.
    function nonFiniteToString(x) {
        // Unsigned.
        return String(x.s * x.s / 0);
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48; --len);
        str = str.slice(i, len);
        if (str) {
            len -= i;
            x.e = e = e - i - 1;
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external) {
                // Overflow?
                if (x.e > x.constructor.maxE) {
                    // Infinity.
                    x.d = null;
                    x.e = NaN;
                // Underflow?
                } else if (x.e < x.constructor.minE) {
                    // Zero.
                    x.e = 0;
                    x.d = [
                        0
                    ];
                // x.constructor.underflow = true;
                } // else x.constructor.underflow = false;
            }
        } else {
            // Zero.
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
   */ function parseOther(x, str) {
        var base, Ctor, divisor, i, isFloat, len, p, xd, xe;
        if (str.indexOf('_') > -1) {
            str = str.replace(/(\d)_(?=\d)/g, '$1');
            if (isDecimal.test(str)) return parseDecimal(x, str);
        } else if (str === 'Infinity' || str === 'NaN') {
            if (!+str) x.s = NaN;
            x.e = NaN;
            x.d = null;
            return x;
        }
        if (isHex.test(str)) {
            base = 16;
            str = str.toLowerCase();
        } else if (isBinary.test(str)) base = 2;
        else if (isOctal.test(str)) base = 8;
        else throw Error(invalidArgument + str);
        // Is there a binary exponent part?
        i = str.search(/p/i);
        if (i > 0) {
            p = +str.slice(i + 1);
            str = str.substring(2, i);
        } else str = str.slice(2);
        // Convert `str` as an integer then divide the result by `base` raised to a power such that the
        // fraction part will be restored.
        i = str.indexOf('.');
        isFloat = i >= 0;
        Ctor = x.constructor;
        if (isFloat) {
            str = str.replace('.', '');
            len = str.length;
            i = len - i;
            // log[10](16) = 1.2041... , log[10](88) = 1.9444....
            divisor = intPow(Ctor, new Ctor(base), i, i * 2);
        }
        xd = convertBase(str, base, BASE);
        xe = xd.length - 1;
        // Remove trailing zeros.
        for(i = xe; xd[i] === 0; --i)xd.pop();
        if (i < 0) return new Ctor(x.s * 0);
        x.e = getBase10Exponent(xd, xe);
        x.d = xd;
        external = false;
        // At what precision to perform the division to ensure exact conversion?
        // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
        // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
        // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
        // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
        // Therefore using 4 * the number of digits of str will always be enough.
        if (isFloat) x = divide(x, divisor, len * 4);
        // Multiply by the binary exponent part if present.
        if (p) x = x.times(Math.abs(p) < 54 ? mathpow(2, p) : Decimal.pow(2, p));
        external = true;
        return x;
    }
    /*
   * sin(x) = x - x^3/3! + x^5/5! - ...
   * |x| < pi/2
   *
   */ function sine(Ctor, x) {
        var k, len = x.d.length;
        if (len < 3) return x.isZero() ? x : taylorSeries(Ctor, 2, x, x);
        // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
        // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
        // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))
        // Estimate the optimum number of times to use the argument reduction.
        k = 1.4 * Math.sqrt(len);
        k = k > 16 ? 16 : k | 0;
        x = x.times(1 / tinyPow(5, k));
        x = taylorSeries(Ctor, 2, x, x);
        // Reverse argument reduction
        var sin2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
        for(; k--;){
            sin2_x = x.times(x);
            x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
        }
        return x;
    }
    // Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
    function taylorSeries(Ctor, n, x, y, isHyperbolic) {
        var j, t, u, x2, i = 1, pr = Ctor.precision, k = Math.ceil(pr / LOG_BASE);
        external = false;
        x2 = x.times(x);
        u = new Ctor(y);
        for(;;){
            t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
            u = isHyperbolic ? y.plus(t) : y.minus(t);
            y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
            t = u.plus(y);
            if (t.d[k] !== void 0) {
                for(j = k; t.d[j] === u.d[j] && j--;);
                if (j == -1) break;
            }
            j = u;
            u = y;
            y = t;
            t = j;
            i++;
        }
        external = true;
        t.d.length = k + 1;
        return t;
    }
    // Exponent e must be positive and non-zero.
    function tinyPow(b, e) {
        var n = b;
        while(--e)n *= b;
        return n;
    }
    // Return the absolute value of `x` reduced to less than or equal to half pi.
    function toLessThanHalfPi(Ctor, x) {
        var t, isNeg = x.s < 0, pi = getPi(Ctor, Ctor.precision, 1), halfPi = pi.times(0.5);
        x = x.abs();
        if (x.lte(halfPi)) {
            quadrant = isNeg ? 4 : 1;
            return x;
        }
        t = x.divToInt(pi);
        if (t.isZero()) quadrant = isNeg ? 3 : 2;
        else {
            x = x.minus(t.times(pi));
            // 0 <= x < pi
            if (x.lte(halfPi)) {
                quadrant = isOdd(t) ? isNeg ? 2 : 3 : isNeg ? 4 : 1;
                return x;
            }
            quadrant = isOdd(t) ? isNeg ? 1 : 4 : isNeg ? 3 : 2;
        }
        return x.minus(pi).abs();
    }
    /*
   * Return the value of Decimal `x` as a string in base `baseOut`.
   *
   * If the optional `sd` argument is present include a binary exponent suffix.
   */ function toStringBinary(x, baseOut, sd, rm) {
        var base, e, i, k, len, roundUp, str, xd, y, Ctor = x.constructor, isExp = sd !== void 0;
        if (isExp) {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        } else {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        }
        if (!x.isFinite()) str = nonFiniteToString(x);
        else {
            str = finiteToString(x);
            i = str.indexOf('.');
            // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
            // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
            // minBinaryExponent = floor(decimalExponent * log[2](10))
            // log[2](10) = 3.321928094887362347870319429489390175864
            if (isExp) {
                base = 2;
                if (baseOut == 16) sd = sd * 4 - 3;
                else if (baseOut == 8) sd = sd * 3 - 2;
            } else base = baseOut;
            // Convert the number as an integer then divide the result by its base raised to a power such
            // that the fraction part will be restored.
            // Non-integer.
            if (i >= 0) {
                str = str.replace('.', '');
                y = new Ctor(1);
                y.e = str.length - i;
                y.d = convertBase(finiteToString(y), 10, base);
                y.e = y.d.length;
            }
            xd = convertBase(str, 10, base);
            e = len = xd.length;
            // Remove trailing zeros.
            for(; xd[--len] == 0;)xd.pop();
            if (!xd[0]) str = isExp ? '0p+0' : '0';
            else {
                if (i < 0) e--;
                else {
                    x = new Ctor(x);
                    x.d = xd;
                    x.e = e;
                    x = divide(x, y, sd, rm, 0, base);
                    xd = x.d;
                    e = x.e;
                    roundUp = inexact;
                }
                // The rounding digit, i.e. the digit after the digit that may be rounded up.
                i = xd[sd];
                k = base / 2;
                roundUp = roundUp || xd[sd + 1] !== void 0;
                roundUp = rm < 4 ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2)) : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 || rm === (x.s < 0 ? 8 : 7));
                xd.length = sd;
                if (roundUp) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(; ++xd[--sd] > base - 1;){
                    xd[sd] = 0;
                    if (!sd) {
                        ++e;
                        xd.unshift(1);
                    }
                }
                // Determine trailing zeros.
                for(len = xd.length; !xd[len - 1]; --len);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ''; i < len; i++)str += NUMERALS.charAt(xd[i]);
                // Add binary exponent suffix?
                if (isExp) {
                    if (len > 1) {
                        if (baseOut == 16 || baseOut == 8) {
                            i = baseOut == 16 ? 4 : 3;
                            for(--len; len % i; len++)str += '0';
                            xd = convertBase(str, base, baseOut);
                            for(len = xd.length; !xd[len - 1]; --len);
                            // xd[0] will always be be 1
                            for(i = 1, str = '1.'; i < len; i++)str += NUMERALS.charAt(xd[i]);
                        } else str = str.charAt(0) + '.' + str.slice(1);
                    }
                    str = str + (e < 0 ? 'p' : 'p+') + e;
                } else if (e < 0) {
                    for(; ++e;)str = '0' + str;
                    str = '0.' + str;
                } else {
                    if (++e > len) for(e -= len; e--;)str += '0';
                    else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
                }
            }
            str = (baseOut == 16 ? '0x' : baseOut == 2 ? '0b' : baseOut == 8 ? '0o' : '') + str;
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  abs
   *  acos
   *  acosh
   *  add
   *  asin
   *  asinh
   *  atan
   *  atanh
   *  atan2
   *  cbrt
   *  ceil
   *  clamp
   *  clone
   *  config
   *  cos
   *  cosh
   *  div
   *  exp
   *  floor
   *  hypot
   *  ln
   *  log
   *  log2
   *  log10
   *  max
   *  min
   *  mod
   *  mul
   *  pow
   *  random
   *  round
   *  set
   *  sign
   *  sin
   *  sinh
   *  sqrt
   *  sub
   *  sum
   *  tan
   *  tanh
   *  trunc
   */ /*
   * Return a new Decimal whose value is the absolute value of `x`.
   *
   * x {number|string|Decimal}
   *
   */ function abs(x) {
        return new this(x).abs();
    }
    /*
   * Return a new Decimal whose value is the arccosine in radians of `x`.
   *
   * x {number|string|Decimal}
   *
   */ function acos(x) {
        return new this(x).acos();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function acosh(x) {
        return new this(x).acosh();
    }
    /*
   * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function add(x, y) {
        return new this(x).plus(y);
    }
    /*
   * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function asin(x) {
        return new this(x).asin();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function asinh(x) {
        return new this(x).asinh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function atan(x) {
        return new this(x).atan();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function atanh(x) {
        return new this(x).atanh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
   * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi, pi]
   *
   * y {number|string|Decimal} The y-coordinate.
   * x {number|string|Decimal} The x-coordinate.
   *
   * atan2(±0, -0)               = ±pi
   * atan2(±0, +0)               = ±0
   * atan2(±0, -x)               = ±pi for x > 0
   * atan2(±0, x)                = ±0 for x > 0
   * atan2(-y, ±0)               = -pi/2 for y > 0
   * atan2(y, ±0)                = pi/2 for y > 0
   * atan2(±y, -Infinity)        = ±pi for finite y > 0
   * atan2(±y, +Infinity)        = ±0 for finite y > 0
   * atan2(±Infinity, x)         = ±pi/2 for finite x
   * atan2(±Infinity, -Infinity) = ±3*pi/4
   * atan2(±Infinity, +Infinity) = ±pi/4
   * atan2(NaN, x) = NaN
   * atan2(y, NaN) = NaN
   *
   */ function atan2(y, x) {
        y = new this(y);
        x = new this(x);
        var r, pr = this.precision, rm = this.rounding, wpr = pr + 4;
        // Either NaN
        if (!y.s || !x.s) r = new this(NaN);
        else if (!y.d && !x.d) {
            r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
            r.s = y.s;
        // x is ±Infinity or y is ±0
        } else if (!x.d || y.isZero()) {
            r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
            r.s = y.s;
        // y is ±Infinity or x is ±0
        } else if (!y.d || x.isZero()) {
            r = getPi(this, wpr, 1).times(0.5);
            r.s = y.s;
        // Both non-zero and finite
        } else if (x.s < 0) {
            this.precision = wpr;
            this.rounding = 1;
            r = this.atan(divide(y, x, wpr, 1));
            x = getPi(this, wpr, 1);
            this.precision = pr;
            this.rounding = rm;
            r = y.s < 0 ? r.minus(x) : r.plus(x);
        } else r = this.atan(divide(y, x, wpr, 1));
        return r;
    }
    /*
   * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function cbrt(x) {
        return new this(x).cbrt();
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
   *
   * x {number|string|Decimal}
   *
   */ function ceil(x) {
        return finalise(x = new this(x), x.e + 1, 2);
    }
    /*
   * Return a new Decimal whose value is `x` clamped to the range delineated by `min` and `max`.
   *
   * x {number|string|Decimal}
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */ function clamp(x, min, max) {
        return new this(x).clamp(min, max);
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *   maxE       {number}
   *   minE       {number}
   *   modulo     {number}
   *   crypto     {boolean|number}
   *   defaults   {true}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, useDefaults = obj.defaults === true, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -EXP_LIMIT,
            0,
            'toExpPos',
            0,
            EXP_LIMIT,
            'maxE',
            0,
            EXP_LIMIT,
            'minE',
            -EXP_LIMIT,
            0,
            'modulo',
            0,
            9
        ];
        for(i = 0; i < ps.length; i += 3){
            if (p = ps[i], useDefaults) this[p] = DEFAULTS[p];
            if ((v = obj[p]) !== void 0) {
                if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
                else throw Error(invalidArgument + p + ': ' + v);
            }
        }
        if (p = 'crypto', useDefaults) this[p] = DEFAULTS[p];
        if ((v = obj[p]) !== void 0) {
            if (v === true || v === false || v === 0 || v === 1) {
                if (v) {
                    if (typeof crypto != 'undefined' && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[p] = true;
                    else throw Error(cryptoUnavailable);
                } else this[p] = false;
            } else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    /*
   * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function cos(x) {
        return new this(x).cos();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function cosh(x) {
        return new this(x).cosh();
    }
    /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * v {number|string|Decimal} A numeric value.
     *
     */ function Decimal(v) {
            var e, i, t, x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(v);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (isDecimalInstance(v)) {
                x.s = v.s;
                if (external) {
                    if (!v.d || v.e > Decimal.maxE) {
                        // Infinity.
                        x.e = NaN;
                        x.d = null;
                    } else if (v.e < Decimal.minE) {
                        // Zero.
                        x.e = 0;
                        x.d = [
                            0
                        ];
                    } else {
                        x.e = v.e;
                        x.d = v.d.slice();
                    }
                } else {
                    x.e = v.e;
                    x.d = v.d ? v.d.slice() : v.d;
                }
                return;
            }
            t = typeof v;
            if (t === 'number') {
                if (v === 0) {
                    x.s = 1 / v < 0 ? -1 : 1;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                if (v < 0) {
                    v = -v;
                    x.s = -1;
                } else x.s = 1;
                // Fast path for small integers.
                if (v === ~~v && v < 1e7) {
                    for(e = 0, i = v; i >= 10; i /= 10)e++;
                    if (external) {
                        if (e > Decimal.maxE) {
                            x.e = NaN;
                            x.d = null;
                        } else if (e < Decimal.minE) {
                            x.e = 0;
                            x.d = [
                                0
                            ];
                        } else {
                            x.e = e;
                            x.d = [
                                v
                            ];
                        }
                    } else {
                        x.e = e;
                        x.d = [
                            v
                        ];
                    }
                    return;
                // Infinity, NaN.
                } else if (v * 0 !== 0) {
                    if (!v) x.s = NaN;
                    x.e = NaN;
                    x.d = null;
                    return;
                }
                return parseDecimal(x, v.toString());
            } else if (t !== 'string') throw Error(invalidArgument + v);
            // Minus sign?
            if ((i = v.charCodeAt(0)) === 45) {
                v = v.slice(1);
                x.s = -1;
            } else {
                // Plus sign?
                if (i === 43) v = v.slice(1);
                x.s = 1;
            }
            return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.EUCLID = 9;
        Decimal.config = Decimal.set = config;
        Decimal.clone = clone;
        Decimal.isDecimal = isDecimalInstance;
        Decimal.abs = abs;
        Decimal.acos = acos;
        Decimal.acosh = acosh; // ES6
        Decimal.add = add;
        Decimal.asin = asin;
        Decimal.asinh = asinh; // ES6
        Decimal.atan = atan;
        Decimal.atanh = atanh; // ES6
        Decimal.atan2 = atan2;
        Decimal.cbrt = cbrt; // ES6
        Decimal.ceil = ceil;
        Decimal.clamp = clamp;
        Decimal.cos = cos;
        Decimal.cosh = cosh; // ES6
        Decimal.div = div;
        Decimal.exp = exp;
        Decimal.floor = floor;
        Decimal.hypot = hypot; // ES6
        Decimal.ln = ln;
        Decimal.log = log;
        Decimal.log10 = log10; // ES6
        Decimal.log2 = log2; // ES6
        Decimal.max = max;
        Decimal.min = min;
        Decimal.mod = mod;
        Decimal.mul = mul;
        Decimal.pow = pow;
        Decimal.random = random;
        Decimal.round = round;
        Decimal.sign = sign; // ES6
        Decimal.sin = sin;
        Decimal.sinh = sinh; // ES6
        Decimal.sqrt = sqrt;
        Decimal.sub = sub;
        Decimal.sum = sum;
        Decimal.tan = tan;
        Decimal.tanh = tanh; // ES6
        Decimal.trunc = trunc; // ES6
        if (obj === void 0) obj = {};
        if (obj) {
            if (obj.defaults !== true) {
                ps = [
                    'precision',
                    'rounding',
                    'toExpNeg',
                    'toExpPos',
                    'maxE',
                    'minE',
                    'modulo',
                    'crypto'
                ];
                for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
            }
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function div(x, y) {
        return new this(x).div(y);
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The power to which to raise the base of the natural log.
   *
   */ function exp(x) {
        return new this(x).exp();
    }
    /*
   * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
   *
   * x {number|string|Decimal}
   *
   */ function floor(x) {
        return finalise(x = new this(x), x.e + 1, 3);
    }
    /*
   * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
   *
   * arguments {number|string|Decimal}
   *
   */ function hypot() {
        var i, n, t = new this(0);
        external = false;
        for(i = 0; i < arguments.length;){
            n = new this(arguments[i++]);
            if (!n.d) {
                if (n.s) {
                    external = true;
                    return new this(1 / 0);
                }
                t = n;
            } else if (t.d) t = t.plus(n.times(n));
        }
        external = true;
        return t.sqrt();
    }
    /*
   * Return true if object is a Decimal instance (where Decimal is any Decimal constructor),
   * otherwise return false.
   *
   */ function isDecimalInstance(obj) {
        return obj instanceof Decimal || obj && obj.toStringTag === tag || false;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function ln(x) {
        return new this(x).ln();
    }
    /*
   * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
   * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * log[y](x)
   *
   * x {number|string|Decimal} The argument of the logarithm.
   * y {number|string|Decimal} The base of the logarithm.
   *
   */ function log(x, y) {
        return new this(x).log(y);
    }
    /*
   * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function log2(x) {
        return new this(x).log(2);
    }
    /*
   * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function log10(x) {
        return new this(x).log(10);
    }
    /*
   * Return a new Decimal whose value is the maximum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */ function max() {
        return maxOrMin(this, arguments, 'lt');
    }
    /*
   * Return a new Decimal whose value is the minimum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */ function min() {
        return maxOrMin(this, arguments, 'gt');
    }
    /*
   * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function mod(x, y) {
        return new this(x).mod(y);
    }
    /*
   * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function mul(x, y) {
        return new this(x).mul(y);
    }
    /*
   * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The base.
   * y {number|string|Decimal} The exponent.
   *
   */ function pow(x, y) {
        return new this(x).pow(y);
    }
    /*
   * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
   * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
   * are produced).
   *
   * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
   *
   */ function random(sd) {
        var d, e, k, n, i = 0, r = new this(1), rd = [];
        if (sd === void 0) sd = this.precision;
        else checkInt32(sd, 1, MAX_DIGITS);
        k = Math.ceil(sd / LOG_BASE);
        if (!this.crypto) for(; i < k;)rd[i++] = Math.random() * 1e7 | 0;
        else if (crypto.getRandomValues) {
            d = crypto.getRandomValues(new Uint32Array(k));
            for(; i < k;){
                n = d[i];
                // 0 <= n < 4294967296
                // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
                if (n >= 4.29e9) d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
                else // 0 <= n <= 4289999999
                // 0 <= (n % 1e7) <= 9999999
                rd[i++] = n % 1e7;
            }
        // Node.js supporting crypto.randomBytes.
        } else if (crypto.randomBytes) {
            // buffer
            d = crypto.randomBytes(k *= 4);
            for(; i < k;){
                // 0 <= n < 2147483648
                n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 0x7f) << 24);
                // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
                if (n >= 2.14e9) crypto.randomBytes(4).copy(d, i);
                else {
                    // 0 <= n <= 2139999999
                    // 0 <= (n % 1e7) <= 9999999
                    rd.push(n % 1e7);
                    i += 4;
                }
            }
            i = k / 4;
        } else throw Error(cryptoUnavailable);
        k = rd[--i];
        sd %= LOG_BASE;
        // Convert trailing digits to zeros according to sd.
        if (k && sd) {
            n = mathpow(10, LOG_BASE - sd);
            rd[i] = (k / n | 0) * n;
        }
        // Remove trailing words which are zero.
        for(; rd[i] === 0; i--)rd.pop();
        // Zero?
        if (i < 0) {
            e = 0;
            rd = [
                0
            ];
        } else {
            e = -1;
            // Remove leading words which are zero and adjust exponent accordingly.
            for(; rd[0] === 0; e -= LOG_BASE)rd.shift();
            // Count the digits of the first word of rd to determine leading zeros.
            for(k = 1, n = rd[0]; n >= 10; n /= 10)k++;
            // Adjust the exponent for leading zeros of the first word of rd.
            if (k < LOG_BASE) e -= LOG_BASE - k;
        }
        r.e = e;
        r.d = rd;
        return r;
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
   *
   * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
   *
   * x {number|string|Decimal}
   *
   */ function round(x) {
        return finalise(x = new this(x), x.e + 1, this.rounding);
    }
    /*
   * Return
   *   1    if x > 0,
   *  -1    if x < 0,
   *   0    if x is 0,
   *  -0    if x is -0,
   *   NaN  otherwise
   *
   * x {number|string|Decimal}
   *
   */ function sign(x) {
        x = new this(x);
        return x.d ? x.d[0] ? x.s : 0 * x.s : x.s || NaN;
    }
    /*
   * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function sin(x) {
        return new this(x).sin();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function sinh(x) {
        return new this(x).sinh();
    }
    /*
   * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function sqrt(x) {
        return new this(x).sqrt();
    }
    /*
   * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function sub(x, y) {
        return new this(x).sub(y);
    }
    /*
   * Return a new Decimal whose value is the sum of the arguments, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * Only the result is rounded, not the intermediate calculations.
   *
   * arguments {number|string|Decimal}
   *
   */ function sum() {
        var i = 0, args = arguments, x = new this(args[i]);
        external = false;
        for(; x.s && ++i < args.length;)x = x.plus(args[i]);
        external = true;
        return finalise(x, this.precision, this.rounding);
    }
    /*
   * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function tan(x) {
        return new this(x).tan();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function tanh(x) {
        return new this(x).tanh();
    }
    /*
   * Return a new Decimal whose value is `x` truncated to an integer.
   *
   * x {number|string|Decimal}
   *
   */ function trunc(x) {
        return finalise(x = new this(x), x.e + 1, 1);
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(DEFAULTS);
    Decimal.prototype.constructor = Decimal;
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Create the internal constants from their string values.
    LN10 = new Decimal(LN10);
    PI = new Decimal(PI);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if ($b73b0d42318075d9$exports) {
        if (typeof Symbol == 'function' && typeof Symbol.iterator == 'symbol') {
            P[Symbol['for']('nodejs.util.inspect.custom')] = P.toString;
            P[Symbol.toStringTag] = 'Decimal';
        }
        $b73b0d42318075d9$exports = Decimal;
    // Browser.
    } else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : window;
        noConflict = globalScope.Decimal;
        Decimal.noConflict = function() {
            globalScope.Decimal = noConflict;
            return Decimal;
        };
        globalScope.Decimal = Decimal;
    }
})($b73b0d42318075d9$exports);



var $dDyyD = parcelRequire("dDyyD");

var $6uYXW = parcelRequire("6uYXW");



async function $965bc6274f24eb13$export$657a70ea8fcce9da() {
    const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get('/care_quest_groups', {
        params: {
            filter: JSON.stringify({
                where: {
                    name: {
                        inq: [
                            'Monthly Income Form',
                            'Monthly Expense Form'
                        ]
                    }
                },
                include: [
                    {
                        relation: 'care_quest_group_questions',
                        scope: {
                            order: [
                                'question_order'
                            ]
                        }
                    }
                ],
                order: 'name DESC'
            })
        }
    });
    return data;
}
async function $965bc6274f24eb13$export$5234c0e940bc4db6(groupIds, clientId) {
    const responses = [];
    const { data: incomeData } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get(`/clients/${clientId}/care_quest_response_groups`, {
        params: {
            filter: JSON.stringify({
                where: {
                    care_quest_groupId: groupIds[0]
                },
                include: 'care_quest_responses',
                limit: 1,
                order: 'response_dttm DESC'
            })
        }
    });
    if (Array.isArray(incomeData) && incomeData.length > 0) responses.push(incomeData[0]);
    const { data: expenseData } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get(`/clients/${clientId}/care_quest_response_groups`, {
        params: {
            filter: JSON.stringify({
                where: {
                    care_quest_groupId: groupIds[1]
                },
                include: 'care_quest_responses',
                limit: 1,
                order: 'response_dttm DESC'
            })
        }
    });
    if (Array.isArray(expenseData) && expenseData.length > 0) responses.push(expenseData[0]);
    return responses;
}
async function $965bc6274f24eb13$export$54a0062a02ac1df7({ userId: userId, care_quest_groupId: care_quest_groupId, questions: questions, answers: answers }) {
    const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).post(`/clients/${userId}/care_quest_response_groups`, {
        care_quest_groupId: care_quest_groupId,
        response_dttm: new Date(),
        completed_by_type: 'client',
        completed_by_id: userId
    });
    await Promise.all(questions.map((question, index)=>(0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).post(`/clients/${userId}/care_quest_responses`, {
            clientId: userId,
            care_quest_response_groupId: data.id,
            care_quest_questionId: question.id,
            care_quest_groupId: care_quest_groupId,
            response_dttm: new Date(),
            care_quest_answer_text: Array.isArray(answers) && answers[index] ? answers[index] : question.default_answer
        })));
}


const $623103cc7c0551f9$var$PersonalFinances = ()=>{
    const { showSuccess: showSuccess, showError: showError } = (0, $8460a3ee79a43e41$export$aa94277a9804d2bd)();
    const { user: user } = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e)();
    const queryClient = (0, $8136cc1e66cf8798$export$22e77b9572c4fded)();
    const [incomes, setIncomes] = (0, $6uYXW.useState)([]);
    const [expenses, setExpenses] = (0, $6uYXW.useState)([]);
    const [lastIncomeEnteredAt, setLastIncomeEnteredAt] = (0, $6uYXW.useState)(null);
    const [lastExpenseEnteredAt, setLastExpenseEnteredAt] = (0, $6uYXW.useState)(null);
    const { data: groups, isPending: isGroupsPending } = (0, $b505c391aa3d7eba$export$dd0a697e1782aedd)({
        queryKey: [
            'personalFinanceGroups'
        ],
        queryFn: (0, $965bc6274f24eb13$export$657a70ea8fcce9da)
    });
    const groupIds = groups?.map(({ id: id })=>id);
    const { data: previousResponses, isPending: isPreviousResponsesPending } = (0, $b505c391aa3d7eba$export$dd0a697e1782aedd)({
        queryKey: [
            'previousResponses',
            groupIds,
            user
        ],
        queryFn: ()=>(0, $965bc6274f24eb13$export$5234c0e940bc4db6)(groupIds, user.id),
        enabled: Array.isArray(groups)
    });
    const assessmentMutation = (0, $09aa25a5777508fa$export$609860bf8b0084c)({
        mutationFn: (0, $965bc6274f24eb13$export$54a0062a02ac1df7),
        onSuccess: ()=>{
            showSuccess('Financial data saved');
            queryClient.invalidateQueries({
                queryKey: [
                    'previousResponses'
                ]
            });
        },
        onError: ()=>{
            showError('There was a problem saving your financial data. Please try again.');
        }
    });
    (0, $6uYXW.useEffect)(()=>{
        if (Array.isArray(groups) && groups.length > 0) {
            setIncomes(groups[0].care_quest_group_questions.map(({ default_answer: default_answer })=>default_answer));
            setExpenses(groups[1].care_quest_group_questions.map(({ default_answer: default_answer })=>default_answer));
        }
    }, [
        groups
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (Array.isArray(previousResponses) && previousResponses.length > 0) {
            // incomes
            const incomeResponse = previousResponses.find(({ care_quest_groupId: care_quest_groupId })=>care_quest_groupId === groupIds[0]);
            if (incomeResponse && Array.isArray(incomeResponse.care_quest_responses) && incomeResponse.care_quest_responses.length > 0) {
                const questionIds = groups[0].care_quest_group_questions.map(({ id: id })=>id);
                const previousIncomes = [];
                questionIds.forEach((questionId)=>{
                    previousIncomes.push(incomeResponse.care_quest_responses.find(({ care_quest_questionId: care_quest_questionId })=>care_quest_questionId === questionId));
                });
                setIncomes(previousIncomes.map(({ care_quest_answer_text: care_quest_answer_text })=>care_quest_answer_text));
                setLastIncomeEnteredAt(incomeResponse.response_dttm);
            }
            // expenses
            const expenseResponse = previousResponses.find(({ care_quest_groupId: care_quest_groupId })=>care_quest_groupId === groupIds[1]);
            if (expenseResponse && Array.isArray(expenseResponse.care_quest_responses) && expenseResponse.care_quest_responses.length > 0) {
                const questionIds = groups[1].care_quest_group_questions.map(({ id: id })=>id);
                const previousExpenses = [];
                questionIds.forEach((questionId)=>{
                    previousExpenses.push(expenseResponse.care_quest_responses.find(({ care_quest_questionId: care_quest_questionId })=>care_quest_questionId === questionId));
                });
                setExpenses(previousExpenses.map(({ care_quest_answer_text: care_quest_answer_text })=>care_quest_answer_text));
                setLastExpenseEnteredAt(expenseResponse.response_dttm);
            }
        }
    }, [
        previousResponses
    ]);
    const handleIncomeEntry = (value, index)=>{
        const newIncomes = Array.from(incomes);
        newIncomes[index] = value;
        setIncomes(newIncomes);
    };
    const handleExpenseEntry = (value, index)=>{
        const newExpenses = Array.from(expenses);
        newExpenses[index] = value;
        setExpenses(newExpenses);
    };
    const totalIncome = incomes.reduce((partialSum, a, currIndex)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($dDyyD)))(a) && currIndex < incomes.length - 1) try {
            return (0, (/*@__PURE__*/$parcel$interopDefault($b73b0d42318075d9$exports))).add(a, partialSum);
        } catch (err) {
        // console.log(err);
        }
        return partialSum;
    }, 0);
    const totalExpense = expenses.reduce((partialSum, a, currIndex)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($dDyyD)))(a) && currIndex < expenses.length - 1) try {
            return (0, (/*@__PURE__*/$parcel$interopDefault($b73b0d42318075d9$exports))).add(a, partialSum);
        } catch (err) {
        // console.log(err);
        }
        return partialSum;
    }, 0);
    const handleSaveFinancialAssessment = ({ target: target })=>{
        const isIncomeForm = target.value == groupIds[0];
        const care_quest_groupId = target.value;
        const questions = groups.find(({ id: id })=>id == care_quest_groupId).care_quest_group_questions;
        const answers = Array.from(isIncomeForm ? incomes : expenses);
        answers.splice(answers.length - 1, 1, isIncomeForm ? totalIncome : totalExpense);
        assessmentMutation.mutate({
            userId: user.id,
            care_quest_groupId: care_quest_groupId,
            questions: questions,
            answers: answers
        });
    };
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
        className: "personal-finances",
        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
            className: "page-wide",
            children: [
                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h1", {
                    children: "Personal Finances"
                }),
                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                    className: "card card-bordered",
                    children: [
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "card-title",
                            children: [
                                "Income",
                                ' ',
                                lastIncomeEnteredAt && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("em", {
                                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("small", {
                                        className: "font-normal text-gray-400 align-text-top",
                                        children: [
                                            "Last updated on",
                                            ' ',
                                            (0, $ebd4f34ba903fc95$export$d9468344d3651243)(new Date(lastIncomeEnteredAt), 'PPPp')
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                            className: "card-body",
                            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                children: groups && groups[0].care_quest_group_questions.filter(({ question_type: question_type })=>question_type === 'Numeric').map((question, index)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                        className: "relative sm:col-span-2",
                                        children: [
                                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                                htmlFor: `income-${question.id}`,
                                                children: question.question_text
                                            }),
                                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                                                    children: "$"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                                type: "number",
                                                min: 0.0,
                                                step: 0.01,
                                                inputMode: "decimal",
                                                id: `income-${question.id}`,
                                                name: question.id,
                                                placeholder: question.default_answer,
                                                value: incomes[index],
                                                onChange: ({ target: target })=>handleIncomeEntry(target.value, index)
                                            })
                                        ]
                                    }, `question-${question.id}`))
                            })
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "flex flex-row card-action",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "basis-3/4",
                                    children: [
                                        "Total: $",
                                        totalIncome.toString(),
                                        " per month"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                    className: "basis-1/4",
                                    children: Array.isArray(groups) && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                                        className: "text-white btn btn-primary btn-block",
                                        name: "care_quest_groupId",
                                        value: groupIds[0],
                                        disabled: isGroupsPending || isPreviousResponsesPending || assessmentMutation.isPending,
                                        onClick: handleSaveFinancialAssessment,
                                        children: "Save Income"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                    className: "card card-bordered",
                    children: [
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "card-title",
                            children: [
                                "Expenses",
                                ' ',
                                lastExpenseEnteredAt && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("em", {
                                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("small", {
                                        className: "font-normal text-gray-400 align-text-top",
                                        children: [
                                            "Last updated on",
                                            ' ',
                                            (0, $ebd4f34ba903fc95$export$d9468344d3651243)(new Date(lastExpenseEnteredAt), 'PPPp')
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                            className: "card-body",
                            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                children: groups && groups[1].care_quest_group_questions.filter(({ question_type: question_type })=>question_type === 'Numeric').map((question, index)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                        className: "relative sm:col-span-2",
                                        children: [
                                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                                htmlFor: `expense-${question.id}`,
                                                children: question.question_text
                                            }),
                                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                                                    children: "$"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                                type: "number",
                                                min: 0.0,
                                                step: 0.01,
                                                inputMode: "decimal",
                                                id: `expense-${question.id}`,
                                                placeholder: question.default_answer,
                                                onChange: ({ target: target })=>handleExpenseEntry(target.value, index),
                                                name: question.id,
                                                value: expenses[index]
                                            })
                                        ]
                                    }, `question-${question.id}`))
                            })
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "flex flex-row card-action",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "basis-3/4",
                                    children: [
                                        "Total: $",
                                        totalExpense.toString(),
                                        " per month"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                    className: "basis-1/4",
                                    children: Array.isArray(groups) && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                                        className: "text-white btn btn-primary btn-block",
                                        name: "care_quest_groupId",
                                        value: groupIds[1],
                                        disabled: isGroupsPending || // isQuestionsPending ||
                                        isPreviousResponsesPending || assessmentMutation.isPending,
                                        onClick: handleSaveFinancialAssessment,
                                        children: "Save Expenses"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $623103cc7c0551f9$export$2e2bcd8739ae039 = $623103cc7c0551f9$var$PersonalFinances;


var $10350528c354a883$export$2e2bcd8739ae039 = (0, $623103cc7c0551f9$export$2e2bcd8739ae039);










var $6uYXW = parcelRequire("6uYXW");


const $5bc9d35b44390826$var$PersonalInfo = ({ user: user })=>{
    const { updateUser: updateUser } = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e)();
    const { showSuccess: showSuccess, showError: showError } = (0, $8460a3ee79a43e41$export$aa94277a9804d2bd)();
    const [isSaving, setIsSaving] = (0, $6uYXW.useState)(false);
    const [nameFirst, setNameFirst] = (0, $6uYXW.useState)(user.name_first);
    const [nameLast, setNameLast] = (0, $6uYXW.useState)(user.name_last);
    const [address, setAddress] = (0, $6uYXW.useState)(user.address || '');
    const [city, setCity] = (0, $6uYXW.useState)(user.city || '');
    const [state, setState] = (0, $6uYXW.useState)(user.state || '');
    const [zip, setZip] = (0, $6uYXW.useState)(user.zip || '');
    const [birthDate, setBirthDate] = (0, $6uYXW.useState)(user.birth_dttm.split('T')[0]);
    const [email, setEmail] = (0, $6uYXW.useState)(user.email || '');
    const [phoneMobile, setPhoneMobile] = (0, $6uYXW.useState)(user.phone_mobile || '');
    const [maritalStatus, setMaritalStatus] = (0, $6uYXW.useState)(user.marital_status || '');
    const [disabilityStatus, setDisibilityStatus] = (0, $6uYXW.useState)(user.disability_status || '');
    const [veteranStatus, setVeteranStatus] = (0, $6uYXW.useState)(user.veteran_status || '');
    const [ethnicity, setEthnicity] = (0, $6uYXW.useState)(user.ethnicity || '');
    const [race, setRace] = (0, $6uYXW.useState)(user.race || '');
    const [genderIdent, setGenderIdent] = (0, $6uYXW.useState)(user.gender || '');
    const [last4SSN, setLast4SSN] = (0, $6uYXW.useState)(user.last_4_ssn || '');
    const [errorDetails, setErrorDetails] = (0, $6uYXW.useState)(null);
    const handleUpdateProfile = async (event)=>{
        event.preventDefault();
        setErrorDetails(null);
        setIsSaving(true);
        // TODO validation
        try {
            const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).put(`/clients/${user.id}`, {
                name_first: nameFirst,
                name_last: nameLast,
                address: address,
                city: city,
                state: state,
                zip: zip,
                email: email,
                phone_mobile: phoneMobile,
                birth_dttm: birthDate,
                marital_status: maritalStatus,
                disability_status: disabilityStatus,
                veteran_status: veteranStatus,
                ethnicity: ethnicity,
                race: race,
                gender: genderIdent,
                last_4_ssn: last4SSN
            });
            updateUser(data);
            showSuccess('Profile updated');
            setIsSaving(false);
        // clear fields
        } catch (err) {
            if (err?.response?.data?.error) {
                const { details: details } = err.response.data.error;
                setErrorDetails(details);
            } else showError('Password not changed');
            setIsSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                className: "px-4 sm:px-0",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h2", {
                        children: "Profile"
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                        className: "mt-1 text-sm leading-6 text-gray-600",
                        children: "Manage your profile and personal information. By adding your mobile phone or email address you will have been access and support while using Tandem."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("form", {
                className: "bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                        className: "card-body",
                        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "form-control sm:col-span-3",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                            htmlFor: "name-first",
                                            className: "label label-text",
                                            children: "First Name"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                            id: "name-first",
                                            name: "name_first",
                                            type: "text",
                                            autoComplete: "given-name",
                                            required: true,
                                            className: "input input-sm input-bordered",
                                            value: nameFirst,
                                            onChange: ({ target: target })=>setNameFirst(target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "form-control sm:col-span-3",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                            htmlFor: "name-last",
                                            className: "label label-text",
                                            children: "Last Name"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                            id: "name-last",
                                            name: "name_last",
                                            type: "text",
                                            autoComplete: "family-name",
                                            required: true,
                                            className: "input input-sm input-bordered",
                                            value: nameLast,
                                            onChange: ({ target: target })=>setNameLast(target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "form-control sm:col-span-4",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                            htmlFor: "address",
                                            className: "label label-text",
                                            children: "Address"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                            id: "address",
                                            name: "address",
                                            type: "text",
                                            autoComplete: "street-address",
                                            required: true,
                                            className: "input input-sm input-bordered",
                                            value: address,
                                            onChange: ({ target: target })=>setAddress(target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "form-control sm:col-span-3",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                            htmlFor: "city",
                                            className: "label label-text",
                                            children: "City"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                            id: "city",
                                            name: "city",
                                            type: "text",
                                            autoComplete: "address-level2",
                                            required: true,
                                            className: "input input-sm input-bordered",
                                            value: city,
                                            onChange: ({ target: target })=>setCity(target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "form-control sm:col-span-2",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                            htmlFor: "state",
                                            className: "label label-text",
                                            children: "State"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                            id: "state",
                                            name: "state",
                                            type: "text",
                                            autoComplete: "address-level1",
                                            required: true,
                                            className: "input input-sm input-bordered",
                                            value: state,
                                            onChange: ({ target: target })=>setState(target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "form-control sm:col-span-1",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                            htmlFor: "zip",
                                            className: "label label-text",
                                            children: "Zip"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                            id: "zip",
                                            name: "zip",
                                            type: "text",
                                            autoComplete: "postal-code",
                                            required: true,
                                            className: "input input-sm input-bordered",
                                            value: zip,
                                            onChange: ({ target: target })=>setZip(target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "form-control sm:col-span-3",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                            htmlFor: "dob",
                                            className: "label label-text",
                                            children: "Date of Birth"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                            id: "dob",
                                            name: "birth_dttm",
                                            type: "date",
                                            autoComplete: "bday",
                                            required: true,
                                            className: "input input-sm input-bordered",
                                            value: birthDate,
                                            onChange: ({ target: target })=>setBirthDate(target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "form-control sm:col-span-3",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                            htmlFor: "gender",
                                            className: "label label-text",
                                            children: "Gender Identification"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("select", {
                                            id: "gender",
                                            className: "select select-bordered select-sm",
                                            value: genderIdent,
                                            onChange: ({ target: target })=>setGenderIdent(target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: ""
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "woman",
                                                    children: "Woman"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "man",
                                                    children: "Man"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "trans_woman",
                                                    children: "Transgender Woman"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "trans_man",
                                                    children: "Transgender Man"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "non_binary",
                                                    children: "Non-binary"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "agender",
                                                    children: "Agender/I don't identify with a gender"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "other",
                                                    children: "Gender not listed"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "decline_to_state",
                                                    children: "Prefer not to state"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("label", {
                                    className: "form-control sm:col-span-3",
                                    htmlFor: "email",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                            className: "label label-text",
                                            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                                                className: "label-text",
                                                children: "Email Address"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                            id: "email",
                                            name: "email",
                                            type: "email",
                                            autoComplete: "email",
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d7456dac8e72de90$exports)))('input', 'input-sm', 'input-bordered', {
                                                'input-error': errorDetails?.messages?.email
                                            }),
                                            value: email,
                                            onChange: ({ target: target })=>setEmail(target.value)
                                        }),
                                        errorDetails?.messages?.email && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                            className: "label label-text",
                                            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                                                className: "label-text-alt text-error",
                                                children: errorDetails.messages.email
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "form-control sm:col-span-3",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                            htmlFor: "phone-mobile",
                                            className: "label label-text",
                                            children: "Mobile Phone"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                            id: "phone-mobile",
                                            name: "phone_mobile",
                                            type: "text",
                                            autoComplete: "tel",
                                            className: "input input-sm input-bordered",
                                            value: phoneMobile,
                                            onChange: ({ target: target })=>setPhoneMobile(target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "form-control sm:col-span-3",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                            htmlFor: "marital-status",
                                            className: "label label-text",
                                            children: "Marital Status"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("select", {
                                            id: "marital-status",
                                            className: "select select-bordered select-sm",
                                            value: maritalStatus,
                                            onChange: ({ target: target })=>setMaritalStatus(target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: ""
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "single",
                                                    children: "Single"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "married",
                                                    children: "Married"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "divorced",
                                                    children: "Divorced"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "widowed",
                                                    children: "Widowed"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "form-control sm:col-span-3",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                            htmlFor: "disability-status",
                                            className: "label label-text",
                                            children: "Disability"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("select", {
                                            id: "disability-status",
                                            className: "select select-bordered select-sm",
                                            value: disabilityStatus,
                                            onChange: ({ target: target })=>setDisibilityStatus(target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: ""
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "no",
                                                    children: "No"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "yes",
                                                    children: "Yes"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "decline",
                                                    children: "Decline to answer"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "form-control sm:col-span-3",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                            htmlFor: "veteran-status",
                                            className: "label label-text",
                                            children: "Veteran"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("select", {
                                            id: "veteran-status",
                                            className: "select select-bordered select-sm",
                                            value: veteranStatus,
                                            onChange: ({ target: target })=>setVeteranStatus(target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: ""
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "no",
                                                    children: "No"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "yes",
                                                    children: "Yes"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "decline",
                                                    children: "Decline to answer"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "form-control sm:col-span-3",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                            htmlFor: "ethnicity",
                                            className: "label label-text",
                                            children: "Ethnicity"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("select", {
                                            id: "ethnicity",
                                            className: "select select-bordered select-sm",
                                            value: ethnicity,
                                            onChange: ({ target: target })=>setEthnicity(target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: ""
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "yes",
                                                    children: "Hispanic or Latino"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "no",
                                                    children: "Not Hispanic or Latino"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "decline",
                                                    children: "Decline to answer"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "form-control sm:col-span-3",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                            htmlFor: "race",
                                            className: "label label-text",
                                            children: "Race"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("select", {
                                            id: "race",
                                            className: "select select-bordered select-sm",
                                            value: race,
                                            onChange: ({ target: target })=>setRace(target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: ""
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "amer_indian",
                                                    children: "American Indian or Alaska Native"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "asian",
                                                    children: "Asian"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "black",
                                                    children: "Black or African American"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "native_hawaiian_islander",
                                                    children: "Native Hawaiian or Other Pacific Islander"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "white",
                                                    children: "White"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "other",
                                                    children: "Other race"
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                    value: "decline",
                                                    children: "Decline to answer"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "form-control sm:col-span-2",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                            htmlFor: "zip",
                                            className: "label label-text",
                                            children: "4 Digit Verification Number"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                            id: "last4SSN",
                                            name: "last4SSN",
                                            type: "text",
                                            autoComplete: "none",
                                            className: "input input-sm input-bordered",
                                            value: last4SSN,
                                            maxLength: 4,
                                            onChange: ({ target: target })=>setLast4SSN(target.value)
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                        className: "justify-end px-8 py-4 border-t card-actions border-gray-900/10",
                        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                            className: "text-white btn btn-primary btn-sm",
                            name: "form",
                            value: "personalInfo",
                            disabled: isSaving,
                            onClick: handleUpdateProfile,
                            children: "Save"
                        })
                    })
                ]
            })
        ]
    });
};
$5bc9d35b44390826$var$PersonalInfo.propTypes = {
    user: (0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).object.isRequired
};
var $5bc9d35b44390826$export$2e2bcd8739ae039 = $5bc9d35b44390826$var$PersonalInfo;






var $6uYXW = parcelRequire("6uYXW");

const $0b563e4c13532bc4$var$ResetPassword = ({ user: user })=>{
    const { showSuccess: showSuccess, showError: showError } = (0, $8460a3ee79a43e41$export$aa94277a9804d2bd)();
    const [password1, setPassword1] = (0, $6uYXW.useState)('');
    const [password2, setPassword2] = (0, $6uYXW.useState)('');
    const handleChangePassword = async (event)=>{
        event.preventDefault();
        // TODO validation
        try {
            await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).put(`/clients/${user.id}`, {
                password: password1
            });
            showSuccess('Password changed');
            // clear fields
            setPassword1('');
            setPassword2('');
        } catch (err) {
            showError('Password not changed');
        }
    };
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "grid grid-cols-1 pt-10 gap-x-8 gap-y-8 md:grid-cols-3",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                className: "px-4 sm:px-0",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h2", {
                        children: "Password Reset"
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                        className: "mt-1 text-sm leading-6 text-gray-600",
                        children: "Reset your password and keep your account secure."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("form", {
                className: "bg-white shadow-sm card ring-1 ring-gray-900/5 md:col-span-2",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                        className: "card-body",
                        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "form-control sm:col-span-3",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                            htmlFor: "password1",
                                            className: "label label-text",
                                            children: "New Password"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                            id: "password1",
                                            name: "password1",
                                            type: "password",
                                            autoComplete: "new-password",
                                            value: password1,
                                            onChange: ({ target: target })=>setPassword1(target.value),
                                            required: true,
                                            className: "input input-sm input-bordered"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "form-control sm:col-span-3",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                            htmlFor: "password2",
                                            className: "label label-text",
                                            children: "Confirm Password"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                            id: "password2",
                                            name: "password2",
                                            type: "password",
                                            autoComplete: "new-password",
                                            value: password2,
                                            onChange: ({ target: target })=>setPassword2(target.value),
                                            required: true,
                                            className: "input input-sm input-bordered"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                        className: "justify-end px-8 py-4 border-t card-actions border-gray-900/10",
                        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                            className: "text-white btn btn-primary btn-sm",
                            name: "form",
                            value: "changePassword",
                            onClick: handleChangePassword,
                            children: "Save"
                        })
                    })
                ]
            })
        ]
    });
};
$0b563e4c13532bc4$var$ResetPassword.propTypes = {
    user: (0, (/*@__PURE__*/$parcel$interopDefault($ea834b5e286ecd0d$exports))).object.isRequired
};
var $0b563e4c13532bc4$export$2e2bcd8739ae039 = $0b563e4c13532bc4$var$ResetPassword;


const $420d21cada6def78$var$Profile = ()=>{
    const { user: user } = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e)();
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
        className: "profile",
        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
            className: "page-wide",
            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                className: "space-y-10 divide-y divide-gray-900/10",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $5bc9d35b44390826$export$2e2bcd8739ae039), {
                        user: user
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $0b563e4c13532bc4$export$2e2bcd8739ae039), {
                        user: user
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                        className: "grid grid-cols-1 pt-10 gap-x-8 gap-y-8 md:grid-cols-3",
                        children: [
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                className: "px-4 sm:px-0",
                                children: [
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h2", {
                                        children: "Challenge Questions"
                                    }),
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                                        className: "mt-1 text-sm leading-6 text-gray-600",
                                        children: "Set your challenge questions to allow for account recovery in case you forget your password."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $65b8bc3753f9832b$export$2e2bcd8739ae039), {
                                user: user
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $420d21cada6def78$export$2e2bcd8739ae039 = $420d21cada6def78$var$Profile;


var $ea70c77f8a81075a$export$2e2bcd8739ae039 = (0, $420d21cada6def78$export$2e2bcd8739ae039);




var $6uYXW = parcelRequire("6uYXW");
function $83c332a89e24872e$var$EyeIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $6uYXW.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $6uYXW.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $6uYXW.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
    }), /*#__PURE__*/ $6uYXW.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    }));
}
const $83c332a89e24872e$var$ForwardRef = /*#__PURE__*/ $6uYXW.forwardRef($83c332a89e24872e$var$EyeIcon);
var $83c332a89e24872e$export$2e2bcd8739ae039 = $83c332a89e24872e$var$ForwardRef;


var $6uYXW = parcelRequire("6uYXW");
function $f4df5d1356e8a8f2$var$EyeSlashIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $6uYXW.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $6uYXW.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $6uYXW.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
    }));
}
const $f4df5d1356e8a8f2$var$ForwardRef = /*#__PURE__*/ $6uYXW.forwardRef($f4df5d1356e8a8f2$var$EyeSlashIcon);
var $f4df5d1356e8a8f2$export$2e2bcd8739ae039 = $f4df5d1356e8a8f2$var$ForwardRef;





var $6uYXW = parcelRequire("6uYXW");



async function $d48122de56c05aba$export$31eb53bd5b582a97({ request: request /*params */  }) {
    const formData = await request.formData();
    const data = Object.fromEntries(formData);
    // TODO validation (password is required)
    // delete data.email;
    data.text_message_notifications = true;
    try {
        await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).post('/clients', data);
        (0, $8460a3ee79a43e41$export$aa94277a9804d2bd).getState().showSuccess('Account created successfully. Please log in.');
        return (0, $9a468b9555c2dd85$export$89e12c5b50f7529d)('/login');
    } catch (err) {
        return err?.response?.data;
    }
}
const $d48122de56c05aba$var$Register = ()=>{
    const navigate = (0, $88be82bcdaab0750$export$9770f232ac06a008)();
    const data = (0, $88be82bcdaab0750$export$fdc00f3f26066d5e)();
    const [showPassword, setShowPassword] = (0, $6uYXW.useState)(true);
    let errorMessage, errorField;
    if (data?.error?.name === 'ValidationError') {
        if (data?.error?.message.includes('email')) {
            errorMessage = 'Account with email address already exists.';
            errorField = 'email';
        } else if (data?.error?.message.includes('username')) {
            errorMessage = 'Account with username already exists.';
            errorField = 'username';
        } else errorMessage = 'Unknown validation error.';
    }
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "page register-account",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                className: "sm:mx-auto sm:w-full sm:max-w-sm",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h2", {
                        className: "text-center",
                        children: "Create Profile"
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                        children: "Fill out your personal information"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "mt-10 sm:mx-auto sm:w-full sm:max-w-sm",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $c6d33de9e7cf86ac$export$a7fed597f4b8afd8), {
                    className: "space-y-6",
                    method: "post",
                    children: [
                        data?.error && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $4bb5f6c4bf3ec124$export$2e2bcd8739ae039), {
                            message: `Error! ${errorMessage}`
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "form-control",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                    htmlFor: "username",
                                    className: "label label-text",
                                    children: "Username"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                    id: "username",
                                    name: "username",
                                    type: "text",
                                    autoComplete: "username",
                                    required: true,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d7456dac8e72de90$exports)))('input', 'input-bordered', {
                                        'input-error': errorField === 'username'
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "form-control",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                    htmlFor: "name-first",
                                    className: "label label-text",
                                    children: "First Name"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                    id: "name-first",
                                    name: "name_first",
                                    type: "text",
                                    autoComplete: "given-name",
                                    required: true,
                                    className: "input input-bordered"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "form-control",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                    htmlFor: "name-last",
                                    className: "label label-text",
                                    children: "Last Name"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                    id: "name-last",
                                    name: "name_last",
                                    type: "text",
                                    autoComplete: "family-name",
                                    required: true,
                                    className: "input input-bordered"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "form-control",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                    htmlFor: "dob",
                                    className: "label label-text",
                                    children: "Date of Birth"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                    id: "dob",
                                    name: "birth_dttm",
                                    type: "date",
                                    autoComplete: "bday",
                                    required: true,
                                    className: "input input-bordered"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "form-control",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                    htmlFor: "email",
                                    className: "label label-text",
                                    children: "Email Address"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                    id: "email",
                                    name: "email",
                                    type: "email",
                                    autoComplete: "email",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($d7456dac8e72de90$exports)))('input', 'input-bordered', {
                                        'input-error': errorField === 'email'
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "form-control",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                    htmlFor: "phone-mobile",
                                    className: "label label-text",
                                    children: "Mobile Phone"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                    id: "phone-mobile",
                                    name: "phone_mobile",
                                    type: "text",
                                    autoComplete: "tel",
                                    className: "input input-bordered"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("label", {
                            className: "form-control",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                    className: "label label-text",
                                    children: "Password"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 bg-white input input-bordered",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                            id: "password",
                                            name: "password",
                                            type: showPassword ? 'password' : 'text',
                                            autoComplete: "new-password",
                                            required: true,
                                            className: "grow",
                                            minLength: 8
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                            className: "p-1 cursor-pointer",
                                            onClick: ()=>setShowPassword(!showPassword),
                                            children: showPassword ? /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $83c332a89e24872e$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4 opacity-70"
                                            }) : /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $f4df5d1356e8a8f2$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4 opacity-70"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                            className: "text-xs",
                            children: "By providing your phone number and clicking \u201CRegister,\u201D you consent to receive text messages from Now In Tandem at the number provided. Message frequency varies. Message and data rates may apply. Reply HELP for help or STOP to cancel. View our Privacy Policy and Terms of Service."
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                                    type: "submit",
                                    className: "btn btn-primary btn-block btn-sm",
                                    children: "Register"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                                    type: "button",
                                    className: "mt-4 btn btn-block btn-sm",
                                    onClick: ()=>navigate(-1),
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $d48122de56c05aba$export$2e2bcd8739ae039 = $d48122de56c05aba$var$Register;




// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $48491bd8914ad64c$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]",
                        "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:241|349)0\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|91(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79]))))\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:55|6[0-8]|[78]\\d|9[02-9]))\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|2[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "(?:[025-7]\\d|44)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[024-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "(?:01\\d|8)\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[235]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37|86)",
                        "300|4(?:0(?:0|20)|370|864)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[178]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-6]|7[246]|8[2-4]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|[78]"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "60|809"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9(?:10|[2-9])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                        "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "46"
                    ]
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6|90"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|9[14]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|3[13])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0|180020",
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-5])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|5[01]))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0|180020",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6|7[245]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "[2-589]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0|180020",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|8(?:28[235-7]|3))|73179|807(?:1|9[1-3])|(?:1552|6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689])\\d|8(?:[14-6]\\d|2[0-79]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "16|[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "18[06]",
                        "18[06]0"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,11}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[03]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0(?:669[0-79]\\d{1,6}|831\\d{2,8})|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[2356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "3[2-8]\\d{9,10}",
                    [
                        11,
                        12
                    ]
                ],
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0|180020",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|427|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[47]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "3|4(?:2[09]|7[01])|6[1-9]",
                        "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[25-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33622|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4[67]|[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(0-$1)",
                    1
                ]
            ],
            "0",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|78|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2679]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:[19]|2[2-46-9]|3[3-9])|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:(?:18|4[0679]|5[03])\\d|2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9]))\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[016-8]\\d|2[0-8]|5[0-5]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|[67]\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|452|678|86",
                        "[12]|452|6788|86"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]|8(?:0[6-9]|[36])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "[2-9]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[0467]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "(?:20|9\\d)\\d{8}|[78]\\d{9,13}",
            [
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "20[129]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[136]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "709\\d{6}|(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "336(?:[013-9]\\d|2[013-9])\\d{5}|(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15-7]|6[0-35-79]|7[1-37-9]))\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "9\\d{9}",
                    [
                        10
                    ]
                ],
                [
                    "8(?:0[04]|108\\d{3})\\d{7}"
                ],
                [
                    "80[39]\\d{7}",
                    [
                        10
                    ]
                ],
                [
                    "808\\d{7}",
                    [
                        10
                    ]
                ]
            ],
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "(?:[15]\\d|800|92)\\d{7}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "[6-9]\\d{6}|[1-6]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "(?:[2489]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-9]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|7[67]|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|[6-8]\\d|90)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-9]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[25-7]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-7]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-359]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-4]|5[1-3]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[59]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|30|[689]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[236-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "(?:[0-57-9]\\d|66)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[1245]|3[12])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "(?:[1-6]\\d|71)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[67]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "3052(?:0[0-8]|[1-9]\\d)\\d{4}|(?:2742|305[3-9])\\d{6}|(?:472|983)[2-47-9]\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-3]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ],
                0,
                0,
                0,
                [
                    "305209\\d{4}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|2\\d{3,4}|(?:[49]\\d|80)\\d{5}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "00",
            "(?:20|33|[5-9]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ]
                ]
            ]
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[47-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2|39"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|[579]\\d|63)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[235-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "2\\d{8}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                [
                    "348[57]\\d{7}",
                    [
                        11
                    ]
                ],
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


function $43db07a482f0fe9a$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $48491bd8914ad64c$export$2e2bcd8739ae039));
    return func.apply(this, args);
}


var $bf5bed8d112b900b$var$objectConstructor = {}.constructor;
function $bf5bed8d112b900b$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $bf5bed8d112b900b$var$objectConstructor;
}


function $ca0b64dfecd21b98$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ca0b64dfecd21b98$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ca0b64dfecd21b98$var$_typeof(o);
}
function $ca0b64dfecd21b98$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ca0b64dfecd21b98$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ca0b64dfecd21b98$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ca0b64dfecd21b98$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ca0b64dfecd21b98$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ca0b64dfecd21b98$var$_defineProperty(e, r, t) {
    return (r = $ca0b64dfecd21b98$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ca0b64dfecd21b98$var$_toPropertyKey(t) {
    var i = $ca0b64dfecd21b98$var$_toPrimitive(t, "string");
    return "symbol" == $ca0b64dfecd21b98$var$_typeof(i) ? i : i + "";
}
function $ca0b64dfecd21b98$var$_toPrimitive(t, r) {
    if ("object" != $ca0b64dfecd21b98$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ca0b64dfecd21b98$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ca0b64dfecd21b98$var$_slicedToArray(r, e) {
    return $ca0b64dfecd21b98$var$_arrayWithHoles(r) || $ca0b64dfecd21b98$var$_iterableToArrayLimit(r, e) || $ca0b64dfecd21b98$var$_unsupportedIterableToArray(r, e) || $ca0b64dfecd21b98$var$_nonIterableRest();
}
function $ca0b64dfecd21b98$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ca0b64dfecd21b98$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ca0b64dfecd21b98$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ca0b64dfecd21b98$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $ca0b64dfecd21b98$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $ca0b64dfecd21b98$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ca0b64dfecd21b98$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $ca0b64dfecd21b98$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $ca0b64dfecd21b98$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata;
    // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === 'string') text = arg_1;
    else throw new TypeError('A text for parsing must be a string.');
    // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === 'string') {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $ca0b64dfecd21b98$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $bf5bed8d112b900b$export$2e2bcd8739ae039)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// The minimum length of the national significant number.
var $98d7a84050901927$export$cd8355bcbe13154 = 2;
var $98d7a84050901927$export$85ddd8c9b243679b = 17;
var $98d7a84050901927$export$514717690676fb4a = 3;
var $98d7a84050901927$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9";
// `DASHES` will be right after the opening square bracket of the "character class"
var $98d7a84050901927$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $98d7a84050901927$var$SLASHES = "\uFF0F/";
var $98d7a84050901927$var$DOTS = "\uFF0E.";
var $98d7a84050901927$export$20542845033f576e = " \xA0\xAD\u200B\u2060\u3000";
var $98d7a84050901927$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]";
// export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $98d7a84050901927$var$TILDES = "~\u2053\u223C\uFF5E";
var $98d7a84050901927$export$7f01587e28f9194 = "".concat($98d7a84050901927$var$DASHES).concat($98d7a84050901927$var$SLASHES).concat($98d7a84050901927$var$DOTS).concat($98d7a84050901927$export$20542845033f576e).concat($98d7a84050901927$var$BRACKETS).concat($98d7a84050901927$var$TILDES);
var $98d7a84050901927$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')


function $aade2e1b3782cdd9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $aade2e1b3782cdd9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $aade2e1b3782cdd9$var$_typeof(o);
}
function $aade2e1b3782cdd9$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $aade2e1b3782cdd9$var$_toPropertyKey(o.key), o);
    }
}
function $aade2e1b3782cdd9$var$_createClass(e, r, t) {
    return r && $aade2e1b3782cdd9$var$_defineProperties(e.prototype, r), t && $aade2e1b3782cdd9$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $aade2e1b3782cdd9$var$_toPropertyKey(t) {
    var i = $aade2e1b3782cdd9$var$_toPrimitive(t, "string");
    return "symbol" == $aade2e1b3782cdd9$var$_typeof(i) ? i : i + "";
}
function $aade2e1b3782cdd9$var$_toPrimitive(t, r) {
    if ("object" != $aade2e1b3782cdd9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $aade2e1b3782cdd9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $aade2e1b3782cdd9$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $aade2e1b3782cdd9$var$_callSuper(t, o, e) {
    return o = $aade2e1b3782cdd9$var$_getPrototypeOf(o), $aade2e1b3782cdd9$var$_possibleConstructorReturn(t, $aade2e1b3782cdd9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $aade2e1b3782cdd9$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $aade2e1b3782cdd9$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $aade2e1b3782cdd9$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $aade2e1b3782cdd9$var$_assertThisInitialized(t);
}
function $aade2e1b3782cdd9$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $aade2e1b3782cdd9$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $aade2e1b3782cdd9$var$_setPrototypeOf(t, e);
}
function $aade2e1b3782cdd9$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $aade2e1b3782cdd9$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$aade2e1b3782cdd9$var$_isNativeFunction(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $aade2e1b3782cdd9$var$_construct(t, arguments, $aade2e1b3782cdd9$var$_getPrototypeOf(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $aade2e1b3782cdd9$var$_setPrototypeOf(Wrapper, t);
    }, $aade2e1b3782cdd9$var$_wrapNativeSuper(t);
}
function $aade2e1b3782cdd9$var$_construct(t, e, r) {
    if ($aade2e1b3782cdd9$var$_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $aade2e1b3782cdd9$var$_setPrototypeOf(p, r.prototype), p;
}
function $aade2e1b3782cdd9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($aade2e1b3782cdd9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $aade2e1b3782cdd9$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
function $aade2e1b3782cdd9$var$_setPrototypeOf(t, e) {
    return $aade2e1b3782cdd9$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $aade2e1b3782cdd9$var$_setPrototypeOf(t, e);
}
function $aade2e1b3782cdd9$var$_getPrototypeOf(t) {
    return $aade2e1b3782cdd9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $aade2e1b3782cdd9$var$_getPrototypeOf(t);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $aade2e1b3782cdd9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    function ParseError(code) {
        var _this;
        $aade2e1b3782cdd9$var$_classCallCheck(this, ParseError);
        _this = $aade2e1b3782cdd9$var$_callSuper(this, ParseError, [
            code
        ]);
        // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf(_this, ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    $aade2e1b3782cdd9$var$_inherits(ParseError, _Error);
    return $aade2e1b3782cdd9$var$_createClass(ParseError);
}(/*#__PURE__*/ $aade2e1b3782cdd9$var$_wrapNativeSuper(Error));


// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $11b042dd02a0a0fd$export$2e2bcd8739ae039(a, b) {
    a = a.split('-');
    b = b.split('-');
    var pa = a[0].split('.');
    var pb = b[0].split('.');
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}



function $bce5ca6227cb3ed2$var$_readOnlyError(r) {
    throw new TypeError('"' + r + '" is read-only');
}
function $bce5ca6227cb3ed2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bce5ca6227cb3ed2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bce5ca6227cb3ed2$var$_typeof(o);
}
function $bce5ca6227cb3ed2$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bce5ca6227cb3ed2$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $bce5ca6227cb3ed2$var$_toPropertyKey(o.key), o);
    }
}
function $bce5ca6227cb3ed2$var$_createClass(e, r, t) {
    return r && $bce5ca6227cb3ed2$var$_defineProperties(e.prototype, r), t && $bce5ca6227cb3ed2$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $bce5ca6227cb3ed2$var$_toPropertyKey(t) {
    var i = $bce5ca6227cb3ed2$var$_toPrimitive(t, "string");
    return "symbol" == $bce5ca6227cb3ed2$var$_typeof(i) ? i : i + "";
}
function $bce5ca6227cb3ed2$var$_toPrimitive(t, r) {
    if ("object" != $bce5ca6227cb3ed2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $bce5ca6227cb3ed2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// Added "possibleLengths" and renamed
// "country_phone_code_to_countries" to "country_calling_codes".
var $bce5ca6227cb3ed2$var$V2 = '1.0.18';
// Added "idd_prefix" and "default_idd_prefix".
var $bce5ca6227cb3ed2$var$V3 = '1.2.0';
// Moved `001` country code to "nonGeographic" section of metadata.
var $bce5ca6227cb3ed2$var$V4 = '1.7.35';
var $bce5ca6227cb3ed2$var$DEFAULT_EXT_PREFIX = ' ext. ';
var $bce5ca6227cb3ed2$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $bce5ca6227cb3ed2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $bce5ca6227cb3ed2$var$_classCallCheck(this, Metadata);
        $bce5ca6227cb3ed2$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $bce5ca6227cb3ed2$var$setVersion.call(this, metadata);
    }
    return $bce5ca6227cb3ed2$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== '001';
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return;
                // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            }
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $bce5ca6227cb3ed2$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== '001') {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $bce5ca6227cb3ed2$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $bce5ca6227cb3ed2$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return this.metadata.countries['001'];
                }
            }
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            }
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            }
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            }
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            }
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            }
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            }
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
}();
var $bce5ca6227cb3ed2$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $bce5ca6227cb3ed2$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $bce5ca6227cb3ed2$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    return $bce5ca6227cb3ed2$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            }
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            }
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            }
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            }
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $bce5ca6227cb3ed2$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $bce5ca6227cb3ed2$var$getType(this.types(), _type2)) return new $bce5ca6227cb3ed2$var$Type($bce5ca6227cb3ed2$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $bce5ca6227cb3ed2$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $bce5ca6227cb3ed2$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
}();
var $bce5ca6227cb3ed2$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $bce5ca6227cb3ed2$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    return $bce5ca6227cb3ed2$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$bce5ca6227cb3ed2$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $bce5ca6227cb3ed2$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $bce5ca6227cb3ed2$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $bce5ca6227cb3ed2$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    return $bce5ca6227cb3ed2$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
}();
function $bce5ca6227cb3ed2$var$getType(types, type) {
    switch(type){
        case 'FIXED_LINE':
            return types[0];
        case 'MOBILE':
            return types[1];
        case 'TOLL_FREE':
            return types[2];
        case 'PREMIUM_RATE':
            return types[3];
        case 'PERSONAL_NUMBER':
            return types[4];
        case 'VOICEMAIL':
            return types[5];
        case 'UAN':
            return types[6];
        case 'PAGER':
            return types[7];
        case 'VOIP':
            return types[8];
        case 'SHARED_COST':
            return types[9];
    }
}
function $bce5ca6227cb3ed2$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
    // `country_phone_code_to_countries` was renamed to `country_calling_codes` in `1.0.18`.
    // For that reason, it's not used in this detection algorithm.
    // Instead, it detects by `countries: {}` property existence.
    if (!(0, $bf5bed8d112b900b$export$2e2bcd8739ae039)(metadata) || !(0, $bf5bed8d112b900b$export$2e2bcd8739ae039)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $bf5bed8d112b900b$export$2e2bcd8739ae039)(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + $bce5ca6227cb3ed2$var$typeOf(metadata) + ': ' + metadata, "."));
}
// Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $bce5ca6227cb3ed2$var$typeOf = function typeOf(_) {
    return $bce5ca6227cb3ed2$var$_typeof(_);
};
function $bce5ca6227cb3ed2$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $bce5ca6227cb3ed2$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.selectNumberingPlan(country).ext();
    return $bce5ca6227cb3ed2$var$DEFAULT_EXT_PREFIX;
}
function $bce5ca6227cb3ed2$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $bce5ca6227cb3ed2$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.selectNumberingPlan(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $bce5ca6227cb3ed2$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $bce5ca6227cb3ed2$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === 'number') {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $11b042dd02a0a0fd$export$2e2bcd8739ae039)(version, $bce5ca6227cb3ed2$var$V3) === -1) this.v2 = true;
        else if ((0, $11b042dd02a0a0fd$export$2e2bcd8739ae039)(version, $bce5ca6227cb3ed2$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }




// The RFC 3966 format for extensions.
var $dbca66c422f02c44$var$RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $dbca66c422f02c44$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $98d7a84050901927$export$852d1d4a47329634), "]{1,").concat(maxLength, "})");
};
function $dbca66c422f02c44$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = '20';
    /** @type {string} */ var extLimitAfterLikelyLabel = '15';
    /** @type {string} */ var extLimitAfterAmbiguousChar = '9';
    /** @type {string} */ var extLimitWhenNotSure = '6';
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*";
    // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?";
    // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)";
    // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)";
    // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+";
    // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*";
    // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $dbca66c422f02c44$var$RFC3966_EXTN_PREFIX + $dbca66c422f02c44$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $dbca66c422f02c44$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $dbca66c422f02c44$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $dbca66c422f02c44$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $dbca66c422f02c44$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $dbca66c422f02c44$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}


//  Regular expression of viable phone numbers. This is location independent.
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $0249e422af2fc5e5$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + (0, $98d7a84050901927$export$852d1d4a47329634) + ']{' + (0, $98d7a84050901927$export$cd8355bcbe13154) + '}';
var $0249e422af2fc5e5$export$a77dd7471651eee = '[' + (0, $98d7a84050901927$export$207c99ccf3902df8) + ']{0,1}' + '(?:' + '[' + (0, $98d7a84050901927$export$7f01587e28f9194) + ']*' + '[' + (0, $98d7a84050901927$export$852d1d4a47329634) + ']' + '){3,}' + '[' + (0, $98d7a84050901927$export$7f01587e28f9194) + (0, $98d7a84050901927$export$852d1d4a47329634) + ']*';
// This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $0249e422af2fc5e5$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $98d7a84050901927$export$207c99ccf3902df8) + ']{0,1}' + '(?:' + '[' + (0, $98d7a84050901927$export$7f01587e28f9194) + ']*' + '[' + (0, $98d7a84050901927$export$852d1d4a47329634) + ']' + '){1,2}' + '$', 'i');
var $0249e422af2fc5e5$export$a2d12a04749c087d = $0249e422af2fc5e5$export$a77dd7471651eee + // Phone number extensions
'(?:' + (0, $dbca66c422f02c44$export$2e2bcd8739ae039)() + ')?';
// The combined regular expression for valid phone numbers:
//
var $0249e422af2fc5e5$var$VALID_PHONE_NUMBER_PATTERN = new RegExp(// Either a short two-digit-only phone number
'^' + $0249e422af2fc5e5$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + $0249e422af2fc5e5$export$a2d12a04749c087d + '$', 'i');
function $0249e422af2fc5e5$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $98d7a84050901927$export$cd8355bcbe13154) && $0249e422af2fc5e5$var$VALID_PHONE_NUMBER_PATTERN.test(number);
}
function $0249e422af2fc5e5$export$4c3f76c95c05197c(number) {
    return $0249e422af2fc5e5$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}



// Regexp of all known extension prefixes used by different regions followed by
// 1 or more valid digits, for use when parsing.
var $19ce1682d761f46a$var$EXTN_PATTERN = new RegExp('(?:' + (0, $dbca66c422f02c44$export$2e2bcd8739ae039)() + ')$', 'i');
function $19ce1682d761f46a$export$2e2bcd8739ae039(number) {
    var start = number.search($19ce1682d761f46a$var$EXTN_PATTERN);
    if (start < 0) return {};
    // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($19ce1682d761f46a$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}


function $5825f5a4b211fdc2$var$_createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = $5825f5a4b211fdc2$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5825f5a4b211fdc2$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5825f5a4b211fdc2$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5825f5a4b211fdc2$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5825f5a4b211fdc2$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $5825f5a4b211fdc2$export$2848f3d68c08fe69 = {
    '0': '0',
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    "\uFF10": '0',
    // Fullwidth digit 0
    "\uFF11": '1',
    // Fullwidth digit 1
    "\uFF12": '2',
    // Fullwidth digit 2
    "\uFF13": '3',
    // Fullwidth digit 3
    "\uFF14": '4',
    // Fullwidth digit 4
    "\uFF15": '5',
    // Fullwidth digit 5
    "\uFF16": '6',
    // Fullwidth digit 6
    "\uFF17": '7',
    // Fullwidth digit 7
    "\uFF18": '8',
    // Fullwidth digit 8
    "\uFF19": '9',
    // Fullwidth digit 9
    "\u0660": '0',
    // Arabic-indic digit 0
    "\u0661": '1',
    // Arabic-indic digit 1
    "\u0662": '2',
    // Arabic-indic digit 2
    "\u0663": '3',
    // Arabic-indic digit 3
    "\u0664": '4',
    // Arabic-indic digit 4
    "\u0665": '5',
    // Arabic-indic digit 5
    "\u0666": '6',
    // Arabic-indic digit 6
    "\u0667": '7',
    // Arabic-indic digit 7
    "\u0668": '8',
    // Arabic-indic digit 8
    "\u0669": '9',
    // Arabic-indic digit 9
    "\u06F0": '0',
    // Eastern-Arabic digit 0
    "\u06F1": '1',
    // Eastern-Arabic digit 1
    "\u06F2": '2',
    // Eastern-Arabic digit 2
    "\u06F3": '3',
    // Eastern-Arabic digit 3
    "\u06F4": '4',
    // Eastern-Arabic digit 4
    "\u06F5": '5',
    // Eastern-Arabic digit 5
    "\u06F6": '6',
    // Eastern-Arabic digit 6
    "\u06F7": '7',
    // Eastern-Arabic digit 7
    "\u06F8": '8',
    // Eastern-Arabic digit 8
    "\u06F9": '9' // Eastern-Arabic digit 9
};
function $5825f5a4b211fdc2$export$1d16fddea1437169(character) {
    return $5825f5a4b211fdc2$export$2848f3d68c08fe69[character];
}
function $5825f5a4b211fdc2$export$2e2bcd8739ae039(string) {
    var result = '';
    // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $5825f5a4b211fdc2$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $5825f5a4b211fdc2$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}


function $5e87b301cd757756$var$_createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = $5e87b301cd757756$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5e87b301cd757756$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5e87b301cd757756$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5e87b301cd757756$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5e87b301cd757756$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $5e87b301cd757756$export$2e2bcd8739ae039(string) {
    var result = '';
    // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $5e87b301cd757756$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $5e87b301cd757756$export$13d8790d7fb84c28(character, result) || '';
    }
    return result;
}
function $5e87b301cd757756$export$13d8790d7fb84c28(character, prevParsedCharacters, eventListener) {
    // Only allow a leading `+`.
    if (character === '+') {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) {
            // `eventListener` argument was added to this `export`ed function on Dec 26th, 2023.
            // Any 3rd-party code that used to `import` and call this function before that
            // won't be passing any `eventListener` argument.
            //
            // The addition of the `eventListener` argument was to fix the slightly-weird behavior
            // of parsing an input string when the user inputs something like `"2+7"
            // https://github.com/catamphetamine/react-phone-number-input/issues/437
            //
            // If the parser encounters an unexpected `+` in a string being parsed
            // then it simply discards that out-of-place `+` and any following characters.
            //
            if (typeof eventListener === 'function') eventListener('end');
            return;
        }
        return '+';
    }
    // Allow digits.
    return (0, $5825f5a4b211fdc2$export$1d16fddea1437169)(character);
}





function $32a2a39031f8d445$var$_createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = $32a2a39031f8d445$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $32a2a39031f8d445$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $32a2a39031f8d445$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $32a2a39031f8d445$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $32a2a39031f8d445$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $32a2a39031f8d445$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $32a2a39031f8d445$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    });
// ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}


function $88b010df83443a8d$export$2e2bcd8739ae039(nationalNumber, country, metadata) {
    return $88b010df83443a8d$export$69333f603c7d5931(nationalNumber, country, undefined, metadata);
}
function $88b010df83443a8d$export$69333f603c7d5931(nationalNumber, country, type, metadata) {
    // If the exact `country` is specified, it's no necessarily already selected in `metadata`.
    // Most likely, in cases when there're multiple countries corresponding to the same
    // "country calling code", the "main" country for that "country calling code" will be selected.
    if (country) {
        metadata = new (0, $bce5ca6227cb3ed2$export$2e2bcd8739ae039)(metadata.metadata);
        metadata.selectNumberingPlan(country);
    }
    var type_info = metadata.type(type);
    // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths();
    // let local_lengths = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return 'IS_POSSIBLE';
    if (type === 'FIXED_LINE_OR_MOBILE') {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type('FIXED_LINE')) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $88b010df83443a8d$export$69333f603c7d5931(nationalNumber, country, 'MOBILE', metadata);
        var mobile_type = metadata.type('MOBILE');
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $32a2a39031f8d445$export$2e2bcd8739ae039)(possible_lengths, mobile_type.possibleLengths());
    } else if (type && !type_info) return 'INVALID_LENGTH';
    var actual_length = nationalNumber.length;
    // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return 'IS_POSSIBLE';
    if (minimum_length > actual_length) return 'TOO_SHORT';
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return 'TOO_LONG';
    // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}


function $ba372f4ea865820c$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $bce5ca6227cb3ed2$export$2e2bcd8739ae039)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.selectNumberingPlan(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    }
    // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $ba372f4ea865820c$export$4f8890cedf1e0497(input.phone || input.nationalNumber, input.country, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $ba372f4ea865820c$export$4f8890cedf1e0497(nationalNumber, country, metadata) {
    //, isInternational) {
    switch((0, $88b010df83443a8d$export$2e2bcd8739ae039)(nationalNumber, country, metadata)){
        case 'IS_POSSIBLE':
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}





/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $35acf32273274407$export$2e2bcd8739ae039(text, regularExpressionText) {
    // If the assigning of the `''` default value is moved to the arguments above,
    // the code coverage would decrease for some weird reason.
    text = text || '';
    return new RegExp('^(?:' + regularExpressionText + ')$').test(text);
}




function $a922f615bcdd44fd$var$_createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = $a922f615bcdd44fd$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a922f615bcdd44fd$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a922f615bcdd44fd$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a922f615bcdd44fd$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a922f615bcdd44fd$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $a922f615bcdd44fd$var$NON_FIXED_LINE_PHONE_TYPES = [
    'MOBILE',
    'PREMIUM_RATE',
    'TOLL_FREE',
    'SHARED_COST',
    'VOIP',
    'PERSONAL_NUMBER',
    'PAGER',
    'UAN',
    'VOICEMAIL'
];
function $a922f615bcdd44fd$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $bce5ca6227cb3ed2$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $35acf32273274407$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern())) return;
    // Is it fixed line number
    if ($a922f615bcdd44fd$export$7bd37b39ade0214d(nationalNumber, 'FIXED_LINE', metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') return 'FIXED_LINE_OR_MOBILE';
        // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type('MOBILE')) return 'FIXED_LINE_OR_MOBILE';
        // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($a922f615bcdd44fd$export$7bd37b39ade0214d(nationalNumber, 'MOBILE', metadata)) return 'FIXED_LINE_OR_MOBILE';
        return 'FIXED_LINE';
    }
    for(var _iterator = $a922f615bcdd44fd$var$_createForOfIteratorHelperLoose($a922f615bcdd44fd$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($a922f615bcdd44fd$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $a922f615bcdd44fd$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
    // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $35acf32273274407$export$2e2bcd8739ae039)(nationalNumber, type.pattern());
}


function $5d71e138e0766ac9$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $bce5ca6227cb3ed2$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $a922f615bcdd44fd$export$2e2bcd8739ae039)(input, options, metadata.metadata) !== undefined;
    // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $35acf32273274407$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern());
}




function $0b024af0a5c56f65$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $bce5ca6227cb3ed2$export$2e2bcd8739ae039)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $0b024af0a5c56f65$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $0b024af0a5c56f65$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $bce5ca6227cb3ed2$export$2e2bcd8739ae039)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}




var $c8237c822f170abb$var$CAPTURING_DIGIT_PATTERN = new RegExp('([' + (0, $98d7a84050901927$export$852d1d4a47329634) + '])');
function $c8237c822f170abb$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
    // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $bce5ca6227cb3ed2$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
    // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length);
    // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($c8237c822f170abb$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === '0') return;
    }
    return number;
}




/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $df7c5677e63c77d4$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode;
            // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule());
                // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length);
                // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            }
            // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup);
                // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}






function $91fed664a0fe75dd$var$_createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = $91fed664a0fe75dd$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $91fed664a0fe75dd$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $91fed664a0fe75dd$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $91fed664a0fe75dd$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $91fed664a0fe75dd$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $91fed664a0fe75dd$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $bce5ca6227cb3ed2$export$2e2bcd8739ae039)(metadata);
    // const matchingCountries = []
    for(var _iterator = $91fed664a0fe75dd$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.selectNumberingPlan(country);
        // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $a922f615bcdd44fd$export$2e2bcd8739ae039)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) // When multiple countries share the same "country calling code",
        // type patterns aren't guaranteed to be unique among them.
        // For example, both `US` and `CA` have the same pattern for `toll_free` numbers.
        // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/103#note_1417147572
        //
        // That means that this `if` condition could be `true` for multiple countries from the list.
        // Currently, it just returns the first one, which is also the "main" country for the "country calling code".
        // In an example with `toll_free` numbers above, `"US"` would be returned even though
        // it could as well be `"CA"`.
        //
        // There was also a time when this attempted to be overly smart
        // and kept track of all such multiple matching countries
        // and then picked the one that matched the `defaultCountry`, if provided.
        // For example, with `toll_free` numbers above, and with `defaultCountry: "CA"`,
        // it would've returned `"CA"` instead of `"US"`.
        // Later it turned out that such "overly smart" behavior turned out to be just confusing,
        // so this "overly smart" country detection was reverted to returning the "main" country
        // for the "country calling code".
        // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/154
        //
        return country;
    }
// // Return the first ("main") one of the `matchingCountries`.
// if (matchingCountries.length > 0) {
// 	return matchingCountries[0]
// }
}


var $f202665e259874b0$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $f202665e259874b0$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($f202665e259874b0$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return '001';
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
    // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $91fed664a0fe75dd$export$2e2bcd8739ae039)(nationalPhoneNumber, {
        countries: possibleCountries,
        metadata: metadata.metadata
    });
}


function $82ddc43a260803c8$export$2e2bcd8739ae039(number, country, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $df7c5677e63c77d4$export$2e2bcd8739ae039)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$82ddc43a260803c8$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
        // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.numberingPlan.possibleLengths()) {
            // If an exact `country` is not specified, attempt to detect it from the assumed national number.
            if (!country) country = (0, $f202665e259874b0$export$2e2bcd8739ae039)(metadata.numberingPlan.callingCode(), {
                nationalNumber: nationalNumber,
                metadata: metadata
            });
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$82ddc43a260803c8$var$isPossibleIncompleteNationalNumber(nationalNumber, country, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}
// In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $82ddc43a260803c8$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $35acf32273274407$export$2e2bcd8739ae039)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $35acf32273274407$export$2e2bcd8739ae039)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
    // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $82ddc43a260803c8$var$isPossibleIncompleteNationalNumber(nationalNumber, country, metadata) {
    switch((0, $88b010df83443a8d$export$2e2bcd8739ae039)(nationalNumber, country, metadata)){
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}




function $878535d1f6f3c21d$export$2e2bcd8739ae039(number, country, defaultCountry, defaultCallingCode, metadata) {
    var countryCallingCode = country || defaultCountry ? (0, $bce5ca6227cb3ed2$export$32876ca2f1919cf0)(country || defaultCountry, metadata) : defaultCallingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $bce5ca6227cb3ed2$export$2e2bcd8739ae039)(metadata);
        metadata.selectNumberingPlan(country || defaultCountry, countryCallingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $82ddc43a260803c8$export$2e2bcd8739ae039)(possibleShorterNumber, country, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $82ddc43a260803c8$export$2e2bcd8739ae039)(number, country, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber;
        // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $35acf32273274407$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) && (0, $35acf32273274407$export$2e2bcd8739ae039)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $88b010df83443a8d$export$2e2bcd8739ae039)(nationalNumber, country, metadata) === 'TOO_LONG') return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}




function $3d92bd5f5d91cfad$export$2e2bcd8739ae039(number, country, defaultCountry, defaultCallingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix;
    // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== '+') {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $c8237c822f170abb$export$2e2bcd8739ae039)(number, country || defaultCountry, defaultCallingCode, metadata);
        // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = '+' + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || defaultCountry || defaultCallingCode) {
                var _extractCountryCallin = (0, $878535d1f6f3c21d$export$2e2bcd8739ae039)(number, country, defaultCountry, defaultCallingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    }
    // `number` can only be international at this point.
    // Fast abortion: country codes do not begin with a '0'
    if (number[1] === '0') return {};
    metadata = new (0, $bce5ca6227cb3ed2$export$2e2bcd8739ae039)(metadata);
    // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $98d7a84050901927$export$514717690676fb4a) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }



// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js


function $7c1db87101d8728f$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $98d7a84050901927$export$7f01587e28f9194), "]+"), 'g'), ' ').trim();
}


var $7079c79331818186$export$4f32ad1c51a7a6be = /(\$\d)/;
function $7079c79331818186$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($7079c79331818186$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $7c1db87101d8728f$export$2e2bcd8739ae039)(formattedNumber);
    return formattedNumber;
}




/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $50b4ca8186ad142e$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function $50b4ca8186ad142e$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $bce5ca6227cb3ed2$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($50b4ca8186ad142e$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}



function $cc96b9e725eeb911$var$_slicedToArray(r, e) {
    return $cc96b9e725eeb911$var$_arrayWithHoles(r) || $cc96b9e725eeb911$var$_iterableToArrayLimit(r, e) || $cc96b9e725eeb911$var$_unsupportedIterableToArray(r, e) || $cc96b9e725eeb911$var$_nonIterableRest();
}
function $cc96b9e725eeb911$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cc96b9e725eeb911$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $cc96b9e725eeb911$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $cc96b9e725eeb911$var$_createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = $cc96b9e725eeb911$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cc96b9e725eeb911$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $cc96b9e725eeb911$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $cc96b9e725eeb911$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $cc96b9e725eeb911$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $cc96b9e725eeb911$export$26fe644d7d92bb13(text) {
    var number;
    var ext;
    // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, 'tel=');
    for(var _iterator = $cc96b9e725eeb911$var$_createForOfIteratorHelperLoose(text.split(';')), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split('='), _part$split2 = $cc96b9e725eeb911$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case 'tel':
                number = value;
                break;
            case 'ext':
                ext = value;
                break;
            case 'phone-context':
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === '+') number = value + number;
                break;
        }
    }
    // If the phone number is not viable, then abort.
    if (!(0, $0249e422af2fc5e5$export$2e2bcd8739ae039)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $cc96b9e725eeb911$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return '';
    if (number[0] !== '+') throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
    return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}


var $ff28d49019c4a2f9$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $ff28d49019c4a2f9$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) // Using ES6 "rest spread" syntax here didn't work with `babel`/`istanbul`
    // for some weird reason: this line of code would cause the code coverage
    // to show as not 100%. That's because `babel`/`istanbul`, for some weird reason,
    // apparently doesn't know how to properly exclude Babel polyfills from code coverage.
    //
    // options = { ...DEFAULT_OPTIONS, ...options }
    //
    options = $ff28d49019c4a2f9$var$merge({}, $ff28d49019c4a2f9$var$DEFAULT_OPTIONS, options);
    else options = $ff28d49019c4a2f9$var$DEFAULT_OPTIONS;
    metadata = new (0, $bce5ca6227cb3ed2$export$2e2bcd8739ae039)(metadata);
    if (input.country && input.country !== '001') {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.selectNumberingPlan(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || '';
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case 'NATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return '';
            number = $ff28d49019c4a2f9$var$formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
            return $ff28d49019c4a2f9$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'INTERNATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $ff28d49019c4a2f9$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $ff28d49019c4a2f9$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'E.164':
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case 'RFC3966':
            return (0, $cc96b9e725eeb911$export$d4f2d2bc1159d115)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case 'IDD':
            if (!options.fromCountry) return;
            var formattedNumber = $ff28d49019c4a2f9$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $ff28d49019c4a2f9$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
    }
}
function $ff28d49019c4a2f9$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $ff28d49019c4a2f9$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $7079c79331818186$export$2e2bcd8739ae039)(number, format, {
        useInternationalFormat: formatAs === 'INTERNATIONAL',
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $ff28d49019c4a2f9$export$a4ff939d1245121e(availableFormats, nationalNumber) {
    // Using a `for ... of` loop here didn't work with `babel`/`istanbul`:
    // for some weird reason, it showed code coverage less than 100%.
    // That's because `babel`/`istanbul`, for some weird reason,
    // apparently doesn't know how to properly exclude Babel polyfills from code coverage.
    //
    // for (const format of availableFormats) { ... }
    //
    return $ff28d49019c4a2f9$var$pickFirstMatchingElement(availableFormats, function(format) {
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1];
            // If leading digits don't match then move on to the next phone number format
            if (nationalNumber.search(lastLeadingDigitsPattern) !== 0) return false;
        }
        // Check that the national number matches the phone number format regular expression
        return (0, $35acf32273274407$export$2e2bcd8739ae039)(nationalNumber, format.pattern());
    });
}
function $ff28d49019c4a2f9$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $ff28d49019c4a2f9$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $bce5ca6227cb3ed2$export$32876ca2f1919cf0)(fromCountry, metadata.metadata);
    // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $ff28d49019c4a2f9$var$formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata);
        // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === '1') return countryCallingCode + ' ' + formattedNumber;
        // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $50b4ca8186ad142e$export$2e2bcd8739ae039)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($ff28d49019c4a2f9$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
}
function $ff28d49019c4a2f9$var$merge() {
    var i = 1;
    for(var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++)objects[_key] = arguments[_key];
    while(i < objects.length){
        if (objects[i]) for(var key in objects[i])objects[0][key] = objects[i][key];
        i++;
    }
    return objects[0];
}
function $ff28d49019c4a2f9$var$pickFirstMatchingElement(elements, testFunction) {
    var i = 0;
    while(i < elements.length){
        if (testFunction(elements[i])) return elements[i];
        i++;
    }
}


function $5bbef17d1712b412$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5bbef17d1712b412$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5bbef17d1712b412$var$_typeof(o);
}
function $5bbef17d1712b412$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5bbef17d1712b412$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5bbef17d1712b412$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5bbef17d1712b412$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5bbef17d1712b412$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5bbef17d1712b412$var$_defineProperty(e, r, t) {
    return (r = $5bbef17d1712b412$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5bbef17d1712b412$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $5bbef17d1712b412$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $5bbef17d1712b412$var$_toPropertyKey(o.key), o);
    }
}
function $5bbef17d1712b412$var$_createClass(e, r, t) {
    return r && $5bbef17d1712b412$var$_defineProperties(e.prototype, r), t && $5bbef17d1712b412$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $5bbef17d1712b412$var$_toPropertyKey(t) {
    var i = $5bbef17d1712b412$var$_toPrimitive(t, "string");
    return "symbol" == $5bbef17d1712b412$var$_typeof(i) ? i : i + "";
}
function $5bbef17d1712b412$var$_toPrimitive(t, r) {
    if ("object" != $5bbef17d1712b412$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5bbef17d1712b412$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $5bbef17d1712b412$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $5bbef17d1712b412$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $5bbef17d1712b412$var$_classCallCheck(this, PhoneNumber);
        // Validate `countryOrCountryCallingCode` argument.
        if (!countryOrCountryCallingCode) throw new TypeError('First argument is required');
        if (typeof countryOrCountryCallingCode !== 'string') throw new TypeError('First argument must be a string');
        // In case of public API use: `constructor(number, metadata)`.
        // Transform the arguments from `constructor(number, metadata)` to
        // `constructor(countryOrCountryCallingCode, nationalNumber, metadata)`.
        if (countryOrCountryCallingCode[0] === '+' && !nationalNumber) throw new TypeError('`metadata` argument not passed');
        if ((0, $bf5bed8d112b900b$export$2e2bcd8739ae039)(nationalNumber) && (0, $bf5bed8d112b900b$export$2e2bcd8739ae039)(nationalNumber.countries)) {
            metadata = nationalNumber;
            var e164Number = countryOrCountryCallingCode;
            if (!$5bbef17d1712b412$var$E164_NUMBER_REGEXP.test(e164Number)) throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
            var _extractCountryCallin = (0, $3d92bd5f5d91cfad$export$2e2bcd8739ae039)(e164Number, undefined, undefined, undefined, metadata), _countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
            nationalNumber = number;
            countryOrCountryCallingCode = _countryCallingCode;
            if (!nationalNumber) throw new Error('Invalid `number` argument passed: too short');
        }
        // Validate `nationalNumber` argument.
        if (!nationalNumber) throw new TypeError('`nationalNumber` argument is required');
        if (typeof nationalNumber !== 'string') throw new TypeError('`nationalNumber` argument must be a string');
        // Validate `metadata` argument.
        (0, $bce5ca6227cb3ed2$export$a0b100d4662a8795)(metadata);
        // Initialize properties.
        var _getCountryAndCountry = $5bbef17d1712b412$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = '+' + this.countryCallingCode + this.nationalNumber;
        // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    return $5bbef17d1712b412$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $0b024af0a5c56f65$export$2e2bcd8739ae039)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $ba372f4ea865820c$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $5d71e138e0766ac9$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $bce5ca6227cb3ed2$export$2e2bcd8739ae039)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            }
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $a922f615bcdd44fd$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $ff28d49019c4a2f9$export$2e2bcd8739ae039)(this, _format, options ? $5bbef17d1712b412$var$_objectSpread($5bbef17d1712b412$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format('NATIONAL', options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format('INTERNATIONAL', options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format('RFC3966', options);
            }
        }
    ]);
}();
var $5bbef17d1712b412$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $5bbef17d1712b412$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $bce5ca6227cb3ed2$export$2e2bcd8739ae039)(metadataJson);
    // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($5bbef17d1712b412$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($5bbef17d1712b412$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = '001';
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}
var $5bbef17d1712b412$var$E164_NUMBER_REGEXP = /^\+\d+$/;






// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $8cc56e9df2519455$export$1ddc7eed78155f68 = '+';
var $8cc56e9df2519455$var$RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
var $8cc56e9df2519455$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $98d7a84050901927$export$852d1d4a47329634) + ']' + '|' + $8cc56e9df2519455$var$RFC3966_VISUAL_SEPARATOR_ + ')';
var $8cc56e9df2519455$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $8cc56e9df2519455$export$1ddc7eed78155f68 + $8cc56e9df2519455$var$RFC3966_PHONE_DIGIT_ + '*' + '[' + (0, $98d7a84050901927$export$852d1d4a47329634) + ']' + $8cc56e9df2519455$var$RFC3966_PHONE_DIGIT_ + '*' + '$';
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $8cc56e9df2519455$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($8cc56e9df2519455$var$RFC3966_GLOBAL_NUMBER_DIGITS_, 'g');
// In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $8cc56e9df2519455$var$ALPHANUM_ = (0, $98d7a84050901927$export$852d1d4a47329634);
var $8cc56e9df2519455$var$RFC3966_DOMAINLABEL_ = '[' + $8cc56e9df2519455$var$ALPHANUM_ + ']+((\\-)*[' + $8cc56e9df2519455$var$ALPHANUM_ + '])*';
var $8cc56e9df2519455$var$VALID_ALPHA_ = 'a-zA-Z';
var $8cc56e9df2519455$var$RFC3966_TOPLABEL_ = '[' + $8cc56e9df2519455$var$VALID_ALPHA_ + ']+((\\-)*[' + $8cc56e9df2519455$var$ALPHANUM_ + '])*';
var $8cc56e9df2519455$var$RFC3966_DOMAINNAME_ = '^(' + $8cc56e9df2519455$var$RFC3966_DOMAINLABEL_ + '\\.)*' + $8cc56e9df2519455$var$RFC3966_TOPLABEL_ + '\\.?$';
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $8cc56e9df2519455$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($8cc56e9df2519455$var$RFC3966_DOMAINNAME_, 'g');
var $8cc56e9df2519455$export$70d485ce3f6de783 = 'tel:';
var $8cc56e9df2519455$export$f6d5879d582c3a27 = ';phone-context=';
var $8cc56e9df2519455$export$9e356e12edb00a81 = ';isub=';
function $8cc56e9df2519455$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($8cc56e9df2519455$export$f6d5879d582c3a27);
    // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $8cc56e9df2519455$export$f6d5879d582c3a27.length;
    // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return '';
    var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart);
    // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $8cc56e9df2519455$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
    // Does phone-context value match pattern of global-number-digits or domainname.
    return $8cc56e9df2519455$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $8cc56e9df2519455$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}



function $04fbd1d831fec691$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $8cc56e9df2519455$export$2e2bcd8739ae039)(numberToParse);
    if (!(0, $8cc56e9df2519455$export$474a4aa22ad6959a)(phoneContext)) throw new (0, $aade2e1b3782cdd9$export$2e2bcd8739ae039)('NOT_A_NUMBER');
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
    else {
        phoneNumberString = '';
        // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $8cc56e9df2519455$export$1ddc7eed78155f68)) phoneNumberString += phoneContext;
        // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $8cc56e9df2519455$export$70d485ce3f6de783));
        var indexOfNationalNumber;
        // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $8cc56e9df2519455$export$70d485ce3f6de783).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $8cc56e9df2519455$export$f6d5879d582c3a27));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    }
    // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $8cc56e9df2519455$export$9e356e12edb00a81));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
    // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== '') return phoneNumberString;
}


// We don't allow input strings for parsing to be longer than 250 chars.
// This prevents malicious input from consuming CPU.
var $4981ea19bd94730a$var$MAX_INPUT_STRING_LENGTH = 250;
// This consists of the plus symbol, digits, and arabic-indic digits.
var $4981ea19bd94730a$var$PHONE_NUMBER_START_PATTERN = new RegExp('[' + (0, $98d7a84050901927$export$207c99ccf3902df8) + (0, $98d7a84050901927$export$852d1d4a47329634) + ']');
// Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $4981ea19bd94730a$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + (0, $98d7a84050901927$export$852d1d4a47329634) + '#' + ']+$');
var $4981ea19bd94730a$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $4981ea19bd94730a$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $bce5ca6227cb3ed2$export$2e2bcd8739ae039)(metadata);
    // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $aade2e1b3782cdd9$export$2e2bcd8739ae039)('INVALID_COUNTRY');
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    }
    // Parse the phone number.
    var _parseInput = $4981ea19bd94730a$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error;
    // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === 'TOO_SHORT') throw new (0, $aade2e1b3782cdd9$export$2e2bcd8739ae039)('TOO_SHORT');
            throw new (0, $aade2e1b3782cdd9$export$2e2bcd8739ae039)('NOT_A_NUMBER');
        }
        return {};
    }
    var _parsePhoneNumber = $4981ea19bd94730a$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $aade2e1b3782cdd9$export$2e2bcd8739ae039)('INVALID_COUNTRY');
        return {};
    }
    // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $98d7a84050901927$export$cd8355bcbe13154)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $aade2e1b3782cdd9$export$2e2bcd8739ae039)('TOO_SHORT');
        // Google's demo just throws an error in this case.
        return {};
    }
    // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $98d7a84050901927$export$85ddd8c9b243679b)) {
        if (options.v2) throw new (0, $aade2e1b3782cdd9$export$2e2bcd8739ae039)('TOO_LONG');
        // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $5bbef17d1712b412$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    }
    // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $35acf32273274407$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $4981ea19bd94730a$var$result(country, nationalNumber, ext) : {};
    // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $ba372f4ea865820c$export$4f8890cedf1e0497)(nationalNumber, country, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $4981ea19bd94730a$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $4981ea19bd94730a$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $aade2e1b3782cdd9$export$2e2bcd8739ae039)('TOO_LONG');
        return;
    }
    if (extract === false) return text;
    // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($4981ea19bd94730a$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text// Trim everything to the left of the phone number
    .slice(startsAt)// Remove trailing non-numerical characters
    .replace($4981ea19bd94730a$var$AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $4981ea19bd94730a$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $04fbd1d831fec691$export$2e2bcd8739ae039)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $4981ea19bd94730a$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    });
    // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $0249e422af2fc5e5$export$2e2bcd8739ae039)(number)) {
        if ((0, $0249e422af2fc5e5$export$4c3f76c95c05197c)(number)) return {
            error: 'TOO_SHORT'
        };
        return {};
    }
    // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $19ce1682d761f46a$export$2e2bcd8739ae039)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $4981ea19bd94730a$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $4981ea19bd94730a$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $3d92bd5f5d91cfad$export$2e2bcd8739ae039)((0, $5e87b301cd757756$export$2e2bcd8739ae039)(formattedPhoneNumber), undefined, defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
    // The exact country of the phone number
    var country;
    // If `formattedPhoneNumber` is passed in "international" format,
    // choose a country by `countryCallingCode`.
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($4981ea19bd94730a$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = '001';
            }
        }
        countryCallingCode = defaultCallingCode || (0, $bce5ca6227cb3ed2$export$32876ca2f1919cf0)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $82ddc43a260803c8$export$2e2bcd8739ae039)((0, $5e87b301cd757756$export$2e2bcd8739ae039)(number), country, metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
    // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $f202665e259874b0$export$2e2bcd8739ae039)(countryCallingCode, {
        nationalNumber: nationalNumber,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === '001') ;
        else metadata.selectNumberingPlan(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}


function $bb613759e99768a3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bb613759e99768a3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bb613759e99768a3$var$_typeof(o);
}
function $bb613759e99768a3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bb613759e99768a3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bb613759e99768a3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bb613759e99768a3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bb613759e99768a3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bb613759e99768a3$var$_defineProperty(e, r, t) {
    return (r = $bb613759e99768a3$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $bb613759e99768a3$var$_toPropertyKey(t) {
    var i = $bb613759e99768a3$var$_toPrimitive(t, "string");
    return "symbol" == $bb613759e99768a3$var$_typeof(i) ? i : i + "";
}
function $bb613759e99768a3$var$_toPrimitive(t, r) {
    if ("object" != $bb613759e99768a3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $bb613759e99768a3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $bb613759e99768a3$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $4981ea19bd94730a$export$2e2bcd8739ae039)(text, $bb613759e99768a3$var$_objectSpread($bb613759e99768a3$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}




function $475355e796f7d8d2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $475355e796f7d8d2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $475355e796f7d8d2$var$_typeof(o);
}
function $475355e796f7d8d2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $475355e796f7d8d2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $475355e796f7d8d2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $475355e796f7d8d2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $475355e796f7d8d2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $475355e796f7d8d2$var$_defineProperty(e, r, t) {
    return (r = $475355e796f7d8d2$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $475355e796f7d8d2$var$_toPropertyKey(t) {
    var i = $475355e796f7d8d2$var$_toPrimitive(t, "string");
    return "symbol" == $475355e796f7d8d2$var$_typeof(i) ? i : i + "";
}
function $475355e796f7d8d2$var$_toPrimitive(t, r) {
    if ("object" != $475355e796f7d8d2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $475355e796f7d8d2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $475355e796f7d8d2$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $bce5ca6227cb3ed2$export$bd9e113b8b17202a)(options.defaultCountry, metadata)) options = $475355e796f7d8d2$var$_objectSpread($475355e796f7d8d2$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
    // Parse phone number.
    try {
        return (0, $bb613759e99768a3$export$2e2bcd8739ae039)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $aade2e1b3782cdd9$export$2e2bcd8739ae039)) ;
        else throw error;
    }
}


function $f5d9bc361bef929c$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $ca0b64dfecd21b98$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $475355e796f7d8d2$export$2e2bcd8739ae039)(text, options, metadata);
}


function $fbeab8f5e0f3ced1$export$da44e4eaa54bc82e() {
    return (0, $43db07a482f0fe9a$export$2e2bcd8739ae039)((0, $f5d9bc361bef929c$export$2e2bcd8739ae039), arguments);
}



var $6uYXW = parcelRequire("6uYXW");

async function $2cb6cb94138d78da$export$31eb53bd5b582a97({ request: request /*params */  }) {
    const formData = await request.formData();
    const data = Object.fromEntries(formData);
    const options = {};
    if (data.identifier) {
        const phoneNumber = (0, $fbeab8f5e0f3ced1$export$da44e4eaa54bc82e)(data.identifier, 'US');
        if (phoneNumber && phoneNumber.isValid()) options.phone_mobile = phoneNumber.number.substring(2); // Remove the +1
        else options.username = data.identifier;
    }
    try {
        await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).post('/clients/resetPassword', options);
    } catch (error) {
        return {
            error: error
        };
    }
    return {
        submitted: true
    };
}
const $2cb6cb94138d78da$var$ResetPassword = ()=>{
    const actionData = (0, $88be82bcdaab0750$export$fdc00f3f26066d5e)();
    const [textAllowed, setTextAllowed] = (0, $6uYXW.useState)(false);
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "justify-center py-12 page",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "sm:mx-auto sm:w-full sm:max-w-sm",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h2", {
                    children: "Reset Password"
                })
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "mt-10 sm:mx-auto sm:w-full sm:max-w-sm",
                children: actionData?.submitted ? /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $32c03629429003d8$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                            className: "pb-4",
                            children: "If the username or mobile number exists, a reset link has been sent. The link will expire in 15 minutes."
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("p", {
                            children: [
                                "Return to",
                                ' ',
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                    to: "/login",
                                    className: "link link-primary",
                                    children: "Login"
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $c6d33de9e7cf86ac$export$a7fed597f4b8afd8), {
                    className: "space-y-6",
                    method: "post",
                    children: [
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                            children: "Enter your username or mobile number. If there is a valid mobile number associated with your account, you will receive a link to reset your password."
                        }),
                        actionData?.error && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                            className: "py-4 text-red-600",
                            children: "An error occurred while attempting to reset the password. Please try again."
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "form-control",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                    htmlFor: "identifier",
                                    className: "label label-text",
                                    children: "Username or Mobile Number"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                    id: "identifier",
                                    name: "identifier",
                                    type: "text",
                                    autoComplete: "off",
                                    required: true,
                                    className: "w-full input input-sm input-bordered"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                            className: "form-control",
                            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("label", {
                                className: "items-start gap-4 cursor-pointer label justify-normal",
                                children: [
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                        type: "checkbox",
                                        checked: textAllowed,
                                        onChange: (e)=>setTextAllowed(e.target.checked),
                                        className: "checkbox"
                                    }),
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                                        className: "label-text",
                                        children: "I consent to receive text messages from Now In Tandem at the number provided when account was registered."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                                className: "text-white btn btn-primary btn-sm btn-block",
                                name: "form",
                                value: "resetPassword",
                                disabled: !textAllowed,
                                children: "Reset Password"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $2cb6cb94138d78da$export$2e2bcd8739ae039 = $2cb6cb94138d78da$var$ResetPassword;


var $1939ec415e22538b$export$2e2bcd8739ae039 = (0, $2cb6cb94138d78da$export$2e2bcd8739ae039);




var $6uYXW = parcelRequire("6uYXW");
function $7ad3e94562d7bb8d$var$CheckCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $6uYXW.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $6uYXW.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $6uYXW.createElement("path", {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
        clipRule: "evenodd"
    }));
}
const $7ad3e94562d7bb8d$var$ForwardRef = /*#__PURE__*/ $6uYXW.forwardRef($7ad3e94562d7bb8d$var$CheckCircleIcon);
var $7ad3e94562d7bb8d$export$2e2bcd8739ae039 = $7ad3e94562d7bb8d$var$ForwardRef;


var $6uYXW = parcelRequire("6uYXW");
function $a16f5acc06ed292b$var$InformationCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $6uYXW.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $6uYXW.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $6uYXW.createElement("path", {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
        clipRule: "evenodd"
    }));
}
const $a16f5acc06ed292b$var$ForwardRef = /*#__PURE__*/ $6uYXW.forwardRef($a16f5acc06ed292b$var$InformationCircleIcon);
var $a16f5acc06ed292b$export$2e2bcd8739ae039 = $a16f5acc06ed292b$var$ForwardRef;



async function $b3bb5dae2440b0ed$export$f4c5de44377d2946({ request: request }) {
    // TODO do actual programs search
    const url = new URL(request.url);
    const categories = url.searchParams.getAll('category');
    const zipCode = url.searchParams.get('zipCode');
    return {
        categories: categories,
        zipCode: zipCode
    };
}
const $b3bb5dae2440b0ed$var$ServicesRequested = ()=>{
    // eslint-disable-next-line no-unused-vars
    const { categories: categories, zipCode: zipCode } = (0, $88be82bcdaab0750$export$1448a5050d252c4d)();
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "page services-requested",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                className: "sm:mx-auto sm:w-full sm:max-w-sm",
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h2", {
                        children: "Services Requested"
                    }),
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("h4", {
                        children: [
                            "49456 ",
                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("strong", {
                                children: "Muskegon County"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "mt-10 sm:mx-auto sm:w-full sm:max-w-sm",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $c6d33de9e7cf86ac$export$a7fed597f4b8afd8), {
                    method: "get",
                    action: "/register",
                    children: [
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h3", {
                            children: "Final Selections"
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                            children: "Services Cart"
                        }),
                        categories.map((category)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                className: "p-4 mt-6 text-white rounded bg-primary-700",
                                children: [
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                        className: "flex flex-row items-center gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                                className: "block w-8 h-8",
                                                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $7ad3e94562d7bb8d$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                                className: "flex-1 text-lg font-bold",
                                                children: "Mission for Area People"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                        className: "mt-2 font-bold",
                                        children: category
                                    }),
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                        children: "Program 1, Program 2..."
                                    }),
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                        className: "flex flex-row items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                                className: "flex-1 text-xs font-bold",
                                                children: "Eligibility Verified"
                                            }),
                                            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $a16f5acc06ed292b$export$2e2bcd8739ae039), {
                                                    className: "block w-6 h-6"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }, category)),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "mt-6",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                    type: "hidden",
                                    name: "zipCode",
                                    value: zipCode
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                                    className: "text-white btn btn-primary btn-sm btn-block",
                                    children: "Confirm & Continue"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $b3bb5dae2440b0ed$export$2e2bcd8739ae039 = $b3bb5dae2440b0ed$var$ServicesRequested;





var $6uYXW = parcelRequire("6uYXW");



async function $3fee788decfefe38$export$f4c5de44377d2946() {
    const { isSignedIn: isSignedIn } = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e).getState();
    if (!isSignedIn()) return (0, $9a468b9555c2dd85$export$89e12c5b50f7529d)('/login');
    // load hub info for consent text
    const { program: program } = (0, $22bff9b089455983$export$8508f2023dac619).getState();
    if (!program) return (0, $9a468b9555c2dd85$export$89e12c5b50f7529d)('/home');
    else {
        const entity = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get(`/clients/get-hub`, {
            params: {
                hubUrl: program.tags_organization?.find(({ category: category })=>category === 'participating_hub')?.traits?.find(({ name: name })=>name === 'participating_hub_url')?.value
            }
        });
        return entity.data;
    }
}
async function $3fee788decfefe38$export$31eb53bd5b582a97() {
    const { clearApplication: clearApplication, getApplication: getApplication } = (0, $22bff9b089455983$export$8508f2023dac619).getState();
    const { user: user } = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e).getState();
    try {
        await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).post(`/clients/${user.id}/submit-application`, getApplication());
        clearApplication();
        return (0, $9a468b9555c2dd85$export$89e12c5b50f7529d)('/home');
    } catch (err) {
        console.error('Error submitting service request', err);
        return null;
    }
}
const $3fee788decfefe38$var$SubmitRequest = ()=>{
    const entity = (0, $88be82bcdaab0750$export$1448a5050d252c4d)();
    const { program: program, setIdempotencyKey: setIdempotencyKey } = (0, $22bff9b089455983$export$8508f2023dac619)();
    // Stable per submission attempt: generated once when this step mounts so
    // error-retries of the same application reuse it (letting the backend dedupe),
    // while a fresh application gets a new key. The action reads it back off the
    // store via getApplication(), so push it there on mount.
    const idempotencyKey = (0, $6uYXW.useRef)(crypto.randomUUID());
    (0, $6uYXW.useEffect)(()=>{
        setIdempotencyKey(idempotencyKey.current);
    }, [
        setIdempotencyKey
    ]);
    // The loader guarantees a program on entry, but a successful submit clears it
    // and redirects — guard the brief re-render in that window so the unguarded
    // program.locations reads below can't throw.
    if (!program) return null;
    const taxonomyName = program.name;
    const hubName = program?.tags_organization?.find(({ category: category })=>category === 'participating_hub')?.subcategory_display;
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "page submit-request",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "sm:mx-auto sm:w-full sm:max-w-2xl",
                children: "Submit Service Request"
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "sm:mx-auto sm:w-full sm:max-w-2xl",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $c6d33de9e7cf86ac$export$a7fed597f4b8afd8), {
                    method: "post",
                    children: [
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h3", {
                            children: taxonomyName
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                            className: "grid grid-cols-1 gap-4 sm:grid-cols-2",
                            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                children: program?.locations?.[0]?.organization_name
                            })
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "mb-4 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("strong", {
                                    children: "Our purpose:"
                                }),
                                " The ",
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("strong", {
                                    children: hubName
                                }),
                                " was created to support connections to social need services in a manner that: (1) reduces barriers to accessing services, (2) protects privacy of personal information, and (3) strengthen the",
                                ' ',
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("strong", {
                                    children: hubName
                                }),
                                " social care safety net.",
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("strong", {
                                    children: "Our commitment to you:"
                                }),
                                " We are committed to ensuring that you control your personal data. You own all data in your profile and can modify or delete your profile at any time. Identifiable data is only shared upon your request when you apply for services. After you apply for a service, the only information shared with the referring agency is the status and time of status changes your request.",
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("strong", {
                                    children: "Consent to share data:"
                                }),
                                " Today, you are applying for",
                                ' ',
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("strong", {
                                    children: taxonomyName
                                }),
                                " from",
                                ' ',
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("strong", {
                                    children: program.locations[0].organization_name
                                }),
                                ", which requires sharing of the following data:",
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("ul", {
                                    className: "ml-6 list-disc",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("li", {
                                            className: "my-2",
                                            children: [
                                                "To ",
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("strong", {
                                                    children: program.locations[0].organization_name
                                                }),
                                                ", for the purposes of determining your eligibility for the service: Your contact information, account ID, name of referring agency if applicable, application information necessary to determine eligibility, which may include the name of any service-related funding source."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("li", {
                                            className: "my-2",
                                            children: [
                                                "To ",
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("strong", {
                                                    children: entity.entity_name
                                                }),
                                                " for the purposes of CIE intermediary administration, providing additional support if needed, and strengthening of the social care safety-net: First and last name, date of birth, your phone number, your account ID, service agency name, referring agency name, service request, service status changes and dates."
                                            ]
                                        })
                                    ]
                                }),
                                "I hereby request and authorize the exchange of data, as described above, for the purposes described. In doing so, I am aware that I may, without penalty, refuse consent for the exchange of information by any agencies listed. I understand that I can seek additional information about my data, how it is protected, and how it is shared at any time by contacting",
                                ' ',
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("strong", {
                                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("a", {
                                        target: "_blank",
                                        href: entity.hub_org_url,
                                        rel: "noreferrer",
                                        className: "link",
                                        children: entity.hub_org_url
                                    })
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                            children: "Please confirm you would like to submit a request for the service above."
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                            className: "mt-6",
                            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                                type: "submit",
                                className: "btn btn-primary btn-block",
                                children: "Submit Request"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $3fee788decfefe38$export$2e2bcd8739ae039 = $3fee788decfefe38$var$SubmitRequest;


var $4954493d632cd190$export$2e2bcd8739ae039 = (0, $3fee788decfefe38$export$2e2bcd8739ae039);






var $6uYXW = parcelRequire("6uYXW");



const $cfbd53e0340227ce$var$TOU_URL = 'https://nowintandem.com/terms-of-use/';
const $cfbd53e0340227ce$var$PRIVACY_URL = 'https://nowintandem.com/privacy/';
const $cfbd53e0340227ce$var$UpdateReferralStatus = ()=>{
    const tokenLogin = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e)((state)=>state.tokenLogin);
    const verifyUser = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e)((state)=>state.verifyUser);
    // Session id returned by token-login, used to scope subsequent calls.
    const userId = (0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e)((state)=>state.session?.userId);
    const [notAccepted, setNotAccepted] = (0, $6uYXW.useState)(true);
    const [referrals, setReferrals] = (0, $6uYXW.useState)([]);
    const [assessments, setAssessments] = (0, $6uYXW.useState)([]);
    const [statuses, setStatuses] = (0, $6uYXW.useState)({});
    const [needsMet, setNeedsMet] = (0, $6uYXW.useState)({});
    const [saved, setSaved] = (0, $6uYXW.useState)({});
    const [savingId, setSavingId] = (0, $6uYXW.useState)(null);
    const [loading, setLoading] = (0, $6uYXW.useState)(false);
    const [loadError, setLoadError] = (0, $6uYXW.useState)(false);
    // Token-login blocks the UI until it resolves; a failure disables Continue.
    const [authPending, setAuthPending] = (0, $6uYXW.useState)(true);
    const [authError, setAuthError] = (0, $6uYXW.useState)(false);
    const paramsString = window.location.hash.split('?')[1] || '';
    const token = new URLSearchParams(paramsString).get('t');
    // Establish the session through userStore. token-login isn't part of the
    // store's normal flows, so it has its own action; cookie/header setup lives
    // there alongside signIn.
    (0, $6uYXW.useEffect)(()=>{
        let cancelled = false;
        const authenticate = async ()=>{
            if (!token) {
                // No token in the URL. On a refresh, an existing session cookie may
                // survive — verifyUser restores the auth header and loads the user.
                // If that leaves us signed in, skip the accept step.
                await verifyUser();
                if (cancelled) return;
                if ((0, $411dbc53a58dde5c$export$cc885caaa8b7ab4e).getState().isSignedIn()) setNotAccepted(false);
                setAuthPending(false);
                return;
            }
            setAuthPending(true);
            setAuthError(false);
            try {
                await tokenLogin(token);
            } catch  {
                if (!cancelled) setAuthError(true);
            } finally{
                if (!cancelled) setAuthPending(false);
            }
        };
        authenticate();
        return ()=>{
            cancelled = true;
        };
    }, [
        token,
        tokenLogin,
        verifyUser
    ]);
    (0, $6uYXW.useEffect)(()=>{
        if (notAccepted) return;
        let cancelled = false;
        setLoading(true);
        setLoadError(false);
        Promise.all([
            (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get(`/clients/${userId}/followup-requests`).then((res)=>{
                if (!cancelled) setReferrals(res.data);
            }),
            (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get(`/clients/${userId}/needed-assessments`).then((res)=>{
                if (!cancelled) setAssessments(res.data);
            })
        ]).catch(()=>{
            if (!cancelled) setLoadError(true);
        }).finally(()=>{
            if (!cancelled) setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        notAccepted,
        userId
    ]);
    // Group referrals by coordinating agency, sort groups by agency_name,
    // and sort each group's referrals by send_followup_on (soonest first).
    const groups = Object.values(referrals.reduce((acc, referral)=>{
        const agency = referral.coord_agency;
        if (!acc[agency.id]) acc[agency.id] = {
            agency: agency,
            referrals: []
        };
        acc[agency.id].referrals.push(referral);
        return acc;
    }, {})).sort((a, b)=>a.agency.agency_name.localeCompare(b.agency.agency_name)).map((group)=>({
            ...group,
            referrals: group.referrals.slice().sort((a, b)=>new Date(a.send_followup_on) - new Date(b.send_followup_on))
        }));
    // Group assessments by coordinating agency, then by service within each
    // agency. Agencies and services are sorted alphabetically by name.
    const assessmentGroups = Object.values(assessments.reduce((acc, assessment)=>{
        const agencyName = assessment.coord_agency_name;
        if (!acc[agencyName]) acc[agencyName] = {
            agencyName: agencyName,
            services: {}
        };
        const serviceName = assessment.service_name;
        if (!acc[agencyName].services[serviceName]) acc[agencyName].services[serviceName] = {
            serviceName: serviceName,
            assessments: []
        };
        acc[agencyName].services[serviceName].assessments.push(assessment);
        return acc;
    }, {})).sort((a, b)=>a.agencyName.localeCompare(b.agencyName)).map((group)=>({
            ...group,
            services: Object.values(group.services).sort((a, b)=>a.serviceName.localeCompare(b.serviceName))
        }));
    const saveStatus = (referralId)=>{
        const status = statuses[referralId];
        if (!status) return;
        const payload = {
            serviceProvided: status
        };
        // needsMet only applies when the service was provided, and is optional.
        if (status === 'provided' && needsMet[referralId] !== undefined) payload.needsMet = needsMet[referralId];
        setSavingId(referralId);
        (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).post(`/clients/${userId}/followup-response/${referralId}`, payload).then(()=>{
            setSaved((prev)=>({
                    ...prev,
                    [referralId]: true
                }));
            // Let the fade-out play, then drop the referral from the list.
            setTimeout(()=>{
                setReferrals((prev)=>prev.filter((r)=>r.id !== referralId));
            }, 700);
        }).finally(()=>{
            setSavingId(null);
        });
    };
    // Block the UI until token-login resolves.
    if (authPending) return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
        className: "flex justify-center px-4 py-10",
        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
            className: "loading loading-dots loading-lg text-primary"
        })
    });
    if (notAccepted) return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "flex flex-col items-center max-w-md gap-6 px-4 py-10 mx-auto text-center",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $95b38580b50577cd$export$2e2bcd8739ae039), {
                className: "w-auto h-12"
            }),
            !token && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $4bb5f6c4bf3ec124$export$2e2bcd8739ae039), {
                message: "Something went wrong. Please use the link provided to you to access this page."
            }),
            authError && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $4bb5f6c4bf3ec124$export$2e2bcd8739ae039), {
                message: "We couldn\u2019t verify your link. Please use the link provided to you to access this page."
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                className: "mb-2 text-sm",
                children: "By clicking \u201CContinue,\u201D you consent to sharing your personally identifiable information (PII) and, if applicable, protected health information (PHI), in accordance with our Privacy Policy."
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("p", {
                className: "mb-2 text-sm",
                children: [
                    "By clicking \u201CContinue,\u201D you accept the terms of our",
                    ' ',
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("a", {
                        className: "link link-primary",
                        href: $cfbd53e0340227ce$var$TOU_URL,
                        target: "_blank",
                        rel: "noreferrer",
                        children: "Terms of Use"
                    }),
                    ' ',
                    "and",
                    ' ',
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("a", {
                        className: "link link-primary",
                        href: $cfbd53e0340227ce$var$PRIVACY_URL,
                        target: "_blank",
                        rel: "noreferrer",
                        children: "Privacy Policy"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                type: "button",
                className: "text-white btn btn-primary btn-sm btn-block",
                onClick: ()=>setNotAccepted(false),
                disabled: !token || authError,
                children: "Continue"
            })
        ]
    });
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "max-w-3xl px-4 py-6 mx-auto",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h1", {
                className: "mb-4 text-2xl font-bold",
                children: "Items needing your attention"
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h3", {
                className: "mb-2 text-lg font-bold",
                children: "Was Service Provided?"
            }),
            loading && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                className: "mb-2",
                children: "Loading referrals\u2026"
            }),
            loadError && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $4bb5f6c4bf3ec124$export$2e2bcd8739ae039), {
                message: "Something went wrong loading your referrals. Please try again later."
            }),
            !loading && !loadError && groups.length === 0 && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                className: "mb-2",
                children: "There are no referrals that need your attention."
            }),
            groups.map(({ agency: agency, referrals: agencyReferrals })=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                    className: "mb-8",
                    children: [
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h2", {
                            className: "mb-2 text-lg font-semibold",
                            children: agency.agency_name
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("ul", {
                            className: "flex flex-col gap-3",
                            children: agencyReferrals.map((referral)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("li", {
                                    className: `p-4 border rounded-lg border-base-300 transition-opacity duration-700 ease-out ${saved[referral.id] ? 'opacity-0' : 'opacity-100'}`,
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                            className: "font-medium",
                                            children: referral.taxonomy_detail
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                            className: "text-sm opacity-70",
                                            children: [
                                                "Follow-up by",
                                                ' ',
                                                new Date(referral.send_followup_on).toLocaleDateString()
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                            className: "flex flex-col gap-3 mt-3 sm:flex-row sm:items-end",
                                            children: [
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("label", {
                                                    className: "flex flex-col gap-1 grow",
                                                    children: [
                                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                                                            className: "text-sm",
                                                            children: "Was service provided?"
                                                        }),
                                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("select", {
                                                            "aria-label": "Was service provided?",
                                                            className: "w-full select select-bordered select-sm",
                                                            value: statuses[referral.id] ?? '',
                                                            disabled: saved[referral.id],
                                                            onChange: ({ target: target })=>{
                                                                setStatuses((prev)=>({
                                                                        ...prev,
                                                                        [referral.id]: target.value
                                                                    }));
                                                                // needsMet only applies to "provided"; clear it otherwise.
                                                                if (target.value !== 'provided') setNeedsMet((prev)=>({
                                                                        ...prev,
                                                                        [referral.id]: undefined
                                                                    }));
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true
                                                                }),
                                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                                    value: "provided",
                                                                    children: "Service was provided"
                                                                }),
                                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                                    value: "not_provided",
                                                                    children: "Service was not provided"
                                                                }),
                                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                                    value: "waiting",
                                                                    children: "Waiting for service to be provided"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("label", {
                                                    className: "flex flex-col gap-1 sm:w-40",
                                                    children: [
                                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("span", {
                                                            className: "text-sm",
                                                            children: [
                                                                "Were needs met?",
                                                                statuses[referral.id] === 'provided' && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("span", {
                                                                    className: "ml-0.5 text-error",
                                                                    children: "*"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("select", {
                                                            "aria-label": "Were needs met?",
                                                            className: "w-full select select-bordered select-sm",
                                                            value: needsMet[referral.id] === undefined ? '' : String(needsMet[referral.id]),
                                                            disabled: statuses[referral.id] !== 'provided' || saved[referral.id],
                                                            onChange: ({ target: target })=>setNeedsMet((prev)=>({
                                                                        ...prev,
                                                                        [referral.id]: target.value === '' ? undefined : target.value === 'true'
                                                                    })),
                                                            children: [
                                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                                    value: ""
                                                                }),
                                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                                    value: "true",
                                                                    children: "Yes"
                                                                }),
                                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                                                    value: "false",
                                                                    children: "No"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "text-white btn btn-primary btn-sm sm:w-auto",
                                                    disabled: !statuses[referral.id] || // "Were needs met?" is required once service is marked provided.
                                                    statuses[referral.id] === 'provided' && needsMet[referral.id] === undefined || savingId === referral.id || saved[referral.id],
                                                    onClick: ()=>saveStatus(referral.id),
                                                    children: saved[referral.id] ? 'Saved' : 'Save'
                                                })
                                            ]
                                        })
                                    ]
                                }, referral.id))
                        })
                    ]
                }, agency.id)),
            assessments.length > 0 && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $32c03629429003d8$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h3", {
                        className: "mt-4 mb-2 text-lg font-bold",
                        children: "Assessments to Complete"
                    }),
                    !loading && !loadError && assessments.length === 0 && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                        className: "mb-2",
                        children: "There are no assessments that need your attention."
                    }),
                    !loading && !loadError && assessments.length > 0 && /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                        className: "mb-8",
                        children: assessmentGroups.map((group)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                className: "mb-6",
                                children: [
                                    /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h4", {
                                        className: "mb-2 text-lg font-semibold",
                                        children: group.agencyName
                                    }),
                                    group.services.map((service)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                                            className: "mb-4",
                                            children: [
                                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h5", {
                                                    className: "mb-2 text-base font-medium",
                                                    children: service.serviceName
                                                }),
                                                service.assessments.map((assessment)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                                                        className: "mb-2",
                                                        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$a6c7ac8248d6e38a), {
                                                            className: "btn btn-primary btn-block",
                                                            to: `/assessments/${assessment.care_quest_group_id}`,
                                                            state: {
                                                                from: '/cca'
                                                            },
                                                            children: assessment.name
                                                        })
                                                    }, assessment.care_quest_group_id))
                                            ]
                                        }, service.serviceName))
                                ]
                            }, group.agencyName))
                    })
                ]
            })
        ]
    });
};
var $cfbd53e0340227ce$export$2e2bcd8739ae039 = $cfbd53e0340227ce$var$UpdateReferralStatus;






var $6uYXW = parcelRequire("6uYXW");

function $91c22d8087e5861f$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    function memoizedFunction() {
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    }
    memoizedFunction.updateDeps = (newDeps)=>{
        deps = newDeps;
    };
    return memoizedFunction;
}
function $91c22d8087e5861f$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $91c22d8087e5861f$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1.01;
const $91c22d8087e5861f$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
    let timeoutId;
    return function(...args) {
        targetWindow.clearTimeout(timeoutId);
        timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
    };
};


const $719435c28c68fa2b$var$getRect = (element)=>{
    const { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = element;
    return {
        width: offsetWidth,
        height: offsetHeight
    };
};
const $719435c28c68fa2b$export$76974b428a49f15b = (index)=>index;
const $719435c28c68fa2b$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $719435c28c68fa2b$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler($719435c28c68fa2b$var$getRect(element));
    if (!targetWindow.ResizeObserver) return ()=>{};
    const observer = new targetWindow.ResizeObserver((entries)=>{
        const run = ()=>{
            const entry = entries[0];
            if (entry == null ? void 0 : entry.borderBoxSize) {
                const box = entry.borderBoxSize[0];
                if (box) {
                    handler({
                        width: box.inlineSize,
                        height: box.blockSize
                    });
                    return;
                }
            }
            handler($719435c28c68fa2b$var$getRect(element));
        };
        instance.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $719435c28c68fa2b$var$addEventListenerOptions = {
    passive: true
};
const $719435c28c68fa2b$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $719435c28c68fa2b$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $719435c28c68fa2b$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $719435c28c68fa2b$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = instance.options.useScrollendEvent && $719435c28c68fa2b$var$supportsScrollend ? ()=>void 0 : (0, $91c22d8087e5861f$export$61fc7d43ac8f84b0)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            const { horizontal: horizontal, isRtl: isRtl } = instance.options;
            offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $719435c28c68fa2b$var$addEventListenerOptions);
    const registerScrollendEvent = instance.options.useScrollendEvent && $719435c28c68fa2b$var$supportsScrollend;
    if (registerScrollendEvent) element.addEventListener("scrollend", endHandler, $719435c28c68fa2b$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        if (registerScrollendEvent) element.removeEventListener("scrollend", endHandler);
    };
};
const $719435c28c68fa2b$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = instance.options.useScrollendEvent && $719435c28c68fa2b$var$supportsScrollend ? ()=>void 0 : (0, $91c22d8087e5861f$export$61fc7d43ac8f84b0)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $719435c28c68fa2b$var$addEventListenerOptions);
    const registerScrollendEvent = instance.options.useScrollendEvent && $719435c28c68fa2b$var$supportsScrollend;
    if (registerScrollendEvent) element.addEventListener("scrollend", endHandler, $719435c28c68fa2b$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        if (registerScrollendEvent) element.removeEventListener("scrollend", endHandler);
    };
};
const $719435c28c68fa2b$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return element[instance.options.horizontal ? "offsetWidth" : "offsetHeight"];
};
const $719435c28c68fa2b$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $719435c28c68fa2b$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $719435c28c68fa2b$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.targetWindow = null;
        this.isScrolling = false;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollRect = null;
        this.scrollOffset = null;
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.elementsCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        const run = ()=>{
                            this._measureElement(entry.target, entry);
                        };
                        this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
                    });
                });
            };
            return {
                disconnect: ()=>{
                    var _a;
                    (_a = get()) == null || _a.disconnect();
                    _ro = null;
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $719435c28c68fa2b$export$76974b428a49f15b,
                rangeExtractor: $719435c28c68fa2b$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $719435c28c68fa2b$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                isScrollingResetDelay: 150,
                enabled: true,
                isRtl: false,
                useScrollendEvent: false,
                useAnimationFrameWithResizeObserver: false,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $91c22d8087e5861f$export$7c73462e0d25e514)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.observer.disconnect();
            this.scrollElement = null;
            this.targetWindow = null;
        };
        this._didMount = ()=>{
            return ()=>{
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            var _a;
            const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                if (!scrollElement) {
                    this.maybeNotify();
                    return;
                }
                this.scrollElement = scrollElement;
                if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                this.elementsCache.forEach((cached)=>{
                    this.observer.observe(cached);
                });
                this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    this.isScrolling = isScrolling;
                    this.maybeNotify();
                }));
            }
        };
        this.getSize = ()=>{
            if (!this.options.enabled) {
                this.scrollRect = null;
                return 0;
            }
            this.scrollRect = this.scrollRect ?? this.options.initialRect;
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getScrollOffset = ()=>{
            if (!this.options.enabled) {
                this.scrollOffset = null;
                return 0;
            }
            this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
            return this.scrollOffset;
        };
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurementOptions = (0, $91c22d8087e5861f$export$7c73462e0d25e514)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey,
                this.options.enabled
            ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey,
                enabled: enabled
            };
        }, {
            key: false
        });
        this.getMeasurements = (0, $91c22d8087e5861f$export$7c73462e0d25e514)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
            if (!enabled) {
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                return [];
            }
            if (this.measurementsCache.length === 0) {
                this.measurementsCache = this.options.initialMeasurementsCache;
                this.measurementsCache.forEach((item)=>{
                    this.itemSizeCache.set(item.key, item.size);
                });
            }
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $91c22d8087e5861f$export$7c73462e0d25e514)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.getScrollOffset(),
                this.options.lanes
            ], (measurements, outerSize, scrollOffset, lanes)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $719435c28c68fa2b$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset,
                lanes: lanes
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualIndexes = (0, $91c22d8087e5861f$export$7c73462e0d25e514)(()=>{
            let startIndex = null;
            let endIndex = null;
            const range = this.calculateRange();
            if (range) {
                startIndex = range.startIndex;
                endIndex = range.endIndex;
            }
            this.maybeNotify.updateDeps([
                this.isScrolling,
                startIndex,
                endIndex
            ]);
            return [
                this.options.rangeExtractor,
                this.options.overscan,
                this.options.count,
                startIndex,
                endIndex
            ];
        }, (rangeExtractor, overscan, count, startIndex, endIndex)=>{
            return startIndex === null || endIndex === null ? [] : rangeExtractor({
                startIndex: startIndex,
                endIndex: endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const index = this.indexFromElement(node);
            const item = this.measurementsCache[index];
            if (!item) return;
            const key = item.key;
            const prevNode = this.elementsCache.get(key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.elementsCache.set(key, node);
            }
            if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
        };
        this.resizeItem = (index, size)=>{
            const item = this.measurementsCache[index];
            if (!item) return;
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) {
                this.elementsCache.forEach((cached, key)=>{
                    if (!cached.isConnected) {
                        this.observer.unobserve(cached);
                        this.elementsCache.delete(key);
                    }
                });
                return;
            }
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $91c22d8087e5861f$export$7c73462e0d25e514)(()=>[
                this.getVirtualIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            if (measurements.length === 0) return void 0;
            return (0, $91c22d8087e5861f$export$9a1adf421b69c6a)(measurements[$719435c28c68fa2b$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $91c22d8087e5861f$export$9a1adf421b69c6a)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align, itemSize = 0)=>{
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") align = toOffset >= scrollOffset + size ? "end" : "start";
            if (align === "center") toOffset += (itemSize - size) / 2;
            else if (align === "end") toOffset -= size;
            const maxOffset = this.getTotalSize() + this.options.scrollMargin - size;
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const item = this.measurementsCache[index];
            if (!item) return void 0;
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align, item.size),
                align
            ];
        };
        this.isDynamicMode = ()=>this.elementsCache.size > 0;
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            index = Math.max(0, Math.min(index, this.options.count - 1));
            let attempts = 0;
            const maxAttempts = 10;
            const tryScroll = (currentAlign)=>{
                if (!this.targetWindow) return;
                const offsetInfo = this.getOffsetForIndex(index, currentAlign);
                if (!offsetInfo) {
                    console.warn("Failed to get offset for index:", index);
                    return;
                }
                const [offset, align] = offsetInfo;
                this._scrollToOffset(offset, {
                    adjustments: void 0,
                    behavior: behavior
                });
                this.targetWindow.requestAnimationFrame(()=>{
                    const currentOffset = this.getScrollOffset();
                    const afterInfo = this.getOffsetForIndex(index, align);
                    if (!afterInfo) {
                        console.warn("Failed to get offset for index:", index);
                        return;
                    }
                    if (!(0, $91c22d8087e5861f$export$8a4f1dcc58a69dbd)(afterInfo[0], currentOffset)) scheduleRetry(align);
                });
            };
            const scheduleRetry = (align)=>{
                if (!this.targetWindow) return;
                attempts++;
                if (attempts < maxAttempts) this.targetWindow.requestAnimationFrame(()=>tryScroll(align));
                else console.warn(`Failed to scroll to index ${index} after ${maxAttempts} attempts.`);
            };
            tryScroll(initialAlign);
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getScrollOffset() + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else if (this.options.lanes === 1) end = ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0;
            else {
                const endByLane = Array(this.options.lanes).fill(null);
                let endIndex = measurements.length - 1;
                while(endIndex >= 0 && endByLane.some((val)=>val === null)){
                    const item = measurements[endIndex];
                    if (endByLane[item.lane] === null) endByLane[item.lane] = item.end;
                    endIndex--;
                }
                end = Math.max(...endByLane.filter((val)=>val !== null));
            }
            return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
    }
}
const $719435c28c68fa2b$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $719435c28c68fa2b$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset, lanes: lanes }) {
    const lastIndex = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    if (measurements.length <= lanes) return {
        startIndex: 0,
        endIndex: lastIndex
    };
    let startIndex = $719435c28c68fa2b$var$findNearestBinarySearch(0, lastIndex, getOffset, scrollOffset);
    let endIndex = startIndex;
    if (lanes === 1) while(endIndex < lastIndex && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    else if (lanes > 1) {
        const endPerLane = Array(lanes).fill(0);
        while(endIndex < lastIndex && endPerLane.some((pos)=>pos < scrollOffset + outerSize)){
            const item = measurements[endIndex];
            endPerLane[item.lane] = item.end;
            endIndex++;
        }
        const startPerLane = Array(lanes).fill(scrollOffset + outerSize);
        while(startIndex >= 0 && startPerLane.some((pos)=>pos >= scrollOffset)){
            const item = measurements[startIndex];
            startPerLane[item.lane] = item.start;
            startIndex--;
        }
        startIndex = Math.max(0, startIndex - startIndex % lanes);
        endIndex = Math.min(lastIndex, endIndex + (lanes - 1 - endIndex % lanes));
    }
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}


const $8cfcd9d89fc43033$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $6uYXW.useLayoutEffect : $6uYXW.useEffect;
function $8cfcd9d89fc43033$var$useVirtualizerBase(options) {
    const rerender = $6uYXW.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $4e60b4008b7e4540$exports.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $6uYXW.useState(()=>new (0, $719435c28c68fa2b$export$89be5a243e59c4b2)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $8cfcd9d89fc43033$var$useIsomorphicLayoutEffect(()=>{
        return instance._didMount();
    }, []);
    $8cfcd9d89fc43033$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $8cfcd9d89fc43033$export$dd6d526d88b5a137(options) {
    return $8cfcd9d89fc43033$var$useVirtualizerBase({
        observeElementRect: $719435c28c68fa2b$export$5a50ff2cde8c3802,
        observeElementOffset: $719435c28c68fa2b$export$fbc040aee017375a,
        scrollToFn: (0, $719435c28c68fa2b$export$1cdb988e5ab69fe7),
        ...options
    });
}
function $8cfcd9d89fc43033$export$645722dcac657cb9(options) {
    return $8cfcd9d89fc43033$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $719435c28c68fa2b$export$e911b82c7a99311),
        observeElementOffset: (0, $719435c28c68fa2b$export$518998f8c5d09287),
        scrollToFn: (0, $719435c28c68fa2b$export$2162c5b3eeedd27),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}



var $6uYXW = parcelRequire("6uYXW");



var $6uYXW = parcelRequire("6uYXW");
function $ce7f6e9fecd912cf$var$l(e, r) {
    return e !== null && r !== null && typeof e == "object" && typeof r == "object" && "id" in e && "id" in r ? e.id === r.id : e === r;
}
function $ce7f6e9fecd912cf$export$988f0cf1b37580ae(e = $ce7f6e9fecd912cf$var$l) {
    return (0, $6uYXW.useCallback)((r, t)=>{
        if (typeof e == "string") {
            let o = e;
            return (r == null ? void 0 : r[o]) === (t == null ? void 0 : t[o]);
        }
        return e(r, t);
    }, [
        e
    ]);
}



var $6uYXW = parcelRequire("6uYXW");


function $f2aeeeb2298b30fa$export$454217e89aea72b(l, r, c) {
    let [i, s] = (0, $6uYXW.useState)(c), e = l !== void 0, t = (0, $6uYXW.useRef)(e), u = (0, $6uYXW.useRef)(!1), d = (0, $6uYXW.useRef)(!1);
    return e && !t.current && !u.current ? (u.current = !0, t.current = e, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !e && t.current && !d.current && (d.current = !0, t.current = e, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [
        e ? l : i,
        (0, $555339916ec7fe05$export$90fc3a17d93f704c)((n)=>(e || (0, $4e60b4008b7e4540$exports.flushSync)(()=>s(n)), r == null ? void 0 : r(n)))
    ];
}



var $6uYXW = parcelRequire("6uYXW");
function $c3bdecb35deebfe6$export$8a91ee242b6d0fe3(e) {
    let [t] = (0, $6uYXW.useState)(e);
    return t;
}







var $6uYXW = parcelRequire("6uYXW");








var $6uYXW = parcelRequire("6uYXW");




var $6uYXW = parcelRequire("6uYXW");

function $75e06f6152a4f511$export$7080b3e976bc91ab(n, e, a, t) {
    let i = (0, $45cf98b6ba6e8cbc$export$86c4283a11f23f95)(a);
    (0, $6uYXW.useEffect)(()=>{
        n = n != null ? n : window;
        function r(o) {
            i.current(o);
        }
        return n.addEventListener(e, r, t), ()=>n.removeEventListener(e, r, t);
    }, [
        n,
        e,
        t
    ]);
}


function $a6bf46fab05f7d2b$export$9b49488873640feb(e) {
    let l = (0, $6uYXW.useRef)({
        value: "",
        selectionStart: null,
        selectionEnd: null
    });
    return (0, $75e06f6152a4f511$export$7080b3e976bc91ab)(e, "blur", (n)=>{
        let t = n.target;
        $36c2319598bace40$export$88a6ceeed5737ba3(t) && (l.current = {
            value: t.value,
            selectionStart: t.selectionStart,
            selectionEnd: t.selectionEnd
        });
    }), (0, $555339916ec7fe05$export$90fc3a17d93f704c)(()=>{
        if (!(0, $d76c946db081c9ef$export$8a2eb51c14bb8899)(e) && $36c2319598bace40$export$88a6ceeed5737ba3(e) && e.isConnected) {
            if (e.focus({
                preventScroll: !0
            }), e.value !== l.current.value) e.setSelectionRange(e.value.length, e.value.length);
            else {
                let { selectionStart: n, selectionEnd: t } = l.current;
                n !== null && t !== null && e.setSelectionRange(n, t);
            }
            l.current = {
                value: "",
                selectionStart: null,
                selectionEnd: null
            };
        }
    });
}










var $6uYXW = parcelRequire("6uYXW");

function $632ad4b12ba452f9$export$3c773aa2b84f29e0(u, t) {
    let e = (0, $6uYXW.useRef)([]), r = (0, $555339916ec7fe05$export$90fc3a17d93f704c)(u);
    (0, $6uYXW.useEffect)(()=>{
        let o = [
            ...e.current
        ];
        for (let [a, l] of t.entries())if (e.current[a] !== l) {
            let n = r(t, o);
            return e.current = t, n;
        }
    }, [
        r,
        ...t
    ]);
}





var $6uYXW = parcelRequire("6uYXW");



var $6uYXW = parcelRequire("6uYXW");
function $744a8ca406c1dda2$export$bc22b3e852574dab(t = {}, i = null, n = []) {
    for (let [e, o] of Object.entries(t))$744a8ca406c1dda2$var$s(n, $744a8ca406c1dda2$var$r(i, e), o);
    return n;
}
function $744a8ca406c1dda2$var$r(t, i) {
    return t ? t + "[" + i + "]" : i;
}
function $744a8ca406c1dda2$var$s(t, i, n) {
    if (Array.isArray(n)) for (let [e, o] of n.entries())$744a8ca406c1dda2$var$s(t, $744a8ca406c1dda2$var$r(i, e.toString()), o);
    else n instanceof Date ? t.push([
        i,
        n.toISOString()
    ]) : typeof n == "boolean" ? t.push([
        i,
        n ? "1" : "0"
    ]) : typeof n == "string" ? t.push([
        i,
        n
    ]) : typeof n == "number" ? t.push([
        i,
        `${n}`
    ]) : n == null ? t.push([
        i,
        ""
    ]) : $744a8ca406c1dda2$var$c(n) && !(0, $6uYXW.isValidElement)(n) && $744a8ca406c1dda2$export$bc22b3e852574dab(n, i, t);
}
function $744a8ca406c1dda2$export$ee02894bdc79dd36(t) {
    var n, e;
    let i = (n = t == null ? void 0 : t.form) != null ? n : t.closest("form");
    if (i) {
        for (let o of i.elements)if (o !== t && (o.tagName === "INPUT" && o.type === "submit" || o.tagName === "BUTTON" && o.type === "submit" || o.nodeName === "INPUT" && o.type === "image")) {
            o.click();
            return;
        }
        (e = i.requestSubmit) == null || e.call(i);
    }
}
function $744a8ca406c1dda2$var$c(t) {
    if (Object.prototype.toString.call(t) !== "[object Object]") return !1;
    let i = Object.getPrototypeOf(t);
    return i === null || Object.getPrototypeOf(i) === null;
}




let $b235cdee777a7e14$var$a = "span";
var $b235cdee777a7e14$export$4e7f8864c6a16d8a = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))($b235cdee777a7e14$export$4e7f8864c6a16d8a || {});
function $b235cdee777a7e14$var$l(t, r) {
    var n;
    let { features: d = 1, ...e } = t, o = {
        ref: r,
        "aria-hidden": (d & 2) === 2 ? !0 : (n = e["aria-hidden"]) != null ? n : void 0,
        hidden: (d & 4) === 4 ? !0 : void 0,
        style: {
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0",
            ...(d & 4) === 4 && (d & 2) !== 2 && {
                display: "none"
            }
        }
    };
    return (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)()({
        ourProps: o,
        theirProps: e,
        slot: {},
        defaultTag: $b235cdee777a7e14$var$a,
        name: "Hidden"
    });
}
let $b235cdee777a7e14$export$8dc98ba7eadeaa56 = (0, $513e46b2b02099d5$export$e43f39796049410c)($b235cdee777a7e14$var$l);


let $424dcb7e2c168caf$var$f = (0, $6uYXW.createContext)(null);
function $424dcb7e2c168caf$export$172bce5caea3d96f(t) {
    let [e, r] = (0, $6uYXW.useState)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($424dcb7e2c168caf$var$f.Provider, {
        value: {
            target: e
        }
    }, t.children, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $b235cdee777a7e14$export$8dc98ba7eadeaa56), {
        features: (0, $b235cdee777a7e14$export$4e7f8864c6a16d8a).Hidden,
        ref: r
    }));
}
function $424dcb7e2c168caf$export$ddeacde93f925346({ children: t }) {
    let e = (0, $6uYXW.useContext)($424dcb7e2c168caf$var$f);
    if (!e) return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Fragment, null, t);
    let { target: r } = e;
    return r ? (0, $4e60b4008b7e4540$exports.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Fragment, null, t), r) : null;
}
function $424dcb7e2c168caf$export$125d0b248abd3e88({ data: t, form: e, disabled: r, onReset: n, overrides: F }) {
    let [i, a] = (0, $6uYXW.useState)(null), p = (0, $550b4821e7e353bd$export$fd183955ff4b45d9)();
    return (0, $6uYXW.useEffect)(()=>{
        if (n && i) return p.addEventListener(i, "reset", n);
    }, [
        i,
        e,
        n
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($424dcb7e2c168caf$export$ddeacde93f925346, null, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($424dcb7e2c168caf$var$C, {
        setForm: a,
        formId: e
    }), (0, $744a8ca406c1dda2$export$bc22b3e852574dab)(t).map(([s, v])=>(0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $b235cdee777a7e14$export$8dc98ba7eadeaa56), {
            features: (0, $b235cdee777a7e14$export$4e7f8864c6a16d8a).Hidden,
            ...(0, $513e46b2b02099d5$export$8e16b83750b44988)({
                key: s,
                as: "input",
                type: "hidden",
                hidden: !0,
                readOnly: !0,
                form: e,
                disabled: r,
                name: s,
                value: v,
                ...F
            })
        })));
}
function $424dcb7e2c168caf$var$C({ setForm: t, formId: e }) {
    return (0, $6uYXW.useEffect)(()=>{
        if (e) {
            let r = document.getElementById(e);
            r && t(r);
        }
    }, [
        t,
        e
    ]), e ? null : (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $b235cdee777a7e14$export$8dc98ba7eadeaa56), {
        features: (0, $b235cdee777a7e14$export$4e7f8864c6a16d8a).Hidden,
        as: "input",
        type: "hidden",
        hidden: !0,
        readOnly: !0,
        ref: (r)=>{
            if (!r) return;
            let n = r.closest("form");
            n && t(n);
        }
    });
}



var $6uYXW = parcelRequire("6uYXW");
function $fc694889197a235d$var$f({ children: t, freeze: e }, o) {
    let n = $fc694889197a235d$export$1a771eb6e04a3c48(e, t);
    return (0, $6uYXW.isValidElement)(n) ? (0, $6uYXW.cloneElement)(n, {
        ref: o
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).Fragment, null, n);
}
const $fc694889197a235d$export$824932a86c309819 = (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).forwardRef($fc694889197a235d$var$f);
function $fc694889197a235d$export$1a771eb6e04a3c48(t, e) {
    let [o, n] = (0, $6uYXW.useState)(e);
    return !t && o !== e && n(e), t ? o : e;
}






function $7cb8d403b53f4a1b$export$a6a2315df743a26b(n) {
    function e() {
        document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
    }
    typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e), e());
}




let $f722e72b68b17510$export$55abd4691b317664 = [];
(0, $7cb8d403b53f4a1b$export$a6a2315df743a26b)(()=>{
    function e(t) {
        if (!$36c2319598bace40$export$79c619c6018bbb44(t.target) || t.target === document.body || $f722e72b68b17510$export$55abd4691b317664[0] === t.target) return;
        let r = t.target;
        r = r.closest((0, $fbf026b0a7ade674$export$acea64b1933eb668)), $f722e72b68b17510$export$55abd4691b317664.unshift(r != null ? r : t.target), $f722e72b68b17510$export$55abd4691b317664 = $f722e72b68b17510$export$55abd4691b317664.filter((o)=>o != null && o.isConnected), $f722e72b68b17510$export$55abd4691b317664.splice(10);
    }
    window.addEventListener("click", e, {
        capture: !0
    }), window.addEventListener("mousedown", e, {
        capture: !0
    }), window.addEventListener("focus", e, {
        capture: !0
    }), document.body.addEventListener("click", e, {
        capture: !0
    }), document.body.addEventListener("mousedown", e, {
        capture: !0
    }), document.body.addEventListener("focus", e, {
        capture: !0
    });
});




















var $580522ebc73c41ee$var$I = Object.defineProperty;
var $580522ebc73c41ee$var$h = (t, i, e)=>i in t ? $580522ebc73c41ee$var$I(t, i, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : t[i] = e;
var $580522ebc73c41ee$var$f = (t, i, e)=>($580522ebc73c41ee$var$h(t, typeof i != "symbol" ? i + "" : i, e), e);
var $580522ebc73c41ee$export$9e9981e79183c56e = ((e)=>(e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))($580522ebc73c41ee$export$9e9981e79183c56e || {}), $580522ebc73c41ee$export$4f91e9fa174f3aa = ((e)=>(e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))($580522ebc73c41ee$export$4f91e9fa174f3aa || {}), $580522ebc73c41ee$export$604fb2d029447fbb = ((n)=>(n[n.Pointer = 0] = "Pointer", n[n.Focus = 1] = "Focus", n[n.Other = 2] = "Other", n))($580522ebc73c41ee$export$604fb2d029447fbb || {}), $580522ebc73c41ee$export$1385d81a6c6bbcd4 = ((l)=>(l[l.OpenCombobox = 0] = "OpenCombobox", l[l.CloseCombobox = 1] = "CloseCombobox", l[l.GoToOption = 2] = "GoToOption", l[l.SetTyping = 3] = "SetTyping", l[l.RegisterOption = 4] = "RegisterOption", l[l.UnregisterOption = 5] = "UnregisterOption", l[l.DefaultToFirstOption = 6] = "DefaultToFirstOption", l[l.SetActivationTrigger = 7] = "SetActivationTrigger", l[l.UpdateVirtualConfiguration = 8] = "UpdateVirtualConfiguration", l[l.SetInputElement = 9] = "SetInputElement", l[l.SetButtonElement = 10] = "SetButtonElement", l[l.SetOptionsElement = 11] = "SetOptionsElement", l[l.MarkInputAsMoved = 12] = "MarkInputAsMoved", l))($580522ebc73c41ee$export$1385d81a6c6bbcd4 || {});
function $580522ebc73c41ee$var$v(t, i = (e)=>e) {
    let e = t.activeOptionIndex !== null ? t.options[t.activeOptionIndex] : null, n = i(t.options.slice()), o = n.length > 0 && n[0].dataRef.current.order !== null ? n.sort((u, a)=>u.dataRef.current.order - a.dataRef.current.order) : (0, $fbf026b0a7ade674$export$20305e96f91bf103)(n, (u)=>u.dataRef.current.domRef.current), r = e ? o.indexOf(e) : null;
    return r === -1 && (r = null), {
        options: o,
        activeOptionIndex: r
    };
}
let $580522ebc73c41ee$var$j = {
    [1] (t) {
        var e;
        if ((e = t.dataRef.current) != null && e.disabled || t.comboboxState === 1) return t;
        let i = t.inputElement ? (0, $4efd704abd02a8a5$export$6e185a5347a09ebe).Tracked((0, $4efd704abd02a8a5$export$988ea8227f238095)(t.inputElement)) : t.inputPositionState;
        return {
            ...t,
            activeOptionIndex: null,
            comboboxState: 1,
            isTyping: !1,
            activationTrigger: 2,
            inputPositionState: i,
            __demoMode: !1
        };
    },
    [0] (t) {
        var i, e;
        if ((i = t.dataRef.current) != null && i.disabled || t.comboboxState === 0) return t;
        if ((e = t.dataRef.current) != null && e.value) {
            let n = t.dataRef.current.calculateIndex(t.dataRef.current.value);
            if (n !== -1) return {
                ...t,
                activeOptionIndex: n,
                comboboxState: 0,
                __demoMode: !1,
                inputPositionState: (0, $4efd704abd02a8a5$export$6e185a5347a09ebe).Idle
            };
        }
        return {
            ...t,
            comboboxState: 0,
            inputPositionState: (0, $4efd704abd02a8a5$export$6e185a5347a09ebe).Idle,
            __demoMode: !1
        };
    },
    [3] (t, i) {
        return t.isTyping === i.isTyping ? t : {
            ...t,
            isTyping: i.isTyping
        };
    },
    [2] (t, i) {
        var r, u, a, s;
        if ((r = t.dataRef.current) != null && r.disabled || t.optionsElement && !((u = t.dataRef.current) != null && u.optionsPropsRef.current.static) && t.comboboxState === 1) return t;
        if (t.virtual) {
            let { options: p, disabled: c } = t.virtual, m = i.focus === (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Specific ? i.idx : (0, $fd8c7f19da8b319f$export$c6b4626b54936d5e)(i, {
                resolveItems: ()=>p,
                resolveActiveIndex: ()=>{
                    var l, x;
                    return (x = (l = t.activeOptionIndex) != null ? l : p.findIndex((S)=>!c(S))) != null ? x : null;
                },
                resolveDisabled: c,
                resolveId () {
                    throw new Error("Function not implemented.");
                }
            }), b = (a = i.trigger) != null ? a : 2;
            return t.activeOptionIndex === m && t.activationTrigger === b ? t : {
                ...t,
                activeOptionIndex: m,
                activationTrigger: b,
                isTyping: !1,
                __demoMode: !1
            };
        }
        let e = $580522ebc73c41ee$var$v(t);
        if (e.activeOptionIndex === null) {
            let p = e.options.findIndex((c)=>!c.dataRef.current.disabled);
            p !== -1 && (e.activeOptionIndex = p);
        }
        let n = i.focus === (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Specific ? i.idx : (0, $fd8c7f19da8b319f$export$c6b4626b54936d5e)(i, {
            resolveItems: ()=>e.options,
            resolveActiveIndex: ()=>e.activeOptionIndex,
            resolveId: (p)=>p.id,
            resolveDisabled: (p)=>p.dataRef.current.disabled
        }), o = (s = i.trigger) != null ? s : 2;
        return t.activeOptionIndex === n && t.activationTrigger === o ? t : {
            ...t,
            ...e,
            isTyping: !1,
            activeOptionIndex: n,
            activationTrigger: o,
            __demoMode: !1
        };
    },
    [4]: (t, i)=>{
        var r, u, a, s;
        if ((r = t.dataRef.current) != null && r.virtual) return {
            ...t,
            options: [
                ...t.options,
                i.payload
            ]
        };
        let e = i.payload, n = $580522ebc73c41ee$var$v(t, (p)=>(p.push(e), p));
        t.activeOptionIndex === null && (a = (u = t.dataRef.current).isSelected) != null && a.call(u, i.payload.dataRef.current.value) && (n.activeOptionIndex = n.options.indexOf(e));
        let o = {
            ...t,
            ...n,
            activationTrigger: 2
        };
        return (s = t.dataRef.current) != null && s.__demoMode && t.dataRef.current.value === void 0 && (o.activeOptionIndex = 0), o;
    },
    [5]: (t, i)=>{
        var n;
        if ((n = t.dataRef.current) != null && n.virtual) return {
            ...t,
            options: t.options.filter((o)=>o.id !== i.id)
        };
        let e = $580522ebc73c41ee$var$v(t, (o)=>{
            let r = o.findIndex((u)=>u.id === i.id);
            return r !== -1 && o.splice(r, 1), o;
        });
        return {
            ...t,
            ...e,
            activationTrigger: 2
        };
    },
    [6]: (t, i)=>t.defaultToFirstOption === i.value ? t : {
            ...t,
            defaultToFirstOption: i.value
        },
    [7]: (t, i)=>t.activationTrigger === i.trigger ? t : {
            ...t,
            activationTrigger: i.trigger
        },
    [8]: (t, i)=>{
        var n, o;
        if (t.virtual === null) return {
            ...t,
            virtual: {
                options: i.options,
                disabled: (n = i.disabled) != null ? n : ()=>!1
            }
        };
        if (t.virtual.options === i.options && t.virtual.disabled === i.disabled) return t;
        let e = t.activeOptionIndex;
        if (t.activeOptionIndex !== null) {
            let r = i.options.indexOf(t.virtual.options[t.activeOptionIndex]);
            r !== -1 ? e = r : e = null;
        }
        return {
            ...t,
            activeOptionIndex: e,
            virtual: {
                options: i.options,
                disabled: (o = i.disabled) != null ? o : ()=>!1
            }
        };
    },
    [9]: (t, i)=>t.inputElement === i.element ? t : {
            ...t,
            inputElement: i.element
        },
    [10]: (t, i)=>t.buttonElement === i.element ? t : {
            ...t,
            buttonElement: i.element
        },
    [11]: (t, i)=>t.optionsElement === i.element ? t : {
            ...t,
            optionsElement: i.element
        },
    [12] (t) {
        return t.inputPositionState.kind !== "Tracked" ? t : {
            ...t,
            inputPositionState: (0, $4efd704abd02a8a5$export$6e185a5347a09ebe).Moved
        };
    }
};
class $580522ebc73c41ee$export$12732f4118fda930 extends (0, $bf0f3973007a2834$export$f391db14ff2d9279) {
    constructor(e){
        super(e);
        $580522ebc73c41ee$var$f(this, "actions", {
            onChange: (e)=>{
                let { onChange: n, compare: o, mode: r, value: u } = this.state.dataRef.current;
                return (0, $151185d7717c1097$export$4659b591c19bdf3d)(r, {
                    [0]: ()=>n == null ? void 0 : n(e),
                    [1]: ()=>{
                        let a = u.slice(), s = a.findIndex((p)=>o(p, e));
                        return s === -1 ? a.push(e) : a.splice(s, 1), n == null ? void 0 : n(a);
                    }
                });
            },
            registerOption: (e, n)=>(this.send({
                    type: 4,
                    payload: {
                        id: e,
                        dataRef: n
                    }
                }), ()=>{
                    this.state.activeOptionIndex === this.state.dataRef.current.calculateIndex(n.current.value) && this.send({
                        type: 6,
                        value: !0
                    }), this.send({
                        type: 5,
                        id: e
                    });
                }),
            goToOption: (e, n)=>(this.send({
                    type: 6,
                    value: !1
                }), this.send({
                    type: 2,
                    ...e,
                    trigger: n
                })),
            setIsTyping: (e)=>{
                this.send({
                    type: 3,
                    isTyping: e
                });
            },
            closeCombobox: ()=>{
                var e, n;
                this.send({
                    type: 1
                }), this.send({
                    type: 6,
                    value: !1
                }), (n = (e = this.state.dataRef.current).onClose) == null || n.call(e);
            },
            openCombobox: ()=>{
                this.send({
                    type: 0
                }), this.send({
                    type: 6,
                    value: !0
                });
            },
            setActivationTrigger: (e)=>{
                this.send({
                    type: 7,
                    trigger: e
                });
            },
            selectActiveOption: ()=>{
                let e = this.selectors.activeOptionIndex(this.state);
                if (e !== null) {
                    if (this.actions.setIsTyping(!1), this.state.virtual) this.actions.onChange(this.state.virtual.options[e]);
                    else {
                        let { dataRef: n } = this.state.options[e];
                        this.actions.onChange(n.current.value);
                    }
                    this.actions.goToOption({
                        focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Specific,
                        idx: e
                    });
                }
            },
            setInputElement: (e)=>{
                this.send({
                    type: 9,
                    element: e
                });
            },
            setButtonElement: (e)=>{
                this.send({
                    type: 10,
                    element: e
                });
            },
            setOptionsElement: (e)=>{
                this.send({
                    type: 11,
                    element: e
                });
            }
        });
        $580522ebc73c41ee$var$f(this, "selectors", {
            activeDescendantId: (e)=>{
                var o, r;
                let n = this.selectors.activeOptionIndex(e);
                if (n !== null) return e.virtual ? (r = e.options.find((u)=>!u.dataRef.current.disabled && e.dataRef.current.compare(u.dataRef.current.value, e.virtual.options[n]))) == null ? void 0 : r.id : (o = e.options[n]) == null ? void 0 : o.id;
            },
            activeOptionIndex: (e)=>{
                if (e.defaultToFirstOption && e.activeOptionIndex === null && (e.virtual ? e.virtual.options.length > 0 : e.options.length > 0)) {
                    if (e.virtual) {
                        let { options: o, disabled: r } = e.virtual, u = o.findIndex((a)=>{
                            var s;
                            return !((s = r == null ? void 0 : r(a)) != null && s);
                        });
                        if (u !== -1) return u;
                    }
                    let n = e.options.findIndex((o)=>!o.dataRef.current.disabled);
                    if (n !== -1) return n;
                }
                return e.activeOptionIndex;
            },
            activeOption: (e)=>{
                var o, r;
                let n = this.selectors.activeOptionIndex(e);
                return n === null ? null : e.virtual ? e.virtual.options[n != null ? n : 0] : (r = (o = e.options[n]) == null ? void 0 : o.dataRef.current.value) != null ? r : null;
            },
            isActive: (e, n, o)=>{
                var u;
                let r = this.selectors.activeOptionIndex(e);
                return r === null ? !1 : e.virtual ? r === e.dataRef.current.calculateIndex(n) : ((u = e.options[r]) == null ? void 0 : u.id) === o;
            },
            shouldScrollIntoView: (e, n, o)=>!(e.virtual || e.__demoMode || e.comboboxState !== 0 || e.activationTrigger === 0 || !this.selectors.isActive(e, n, o)),
            didInputMove (e) {
                return e.inputPositionState.kind === "Moved";
            }
        });
        {
            let n = this.state.id, o = (0, $742c0ddaeb293345$export$151359021f43c28a).get(null);
            this.disposables.add(o.on((0, $742c0ddaeb293345$export$1385d81a6c6bbcd4).Push, (r)=>{
                !o.selectors.isTop(r, n) && this.state.comboboxState === 0 && this.actions.closeCombobox();
            })), this.on(0, ()=>o.actions.push(n)), this.on(1, ()=>o.actions.pop(n));
        }
        this.disposables.group((n)=>{
            this.on(1, (o)=>{
                o.inputElement && (n.dispose(), n.add((0, $4efd704abd02a8a5$export$3449027609988d06)(o.inputElement, o.inputPositionState, ()=>{
                    this.send({
                        type: 12
                    });
                })));
            });
        });
    }
    static new({ id: e, virtual: n = null, __demoMode: o = !1 }) {
        var r;
        return new $580522ebc73c41ee$export$12732f4118fda930({
            id: e,
            dataRef: {
                current: {}
            },
            comboboxState: o ? 0 : 1,
            isTyping: !1,
            options: [],
            virtual: n ? {
                options: n.options,
                disabled: (r = n.disabled) != null ? r : ()=>!1
            } : null,
            activeOptionIndex: null,
            activationTrigger: 2,
            inputElement: null,
            buttonElement: null,
            optionsElement: null,
            __demoMode: o,
            inputPositionState: (0, $4efd704abd02a8a5$export$6e185a5347a09ebe).Idle
        });
    }
    reduce(e, n) {
        return (0, $151185d7717c1097$export$4659b591c19bdf3d)(n.type, $580522ebc73c41ee$var$j, e, n);
    }
}



var $6uYXW = parcelRequire("6uYXW");


const $fd4a3270d4c1e9ec$export$ff587987c5eb6af7 = (0, $6uYXW.createContext)(null);
function $fd4a3270d4c1e9ec$export$c6ebc2e2e2e02aee(n) {
    let o = (0, $6uYXW.useContext)($fd4a3270d4c1e9ec$export$ff587987c5eb6af7);
    if (o === null) {
        let e = new Error(`<${n} /> is missing a parent <Combobox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(e, $fd4a3270d4c1e9ec$export$ffa4b94526b7f799), e;
    }
    return o;
}
function $fd4a3270d4c1e9ec$export$ffa4b94526b7f799({ id: n, virtual: o = null, __demoMode: e = !1 }) {
    let t = (0, $6uYXW.useMemo)(()=>(0, $580522ebc73c41ee$export$12732f4118fda930).new({
            id: n,
            virtual: o,
            __demoMode: e
        }), []);
    return (0, $73cba5e331f72191$export$cd059ee7fd0e9f3d)(()=>t.dispose()), t;
}


"use client";
let $f148ced62087f048$var$de = (0, $6uYXW.createContext)(null);
$f148ced62087f048$var$de.displayName = "ComboboxDataContext";
function $f148ced62087f048$var$te(T) {
    let O = (0, $6uYXW.useContext)($f148ced62087f048$var$de);
    if (O === null) {
        let e = new Error(`<${T} /> is missing a parent <Combobox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(e, $f148ced62087f048$var$te), e;
    }
    return O;
}
let $f148ced62087f048$var$Le = (0, $6uYXW.createContext)(null);
function $f148ced62087f048$var$Eo(T) {
    let O = (0, $fd4a3270d4c1e9ec$export$c6ebc2e2e2e02aee)("VirtualProvider"), e = $f148ced62087f048$var$te("VirtualProvider"), { options: o } = e.virtual, E = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(O, (a)=>a.optionsElement), [R, y] = (0, $6uYXW.useMemo)(()=>{
        let a = E;
        if (!a) return [
            0,
            0
        ];
        let u = window.getComputedStyle(a);
        return [
            parseFloat(u.paddingBlockStart || u.paddingTop),
            parseFloat(u.paddingBlockEnd || u.paddingBottom)
        ];
    }, [
        E
    ]), b = (0, $8cfcd9d89fc43033$export$dd6d526d88b5a137)({
        enabled: o.length !== 0,
        scrollPaddingStart: R,
        scrollPaddingEnd: y,
        count: o.length,
        estimateSize () {
            return 40;
        },
        getScrollElement () {
            return O.state.optionsElement;
        },
        overscan: 12
    }), [h, p] = (0, $6uYXW.useState)(0);
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        p((a)=>a + 1);
    }, [
        o
    ]);
    let f = b.getVirtualItems(), n = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(O, (a)=>a.activationTrigger === (0, $580522ebc73c41ee$export$604fb2d029447fbb).Pointer), m = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(O, O.selectors.activeOptionIndex);
    return f.length === 0 ? null : (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($f148ced62087f048$var$Le.Provider, {
        value: b
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement("div", {
        style: {
            position: "relative",
            width: "100%",
            height: `${b.getTotalSize()}px`
        },
        ref: (a)=>{
            a && (n || m !== null && o.length > m && b.scrollToIndex(m));
        }
    }, f.map((a)=>{
        var u;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $6uYXW.Fragment), {
            key: a.key
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).cloneElement((u = T.children) == null ? void 0 : u.call(T, {
            ...T.slot,
            option: o[a.index]
        }), {
            key: `${h}-${a.key}`,
            "data-index": a.index,
            "aria-setsize": o.length,
            "aria-posinset": a.index + 1,
            style: {
                position: "absolute",
                top: 0,
                left: 0,
                transform: `translateY(${a.start}px)`,
                overflowAnchor: "none"
            }
        }));
    })));
}
let $f148ced62087f048$var$ho = (0, $6uYXW.Fragment);
function $f148ced62087f048$var$Ao(T, O) {
    let e = (0, $6uYXW.useId)(), o = (0, $303765c5ac0e0bd6$export$c763bb7a184a0f11)(), { value: E, defaultValue: R, onChange: y, form: b, name: h, by: p, invalid: f = !1, disabled: n = o || !1, onClose: m, __demoMode: a = !1, multiple: u = !1, immediate: A = !1, virtual: d = null, nullable: X, ...G } = T, C = (0, $c3bdecb35deebfe6$export$8a91ee242b6d0fe3)(R), [x = u ? [] : void 0, v] = (0, $f2aeeeb2298b30fa$export$454217e89aea72b)(E, y, C), c = (0, $fd4a3270d4c1e9ec$export$ffa4b94526b7f799)({
        id: e,
        virtual: d,
        __demoMode: a
    }), z = (0, $6uYXW.useRef)({
        static: !1,
        hold: !1
    }), D = (0, $ce7f6e9fecd912cf$export$988f0cf1b37580ae)(p), K = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((i)=>d ? p === null ? d.options.indexOf(i) : d.options.findIndex((M)=>D(M, i)) : c.state.options.findIndex((M)=>D(M.dataRef.current.value, i))), W = (0, $6uYXW.useCallback)((i)=>(0, $151185d7717c1097$export$4659b591c19bdf3d)(l.mode, {
            [(0, $580522ebc73c41ee$export$4f91e9fa174f3aa).Multi]: ()=>x.some((M)=>D(M, i)),
            [(0, $580522ebc73c41ee$export$4f91e9fa174f3aa).Single]: ()=>D(x, i)
        }), [
        x
    ]), S = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(c, (i)=>i.virtual), j = (0, $555339916ec7fe05$export$90fc3a17d93f704c)(()=>m == null ? void 0 : m()), l = (0, $6uYXW.useMemo)(()=>({
            __demoMode: a,
            immediate: A,
            optionsPropsRef: z,
            value: x,
            defaultValue: C,
            disabled: n,
            invalid: f,
            mode: u ? (0, $580522ebc73c41ee$export$4f91e9fa174f3aa).Multi : (0, $580522ebc73c41ee$export$4f91e9fa174f3aa).Single,
            virtual: d ? S : null,
            onChange: v,
            isSelected: W,
            calculateIndex: K,
            compare: D,
            onClose: j
        }), [
        a,
        A,
        z,
        x,
        C,
        n,
        f,
        u,
        d,
        S,
        v,
        W,
        K,
        D,
        j
    ]);
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        var i;
        d && c.send({
            type: (0, $580522ebc73c41ee$export$1385d81a6c6bbcd4).UpdateVirtualConfiguration,
            options: d.options,
            disabled: (i = d.disabled) != null ? i : null
        });
    }, [
        d,
        d == null ? void 0 : d.options,
        d == null ? void 0 : d.disabled
    ]), (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        c.state.dataRef.current = l;
    }, [
        l
    ]);
    let [k, Y, s, U] = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(c, (i)=>[
            i.comboboxState,
            i.buttonElement,
            i.inputElement,
            i.optionsElement
        ]), $ = (0, $742c0ddaeb293345$export$151359021f43c28a).get(null), ne = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)($, (0, $6uYXW.useCallback)((i)=>$.selectors.isTop(i, e), [
        $,
        e
    ]));
    (0, $26e1e3973f586229$export$71b2224f1ce5e08e)(ne, [
        Y,
        s,
        U
    ], ()=>c.actions.closeCombobox());
    let be = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(c, c.selectors.activeOptionIndex), ee = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(c, c.selectors.activeOption), q = (0, $fbe56f88477e21c7$export$9d4c57ee4c6ffdd8)({
        open: k === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open,
        disabled: n,
        invalid: f,
        activeIndex: be,
        activeOption: ee,
        value: x
    }), [t, V] = (0, $480d43553d3d88f4$export$d6875122194c7b44)(), P = O === null ? {} : {
        ref: O
    }, N = (0, $6uYXW.useCallback)(()=>{
        if (C !== void 0) return v == null ? void 0 : v(C);
    }, [
        v,
        C
    ]), g = (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement(V, {
        value: t,
        props: {
            htmlFor: s == null ? void 0 : s.id
        },
        slot: {
            open: k === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open,
            disabled: n
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $b78d9d7c3cf3d636$export$e473aa84737d3250), null, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($f148ced62087f048$var$de.Provider, {
        value: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $fd4a3270d4c1e9ec$export$ff587987c5eb6af7).Provider, {
        value: c
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $efd9a985d91b0391$export$2a0ed818b175f558), {
        value: (0, $151185d7717c1097$export$4659b591c19bdf3d)(k, {
            [(0, $580522ebc73c41ee$export$9e9981e79183c56e).Open]: (0, $efd9a985d91b0391$export$7254cc27399e90bd).Open,
            [(0, $580522ebc73c41ee$export$9e9981e79183c56e).Closed]: (0, $efd9a985d91b0391$export$7254cc27399e90bd).Closed
        })
    }, h != null && (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $424dcb7e2c168caf$export$125d0b248abd3e88), {
        disabled: n,
        data: x != null ? {
            [h]: x
        } : {},
        form: b,
        onReset: N
    }), g({
        ourProps: P,
        theirProps: G,
        slot: q,
        defaultTag: $f148ced62087f048$var$ho,
        name: "Combobox"
    }))))));
}
let $f148ced62087f048$var$Io = "input";
function $f148ced62087f048$var$Ro(T, O) {
    var ee, q;
    let e = (0, $fd4a3270d4c1e9ec$export$c6ebc2e2e2e02aee)("Combobox.Input"), o = $f148ced62087f048$var$te("Combobox.Input"), E = (0, $6uYXW.useId)(), R = (0, $c50bcf43c5423b2f$export$6ba3910d268310db)(), { id: y = R || `headlessui-combobox-input-${E}`, onChange: b, displayValue: h, disabled: p = o.disabled || !1, autoFocus: f = !1, type: n = "text", ...m } = T, a = (0, $6uYXW.useRef)(null), u = (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)(a, O, (0, $b78d9d7c3cf3d636$export$916a28f343467e85)(), e.actions.setInputElement), [A, d] = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(e, (t)=>[
            t.comboboxState,
            t.isTyping
        ]), X = (0, $550b4821e7e353bd$export$fd183955ff4b45d9)(), G = (0, $555339916ec7fe05$export$90fc3a17d93f704c)(()=>{
        e.actions.onChange(null), e.state.optionsElement && (e.state.optionsElement.scrollTop = 0), e.actions.goToOption({
            focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Nothing
        });
    }), C = (0, $6uYXW.useMemo)(()=>{
        var t;
        return typeof h == "function" && o.value !== void 0 ? (t = h(o.value)) != null ? t : "" : typeof o.value == "string" ? o.value : "";
    }, [
        o.value,
        h
    ]);
    (0, $632ad4b12ba452f9$export$3c773aa2b84f29e0)(([t, V], [P, N])=>{
        if (e.state.isTyping) return;
        let g = a.current;
        g && ((N === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open && V === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Closed || t !== P) && (g.value = t), requestAnimationFrame(()=>{
            if (e.state.isTyping || !g || (0, $d76c946db081c9ef$export$8a2eb51c14bb8899)(g)) return;
            let { selectionStart: i, selectionEnd: M } = g;
            Math.abs((M != null ? M : 0) - (i != null ? i : 0)) === 0 && i === 0 && g.setSelectionRange(g.value.length, g.value.length);
        }));
    }, [
        C,
        A,
        d
    ]), (0, $632ad4b12ba452f9$export$3c773aa2b84f29e0)(([t], [V])=>{
        if (t === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open && V === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Closed) {
            if (e.state.isTyping) return;
            let P = a.current;
            if (!P) return;
            let N = P.value, { selectionStart: g, selectionEnd: i, selectionDirection: M } = P;
            P.value = "", P.value = N, M !== null ? P.setSelectionRange(g, i, M) : P.setSelectionRange(g, i);
        }
    }, [
        A
    ]);
    let x = (0, $6uYXW.useRef)(!1), v = (0, $555339916ec7fe05$export$90fc3a17d93f704c)(()=>{
        x.current = !0;
    }), c = (0, $555339916ec7fe05$export$90fc3a17d93f704c)(()=>{
        X.nextFrame(()=>{
            x.current = !1;
        });
    }), z = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((t)=>{
        switch(e.actions.setIsTyping(!0), t.key){
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Enter:
                if (e.state.comboboxState !== (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open || x.current) return;
                if (t.preventDefault(), t.stopPropagation(), e.selectors.activeOptionIndex(e.state) === null) {
                    e.actions.closeCombobox();
                    return;
                }
                e.actions.selectActiveOption(), o.mode === (0, $580522ebc73c41ee$export$4f91e9fa174f3aa).Single && e.actions.closeCombobox();
                break;
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).ArrowDown:
                return t.preventDefault(), t.stopPropagation(), (0, $151185d7717c1097$export$4659b591c19bdf3d)(e.state.comboboxState, {
                    [(0, $580522ebc73c41ee$export$9e9981e79183c56e).Open]: ()=>e.actions.goToOption({
                            focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Next
                        }),
                    [(0, $580522ebc73c41ee$export$9e9981e79183c56e).Closed]: ()=>e.actions.openCombobox()
                });
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).ArrowUp:
                return t.preventDefault(), t.stopPropagation(), (0, $151185d7717c1097$export$4659b591c19bdf3d)(e.state.comboboxState, {
                    [(0, $580522ebc73c41ee$export$9e9981e79183c56e).Open]: ()=>e.actions.goToOption({
                            focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Previous
                        }),
                    [(0, $580522ebc73c41ee$export$9e9981e79183c56e).Closed]: ()=>{
                        (0, $4e60b4008b7e4540$exports.flushSync)(()=>e.actions.openCombobox()), o.value || e.actions.goToOption({
                            focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Last
                        });
                    }
                });
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Home:
                if (e.state.comboboxState === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Closed || t.shiftKey) break;
                return t.preventDefault(), t.stopPropagation(), e.actions.goToOption({
                    focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).First
                });
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).PageUp:
                return t.preventDefault(), t.stopPropagation(), e.actions.goToOption({
                    focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).First
                });
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).End:
                if (e.state.comboboxState === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Closed || t.shiftKey) break;
                return t.preventDefault(), t.stopPropagation(), e.actions.goToOption({
                    focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Last
                });
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).PageDown:
                return t.preventDefault(), t.stopPropagation(), e.actions.goToOption({
                    focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Last
                });
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Escape:
                return e.state.comboboxState !== (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open ? void 0 : (t.preventDefault(), e.state.optionsElement && !o.optionsPropsRef.current.static && t.stopPropagation(), o.mode === (0, $580522ebc73c41ee$export$4f91e9fa174f3aa).Single && o.value === null && G(), e.actions.closeCombobox());
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Tab:
                if (e.actions.setIsTyping(!1), e.state.comboboxState !== (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open) return;
                o.mode === (0, $580522ebc73c41ee$export$4f91e9fa174f3aa).Single && e.state.activationTrigger !== (0, $580522ebc73c41ee$export$604fb2d029447fbb).Focus && e.actions.selectActiveOption(), e.actions.closeCombobox();
                break;
        }
    }), D = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((t)=>{
        b == null || b(t), o.mode === (0, $580522ebc73c41ee$export$4f91e9fa174f3aa).Single && t.target.value === "" && G(), e.actions.openCombobox();
    }), K = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((t)=>{
        var P, N, g;
        let V = (P = t.relatedTarget) != null ? P : (0, $f722e72b68b17510$export$55abd4691b317664).find((i)=>i !== t.currentTarget);
        if (!((N = e.state.optionsElement) != null && N.contains(V)) && !((g = e.state.buttonElement) != null && g.contains(V)) && e.state.comboboxState === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open) return t.preventDefault(), o.mode === (0, $580522ebc73c41ee$export$4f91e9fa174f3aa).Single && o.value === null && G(), e.actions.closeCombobox();
    }), W = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((t)=>{
        var P, N, g;
        let V = (P = t.relatedTarget) != null ? P : (0, $f722e72b68b17510$export$55abd4691b317664).find((i)=>i !== t.currentTarget);
        (N = e.state.buttonElement) != null && N.contains(V) || (g = e.state.optionsElement) != null && g.contains(V) || o.disabled || o.immediate && e.state.comboboxState !== (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open && X.microTask(()=>{
            (0, $4e60b4008b7e4540$exports.flushSync)(()=>e.actions.openCombobox()), e.actions.setActivationTrigger((0, $580522ebc73c41ee$export$604fb2d029447fbb).Focus);
        });
    }), S = (0, $480d43553d3d88f4$export$1f86aee6764cddb2)(), j = (0, $1eae8f067ba552e0$export$899851af1363628)(), { isFocused: l, focusProps: k } = (0, $63b99e5b44fc4848$export$4e328f61c538687f)({
        autoFocus: f
    }), { isHovered: Y, hoverProps: s } = (0, $2c47d83feaa2f132$export$ae780daf29e6d456)({
        isDisabled: p
    }), U = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(e, (t)=>t.optionsElement), $ = (0, $fbe56f88477e21c7$export$9d4c57ee4c6ffdd8)({
        open: A === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open,
        disabled: p,
        invalid: o.invalid,
        hover: Y,
        focus: l,
        autofocus: f
    }), ne = (0, $513e46b2b02099d5$export$9d1611c77c2fe928)({
        ref: u,
        id: y,
        role: "combobox",
        type: n,
        "aria-controls": U == null ? void 0 : U.id,
        "aria-expanded": A === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open,
        "aria-activedescendant": (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(e, e.selectors.activeDescendantId),
        "aria-labelledby": S,
        "aria-describedby": j,
        "aria-autocomplete": "list",
        defaultValue: (q = (ee = T.defaultValue) != null ? ee : o.defaultValue !== void 0 ? h == null ? void 0 : h(o.defaultValue) : null) != null ? q : o.defaultValue,
        disabled: p || void 0,
        autoFocus: f,
        onCompositionStart: v,
        onCompositionEnd: c,
        onKeyDown: z,
        onChange: D,
        onFocus: W,
        onBlur: K
    }, k, s);
    return (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)()({
        ourProps: ne,
        theirProps: m,
        slot: $,
        defaultTag: $f148ced62087f048$var$Io,
        name: "Combobox.Input"
    });
}
let $f148ced62087f048$var$_o = "button";
function $f148ced62087f048$var$Fo(T, O) {
    let e = (0, $fd4a3270d4c1e9ec$export$c6ebc2e2e2e02aee)("Combobox.Button"), o = $f148ced62087f048$var$te("Combobox.Button"), [E, R] = (0, $6uYXW.useState)(null), y = (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)(O, R, e.actions.setButtonElement), b = (0, $6uYXW.useId)(), { id: h = `headlessui-combobox-button-${b}`, disabled: p = o.disabled || !1, autoFocus: f = !1, ...n } = T, [m, a, u] = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(e, (l)=>[
            l.comboboxState,
            l.inputElement,
            l.optionsElement
        ]), A = (0, $a6bf46fab05f7d2b$export$9b49488873640feb)(a), d = m === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open;
    (0, $61338770e1b4369c$export$a46c853b8b55573a)(d, {
        trigger: E,
        action: (0, $6uYXW.useCallback)((l)=>{
            if (E != null && E.contains(l.target)) return (0, $61338770e1b4369c$export$e19cd5f9376f8cee).Ignore;
            if (a != null && a.contains(l.target)) return (0, $61338770e1b4369c$export$e19cd5f9376f8cee).Ignore;
            let k = l.target.closest('[role="option"]:not([data-disabled])');
            return $36c2319598bace40$export$1b3bfaa9684536aa(k) ? (0, $61338770e1b4369c$export$e19cd5f9376f8cee).Select(k) : u != null && u.contains(l.target) ? (0, $61338770e1b4369c$export$e19cd5f9376f8cee).Ignore : (0, $61338770e1b4369c$export$e19cd5f9376f8cee).Close;
        }, [
            E,
            a,
            u
        ]),
        close: e.actions.closeCombobox,
        select: e.actions.selectActiveOption
    });
    let X = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((l)=>{
        switch(l.key){
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Space:
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Enter:
                l.preventDefault(), l.stopPropagation(), e.state.comboboxState === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Closed && (0, $4e60b4008b7e4540$exports.flushSync)(()=>e.actions.openCombobox()), A();
                return;
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).ArrowDown:
                l.preventDefault(), l.stopPropagation(), e.state.comboboxState === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Closed && ((0, $4e60b4008b7e4540$exports.flushSync)(()=>e.actions.openCombobox()), e.state.dataRef.current.value || e.actions.goToOption({
                    focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).First
                })), A();
                return;
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).ArrowUp:
                l.preventDefault(), l.stopPropagation(), e.state.comboboxState === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Closed && ((0, $4e60b4008b7e4540$exports.flushSync)(()=>e.actions.openCombobox()), e.state.dataRef.current.value || e.actions.goToOption({
                    focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Last
                })), A();
                return;
            case (0, $961a4e4f4fb2e176$export$4b0075e5ea5e1f26).Escape:
                if (e.state.comboboxState !== (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open) return;
                l.preventDefault(), e.state.optionsElement && !o.optionsPropsRef.current.static && l.stopPropagation(), (0, $4e60b4008b7e4540$exports.flushSync)(()=>e.actions.closeCombobox()), A();
                return;
            default:
                return;
        }
    }), G = (0, $15a351b74ba7cdc8$export$87bd167e79a089ba)(()=>{
        e.state.comboboxState === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open ? e.actions.closeCombobox() : e.actions.openCombobox(), A();
    }), C = (0, $480d43553d3d88f4$export$1f86aee6764cddb2)([
        h
    ]), { isFocusVisible: x, focusProps: v } = (0, $63b99e5b44fc4848$export$4e328f61c538687f)({
        autoFocus: f
    }), { isHovered: c, hoverProps: z } = (0, $2c47d83feaa2f132$export$ae780daf29e6d456)({
        isDisabled: p
    }), { pressed: D, pressProps: K } = (0, $2a0752a989a3abf0$export$73224eeef4bbe873)({
        disabled: p
    }), W = (0, $fbe56f88477e21c7$export$9d4c57ee4c6ffdd8)({
        open: m === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open,
        active: D || m === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open,
        disabled: p,
        invalid: o.invalid,
        value: o.value,
        hover: c,
        focus: x
    }), S = (0, $513e46b2b02099d5$export$9d1611c77c2fe928)({
        ref: y,
        id: h,
        type: (0, $8df6c730accaca48$export$53652b2b272efe9c)(T, E),
        tabIndex: -1,
        "aria-haspopup": "listbox",
        "aria-controls": u == null ? void 0 : u.id,
        "aria-expanded": m === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open,
        "aria-labelledby": C,
        disabled: p || void 0,
        autoFocus: f,
        onKeyDown: X
    }, G, v, z, K);
    return (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)()({
        ourProps: S,
        theirProps: n,
        slot: W,
        defaultTag: $f148ced62087f048$var$_o,
        name: "Combobox.Button"
    });
}
let $f148ced62087f048$var$Do = "div", $f148ced62087f048$var$So = (0, $513e46b2b02099d5$export$ba0ea3f20e7bf777).RenderStrategy | (0, $513e46b2b02099d5$export$ba0ea3f20e7bf777).Static;
function $f148ced62087f048$var$Mo(T, O) {
    var M, Ce, ve;
    let e = (0, $6uYXW.useId)(), { id: o = `headlessui-combobox-options-${e}`, hold: E = !1, anchor: R, portal: y = !1, modal: b = !0, transition: h = !1, ...p } = T, f = (0, $fd4a3270d4c1e9ec$export$c6ebc2e2e2e02aee)("Combobox.Options"), n = $f148ced62087f048$var$te("Combobox.Options"), m = (0, $b78d9d7c3cf3d636$export$ee5342e485f0bdb0)(R);
    m && (y = !0);
    let [a, u] = (0, $b78d9d7c3cf3d636$export$aff4be9ef2a28e43)(m), [A, d] = (0, $6uYXW.useState)(null), X = (0, $b78d9d7c3cf3d636$export$106e71f938eae412)(), G = (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)(O, m ? a : null, f.actions.setOptionsElement, d), [C, x, v, c, z] = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(f, (_)=>[
            _.comboboxState,
            _.inputElement,
            _.buttonElement,
            _.optionsElement,
            _.activationTrigger
        ]), D = (0, $8994b146d9de4c13$export$dd9fbcea3de0ae36)(x || v), K = (0, $8994b146d9de4c13$export$dd9fbcea3de0ae36)(c), W = (0, $efd9a985d91b0391$export$fc6fdf0ecf360e)(), [S, j] = (0, $ccac44f91c8229c7$export$7b286972b8d8ccbf)(h, A, W !== null ? (W & (0, $efd9a985d91b0391$export$7254cc27399e90bd).Open) === (0, $efd9a985d91b0391$export$7254cc27399e90bd).Open : C === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open);
    (0, $0635c499e325c995$export$b41b9097915aa006)(S, x, f.actions.closeCombobox);
    let l = n.__demoMode ? !1 : b && C === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open;
    (0, $df0eaf79c869102e$export$e47ba1b900da5d3b)(l, K);
    let k = n.__demoMode ? !1 : b && C === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open;
    (0, $09ac2e93626b6281$export$af489fa7e5283cc3)(k, {
        allowed: (0, $6uYXW.useCallback)(()=>[
                x,
                v,
                c
            ], [
            x,
            v,
            c
        ])
    });
    let s = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(f, f.selectors.didInputMove) ? !1 : S;
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        var _;
        n.optionsPropsRef.current.static = (_ = T.static) != null ? _ : !1;
    }, [
        n.optionsPropsRef,
        T.static
    ]), (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        n.optionsPropsRef.current.hold = E;
    }, [
        n.optionsPropsRef,
        E
    ]), (0, $398e4c5e66e6a1a3$export$b0abce39eb34b36)(C === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open, {
        container: c,
        accept (_) {
            return _.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : _.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (_) {
            _.setAttribute("role", "none");
        }
    });
    let U = (0, $480d43553d3d88f4$export$1f86aee6764cddb2)([
        v == null ? void 0 : v.id
    ]), $ = (0, $fbe56f88477e21c7$export$9d4c57ee4c6ffdd8)({
        open: C === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Open,
        option: void 0
    }), ne = (0, $555339916ec7fe05$export$90fc3a17d93f704c)(()=>{
        f.actions.setActivationTrigger((0, $580522ebc73c41ee$export$604fb2d029447fbb).Pointer);
    }), be = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((_)=>{
        _.preventDefault(), f.actions.setActivationTrigger((0, $580522ebc73c41ee$export$604fb2d029447fbb).Pointer);
    }), ee = (0, $513e46b2b02099d5$export$9d1611c77c2fe928)(m ? X() : {}, {
        "aria-labelledby": U,
        role: "listbox",
        "aria-multiselectable": n.mode === (0, $580522ebc73c41ee$export$4f91e9fa174f3aa).Multi ? !0 : void 0,
        id: o,
        ref: G,
        style: {
            ...p.style,
            ...u,
            "--input-width": (0, $ac376574bfb928bb$export$2b86bedf890eab8)(S, x, !0).width,
            "--button-width": (0, $ac376574bfb928bb$export$2b86bedf890eab8)(S, v, !0).width
        },
        onWheel: z === (0, $580522ebc73c41ee$export$604fb2d029447fbb).Pointer ? void 0 : ne,
        onMouseDown: be,
        ...(0, $ccac44f91c8229c7$export$c291d481c40a2fc3)(j)
    }), q = S && C === (0, $580522ebc73c41ee$export$9e9981e79183c56e).Closed && !T.static, t = (0, $fc694889197a235d$export$1a771eb6e04a3c48)(q, (M = n.virtual) == null ? void 0 : M.options), V = (0, $fc694889197a235d$export$1a771eb6e04a3c48)(q, n.value), P = (0, $6uYXW.useCallback)((_)=>n.compare(V, _), [
        n.compare,
        V
    ]), N = (0, $6uYXW.useMemo)(()=>{
        if (!n.virtual) return n;
        if (t === void 0) throw new Error("Missing `options` in virtual mode");
        return t !== n.virtual.options ? {
            ...n,
            virtual: {
                ...n.virtual,
                options: t
            }
        } : n;
    }, [
        n,
        t,
        (Ce = n.virtual) == null ? void 0 : Ce.options
    ]);
    n.virtual && Object.assign(p, {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($f148ced62087f048$var$de.Provider, {
            value: N
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($f148ced62087f048$var$Eo, {
            slot: $
        }, p.children))
    });
    let g = (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)(), i = (0, $6uYXW.useMemo)(()=>n.mode === (0, $580522ebc73c41ee$export$4f91e9fa174f3aa).Multi ? n : {
            ...n,
            isSelected: P
        }, [
        n,
        P
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $50dad12a3f22a3c2$export$602eac185826482c), {
        enabled: y ? T.static || S : !1,
        ownerDocument: D
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement($f148ced62087f048$var$de.Provider, {
        value: i
    }, g({
        ourProps: ee,
        theirProps: {
            ...p,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($6uYXW))).createElement((0, $fc694889197a235d$export$824932a86c309819), {
                freeze: q
            }, typeof p.children == "function" ? (ve = p.children) == null ? void 0 : ve.call(p, $) : p.children)
        },
        slot: $,
        defaultTag: $f148ced62087f048$var$Do,
        features: $f148ced62087f048$var$So,
        visible: s,
        name: "Combobox.Options"
    })));
}
let $f148ced62087f048$var$Lo = "div";
function $f148ced62087f048$var$Vo(T, O) {
    var l, k, Y;
    let e = $f148ced62087f048$var$te("Combobox.Option"), o = (0, $fd4a3270d4c1e9ec$export$c6ebc2e2e2e02aee)("Combobox.Option"), E = (0, $6uYXW.useId)(), { id: R = `headlessui-combobox-option-${E}`, value: y, disabled: b = (Y = (k = (l = e.virtual) == null ? void 0 : l.disabled) == null ? void 0 : k.call(l, y)) != null ? Y : !1, order: h = null, ...p } = T, [f] = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(o, (s)=>[
            s.inputElement
        ]), n = (0, $a6bf46fab05f7d2b$export$9b49488873640feb)(f), m = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(o, (0, $6uYXW.useCallback)((s)=>o.selectors.isActive(s, y, R), [
        y,
        R
    ])), a = e.isSelected(y), u = (0, $6uYXW.useRef)(null), A = (0, $45cf98b6ba6e8cbc$export$86c4283a11f23f95)({
        disabled: b,
        value: y,
        domRef: u,
        order: h
    }), d = (0, $6uYXW.useContext)($f148ced62087f048$var$Le), X = (0, $c8ac0a774b50c957$export$f6a25a78204acc7e)(O, u, d ? d.measureElement : null), G = (0, $555339916ec7fe05$export$90fc3a17d93f704c)(()=>{
        o.actions.setIsTyping(!1), o.actions.onChange(y);
    });
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>o.actions.registerOption(R, A), [
        A,
        R
    ]);
    let C = (0, $185fb310b820deb4$export$89d3cfa2bf31e31a)(o, (0, $6uYXW.useCallback)((s)=>o.selectors.shouldScrollIntoView(s, y, R), [
        y,
        R
    ]));
    (0, $f90baf459dcf3957$export$ce5ed857c741fd71)(()=>{
        if (C) return (0, $5b6227043c6a88bc$export$12b26c28a05aa001)().requestAnimationFrame(()=>{
            var s, U;
            (U = (s = u.current) == null ? void 0 : s.scrollIntoView) == null || U.call(s, {
                block: "nearest"
            });
        });
    }, [
        C,
        u
    ]);
    let x = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((s)=>{
        s.preventDefault(), s.button === (0, $b525ec018fa637e5$export$92850d9476e00eee).Left && (b || (G(), (0, $a0810353f512e7f9$export$d0a8044dce8ff2fc)() || requestAnimationFrame(()=>n()), e.mode === (0, $580522ebc73c41ee$export$4f91e9fa174f3aa).Single && o.actions.closeCombobox()));
    }), v = (0, $555339916ec7fe05$export$90fc3a17d93f704c)(()=>{
        if (b) return o.actions.goToOption({
            focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Nothing
        });
        let s = e.calculateIndex(y);
        o.actions.goToOption({
            focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Specific,
            idx: s
        });
    }), c = (0, $2277b68d6ee21509$export$24ebee078bde85c3)(), z = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((s)=>c.update(s)), D = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((s)=>{
        if (!c.wasMoved(s) || b || m && o.state.activationTrigger === (0, $580522ebc73c41ee$export$604fb2d029447fbb).Pointer) return;
        let U = e.calculateIndex(y);
        o.actions.goToOption({
            focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Specific,
            idx: U
        }, (0, $580522ebc73c41ee$export$604fb2d029447fbb).Pointer);
    }), K = (0, $555339916ec7fe05$export$90fc3a17d93f704c)((s)=>{
        c.wasMoved(s) && (b || m && (e.optionsPropsRef.current.hold || o.state.activationTrigger === (0, $580522ebc73c41ee$export$604fb2d029447fbb).Pointer && o.actions.goToOption({
            focus: (0, $fd8c7f19da8b319f$export$807a7eae502106e7).Nothing
        })));
    }), W = (0, $fbe56f88477e21c7$export$9d4c57ee4c6ffdd8)({
        active: m,
        focus: m,
        selected: a,
        disabled: b
    }), S = {
        id: R,
        ref: X,
        role: "option",
        tabIndex: b === !0 ? void 0 : -1,
        "aria-disabled": b === !0 ? !0 : void 0,
        "aria-selected": a,
        disabled: void 0,
        onMouseDown: x,
        onFocus: v,
        onPointerEnter: z,
        onMouseEnter: z,
        onPointerMove: D,
        onMouseMove: D,
        onPointerLeave: K,
        onMouseLeave: K
    };
    return (0, $513e46b2b02099d5$export$e25bb1e5b53cbdff)()({
        ourProps: S,
        theirProps: p,
        slot: W,
        defaultTag: $f148ced62087f048$var$Lo,
        name: "Combobox.Option"
    });
}
let $f148ced62087f048$var$wo = (0, $513e46b2b02099d5$export$e43f39796049410c)($f148ced62087f048$var$Ao), $f148ced62087f048$export$756fe6c16147e11a = (0, $513e46b2b02099d5$export$e43f39796049410c)($f148ced62087f048$var$Fo), $f148ced62087f048$export$de5e47f31372e2e3 = (0, $513e46b2b02099d5$export$e43f39796049410c)($f148ced62087f048$var$Ro), $f148ced62087f048$export$3ca0d3769eaf5f66 = (0, $480d43553d3d88f4$export$b04be29aa201d4f5), $f148ced62087f048$export$47929aa3fb52fca2 = (0, $513e46b2b02099d5$export$e43f39796049410c)($f148ced62087f048$var$Mo), $f148ced62087f048$export$7ce8df7790337ff4 = (0, $513e46b2b02099d5$export$e43f39796049410c)($f148ced62087f048$var$Vo), $f148ced62087f048$export$27957ad87354dd7e = Object.assign($f148ced62087f048$var$wo, {
    Input: $f148ced62087f048$export$de5e47f31372e2e3,
    Button: $f148ced62087f048$export$756fe6c16147e11a,
    Label: $f148ced62087f048$export$3ca0d3769eaf5f66,
    Options: $f148ced62087f048$export$47929aa3fb52fca2,
    Option: $f148ced62087f048$export$7ce8df7790337ff4
});



var $6uYXW = parcelRequire("6uYXW");
function $4f38f86cc93bd570$var$ChevronUpDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $6uYXW.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $6uYXW.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $6uYXW.createElement("path", {
        fillRule: "evenodd",
        d: "M10.53 3.47a.75.75 0 0 0-1.06 0L6.22 6.72a.75.75 0 0 0 1.06 1.06L10 5.06l2.72 2.72a.75.75 0 1 0 1.06-1.06l-3.25-3.25Zm-4.31 9.81 3.25 3.25a.75.75 0 0 0 1.06 0l3.25-3.25a.75.75 0 1 0-1.06-1.06L10 14.94l-2.72-2.72a.75.75 0 0 0-1.06 1.06Z",
        clipRule: "evenodd"
    }));
}
const $4f38f86cc93bd570$var$ForwardRef = /*#__PURE__*/ $6uYXW.forwardRef($4f38f86cc93bd570$var$ChevronUpDownIcon);
var $4f38f86cc93bd570$export$2e2bcd8739ae039 = $4f38f86cc93bd570$var$ForwardRef;





var $dDyyD = parcelRequire("dDyyD");

var $j5aH7 = parcelRequire("j5aH7");

var $6uYXW = parcelRequire("6uYXW");

const $a655e31a94ca029c$var$ZipCodeSearch = ()=>{
    const { data: taxonomies, isPending: isPending } = (0, $b505c391aa3d7eba$export$dd0a697e1782aedd)({
        queryKey: [
            'taxonomies'
        ],
        queryFn: async ()=>{
            const { data: data } = await (0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).get('/requests/cca-taxonomy-terms');
            return (0, (/*@__PURE__*/$parcel$interopDefault($j5aH7)))(data, [
                'taxonomy_name_reference'
            ]);
        }
    });
    const [selectedCounty, setSelectedCounty] = (0, $6uYXW.useState)('');
    const [selectedZipCode, setSelectedZipCode] = (0, $6uYXW.useState)('');
    const [selectedTaxonomy, setSelectedTaxonomy] = (0, $6uYXW.useState)('');
    const [taxonomyFilter, setTaxonomyFilter] = (0, $6uYXW.useState)('');
    let filteredTaxonomies = [];
    if (!isPending) filteredTaxonomies = taxonomies && taxonomyFilter === '' ? taxonomies : taxonomies.filter((taxonomy)=>taxonomy.taxonomy_name_reference.toLowerCase().replace(/\s+/g, '').includes(taxonomyFilter.toLowerCase().replace(/\s+/g, '')));
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
        className: "page zip-code-search",
        children: [
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "text-center sm:mx-auto sm:w-full sm:max-w-lg",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("h2", {
                    children: "Get Assistance and the Help you need!"
                })
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "mt-8 sm:mx-auto sm:w-full sm:max-w-sm",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("p", {
                    children: "Needing assistance with food, transportation, medical bills and housing? We can help! Use the search below to start finding available services in your area!"
                })
            }),
            /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                className: "sm:mx-auto sm:w-full sm:max-w-sm",
                children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $c6d33de9e7cf86ac$export$a7fed597f4b8afd8), {
                    action: "/organizations",
                    className: "space-y-6",
                    method: "get",
                    children: [
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "mt-6 form-control",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                    htmlFor: "county",
                                    className: "label label-text",
                                    children: "County"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("select", {
                                    id: "county",
                                    name: "county",
                                    className: "w-full input select-sm select-bordered",
                                    required: true,
                                    onChange: ({ target: target })=>setSelectedCounty(target.value),
                                    value: selectedCounty,
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                            value: "",
                                            children: "-- Select a County --"
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("option", {
                                            value: "muskegon",
                                            children: "Muskegon"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "mt-6 form-control",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                    htmlFor: "zip-code",
                                    className: "label label-text",
                                    children: "Zip Code"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("input", {
                                    type: "text",
                                    inputMode: "numeric",
                                    required: true,
                                    id: "zip-code",
                                    name: "zipCode",
                                    className: "w-full input input-sm input-bordered",
                                    onChange: ({ target: target })=>setSelectedZipCode(target.value),
                                    value: selectedZipCode,
                                    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($dDyyD)))(selectedCounty)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)("div", {
                            className: "mt-6 form-control",
                            children: [
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("label", {
                                    className: "label label-text",
                                    children: "Program"
                                }),
                                /*#__PURE__*/ (0, $32c03629429003d8$exports.jsxs)((0, $f148ced62087f048$export$27957ad87354dd7e), {
                                    as: "div",
                                    className: "relative",
                                    value: selectedTaxonomy,
                                    onChange: setSelectedTaxonomy,
                                    name: "taxonomy",
                                    children: [
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $f148ced62087f048$export$de5e47f31372e2e3), {
                                            className: "w-full input input-sm input-bordered",
                                            required: true,
                                            displayValue: (taxonomy)=>taxonomy?.taxonomy_name_reference,
                                            onChange: (event)=>setTaxonomyFilter(event.target.value),
                                            autoComplete: "off",
                                            placeholder: "food, rent assistance, diapers, etc."
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $f148ced62087f048$export$756fe6c16147e11a), {
                                            className: "absolute inset-y-0 right-0 flex items-center pr-2",
                                            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $4f38f86cc93bd570$export$2e2bcd8739ae039), {
                                                className: "w-5 h-5 text-gray-400",
                                                "aria-hidden": "true"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $f148ced62087f048$export$47929aa3fb52fca2), {
                                            className: "absolute z-10 w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                                            children: filteredTaxonomies.map((taxonomy)=>/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $f148ced62087f048$export$7ce8df7790337ff4), {
                                                    value: taxonomy,
                                                    className: "relative px-2 py-1 cursor-default select-none data-focus:bg-tandem-100",
                                                    children: taxonomy.taxonomy_name_reference
                                                }, taxonomy.taxonomy_code))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("div", {
                            className: "mt-6",
                            children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)("button", {
                                className: "text-white btn btn-primary btn-sm btn-block",
                                disabled: isPending || (0, (/*@__PURE__*/$parcel$interopDefault($dDyyD)))(selectedTaxonomy) || (0, (/*@__PURE__*/$parcel$interopDefault($dDyyD)))(selectedZipCode) || (0, (/*@__PURE__*/$parcel$interopDefault($dDyyD)))(selectedCounty),
                                children: "Search"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $a655e31a94ca029c$export$2e2bcd8739ae039 = $a655e31a94ca029c$var$ZipCodeSearch;


(0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).defaults.baseURL = "https://app.nowintandem.com/scapi";
// Create a client
const $7158de9e865c7fee$var$queryClient = new (0, $18acf5281fa49b03$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false
        }
    }
});
const $7158de9e865c7fee$var$router = (0, $c6d33de9e7cf86ac$export$1ba7ed8a3a7b3765)([
    {
        element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $ce7ce7b7f0e3cbea$export$2e2bcd8739ae039), {}),
        errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {}),
        children: [
            {
                path: '/cca',
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $cfbd53e0340227ce$export$2e2bcd8739ae039), {}),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {})
            },
            {
                path: '/',
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $a655e31a94ca029c$export$2e2bcd8739ae039), {}),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {})
            },
            {
                path: '/organizations',
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $f98453a3b051f25f$export$2e2bcd8739ae039), {}),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {}),
                loader: (0, $25522fd699d42b1c$export$f4c5de44377d2946)
            },
            {
                path: '/orgServices/:orgId',
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $5dced1388b58754f$export$2e2bcd8739ae039), {}),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {})
            },
            {
                path: '/checkProfile',
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $e8cd06ed188feb94$export$2e2bcd8739ae039), {}),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {}),
                loader: (0, $3e074ae14a790c44$export$f4c5de44377d2946)
            },
            {
                path: '/submitRequest',
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $4954493d632cd190$export$2e2bcd8739ae039), {}),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {}),
                loader: (0, $3fee788decfefe38$export$f4c5de44377d2946),
                action: (0, $3fee788decfefe38$export$31eb53bd5b582a97)
            },
            {
                path: '/servicesRequested',
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $b3bb5dae2440b0ed$export$2e2bcd8739ae039), {}),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {}),
                loader: (0, $b3bb5dae2440b0ed$export$f4c5de44377d2946)
            },
            {
                path: '/home',
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $5c7f6f99ffebc2a8$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $5db40108ec48fd36$export$2e2bcd8739ae039), {})
                }),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {})
            },
            {
                path: '/login',
                action: (0, $fbe49b383ff2a675$export$31eb53bd5b582a97),
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $fbe49b383ff2a675$export$2e2bcd8739ae039), {}),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {})
            },
            {
                path: '/register',
                action: (0, $d48122de56c05aba$export$31eb53bd5b582a97),
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $d48122de56c05aba$export$2e2bcd8739ae039), {}),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {})
            },
            {
                path: '/forgotPassword/:subTask?',
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $48f8dfe8d4e2503d$export$2e2bcd8739ae039), {}),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {}),
                loader: (0, $b811950337b3734f$export$f4c5de44377d2946),
                action: (0, $b811950337b3734f$export$31eb53bd5b582a97)
            },
            {
                path: '/forgotPassword/reset',
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $1939ec415e22538b$export$2e2bcd8739ae039), {}),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {}),
                action: (0, $2cb6cb94138d78da$export$31eb53bd5b582a97)
            },
            {
                path: '/changePassword',
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $5502b534e446bf5a$export$2e2bcd8739ae039), {}),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {}),
                action: (0, $07ee53d1fd944508$export$31eb53bd5b582a97)
            },
            {
                path: '/profile',
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $5c7f6f99ffebc2a8$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $ea70c77f8a81075a$export$2e2bcd8739ae039), {})
                }),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {})
            },
            {
                path: '/personalFinances',
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $5c7f6f99ffebc2a8$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $10350528c354a883$export$2e2bcd8739ae039), {})
                }),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {})
            },
            {
                path: '/assessments',
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $5c7f6f99ffebc2a8$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $8e0ea8865cb8f5ee$export$2e2bcd8739ae039), {})
                }),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {})
            },
            {
                path: '/assessments/:formId',
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $5c7f6f99ffebc2a8$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $1faa9d57eb35cbd7$export$2e2bcd8739ae039), {})
                }),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {})
            },
            {
                path: '/completeRegistration',
                element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $5c7f6f99ffebc2a8$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $b01bc80274f0921f$export$2e2bcd8739ae039), {})
                }),
                errorElement: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $2c0a2054119283d0$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $bdd7c25d548c08c8$export$2e2bcd8739ae039), {}),
        path: '/logout'
    },
    {
        element: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $88be82bcdaab0750$export$444b3ab0cb9aec40), {
            to: "/"
        }),
        path: '*'
    }
]);
// Add a response interceptor
(0, $3a7fe52a8cf7806b$export$2e2bcd8739ae039).interceptors.response.use(function(response) {
    return response;
}, function(error) {
    if (error?.config?.headers?.Authorization && 401 === error?.response?.status) $7158de9e865c7fee$var$router.navigate('/login');
    else return Promise.reject(error);
});
const $7158de9e865c7fee$var$App = ()=>{
    return /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $8136cc1e66cf8798$export$45604f0cc8ae667b), {
        client: $7158de9e865c7fee$var$queryClient,
        children: /*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $c6d33de9e7cf86ac$export$323e4fc2fa4753fb), {
            router: $7158de9e865c7fee$var$router
        })
    });
};
var $7158de9e865c7fee$export$2e2bcd8739ae039 = $7158de9e865c7fee$var$App;


(function() {
    const root = (0, $b77ba2fb0905f4fb$export$882461b6382ed46c)(document.getElementById('app'));
    root.render(/*#__PURE__*/ (0, $32c03629429003d8$exports.jsx)((0, $7158de9e865c7fee$export$2e2bcd8739ae039), {}));
})();


//# sourceMappingURL=build.60f9fb2a.js.map
